import { gql } from '@apollo/client'
import * as ApolloReactCommon from '@apollo/client/react'
import * as ApolloReactHooks from '@apollo/client/react'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: string; output: string }
  JSON: { input: any; output: any }
}

export type AcceptHoldingPaymentInput = {
  /** 수락할 PaymentAdjustment ID */
  id: Scalars['String']['input']
}

/** Merchant account entry Excel export response */
export type AccountExportResponse = {
  __typename?: 'AccountExportResponse'
  /** Immediate download URL for exports with 1000 records or fewer */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** Async job ID for exports with more than 1000 records */
  jobId?: Maybe<Scalars['String']['output']>
  /** Informational message for the export request */
  message?: Maybe<Scalars['String']['output']>
  /** Process type: IMMEDIATE or ASYNC */
  processType: Scalars['String']['output']
  /** Total record count */
  recordCount: Scalars['Int']['output']
}

/** 내부 회계 분개용 채널 코드 */
export type AccountingChannelResponse = {
  __typename?: 'AccountingChannelResponse'
  /** 채널 코드 (resolveAccountingChannel 키) */
  code: Scalars['String']['output']
  /** 채널 표시명 */
  label: Scalars['String']['output']
}

/** Accounting subject type */
export enum AccountingSubjectType {
  A = 'A',
  J = 'J',
  L = 'L',
}

export type ActivateExchangeRateInput = {
  /** 환율 ID */
  id: Scalars['Int']['input']
  /** 활성화 상태 */
  isActive?: Scalars['Boolean']['input']
}

/** 진행 중(미검증·미만료) 검증 송금 조회 — Safety Withdraw 재개용 */
export type ActiveMicroTransferInput = {
  /** 지갑 주소 */
  address: Scalars['String']['input']
  /** L3 통화 코드 (예: TRON_USDT) */
  currency: Scalars['String']['input']
  /** 가맹점 ID (관리자용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type AddIpWhitelistInput = {
  /** 단일 IP(예: 1.2.3.4) 또는 CIDR(예: 1.2.3.0/24) */
  ipCidr: Scalars['String']['input']
  label?: InputMaybe<Scalars['String']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

/** PG 정산 이벤트 추가 입력 */
export type AddPgSettlementEventInput = {
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 이벤트 타입 */
  eventType: PgSettlementEventType
  /** 메타데이터 */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** PG 정산 ID */
  pgSettlementId?: InputMaybe<Scalars['String']['input']>
  /** PG 정산금 이체 요청 ID */
  pgSettlementTransferId?: InputMaybe<Scalars['String']['input']>
  /** 제목 */
  title: Scalars['String']['input']
}

/** 수동 수수료 추가 입력 */
export type AddPgSettlementFeeInput = {
  /** 수수료 금액 */
  amount: Scalars['Float']['input']
  /** 통화 (기본: 항목의 통화) */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 수수료 유형 */
  feeType: FeeType
  /** 정산 항목 ID */
  pgSettlementItemId: Scalars['String']['input']
  /** 트랜잭션 해시 */
  txHash?: InputMaybe<Scalars['String']['input']>
}

/** 주소 검증 여부 조회 */
export type AddressVerifiedInput = {
  /** 지갑 주소 */
  address: Scalars['String']['input']
  /** L3 통화 코드 (예: TRON_USDT) */
  currency: Scalars['String']['input']
  /** 가맹점 ID (관리자용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

/** 결제 금액 조정 결정 상태 */
export enum AdjustmentDecision {
  ACCEPTED = 'ACCEPTED',
  AUTO_EXPIRED = 'AUTO_EXPIRED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

/** 결제 금액 조정 사유 */
export enum AdjustmentReason {
  OVERPAYMENT = 'OVERPAYMENT',
  UNDERPAYMENT = 'UNDERPAYMENT',
}

export type AdminSignUpInput = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  password: Scalars['String']['input']
  phoneCountryCode: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
}

export type AdminSignUpResponse = {
  __typename?: 'AdminSignUpResponse'
  /** Whether the admin account was created successfully */
  success: Scalars['Boolean']['output']
}

export type AirwallexReconciliationResult = {
  __typename?: 'AirwallexReconciliationResult'
  /** 승인 대기로 적재된 수수료 차이 */
  feeMismatches: Scalars['JSON']['output']
  /** 우리쪽 통계 */
  ourSide: ReconciliationSideResult
  /** 조회 시작일 */
  periodFrom: Scalars['DateTime']['output']
  /** 조회 종료일 */
  periodTo: Scalars['DateTime']['output']
  /** PG쪽 통계 */
  pgSide: ReconciliationSideResult
  /** 대사 실행 ID (DB 저장됨) */
  reconciliationRunId: Scalars['String']['output']
  /** 대사 상태 (SUCCESS, PARTIAL, FAILED) */
  status: Scalars['String']['output']
  /** 총 API 호출 횟수 */
  totalApiCalls: Scalars['Int']['output']
  /** Airwallex 거래 불일치 상세 */
  transactionMismatches: Scalars['JSON']['output']
}

export type AmlAlertFilterInput = {
  alertType?: InputMaybe<AmlAlertType>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  severity?: InputMaybe<RiskLevel>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  status?: InputMaybe<AmlAlertStatus>
}

export type AmlAlertListModel = {
  __typename?: 'AmlAlertListModel'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<AmlAlertModel>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type AmlAlertModel = {
  __typename?: 'AmlAlertModel'
  alertType: AmlAlertType
  assigneeId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  merchantId: Scalars['Int']['output']
  merchantName?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  paymentId?: Maybe<Scalars['String']['output']>
  resolvedAt?: Maybe<Scalars['DateTime']['output']>
  resolvedById?: Maybe<Scalars['Int']['output']>
  screeningResult?: Maybe<AmlScreeningResultModel>
  screeningResultId: Scalars['String']['output']
  severity: RiskLevel
  status: AmlAlertStatus
  updatedAt: Scalars['DateTime']['output']
}

/** AML 알림 처리 상태 */
export enum AmlAlertStatus {
  FALSE_POSITIVE = 'FALSE_POSITIVE',
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED',
  REVIEWING = 'REVIEWING',
}

/** AML 알림 유형 */
export enum AmlAlertType {
  DARKWEB = 'DARKWEB',
  GAMBLING = 'GAMBLING',
  HIGH_RISK_WALLET = 'HIGH_RISK_WALLET',
  MIXER_DETECTED = 'MIXER_DETECTED',
  SANCTIONED_ADDRESS = 'SANCTIONED_ADDRESS',
  SCAM = 'SCAM',
  STOLEN_FUNDS = 'STOLEN_FUNDS',
  TERRORISM = 'TERRORISM',
}

export type AmlScreeningResultFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  paymentId?: InputMaybe<Scalars['String']['input']>
  riskLevel?: InputMaybe<RiskLevel>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  status?: InputMaybe<AmlScreeningStatus>
}

export type AmlScreeningResultListModel = {
  __typename?: 'AmlScreeningResultListModel'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<AmlScreeningResultModel>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type AmlScreeningResultModel = {
  __typename?: 'AmlScreeningResultModel'
  blockchain: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  detectedCategories?: Maybe<Scalars['JSON']['output']>
  direction: WalletScreeningDirection
  id: Scalars['ID']['output']
  paymentId?: Maybe<Scalars['String']['output']>
  providerId: Scalars['Int']['output']
  providerName?: Maybe<Scalars['String']['output']>
  rawResponse?: Maybe<Scalars['JSON']['output']>
  riskLevel: RiskLevel
  riskScore?: Maybe<Scalars['Int']['output']>
  screenedAt?: Maybe<Scalars['DateTime']['output']>
  status: AmlScreeningStatus
  transactionId?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
  walletAddress: Scalars['String']['output']
}

/** AML 스크리닝 결과 상태 */
export enum AmlScreeningStatus {
  BLOCK = 'BLOCK',
  ERROR = 'ERROR',
  PASS = 'PASS',
  PENDING = 'PENDING',
  REVIEW = 'REVIEW',
}

/** API 키 필터 입력 */
export type ApiKeyFilterInput = {
  /** 키 환경 */
  environment?: InputMaybe<Scalars['String']['input']>
  /** 삭제된 키 포함 여부 */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>
  /** 만료된 키 포함 여부 */
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>
  /** 키 타입 (TEST/LIVE) */
  keyType?: InputMaybe<Scalars['String']['input']>
  /** 가맹점 ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 상태 */
  status?: InputMaybe<Scalars['String']['input']>
}

export type ApiKeyList = {
  __typename?: 'ApiKeyList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<MerchantApiKey>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 승인 대기 항목 카테고리 */
export enum ApprovalTodoCategory {
  CHANNEL_FEE = 'CHANNEL_FEE',
  OFFRAMP = 'OFFRAMP',
  ONRAMP = 'ONRAMP',
  PAYOUT = 'PAYOUT',
  RECONCILIATION = 'RECONCILIATION',
  REFUND = 'REFUND',
  TOPUP = 'TOPUP',
  WITHDRAWAL = 'WITHDRAWAL',
}

export type ApprovalTodoFilterInput = {
  category?: InputMaybe<ApprovalTodoCategory>
}

export type ApprovalTodoItem = {
  __typename?: 'ApprovalTodoItem'
  amount: Scalars['Float']['output']
  category: ApprovalTodoCategory
  createdAt: Scalars['DateTime']['output']
  currency: Scalars['String']['output']
  merchantId?: Maybe<Scalars['Int']['output']>
  merchantName?: Maybe<Scalars['String']['output']>
  orderId: Scalars['String']['output']
  version?: Maybe<Scalars['String']['output']>
}

export type ApprovalTodoList = {
  __typename?: 'ApprovalTodoList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ApprovalTodoItem>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type ApprovalTodoSummary = {
  __typename?: 'ApprovalTodoSummary'
  channelFeeCount: Scalars['Int']['output']
  offrampCount: Scalars['Int']['output']
  onrampCount: Scalars['Int']['output']
  payoutCount: Scalars['Int']['output']
  reconciliationCount: Scalars['Int']['output']
  refundCount: Scalars['Int']['output']
  topupCount: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
  withdrawalCount: Scalars['Int']['output']
}

export type ApproveCryptoPayoutInput = {
  /** Payout institution selected by admin */
  channel: CryptoPayoutChannel
  /** Crypto payout order ID */
  orderId: Scalars['String']['input']
}

export type ApproveManualRefundInput = {
  /** 승인할 수동 환불 ID */
  id: Scalars['String']['input']
  /** 승인 메모 */
  reviewNote?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
  /** 환불 지갑주소 (옵션, 입력 시 메타데이터 주소 대신 사용) */
  walletAddress?: InputMaybe<Scalars['String']['input']>
}

export type ApproveOfframpInput = {
  /** Offramp institution selected by admin */
  channel: OfframpChannel
  /** Offramp order ID */
  orderId: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type ApproveOnrampInput = {
  /** Onramp institution selected by admin */
  channel: OnrampChannel
  /** Trigger the funding transfer from the source channel to the onramp channel after approval */
  fundingEnabled?: Scalars['Boolean']['input']
  /** Onramp order ID */
  orderId: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type ApproveRefundApprovalInput = {
  id: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type AssignTopupToInternalTransferInput = {
  channelTransferId: Scalars['String']['input']
  id: Scalars['Int']['input']
  memo?: InputMaybe<Scalars['String']['input']>
}

export type AssignUserMenusInput = {
  /** 할당할 메뉴 및 권한 목록 */
  menuAssignments: Array<MenuAssignmentInput>
  /** 사용자 ID */
  userId: Scalars['Int']['input']
}

/** 자동환불 엑셀 다운로드 응답 */
export type AutoRefundExcelResponse = {
  __typename?: 'AutoRefundExcelResponse'
  /** 즉시 다운로드 URL (1000건 이하) */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** 비동기 작업 ID (1000건 초과) */
  jobId?: Maybe<Scalars['String']['output']>
  /** 사용자 메시지 */
  message: Scalars['String']['output']
  /** 처리 유형 (IMMEDIATE/ASYNC) */
  processType: Scalars['String']['output']
  /** 총 레코드 수 */
  recordCount: Scalars['Int']['output']
}

export type AutoRefundFilterInput = {
  /** 자동환불 유형 */
  autoRefundType?: InputMaybe<AutoRefundType>
  /** 부분 환불 여부 */
  isPartial?: InputMaybe<Scalars['Boolean']['input']>
  /** 엑셀 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 최대 환불 금액 */
  maxAmount?: InputMaybe<Scalars['Float']['input']>
  /** 가맹점 ID (내부 관리용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 최소 환불 금액 */
  minAmount?: InputMaybe<Scalars['Float']['input']>
  /** 환불 종료일 */
  refundEndDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 환불 시작일 */
  refundStartDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>
  /** 검색 영역 */
  searchField?: InputMaybe<RefundSearchField>
  /** 환불 상태 */
  status?: InputMaybe<TransactionStatus>
}

/** 자동환불 목록 응답 */
export type AutoRefundList = {
  __typename?: 'AutoRefundList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<Transaction>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 자동환불 유형 */
export enum AutoRefundType {
  OVERPAYMENT = 'OVERPAYMENT',
  PAYMENT_EXPIRED = 'PAYMENT_EXPIRED',
  PAYMENT_TIMEOUT = 'PAYMENT_TIMEOUT',
  PAYMENT_UNDERPAID = 'PAYMENT_UNDERPAID',
}

export type BankTransferOptionsInput = {
  /** 은행 코드 */
  bankCode: Scalars['String']['input']
}

export type BatchCryptoPayoutResponse = {
  __typename?: 'BatchCryptoPayoutResponse'
  /** Merchant payout batch number */
  batchNo: Scalars['String']['output']
  /** Batch completion time */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  id: Scalars['Int']['output']
  /** Merchant ID */
  merchantId: Scalars['Int']['output']
  /** Batch remark */
  remark?: Maybe<Scalars['String']['output']>
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output']
}

export type BatchCryptoPayoutUploadResponse = {
  __typename?: 'BatchCryptoPayoutUploadResponse'
  /** Batch database ID */
  batchId: Scalars['Int']['output']
  /** Merchant payout batch number */
  batchNo: Scalars['String']['output']
  /** Number of validated payout rows */
  rowCount: Scalars['Int']['output']
}

/** 가맹점 수취인 */
export type BeneficiaryModel = {
  __typename?: 'BeneficiaryModel'
  /** 지갑 주소 (CRYPTO) */
  address?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  /** 수취인 타입별 상세 정보 */
  details?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  /** 별칭 */
  label?: Maybe<Scalars['String']['output']>
  /** 마지막 사용 시각 */
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>
  /** 네트워크 (CRYPTO) */
  network?: Maybe<Scalars['String']['output']>
  /** 수취인 유형 (CRYPTO | BANK) */
  type: Scalars['String']['output']
  /** 검증 완료 시각 */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>
}

export type BinanceConnectLinkRequest = {
  /** Receive address */
  address: Scalars['String']['input']
  /** Payment ID */
  paymentId: Scalars['String']['input']
}

export type BinanceConnectLinkResponse = {
  __typename?: 'BinanceConnectLinkResponse'
  /** Binance connect redirect link */
  link: Scalars['String']['output']
  /** Link expiry time */
  linkExpireTime: Scalars['DateTime']['output']
}

export type BulkRoleMenuPermissionInput = {
  permissions: Array<RoleMenuPermissionItem>
  role: UserRole
}

/** Steps included in one business action */
export enum BusinessStep {
  CANCEL = 'CANCEL',
  FAIL = 'FAIL',
  INITIATE = 'INITIATE',
  RECEIVE = 'RECEIVE',
  SUCCESS = 'SUCCESS',
}

/** Business type for account record */
export enum BusinessType {
  CHANNEL_BALANCE_TRANSFER = 'CHANNEL_BALANCE_TRANSFER',
  MANUAL_TRANSFER = 'MANUAL_TRANSFER',
  MICRO_TRANSFER = 'MICRO_TRANSFER',
  OFFRAMP = 'OFFRAMP',
  ONRAMP = 'ONRAMP',
  ONRAMP_FUNDING = 'ONRAMP_FUNDING',
  PAYIN_AUTO_REFUND = 'PAYIN_AUTO_REFUND',
  PAYIN_OFFRAMP = 'PAYIN_OFFRAMP',
  PAYIN_ORDER = 'PAYIN_ORDER',
  PAYIN_PAYMENT = 'PAYIN_PAYMENT',
  PAYIN_REFUND = 'PAYIN_REFUND',
  PAYIN_SETTLEMENT = 'PAYIN_SETTLEMENT',
  PAYOUT = 'PAYOUT',
  TOPUP = 'TOPUP',
  WITHDRAWAL = 'WITHDRAWAL',
}

/** 환불 링크 취소 입력 */
export type CancelRefundLinkInput = {
  /** 취소 사유 */
  reason?: InputMaybe<Scalars['String']['input']>
  /** 취소할 환불 링크 ID */
  refundLinkId: Scalars['String']['input']
}

/** 환불 링크 취소 응답 */
export type CancelRefundLinkResponse = {
  __typename?: 'CancelRefundLinkResponse'
  /** 메시지 (성공 또는 실패 사유) */
  message?: Maybe<Scalars['String']['output']>
  /** 연결된 결제 ID */
  paymentId: Scalars['String']['output']
  /** 취소된 환불 링크 ID */
  refundLinkId: Scalars['String']['output']
  /** 변경된 상태 */
  status: RefundLinkStatus
  /** 취소 성공 여부 */
  success: Scalars['Boolean']['output']
}

export type CancelTopupRequestInput = {
  requestId: Scalars['String']['input']
}

/** 취소/환불 통계 */
export type CancellationStats = {
  __typename?: 'CancellationStats'
  /** 자동 환불 - 만료 */
  autoRefundExpired: Scalars['Int']['output']
  /** 자동 환불 - 초과입금 */
  autoRefundOverpayment: Scalars['Int']['output']
  /** 자동 환불 - 타임아웃 */
  autoRefundTimeout: Scalars['Int']['output']
  /** 자동 환불 - 미달입금 */
  autoRefundUnderpaid: Scalars['Int']['output']
  /** 자동 환불 건수 */
  cancellationAutoCount: Scalars['Int']['output']
  /** 총 취소/환불 건수 */
  cancellationCount: Scalars['Int']['output']
  /** 전액 취소/환불 건수 */
  cancellationFullCount: Scalars['Int']['output']
  /** 부분 취소/환불 건수 */
  cancellationPartialCount: Scalars['Int']['output']
  /** 취소/환불률 (%) */
  cancellationRate?: Maybe<Scalars['Float']['output']>
  /** 취소/환불 성공 건수 */
  cancellationSuccessCount: Scalars['Int']['output']
  /** 총 취소/환불 금액 */
  cancellationTotalAmount: Scalars['Float']['output']
}

export type CardOptionsInput = {
  /** 할부 개월 수 */
  installmentMonths?: InputMaybe<Scalars['Int']['input']>
}

/** 비밀번호 변경 입력 */
export type ChangePasswordInput = {
  /** 새 비밀번호 확인 */
  confirmPassword: Scalars['String']['input']
  /** 현재 비밀번호 */
  currentPassword: Scalars['String']['input']
  /** 새 비밀번호 */
  newPassword: Scalars['String']['input']
}

export type Channel = {
  __typename?: 'Channel'
  capabilities: Array<ChannelCapability>
  code: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  description?: Maybe<Scalars['String']['output']>
  /** 연결된 payin PG (PaymentGateway.id) */
  gatewayId?: Maybe<Scalars['Int']['output']>
  /** 연결된 PG의 상태 (payin 실제 스위치) */
  gatewayStatus?: Maybe<GatewayStatus>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  status: ChannelStatus
  /** 채널의 충전 입금 정보 제공 방식 */
  topupAccountSource: TopupAccountSource
  updatedAt: Scalars['DateTime']['output']
}

export type ChannelBalance = {
  __typename?: 'ChannelBalance'
  balances: Array<ChannelBalanceItem>
  channelCode: Scalars['String']['output']
  channelLabel: Scalars['String']['output']
}

export type ChannelBalanceItem = {
  __typename?: 'ChannelBalanceItem'
  availableBalance: Scalars['String']['output']
  currency: Scalars['String']['output']
  frozenBalance?: Maybe<Scalars['String']['output']>
  totalBalance?: Maybe<Scalars['String']['output']>
}

/** 페이아웃 채널별 분포 항목 */
export type ChannelBreakdownItem = {
  __typename?: 'ChannelBreakdownItem'
  /** 성공 금액 합 */
  amount: Scalars['Float']['output']
  /** 채널 (예: COBO, PYVIO) */
  channel: Scalars['String']['output']
  /** 채널 비용 합 (성공건만) */
  channelFeeAmount: Scalars['Float']['output']
  /** 전체 건수 (성공+실패) */
  count: Scalars['Int']['output']
  /** 우리 수수료 합 (성공건만) */
  feeAmount: Scalars['Float']['output']
  /** 성공 건수 */
  successCount: Scalars['Int']['output']
}

export type ChannelCapability = {
  __typename?: 'ChannelCapability'
  capability: ChannelCapabilityType
  /** 기능별 운영 설정값 (비밀값 저장 금지) */
  config?: Maybe<Scalars['JSON']['output']>
  enabled: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
}

/** 채널 제공 기능 */
export enum ChannelCapabilityType {
  BALANCE = 'BALANCE',
  OFFRAMP = 'OFFRAMP',
  ONRAMP = 'ONRAMP',
  PAYIN = 'PAYIN',
  PAYOUT = 'PAYOUT',
  TOPUP = 'TOPUP',
  WITHDRAWAL = 'WITHDRAWAL',
}

export type ChannelFilterInput = {
  /** 이 기능이 enabled인 채널만 */
  capability?: InputMaybe<ChannelCapabilityType>
  status?: InputMaybe<ChannelStatus>
}

export type ChannelFundFlow = {
  __typename?: 'ChannelFundFlow'
  amount: Scalars['Float']['output']
  chainTx?: Maybe<Scalars['String']['output']>
  channelCode: Scalars['String']['output']
  currency: Scalars['String']['output']
  direction: FundFlowDirection
  externalId: Scalars['String']['output']
  /** PG 원본 상태값 (raw에서 추출 — 예: Underpaid, SETTLED, fund_type) */
  externalStatus?: Maybe<Scalars['String']['output']>
  feeAmount?: Maybe<Scalars['Float']['output']>
  id: Scalars['String']['output']
  occurredAt: Scalars['DateTime']['output']
  source: Scalars['String']['output']
  status: ChannelFundFlowStatus
  syncedAt: Scalars['DateTime']['output']
}

export type ChannelFundFlowFilterInput = {
  channelCode?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  direction?: InputMaybe<FundFlowDirection>
  from?: InputMaybe<Scalars['DateTime']['input']>
  status?: InputMaybe<ChannelFundFlowStatus>
  to?: InputMaybe<Scalars['DateTime']['input']>
}

export type ChannelFundFlowList = {
  __typename?: 'ChannelFundFlowList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ChannelFundFlow>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 채널 자금 흐름 상태 */
export enum ChannelFundFlowStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

/** 채널 자금 흐름 동기화 기간 모드 */
export enum ChannelFundFlowSyncRangeMode {
  CUSTOM = 'CUSTOM',
  DEFAULT = 'DEFAULT',
}

export type ChannelFundFlowSyncRun = {
  __typename?: 'ChannelFundFlowSyncRun'
  channelCode: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  error?: Maybe<Scalars['String']['output']>
  fetched: Scalars['Int']['output']
  finishedAt?: Maybe<Scalars['DateTime']['output']>
  heartbeatAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['String']['output']
  rangeFrom: Scalars['DateTime']['output']
  rangeMode: ChannelFundFlowSyncRangeMode
  rangeTo: Scalars['DateTime']['output']
  startedAt?: Maybe<Scalars['DateTime']['output']>
  status: ChannelFundFlowSyncStatus
  stepsDone: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
  upserted: Scalars['Int']['output']
}

/** 채널 자금 흐름 동기화 실행 상태 */
export enum ChannelFundFlowSyncStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
}

export type ChannelList = {
  __typename?: 'ChannelList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<Channel>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type ChannelRoute = {
  __typename?: 'ChannelRoute'
  businessType: ChannelRouteBusinessType
  channel: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  /** Merchant associated with this channel route */
  merchant?: Maybe<Merchant>
  merchantId?: Maybe<Scalars['Int']['output']>
}

/** Channel route business type */
export enum ChannelRouteBusinessType {
  OFFRAMP = 'OFFRAMP',
  ONRAMP = 'ONRAMP',
  PAYOUT = 'PAYOUT',
  TOPUP = 'TOPUP',
  TOPUP_CRYPTO = 'TOPUP_CRYPTO',
  WITHDRAWAL = 'WITHDRAWAL',
}

export type ChannelRouteFilterInput = {
  /** Business type */
  businessType?: InputMaybe<ChannelRouteBusinessType>
  /** Route channel */
  channel?: InputMaybe<Scalars['String']['input']>
  /** Merchant ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type ChannelRouteList = {
  __typename?: 'ChannelRouteList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ChannelRoute>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 채널 상태 */
export enum ChannelStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  MAINTENANCE = 'MAINTENANCE',
}

export type ChannelTopupAccount = {
  __typename?: 'ChannelTopupAccount'
  accountName: Scalars['String']['output']
  accountNumber: Scalars['String']['output']
  bankCode?: Maybe<Scalars['String']['output']>
  bankName: Scalars['String']['output']
  branchCode?: Maybe<Scalars['String']['output']>
  currency: Scalars['String']['output']
  externalId: Scalars['String']['output']
  location?: Maybe<Scalars['String']['output']>
  nickName?: Maybe<Scalars['String']['output']>
  swiftCode?: Maybe<Scalars['String']['output']>
}

export type ChannelTransferFilterInput = {
  sourceChannel?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ChannelTransferStatus>
  targetChannel?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<ChannelTransferType>
}

export type ChannelTransferModel = {
  __typename?: 'ChannelTransferModel'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  completedBy?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<Scalars['String']['output']>
  destinationAddress?: Maybe<Scalars['String']['output']>
  destinationMemo?: Maybe<Scalars['String']['output']>
  errorCode?: Maybe<Scalars['String']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  failedAt?: Maybe<Scalars['DateTime']['output']>
  feeAmount?: Maybe<Scalars['Float']['output']>
  feeCurrency?: Maybe<Scalars['String']['output']>
  gatewayCode?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  memo?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<Scalars['JSON']['output']>
  processedAt?: Maybe<Scalars['DateTime']['output']>
  providerRef?: Maybe<Scalars['String']['output']>
  requestedAmount?: Maybe<Scalars['Float']['output']>
  requestedAt: Scalars['DateTime']['output']
  requestedCurrency?: Maybe<Scalars['String']['output']>
  sourceAmount?: Maybe<Scalars['Float']['output']>
  sourceChannel: Scalars['String']['output']
  sourceCurrency?: Maybe<Scalars['String']['output']>
  status: ChannelTransferStatus
  succeededAt?: Maybe<Scalars['DateTime']['output']>
  targetAmount?: Maybe<Scalars['Float']['output']>
  targetChannel: Scalars['String']['output']
  targetCurrency?: Maybe<Scalars['String']['output']>
  transferId: Scalars['String']['output']
  txHash?: Maybe<Scalars['String']['output']>
  type: ChannelTransferType
  updatedAt: Scalars['DateTime']['output']
}

export type ChannelTransferPage = {
  __typename?: 'ChannelTransferPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ChannelTransferModel>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 채널 트랜스퍼 상태 */
export enum ChannelTransferStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

/** 채널 트랜스퍼 타입 */
export enum ChannelTransferType {
  MANUAL_TRANSFER = 'MANUAL_TRANSFER',
  OFFRAMP = 'OFFRAMP',
  ONRAMP_FUNDING = 'ONRAMP_FUNDING',
}

export type CheckoutPaymentOption = {
  __typename?: 'CheckoutPaymentOption'
  displayName: Scalars['String']['output']
  icon?: Maybe<Scalars['String']['output']>
  maxAmount?: Maybe<Scalars['Float']['output']>
  method: Scalars['String']['output']
  minAmount?: Maybe<Scalars['Float']['output']>
  supportedCountries?: Maybe<Array<Scalars['String']['output']>>
}

export type CheckoutSession = {
  __typename?: 'CheckoutSession'
  amount: Scalars['Float']['output']
  checkoutPaymentOptions: Array<CheckoutPaymentOption>
  checkoutUrl: Scalars['String']['output']
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  currency: Scalars['String']['output']
  customer?: Maybe<CustomerInfo>
  expiresAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  merchant?: Maybe<Merchant>
  merchantId: Scalars['Float']['output']
  merchantOrderId: Scalars['String']['output']
  metadata?: Maybe<Scalars['JSON']['output']>
  options?: Maybe<Scalars['JSON']['output']>
  orderName: Scalars['String']['output']
  payment?: Maybe<Payment>
  paymentId?: Maybe<Scalars['String']['output']>
  selectedPaymentMethod?: Maybe<Scalars['String']['output']>
  sessionId: Scalars['String']['output']
  status: CheckoutSessionStatus
  updatedAt: Scalars['DateTime']['output']
  urls?: Maybe<CheckoutUrls>
}

/** 체크아웃 세션 상태 */
export enum CheckoutSessionStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
}

export type CheckoutSessionStatusUpdate = {
  __typename?: 'CheckoutSessionStatusUpdate'
  sessionId: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type CheckoutUrls = {
  __typename?: 'CheckoutUrls'
  fail: Scalars['String']['output']
  success: Scalars['String']['output']
  webhook?: Maybe<Scalars['String']['output']>
}

/** Single client-side error event payload */
export type ClientErrorInput = {
  /** ISO8601 timestamp (client clock; server also records receivedAt) */
  capturedAt: Scalars['String']['input']
  /** React componentStack */
  componentStack?: InputMaybe<Scalars['String']['input']>
  /** GraphQL extensions.code */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** Client-generated short id (<=24 chars) */
  errorId: Scalars['String']['input']
  /** Additional masked context */
  extra?: InputMaybe<Scalars['JSON']['input']>
  /** HTTP status code (100~599) */
  httpStatus?: InputMaybe<Scalars['Int']['input']>
  /** Masked error message */
  message: Scalars['String']['input']
  /** Error constructor name */
  name: Scalars['String']['input']
  /** Apollo operation name */
  operationName?: InputMaybe<Scalars['String']['input']>
  /** Release identifier (commit SHA or version) */
  release: Scalars['String']['input']
  /** Capture source category */
  source: ClientErrorSource
  /** Masked stack trace */
  stack?: InputMaybe<Scalars['String']['input']>
  /** Pathname + whitelisted query */
  url: Scalars['String']['input']
}

/** 클라이언트 에러 캡처 소스 카테고리 */
export enum ClientErrorSource {
  GRAPHQL = 'GRAPHQL',
  MANUAL = 'MANUAL',
  NETWORK = 'NETWORK',
  REACT_RENDER = 'REACT_RENDER',
  UNHANDLED_REJECTION = 'UNHANDLED_REJECTION',
  WINDOW_ERROR = 'WINDOW_ERROR',
}

export type CoboOrderLinkRequest = {
  /** Checkout session ID */
  checkoutId: Scalars['String']['input']
  /** Locale for payment page (en, ko, zh, etc.) */
  locale?: InputMaybe<Scalars['String']['input']>
}

export type CoboOrderLinkResponse = {
  __typename?: 'CoboOrderLinkResponse'
  /** Cobo order link token */
  token: Scalars['String']['output']
  /** Cobo order link url */
  url: Scalars['String']['output']
}

export type CoboReconciliationResult = {
  __typename?: 'CoboReconciliationResult'
  /** 우리쪽 통계 */
  ourSide: ReconciliationSideResult
  /** 조회 시작일 */
  periodFrom: Scalars['DateTime']['output']
  /** 조회 종료일 */
  periodTo: Scalars['DateTime']['output']
  /** PG쪽 통계 */
  pgSide: ReconciliationSideResult
  /** 대사 실행 ID (DB 저장됨) */
  reconciliationRunId: Scalars['String']['output']
  /** 대사 상태 (SUCCESS, PARTIAL, FAILED) */
  status: Scalars['String']['output']
  /** 총 API 호출 횟수 */
  totalApiCalls: Scalars['Int']['output']
  /** Transaction 불일치 목록 (매칭된 Payment 내 Transaction 불일치) */
  transactionMismatches?: Maybe<Scalars['JSON']['output']>
}

export type CompanyInfoInput = {
  /** 회사명 */
  companyName?: InputMaybe<Scalars['String']['input']>
  /** 회사 소재 국가 */
  countryCode?: InputMaybe<CountryCode>
  /** 직원수 */
  employeeCount?: InputMaybe<Scalars['Int']['input']>
  /** 회사 등록일 */
  registeredDate?: InputMaybe<Scalars['String']['input']>
  /** 세금 번호 */
  taxNumber?: InputMaybe<Scalars['String']['input']>
  /** 회사 홈페이지 URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type CompleteCryptoPayoutManuallyInput = {
  /** Blockchain transaction hash */
  chainTx?: InputMaybe<Scalars['String']['input']>
  /** Channel fee amount charged by the selected institution */
  channelFeeAmount: Scalars['Float']['input']
  /** Channel payout order ID */
  channelOrderId: Scalars['String']['input']
  /** Crypto payout order ID */
  orderId: Scalars['String']['input']
}

export type CompleteOfframpManuallyInput = {
  /** Channel fee amount charged by the selected institution */
  channelFeeAmount: Scalars['Float']['input']
  /** Channel offramp order ID */
  channelOrderId: Scalars['String']['input']
  /** Offramp order ID */
  orderId: Scalars['String']['input']
  /** Target amount sent by the selected institution */
  targetAmount: Scalars['Float']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type CompleteOfframpTransferInput = {
  feeAmount?: Scalars['Float']['input']
  feeCurrency?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  memo?: InputMaybe<Scalars['String']['input']>
  sourceAmount: Scalars['Float']['input']
  sourceCurrency: Scalars['String']['input']
  targetAmount: Scalars['Float']['input']
  targetCurrency: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
  txHash?: InputMaybe<Scalars['String']['input']>
}

export type CompleteOnrampManuallyInput = {
  /** Channel fee amount charged by the selected institution */
  channelFeeAmount: Scalars['Float']['input']
  /** Channel onramp order ID */
  channelOrderId: Scalars['String']['input']
  /** Onramp order ID */
  orderId: Scalars['String']['input']
  /** Target amount received from the selected institution */
  targetAmount: Scalars['Float']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

/** 출금 완료 입력 */
export type CompleteWithdrawalInput = {
  /** 완료 메모 */
  completionNote?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
  /** 은행/PG사 거래 참조번호 */
  transactionRef?: InputMaybe<Scalars['String']['input']>
  /** 출금 요청 ID */
  withdrawalId: Scalars['String']['input']
}

export type ConfirmEnrollmentInput = {
  code: Scalars['String']['input']
  emailCode: Scalars['String']['input']
}

export type ConfirmReceiptInput = {
  id: Scalars['String']['input']
  memo?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

/** Input for contacting sales team */
export type ContactSalesInput = {
  /** Company name */
  companyName: Scalars['String']['input']
  /** Email address for contact */
  email: Scalars['String']['input']
  /** Additional message or details (optional) */
  message?: InputMaybe<Scalars['String']['input']>
  /** Name of the person submitting the inquiry */
  name: Scalars['String']['input']
  /** Phone number for contact */
  phoneNumber: Scalars['String']['input']
  /** Company website URL (optional) */
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

/** Response for contacting sales team */
export type ContactSalesResponse = {
  __typename?: 'ContactSalesResponse'
  /** Message describing the result of the submission */
  message: Scalars['String']['output']
  /** Whether the submission was successful */
  success: Scalars['Boolean']['output']
}

/** 국가 코드 */
export enum CountryCode {
  CN = 'CN',
  ID = 'ID',
  JP = 'JP',
  KR = 'KR',
  MY = 'MY',
  PH = 'PH',
  SG = 'SG',
  TH = 'TH',
  US = 'US',
  VN = 'VN',
}

/** API 키 생성 입력 */
export type CreateApiKeyInput = {
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 키 환경 (CLIENT_KEY/SECRET_KEY/WEBHOOK_KEY) */
  environment: Scalars['String']['input']
  /** 만료일 (ISO 8601) */
  expiresAt?: InputMaybe<Scalars['String']['input']>
  /** IP 화이트리스트 (비어있으면 모든 IP 허용) */
  ipWhitelist?: InputMaybe<Array<Scalars['String']['input']>>
  /** 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 가맹점 ID (ADMIN만 설정 가능) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

/** API 키 생성/재생성 응답 */
export type CreateApiKeyResponse = {
  __typename?: 'CreateApiKeyResponse'
  /** 생성된 API 키 정보 */
  apiKey: MerchantApiKey
  /** 안내 메시지 */
  message: Scalars['String']['output']
  /** 평문 API 키 (생성 시 1회만 제공, 안전하게 보관 필요) */
  plainTextKey: Scalars['String']['output']
}

/** USD 은행 수취인 등록 입력 */
export type CreateBankBeneficiaryInput = {
  /** 예금주명 */
  accountHolder: Scalars['String']['input']
  /** 계좌번호 */
  accountNumber: Scalars['String']['input']
  /** 계좌 타입 */
  accountType?: InputMaybe<Scalars['String']['input']>
  /** 은행 주소 */
  bankAddress?: InputMaybe<Scalars['String']['input']>
  /** 은행 코드 */
  bankCode?: InputMaybe<Scalars['String']['input']>
  /** 은행 국가 코드 */
  bankCountry: Scalars['String']['input']
  /** 은행명 */
  bankName: Scalars['String']['input']
  /** 수취인 주소 */
  beneficiaryAddress?: InputMaybe<Scalars['String']['input']>
  /** 통화 코드. 현재 USD만 지원 */
  currency: Scalars['String']['input']
  /** 별칭 */
  label?: InputMaybe<Scalars['String']['input']>
  /** 메모 */
  memo?: InputMaybe<Scalars['String']['input']>
  /** 가맹점 ID (관리자용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** ACH routing number */
  routingNumber?: InputMaybe<Scalars['String']['input']>
  /** SWIFT/BIC 코드 */
  swiftCode?: InputMaybe<Scalars['String']['input']>
}

export type CreateChannelInput = {
  /** 채널 코드 (대문자·숫자·언더스코어) */
  code: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  status?: InputMaybe<ChannelStatus>
}

export type CreateChannelRouteInput = {
  /** Business type */
  businessType: ChannelRouteBusinessType
  /** Route channel (Channel registry code) */
  channel: Scalars['String']['input']
  /** Merchant ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateCoboOrderRequest = {
  /** Checkout session ID */
  checkoutId: Scalars['String']['input']
  /** payment token ID for the order (e.g., ETH_USDT, TRON_USDT) */
  tokenId: Scalars['String']['input']
}

export type CreateCoboOrderResponse = {
  __typename?: 'CreateCoboOrderResponse'
  /** Exchange rate used for the token to fiat currency */
  exchangeRate: Scalars['String']['output']
  /** Token amount to be paid */
  payableAmount: Scalars['String']['output']
  /** Address to receive the token */
  receiveAddress: Scalars['String']['output']
}

export type CreateCryptoRefundFeeInput = {
  /** 주문/정산 통화 ID (L1/L2, e.g. USD, KRW) */
  currencyId: Scalars['Int']['input']
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 수수료 금액 또는 비율 (PERCENTAGE일 경우 0-100) */
  feeAmount: Scalars['Float']['input']
  /** 수수료 타입 */
  feeType: CryptoRefundFeeType
  /** 활성화 상태 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 최대 수수료 */
  maxFee?: InputMaybe<Scalars['Float']['input']>
  /** 가맹점 ID (시스템 기본값 생성 시 생략) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 최소 수수료 */
  minFee?: InputMaybe<Scalars['Float']['input']>
  /** 실결제 통화 ID (L3 Crypto Currency, e.g. TRON_USDT) */
  payableCurrencyId: Scalars['Int']['input']
}

export type CreateCurrencyInput = {
  /** 내부용 기본 토큰 (USDT, USD 등) */
  baseToken: Scalars['String']['input']
  /** 통화 코드 (USD, KRW, TRON_USDT 등) */
  code: Scalars['String']['input']
  /** 소수점 자리수 */
  decimals?: Scalars['Int']['input']
  /** 활성 상태 */
  isActive?: Scalars['Boolean']['input']
  /** 환율 조회 대상 통화 여부 */
  isExchangeRateEnabled?: Scalars['Boolean']['input']
  /** 정산 가능 통화 여부 */
  isSettleable?: Scalars['Boolean']['input']
  /** 출금 가능 통화 여부 */
  isWithdrawable?: Scalars['Boolean']['input']
  /** AML 스크리닝 최소 금액 (null이면 전액 스크리닝) */
  minAmlScreeningAmount?: InputMaybe<Scalars['Float']['input']>
  /** 통화 이름 (US Dollar, Korean Won 등) */
  name: Scalars['String']['input']
  /** 블록체인 네트워크 (TRON, ETH 등, Fiat은 null) */
  network?: InputMaybe<Scalars['String']['input']>
  /** 통화 기호 ($, ₩, ¥ 등) */
  symbol: Scalars['String']['input']
  /** 통화 토큰 유형 (FIAT, STABLECOIN, CRYPTO) */
  tokenType?: TokenType
}

export type CreateExchangeRateInput = {
  /** 예금 마진 (%) - 예금 시 적용 */
  depositMargin?: Scalars['Float']['input']
  /** 기준 통화 ID */
  fromCurrencyId: Scalars['Int']['input']
  /** 결제 마진 (%) - 고객 결제 시 적용 */
  paymentMargin?: Scalars['Float']['input']
  /** 환율 */
  rate: Scalars['Float']['input']
  /** 환율 출처 */
  source: ExchangeRateSource
  /** 대상 통화 ID */
  toCurrencyId: Scalars['Int']['input']
  /** 유효 시작일 (ISO 8601) */
  validFrom?: InputMaybe<Scalars['String']['input']>
  /** 유효 종료일 (ISO 8601) */
  validTo?: InputMaybe<Scalars['String']['input']>
  /** 출금 마진 (%) - 가맹점 출금 시 적용 */
  withdrawalMargin?: Scalars['Float']['input']
}

export type CreateManualRefundInput = {
  /** 환불할 금액 */
  amount: Scalars['Float']['input']
  /** 은행/PG사 환불 참조번호 */
  externalRefundId?: InputMaybe<Scalars['String']['input']>
  /** 환불 처리 담당자 메모 */
  note?: InputMaybe<Scalars['String']['input']>
  /** 결제 키 (Payment.paymentKey) */
  paymentKey: Scalars['String']['input']
  /** 환불 사유 */
  reason?: InputMaybe<Scalars['String']['input']>
}

export type CreateManualTopupInput = {
  /** Topup channel */
  channel: TopupChannel
  /** Topup channel account number */
  channelAccountNo?: InputMaybe<Scalars['String']['input']>
  /** Channel fee amount */
  channelFeeAmount: Scalars['Float']['input']
  /** Channel order ID */
  channelOrderId: Scalars['String']['input']
  /** Currency code */
  currency: Scalars['String']['input']
  /** Amount received after the channel fee is deducted */
  receivedAmount: Scalars['Float']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type CreateManualTransferInput = {
  amount: Scalars['Float']['input']
  currency: Scalars['String']['input']
  destinationAddress: Scalars['String']['input']
  destinationMemo?: InputMaybe<Scalars['String']['input']>
  memo?: InputMaybe<Scalars['String']['input']>
  network?: InputMaybe<Scalars['String']['input']>
  sourceChannel: Scalars['String']['input']
  targetChannel: Scalars['String']['input']
  tokenId: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type CreateMenuInput = {
  code: Scalars['String']['input']
  component?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  excludeRoles?: Array<UserRole>
  icon?: InputMaybe<Scalars['String']['input']>
  isPublic?: Scalars['Boolean']['input']
  isVisible?: Scalars['Boolean']['input']
  menuType?: Scalars['String']['input']
  name: Scalars['String']['input']
  parentId?: InputMaybe<Scalars['Int']['input']>
  path?: InputMaybe<Scalars['String']['input']>
  sortOrder?: Scalars['Int']['input']
  target?: Scalars['String']['input']
}

export type CreateMerchantExchangeMarginInput = {
  /** 예금 마진율 (0~100%) */
  depositMarginRate?: InputMaybe<Scalars['Float']['input']>
  /** 원 통화 ID (Currency 테이블 참조) */
  fromCurrencyId: Scalars['Int']['input']
  /** 가맹점 ID */
  merchantId: Scalars['Int']['input']
  /** 결제 마진율 (0~100%) */
  paymentMarginRate?: InputMaybe<Scalars['Float']['input']>
  /** 대상 통화 ID (Currency 테이블 참조) */
  toCurrencyId: Scalars['Int']['input']
  /** 출금 마진율 (0~100%) */
  withdrawalMarginRate?: InputMaybe<Scalars['Float']['input']>
}

/** 가맹점 자주 쓰는 수취인 생성 */
export type CreateMerchantFrequentRecipientInput = {
  /** 주소 */
  address: Scalars['String']['input']
  /** 가맹점 ID (관리자용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 네트워크 */
  network: Scalars['String']['input']
  /** 수취인 이름 */
  recipientName: Scalars['String']['input']
}

export type CreateMerchantInput = {
  /** 추가 정보 */
  additionalInfo?: InputMaybe<Scalars['String']['input']>
  /** 관리자 이메일 */
  adminEmail: Scalars['String']['input']
  /** 관리자 이메일 언어 설정 */
  adminLocale?: InputMaybe<EmailLocale>
  /** 관리자 이름 */
  adminName: Scalars['String']['input']
  /** 관리자 전화 국가코드 */
  adminPhoneCountryCode: Scalars['String']['input']
  /** 관리자 전화번호 */
  adminPhoneNumber: Scalars['String']['input']
  /** 사업장 주소 */
  businessAddress?: InputMaybe<Scalars['String']['input']>
  /** 업종 */
  businessCategory?: InputMaybe<Scalars['String']['input']>
  /** 상호명 */
  businessName?: InputMaybe<Scalars['String']['input']>
  /** 사업자등록번호 */
  businessNumber?: InputMaybe<Scalars['String']['input']>
  /** 사업장 전화 국가코드 */
  businessPhoneCountryCode?: InputMaybe<Scalars['String']['input']>
  /** 사업장 전화번호 */
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>
  /** 회사 추가 정보 */
  companyInfo?: InputMaybe<CompanyInfoInput>
  /** 첨부 서류 */
  documents?: InputMaybe<Array<DocumentInput>>
  /** 상점 이메일 */
  email: Scalars['String']['input']
  /** 상점 배경 설명 */
  merchantBackground?: InputMaybe<Scalars['String']['input']>
  /** 상점명 */
  name: Scalars['String']['input']
  /** 관련 회사 */
  relevantCompany?: InputMaybe<Scalars['String']['input']>
  /** 대표자명 */
  representativeName?: InputMaybe<Scalars['String']['input']>
  /** 위험 수준 - 관리자만 설정 가능 */
  riskLevel?: InputMaybe<RiskLevel>
  /** 정산 상세 정보 */
  settlementInfo?: InputMaybe<SettlementInfoInput>
  /** 서명권자 정보 */
  signerInfo?: InputMaybe<SignerInfoInput>
  /** 상점 상태 */
  status?: InputMaybe<MerchantStatus>
  /** 상점 타입 */
  type?: InputMaybe<MerchantType>
}

export type CreateMerchantPaymentMethodInput = {
  /** 통화별 수수료 설정 */
  currencyFees?: InputMaybe<Scalars['JSON']['input']>
  /** 커스텀 라우팅 ID */
  customRoutingId?: InputMaybe<Scalars['Int']['input']>
  /** 일일 결제 한도 */
  dailyLimitAmount?: InputMaybe<Scalars['Int']['input']>
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 표시 이름 */
  displayName: Scalars['String']['input']
  /** 수수료율 (%) */
  feeRate?: Scalars['Float']['input']
  /** 고정 수수료 */
  fixedFee?: Scalars['Float']['input']
  /** 활성화 여부 */
  isEnabled?: Scalars['Boolean']['input']
  /** 최대 결제 금액 */
  maxAmount?: Scalars['Float']['input']
  /** 최대 수수료 */
  maxFee?: InputMaybe<Scalars['Float']['input']>
  /** 가맹점 ID */
  merchantId: Scalars['Int']['input']
  /** 최소 결제 금액 */
  minAmount?: Scalars['Float']['input']
  /** 최소 수수료 */
  minFee?: Scalars['Float']['input']
  /** 월간 결제 한도 */
  monthlyLimitAmount?: InputMaybe<Scalars['Int']['input']>
  /** 결제 수단 */
  paymentMethod: PaymentMethod
  /** 정산 주기 (일) - 관리자만 설정 가능 */
  settlementCycle?: InputMaybe<Scalars['Int']['input']>
}

export type CreateMerchantPaymentMethodResponse = {
  __typename?: 'CreateMerchantPaymentMethodResponse'
  merchantPaymentMethod: MerchantPaymentMethod
  message: Scalars['String']['output']
}

export type CreateMerchantResponse = {
  __typename?: 'CreateMerchantResponse'
  /** 생성된 관리자 ID */
  adminUserId: Scalars['ID']['output']
  /** 생성된 상점 ID */
  merchantId: Scalars['ID']['output']
  /** 상점 고유 식별자 (MID) */
  mid: Scalars['String']['output']
}

export type CreateMerchantUserInput = {
  /** 이메일 */
  email: Scalars['String']['input']
  /** 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 할당할 메뉴 ID 목록 */
  menuIds?: InputMaybe<Array<Scalars['Int']['input']>>
  /** 메뉴별 상세 권한 설정 */
  menuPermissions?: InputMaybe<Array<MenuPermissionInput>>
  /** 가맹점 ID (ADMIN이 생성 시 필수) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 이름 */
  name: Scalars['String']['input']
  /** 전화 국가코드 */
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>
  /** 전화번호 */
  phoneNumber?: InputMaybe<Scalars['String']['input']>
}

export type CreateMerchantUserResponse = {
  __typename?: 'CreateMerchantUserResponse'
  /** 이메일 발송 성공 여부 */
  emailSent: Scalars['Boolean']['output']
  /** 추가 메시지 */
  message?: Maybe<Scalars['String']['output']>
  /** 비밀번호 설정 링크 (이메일로도 발송됨) */
  passwordSetupUrl: Scalars['String']['output']
  /** 링크 만료 시간 */
  tokenExpiresAt: Scalars['DateTime']['output']
  /** 생성된 사용자 정보 */
  user: User
}

export type CreateOfframpTransferInput = {
  destinationAddress?: InputMaybe<Scalars['String']['input']>
  destinationMemo?: InputMaybe<Scalars['String']['input']>
  memo?: InputMaybe<Scalars['String']['input']>
  requestedAmount: Scalars['Float']['input']
  requestedCurrency: Scalars['String']['input']
  sourceChannel: Scalars['String']['input']
  targetChannel: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type CreatePaymentFromSessionInput = {
  /** 계좌이체 옵션 */
  bankTransferOptions?: InputMaybe<BankTransferOptionsInput>
  /** 카드 결제 옵션 */
  cardOptions?: InputMaybe<CardOptionsInput>
  /** 암호화폐 결제 옵션 */
  cryptoOptions?: InputMaybe<CryptoOptionsInput>
  /** 고객 정보 */
  customer?: InputMaybe<CustomerInput>
  /** 결제 수단 */
  paymentMethod: Scalars['String']['input']
  /** 체크아웃 세션 ID */
  sessionId: Scalars['String']['input']
}

export type CreatePaymentGatewayInput = {
  /** API 버전 */
  apiVersion: Scalars['String']['input']
  /** 기본 수수료율 (0% ~ 100%) */
  baseFeeRate: Scalars['Float']['input']
  /** PG사 API 기본 URL */
  baseUrl: Scalars['String']['input']
  /** PG사 고유 코드 (예: toss, nice) */
  code: Scalars['String']['input']
  /** 최대 결제 금액 */
  maxAmount: Scalars['Int']['input']
  /** 최소 결제 금액 */
  minAmount: Scalars['Int']['input']
  /** PG사 이름 */
  name: Scalars['String']['input']
  /** 정산 주기 (일 단위) */
  settlementCycle: Scalars['Int']['input']
  /** PG사 상태 */
  status?: InputMaybe<GatewayStatus>
  /** 지원하는 통화 목록 */
  supportedCurrencies: Array<Scalars['String']['input']>
  /** 지원하는 결제 수단 목록 */
  supportedMethods: Array<PaymentMethod>
  /** 즉시 정산 지원 여부 */
  supportsInstantSettlement?: InputMaybe<Scalars['Boolean']['input']>
  /** 부분 환불 지원 여부 */
  supportsPartialRefund?: InputMaybe<Scalars['Boolean']['input']>
  /** 정기 결제 지원 여부 */
  supportsRecurring?: InputMaybe<Scalars['Boolean']['input']>
  /** 웹훅 지원 여부 */
  supportsWebhook?: InputMaybe<Scalars['Boolean']['input']>
}

export type CreatePaymentMethodConfigInput = {
  /** 기본 최대 결제 금액 */
  defaultMaxAmount?: InputMaybe<Scalars['Int']['input']>
  /** 기본 최소 결제 금액 */
  defaultMinAmount?: InputMaybe<Scalars['Int']['input']>
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 표시 이름 */
  displayName: Scalars['String']['input']
  /** 아이콘 URL */
  icon?: InputMaybe<Scalars['String']['input']>
  /** 활성화 여부 */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** 추가 메타데이터 */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** 결제 수단 */
  paymentMethod: PaymentMethod
  /** 우선순위 (높을수록 우선) */
  priority?: InputMaybe<Scalars['Int']['input']>
}

export type CreatePaymentMethodRoutingInput = {
  /** PG사 ID */
  gatewayId: Scalars['Int']['input']
  /** 활성 상태 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 기본 라우팅 여부 */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** 결제 수단 */
  paymentMethod: PaymentMethod
  /** 우선순위 (높을수록 선호) */
  priority?: InputMaybe<Scalars['Int']['input']>
}

export type CreatePaymentResponse = {
  __typename?: 'CreatePaymentResponse'
  additionalData?: Maybe<Scalars['JSON']['output']>
  cryptoAddress?: Maybe<CryptoAddressInfo>
  nextAction?: Maybe<PaymentNextAction>
  paymentId: Scalars['String']['output']
  qrCodeUrl?: Maybe<Scalars['String']['output']>
  redirectUrl?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
}

/** PG 정산 요청 생성 입력 */
export type CreatePgSettlementInput = {
  /** 시작일 (UTC) */
  dateFrom: Scalars['DateTime']['input']
  /** 종료일 (UTC) */
  dateTo: Scalars['DateTime']['input']
  /** 법정화폐 통화 코드 (FIAT 정산 시 사용, 기본값: USD) */
  fiatCurrency?: InputMaybe<Scalars['String']['input']>
  /** 정산 항목 목록 (gateway + currency 조합) */
  items: Array<CreatePgSettlementItemInput>
  /** 정산 방식 (CRYPTO: 크립토 지갑 출금, FIAT: 법정화폐 출금) */
  settlementType: PgSettlementType
  /** 트리거 정보 (SCHEDULER, MANUAL:user@email) */
  triggeredBy?: InputMaybe<Scalars['String']['input']>
}

/** PG 정산 항목 입력 */
export type CreatePgSettlementItemInput = {
  /** 크립토 지갑 주소 (CRYPTO 정산 시 해당 토큰의 수신 주소) */
  cryptoAddress?: InputMaybe<Scalars['String']['input']>
  /** Gateway ID */
  gatewayId: Scalars['Int']['input']
  /** 주문 통화 Currency ID - 프리뷰에서 전달 */
  orderCurrencyId?: InputMaybe<Scalars['Int']['input']>
  /** 실제 결제(크립토) 통화 Currency ID */
  payableCurrencyId: Scalars['Int']['input']
  /** 지갑 메모 (일부 체인에 필요: EOS, Cosmos, Stellar 등) */
  walletMemo?: InputMaybe<Scalars['String']['input']>
}

/** 환불 링크 생성 입력 */
export type CreateRefundLinkInput = {
  /** 고객 이메일 (환불 링크 발송용) */
  customerEmail?: InputMaybe<Scalars['String']['input']>
  /** 환불할 결제 ID */
  paymentId: Scalars['String']['input']
  /** 환불 사유 */
  reason?: InputMaybe<Scalars['String']['input']>
  /** 환불 금액 */
  refundAmount: Scalars['Float']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

/** 환불 링크 생성 응답 */
export type CreateRefundLinkResponse = {
  __typename?: 'CreateRefundLinkResponse'
  /** 이메일 큐 추가 여부 (비동기 발송) */
  emailQueued: Scalars['Boolean']['output']
  /** 링크 만료 시간 */
  expiresAt: Scalars['DateTime']['output']
  /** 생성된 환불 링크 ID */
  refundLinkId: Scalars['String']['output']
  /** 환불 링크 URL */
  refundUrl: Scalars['String']['output']
}

export type CreateTopupRequestInput = {
  amount: Scalars['Float']['input']
  currency: Scalars['String']['input']
  /** ADMIN 대리생성 시 대상 가맹점 */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  tokenId?: InputMaybe<Scalars['String']['input']>
}

/** 출금 요청 생성 입력 */
export type CreateWithdrawalInput = {
  /** 저장된 수취인 ID */
  beneficiaryId: Scalars['Int']['input']
  /** 차감할 잔액 통화 코드 */
  fromCurrency: Scalars['String']['input']
  /** 가맹점 ID (관리자용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 출금 방법 */
  method: WithdrawalMethod
  /** 출금 요청 금액 */
  requestedAmount: Scalars['Float']['input']
  /** 출금 요청 통화 코드 (원하는 출금 통화) */
  requestedCurrency: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type CryptoAddressInfo = {
  __typename?: 'CryptoAddressInfo'
  address: Scalars['String']['output']
  amount: Scalars['Float']['output']
  memo?: Maybe<Scalars['String']['output']>
  network: Scalars['String']['output']
  qrCode?: Maybe<Scalars['String']['output']>
  token: Scalars['String']['output']
}

/** 암호화폐별 거래 내역 */
export type CryptoBreakdownItem = {
  __typename?: 'CryptoBreakdownItem'
  /** 거래 금액 (결제 통화 기준) */
  amount: Scalars['Float']['output']
  /** 평균 거래 금액 */
  avgAmount: Scalars['Float']['output']
  /** 거래 건수 */
  count: Scalars['Int']['output']
  /** 암호화폐 코드 (예: BTC, ETH, USDT) */
  crypto: Scalars['String']['output']
}

/** 암호화폐×네트워크 조합별 거래 내역 */
export type CryptoNetworkBreakdownItem = {
  __typename?: 'CryptoNetworkBreakdownItem'
  /** 거래 금액 (결제 통화 기준) */
  amount: Scalars['Float']['output']
  /** 평균 거래 금액 */
  avgAmount: Scalars['Float']['output']
  /** 거래 건수 */
  count: Scalars['Int']['output']
  /** 암호화폐 코드 (예: USDT, USDC) */
  crypto: Scalars['String']['output']
  /** 네트워크 (예: ETHEREUM, POLYGON, BASE_ETH) */
  network: Scalars['String']['output']
}

export type CryptoOptionsInput = {
  /** 블록체인 네트워크 */
  network: Scalars['String']['input']
  /** 토큰 종류 */
  token: Scalars['String']['input']
}

/** Crypto payout channel enum */
export enum CryptoPayoutChannel {
  AIRWALLEX = 'AIRWALLEX',
  COBO = 'COBO',
  HASHKEY = 'HASHKEY',
  PYVIO = 'PYVIO',
}

export type CryptoPayoutDetailResponse = {
  __typename?: 'CryptoPayoutDetailResponse'
  /** Target address for crypto payout */
  address: Scalars['String']['output']
  /** Batch payout ID */
  batchId?: Maybe<Scalars['Int']['output']>
  /** Batch payout number */
  batchNo?: Maybe<Scalars['String']['output']>
  /** Chain transaction hash */
  chainTx?: Maybe<Scalars['String']['output']>
  /** Crypto payout channel */
  channel?: Maybe<CryptoPayoutChannel>
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order ID */
  channelOrderId?: Maybe<Scalars['String']['output']>
  /** Completion timestamp */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** Token symbol for crypto payout */
  currency: Scalars['String']['output']
  /** Failed reason */
  failedReason?: Maybe<Scalars['String']['output']>
  /** Fee amount */
  feeAmount?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  /** Merchant associated with the crypto payout */
  merchant?: Maybe<Merchant>
  /** Merchant ID */
  merchantId: Scalars['Int']['output']
  /** Merchant order ID */
  merchantOrderId?: Maybe<Scalars['String']['output']>
  /** Metadata */
  metaData?: Maybe<Scalars['JSON']['output']>
  /** Network for crypto payout */
  network: Scalars['String']['output']
  /** Crypto payout order number */
  orderId: Scalars['String']['output']
  /** Processor user ID */
  processedBy?: Maybe<Scalars['Int']['output']>
  /** Processor name */
  processedByName?: Maybe<Scalars['String']['output']>
  /** Crypto payout status */
  status: CryptoPayoutStatus
  /** Target amount */
  targetAmount: Scalars['Float']['output']
  /** Total amount */
  totalAmount?: Maybe<Scalars['Float']['output']>
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output']
}

/** Crypto payout Excel export response */
export type CryptoPayoutExportResponse = {
  __typename?: 'CryptoPayoutExportResponse'
  /** Immediate download URL for exports with 1000 records or fewer */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** Async job ID for exports with more than 1000 records */
  jobId?: Maybe<Scalars['String']['output']>
  /** Informational message for the export request */
  message?: Maybe<Scalars['String']['output']>
  /** Process type: IMMEDIATE or ASYNC */
  processType: Scalars['String']['output']
  /** Total record count */
  recordCount: Scalars['Int']['output']
}

export type CryptoPayoutListInput = {
  /** Target address for crypto payout */
  address?: InputMaybe<Scalars['String']['input']>
  /** Batch payout ID */
  batchId?: InputMaybe<Scalars['Int']['input']>
  /** Batch payout number */
  batchNo?: InputMaybe<Scalars['String']['input']>
  /** Crypto payout channel */
  channel?: InputMaybe<CryptoPayoutChannel>
  /** From date */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Excel email locale. Default: en */
  locale?: InputMaybe<EmailLocale>
  /** Merchant ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** Payout order ID or channel order ID */
  orderId?: InputMaybe<Scalars['String']['input']>
  /** Payout status */
  status?: InputMaybe<CryptoPayoutStatus>
  /** To date */
  toDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type CryptoPayoutPage = {
  __typename?: 'CryptoPayoutPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<CryptoPayoutResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type CryptoPayoutResponse = {
  __typename?: 'CryptoPayoutResponse'
  /** Target address for crypto payout */
  address: Scalars['String']['output']
  /** Batch payout ID */
  batchId?: Maybe<Scalars['Int']['output']>
  /** Batch payout number */
  batchNo?: Maybe<Scalars['String']['output']>
  /** Crypto payout channel */
  channel?: Maybe<CryptoPayoutChannel>
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order ID */
  channelOrderId?: Maybe<Scalars['String']['output']>
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** Token symbol for crypto payout */
  currency: Scalars['String']['output']
  /** Fee amount */
  feeAmount?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  /** Merchant associated with the crypto payout */
  merchant?: Maybe<Merchant>
  /** Merchant ID */
  merchantId: Scalars['Int']['output']
  /** Merchant order ID */
  merchantOrderId?: Maybe<Scalars['String']['output']>
  /** Crypto payout order number */
  orderId: Scalars['String']['output']
  /** Crypto payout status */
  status: CryptoPayoutStatus
  /** Target amount */
  targetAmount: Scalars['Float']['output']
  /** Total amount */
  totalAmount?: Maybe<Scalars['Float']['output']>
}

/** Crypto payout status enum */
export enum CryptoPayoutStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
}

export type CryptoRefundFee = {
  __typename?: 'CryptoRefundFee'
  createdAt: Scalars['DateTime']['output']
  currency: Scalars['String']['output']
  /** 주문/정산 통화 ID */
  currencyId: Scalars['Int']['output']
  /** 설명 */
  description?: Maybe<Scalars['String']['output']>
  /** 수수료 금액 또는 비율 */
  feeAmount: Scalars['Float']['output']
  /** 수수료 타입 */
  feeType: CryptoRefundFeeType
  id: Scalars['ID']['output']
  /** 활성화 상태 */
  isActive: Scalars['Boolean']['output']
  /** 최대 수수료 */
  maxFee?: Maybe<Scalars['Float']['output']>
  /** 최소 수수료 */
  minFee?: Maybe<Scalars['Float']['output']>
  /** 실결제 통화 ID (L3 Crypto Currency) */
  payableCurrencyId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CryptoRefundFeeFilterInput = {
  /** 주문/정산 통화 ID 필터 */
  currencyId?: InputMaybe<Scalars['Int']['input']>
  /** 수수료 타입 필터 */
  feeType?: InputMaybe<CryptoRefundFeeType>
  /** 활성화 상태 필터 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 실결제 통화 ID 필터 (L3) */
  payableCurrencyId?: InputMaybe<Scalars['Int']['input']>
}

export type CryptoRefundFeeList = {
  __typename?: 'CryptoRefundFeeList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<CryptoRefundFee>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 암호화폐 환불 수수료 타입 */
export enum CryptoRefundFeeType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}

export type CryptoStatusInfo = {
  __typename?: 'CryptoStatusInfo'
  blockchainTxHash?: Maybe<Scalars['String']['output']>
  confirmations?: Maybe<Scalars['Int']['output']>
  cryptoAmount?: Maybe<Scalars['Float']['output']>
  network?: Maybe<Scalars['String']['output']>
  token?: Maybe<Scalars['String']['output']>
}

export type Currency = {
  __typename?: 'Currency'
  /** 내부용 기본 토큰 (USDT, USD 등) */
  baseToken: Scalars['String']['output']
  /** 통화 코드 (USD, TRON_USDT 등 - 외부용 전체 코드) */
  code: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  /** 소수점 자리수 */
  decimals: Scalars['Int']['output']
  /** 이 통화에서 출발하는 환율 정보 */
  exchangeRatesFrom?: Maybe<Array<ExchangeRate>>
  /** 이 통화로 도착하는 환율 정보 */
  exchangeRatesTo?: Maybe<Array<ExchangeRate>>
  id: Scalars['ID']['output']
  /** 활성 상태 */
  isActive: Scalars['Boolean']['output']
  /** 환율 조회 대상 통화 여부 */
  isExchangeRateEnabled: Scalars['Boolean']['output']
  /** 정산 가능 통화 여부 */
  isSettleable: Scalars['Boolean']['output']
  /** 출금 가능 통화 여부 */
  isWithdrawable: Scalars['Boolean']['output']
  /** AML 스크리닝 최소 금액 (null이면 전액 스크리닝) */
  minAmlScreeningAmount?: Maybe<Scalars['Float']['output']>
  /** 통화 이름 (US Dollar, Tether USD (Tron) 등) */
  name: Scalars['String']['output']
  /** 블록체인 네트워크 (TRON, ETH 등, Fiat은 null) */
  network?: Maybe<Scalars['String']['output']>
  /** 통화 기호 ($, ₩, ¥ 등) */
  symbol: Scalars['String']['output']
  /** 통화 토큰 유형 (FIAT, STABLECOIN, CRYPTO) */
  tokenType: TokenType
  updatedAt: Scalars['DateTime']['output']
}

export type CurrencyFilterInput = {
  /** 기본 토큰 필터 (USDT, USDC, USD 등) */
  baseToken?: InputMaybe<Scalars['String']['input']>
  /** 활성 상태 필터 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 환율 조회 대상 통화 필터 */
  isExchangeRateEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** 정산 가능 통화 필터 */
  isSettleable?: InputMaybe<Scalars['Boolean']['input']>
  /** 출금 가능 통화 필터 */
  isWithdrawable?: InputMaybe<Scalars['Boolean']['input']>
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>
  /** 검색 필드 */
  searchField?: InputMaybe<CurrencySearchField>
  /** 토큰 유형 필터 (FIAT, STABLECOIN, CRYPTO) */
  tokenType?: InputMaybe<TokenType>
}

/** 통화 목록 */
export type CurrencyList = {
  __typename?: 'CurrencyList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<Currency>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 통화 검색 필드 */
export enum CurrencySearchField {
  ALL = 'ALL',
  CODE = 'CODE',
  NAME = 'NAME',
  SYMBOL = 'SYMBOL',
}

/** 현재 활성화된 API 키 세트 */
export type CurrentApiKeys = {
  __typename?: 'CurrentApiKeys'
  /** 클라이언트 키 (PUBLIC) */
  clientKey?: Maybe<MerchantApiKey>
  /** 환경 (TEST/LIVE) */
  keyType: Scalars['String']['output']
  /** 시크릿 키 (PRIVATE) */
  secretKey?: Maybe<MerchantApiKey>
  /** 웹훅 서명 키 */
  webhookKey?: Maybe<MerchantApiKey>
}

export type CurrentExchangeRate = {
  __typename?: 'CurrentExchangeRate'
  /** 예금 환율 (예금 시 적용) */
  depositRate: Scalars['Float']['output']
  /** 기준 통화 코드 */
  fromCurrency: Scalars['String']['output']
  /** 결제 환율 (고객 결제 시 적용) */
  paymentRate: Scalars['Float']['output']
  /** 현재 환율 */
  rate: Scalars['Float']['output']
  /** 환율 출처 */
  source: ExchangeRateSource
  /** 대상 통화 코드 */
  toCurrency: Scalars['String']['output']
  /** 환율 적용 시작일 */
  validFrom: Scalars['DateTime']['output']
  /** 환율 적용 종료일 */
  validTo?: Maybe<Scalars['DateTime']['output']>
  /** 출금 환율 (가맹점 출금 시 적용) */
  withdrawalRate: Scalars['Float']['output']
}

export type CustomerInfo = {
  __typename?: 'CustomerInfo'
  customerId?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export type CustomerInput = {
  /** 고객 ID */
  customerId?: InputMaybe<Scalars['String']['input']>
  /** 고객 이메일 */
  email?: InputMaybe<Scalars['String']['input']>
  /** 고객 이름 */
  name?: InputMaybe<Scalars['String']['input']>
  /** 고객 전화번호 */
  phone?: InputMaybe<Scalars['String']['input']>
}

/** Debit or credit flag */
export enum DcFlag {
  C = 'C',
  D = 'D',
}

export type DailySettlementResult = {
  __typename?: 'DailySettlementResult'
  count: Scalars['Int']['output']
  message: Scalars['String']['output']
  settlementDate: Scalars['DateTime']['output']
  success: Scalars['Boolean']['output']
}

/** 일별 거래 요약 Excel 다운로드 응답 */
export type DailySummaryExcelResponse = {
  __typename?: 'DailySummaryExcelResponse'
  /** Excel 파일 다운로드 URL (GCS Signed URL) */
  downloadUrl: Scalars['String']['output']
  /** 다운로드 메시지 */
  message: Scalars['String']['output']
  /** 포함된 레코드 수 */
  recordCount: Scalars['Int']['output']
}

/** 일별 거래 요약 */
export type DailyTransactionSummary = {
  __typename?: 'DailyTransactionSummary'
  /** 집계 실행 시각 */
  aggregatedAt: Scalars['String']['output']
  /** 집계 날짜 (YYYY-MM-DD) */
  aggregationDate: Scalars['String']['output']
  /** 취소/환불 통계 */
  cancellationStats: CancellationStats
  /** 생성 시각 */
  createdAt: Scalars['String']['output']
  /** 암호화폐별 거래 분포 */
  cryptoBreakdown?: Maybe<Array<CryptoBreakdownItem>>
  /** 암호화폐×네트워크 조합별 거래 분포 */
  cryptoNetworkBreakdown?: Maybe<Array<CryptoNetworkBreakdownItem>>
  /** 통화 코드 */
  currency: Scalars['String']['output']
  /** 시간대별 거래 분포 */
  hourlyBreakdown?: Maybe<Array<HourlyBreakdownItem>>
  /** 요약 ID */
  id: Scalars['Int']['output']
  /** 가맹점 ID (NULL = 시스템 전체 합계) */
  merchantId?: Maybe<Scalars['Int']['output']>
  /** 네트워크별 거래 분포 */
  networkBreakdown?: Maybe<Array<NetworkBreakdownItem>>
  /** 결제 통계 */
  paymentStats: PaymentStats
  /** 수정 시각 */
  updatedAt: Scalars['String']['output']
}

/** 대시보드 요약 (백엔드 집계) */
export type DashboardSummary = {
  __typename?: 'DashboardSummary'
  /** 취소/환불 통계 */
  cancellationStats: CancellationStats
  /** 암호화폐별 거래 분포 */
  cryptoBreakdown: Array<CryptoBreakdownItem>
  /** 암호화폐×네트워크 조합별 거래 분포 */
  cryptoNetworkBreakdown: Array<CryptoNetworkBreakdownItem>
  /** 시간별 거래 분포 (선택한 타임존 기준 0-23시) */
  hourlyBreakdown: Array<HourlyBreakdownItem>
  /** 네트워크별 거래 분포 */
  networkBreakdown: Array<NetworkBreakdownItem>
  /** 결제 통계 */
  paymentStats: PaymentStats
}

/** 결제 금액 조정 결정 출처 */
export enum DecisionSource {
  API = 'API',
  AUTO_FALLBACK = 'AUTO_FALLBACK',
  PORTAL = 'PORTAL',
}

export type DeleteMerchantPaymentMethodResponse = {
  __typename?: 'DeleteMerchantPaymentMethodResponse'
  /** 응답 메시지 */
  message: Scalars['String']['output']
  /** 삭제 성공 여부 */
  success: Scalars['Boolean']['output']
}

/** 삭제 결과 */
export type DeleteResult = {
  __typename?: 'DeleteResult'
  /** 삭제된 ID */
  id: Scalars['String']['output']
  /** 성공 여부 */
  success: Scalars['Boolean']['output']
}

/** 목적지 유형 */
export enum DestinationType {
  /** 은행 계좌 */
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  /** 크립토 주소 */
  CRYPTO_ADDRESS = 'CRYPTO_ADDRESS',
  /** 내부 지갑 */
  INTERNAL_WALLET = 'INTERNAL_WALLET',
  /** 오프램프 입금 주소 */
  OFFRAMP_DEPOSIT = 'OFFRAMP_DEPOSIT',
}

export type DispatchReconciliationFilterInput = {
  kind?: InputMaybe<DispatchReconciliationKind>
}

export type DispatchReconciliationItem = {
  __typename?: 'DispatchReconciliationItem'
  amount?: Maybe<Scalars['Float']['output']>
  currency?: Maybe<Scalars['String']['output']>
  kind: DispatchReconciliationKind
  merchantId?: Maybe<Scalars['Int']['output']>
  merchantName?: Maybe<Scalars['String']['output']>
  paymentId?: Maybe<Scalars['String']['output']>
  providerReference?: Maybe<Scalars['String']['output']>
  reason?: Maybe<Scalars['String']['output']>
  recordId: Scalars['String']['output']
  since: Scalars['DateTime']['output']
  state: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type DispatchReconciliationItemList = {
  __typename?: 'DispatchReconciliationItemList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<DispatchReconciliationItem>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 미확인 송금 대사 항목 종류 */
export enum DispatchReconciliationKind {
  CHANNEL_TRANSFER = 'CHANNEL_TRANSFER',
  PAYOUT = 'PAYOUT',
  PG_SETTLEMENT_TRANSFER = 'PG_SETTLEMENT_TRANSFER',
  REFUND = 'REFUND',
}

export type DocumentInput = {
  /** 문서 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 만료일 (신분증 등) */
  expiresAt?: InputMaybe<Scalars['String']['input']>
  /** 파일 업로드 ID (FileUpload.id) */
  fileUploadId: Scalars['Int']['input']
  /** MIME 타입 (예: application/pdf) */
  mimeType?: InputMaybe<Scalars['String']['input']>
  /** 문서명 (예: 사업자등록증_2025.pdf) */
  name: Scalars['String']['input']
  /** 파일 크기 (bytes) */
  size?: InputMaybe<Scalars['Int']['input']>
  /** 문서 타입 */
  type: DocumentType
}

/** 문서 상태 */
export enum DocumentStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  EXPIRED = 'EXPIRED',
  PENDING_REVIEW = 'PENDING_REVIEW',
}

/** 문서 타입 */
export enum DocumentType {
  BANK_STATEMENT = 'BANK_STATEMENT',
  BUSINESS_REGISTRATION = 'BUSINESS_REGISTRATION',
  CONTRACT = 'CONTRACT',
  CORPORATE_REGISTRATION = 'CORPORATE_REGISTRATION',
  FINANCIAL_STATEMENT = 'FINANCIAL_STATEMENT',
  ID_CARD = 'ID_CARD',
  OTHER = 'OTHER',
}

/** 이메일 언어 설정 */
export enum EmailLocale {
  EN = 'EN',
  KO = 'KO',
  ZH = 'ZH',
}

export type EnrollmentStartModel = {
  __typename?: 'EnrollmentStartModel'
  /** Whether the enrollment email code was sent */
  emailCodeSent: Scalars['Boolean']['output']
  /** Manual entry key (base32 secret) */
  manualKey: Scalars['String']['output']
  /** QR code as a data URL (image/png base64) */
  qrDataUrl: Scalars['String']['output']
}

/** 가맹점별 incorrect transfer 처리 모드 */
export enum ExceptionHandlingMode {
  /** 자동환불 (기본) */
  AUTO_REFUND = 'AUTO_REFUND',
  /** 가맹점이 수락/거절 결정 */
  UPDATE_PAYMENT = 'UPDATE_PAYMENT',
}

export type ExceptionalTransfer = {
  __typename?: 'ExceptionalTransfer'
  /** 블록체인 트랜잭션 해시 */
  blockchainTxHash?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  /** 감지 시각 */
  detectedAt: Scalars['DateTime']['output']
  /** 웹훅 이벤트 타입 */
  eventType: Scalars['String']['output']
  /** 의도되었던(예상) 토큰 ID */
  expectedTokenId: Scalars['String']['output']
  /** 발신 주소 */
  fromAddress?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 가맹점 이름 */
  merchantName?: Maybe<Scalars['String']['output']>
  /** 가맹점 번호 (merchantNo) */
  merchantNo?: Maybe<Scalars['String']['output']>
  /** PG 트랜잭션 ID (Cobo tx_id) */
  pgTransactionId: Scalars['String']['output']
  /** 원본 PG 웹훅 페이로드 (디버깅·감사 전용, ADMIN-only — 외부 노출 금지) */
  rawWebhookData: Scalars['JSON']['output']
  /** 실제 입금 금액 (정밀도 손실 방지를 위해 문자열로 노출) */
  receivedAmount: Scalars['String']['output']
  /** 실제 입금된 토큰 ID */
  receivedTokenId: Scalars['String']['output']
  /** 처리 메모 */
  resolutionNote?: Maybe<Scalars['String']['output']>
  /** 처리 완료 시각 */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>
  /** 처리자 User ID */
  resolvedById?: Maybe<Scalars['Int']['output']>
  /** 처리자 이름 */
  resolvedByName?: Maybe<Scalars['String']['output']>
  /** 처리 상태 */
  status: ExceptionalTransferStatus
  /** 입금 주소 (TopupAddress와 매칭됨) */
  toAddress: Scalars['String']['output']
  /** TopupAddress 체인 */
  topupAddressChain?: Maybe<Scalars['String']['output']>
  /** 매칭된 TopupAddress ID */
  topupAddressId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type ExceptionalTransferFilterInput = {
  /** 블록체인 트랜잭션 해시 */
  blockchainTxHash?: InputMaybe<Scalars['String']['input']>
  /** 시작일 */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 종료일 */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
  /** 가맹점 ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** PG 트랜잭션 ID */
  pgTransactionId?: InputMaybe<Scalars['String']['input']>
  /** 받은 토큰 ID */
  receivedTokenId?: InputMaybe<Scalars['String']['input']>
  /** 처리 상태 필터 */
  status?: InputMaybe<ExceptionalTransferStatus>
  /** 입금 주소 */
  toAddress?: InputMaybe<Scalars['String']['input']>
}

export type ExceptionalTransferList = {
  __typename?: 'ExceptionalTransferList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ExceptionalTransfer>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 비정상 입금 처리 상태 */
export enum ExceptionalTransferStatus {
  DETECTED = 'DETECTED',
  IGNORED = 'IGNORED',
  RESOLVED = 'RESOLVED',
}

export type ExchangeRate = {
  __typename?: 'ExchangeRate'
  createdAt: Scalars['DateTime']['output']
  /** 통화 쌍 표기 (USD/KRW) */
  currencyPair: Scalars['String']['output']
  /** 예금 마진 (%) - 예금 시 적용 */
  depositMargin: Scalars['Float']['output']
  /** 예금 환율 (예금 시 적용) */
  depositRate: Scalars['Float']['output']
  /** 기준 통화 */
  fromCurrency: Currency
  /** 기준 통화 ID */
  fromCurrencyId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  /** 활성 상태 */
  isActive: Scalars['Boolean']['output']
  /** 현재 유효한 환율인지 여부 */
  isCurrentlyValid: Scalars['Boolean']['output']
  /** 결제 마진 (%) - 고객 결제 시 적용 */
  paymentMargin: Scalars['Float']['output']
  /** 결제 환율 (고객 결제 시 적용) */
  paymentRate: Scalars['Float']['output']
  /** 환율 */
  rate: Scalars['Float']['output']
  /** 환율 출처 */
  source: ExchangeRateSource
  /** 대상 통화 */
  toCurrency: Currency
  /** 대상 통화 ID */
  toCurrencyId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
  /** 유효 시작일 */
  validFrom: Scalars['DateTime']['output']
  /** 유효 종료일 */
  validTo?: Maybe<Scalars['DateTime']['output']>
  /** 출금 마진 (%) - 가맹점 출금 시 적용 */
  withdrawalMargin: Scalars['Float']['output']
  /** 출금 환율 (가맹점 출금 시 적용) */
  withdrawalRate: Scalars['Float']['output']
}

export type ExchangeRateFilterInput = {
  /** 기준 통화 ID */
  fromCurrencyId?: InputMaybe<Scalars['Int']['input']>
  /** 활성 상태 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 현재 유효한 환율만 조회 */
  onlyCurrentlyValid?: InputMaybe<Scalars['Boolean']['input']>
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>
  /** 검색 필드 */
  searchField?: InputMaybe<ExchangeRateSearchField>
  /** 환율 출처 */
  source?: InputMaybe<ExchangeRateSource>
  /** 대상 통화 ID */
  toCurrencyId?: InputMaybe<Scalars['Int']['input']>
  /** 유효 시작일 (이후) */
  validFromAfter?: InputMaybe<Scalars['String']['input']>
  /** 유효 시작일 (이전) */
  validFromBefore?: InputMaybe<Scalars['String']['input']>
  /** 유효 종료일 (이후) */
  validToAfter?: InputMaybe<Scalars['String']['input']>
  /** 유효 종료일 (이전) */
  validToBefore?: InputMaybe<Scalars['String']['input']>
}

/** 환율 목록 */
export type ExchangeRateList = {
  __typename?: 'ExchangeRateList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ExchangeRate>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 환율 검색 필드 */
export enum ExchangeRateSearchField {
  ALL = 'ALL',
  CURRENCY_PAIR = 'CURRENCY_PAIR',
  FROM_CURRENCY = 'FROM_CURRENCY',
  SOURCE = 'SOURCE',
  TO_CURRENCY = 'TO_CURRENCY',
}

/** 환율 출처 */
export enum ExchangeRateSource {
  BANK_API = 'BANK_API',
  COBO_API = 'COBO_API',
  FIXED = 'FIXED',
  FOREX_API = 'FOREX_API',
  MANUAL = 'MANUAL',
}

export type ExchangeRateUpdate = {
  __typename?: 'ExchangeRateUpdate'
  change24h?: Maybe<Scalars['Float']['output']>
  from: Scalars['String']['output']
  rate: Scalars['Float']['output']
  to: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type ExchangeRateUpdateResult = {
  __typename?: 'ExchangeRateUpdateResult'
  /** 새로 생성된 환율 개수 */
  createdCount: Scalars['Int']['output']
  /** 오류가 발생한 환율 개수 */
  errorCount: Scalars['Int']['output']
  /** 오류가 발생한 통화 쌍 목록 */
  errorCurrencyPairs: Array<Scalars['String']['output']>
  /** 업데이트 실행 시간 */
  executedAt: Scalars['DateTime']['output']
  /** 전체 처리 결과 요약 */
  summary: Scalars['String']['output']
  /** 업데이트된 환율 개수 */
  updatedCount: Scalars['Int']['output']
  /** 업데이트된 통화 쌍 목록 */
  updatedCurrencyPairs: Array<Scalars['String']['output']>
}

export type ExecuteAirwallexReconciliationInput = {
  /** 대사 시작일 (미지정 시 어제 00:00:00 HKT) */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 대사 종료일 (미지정 시 오늘 00:00:00 HKT) */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
  /** 내부 인증 시크릿 (Cloud Scheduler 인증용) */
  internalSecret: Scalars['String']['input']
}

export type ExecuteCoboReconciliationInput = {
  /** 대사 시작일 (미지정 시 어제 00:00:00 HKT) */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 대사 종료일 (미지정 시 오늘 00:00:00 HKT) */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
  /** 내부 인증 시크릿 (Cloud Scheduler 인증용) */
  internalSecret: Scalars['String']['input']
}

export type ExecuteDailySettlementInput = {
  /** 정산 시작일시 */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 정산 종료일시 */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
  /** 내부 인증 시크릿 */
  internalSecret: Scalars['String']['input']
}

export type ExecuteExchangeRateUpdateInput = {
  /** 업데이트할 통화 코드 목록 (미지정 시 활성 통화 모두) */
  currencyCodes?: InputMaybe<Array<Scalars['String']['input']>>
  /** 내부 인증 시크릿 */
  internalSecret: Scalars['String']['input']
}

export type ExecuteHourlyAggregationInput = {
  /** 집계 시작 DateTime (ISO 8601 형식, 생략 시 이전 시간의 시작) */
  dateTimeFrom?: InputMaybe<Scalars['String']['input']>
  /** 집계 종료 DateTime (ISO 8601 형식, 생략 시 이전 시간의 종료) */
  dateTimeTo?: InputMaybe<Scalars['String']['input']>
  /** 집계할 직전 완료 시간 수 (dateTimeFrom/dateTimeTo 생략 시 사용, 기본 1) */
  hoursBack?: InputMaybe<Scalars['Int']['input']>
  /** 내부 인증 시크릿 */
  internalSecret: Scalars['String']['input']
}

export type ExecuteOfframpReconciliationInput = {
  /** 이 시간(분)이 지나도 확인되지 않으면 UNKNOWN 으로 보류한다 (≥max(60, olderThanMinutes), ≤30일) */
  escalateAfterMinutes?: InputMaybe<Scalars['Int']['input']>
  /** 내부 인증 시크릿 */
  internalSecret: Scalars['String']['input']
  /** 이 시간(분)보다 오래 갱신되지 않은 PROCESSING 행만 대사한다 (≥15) */
  olderThanMinutes?: InputMaybe<Scalars['Int']['input']>
}

export type ExecutePgDispatchReconciliationInput = {
  /** 이 시간(분)이 지나도 확인되지 않으면 경보한다 (≥60, ≤30일) */
  escalateAfterMinutes?: InputMaybe<Scalars['Int']['input']>
  /** 내부 인증 시크릿 */
  internalSecret: Scalars['String']['input']
  /** 이 시간(분)보다 오래 갱신되지 않은 미확인 지급만 대사한다 (≥15) */
  olderThanMinutes?: InputMaybe<Scalars['Int']['input']>
}

export type ExecuteRefundDispatchReconciliationInput = {
  /** 이 시간(분)이 지나도 확인되지 않으면 경보한다 (≥60, ≤30일) */
  escalateAfterMinutes?: InputMaybe<Scalars['Int']['input']>
  /** 내부 인증 시크릿 */
  internalSecret: Scalars['String']['input']
  /** 이 시간(분)보다 오래된 미확인 환불만 대사한다 (≥15) */
  olderThanMinutes?: InputMaybe<Scalars['Int']['input']>
}

export type ExperimentEventInput = {
  /** One type of event subject */
  deviceId?: InputMaybe<Scalars['String']['input']>
  /** Event name */
  eventName: Scalars['String']['input']
  /** Experiment key */
  experimentKey: Scalars['String']['input']
  /** One type of event subject */
  sessionId?: InputMaybe<Scalars['String']['input']>
  /** Variant key */
  variantKey: Scalars['String']['input']
}

export type ExpireCheckoutSessionInput = {
  /** Checkout session ID to expire */
  sessionId: Scalars['String']['input']
}

export type ExpireCheckoutSessionResponse = {
  __typename?: 'ExpireCheckoutSessionResponse'
  /** Response message */
  message: Scalars['String']['output']
  /** Session ID that was expired */
  sessionId: Scalars['String']['output']
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output']
}

/** 출금 실패 입력 */
export type FailWithdrawalInput = {
  /** 실패 사유 */
  failureReason: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
  /** 출금 요청 ID */
  withdrawalId: Scalars['String']['input']
}

/** Fee business type, e.g. PAYOUT TOPUP */
export enum FeeBusinessType {
  MICRO_TRANSFER = 'MICRO_TRANSFER',
  OFFRAMP = 'OFFRAMP',
  ONRAMP = 'ONRAMP',
  PAYOUT = 'PAYOUT',
  TOPUP = 'TOPUP',
  WITHDRAWAL = 'WITHDRAWAL',
}

export type FeeSettingInput = {
  /** Fee business type */
  bizType: FeeBusinessType
  /** Currency code */
  currency: Scalars['String']['input']
  /** Merchant ID */
  merchantId: Scalars['Int']['input']
}

export type FeeSettingPage = {
  __typename?: 'FeeSettingPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<FeeSettingResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type FeeSettingResponse = {
  __typename?: 'FeeSettingResponse'
  /** Fee business type, e.g. PAYOUT TOPUP WITHDRAWAL */
  bizType: FeeBusinessType
  /** Currency code, null means default setting for all currencies */
  currency?: Maybe<Scalars['String']['output']>
  /** Fee rate */
  feeRate: Scalars['Float']['output']
  /** Fixed fee */
  fixedFee: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** Maximum fee */
  maxFee?: Maybe<Scalars['Float']['output']>
  /** Merchant ID, null means global setting */
  merchantId?: Maybe<Scalars['Int']['output']>
  /** bizType-specific extension data (e.g., WITHDRAWAL → { minAmount: number }) */
  metadata?: Maybe<Scalars['JSON']['output']>
  /** Minimum fee */
  minFee: Scalars['Float']['output']
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output']
}

export type FeeSettingUpdateInput = {
  /** Fee business type */
  bizType: FeeBusinessType
  /** Currency code */
  currency?: InputMaybe<Scalars['String']['input']>
  /** Fee rate in percentage, e.g., 2.5 for 2.5% */
  feeRate: Scalars['Float']['input']
  /** Fixed fee amount */
  fixedFee: Scalars['Float']['input']
  /** Fee setting ID */
  id?: InputMaybe<Scalars['ID']['input']>
  /** Maximum fee amount */
  maxFee?: InputMaybe<Scalars['Float']['input']>
  /** Merchant ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** bizType-specific extension data (e.g., WITHDRAWAL → { minAmount: number }) */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** Minimum fee amount */
  minFee: Scalars['Float']['input']
}

/** 수수료 유형 */
export enum FeeType {
  /** 브릿징 수수료 */
  BRIDGING_FEE = 'BRIDGING_FEE',
  /** 환전 수수료 */
  EXCHANGE_FEE = 'EXCHANGE_FEE',
  /** 네트워크/가스 수수료 */
  NETWORK_FEE = 'NETWORK_FEE',
  /** 기타 */
  OTHER = 'OTHER',
  /** PG 수수료 */
  PG_COMMISSION = 'PG_COMMISSION',
  /** 처리 수수료 */
  PROCESSING_FEE = 'PROCESSING_FEE',
  /** 프로바이더 수수료 */
  PROVIDER_FEE = 'PROVIDER_FEE',
  /** 송금 수수료 */
  WIRE_FEE = 'WIRE_FEE',
}

/** FIAT 주문 크립토 자동 출금 결과 */
export type FiatOrderCryptoSettlementResult = {
  __typename?: 'FiatOrderCryptoSettlementResult'
  /** 배치 ID (복수인 경우 쉼표 구분) */
  batchId: Scalars['String']['output']
  /** 정산 건수 */
  settlementCount: Scalars['Int']['output']
  /** 지갑 미등록으로 스킵된 건수 */
  skippedCount: Scalars['Int']['output']
  /** 상태 (COMPLETED, NO_TARGETS, NO_FIAT_ORDERS, NO_WALLET_CONFIG) */
  status: Scalars['String']['output']
  /** 총 금액 */
  totalAmount: Scalars['String']['output']
}

export type FileAccessResponse = {
  __typename?: 'FileAccessResponse'
  /** 파일 설명 */
  description?: Maybe<Scalars['String']['output']>
  /** 파일명 */
  fileName: Scalars['String']['output']
  /** 파일 ID */
  id: Scalars['Int']['output']
  /** 파일 MIME 타입 */
  mimeType: Scalars['String']['output']
  /** 파일 접근용 Signed URL (1시간 유효) */
  signedUrl: Scalars['String']['output']
  /** 파일 크기 (bytes) */
  size: Scalars['Float']['output']
  /** 업로드 시간 */
  uploadedAt: Scalars['DateTime']['output']
}

export type FileInfo = {
  __typename?: 'FileInfo'
  /** 파일 설명 */
  description?: Maybe<Scalars['String']['output']>
  /** 파일명 */
  fileName: Scalars['String']['output']
  /** 파일 크기 (bytes) */
  fileSize?: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  /** MIME 타입 */
  mimeType: Scalars['String']['output']
  /** 서명된 URL (동적 생성) */
  signedUrl?: Maybe<Scalars['String']['output']>
  /** 업로드 시간 */
  uploadedAt: Scalars['DateTime']['output']
}

export type FileUploadResponse = {
  __typename?: 'FileUploadResponse'
  /** URL 만료 시간 */
  expiresAt: Scalars['DateTime']['output']
  /** 파일 경로 (업로드 완료 후 참조용) */
  filePath: Scalars['String']['output']
  /** 업로드 ID (confirmFileUpload에서 사용) */
  uploadId: Scalars['Int']['output']
  /** 익명 업로드시 사용할 토큰 */
  uploadToken?: Maybe<Scalars['String']['output']>
  /** 업로드용 Signed URL (10분간 유효) */
  uploadUrl: Scalars['String']['output']
}

export type FrozenAmountDetailResponse = {
  __typename?: 'FrozenAmountDetailResponse'
  /** Frozen amount */
  amount: Scalars['Float']['output']
  /** Frozen type */
  type: MerchantAccountFrozen
}

export type FundFlowBalanceItem = {
  __typename?: 'FundFlowBalanceItem'
  availableBalance: Scalars['String']['output']
  currency: Scalars['String']['output']
  frozenBalance?: Maybe<Scalars['String']['output']>
  totalBalance?: Maybe<Scalars['String']['output']>
}

export type FundFlowChannel = {
  __typename?: 'FundFlowChannel'
  code: Scalars['String']['output']
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>
  name: Scalars['String']['output']
  status: ChannelStatus
}

export type FundFlowChannelBalance = {
  __typename?: 'FundFlowChannelBalance'
  balances: Array<FundFlowBalanceItem>
  channelCode: Scalars['String']['output']
  feeStationBalances?: Maybe<Array<FundFlowBalanceItem>>
}

/** 자금 흐름 방향 */
export enum FundFlowDirection {
  IN = 'IN',
  OUT = 'OUT',
}

/** PG사 상태 */
export enum GatewayStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  MAINTENANCE = 'MAINTENANCE',
}

export type GenerateFileUploadUrlInput = {
  /** 파일 저장 경로 (미지정시 자동 생성) */
  customPath?: InputMaybe<Scalars['String']['input']>
  /** 파일 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 파일명 */
  fileName: Scalars['String']['input']
  /** 공개 파일 여부 */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>
  /** 파일 MIME 타입 */
  mimeType: Scalars['String']['input']
}

export type GetDailyTransactionSummaryInput = {
  /** 통화 코드 (필수) */
  currency: Scalars['String']['input']
  /** 조회 시작 DateTime (ISO 8601 형식) */
  dateTimeFrom: Scalars['String']['input']
  /** 조회 종료 DateTime (ISO 8601 형식) */
  dateTimeTo: Scalars['String']['input']
  /** 엑셀 다운로드 언어 설정. 기본값: ko */
  locale?: InputMaybe<EmailLocale>
  /** 가맹점 ID (ADMIN 전용, 생략 시 본인 가맹점) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** IANA 타임존 (필수, 예: Asia/Seoul, UTC) */
  timezone: Scalars['String']['input']
}

export type GetDashboardSummaryInput = {
  /** 통화 코드 (생략 시 전체) */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 조회 시작 DateTime (ISO 8601 형식) */
  dateTimeFrom: Scalars['String']['input']
  /** 조회 종료 DateTime (ISO 8601 형식) */
  dateTimeTo: Scalars['String']['input']
  /** 가맹점 ID (ADMIN 전용, 생략 시 본인 가맹점) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** IANA 타임존 (필수, 예: Asia/Seoul, UTC) */
  timezone: Scalars['String']['input']
}

export type GetHourlyPayoutSummaryInput = {
  /** 통화 코드 (선택, 없으면 전체 통화) */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 조회 시작 DateTime (ISO 8601, UTC) */
  dateTimeFrom: Scalars['String']['input']
  /** 조회 종료 DateTime (ISO 8601, UTC) */
  dateTimeTo: Scalars['String']['input']
  /** 특정 가맹점 ID 필터 (ADMIN 전용, 생략 시 전체 가맹점) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** IANA 타임존 (예: Asia/Seoul, UTC) */
  timezone: Scalars['String']['input']
}

export type GetHourlyTransactionSummaryInput = {
  /** 통화 코드 (생략 시 전체) */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 조회 시작 DateTime (ISO 8601 형식) */
  dateTimeFrom: Scalars['String']['input']
  /** 조회 종료 DateTime (ISO 8601 형식) */
  dateTimeTo: Scalars['String']['input']
  /** 가맹점 ID (ADMIN 전용, 생략 시 본인 가맹점) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** IANA 타임존 (예: Asia/Seoul, Asia/Hong_Kong) */
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type GetMerchantPayoutStatisticsInput = {
  /** 통화 코드 (필수) */
  currency: Scalars['String']['input']
  /** 조회 시작 DateTime (ISO 8601 형식) */
  dateTimeFrom: Scalars['String']['input']
  /** 조회 종료 DateTime (ISO 8601 형식) */
  dateTimeTo: Scalars['String']['input']
  /** 페이지당 항목 수 (기본값: 20, 최대: 100) */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** 엑셀 다운로드 언어 설정. 기본값: ko */
  locale?: InputMaybe<EmailLocale>
  /** 특정 가맹점 ID 필터 (ADMIN 전용, 생략 시 전체 가맹점) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 페이지 번호 (기본값: 1) */
  page?: InputMaybe<Scalars['Int']['input']>
  /** IANA 타임존 (필수, 예: Asia/Seoul, UTC) */
  timezone: Scalars['String']['input']
}

export type GetMerchantStatisticsInput = {
  /** 통화 코드 (필수) */
  currency: Scalars['String']['input']
  /** 조회 시작 DateTime (ISO 8601 형식) */
  dateTimeFrom: Scalars['String']['input']
  /** 조회 종료 DateTime (ISO 8601 형식) */
  dateTimeTo: Scalars['String']['input']
  /** 페이지당 항목 수 (기본값: 20, 최대: 100) */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** 엑셀 다운로드 언어 설정. 기본값: ko */
  locale?: InputMaybe<EmailLocale>
  /** 특정 가맹점 ID 필터 (ADMIN 전용, 생략 시 전체 가맹점) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 페이지 번호 (기본값: 1) */
  page?: InputMaybe<Scalars['Int']['input']>
  /** IANA 타임존 (필수, 예: Asia/Seoul, UTC) */
  timezone: Scalars['String']['input']
}

export type GetPayableAmountsRequest = {
  /** Deprecated and ignored: the amount comes from sessionId */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** Deprecated and ignored: the currency comes from sessionId */
  currency?: InputMaybe<Scalars['String']['input']>
  /** Deprecated and ignored: the merchant comes from sessionId */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** Checkout session ID (checkoutId) */
  sessionId: Scalars['String']['input']
  /** payment token IDs (e.g., [ETH_USDT, TRON_USDT]) */
  tokenIds: Array<Scalars['String']['input']>
}

export type GetPayoutSummaryInput = {
  /** 통화 코드 (선택) */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 조회 시작 DateTime (ISO 8601, UTC) */
  dateTimeFrom: Scalars['String']['input']
  /** 조회 종료 DateTime (ISO 8601, UTC) */
  dateTimeTo: Scalars['String']['input']
  /** 특정 가맹점 ID 필터 (ADMIN 전용, 생략 시 전체 가맹점) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** IANA 타임존 (예: Asia/Seoul) */
  timezone: Scalars['String']['input']
}

export type GrantUserMenuAccessInput = {
  canCreate?: Scalars['Boolean']['input']
  canDelete?: Scalars['Boolean']['input']
  canEdit?: Scalars['Boolean']['input']
  canExport?: Scalars['Boolean']['input']
  canView?: Scalars['Boolean']['input']
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>
  menuCode: Scalars['String']['input']
  userId: Scalars['Int']['input']
}

export type GrayDecisionInput = {
  /** One field of criteria for variant selection */
  deviceId?: InputMaybe<Scalars['String']['input']>
  /** Experiment key */
  experimentKey: Scalars['String']['input']
  /** One field of criteria for variant selection */
  sessionId?: InputMaybe<Scalars['String']['input']>
}

export type GrayDecisionResponse = {
  __typename?: 'GrayDecisionResponse'
  /** Experiment key */
  experimentKey: Scalars['String']['output']
  /** Result params of decision */
  payload: Scalars['JSON']['output']
  /** Variant key of decision */
  variantKey: Scalars['String']['output']
}

export type HandleAirwallexReconciliationInput = {
  /** 조회 시작일 (미지정 시 어제 00:00:00 HKT) */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 조회 종료일 (미지정 시 오늘 00:00:00 HKT) */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
}

export type HandleCoboReconciliationInput = {
  /** 조회 시작일 (미지정 시 어제 00:00:00) */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 조회 종료일 (미지정 시 오늘 00:00:00) */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
}

/** 시간별 거래 집계 실행 결과 */
export type HourlyAggregationResult = {
  __typename?: 'HourlyAggregationResult'
  /** 집계 시작 시간 */
  aggregatedFrom: Scalars['DateTime']['output']
  /** 집계 종료 시간 */
  aggregatedTo: Scalars['DateTime']['output']
  /** 집계 실행 시각 */
  executedAt: Scalars['DateTime']['output']
  /** 집계된 시간 수 */
  hoursAggregated: Scalars['Int']['output']
  /** 처리된 가맹점 수 */
  merchantsProcessed: Scalars['Int']['output']
  /** 실행 메시지 */
  message: Scalars['String']['output']
  /** 페이아웃 집계 가맹점 수 */
  payoutMerchantsProcessed: Scalars['Int']['output']
  /** 집계된 페이아웃 레코드 수 */
  payoutRecords: Scalars['Int']['output']
  /** 집계 성공 여부 */
  success: Scalars['Boolean']['output']
  /** 집계된 총 레코드 수 */
  totalRecords: Scalars['Int']['output']
}

/** 시간대별 거래 내역 */
export type HourlyBreakdownItem = {
  __typename?: 'HourlyBreakdownItem'
  /** 거래 건수 */
  count: Scalars['Int']['output']
  /** 시간 (0-23) */
  hour: Scalars['Int']['output']
  /** 성공 금액 */
  successAmount: Scalars['Float']['output']
  /** 성공 건수 */
  successCount: Scalars['Int']['output']
}

/** 페이아웃 시간대별 분포 항목 (대시보드 그래프용) */
export type HourlyPayoutBreakdownItem = {
  __typename?: 'HourlyPayoutBreakdownItem'
  /** 전체 건수 */
  count: Scalars['Int']['output']
  /** 시 (0-23, 사용자 타임존 기준) */
  hour: Scalars['Int']['output']
  /** 성공 금액 합 */
  successAmount: Scalars['Float']['output']
  /** 성공 건수 */
  successCount: Scalars['Int']['output']
}

/** 시간별 페이아웃 요약 (UTC 기준) */
export type HourlyPayoutSummary = {
  __typename?: 'HourlyPayoutSummary'
  /** 집계 실행 시각 */
  aggregatedAt: Scalars['DateTime']['output']
  /** 집계 시간 (UTC DateTime, 한 시간 단위) */
  aggregationHour: Scalars['DateTime']['output']
  /** 채널별 페이아웃 분포 */
  channelBreakdown?: Maybe<Scalars['JSON']['output']>
  /** 생성 시각 */
  createdAt: Scalars['DateTime']['output']
  /** 통화 코드 */
  currency: Scalars['String']['output']
  /** 요약 ID */
  id: Scalars['Int']['output']
  /** 야간 재집계 완료 여부 */
  isReconciled: Scalars['Boolean']['output']
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 네트워크별 페이아웃 분포 */
  networkBreakdown?: Maybe<Scalars['JSON']['output']>
  /** 성공 페이아웃 평균 금액 */
  payoutAvgAmount?: Maybe<Scalars['Float']['output']>
  /** 채널(COBO/PYVIO) 비용 합 (성공건만) */
  payoutChannelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** 전체 페이아웃 건수 (성공+실패) */
  payoutCount: Scalars['Int']['output']
  /** 실패 (FAILED) 건수 */
  payoutFailedCount: Scalars['Int']['output']
  /** 우리 수수료 합 (성공건만) */
  payoutFeeAmount: Scalars['Float']['output']
  /** 성공 페이아웃 금액 합 */
  payoutSuccessAmount: Scalars['Float']['output']
  /** 성공 (COMPLETED) 건수 */
  payoutSuccessCount: Scalars['Int']['output']
  /** 토큰별 페이아웃 분포 */
  tokenBreakdown?: Maybe<Scalars['JSON']['output']>
  /** 토큰×네트워크 조합별 페이아웃 분포 */
  tokenNetworkBreakdown?: Maybe<Scalars['JSON']['output']>
  /** 수정 시각 */
  updatedAt: Scalars['DateTime']['output']
}

/** 시간별 페이아웃 요약 페이지네이션 응답 */
export type HourlyPayoutSummaryList = {
  __typename?: 'HourlyPayoutSummaryList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<HourlyPayoutSummary>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 시간별 거래 요약 (UTC 기준) */
export type HourlyTransactionSummary = {
  __typename?: 'HourlyTransactionSummary'
  /** 집계 실행 시각 */
  aggregatedAt: Scalars['DateTime']['output']
  /** 집계 시간 (UTC DateTime) */
  aggregationHour: Scalars['DateTime']['output']
  /** 자동 환불 - 만료 */
  autoRefundExpired: Scalars['Int']['output']
  /** 자동 환불 - 초과입금 */
  autoRefundOverpayment: Scalars['Int']['output']
  /** 자동 환불 - 타임아웃 */
  autoRefundTimeout: Scalars['Int']['output']
  /** 자동 환불 - 미달입금 */
  autoRefundUnderpaid: Scalars['Int']['output']
  /** 총 취소/환불 금액 */
  cancellationAmount: Scalars['Float']['output']
  /** 총 취소/환불 건수 */
  cancellationCount: Scalars['Int']['output']
  /** 전액 취소/환불 건수 */
  cancellationFullCount: Scalars['Int']['output']
  /** 부분 취소/환불 건수 */
  cancellationPartialCount: Scalars['Int']['output']
  /** 생성 시각 */
  createdAt: Scalars['DateTime']['output']
  /** 암호화폐별 거래 분포 */
  cryptoBreakdown?: Maybe<Scalars['JSON']['output']>
  /** 암호화폐×네트워크 조합별 거래 분포 */
  cryptoNetworkBreakdown?: Maybe<Scalars['JSON']['output']>
  /** 통화 코드 */
  currency: Scalars['String']['output']
  /** 요약 ID */
  id: Scalars['Int']['output']
  /** 야간 재집계 완료 여부 */
  isReconciled: Scalars['Boolean']['output']
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 네트워크별 거래 분포 */
  networkBreakdown?: Maybe<Scalars['JSON']['output']>
  /** 평균 결제 금액 */
  paymentAvgAmount?: Maybe<Scalars['Float']['output']>
  /** 총 결제 건수 */
  paymentCount: Scalars['Int']['output']
  /** 결제 실패 건수 */
  paymentFailedCount: Scalars['Int']['output']
  /** 결제 대기 건수 */
  paymentPendingCount: Scalars['Int']['output']
  /** 결제 성공 금액 */
  paymentSuccessAmount: Scalars['Float']['output']
  /** 결제 성공 건수 */
  paymentSuccessCount: Scalars['Int']['output']
  /** 수정 시각 */
  updatedAt: Scalars['DateTime']['output']
}

/** 시간별 거래 요약 페이지네이션 응답 */
export type HourlyTransactionSummaryList = {
  __typename?: 'HourlyTransactionSummaryList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<HourlyTransactionSummary>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 신분증 타입 */
export enum IdType {
  BUSINESS_LICENSE = 'BUSINESS_LICENSE',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  NATIONAL_ID = 'NATIONAL_ID',
  OTHER = 'OTHER',
  PASSPORT = 'PASSPORT',
}

/** Internal account business type */
export enum InternalAccountBusiness {
  BANK = 'BANK',
  CHANNEL = 'CHANNEL',
  CLIENT_ASSETS = 'CLIENT_ASSETS',
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
  MICRO_TRANSFER = 'MICRO_TRANSFER',
  NOT_BANK = 'NOT_BANK',
  OFFRAMP = 'OFFRAMP',
  ONRAMP = 'ONRAMP',
  PAYIN = 'PAYIN',
  PAYOUT = 'PAYOUT',
  TOPUP = 'TOPUP',
  WITHDRAWAL = 'WITHDRAWAL',
}

/** Internal account business sub type */
export enum InternalAccountBusinessSub {
  BALANCE = 'BALANCE',
  DEPOSIT_CLEARING = 'DEPOSIT_CLEARING',
  MICRO_TRANSFER_SERVICE_FEE = 'MICRO_TRANSFER_SERVICE_FEE',
  NONE = 'NONE',
  OFFRAMP_SERVICE_FEE = 'OFFRAMP_SERVICE_FEE',
  ONRAMP_SERVICE_FEE = 'ONRAMP_SERVICE_FEE',
  PAYIN_REFUND_FEE = 'PAYIN_REFUND_FEE',
  PAYIN_SERVICE_FEE = 'PAYIN_SERVICE_FEE',
  PAYIN_SETTLEMENT_FEE = 'PAYIN_SETTLEMENT_FEE',
  PAYOUT_SERVICE_FEE = 'PAYOUT_SERVICE_FEE',
  PENDING_SETTLEMENT = 'PENDING_SETTLEMENT',
  TOPUP_SERVICE_FEE = 'TOPUP_SERVICE_FEE',
  WITHDRAWAL_CLEARING = 'WITHDRAWAL_CLEARING',
  WITHDRAWAL_SERVICE_FEE = 'WITHDRAWAL_SERVICE_FEE',
}

export type InternalAccountEntryListInput = {
  /** Internal account business type */
  accountBusiness?: InputMaybe<InternalAccountBusiness>
  /** Internal account business sub type */
  accountBusinessSub?: InputMaybe<InternalAccountBusinessSub>
  /** Accounting subject type */
  accountSubject?: InputMaybe<AccountingSubjectType>
  /** Internal account type */
  accountType?: InputMaybe<InternalAccountType>
  /** Business order number */
  bizOrderNo?: InputMaybe<Scalars['String']['input']>
  /** Business type */
  bizType?: InputMaybe<BusinessType>
  /** Currency */
  currency?: InputMaybe<Scalars['String']['input']>
  /** From date */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Internal account target entity */
  targetEntity?: InputMaybe<InternalAccountTargetEntity>
  /** To date */
  toDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type InternalAccountEntryPage = {
  __typename?: 'InternalAccountEntryPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<InternalAccountEntryResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type InternalAccountEntryResponse = {
  __typename?: 'InternalAccountEntryResponse'
  /** Account number */
  accountNo: Scalars['String']['output']
  /** Account type description */
  accountType: Scalars['String']['output']
  /** Amount of this entry */
  amount: Scalars['Float']['output']
  /** Business order number */
  bizOrderNo: Scalars['String']['output']
  /** Business step */
  bizStep: BusinessStep
  /** Business type */
  bizType: BusinessType
  /** Create time */
  createdAt: Scalars['DateTime']['output']
  /** Currency of this entry */
  currency: Scalars['String']['output']
  /** Debit or credit flag of this entry */
  dcFlag: DcFlag
  /** Entry number */
  entryNo: Scalars['String']['output']
  /** Remark of this entry */
  remark?: Maybe<Scalars['String']['output']>
  /** Voucher number */
  voucherNo: Scalars['String']['output']
}

/** Internal account target entity */
export enum InternalAccountTargetEntity {
  AIRWALLEX = 'AIRWALLEX',
  BANK = 'BANK',
  COBO = 'COBO',
  GRIP = 'GRIP',
  HASHKEY = 'HASHKEY',
  PYVIO = 'PYVIO',
}

/** Internal account type */
export enum InternalAccountType {
  COST = 'COST',
  DEPOSITS = 'DEPOSITS',
  PAYABLE = 'PAYABLE',
  RECEIVABLE = 'RECEIVABLE',
  REVENUE = 'REVENUE',
  TRANSITION = 'TRANSITION',
}

export type IpWhitelistEntryModel = {
  __typename?: 'IpWhitelistEntryModel'
  createdAt: Scalars['DateTime']['output']
  createdBy: Scalars['Int']['output']
  id: Scalars['Int']['output']
  ipCidr: Scalars['String']['output']
  label?: Maybe<Scalars['String']['output']>
}

/** 현재 스코프의 화이트리스트 상태 + 요청자 IP */
export type IpWhitelistStatusModel = {
  __typename?: 'IpWhitelistStatusModel'
  /** 요청자의 현재 클라이언트 IP (자기잠금 방지 안내용) */
  currentIp?: Maybe<Scalars['String']['output']>
  /** 스코프 화이트리스트 활성화 여부 */
  enabled: Scalars['Boolean']['output']
  entries: Array<IpWhitelistEntryModel>
}

export type ManualRefundApproval = {
  __typename?: 'ManualRefundApproval'
  /** 자동 환불 Job ID */
  autoRefundJobId: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  /** 통화 */
  currency?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  payment?: Maybe<Payment>
  paymentId: Scalars['String']['output']
  /** 환불 사유 */
  reason: Scalars['String']['output']
  /** 환불 요청 금액 */
  refundAmount: Scalars['Float']['output']
  refundLink?: Maybe<RefundLink>
  /** 연결된 환불 링크 ID */
  refundLinkId?: Maybe<Scalars['String']['output']>
  /** 요청 시간 */
  requestedAt: Scalars['DateTime']['output']
  /** 요청자 */
  requestedBy: Scalars['String']['output']
  /** 검토 메모 */
  reviewNote?: Maybe<Scalars['String']['output']>
  /** 검토 완료 시간 */
  reviewedAt?: Maybe<Scalars['DateTime']['output']>
  /** 검토자 ID */
  reviewedBy?: Maybe<Scalars['String']['output']>
  /** 승인 상태 */
  status: ManualRefundApprovalStatus
  updatedAt: Scalars['DateTime']['output']
  /** 수동 승인 시 지정한 환불 지갑주소 (옵션) */
  walletAddress?: Maybe<Scalars['String']['output']>
}

export type ManualRefundApprovalFilterInput = {
  /** 종료 날짜 */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 가맹점 MID */
  mid?: InputMaybe<Scalars['String']['input']>
  /** 결제 ID */
  paymentId?: InputMaybe<Scalars['String']['input']>
  /** 시작 날짜 */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 승인 상태 필터 */
  status?: InputMaybe<ManualRefundApprovalStatus>
}

export type ManualRefundApprovalList = {
  __typename?: 'ManualRefundApprovalList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ManualRefundApproval>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 수동 환불 승인 상태 */
export enum ManualRefundApprovalStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

export type ManualRefundResponse = {
  __typename?: 'ManualRefundResponse'
  /** 처리 결과 메시지 */
  message: Scalars['String']['output']
  /** 변경된 결제 상태 */
  newPaymentStatus: PaymentStatus
  /** 결제 ID */
  paymentId: Scalars['String']['output']
  /** 처리 일시 */
  processedAt: Scalars['DateTime']['output']
  /** 환불 금액 */
  refundAmount: Scalars['Float']['output']
  /** 남은 결제 금액 */
  remainingAmount: Scalars['Float']['output']
  /** 총 환불 금액 (기존 + 신규) */
  totalRefundedAmount: Scalars['Float']['output']
  /** 생성된 환불 트랜잭션 ID */
  transactionId: Scalars['String']['output']
  /** 수동 환불 식별자 (MANUAL_REFUND_*) */
  transactionKey: Scalars['String']['output']
}

export type Menu = {
  __typename?: 'Menu'
  children?: Maybe<Array<Menu>>
  code: Scalars['String']['output']
  component?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  excludeRoles: Array<Scalars['String']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isDeleted: Scalars['Boolean']['output']
  isPublic: Scalars['Boolean']['output']
  isVisible: Scalars['Boolean']['output']
  menuType: Scalars['String']['output']
  name: Scalars['String']['output']
  parentId?: Maybe<Scalars['Int']['output']>
  path?: Maybe<Scalars['String']['output']>
  permissions?: Maybe<MenuPermissions>
  sortOrder: Scalars['Int']['output']
  target: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type MenuAssignmentInput = {
  /** 생성 권한 */
  canCreate?: InputMaybe<Scalars['Boolean']['input']>
  /** 삭제 권한 */
  canDelete?: InputMaybe<Scalars['Boolean']['input']>
  /** 수정 권한 */
  canEdit?: InputMaybe<Scalars['Boolean']['input']>
  /** 내보내기 권한 */
  canExport?: InputMaybe<Scalars['Boolean']['input']>
  /** 조회 권한 */
  canView?: InputMaybe<Scalars['Boolean']['input']>
  /** 메뉴 ID */
  menuId: Scalars['Int']['input']
}

export type MenuFilterInput = {
  hasExcludeRoles?: InputMaybe<Array<UserRole>>
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>
  isPublic?: InputMaybe<Scalars['Boolean']['input']>
  isVisible?: InputMaybe<Scalars['Boolean']['input']>
  menuType?: InputMaybe<Scalars['String']['input']>
  parentId?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type MenuOrderItem = {
  menuId: Scalars['Int']['input']
  sortOrder: Scalars['Int']['input']
}

export type MenuPermissionInput = {
  /** 생성 권한 */
  canCreate?: Scalars['Boolean']['input']
  /** 삭제 권한 */
  canDelete?: Scalars['Boolean']['input']
  /** 수정 권한 */
  canEdit?: Scalars['Boolean']['input']
  /** 내보내기 권한 */
  canExport?: Scalars['Boolean']['input']
  /** 조회 권한 */
  canView?: Scalars['Boolean']['input']
  /** 메뉴 ID */
  menuId: Scalars['Int']['input']
}

export type MenuPermissions = {
  __typename?: 'MenuPermissions'
  canCreate: Scalars['Boolean']['output']
  canDelete: Scalars['Boolean']['output']
  canEdit: Scalars['Boolean']['output']
  canExport: Scalars['Boolean']['output']
  canView: Scalars['Boolean']['output']
}

export type Merchant = {
  __typename?: 'Merchant'
  accountHolder?: Maybe<Scalars['String']['output']>
  /** 추가 정보 */
  additionalInfo?: Maybe<Scalars['String']['output']>
  approvedAt?: Maybe<Scalars['DateTime']['output']>
  approvedBy?: Maybe<Scalars['Int']['output']>
  bankAccount?: Maybe<Scalars['String']['output']>
  /** 은행 주소 */
  bankAddress?: Maybe<Scalars['String']['output']>
  /** 은행 지점명 */
  bankBranch?: Maybe<Scalars['String']['output']>
  bankCode?: Maybe<Scalars['String']['output']>
  /** 은행명 */
  bankName?: Maybe<Scalars['String']['output']>
  businessAddress?: Maybe<Scalars['String']['output']>
  businessCategory?: Maybe<Scalars['String']['output']>
  businessName?: Maybe<Scalars['String']['output']>
  businessNumber?: Maybe<Scalars['String']['output']>
  /** 사업장 전화 국가코드 */
  businessPhoneCountryCode?: Maybe<Scalars['String']['output']>
  /** 사업장 전화번호 */
  businessPhoneNumber?: Maybe<Scalars['String']['output']>
  /** 회사명 */
  companyName?: Maybe<Scalars['String']['output']>
  contractEndDate?: Maybe<Scalars['DateTime']['output']>
  contractStartDate?: Maybe<Scalars['DateTime']['output']>
  /** 회사 소재 국가 */
  countryCode?: Maybe<CountryCode>
  createdAt: Scalars['DateTime']['output']
  /** 삭제일 */
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  email: Scalars['String']['output']
  /** 직원수 */
  employeeCount?: Maybe<Scalars['Int']['output']>
  /** incorrect transfer 처리 모드 */
  exceptionHandlingMode: ExceptionHandlingMode
  id: Scalars['ID']['output']
  ipWhitelist: Array<Scalars['String']['output']>
  /** 소프트 삭제 여부 */
  isDeleted: Scalars['Boolean']['output']
  /** 상점 관리자 - 권한에 따라 조회 가능 */
  merchantAdminUser?: Maybe<MerchantUser>
  /** 상점 배경 설명 */
  merchantBackground?: Maybe<Scalars['String']['output']>
  /** 상점 문서 목록 - 권한에 따라 조회 가능 */
  merchantDocuments: Array<MerchantDocument>
  /** 상점 아이디 (MID) */
  mid: Scalars['String']['output']
  name: Scalars['String']['output']
  /** 회사 등록일 */
  registeredDate?: Maybe<Scalars['DateTime']['output']>
  rejectedReason?: Maybe<Scalars['String']['output']>
  /** 관련 회사 */
  relevantCompany?: Maybe<Scalars['String']['output']>
  representativeName?: Maybe<Scalars['String']['output']>
  /** 위험 수준 */
  riskLevel: Scalars['String']['output']
  /** 정산 지역 */
  settlementArea?: Maybe<Scalars['String']['output']>
  /** 서명권자 생년월일 */
  signerBirthDate?: Maybe<Scalars['DateTime']['output']>
  /** 신분증 파일 경로 */
  signerIdDocument?: Maybe<Scalars['String']['output']>
  /** 신분증 번호 */
  signerIdNumber?: Maybe<Scalars['String']['output']>
  /** 신분증 타입 */
  signerIdType?: Maybe<IdType>
  /** 신분증 유효기간 시작일 */
  signerIdValidFrom?: Maybe<Scalars['DateTime']['output']>
  /** 신분증 유효기간 종료일 */
  signerIdValidTo?: Maybe<Scalars['DateTime']['output']>
  /** 서명권자 이름 */
  signerName?: Maybe<Scalars['String']['output']>
  /** 거주지 주소 */
  signerResidentialAddress?: Maybe<Scalars['String']['output']>
  /** 거주 국가 */
  signerResidentialCountry?: Maybe<CountryCode>
  status: MerchantStatus
  /** SWIFT 코드 */
  swiftCode?: Maybe<Scalars['String']['output']>
  /** 세금 번호 */
  taxNumber?: Maybe<Scalars['String']['output']>
  totalDailyLimitAmount?: Maybe<Scalars['Int']['output']>
  totalMonthlyLimitAmount?: Maybe<Scalars['Int']['output']>
  type: MerchantType
  updatedAt: Scalars['DateTime']['output']
  /** 검증 상태 */
  verificationStatus: Scalars['String']['output']
  webhookUrl?: Maybe<Scalars['String']['output']>
  /** 회사 홈페이지 URL */
  websiteUrl?: Maybe<Scalars['String']['output']>
}

export type MerchantAccountEntryListInput = {
  /** Account type */
  accountType?: InputMaybe<MerchantAccountType>
  /** Business order number */
  bizOrderNo?: InputMaybe<Scalars['String']['input']>
  /** Business type */
  bizType?: InputMaybe<BusinessType>
  /** Currency */
  currency?: InputMaybe<Scalars['String']['input']>
  /** From date */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Account frozen type */
  frozenType?: InputMaybe<MerchantAccountFrozen>
  /** To date */
  toDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type MerchantAccountEntryPage = {
  __typename?: 'MerchantAccountEntryPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<MerchantAccountEntryResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type MerchantAccountEntryResponse = {
  __typename?: 'MerchantAccountEntryResponse'
  /** Account number */
  accountNo: Scalars['String']['output']
  /** Account type description */
  accountType: Scalars['String']['output']
  /** Amount of this entry */
  amount: Scalars['Float']['output']
  /** Account balance after this entry */
  balance: Scalars['Float']['output']
  /** Business order number */
  bizOrderNo: Scalars['String']['output']
  /** Business step */
  bizStep: BusinessStep
  /** Business type */
  bizType: BusinessType
  /** Create time */
  createdAt: Scalars['DateTime']['output']
  /** Currency of this entry */
  currency: Scalars['String']['output']
  /** Entry number */
  entryNo: Scalars['String']['output']
  /** Remark of this entry */
  remark?: Maybe<Scalars['String']['output']>
  /** Voucher number */
  voucherNo: Scalars['String']['output']
}

/** Merchant account frozen type */
export enum MerchantAccountFrozen {
  DISPUT_FROZEN = 'DISPUT_FROZEN',
  EXCHANGE_FROZEN = 'EXCHANGE_FROZEN',
  NORMAL = 'NORMAL',
  PAYOUT_FROZEN = 'PAYOUT_FROZEN',
  REFUND_FROZEN = 'REFUND_FROZEN',
  WITHDRAWAL_FROZEN = 'WITHDRAWAL_FROZEN',
}

export type MerchantAccountResponse = {
  __typename?: 'MerchantAccountResponse'
  /** Account balance amount */
  balanceAmount: Scalars['Float']['output']
  /** Account balance currency to appear */
  currency: Scalars['String']['output']
  /** Frozen amount */
  frozenAmount: Scalars['Float']['output']
  /** Frozen amount details */
  frozenDetails: Array<FrozenAmountDetailResponse>
  /** Pending settlement amount */
  pendingSettlementAmount: Scalars['Float']['output']
}

export type MerchantAccountSummaryResponse = {
  __typename?: 'MerchantAccountSummaryResponse'
  /** Account balance details for different currencies */
  details: Array<MerchantAccountResponse>
  /** Account balance summary */
  summary: MerchantAccountResponse
}

/** Merchant account type */
export enum MerchantAccountType {
  BALANCE = 'BALANCE',
  PENDING_CLEARING = 'PENDING_CLEARING',
  PENDING_SETTLEMENT = 'PENDING_SETTLEMENT',
}

/** 가맹점 API 키 */
export type MerchantApiKey = {
  __typename?: 'MerchantApiKey'
  /** 생성일 */
  createdAt: Scalars['DateTime']['output']
  /** 생성자 ID */
  createdBy?: Maybe<Scalars['Int']['output']>
  /** 삭제일 */
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  /** 설명 */
  description?: Maybe<Scalars['String']['output']>
  /** 표시 이름 */
  displayName: Scalars['String']['output']
  /** 키 환경 (CLIENT_KEY/SECRET_KEY/WEBHOOK_KEY) */
  environment: Scalars['String']['output']
  /** 만료일 */
  expiresAt?: Maybe<Scalars['DateTime']['output']>
  /** API 키 ID */
  id: Scalars['Int']['output']
  /** IP 화이트리스트 */
  ipWhitelist: Array<Scalars['String']['output']>
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean']['output']
  /** 마스킹된 키 (test_ck_abcd1234****wxyz) */
  keyMasked: Scalars['String']['output']
  /** 키 prefix (처음 12자) */
  keyPrefix: Scalars['String']['output']
  /** 키 타입 (TEST/LIVE) */
  keyType: Scalars['String']['output']
  /** 마지막 사용일 */
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>
  /** 가맹점 정보 */
  merchant?: Maybe<Merchant>
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 취소일 */
  revokedAt?: Maybe<Scalars['DateTime']['output']>
  /** 취소자 ID */
  revokedBy?: Maybe<Scalars['Int']['output']>
  /** 상태 (ACTIVE/INACTIVE/REVOKED/EXPIRED) */
  status: Scalars['String']['output']
  /** 수정일 */
  updatedAt: Scalars['DateTime']['output']
  /** 사용 횟수 */
  usageCount: Scalars['Int']['output']
}

export type MerchantAvailablePaymentMethod = {
  __typename?: 'MerchantAvailablePaymentMethod'
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  paymentMethod: PaymentMethod
  recommendedGateway: Scalars['String']['output']
  supportedGateways: Array<Scalars['String']['output']>
}

export type MerchantCryptoRefundFee = {
  __typename?: 'MerchantCryptoRefundFee'
  createdAt: Scalars['DateTime']['output']
  currency: Scalars['String']['output']
  /** 주문/정산 통화 ID */
  currencyId: Scalars['Int']['output']
  /** 설명 */
  description?: Maybe<Scalars['String']['output']>
  /** 수수료 금액 또는 비율 */
  feeAmount: Scalars['Float']['output']
  /** 수수료 타입 */
  feeType: CryptoRefundFeeType
  id: Scalars['ID']['output']
  /** 활성화 상태 */
  isActive: Scalars['Boolean']['output']
  /** 최대 수수료 */
  maxFee?: Maybe<Scalars['Float']['output']>
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 최소 수수료 */
  minFee?: Maybe<Scalars['Float']['output']>
  /** 실결제 통화 ID (L3 Crypto Currency) */
  payableCurrencyId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type MerchantCryptoRefundFeeList = {
  __typename?: 'MerchantCryptoRefundFeeList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<MerchantCryptoRefundFee>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type MerchantDocument = {
  __typename?: 'MerchantDocument'
  createdAt: Scalars['DateTime']['output']
  /** 삭제 일시 */
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  /** 문서 설명 */
  description?: Maybe<Scalars['String']['output']>
  /** 만료일 */
  expiresAt?: Maybe<Scalars['DateTime']['output']>
  /** 파일 정보 */
  fileUpload?: Maybe<FileInfo>
  fileUploadId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean']['output']
  /** 검증 완료 여부 */
  isVerified: Scalars['Boolean']['output']
  merchantId: Scalars['Int']['output']
  /** 문서 상태 */
  status: DocumentStatus
  /** 문서 타입 */
  type: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  /** 검증 일시 */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>
  /** 검증한 사용자 ID */
  verifiedBy?: Maybe<Scalars['Int']['output']>
}

/** 가맹점 환율 마진 설정 */
export type MerchantExchangeMargin = {
  __typename?: 'MerchantExchangeMargin'
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output']
  /** 예금 마진율 (%) */
  depositMarginRate?: Maybe<Scalars['Float']['output']>
  /** 실제 적용되는 예금 마진율 (%) - 가맹점 오버라이드 또는 시스템 기본값 */
  effectiveDepositMargin: Scalars['Float']['output']
  /** 실제 적용되는 결제 마진율 (%) - 가맹점 오버라이드 또는 시스템 기본값 */
  effectivePaymentMargin: Scalars['Float']['output']
  /** 실제 적용되는 출금 마진율 (%) - 가맹점 오버라이드 또는 시스템 기본값 */
  effectiveWithdrawalMargin: Scalars['Float']['output']
  /** 원 통화 정보 */
  fromCurrency: Currency
  /** 원 통화 ID (Currency 테이블 참조) */
  fromCurrencyId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  /** 활성화 상태 */
  isActive: Scalars['Boolean']['output']
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 결제 마진율 (%) */
  paymentMarginRate?: Maybe<Scalars['Float']['output']>
  /** 대상 통화 정보 */
  toCurrency: Currency
  /** 대상 통화 ID (Currency 테이블 참조) */
  toCurrencyId: Scalars['Int']['output']
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output']
  /** 출금 마진율 (%) */
  withdrawalMarginRate?: Maybe<Scalars['Float']['output']>
}

export type MerchantExchangeMarginFilterInput = {
  /** 원 통화 ID */
  fromCurrencyId?: InputMaybe<Scalars['Int']['input']>
  /** 활성화 상태 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 가맹점 ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 대상 통화 ID */
  toCurrencyId?: InputMaybe<Scalars['Int']['input']>
}

/** 가맹점 환율 마진 목록 */
export type MerchantExchangeMarginList = {
  __typename?: 'MerchantExchangeMarginList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<MerchantExchangeMargin>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type MerchantFilterInput = {
  /** 가맹점 ID */
  id?: InputMaybe<Scalars['Int']['input']>
  /** 위험 수준 (LOW, MEDIUM, HIGH, CRITICAL) */
  riskLevel?: InputMaybe<Scalars['String']['input']>
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>
  /** 검색 필드 (ALL: 전체, NAME: 상점명, EMAIL: 이메일, MID: 상점ID, BUSINESS_NUMBER: 사업자번호) */
  searchField?: InputMaybe<MerchantSearchField>
  /** 상점 상태 */
  status?: InputMaybe<MerchantStatus>
  /** 상점 상태 목록 (복수 선택) */
  statuses?: InputMaybe<Array<MerchantStatus>>
  /** 상점 타입 */
  type?: InputMaybe<MerchantType>
}

/** 가맹점 자주 쓰는 수취인 */
export type MerchantFrequentRecipientModel = {
  __typename?: 'MerchantFrequentRecipientModel'
  /** 주소 */
  address: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  merchantId: Scalars['Int']['output']
  /** 네트워크 */
  network: Scalars['String']['output']
  /** 수취인 이름 */
  recipientName: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type MerchantFrequentRecipientPage = {
  __typename?: 'MerchantFrequentRecipientPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<MerchantFrequentRecipientModel>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type MerchantList = {
  __typename?: 'MerchantList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<Merchant>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type MerchantPaymentMethod = {
  __typename?: 'MerchantPaymentMethod'
  createdAt: Scalars['DateTime']['output']
  currencyFees?: Maybe<Scalars['JSON']['output']>
  customRoutingId?: Maybe<Scalars['Int']['output']>
  dailyLimitAmount?: Maybe<Scalars['Int']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  feeRate: Scalars['Float']['output']
  fixedFee: Scalars['Float']['output']
  id: Scalars['ID']['output']
  isDeleted: Scalars['Boolean']['output']
  isEnabled: Scalars['Boolean']['output']
  maxAmount: Scalars['Float']['output']
  maxFee?: Maybe<Scalars['Float']['output']>
  /** 결제수단을 소유한 가맹점 정보 */
  merchant?: Maybe<Merchant>
  merchantId: Scalars['Int']['output']
  minAmount: Scalars['Float']['output']
  minFee: Scalars['Float']['output']
  monthlyLimitAmount?: Maybe<Scalars['Int']['output']>
  paymentMethod: PaymentMethod
  /** 정산 주기 (일) */
  settlementCycle: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type MerchantPaymentMethodFilterInput = {
  /** 결제 수단 목록 (여러개 선택 가능) */
  paymentMethods?: InputMaybe<Array<PaymentMethod>>
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>
  /** 검색 필드 (ALL: 전체, NAME: 상점명, MID: 상점ID) */
  searchField?: InputMaybe<PaymentMethodSearchField>
}

export type MerchantPaymentMethodList = {
  __typename?: 'MerchantPaymentMethodList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<MerchantWithPaymentMethods>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 가맹점별 페이아웃 통계 엑셀 다운로드 응답 */
export type MerchantPayoutStatisticsExcelResponse = {
  __typename?: 'MerchantPayoutStatisticsExcelResponse'
  /** Excel 파일 다운로드 URL (GCS Signed URL) */
  downloadUrl: Scalars['String']['output']
  /** 다운로드 메시지 */
  message: Scalars['String']['output']
  /** 포함된 레코드 수 */
  recordCount: Scalars['Int']['output']
}

/** 가맹점별 일별 페이아웃 통계 항목 */
export type MerchantPayoutStatisticsItem = {
  __typename?: 'MerchantPayoutStatisticsItem'
  /** 집계 실행 시각 */
  aggregatedAt: Scalars['String']['output']
  /** 집계 날짜 (YYYY-MM-DD) */
  aggregationDate: Scalars['String']['output']
  /** 생성 시각 */
  createdAt: Scalars['String']['output']
  /** 통화 코드 */
  currency: Scalars['String']['output']
  /** 레코드 ID (응답 내 ROW_NUMBER) */
  id: Scalars['Int']['output']
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 가맹점명 */
  merchantName: Scalars['String']['output']
  /** 페이아웃 통계 */
  payoutStats: PayoutStats
  /** 수정 시각 */
  updatedAt: Scalars['String']['output']
}

/** 가맹점별 페이아웃 통계 목록 (페이지네이션) */
export type MerchantPayoutStatisticsList = {
  __typename?: 'MerchantPayoutStatisticsList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<MerchantPayoutStatisticsItem>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 가맹점 검색 필드 */
export enum MerchantSearchField {
  ALL = 'ALL',
  BUSINESS_NUMBER = 'BUSINESS_NUMBER',
  EMAIL = 'EMAIL',
  MID = 'MID',
  NAME = 'NAME',
}

/** 가맹점별 통계 엑셀 다운로드 응답 */
export type MerchantStatisticsExcelResponse = {
  __typename?: 'MerchantStatisticsExcelResponse'
  /** Excel 파일 다운로드 URL (GCS Signed URL) */
  downloadUrl: Scalars['String']['output']
  /** 다운로드 메시지 */
  message: Scalars['String']['output']
  /** 포함된 레코드 수 */
  recordCount: Scalars['Int']['output']
}

/** 가맹점별 일별 통계 항목 */
export type MerchantStatisticsItem = {
  __typename?: 'MerchantStatisticsItem'
  /** 집계 실행 시각 */
  aggregatedAt: Scalars['String']['output']
  /** 집계 날짜 (YYYY-MM-DD) */
  aggregationDate: Scalars['String']['output']
  /** 취소/환불 통계 */
  cancellationStats: CancellationStats
  /** 생성 시각 */
  createdAt: Scalars['String']['output']
  /** 통화 코드 */
  currency: Scalars['String']['output']
  /** 요약 ID */
  id: Scalars['Int']['output']
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 가맹점명 */
  merchantName: Scalars['String']['output']
  /** 결제 통계 */
  paymentStats: PaymentStats
  /** 수정 시각 */
  updatedAt: Scalars['String']['output']
}

/** 가맹점별 통계 목록 (페이지네이션) */
export type MerchantStatisticsList = {
  __typename?: 'MerchantStatisticsList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<MerchantStatisticsItem>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 가맹점 상태 */
export enum MerchantStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SUSPENDED = 'SUSPENDED',
}

/** 가맹점 타입 */
export enum MerchantType {
  CORPORATION = 'CORPORATION',
  ENTERPRISE = 'ENTERPRISE',
  INDIVIDUAL = 'INDIVIDUAL',
  STARTUP = 'STARTUP',
}

export type MerchantUser = {
  __typename?: 'MerchantUser'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  /** 이메일 */
  email: Scalars['String']['output']
  /** 이메일 인증 여부 */
  emailVerified: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  /** 마지막 로그인 */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>
  /** 이름 */
  name: Scalars['String']['output']
  /** 전화 국가코드 */
  phoneCountryCode?: Maybe<Scalars['String']['output']>
  /** 전화번호 */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** 전화번호 인증 여부 */
  phoneVerified: Scalars['Boolean']['output']
  /** 사용자 역할 */
  role: Scalars['String']['output']
  /** 사용자 상태 */
  status: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MerchantUserDetail = {
  __typename?: 'MerchantUserDetail'
  /** 생성 일시 */
  createdAt: Scalars['DateTime']['output']
  /** 삭제 일시 */
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  /** 이메일 */
  email: Scalars['String']['output']
  /** 이메일 인증 여부 */
  emailVerified: Scalars['Boolean']['output']
  /** 이메일 인증 일시 */
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>
  /** 사용자 ID */
  id: Scalars['Int']['output']
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean']['output']
  /** 마지막 로그인 일시 */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>
  /** 사용자 메뉴 권한 목록 */
  menuPermissions?: Maybe<Array<UserMenuPermission>>
  /** 소속 가맹점 */
  merchant?: Maybe<Merchant>
  /** 가맹점 ID */
  merchantId?: Maybe<Scalars['Int']['output']>
  /** 이름 */
  name: Scalars['String']['output']
  /** 전화번호 국가코드 */
  phoneCountryCode?: Maybe<Scalars['String']['output']>
  /** 전화번호 */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** 전화번호 인증 여부 */
  phoneVerified: Scalars['Boolean']['output']
  /** 전화번호 인증 일시 */
  phoneVerifiedAt?: Maybe<Scalars['DateTime']['output']>
  /** 역할 */
  role: UserRole
  /** 상태 */
  status: UserStatus
  /** 현재 역할 정책상 로그인·자금 작업에 2FA 코드 입력이 필요한지 (정책 ON + 등록 완료) */
  twoFactorCodeRequired: Scalars['Boolean']['output']
  /** 2단계 인증 활성화 여부 */
  twoFactorEnabled: Scalars['Boolean']['output']
  /** 수정 일시 */
  updatedAt: Scalars['DateTime']['output']
}

export type MerchantUserFilterInput = {
  /** 가맹점 ID (ADMIN이 조회 시 필터링) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 검색 키워드 */
  searchKeyword?: InputMaybe<Scalars['String']['input']>
  /** 검색 필드 (EMAIL, NAME) */
  searchType?: InputMaybe<MerchantUserSearchField>
  /** 사용자 상태 필터 */
  status?: InputMaybe<UserStatus>
}

export type MerchantUserList = {
  __typename?: 'MerchantUserList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<User>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 가맹점 사용자 검색 필드 */
export enum MerchantUserSearchField {
  EMAIL = 'EMAIL',
  NAME = 'NAME',
}

export type MerchantWithPaymentMethods = {
  __typename?: 'MerchantWithPaymentMethods'
  /** 활성화된 결제수단 수 */
  activePaymentMethodsCount: Scalars['Int']['output']
  /** 생성일 */
  createdAt: Scalars['DateTime']['output']
  /** 이메일 */
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  /** 상점 고유 식별자 (MID) */
  mid: Scalars['String']['output']
  /** 상점명 */
  name: Scalars['String']['output']
  /** 상점의 결제수단 목록 */
  paymentMethods: Array<MerchantPaymentMethod>
  /** 상점 상태 */
  status: MerchantStatus
  /** 상점 타입 */
  type: MerchantType
}

/** Safety Withdraw 검증 송금 */
export type MicroTransferModel = {
  __typename?: 'MicroTransferModel'
  /** 대상 주소 */
  address: Scalars['String']['output']
  /** 코드 오입력 횟수 */
  attempts: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  /** L3 통화 코드 */
  currency: Scalars['String']['output']
  /** 코드 입력 만료 시각 */
  expiresAt?: Maybe<Scalars['DateTime']['output']>
  /** 검증 수수료 */
  feeAmount: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** 네트워크 */
  network: Scalars['String']['output']
  status: MicroTransferStatus
}

/** Safety Withdraw 검증 송금 상태 */
export enum MicroTransferStatus {
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SENDING = 'SENDING',
  SEND_FAILED = 'SEND_FAILED',
  SENT = 'SENT',
  VERIFIED = 'VERIFIED',
}

export type Mutation = {
  __typename?: 'Mutation'
  /** HOLDING 결제를 수락 (입금된 금액으로 정산 확정) */
  acceptHoldingPayment: PaymentAdjustment
  /** 환율 활성화/비활성화 (관리자만) */
  activateExchangeRate: ExchangeRate
  /** 어드민 IP 화이트리스트 엔트리 추가 */
  addAdminIpWhitelist: IpWhitelistEntryModel
  /** 가맹점 IP 화이트리스트 엔트리 추가 */
  addMerchantIpWhitelist: IpWhitelistEntryModel
  /** PG 정산 이벤트 추가 (수동 메모/이벤트) */
  addPgSettlementEvent: PgSettlementEventModel
  /** PG 정산 항목에 수수료 수동 추가 */
  addPgSettlementFee: PgSettlementFeeModel
  /** 관리자 계정을 생성합니다. 로그인 토큰은 반환하지 않습니다. */
  adminSignUp: AdminSignUpResponse
  /** Approve a pending crypto payout request */
  approveCryptoPayout: Scalars['Boolean']['output']
  /** 수동 환불 승인 처리 */
  approveManualRefund: ManualRefundApproval
  /** Approve an offramp order */
  approveOfframp: Scalars['Boolean']['output']
  /** Approve a pending onramp request */
  approveOnramp: Scalars['Boolean']['output']
  approveRefundApprovalRequest: RefundApprovalRequest
  assignTopupToInternalTransfer: Scalars['Boolean']['output']
  /** 사용자 메뉴 권한 할당 - ADMIN, MERCHANT_ADMIN만 접근 가능 */
  assignUserMenus: Scalars['Boolean']['output']
  /** Calculate balance hash for merchant account */
  calculateBalanceHash: Scalars['Boolean']['output']
  /** Cancel a crypto payout */
  cancelPayout: Scalars['Boolean']['output']
  /** 환불 링크 취소 (PENDING 상태만 취소 가능) */
  cancelRefundLink: CancelRefundLinkResponse
  /** 충전 요청 취소 */
  cancelTopupRequest: Scalars['Boolean']['output']
  /** 출금 요청 취소 */
  cancelWithdrawal: Withdrawal
  /** 비밀번호 변경 */
  changePassword: Scalars['Boolean']['output']
  /** Manually complete a pending crypto payout request */
  completeCryptoPayoutManually: Scalars['Boolean']['output']
  /** Manually complete a pending offramp request */
  completeOfframpManually: Scalars['Boolean']['output']
  completeOfframpTransfer: ChannelTransferModel
  /** Manually complete a pending onramp request */
  completeOnrampManually: Scalars['Boolean']['output']
  /** 출금 완료 처리 (관리자) */
  completeWithdrawal: Withdrawal
  /** 파일 업로드 완료 확인 */
  confirmFileUpload: FileAccessResponse
  /** Confirm a topup order and match a merchant */
  confirmTopup: Scalars['Boolean']['output']
  confirmTransferReceipt: ChannelTransferModel
  /** 2FA 등록 확정 (코드 검증) */
  confirmTwoFactorEnrollment: Scalars['Boolean']['output']
  /** Contact sales team with inquiry */
  contactSales: ContactSalesResponse
  /** USD 은행 수취인 등록 */
  createBankBeneficiary: BeneficiaryModel
  /** 채널 등록 */
  createChannel: Channel
  /** Create a new channel route */
  createChannelRoute: ChannelRoute
  /** Create Cobo payment order for crypto payment checkout session */
  createCoboOrder: CreateCoboOrderResponse
  /** 암호화폐 환불 수수료 생성 */
  createCryptoRefundFee: CryptoRefundFee
  /** 통화 생성 */
  createCurrency: Currency
  /** 일일 정산 집계 실행 */
  createDailySettlements: DailySettlementResult
  /** 환율 생성 (관리자만) */
  createExchangeRate: ExchangeRate
  /** Create new fee setting */
  createFeeSetting: Scalars['Boolean']['output']
  /** 수동 환불 처리 (은행/PG사에서 먼저 처리된 환불을 시스템에 반영) */
  createManualRefund: ManualRefundResponse
  /** Create a manual topup record pending confirmation */
  createManualTopup: TopupDetailResponse
  createManualTransfer: ChannelTransferModel
  /** 메뉴 생성 */
  createMenu: Menu
  /** 상점 생성 및 관리자 계정 생성 */
  createMerchant: CreateMerchantResponse
  /** API 키 생성 (평문 키 1회 반환) */
  createMerchantApiKey: CreateApiKeyResponse
  /** 가맹점별 암호화폐 환불 수수료 생성 */
  createMerchantCryptoRefundFee: MerchantCryptoRefundFee
  /** 가맹점 환율 마진 생성 (관리자 전용) */
  createMerchantExchangeMargin: MerchantExchangeMargin
  /** Create merchant frequent recipient */
  createMerchantFrequentRecipient: MerchantFrequentRecipientModel
  createMerchantPaymentMethod: CreateMerchantPaymentMethodResponse
  /** 가맹점 사용자 생성 - ADMIN, MERCHANT_ADMIN만 접근 가능 */
  createMerchantUser: CreateMerchantUserResponse
  createOfframpTransfer: ChannelTransferModel
  /** Create a payment from an existing checkout session */
  createPaymentFromSession: CreatePaymentResponse
  /** PG사 생성 */
  createPaymentGateway: PaymentGateway
  /** Create a new payment method configuration */
  createPaymentMethodConfig: PaymentMethodConfig
  /** Create a new payment method routing */
  createPaymentMethodRouting: PaymentMethodRouting
  /** PG 정산 요청 생성 */
  createPgSettlements: Array<PgSettlementModel>
  /** 환불 링크 생성 (관리자용) */
  createRefundLink: CreateRefundLinkResponse
  /** AML 위험 관리 공급자 생성 */
  createRiskManagementProvider: RiskManagementProviderModel
  /** 충전 요청 생성 */
  createTopupRequest: TopupRequestDetail
  /** 출금 요청 생성 */
  createWithdrawal: Withdrawal
  /** 수취인 삭제 */
  deleteBeneficiary: Scalars['Boolean']['output']
  /** Delete a channel route */
  deleteChannelRoute: ChannelRoute
  /** 암호화폐 환불 수수료 삭제 */
  deleteCryptoRefundFee: CryptoRefundFee
  /** 통화 삭제 */
  deleteCurrency: Scalars['Boolean']['output']
  /** 환율 삭제 (관리자만) */
  deleteExchangeRate: Scalars['Boolean']['output']
  /** Delete fee setting */
  deleteFeeSetting: Scalars['Boolean']['output']
  /** 파일 삭제 (소프트 삭제) */
  deleteFile: Scalars['Boolean']['output']
  /** 메뉴 삭제 (소프트 삭제) */
  deleteMenu: Menu
  /** 가맹점별 암호화폐 환불 수수료 삭제 */
  deleteMerchantCryptoRefundFee: MerchantCryptoRefundFee
  /** 가맹점 환율 마진 삭제 (관리자 전용) */
  deleteMerchantExchangeMargin: Scalars['Boolean']['output']
  /** Delete merchant frequent recipient by ID */
  deleteMerchantFrequentRecipient: Scalars['Boolean']['output']
  deleteMerchantPaymentMethod: DeleteMerchantPaymentMethodResponse
  /** 가맹점 사용자 삭제 (소프트 삭제) - ADMIN, MERCHANT_ADMIN만 접근 가능 */
  deleteMerchantUser: Scalars['Boolean']['output']
  /** PG사 삭제 */
  deletePaymentGateway: PaymentGateway
  /** Delete a payment method configuration */
  deletePaymentMethodConfig: PaymentMethodConfig
  /** Delete a payment method routing */
  deletePaymentMethodRouting: PaymentMethodRouting
  /** PG 정산 수수료 삭제 */
  deletePgSettlementFee: DeleteResult
  /** PG 정산 지갑 설정 삭제 */
  deletePgSettlementWalletConfig: Scalars['Boolean']['output']
  /** 자동환불 내역 엑셀 다운로드 (1000건 이하: 즉시 다운로드, 초과: 이메일 발송) */
  downloadAutoRefundExcel: AutoRefundExcelResponse
  /** Download crypto payout records as Excel */
  downloadCryptoPayoutExcel: CryptoPayoutExportResponse
  /** 일별 거래 요약 Excel 다운로드 */
  downloadDailySummaryExcel: DailySummaryExcelResponse
  /** Download merchant account balance change records as Excel */
  downloadMerchantAccountEntryExcel: AccountExportResponse
  /** 가맹점별 페이아웃 통계 Excel 다운로드 (ADMIN 전용) */
  downloadMerchantPayoutStatisticsExcel: MerchantPayoutStatisticsExcelResponse
  /** 가맹점별 통계 Excel 다운로드 (ADMIN 전용) */
  downloadMerchantStatisticsExcel: MerchantStatisticsExcelResponse
  /** Download offramp records as Excel */
  downloadOfframpExcel: OfframpExportResponse
  /** Download onramp records as Excel */
  downloadOnrampExcel: OnrampExportResponse
  /** 결제 내역 엑셀 다운로드 */
  downloadPaymentExcel: PaymentExportResponse
  /** 환불 내역 엑셀 다운로드 (1000건 이하: 즉시 다운로드, 초과: 이메일 발송) */
  downloadRefundExcel: RefundExcelResponse
  /** 정산 내역 엑셀 다운로드 (1000건 이하: 즉시 다운로드, 초과: 이메일 발송) */
  downloadSettlementExcel: SettlementExcelResponse
  /** 정산 기준일과 가맹점별 거래 내역 엑셀 다운로드 (1000건 이하: 즉시 다운로드, 초과: 이메일 발송) */
  downloadTransactionExcel: TransactionExcelResponse
  /** 출금 내역 엑셀 다운로드 (recipientInfo를 개별 컬럼으로 분리) */
  downloadWithdrawalExcel: WithdrawalExportResponse
  /** Cloud Scheduler Airwallex 대사 배치 실행 */
  executeAirwallexReconciliationScheduler: AirwallexReconciliationResult
  /** Cloud Scheduler Cobo 대사 배치 실행 */
  executeCoboReconciliationScheduler: CoboReconciliationResult
  /** Cloud Scheduler Crypto to USD exchange rate updating */
  executeCryptoExchangeRateUpdateScheduler: ExchangeRateUpdateResult
  /** Cloud Scheduler 일일 정산 배치 실행 */
  executeDailySettlementScheduler: DailySettlementResult
  /** Cloud Scheduler for cleaning up history data */
  executeDataCleanupScheduler: Scalars['String']['output']
  /** Cloud Scheduler 환율 업데이트 배치 실행 */
  executeExchangeRateUpdateScheduler: ExchangeRateUpdateResult
  /** Cloud Scheduler 엑셀 파일 정리 실행 */
  executeExportCleanupScheduler: Scalars['String']['output']
  /** FIAT 주문 크립토 자동 출금 (매일 03:30 HKT) */
  executeFiatOrderCryptoSettlementScheduler: FiatOrderCryptoSettlementResult
  /** 시간별 집계 수동 실행 (결제 + 페이아웃, ADMIN 전용) */
  executeHourlyAggregation: HourlyAggregationResult
  /** Cloud Scheduler 시간별 집계 실행 (결제 + 페이아웃) */
  executeHourlyAggregationScheduler: HourlyAggregationResult
  /** Cloud Scheduler: Internal account daily trial balance */
  executeInternalAccountDailyTrialBalanceScheduler: Scalars['Boolean']['output']
  /** 정체된 PYVIO 오프램프 대사 (재발송 없음) */
  executeOfframpReconciliationScheduler: OfframpReconciliationResult
  /** 미확인 PG 지급 디스패치 대사 */
  executePgDispatchReconciliationScheduler: PgDispatchReconciliationResult
  /** 미확인 환불 디스패치 대사 */
  executeRefundDispatchReconciliationScheduler: RefundDispatchReconciliationResult
  /** Expire a checkout session (only for PENDING or PROCESSING status) */
  expireCheckoutSession: ExpireCheckoutSessionResponse
  failOfframpTransfer: ChannelTransferModel
  /** 출금 실패 처리 (관리자) */
  failWithdrawal: Withdrawal
  /** 파일 업로드를 위한 Signed URL 생성 */
  generateFileUploadUrl: FileUploadResponse
  /** 사용자에게 추가 메뉴 접근 권한 부여 */
  grantUserMenuAccess: UserMenu
  /** Airwallex PG 거래 대사 수행 (수동) */
  handleAirwallexReconciliation: AirwallexReconciliationResult
  /** Cobo PG 거래 대사 수행 (수동) */
  handleCoboReconciliation: CoboReconciliationResult
  /** 로그아웃 */
  logout: Scalars['Boolean']['output']
  /** Mock actyve webhooks */
  mockActyve: Scalars['Boolean']['output']
  /** Mock cobo webhooks */
  mockCobo: Scalars['Boolean']['output']
  /** Mock pyvio webhooks */
  mockPyvio: Scalars['Boolean']['output']
  omitTopup: Scalars['Boolean']['output']
  /** 출금 처리 시작 (관리자) */
  processWithdrawal: Withdrawal
  /** 검증 송금 수동 재확인 — webhook 유실로 SENDING 에 멈춘 건을 Cobo 종결 상태로 대사 */
  recheckMicroTransfer: MicroTransferModel
  recheckPayoutDispatch: PayoutDispatchRecheckResultModel
  recheckRefundDispatch: RefundDispatchRecheckResultModel
  /** Record the experiment event */
  recordExperimentEvent: Scalars['Boolean']['output']
  /** Record an onramp funding transfer sent manually */
  recordOnrampFundingTransfer: OnrampFundingTransfer
  refreshAccessToken: SignInResponse
  /** 결제 환불 처리 (정산일 기준 자동 CANCEL/REFUND 구분) */
  refundPayment: RefundPaymentResponse
  /** API 키 재생성 (기존 키 REVOKED + 새 키 생성) */
  regenerateMerchantApiKey: CreateApiKeyResponse
  /** 검증된 지갑주소를 수취인으로 등록 */
  registerBeneficiary: BeneficiaryModel
  /** Reject a pending crypto payout request */
  rejectCryptoPayout: Scalars['Boolean']['output']
  /** HOLDING 결제를 거절 (자동환불 큐 등록) */
  rejectHoldingPayment: PaymentAdjustment
  /** 수동 환불 거절 처리 */
  rejectManualRefund: ManualRefundApproval
  /** Reject an offramp order */
  rejectOfframp: Scalars['Boolean']['output']
  /** Reject a pending onramp request */
  rejectOnramp: Scalars['Boolean']['output']
  rejectRefundApprovalRequest: RefundApprovalRequest
  /** 어드민 IP 화이트리스트 엔트리 삭제 */
  removeAdminIpWhitelist: Scalars['Boolean']['output']
  /** 가맹점 IP 화이트리스트 엔트리 삭제 */
  removeMerchantIpWhitelist: Scalars['Boolean']['output']
  /** 메뉴 순서 변경 */
  reorderMenus: Scalars['Boolean']['output']
  /** Ingest anonymous client-side error events (e.g. login page crashes before authentication). No user context is recorded. */
  reportAnonymousClientErrors: ReportClientErrorsResponse
  /** Ingest authenticated client-side error events. User context is extracted server-side from the validated session. */
  reportClientErrors: ReportClientErrorsResponse
  /** Safety Withdraw 검증 송금 요청 */
  requestMicroTransfer: MicroTransferModel
  /** 새 기기 로그인 이메일 코드 재발송 */
  resendLoginDeviceCode: Scalars['Boolean']['output']
  /** 비밀번호 설정 이메일 재발송 - ADMIN, MERCHANT_ADMIN만 접근 가능 */
  resendPasswordSetupEmail: Scalars['Boolean']['output']
  /** 환불 이메일 재발송 (기존 RefundLink 취소 후 새 링크 생성) */
  resendRefundEmail: ManualRefundApproval
  /** 관리자: 사용자 2FA 초기화 */
  resetUserTwoFactor: Scalars['Boolean']['output']
  resolveReconciliationMismatchItem: ReconciliationMismatchItem
  resolveRefundReconciliation: RefundDispatchRecheckResultModel
  retryChannelFundFlowSync: ChannelFundFlowSyncRun
  /** Retry a failed onramp funding transfer */
  retryOnrampFundingTransfer: Scalars['Boolean']['output']
  /** Retry a crypto payout */
  retryPayout: Scalars['Boolean']['output']
  /** 출금 재처리 (관리자, ON_HOLD → PROCESSING) */
  retryWithdrawal: Withdrawal
  /** API 키 취소 (REVOKED 상태로 변경) */
  revokeMerchantApiKey: MerchantApiKey
  /** 사용자의 메뉴 접근 권한 제거 */
  revokeUserMenuAccess: Scalars['Boolean']['output']
  /** Roll back a completed topup and post reversing account entries */
  rollbackTopup: Scalars['Boolean']['output']
  /** 어드민 IP 화이트리스트 on/off */
  setAdminIpWhitelistEnabled: Scalars['Boolean']['output']
  /** 역할별 메뉴 권한 일괄 설정 */
  setBulkRoleMenuPermissions: Array<RoleMenu>
  /** 가맹점 IP 화이트리스트 on/off */
  setMerchantIpWhitelistEnabled: Scalars['Boolean']['output']
  /** 토큰 기반 비밀번호 설정 - 이메일로 받은 링크에서 사용 */
  setPasswordByToken: Scalars['Boolean']['output']
  /** 역할별 메뉴 권한 설정 */
  setRoleMenuPermissions: RoleMenu
  /** 사용자별 메뉴 권한 설정 */
  setUserMenuPermissions: UserMenu
  signIn: SignInResponse
  /** Simulate a failed onramp funding transfer */
  simulateOnrampFundingTransferFailed: Scalars['Boolean']['output']
  /** Simulate a paid onramp funding transfer */
  simulateOnrampFundingTransferPaid: Scalars['Boolean']['output']
  /** QA/Staging Airwallex 충전 입금 시뮬레이션 */
  simulateTopupDeposit: SimulateTopupDepositResult
  startChannelFundFlowSync: ChannelFundFlowSyncRun
  /** Start a crypto payout request that enters approval flow */
  startCryptoPayout: Scalars['Boolean']['output']
  /** Start an offramp order */
  startOfframp: Scalars['Boolean']['output']
  /** Start an onramp order */
  startOnramp: Scalars['Boolean']['output']
  /** 2FA 등록 시작 (QR 발급) */
  startTwoFactorEnrollment: EnrollmentStartModel
  /** 충전 요청 증빙 제출 */
  submitTopupRequestEvidence: Scalars['Boolean']['output']
  /** Submit wallet address for crypto refund (Public) */
  submitWalletAddress: SubmitWalletAddressResponse
  /** 채널 자금 흐름 동기화 */
  syncChannelFundFlows: SyncChannelFundFlowsResult
  /** Test account business logic */
  testAccountBusiness: Scalars['Boolean']['output']
  /** API 키 상태 토글 (ACTIVE <-> INACTIVE) */
  toggleMerchantApiKey: MerchantApiKey
  /** AML 알림 상태 변경 */
  updateAmlAlertStatus: AmlAlertModel
  /** 채널 수정 (이름/설명/상태) */
  updateChannel: Channel
  /** 채널 capability 토글/설정 (관리·표시용 — 실제 플로우 차단은 후속 단계) */
  updateChannelCapability: ChannelCapability
  /** 암호화폐 환불 수수료 수정 */
  updateCryptoRefundFee: CryptoRefundFee
  /** 통화 수정 */
  updateCurrency: Currency
  /** 비정상 입금 처리 상태 변경 (RESOLVED / IGNORED) */
  updateExceptionalTransferStatus: ExceptionalTransfer
  /** 환율 수정 (관리자만) */
  updateExchangeRate: ExchangeRate
  /** Update fee setting */
  updateFeeSetting: Scalars['Boolean']['output']
  /** 메뉴 수정 */
  updateMenu: Menu
  /** 상점 정보 수정 - 관리자와 가맹점 관리자만 접근 가능 */
  updateMerchant: Merchant
  /** 가맹점별 암호화폐 환불 수수료 수정 */
  updateMerchantCryptoRefundFee: MerchantCryptoRefundFee
  /** 가맹점 환율 마진 수정 (관리자 전용) */
  updateMerchantExchangeMargin: MerchantExchangeMargin
  /** Update merchant frequent recipient by ID */
  updateMerchantFrequentRecipient: MerchantFrequentRecipientModel
  updateMerchantPaymentMethod: UpdateMerchantPaymentMethodResponse
  /** 가맹점 사용자 수정 - ADMIN, MERCHANT_ADMIN만 접근 가능 */
  updateMerchantUser: User
  /** PG사 수정 */
  updatePaymentGateway: PaymentGateway
  /** PG사 상태 변경 */
  updatePaymentGatewayStatus: PaymentGateway
  /** Update a payment method configuration */
  updatePaymentMethodConfig: PaymentMethodConfig
  /** Update a payment method routing */
  updatePaymentMethodRouting: PaymentMethodRouting
  updatePaymentRouting: Scalars['Boolean']['output']
  /** PG 정산 수수료 수정 */
  updatePgSettlementFee: PgSettlementFeeModel
  /** PG 정산금 이체 요청 상태 업데이트 (수동) */
  updatePgSettlementTransferStatus: PgSettlementTransferModel
  /** 환불 링크 고객 이메일 수정 및 재발송 (시스템 관리자 전용) */
  updateRefundLinkEmail: UpdateRefundLinkEmailResponse
  /** AML 위험 관리 공급자 상태 변경 */
  updateRiskProviderStatus: RiskManagementProviderModel
  /** Update routing priority */
  updateRoutingPriority: PaymentMethodRouting
  /** 관리자: 보안 정책 변경 */
  updateSecurityPolicy: SecurityPolicyModel
  /** 시스템 설정 단일 업데이트 */
  updateSystemSetting: SystemSettingModel
  /** 시스템 설정 벌크 업데이트 */
  updateSystemSettings: Array<SystemSettingModel>
  /** 사용자 정보 수정 */
  updateUser: User
  /** 출금 요청 수정 */
  updateWithdrawal: Withdrawal
  /** Validate an uploaded .xlsx file and queue sequential crypto payouts */
  uploadBatchCryptoPayout: BatchCryptoPayoutUploadResponse
  /** PG 정산 지갑 설정 생성/수정 */
  upsertPgSettlementWalletConfig: PgSettlementWalletConfigModel
  /** 새 기기 로그인 이메일 코드 검증 */
  verifyLoginDevice: SignInResponse
  /** 로그인 2FA 코드 검증 */
  verifyLoginTwoFactor: SignInResponse
  /** Safety Withdraw 검증 코드 단독 확인 (출금 없음). SENDING 상태에서도 즉시 검증 가능. */
  verifyMicroTransferCode: VerifyMicroTransferCodeModel
}

export type MutationAcceptHoldingPaymentArgs = {
  input: AcceptHoldingPaymentInput
}

export type MutationActivateExchangeRateArgs = {
  input: ActivateExchangeRateInput
}

export type MutationAddAdminIpWhitelistArgs = {
  input: AddIpWhitelistInput
}

export type MutationAddMerchantIpWhitelistArgs = {
  input: AddIpWhitelistInput
}

export type MutationAddPgSettlementEventArgs = {
  input: AddPgSettlementEventInput
}

export type MutationAddPgSettlementFeeArgs = {
  input: AddPgSettlementFeeInput
}

export type MutationAdminSignUpArgs = {
  input: AdminSignUpInput
}

export type MutationApproveCryptoPayoutArgs = {
  input: ApproveCryptoPayoutInput
}

export type MutationApproveManualRefundArgs = {
  input: ApproveManualRefundInput
}

export type MutationApproveOfframpArgs = {
  input: ApproveOfframpInput
}

export type MutationApproveOnrampArgs = {
  input: ApproveOnrampInput
}

export type MutationApproveRefundApprovalRequestArgs = {
  input: ApproveRefundApprovalInput
}

export type MutationAssignTopupToInternalTransferArgs = {
  input: AssignTopupToInternalTransferInput
}

export type MutationAssignUserMenusArgs = {
  input: AssignUserMenusInput
}

export type MutationCalculateBalanceHashArgs = {
  accountId: Scalars['Int']['input']
}

export type MutationCancelPayoutArgs = {
  orderId: Scalars['String']['input']
}

export type MutationCancelRefundLinkArgs = {
  input: CancelRefundLinkInput
}

export type MutationCancelTopupRequestArgs = {
  input: CancelTopupRequestInput
}

export type MutationCancelWithdrawalArgs = {
  id: Scalars['String']['input']
}

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput
}

export type MutationCompleteCryptoPayoutManuallyArgs = {
  input: CompleteCryptoPayoutManuallyInput
}

export type MutationCompleteOfframpManuallyArgs = {
  input: CompleteOfframpManuallyInput
}

export type MutationCompleteOfframpTransferArgs = {
  input: CompleteOfframpTransferInput
}

export type MutationCompleteOnrampManuallyArgs = {
  input: CompleteOnrampManuallyInput
}

export type MutationCompleteWithdrawalArgs = {
  input: CompleteWithdrawalInput
}

export type MutationConfirmFileUploadArgs = {
  uploadId: Scalars['Int']['input']
  uploadToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationConfirmTopupArgs = {
  id: Scalars['Int']['input']
  merchantId: Scalars['Int']['input']
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type MutationConfirmTransferReceiptArgs = {
  input: ConfirmReceiptInput
}

export type MutationConfirmTwoFactorEnrollmentArgs = {
  input: ConfirmEnrollmentInput
}

export type MutationContactSalesArgs = {
  input: ContactSalesInput
}

export type MutationCreateBankBeneficiaryArgs = {
  input: CreateBankBeneficiaryInput
}

export type MutationCreateChannelArgs = {
  input: CreateChannelInput
}

export type MutationCreateChannelRouteArgs = {
  input: CreateChannelRouteInput
}

export type MutationCreateCoboOrderArgs = {
  input: CreateCoboOrderRequest
}

export type MutationCreateCryptoRefundFeeArgs = {
  input: CreateCryptoRefundFeeInput
}

export type MutationCreateCurrencyArgs = {
  input: CreateCurrencyInput
}

export type MutationCreateDailySettlementsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
}

export type MutationCreateExchangeRateArgs = {
  input: CreateExchangeRateInput
}

export type MutationCreateFeeSettingArgs = {
  input: FeeSettingUpdateInput
}

export type MutationCreateManualRefundArgs = {
  input: CreateManualRefundInput
}

export type MutationCreateManualTopupArgs = {
  input: CreateManualTopupInput
}

export type MutationCreateManualTransferArgs = {
  input: CreateManualTransferInput
}

export type MutationCreateMenuArgs = {
  input: CreateMenuInput
}

export type MutationCreateMerchantArgs = {
  input: CreateMerchantInput
}

export type MutationCreateMerchantApiKeyArgs = {
  input: CreateApiKeyInput
}

export type MutationCreateMerchantCryptoRefundFeeArgs = {
  input: CreateCryptoRefundFeeInput
}

export type MutationCreateMerchantExchangeMarginArgs = {
  input: CreateMerchantExchangeMarginInput
}

export type MutationCreateMerchantFrequentRecipientArgs = {
  input: CreateMerchantFrequentRecipientInput
}

export type MutationCreateMerchantPaymentMethodArgs = {
  input: CreateMerchantPaymentMethodInput
}

export type MutationCreateMerchantUserArgs = {
  input: CreateMerchantUserInput
}

export type MutationCreateOfframpTransferArgs = {
  input: CreateOfframpTransferInput
}

export type MutationCreatePaymentFromSessionArgs = {
  input: CreatePaymentFromSessionInput
}

export type MutationCreatePaymentGatewayArgs = {
  input: CreatePaymentGatewayInput
}

export type MutationCreatePaymentMethodConfigArgs = {
  input: CreatePaymentMethodConfigInput
}

export type MutationCreatePaymentMethodRoutingArgs = {
  input: CreatePaymentMethodRoutingInput
}

export type MutationCreatePgSettlementsArgs = {
  input: CreatePgSettlementInput
}

export type MutationCreateRefundLinkArgs = {
  input: CreateRefundLinkInput
}

export type MutationCreateRiskManagementProviderArgs = {
  code: Scalars['String']['input']
  name: Scalars['String']['input']
  priority?: Scalars['Int']['input']
}

export type MutationCreateTopupRequestArgs = {
  input: CreateTopupRequestInput
}

export type MutationCreateWithdrawalArgs = {
  input: CreateWithdrawalInput
}

export type MutationDeleteBeneficiaryArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteChannelRouteArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCryptoRefundFeeArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteCurrencyArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteExchangeRateArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteFeeSettingArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteFileArgs = {
  fileId: Scalars['Int']['input']
  uploadToken?: InputMaybe<Scalars['String']['input']>
}

export type MutationDeleteMenuArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteMerchantCryptoRefundFeeArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteMerchantExchangeMarginArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteMerchantFrequentRecipientArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteMerchantPaymentMethodArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteMerchantUserArgs = {
  userId: Scalars['Int']['input']
}

export type MutationDeletePaymentGatewayArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeletePaymentMethodConfigArgs = {
  id: Scalars['Float']['input']
}

export type MutationDeletePaymentMethodRoutingArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeletePgSettlementFeeArgs = {
  id: Scalars['String']['input']
}

export type MutationDeletePgSettlementWalletConfigArgs = {
  id: Scalars['String']['input']
}

export type MutationDownloadAutoRefundExcelArgs = {
  filter?: InputMaybe<AutoRefundFilterInput>
}

export type MutationDownloadCryptoPayoutExcelArgs = {
  filter?: InputMaybe<CryptoPayoutListInput>
}

export type MutationDownloadDailySummaryExcelArgs = {
  input: GetDailyTransactionSummaryInput
}

export type MutationDownloadMerchantAccountEntryExcelArgs = {
  filter?: InputMaybe<MerchantAccountEntryListInput>
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type MutationDownloadMerchantPayoutStatisticsExcelArgs = {
  input: GetMerchantPayoutStatisticsInput
}

export type MutationDownloadMerchantStatisticsExcelArgs = {
  input: GetMerchantStatisticsInput
}

export type MutationDownloadOfframpExcelArgs = {
  filter?: InputMaybe<OfframpListInput>
}

export type MutationDownloadOnrampExcelArgs = {
  filter?: InputMaybe<OnrampListInput>
}

export type MutationDownloadPaymentExcelArgs = {
  filter?: InputMaybe<PaymentFilterInput>
}

export type MutationDownloadRefundExcelArgs = {
  filter?: InputMaybe<RefundFilterInput>
}

export type MutationDownloadSettlementExcelArgs = {
  filter?: InputMaybe<SettlementFilterInput>
}

export type MutationDownloadTransactionExcelArgs = {
  filter: TransactionExcelFilterInput
}

export type MutationDownloadWithdrawalExcelArgs = {
  filter?: InputMaybe<WithdrawalFilterInput>
}

export type MutationExecuteAirwallexReconciliationSchedulerArgs = {
  input: ExecuteAirwallexReconciliationInput
}

export type MutationExecuteCoboReconciliationSchedulerArgs = {
  input: ExecuteCoboReconciliationInput
}

export type MutationExecuteCryptoExchangeRateUpdateSchedulerArgs = {
  input: ExecuteExchangeRateUpdateInput
}

export type MutationExecuteDailySettlementSchedulerArgs = {
  input: ExecuteDailySettlementInput
}

export type MutationExecuteDataCleanupSchedulerArgs = {
  internalSecret: Scalars['String']['input']
}

export type MutationExecuteExchangeRateUpdateSchedulerArgs = {
  input: ExecuteExchangeRateUpdateInput
}

export type MutationExecuteExportCleanupSchedulerArgs = {
  internalSecret: Scalars['String']['input']
}

export type MutationExecuteFiatOrderCryptoSettlementSchedulerArgs = {
  gatewayCode?: InputMaybe<Scalars['String']['input']>
  internalSecret: Scalars['String']['input']
  targetDate?: InputMaybe<Scalars['String']['input']>
}

export type MutationExecuteHourlyAggregationArgs = {
  dateTimeFrom: Scalars['String']['input']
  dateTimeTo: Scalars['String']['input']
}

export type MutationExecuteHourlyAggregationSchedulerArgs = {
  input: ExecuteHourlyAggregationInput
}

export type MutationExecuteInternalAccountDailyTrialBalanceSchedulerArgs = {
  internalSecret: Scalars['String']['input']
  offsetDay?: InputMaybe<Scalars['Int']['input']>
  period?: InputMaybe<Scalars['Int']['input']>
}

export type MutationExecuteOfframpReconciliationSchedulerArgs = {
  input: ExecuteOfframpReconciliationInput
}

export type MutationExecutePgDispatchReconciliationSchedulerArgs = {
  input: ExecutePgDispatchReconciliationInput
}

export type MutationExecuteRefundDispatchReconciliationSchedulerArgs = {
  input: ExecuteRefundDispatchReconciliationInput
}

export type MutationExpireCheckoutSessionArgs = {
  input: ExpireCheckoutSessionInput
}

export type MutationFailOfframpTransferArgs = {
  errorMessage: Scalars['String']['input']
  id: Scalars['String']['input']
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type MutationFailWithdrawalArgs = {
  input: FailWithdrawalInput
}

export type MutationGenerateFileUploadUrlArgs = {
  input: GenerateFileUploadUrlInput
}

export type MutationGrantUserMenuAccessArgs = {
  input: GrantUserMenuAccessInput
}

export type MutationHandleAirwallexReconciliationArgs = {
  input: HandleAirwallexReconciliationInput
}

export type MutationHandleCoboReconciliationArgs = {
  input: HandleCoboReconciliationInput
}

export type MutationMockActyveArgs = {
  data: Scalars['JSON']['input']
  eventType: Scalars['String']['input']
}

export type MutationMockCoboArgs = {
  data: Scalars['JSON']['input']
  eventType: Scalars['String']['input']
}

export type MutationMockPyvioArgs = {
  data: Scalars['JSON']['input']
  eventType: Scalars['String']['input']
}

export type MutationOmitTopupArgs = {
  input: OmitTopupInput
}

export type MutationProcessWithdrawalArgs = {
  input: ProcessWithdrawalInput
}

export type MutationRecheckMicroTransferArgs = {
  id: Scalars['ID']['input']
}

export type MutationRecheckPayoutDispatchArgs = {
  input: RecheckPayoutDispatchInput
}

export type MutationRecheckRefundDispatchArgs = {
  input: RecheckRefundDispatchInput
}

export type MutationRecordExperimentEventArgs = {
  input: ExperimentEventInput
}

export type MutationRecordOnrampFundingTransferArgs = {
  input: RecordOnrampFundingTransferInput
}

export type MutationRefreshAccessTokenArgs = {
  input: RefreshTokenInput
}

export type MutationRefundPaymentArgs = {
  input: RefundPaymentInput
}

export type MutationRegenerateMerchantApiKeyArgs = {
  input: RegenerateApiKeyInput
}

export type MutationRegisterBeneficiaryArgs = {
  input: RegisterBeneficiaryInput
}

export type MutationRejectCryptoPayoutArgs = {
  input: RejectCryptoPayoutInput
}

export type MutationRejectHoldingPaymentArgs = {
  input: RejectHoldingPaymentInput
}

export type MutationRejectManualRefundArgs = {
  input: RejectManualRefundInput
}

export type MutationRejectOfframpArgs = {
  input: RejectOfframpInput
}

export type MutationRejectOnrampArgs = {
  input: RejectOnrampInput
}

export type MutationRejectRefundApprovalRequestArgs = {
  input: RejectRefundApprovalInput
}

export type MutationRemoveAdminIpWhitelistArgs = {
  id: Scalars['Int']['input']
}

export type MutationRemoveMerchantIpWhitelistArgs = {
  id: Scalars['Int']['input']
}

export type MutationReorderMenusArgs = {
  input: ReorderMenusInput
}

export type MutationReportAnonymousClientErrorsArgs = {
  input: ReportClientErrorsInput
}

export type MutationReportClientErrorsArgs = {
  input: ReportClientErrorsInput
}

export type MutationRequestMicroTransferArgs = {
  input: RequestMicroTransferInput
}

export type MutationResendLoginDeviceCodeArgs = {
  input: ResendLoginDeviceCodeInput
}

export type MutationResendPasswordSetupEmailArgs = {
  locale?: InputMaybe<EmailLocale>
  userId: Scalars['Int']['input']
}

export type MutationResendRefundEmailArgs = {
  approvalId: Scalars['String']['input']
}

export type MutationResetUserTwoFactorArgs = {
  userId: Scalars['Int']['input']
}

export type MutationResolveReconciliationMismatchItemArgs = {
  input: ResolveReconciliationMismatchItemInput
}

export type MutationResolveRefundReconciliationArgs = {
  input: ResolveRefundReconciliationInput
}

export type MutationRetryChannelFundFlowSyncArgs = {
  runId: Scalars['String']['input']
}

export type MutationRetryOnrampFundingTransferArgs = {
  input: RetryOnrampFundingTransferInput
}

export type MutationRetryPayoutArgs = {
  orderId: Scalars['String']['input']
}

export type MutationRetryWithdrawalArgs = {
  input: RetryWithdrawalInput
}

export type MutationRevokeMerchantApiKeyArgs = {
  id: Scalars['Int']['input']
}

export type MutationRevokeUserMenuAccessArgs = {
  input: RevokeUserMenuAccessInput
}

export type MutationRollbackTopupArgs = {
  input: RollbackTopupInput
}

export type MutationSetAdminIpWhitelistEnabledArgs = {
  input: SetAdminIpWhitelistEnabledInput
}

export type MutationSetBulkRoleMenuPermissionsArgs = {
  input: BulkRoleMenuPermissionInput
}

export type MutationSetMerchantIpWhitelistEnabledArgs = {
  input: SetMerchantIpWhitelistEnabledInput
}

export type MutationSetPasswordByTokenArgs = {
  input: SetPasswordByTokenInput
}

export type MutationSetRoleMenuPermissionsArgs = {
  input: RoleMenuPermissionInput
}

export type MutationSetUserMenuPermissionsArgs = {
  input: UserMenuPermissionInput
}

export type MutationSignInArgs = {
  input: SignInInput
}

export type MutationSimulateOnrampFundingTransferFailedArgs = {
  failureType?: InputMaybe<Scalars['String']['input']>
  orderId: Scalars['String']['input']
}

export type MutationSimulateOnrampFundingTransferPaidArgs = {
  orderId: Scalars['String']['input']
}

export type MutationSimulateTopupDepositArgs = {
  requestId: Scalars['String']['input']
}

export type MutationStartChannelFundFlowSyncArgs = {
  input: StartChannelFundFlowSyncInput
}

export type MutationStartCryptoPayoutArgs = {
  input: StartCryptoPayoutInput
}

export type MutationStartOfframpArgs = {
  input: StartOfframpInput
}

export type MutationStartOnrampArgs = {
  input: StartOnrampInput
}

export type MutationSubmitTopupRequestEvidenceArgs = {
  input: SubmitTopupRequestEvidenceInput
}

export type MutationSubmitWalletAddressArgs = {
  input: SubmitWalletAddressInput
}

export type MutationSyncChannelFundFlowsArgs = {
  channelCode?: InputMaybe<Scalars['String']['input']>
}

export type MutationTestAccountBusinessArgs = {
  data: Scalars['JSON']['input']
  type: Scalars['String']['input']
}

export type MutationToggleMerchantApiKeyArgs = {
  id: Scalars['Int']['input']
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdateAmlAlertStatusArgs = {
  id: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  status: AmlAlertStatus
}

export type MutationUpdateChannelArgs = {
  input: UpdateChannelInput
}

export type MutationUpdateChannelCapabilityArgs = {
  input: UpdateChannelCapabilityInput
}

export type MutationUpdateCryptoRefundFeeArgs = {
  id: Scalars['Int']['input']
  input: UpdateCryptoRefundFeeInput
}

export type MutationUpdateCurrencyArgs = {
  input: UpdateCurrencyInput
}

export type MutationUpdateExceptionalTransferStatusArgs = {
  input: UpdateExceptionalTransferStatusInput
}

export type MutationUpdateExchangeRateArgs = {
  input: UpdateExchangeRateInput
}

export type MutationUpdateFeeSettingArgs = {
  input: FeeSettingUpdateInput
}

export type MutationUpdateMenuArgs = {
  input: UpdateMenuInput
}

export type MutationUpdateMerchantArgs = {
  input: UpdateMerchantInput
}

export type MutationUpdateMerchantCryptoRefundFeeArgs = {
  id: Scalars['Int']['input']
  input: UpdateCryptoRefundFeeInput
}

export type MutationUpdateMerchantExchangeMarginArgs = {
  id: Scalars['Int']['input']
  input: UpdateMerchantExchangeMarginInput
}

export type MutationUpdateMerchantFrequentRecipientArgs = {
  id: Scalars['Int']['input']
  input: UpdateMerchantFrequentRecipientInput
}

export type MutationUpdateMerchantPaymentMethodArgs = {
  input: UpdateMerchantPaymentMethodInput
}

export type MutationUpdateMerchantUserArgs = {
  input: UpdateMerchantUserInput
}

export type MutationUpdatePaymentGatewayArgs = {
  id: Scalars['Int']['input']
  input: UpdatePaymentGatewayInput
}

export type MutationUpdatePaymentGatewayStatusArgs = {
  id: Scalars['Int']['input']
  status: GatewayStatus
}

export type MutationUpdatePaymentMethodConfigArgs = {
  id: Scalars['Float']['input']
  input: UpdatePaymentMethodConfigInput
}

export type MutationUpdatePaymentMethodRoutingArgs = {
  id: Scalars['Int']['input']
  input: UpdatePaymentMethodRoutingInput
}

export type MutationUpdatePaymentRoutingArgs = {
  input: UpdatePaymentRoutingInput
}

export type MutationUpdatePgSettlementFeeArgs = {
  input: UpdatePgSettlementFeeInput
}

export type MutationUpdatePgSettlementTransferStatusArgs = {
  input: UpdatePgSettlementTransferStatusInput
}

export type MutationUpdateRefundLinkEmailArgs = {
  input: UpdateRefundLinkEmailInput
}

export type MutationUpdateRiskProviderStatusArgs = {
  id: Scalars['Int']['input']
  status: RiskProviderStatus
}

export type MutationUpdateRoutingPriorityArgs = {
  id: Scalars['Int']['input']
  priority: Scalars['Int']['input']
}

export type MutationUpdateSecurityPolicyArgs = {
  input: UpdateSecurityPolicyInput
}

export type MutationUpdateSystemSettingArgs = {
  input: UpdateSystemSettingInput
}

export type MutationUpdateSystemSettingsArgs = {
  inputs: Array<UpdateSystemSettingInput>
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateWithdrawalArgs = {
  id: Scalars['String']['input']
  input: UpdateWithdrawalInput
}

export type MutationUploadBatchCryptoPayoutArgs = {
  input: UploadBatchCryptoPayoutInput
}

export type MutationUpsertPgSettlementWalletConfigArgs = {
  input: UpsertPgSettlementWalletConfigInput
}

export type MutationVerifyLoginDeviceArgs = {
  input: VerifyLoginDeviceInput
}

export type MutationVerifyLoginTwoFactorArgs = {
  input: VerifyLoginTwoFactorInput
}

export type MutationVerifyMicroTransferCodeArgs = {
  input: VerifyMicroTransferCodeInput
}

/** 네트워크별 거래 내역 */
export type NetworkBreakdownItem = {
  __typename?: 'NetworkBreakdownItem'
  /** 거래 금액 */
  amount: Scalars['Float']['output']
  /** 거래 건수 */
  count: Scalars['Int']['output']
  /** 네트워크 이름 (예: Ethereum, Polygon, BSC) */
  network: Scalars['String']['output']
}

/** Offramp channel enum */
export enum OfframpChannel {
  AIRWALLEX = 'AIRWALLEX',
  COBO = 'COBO',
  HASHKEY = 'HASHKEY',
  PYVIO = 'PYVIO',
}

export type OfframpDetailResponse = {
  __typename?: 'OfframpDetailResponse'
  /** Offramp channel */
  channel?: Maybe<OfframpChannel>
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order ID */
  channelOrderId?: Maybe<Scalars['String']['output']>
  /** Completion timestamp */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** Failed reason */
  failedReason?: Maybe<Scalars['String']['output']>
  /** Fee amount */
  feeAmount?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  /** Merchant associated with the offramp */
  merchant?: Maybe<Merchant>
  /** Merchant ID */
  merchantId: Scalars['Int']['output']
  /** Metadata */
  metaData?: Maybe<Scalars['JSON']['output']>
  /** Net amount */
  netAmount?: Maybe<Scalars['Float']['output']>
  /** Offramp order number */
  orderId: Scalars['String']['output']
  /** Origin amount */
  originAmount: Scalars['Float']['output']
  /** Origin currency code */
  originCurrency: Scalars['String']['output']
  /** Processor user ID */
  processedBy?: Maybe<Scalars['Int']['output']>
  /** Processor name */
  processedByName?: Maybe<Scalars['String']['output']>
  /** Offramp status */
  status: OfframpStatus
  /** Target amount */
  targetAmount: Scalars['Float']['output']
  /** Target currency code */
  targetCurrency: Scalars['String']['output']
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output']
}

/** Offramp Excel export response */
export type OfframpExportResponse = {
  __typename?: 'OfframpExportResponse'
  downloadUrl?: Maybe<Scalars['String']['output']>
  jobId?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  /** Process type: IMMEDIATE or ASYNC */
  processType: Scalars['String']['output']
  /** Total record count */
  recordCount: Scalars['Int']['output']
}

export type OfframpListInput = {
  /** Offramp channel */
  channel?: InputMaybe<OfframpChannel>
  /** From date */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Excel email locale. Default: en */
  locale?: InputMaybe<EmailLocale>
  /** Merchant ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** Offramp order ID or channel order ID */
  orderId?: InputMaybe<Scalars['String']['input']>
  /** Offramp status */
  status?: InputMaybe<OfframpStatus>
  /** To date */
  toDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type OfframpPage = {
  __typename?: 'OfframpPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<OfframpResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 정체된 PYVIO 오프램프 대사 결과 */
export type OfframpReconciliationResult = {
  __typename?: 'OfframpReconciliationResult'
  completed: Scalars['Int']['output']
  errors: Array<Scalars['String']['output']>
  failed: Scalars['Int']['output']
  message: Scalars['String']['output']
  parked: Scalars['Int']['output']
  scanned: Scalars['Int']['output']
  stillProcessing: Scalars['Int']['output']
}

export type OfframpResponse = {
  __typename?: 'OfframpResponse'
  /** Offramp channel */
  channel?: Maybe<OfframpChannel>
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order ID */
  channelOrderId?: Maybe<Scalars['String']['output']>
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** Failed reason */
  failedReason?: Maybe<Scalars['String']['output']>
  /** Fee amount */
  feeAmount?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  /** Merchant associated with the offramp */
  merchant?: Maybe<Merchant>
  /** Merchant ID */
  merchantId: Scalars['Int']['output']
  /** Net amount */
  netAmount?: Maybe<Scalars['Float']['output']>
  /** Offramp order number */
  orderId: Scalars['String']['output']
  /** Origin amount */
  originAmount: Scalars['Float']['output']
  /** Origin currency code */
  originCurrency: Scalars['String']['output']
  /** Offramp status */
  status: OfframpStatus
  /** Target amount */
  targetAmount: Scalars['Float']['output']
  /** Target currency code */
  targetCurrency: Scalars['String']['output']
}

/** Offramp status enum */
export enum OfframpStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
}

export type OmitTopupInput = {
  id: Scalars['Int']['input']
  reason: Scalars['String']['input']
}

/** Onramp channel enum */
export enum OnrampChannel {
  AIRWALLEX = 'AIRWALLEX',
  COBO = 'COBO',
  HASHKEY = 'HASHKEY',
  PYVIO = 'PYVIO',
}

export type OnrampDetailResponse = {
  __typename?: 'OnrampDetailResponse'
  /** Onramp channel */
  channel?: Maybe<OnrampChannel>
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order ID */
  channelOrderId?: Maybe<Scalars['String']['output']>
  /** Completion timestamp */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** Failed reason */
  failedReason?: Maybe<Scalars['String']['output']>
  /** Fee amount */
  feeAmount?: Maybe<Scalars['Float']['output']>
  /** Funding source channel for this onramp (admin only) */
  fundingSource?: Maybe<Scalars['String']['output']>
  /** Funding transfer for this onramp (admin only) */
  fundingTransfer?: Maybe<OnrampFundingTransfer>
  id: Scalars['ID']['output']
  /** Merchant associated with the onramp */
  merchant?: Maybe<Merchant>
  /** Merchant ID */
  merchantId: Scalars['Int']['output']
  /** Metadata */
  metaData?: Maybe<Scalars['JSON']['output']>
  /** Net amount */
  netAmount?: Maybe<Scalars['Float']['output']>
  /** Onramp channel resolved from the channel route (admin only) */
  onrampChannel?: Maybe<Scalars['String']['output']>
  /** Onramp order number */
  orderId: Scalars['String']['output']
  /** Origin amount */
  originAmount: Scalars['Float']['output']
  /** Origin currency code */
  originCurrency: Scalars['String']['output']
  /** Processor user ID */
  processedBy?: Maybe<Scalars['Int']['output']>
  /** Processor name */
  processedByName?: Maybe<Scalars['String']['output']>
  /** Onramp status */
  status: OnrampStatus
  /** Target amount */
  targetAmount: Scalars['Float']['output']
  /** Target currency code */
  targetCurrency: Scalars['String']['output']
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output']
}

/** Onramp Excel export response */
export type OnrampExportResponse = {
  __typename?: 'OnrampExportResponse'
  downloadUrl?: Maybe<Scalars['String']['output']>
  jobId?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  /** Process type: IMMEDIATE or ASYNC */
  processType: Scalars['String']['output']
  /** Total record count */
  recordCount: Scalars['Int']['output']
}

export type OnrampFundingTransfer = {
  __typename?: 'OnrampFundingTransfer'
  canSimulate: Scalars['Boolean']['output']
  completedAt?: Maybe<Scalars['DateTime']['output']>
  completedBy?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<Scalars['String']['output']>
  destinationAddress?: Maybe<Scalars['String']['output']>
  destinationMemo?: Maybe<Scalars['String']['output']>
  errorCode?: Maybe<Scalars['String']['output']>
  errorMessage?: Maybe<Scalars['String']['output']>
  failedAt?: Maybe<Scalars['DateTime']['output']>
  feeAmount?: Maybe<Scalars['Float']['output']>
  feeCurrency?: Maybe<Scalars['String']['output']>
  gatewayCode?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  memo?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<Scalars['JSON']['output']>
  processedAt?: Maybe<Scalars['DateTime']['output']>
  providerRef?: Maybe<Scalars['String']['output']>
  requestedAmount?: Maybe<Scalars['Float']['output']>
  requestedAt: Scalars['DateTime']['output']
  requestedCurrency?: Maybe<Scalars['String']['output']>
  sourceAmount?: Maybe<Scalars['Float']['output']>
  sourceChannel: Scalars['String']['output']
  sourceCurrency?: Maybe<Scalars['String']['output']>
  status: ChannelTransferStatus
  succeededAt?: Maybe<Scalars['DateTime']['output']>
  targetAmount?: Maybe<Scalars['Float']['output']>
  targetChannel: Scalars['String']['output']
  targetCurrency?: Maybe<Scalars['String']['output']>
  transferId: Scalars['String']['output']
  txHash?: Maybe<Scalars['String']['output']>
  type: ChannelTransferType
  updatedAt: Scalars['DateTime']['output']
}

export type OnrampListInput = {
  /** Onramp channel */
  channel?: InputMaybe<OnrampChannel>
  /** From date */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>
  /** Excel email locale. Default: en */
  locale?: InputMaybe<EmailLocale>
  /** Merchant ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** Onramp order ID or channel order ID */
  orderId?: InputMaybe<Scalars['String']['input']>
  /** Onramp status */
  status?: InputMaybe<OnrampStatus>
  /** To date */
  toDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type OnrampPage = {
  __typename?: 'OnrampPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<OnrampResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type OnrampResponse = {
  __typename?: 'OnrampResponse'
  /** Onramp channel */
  channel?: Maybe<OnrampChannel>
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order ID */
  channelOrderId?: Maybe<Scalars['String']['output']>
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** Failed reason */
  failedReason?: Maybe<Scalars['String']['output']>
  /** Fee amount */
  feeAmount?: Maybe<Scalars['Float']['output']>
  /** Funding source channel for this onramp (admin only) */
  fundingSource?: Maybe<Scalars['String']['output']>
  /** Funding transfer for this onramp (admin only) */
  fundingTransfer?: Maybe<OnrampFundingTransfer>
  id: Scalars['ID']['output']
  /** Merchant associated with the onramp */
  merchant?: Maybe<Merchant>
  /** Merchant ID */
  merchantId: Scalars['Int']['output']
  /** Net amount */
  netAmount?: Maybe<Scalars['Float']['output']>
  /** Onramp order number */
  orderId: Scalars['String']['output']
  /** Origin amount */
  originAmount: Scalars['Float']['output']
  /** Origin currency code */
  originCurrency: Scalars['String']['output']
  /** Onramp status */
  status: OnrampStatus
  /** Target amount */
  targetAmount: Scalars['Float']['output']
  /** Target currency code */
  targetCurrency: Scalars['String']['output']
}

/** Onramp status enum */
export enum OnrampStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
}

export type PayableAmountResponse = {
  __typename?: 'PayableAmountResponse'
  /** Amount to be paid for the token */
  amount: Scalars['String']['output']
  /** token ID (e.g., ETH_USDT, TRON_USDT) */
  tokenId: Scalars['String']['output']
}

export type Payment = {
  __typename?: 'Payment'
  amount: Scalars['Float']['output']
  createdAt: Scalars['DateTime']['output']
  /** 통화 코드 (레거시, currencyId 사용 권장) */
  currency?: Maybe<Scalars['String']['output']>
  /** Currency 테이블 참조 ID */
  currencyId: Scalars['Int']['output']
  customerEmail?: Maybe<Scalars['String']['output']>
  customerId?: Maybe<Scalars['String']['output']>
  customerName?: Maybe<Scalars['String']['output']>
  customerPhone?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  expiresAt?: Maybe<Scalars['DateTime']['output']>
  failUrl?: Maybe<Scalars['String']['output']>
  gatewayFeeAmount?: Maybe<Scalars['Float']['output']>
  gatewayOrderId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastRefundedAt?: Maybe<Scalars['DateTime']['output']>
  /** 결제를 요청한 가맹점 정보 */
  merchant?: Maybe<Merchant>
  merchantId: Scalars['Int']['output']
  /** 가맹점 주문 ID */
  merchantOrderId: Scalars['String']['output']
  /** 사용된 가맹점 결제 수단 정보 */
  merchantPaymentMethod?: Maybe<MerchantPaymentMethod>
  merchantPaymentMethodId: Scalars['Int']['output']
  metadata?: Maybe<Scalars['JSON']['output']>
  netAmount: Scalars['Float']['output']
  network?: Maybe<Scalars['String']['output']>
  orderName?: Maybe<Scalars['String']['output']>
  ourFeeAmount: Scalars['Float']['output']
  paidAmount: Scalars['Float']['output']
  paidAt?: Maybe<Scalars['DateTime']['output']>
  payableAmount?: Maybe<Scalars['Float']['output']>
  payableCurrency?: Maybe<Scalars['String']['output']>
  /** 실제 결제 Currency 테이블 참조 ID */
  payableCurrencyId?: Maybe<Scalars['Int']['output']>
  /** 실제 결제 네트워크 (Currency 테이블에서 resolve) */
  payableNetwork?: Maybe<Scalars['String']['output']>
  /** PG사에 전달하는 결제 키 (내부용) */
  paymentKey?: Maybe<Scalars['String']['output']>
  paymentMethod: PaymentMethod
  /** 결제 유형 */
  paymentType: PaymentType
  pendingRefundApprovalAmount: Scalars['String']['output']
  /** 결제에 연결된 환불링크 목록 */
  refundLinks?: Maybe<Array<RefundLink>>
  refundedAmount: Scalars['Float']['output']
  selectedGatewayId?: Maybe<Scalars['Int']['output']>
  status: PaymentStatus
  successUrl?: Maybe<Scalars['String']['output']>
  totalFeeAmount: Scalars['Float']['output']
  /** 결제와 관련된 모든 거래 내역 (결제, 취소, 환불 등) */
  transactions?: Maybe<Array<Transaction>>
  updatedAt: Scalars['DateTime']['output']
  webhookUrl?: Maybe<Scalars['String']['output']>
}

export type PaymentAdjustment = {
  __typename?: 'PaymentAdjustment'
  /** 실제 입금 통화 코드 */
  actualCurrency?: Maybe<Scalars['String']['output']>
  actualCurrencyId: Scalars['Int']['output']
  /** 실제 입금 금액 */
  actualReceivedAmount: Scalars['Float']['output']
  createdAt: Scalars['DateTime']['output']
  decidedAt?: Maybe<Scalars['DateTime']['output']>
  decidedByApiKeyId?: Maybe<Scalars['Int']['output']>
  decidedByUserId?: Maybe<Scalars['Int']['output']>
  decision: AdjustmentDecision
  decisionSource?: Maybe<DecisionSource>
  /** 수락 시 확정 금액 */
  finalAmount?: Maybe<Scalars['Float']['output']>
  /** 확정 통화 코드 */
  finalCurrency?: Maybe<Scalars['String']['output']>
  finalCurrencyId?: Maybe<Scalars['Int']['output']>
  /** 수락 시점 FX */
  fxRateSnapshotFinal?: Maybe<Scalars['Float']['output']>
  /** HOLDING 진입 시점 FX */
  fxRateSnapshotInit?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  merchantId: Scalars['Int']['output']
  /** 원본 주문 금액 */
  originalAmount: Scalars['Float']['output']
  /** 원본 주문 통화 코드 */
  originalCurrency?: Maybe<Scalars['String']['output']>
  originalCurrencyId: Scalars['Int']['output']
  /** 결제 생성 시 청구된 크립토 양 (원본 청구값) */
  originalPayableAmount?: Maybe<Scalars['Float']['output']>
  /** 청구 크립토 통화 코드 */
  originalPayableCurrency?: Maybe<Scalars['String']['output']>
  originalPayableCurrencyId?: Maybe<Scalars['Int']['output']>
  paymentId: Scalars['String']['output']
  reason: AdjustmentReason
  rejectReason?: Maybe<Scalars['String']['output']>
  transactionId: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type PaymentAdjustmentFilterInput = {
  /** 결정 상태 필터 */
  decision?: InputMaybe<AdjustmentDecision>
  /** 종료 날짜 */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 가맹점 ID (ADMIN 전용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 결제 ID */
  paymentId?: InputMaybe<Scalars['String']['input']>
  /** 조정 사유 필터 */
  reason?: InputMaybe<AdjustmentReason>
  /** 시작 날짜 */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type PaymentAdjustmentList = {
  __typename?: 'PaymentAdjustmentList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<PaymentAdjustment>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type PaymentExportResponse = {
  __typename?: 'PaymentExportResponse'
  /** 즉시 다운로드 URL (1000건 이하) */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** 비동기 작업 ID (1000건 초과) */
  jobId?: Maybe<Scalars['String']['output']>
  /** 안내 메시지 */
  message?: Maybe<Scalars['String']['output']>
  /** 처리 방식: IMMEDIATE 또는 ASYNC */
  processType: Scalars['String']['output']
  /** 총 레코드 수 */
  recordCount: Scalars['Int']['output']
}

export type PaymentFilterInput = {
  /** 종료일 */
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 엑셀 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 가맹점 ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 결제 수단 */
  paymentMethod?: InputMaybe<PaymentMethod>
  /** 결제 유형 */
  paymentType?: InputMaybe<PaymentType>
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>
  /** 검색 영역 */
  searchField?: InputMaybe<PaymentSearchField>
  /** 시작일 */
  startDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 결제 상태 */
  status?: InputMaybe<PaymentStatus>
}

export type PaymentGateway = {
  __typename?: 'PaymentGateway'
  apiVersion?: Maybe<Scalars['String']['output']>
  /** 기본 수수료율 */
  baseFeeRate?: Maybe<Scalars['Float']['output']>
  baseUrl?: Maybe<Scalars['String']['output']>
  code: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  /** 최대 결제금액 */
  maxAmount?: Maybe<Scalars['Int']['output']>
  /** 최소 결제금액 */
  minAmount?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  /** 정산 주기(일) */
  settlementCycle?: Maybe<Scalars['Int']['output']>
  status?: Maybe<GatewayStatus>
  /** 지원 통화 */
  supportedCurrencies?: Maybe<Array<Scalars['String']['output']>>
  /** 지원 결제수단 */
  supportedMethods?: Maybe<Array<PaymentMethod>>
  /** 즉시 정산 지원 여부 */
  supportsInstantSettlement?: Maybe<Scalars['Boolean']['output']>
  /** 부분 환불 지원 여부 */
  supportsPartialRefund?: Maybe<Scalars['Boolean']['output']>
  /** 정기결제 지원 여부 */
  supportsRecurring?: Maybe<Scalars['Boolean']['output']>
  /** 웹훅 지원 여부 */
  supportsWebhook?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PaymentGatewayFilterInput = {
  /** PG사 코드로 검색 */
  code?: InputMaybe<Scalars['String']['input']>
  /** PG사 상태로 필터링 */
  status?: InputMaybe<GatewayStatus>
  /** 특정 통화 지원 여부 */
  supportedCurrency?: InputMaybe<Scalars['String']['input']>
  /** 특정 결제 수단 지원 여부 */
  supportedMethod?: InputMaybe<PaymentMethod>
  /** 즉시 정산 지원 여부로 필터링 */
  supportsInstantSettlement?: InputMaybe<Scalars['Boolean']['input']>
  /** 부분 환불 지원 여부로 필터링 */
  supportsPartialRefund?: InputMaybe<Scalars['Boolean']['input']>
  /** 정기 결제 지원 여부로 필터링 */
  supportsRecurring?: InputMaybe<Scalars['Boolean']['input']>
  /** 웹훅 지원 여부로 필터링 */
  supportsWebhook?: InputMaybe<Scalars['Boolean']['input']>
}

export type PaymentGatewayList = {
  __typename?: 'PaymentGatewayList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<PaymentGateway>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type PaymentList = {
  __typename?: 'PaymentList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<Payment>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 결제 수단 */
export enum PaymentMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CARD = 'CARD',
  CRYPTO = 'CRYPTO',
  E_WALLET = 'E_WALLET',
  MOBILE = 'MOBILE',
  QR_CODE = 'QR_CODE',
  VIRTUAL_ACCOUNT = 'VIRTUAL_ACCOUNT',
}

export type PaymentMethodConfig = {
  __typename?: 'PaymentMethodConfig'
  createdAt: Scalars['DateTime']['output']
  defaultMaxAmount?: Maybe<Scalars['Int']['output']>
  defaultMinAmount?: Maybe<Scalars['Int']['output']>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  isEnabled: Scalars['Boolean']['output']
  metadata?: Maybe<Scalars['JSON']['output']>
  paymentMethod: PaymentMethod
  priority: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type PaymentMethodConfigFilterInput = {
  /** 활성화 여부 */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** 결제 수단 */
  paymentMethod?: InputMaybe<PaymentMethod>
}

export type PaymentMethodConfigList = {
  __typename?: 'PaymentMethodConfigList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<PaymentMethodConfig>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type PaymentMethodRouting = {
  __typename?: 'PaymentMethodRouting'
  /** 가용성 (0.0 - 1.0) */
  availability?: Maybe<Scalars['Float']['output']>
  /** 평균 응답시간 (ms) */
  avgResponseTime?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  /** The payment gateway for this routing */
  gateway?: Maybe<PaymentGateway>
  gatewayId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  /** 활성 상태 */
  isActive: Scalars['Boolean']['output']
  /** 기본 라우팅 여부 */
  isDefault: Scalars['Boolean']['output']
  paymentMethod: PaymentMethod
  /** 우선순위 (높을수록 선호) */
  priority: Scalars['Int']['output']
  /** 성공률 (0.0 - 1.0) */
  successRate?: Maybe<Scalars['Float']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type PaymentMethodRoutingFilterInput = {
  /** PG사 ID로 필터링 */
  gatewayId?: InputMaybe<Scalars['Int']['input']>
  /** 활성 상태로 필터링 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 기본 라우팅 여부로 필터링 */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** 결제 수단으로 필터링 */
  paymentMethod?: InputMaybe<PaymentMethod>
}

export type PaymentMethodRoutingList = {
  __typename?: 'PaymentMethodRoutingList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<PaymentMethodRouting>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 결제수단 검색 필드 */
export enum PaymentMethodSearchField {
  ALL = 'ALL',
  MID = 'MID',
  NAME = 'NAME',
}

export type PaymentNextAction = {
  __typename?: 'PaymentNextAction'
  data?: Maybe<Scalars['JSON']['output']>
  depositInfo?: Maybe<CryptoAddressInfo>
  redirectUrl?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

/** 결제 검색 필드 */
export enum PaymentSearchField {
  ALL = 'ALL',
  GRIP_ORDER_ID = 'GRIP_ORDER_ID',
  MERCHANT_ORDER_ID = 'MERCHANT_ORDER_ID',
  MID = 'MID',
}

/** 결제 통계 */
export type PaymentStats = {
  __typename?: 'PaymentStats'
  /** 평균 결제 금액 */
  paymentAvgAmount?: Maybe<Scalars['Float']['output']>
  /** 총 결제 건수 */
  paymentCount: Scalars['Int']['output']
  /** 결제 실패 건수 */
  paymentFailedCount: Scalars['Int']['output']
  /** 결제 대기 건수 */
  paymentPendingCount: Scalars['Int']['output']
  /** 결제 성공 금액 */
  paymentSuccessAmount: Scalars['Float']['output']
  /** 결제 성공 건수 */
  paymentSuccessCount: Scalars['Int']['output']
  /** 결제 성공률 (%) */
  paymentSuccessRate?: Maybe<Scalars['Float']['output']>
  /** 총 결제 금액 */
  paymentTotalAmount: Scalars['Float']['output']
}

/** 결제 상태 */
export enum PaymentStatus {
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  HOLDING = 'HOLDING',
  OVER_PAID = 'OVER_PAID',
  PAID = 'PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PARTIAL_CANCELLED = 'PARTIAL_CANCELLED',
  PARTIAL_REFUNDED = 'PARTIAL_REFUNDED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  REFUNDED = 'REFUNDED',
}

export type PaymentStatusUpdate = {
  __typename?: 'PaymentStatusUpdate'
  crypto?: Maybe<CryptoStatusInfo>
  failureReason?: Maybe<Scalars['String']['output']>
  paymentId: Scalars['String']['output']
  status: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

/** 결제 유형 */
export enum PaymentType {
  CHECKOUT = 'CHECKOUT',
  DIRECT = 'DIRECT',
  TOPUP = 'TOPUP',
}

/** 지급 디스패치 단건 재확인 결과 */
export enum PayoutDispatchRecheckOutcome {
  LOOKUP_FAILED = 'LOOKUP_FAILED',
  MARKED_UNCERTAIN = 'MARKED_UNCERTAIN',
  RESOLVED = 'RESOLVED',
  SKIPPED = 'SKIPPED',
}

export type PayoutDispatchRecheckResultModel = {
  __typename?: 'PayoutDispatchRecheckResultModel'
  message: Scalars['String']['output']
  outcome: PayoutDispatchRecheckOutcome
}

/** 페이아웃 통계 (집계값) */
export type PayoutStats = {
  __typename?: 'PayoutStats'
  /** 성공 페이아웃 평균 금액 */
  payoutAvgAmount: Scalars['Float']['output']
  /** 채널(COBO/PYVIO) 비용 합 (성공건만) */
  payoutChannelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** 전체 페이아웃 건수 (성공+실패) */
  payoutCount: Scalars['Int']['output']
  /** 실패 (FAILED) 건수 */
  payoutFailedCount: Scalars['Int']['output']
  /** 우리 수수료 합 (성공건만) */
  payoutFeeAmount: Scalars['Float']['output']
  /** 성공 페이아웃 금액 합 */
  payoutSuccessAmount: Scalars['Float']['output']
  /** 성공 (COMPLETED) 건수 */
  payoutSuccessCount: Scalars['Int']['output']
  /** 성공률 (%) */
  payoutSuccessRate: Scalars['Float']['output']
}

/** 대시보드 페이아웃 요약 (백엔드 집계) */
export type PayoutSummary = {
  __typename?: 'PayoutSummary'
  /** 채널별 페이아웃 분포 */
  channelBreakdown: Array<ChannelBreakdownItem>
  /** 시간별 페이아웃 분포 (선택한 타임존 기준 0-23시) */
  hourlyBreakdown: Array<HourlyPayoutBreakdownItem>
  /** 네트워크별 페이아웃 분포 */
  networkBreakdown: Array<NetworkBreakdownItem>
  /** 페이아웃 통계 */
  payoutStats: PayoutStats
  /** 토큰별 페이아웃 분포 */
  tokenBreakdown: Array<TokenBreakdownItem>
  /** 토큰×네트워크 조합별 페이아웃 분포 */
  tokenNetworkBreakdown: Array<TokenNetworkBreakdownItem>
}

/** 미확인 PG 지급 디스패치 대사 결과 */
export type PgDispatchReconciliationResult = {
  __typename?: 'PgDispatchReconciliationResult'
  errors: Array<Scalars['String']['output']>
  markedUncertain: Scalars['Int']['output']
  markedUnsent: Scalars['Int']['output']
  message: Scalars['String']['output']
  resolved: Scalars['Int']['output']
  scanned: Scalars['Int']['output']
  skipped: Scalars['Int']['output']
}

/** PG 정산 이벤트 (기존 SettlementEvent) */
export type PgSettlementEventModel = {
  __typename?: 'PgSettlementEventModel'
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output']
  /** 생성자 */
  createdBy?: Maybe<Scalars['String']['output']>
  /** 설명 */
  description?: Maybe<Scalars['String']['output']>
  /** 이벤트 소스 */
  eventSource: Scalars['String']['output']
  /** 이벤트 타입 */
  eventType: PgSettlementEventType
  /** 이벤트 ID */
  id: Scalars['String']['output']
  /** 메타데이터 */
  metadata?: Maybe<Scalars['JSON']['output']>
  /** 새 상태 */
  newStatus?: Maybe<Scalars['String']['output']>
  /** 발생일시 */
  occurredAt: Scalars['DateTime']['output']
  /** PG 정산 ID */
  pgSettlementId?: Maybe<Scalars['String']['output']>
  /** PG 정산금 이체 요청 ID */
  pgSettlementTransferId?: Maybe<Scalars['String']['output']>
  /** 이전 상태 */
  previousStatus?: Maybe<Scalars['String']['output']>
  /** 제목 */
  title: Scalars['String']['output']
}

/** PG 정산 이벤트 타입 */
export enum PgSettlementEventType {
  /** 에러 발생 */
  ERROR_OCCURRED = 'ERROR_OCCURRED',
  /** 수동 업데이트 */
  MANUAL_UPDATE = 'MANUAL_UPDATE',
  /** 메모 추가 */
  NOTE_ADDED = 'NOTE_ADDED',
  /** 정산 완료 */
  SETTLEMENT_COMPLETED = 'SETTLEMENT_COMPLETED',
  /** 정산 생성됨 */
  SETTLEMENT_CREATED = 'SETTLEMENT_CREATED',
  /** 정산 실패 */
  SETTLEMENT_FAILED = 'SETTLEMENT_FAILED',
  /** 정산 부분 완료 */
  SETTLEMENT_PARTIALLY_COMPLETED = 'SETTLEMENT_PARTIALLY_COMPLETED',
  /** 정산 처리중 */
  SETTLEMENT_PROCESSING = 'SETTLEMENT_PROCESSING',
  /** 정산 제출됨 */
  SETTLEMENT_SUBMITTED = 'SETTLEMENT_SUBMITTED',
  /** 이체 컨펌 대기 */
  TRANSFER_AWAITING_CONFIRM = 'TRANSFER_AWAITING_CONFIRM',
  /** 이체 취소 */
  TRANSFER_CANCELLED = 'TRANSFER_CANCELLED',
  /** 이체 완료 */
  TRANSFER_COMPLETED = 'TRANSFER_COMPLETED',
  /** 이체 생성됨 */
  TRANSFER_CREATED = 'TRANSFER_CREATED',
  /** 이체 실패 */
  TRANSFER_FAILED = 'TRANSFER_FAILED',
  /** 이체 처리중 */
  TRANSFER_PROCESSING = 'TRANSFER_PROCESSING',
  /** 이체 제출됨 */
  TRANSFER_SUBMITTED = 'TRANSFER_SUBMITTED',
}

/** PG 정산 수수료 기록 (기존 SettlementFeeRecord) */
export type PgSettlementFeeModel = {
  __typename?: 'PgSettlementFeeModel'
  /** 수수료 금액 */
  amount: Scalars['Float']['output']
  /** 블록 번호 */
  blockNumber?: Maybe<Scalars['Int']['output']>
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output']
  /** 통화 */
  currency?: Maybe<Scalars['String']['output']>
  /** 설명 */
  description?: Maybe<Scalars['String']['output']>
  /** 수수료 유형 */
  feeType: FeeType
  /** 수수료 기록 ID */
  id: Scalars['String']['output']
  /** 추가 메타데이터 */
  metadata?: Maybe<Scalars['JSON']['output']>
  /** 정산 항목 ID */
  pgSettlementItemId: Scalars['String']['output']
  /** 트랜잭션 해시 */
  txHash?: Maybe<Scalars['String']['output']>
}

/** PG 정산 항목 (토큰/통화별) (기존 SettlementItem) */
export type PgSettlementItemModel = {
  __typename?: 'PgSettlementItemModel'
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output']
  /** 수수료 기록 목록 */
  feeRecords?: Maybe<Array<PgSettlementFeeModel>>
  /** 정산 항목 ID */
  id: Scalars['String']['output']
  /** 메모 */
  notes?: Maybe<Scalars['String']['output']>
  /** 주문 통화 코드 (USD, KRW 등) - 히스토리 추적용 */
  orderCurrencyCode?: Maybe<Scalars['String']['output']>
  /** 실제 결제(크립토) 통화 코드 (TRON_USDT, ETH_USDT 등) */
  payableCurrencyCode: Scalars['String']['output']
  /** PG 정산 ID */
  pgSettlementId: Scalars['String']['output']
  /** PG 정산 참조 ID */
  pgSettlementRef?: Maybe<Scalars['String']['output']>
  /** 요청 금액 */
  requestedAmount: Scalars['Float']['output']
  /** 정산 금액 */
  settledAmount?: Maybe<Scalars['Float']['output']>
  /** 상태 */
  status: PgSettlementItemStatus
  /** 트랜잭션 수 */
  transactionCount?: Maybe<Scalars['Int']['output']>
  /** 이체 요청 목록 */
  transfers: Array<PgSettlementTransferModel>
  /** 트랜잭션 해시 */
  txHash?: Maybe<Scalars['String']['output']>
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output']
}

/** PG 정산 항목 상태 */
export enum PgSettlementItemStatus {
  /** 완료 */
  COMPLETED = 'COMPLETED',
  /** 실패 */
  FAILED = 'FAILED',
  /** 대기중 */
  PENDING = 'PENDING',
  /** 이체 처리중 */
  PROCESSING = 'PROCESSING',
  /** PG에서 정산됨 */
  SETTLED = 'SETTLED',
}

/** PG 정산 목록 응답 */
export type PgSettlementListModel = {
  __typename?: 'PgSettlementListModel'
  hasNext: Scalars['Boolean']['output']
  hasPrev: Scalars['Boolean']['output']
  items: Array<PgSettlementModel>
  limit: Scalars['Int']['output']
  page: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

/** PG 정산 (기존 SettlementBatch) */
export type PgSettlementModel = {
  __typename?: 'PgSettlementModel'
  /** 배치 ID (외부 참조용) */
  batchId: Scalars['String']['output']
  /** 완료일시 */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output']
  /** 통화 (대표 통화 - 표시용) */
  currency: Scalars['String']['output']
  /** 정산 기간 시작일 */
  dateFrom: Scalars['DateTime']['output']
  /** 정산 기간 종료일 */
  dateTo: Scalars['DateTime']['output']
  /** 에러 코드 */
  errorCode?: Maybe<Scalars['String']['output']>
  /** 에러 메시지 */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** 이벤트 목록 */
  events?: Maybe<Array<PgSettlementEventModel>>
  /** PG사 정보 */
  gateway?: Maybe<PaymentGateway>
  /** Gateway ID */
  gatewayId: Scalars['Int']['output']
  /** PG 정산 ID */
  id: Scalars['String']['output']
  /** 항목 수 */
  itemCount: Scalars['Int']['output']
  /** 정산 항목 목록 */
  items: Array<PgSettlementItemModel>
  /** 요청일시 */
  requestedAt: Scalars['DateTime']['output']
  /** 정산 방식 (CRYPTO: 크립토 지갑 출금, FIAT: 법정화폐 출금) */
  settlementType: PgSettlementType
  /** 상태 */
  status: PgSettlementStatus
  /** 제출일시 */
  submittedAt?: Maybe<Scalars['DateTime']['output']>
  /** 타임라인 */
  timeline: PgSettlementTimelineModel
  /** 트리거 정보 (SCHEDULER, MANUAL:user@email) */
  triggeredBy?: Maybe<Scalars['String']['output']>
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output']
}

/** PG 정산 처리된 기간 */
export type PgSettlementPeriodModel = {
  __typename?: 'PgSettlementPeriodModel'
  /** 정산 기간 시작일 */
  dateFrom: Scalars['DateTime']['output']
  /** 정산 기간 종료일 */
  dateTo: Scalars['DateTime']['output']
  /** 정산 상태 */
  status: PgSettlementStatus
}

/** PG 정산 프리뷰 조회 입력 */
export type PgSettlementPreviewInput = {
  /** 시작일 (UTC) */
  dateFrom: Scalars['DateTime']['input']
  /** 종료일 (UTC) */
  dateTo: Scalars['DateTime']['input']
  /** Gateway 코드 (cobo 등) - 미지정시 전체 조회 */
  gatewayCode?: InputMaybe<Scalars['String']['input']>
}

/** PG 정산 프리뷰 항목 */
export type PgSettlementPreviewItemModel = {
  __typename?: 'PgSettlementPreviewItemModel'
  /** Gateway 코드 */
  gatewayCode: Scalars['String']['output']
  /** Gateway ID */
  gatewayId: Scalars['Int']['output']
  /** Gateway 이름 */
  gatewayName: Scalars['String']['output']
  /** 주문 통화 코드 (예: KRW, USD) */
  orderCurrencyCode: Scalars['String']['output']
  /** 주문 통화 Currency ID */
  orderCurrencyId: Scalars['Int']['output']
  /** 원래 주문 금액 순 정산 금액 */
  originalNetAmount: Scalars['Float']['output']
  /** 원래 주문 금액 결제 합계 (amount) */
  originalPaymentAmount: Scalars['Float']['output']
  /** 원래 주문 금액 환불 합계 */
  originalRefundAmount: Scalars['Float']['output']
  /** 실제 결제 통화 코드 (예: TRON_USDT) */
  payableCurrencyCode: Scalars['String']['output']
  /** 실제 결제 통화 ID (크립토) */
  payableCurrencyId: Scalars['Int']['output']
  /** 실제 결제 통화/토큰 이름 */
  payableCurrencyName: Scalars['String']['output']
  /** 크립토 순 정산 금액 */
  payableNetAmount: Scalars['Float']['output']
  /** 크립토 결제 금액 합계 (payableAmount) */
  payablePaymentAmount: Scalars['Float']['output']
  /** 크립토 환불 금액 합계 */
  payableRefundAmount: Scalars['Float']['output']
  /** 결제 건수 */
  paymentCount: Scalars['Int']['output']
  /** 환불 건수 */
  refundCount: Scalars['Int']['output']
  /** 총 거래 건수 */
  totalTransactionCount: Scalars['Int']['output']
}

/** PG 정산 프리뷰 결과 */
export type PgSettlementPreviewModel = {
  __typename?: 'PgSettlementPreviewModel'
  /** 시작일 */
  dateFrom: Scalars['DateTime']['output']
  /** 종료일 */
  dateTo: Scalars['DateTime']['output']
  /** 프리뷰 항목 목록 */
  items: Array<PgSettlementPreviewItemModel>
  /** 총 항목 수 */
  totalItems: Scalars['Int']['output']
}

/** PG 정산 상태 */
export enum PgSettlementStatus {
  /** 취소 */
  CANCELLED = 'CANCELLED',
  /** 완료 */
  COMPLETED = 'COMPLETED',
  /** 실패 */
  FAILED = 'FAILED',
  /** 부분 완료 */
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
  /** 대기중 */
  PENDING = 'PENDING',
  /** 처리중 */
  PROCESSING = 'PROCESSING',
  /** 제출됨 */
  SUBMITTED = 'SUBMITTED',
}

/** PG 정산 타임라인 */
export type PgSettlementTimelineModel = {
  __typename?: 'PgSettlementTimelineModel'
  events: Array<PgSettlementEventModel>
  totalCount: Scalars['Float']['output']
}

/** PG 정산금 이체 요청 (기존 PayoutRequest) */
export type PgSettlementTransferModel = {
  __typename?: 'PgSettlementTransferModel'
  /** 블록 번호 */
  blockNumber?: Maybe<Scalars['Int']['output']>
  /** 완료일시 */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output']
  /** 목적지 채널 코드 */
  destChannelCode?: Maybe<Scalars['String']['output']>
  /** 목적지 ID */
  destinationId?: Maybe<Scalars['String']['output']>
  /** 목적지 상세 정보 */
  destinationInfo?: Maybe<Scalars['JSON']['output']>
  /** 목적지 유형 */
  destinationType: DestinationType
  /** 에러 코드 */
  errorCode?: Maybe<Scalars['String']['output']>
  /** 에러 메시지 */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** 이벤트 목록 */
  events?: Maybe<Array<PgSettlementEventModel>>
  /** 환율 */
  exchangeRate?: Maybe<Scalars['Float']['output']>
  /** 이체 요청 ID */
  id: Scalars['String']['output']
  /** 메모 */
  notes?: Maybe<Scalars['String']['output']>
  /** 정산 항목 ID */
  pgSettlementItemId: Scalars['String']['output']
  /** 처리일시 */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** PG 응답의 참조 ID */
  providerRef?: Maybe<Scalars['String']['output']>
  /** Provider 요청 */
  providerRequest?: Maybe<Scalars['JSON']['output']>
  /** Provider 응답 */
  providerResponse?: Maybe<Scalars['JSON']['output']>
  /** 수령 금액 */
  receivedAmount?: Maybe<Scalars['Float']['output']>
  /** 수령 통화 */
  receivedCurrency?: Maybe<Scalars['String']['output']>
  /** 요청 ID (외부 참조용) */
  requestId: Scalars['String']['output']
  /** 요청일시 */
  requestedAt: Scalars['DateTime']['output']
  /** 재시도 횟수 */
  retryCount: Scalars['Int']['output']
  /** 이체 금액 */
  sourceAmount: Scalars['Float']['output']
  /** 소스 채널 코드 */
  sourceChannelCode?: Maybe<Scalars['String']['output']>
  /** 이체 통화 */
  sourceCurrency: Scalars['String']['output']
  /** 이체 네트워크 (크립토인 경우) */
  sourceNetwork?: Maybe<Scalars['String']['output']>
  /** 상태 */
  status: PgSettlementTransferStatus
  /** 제출일시 */
  submittedAt?: Maybe<Scalars['DateTime']['output']>
  /** 변환 목표 금액 */
  targetAmount?: Maybe<Scalars['Float']['output']>
  /** 변환 목표 통화 */
  targetCurrency?: Maybe<Scalars['String']['output']>
  /** 이체 유형 */
  transferType: TransferType
  /** 트랜잭션 해시 */
  txHash?: Maybe<Scalars['String']['output']>
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output']
}

/** PG 정산금 이체 상태 */
export enum PgSettlementTransferStatus {
  /** 컨펌 대기 */
  AWAITING_CONFIRM = 'AWAITING_CONFIRM',
  /** 취소 */
  CANCELLED = 'CANCELLED',
  /** 완료 */
  COMPLETED = 'COMPLETED',
  /** 실패 */
  FAILED = 'FAILED',
  /** 대기중 */
  PENDING = 'PENDING',
  /** 처리중 */
  PROCESSING = 'PROCESSING',
  /** 제출됨 */
  SUBMITTED = 'SUBMITTED',
}

/** PG 정산 방식 */
export enum PgSettlementType {
  /** 크립토 지갑 출금 */
  CRYPTO = 'CRYPTO',
  /** 법정화폐 출금 (오프램프) */
  FIAT = 'FIAT',
}

/** PG 정산 수령 지갑 설정. PG사+토큰 조합에 매칭되어 정산 이체 시 목적지 지갑으로 자동 지정됩니다. */
export type PgSettlementWalletConfigModel = {
  __typename?: 'PgSettlementWalletConfigModel'
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output']
  /** 생성자 ID */
  createdBy?: Maybe<Scalars['Int']['output']>
  /** 통화 코드 (TRON_USDT, ETH_USDT 등) */
  currencyCode: Scalars['String']['output']
  /** Currency ID (Currency 테이블 FK) */
  currencyId: Scalars['Int']['output']
  /** Gateway 코드 (COBO, BINANCE 등) */
  gatewayCode: Scalars['String']['output']
  /** Gateway ID */
  gatewayId: Scalars['Int']['output']
  /** Gateway 이름 */
  gatewayName: Scalars['String']['output']
  /** 지갑 설정 ID */
  id: Scalars['String']['output']
  /** 활성화 여부 */
  isActive: Scalars['Boolean']['output']
  /** 네트워크 (TRON, ETH 등) */
  network?: Maybe<Scalars['String']['output']>
  /** 이 지갑이 속한 회계 채널 코드. 이체 완료 시 해당 채널로 내부 회계 분개가 기록됩니다. */
  targetChannelCode?: Maybe<Scalars['String']['output']>
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output']
  /** 이체 대상 지갑 주소 */
  walletAddress: Scalars['String']['output']
  /** 지갑 메모 (일부 체인에 필요) */
  walletMemo?: Maybe<Scalars['String']['output']>
}

/** 출금 처리 입력 */
export type ProcessWithdrawalInput = {
  /** 처리 메모 */
  processingNote?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
  /** 출금 요청 ID */
  withdrawalId: Scalars['String']['input']
}

export type Query = {
  __typename?: 'Query'
  /** 내부 회계 분개에 사용 가능한 채널 목록 */
  accountingChannels: Array<AccountingChannelResponse>
  /** 활성화된 통화 목록 조회 (페이지네이션 없음) */
  activeCurrencies: Array<Currency>
  /** Safety Withdraw 재개용 — 미검증 주소의 진행 중(활성·미만료) 검증 송금 조회. 없으면 null. */
  activeMicroTransfer?: Maybe<MicroTransferModel>
  /** 활성 PG사 목록 조회 */
  activePaymentGateways: Array<PaymentGateway>
  /** 어드민 IP 화이트리스트 상태 + 현재 접속 IP */
  adminIpWhitelist: IpWhitelistStatusModel
  /** 전체 메뉴 조회 (관리자용) */
  allMenus: Array<Menu>
  /** AML 알림 단건 조회 */
  amlAlert?: Maybe<AmlAlertModel>
  /** AML 알림 목록 조회 (페이지네이션) */
  amlAlerts: AmlAlertListModel
  /** AML 스크리닝 결과 단건 조회 */
  amlScreeningResult?: Maybe<AmlScreeningResultModel>
  /** AML 스크리닝 결과 목록 조회 (페이지네이션) */
  amlScreeningResults: AmlScreeningResultListModel
  /** 결제 ID로 AML 스크리닝 결과 목록 조회 */
  amlScreeningResultsByPayment: Array<AmlScreeningResultModel>
  approvalTodoList: ApprovalTodoList
  approvalTodoSummary: ApprovalTodoSummary
  /** 자동환불 목록 조회 */
  autoRefunds: AutoRefundList
  /** 가맹점 사용자에게 할당 가능한 메뉴 목록 */
  availableMenusForMerchantUser: Array<Menu>
  availablePaymentMethods: Array<MerchantAvailablePaymentMethod>
  /** Query a crypto payout batch by ID */
  batchCryptoPayout: BatchCryptoPayoutResponse
  /** 가맹점 수취인 목록 (활성) */
  beneficiaries: Array<BeneficiaryModel>
  /** 코드로 채널 조회 */
  channel: Channel
  channelBalance: ChannelBalance
  channelFundFlowSyncRuns: Array<ChannelFundFlowSyncRun>
  /** 채널 자금 흐름 조회 */
  channelFundFlows: ChannelFundFlowList
  /** Get paginated channel routes */
  channelRoutes: ChannelRouteList
  /** 채널의 충전 입금 계좌 목록 조회 */
  channelTopupAccounts: Array<ChannelTopupAccount>
  channelTransfer: ChannelTransferModel
  channelTransfers: ChannelTransferPage
  /** 채널 목록 조회 */
  channels: ChannelList
  /** 스케줄러 실행 중 여부 확인 */
  checkSchedulerRunning: Scalars['Boolean']['output']
  /** Get checkout session details by session ID */
  checkoutSession: CheckoutSession
  /** Get checkout session status by session ID */
  checkoutSessionStatus: CheckoutSessionStatus
  /** Get Cobo order link for crypto payment checkout session */
  coboOrderLink: CoboOrderLinkResponse
  /** 금액 환산 (현재 환율 기준) */
  convertAmount: Scalars['Float']['output']
  /** Query crypto payout detail by ID */
  cryptoPayoutDetail: CryptoPayoutDetailResponse
  /** Query crypto payout records with pagination */
  cryptoPayoutList: CryptoPayoutPage
  /** 암호화폐 환불 수수료 단일 조회 */
  cryptoRefundFee: CryptoRefundFee
  /** 암호화폐 환불 수수료 목록 조회 */
  cryptoRefundFees: CryptoRefundFeeList
  /** 통화 목록 조회 */
  currencies: CurrencyList
  /** 통화 단건 조회 */
  currency: Currency
  /** 통화 코드로 조회 */
  currencyByCode?: Maybe<Currency>
  /** 현재 활성 환율 조회 */
  currentExchangeRate?: Maybe<CurrentExchangeRate>
  /** 현재 활성화된 API 키 세트 조회 (환경 기반 자동 결정) */
  currentMerchantApiKeys: CurrentApiKeys
  /** 일별 거래 요약 목록 조회 (DB GROUP BY 집계, 페이지네이션 없음) */
  dailyTransactionSummaries: Array<DailyTransactionSummary>
  /** 대시보드 요약 조회 (백엔드 집계, 페이지네이션 없음) */
  dashboardSummary: DashboardSummary
  dispatchReconciliationItems: DispatchReconciliationItemList
  /** 체인 이동 출금 브리징 수수료 견적 */
  estimateWithdrawalBridgingFee: WithdrawalBridgingFeeEstimate
  /** 비정상 입금 단건 조회 (어드민 전용) */
  exceptionalTransfer: ExceptionalTransfer
  /** 비정상 입금 목록 조회 (어드민 전용) */
  exceptionalTransfers: ExceptionalTransferList
  /** 환율 단건 조회 */
  exchangeRate: ExchangeRate
  /** 환율 히스토리 조회 */
  exchangeRateHistory: Array<ExchangeRate>
  /** 환율 목록 조회 (페이지네이션 및 필터링 지원) */
  exchangeRates: ExchangeRateList
  /** 기준 통화별 환율 목록 조회 */
  exchangeRatesByFromCurrency: Array<ExchangeRate>
  /** 대상 통화별 환율 목록 조회 */
  exchangeRatesByToCurrency: Array<ExchangeRate>
  /** Query applicable fee setting */
  feeSetting: FeeSettingResponse
  /** Query fee settings with pagination */
  feeSettingList: FeeSettingPage
  /** 파일 조회 - 권한 검증 및 서명된 URL 반환 */
  file: FileAccessResponse
  /** 파일 다운로드 URL 생성 - 5분간 유효 */
  fileDownloadUrl: Scalars['String']['output']
  /** 여러 파일 조회 - 권한 검증 및 서명된 URL 반환 */
  files: Array<FileAccessResponse>
  /** 채널 잔액 조회 */
  fundFlowChannelBalance: FundFlowChannelBalance
  /** 자금 현황 채널 목록 */
  fundFlowChannels: Array<FundFlowChannel>
  /** Get Binance connect redirect link for crypto payment */
  getBinanceConnectLink: BinanceConnectLinkResponse
  /** 마지막 성공 실행 조회 */
  getLastSuccessfulRun?: Maybe<SchedulerLog>
  /** Get payable amount for different tokens */
  getPayableAmountsByTokens: Array<PayableAmountResponse>
  /** 특정 스케줄러의 최근 실행 로그 */
  getRecentSchedulerLogs: Array<SchedulerLog>
  /** 최근 출금 요청 */
  getRecentWithdrawals: Array<Withdrawal>
  /** Get refund link information by token (Public) */
  getRefundLinkInfo: RefundLinkInfo
  /** 스케줄러 로그 단건 조회 */
  getSchedulerLog: SchedulerLog
  /** 스케줄러 로그 목록 조회 */
  getSchedulerLogs: SchedulerLogList
  /** Decide the variant for gray-scale testing */
  grayDecision: GrayDecisionResponse
  /** 시간별 페이아웃 요약 목록 조회 (UTC 기준) */
  hourlyPayoutSummaries: HourlyPayoutSummaryList
  /** 시간별 거래 요약 목록 조회 (UTC 기준, 타임존 지원) */
  hourlyTransactionSummaries: HourlyTransactionSummaryList
  /** 진행 중(SENDING/SENT, 미만료) 검증 송금 목록 — 수취인 페이지 "검증 진행 중" 표시용 */
  inProgressMicroTransfers: Array<MicroTransferModel>
  /** Query internal account entries with pagination */
  internalAccountEntryList: InternalAccountEntryPage
  /** 출금 주소 검증 여부 (Safety Withdraw) */
  isAddressVerified: Scalars['Boolean']['output']
  /** 수동 환불 승인 단건 조회 */
  manualRefundApproval: ManualRefundApproval
  /** 수동 환불 승인 목록 조회 */
  manualRefundApprovals: ManualRefundApprovalList
  /** 내 정보 조회 */
  me: User
  /** 특정 메뉴 조회 */
  menu?: Maybe<Menu>
  /** 상점 단건 조회 - 관리자와 해당 상점 관리자만 접근 가능 */
  merchant: Merchant
  /** Query merchant available balance by currency */
  merchantAccountAvailableBalance: Scalars['Float']['output']
  /** Query merchant account entries with pagination */
  merchantAccountEntryList: MerchantAccountEntryPage
  /** Query merchant account summary */
  merchantAccountSummary: MerchantAccountSummaryResponse
  /** 단일 API 키 조회 */
  merchantApiKey?: Maybe<MerchantApiKey>
  /** API 키 목록 조회 */
  merchantApiKeys: ApiKeyList
  /** 가맹점 암호화폐 환불 수수료 단일 조회 */
  merchantCryptoRefundFee: MerchantCryptoRefundFee
  /** 가맹점별 암호화폐 환불 수수료 목록 조회 */
  merchantCryptoRefundFees: MerchantCryptoRefundFeeList
  /** 가맹점 환율 마진 단건 조회 */
  merchantExchangeMargin?: Maybe<MerchantExchangeMargin>
  /** 가맹점 환율 마진 목록 조회 */
  merchantExchangeMargins: MerchantExchangeMarginList
  /** Query one merchant frequent recipient by merchant ID, network, and address */
  merchantFrequentRecipient?: Maybe<MerchantFrequentRecipientModel>
  /** Query merchant frequent recipients by merchant ID and network */
  merchantFrequentRecipients: MerchantFrequentRecipientPage
  /** 가맹점 IP 화이트리스트 상태 + 현재 접속 IP */
  merchantIpWhitelist: IpWhitelistStatusModel
  merchantPaymentMethod: MerchantPaymentMethod
  merchantPaymentMethods: Array<MerchantPaymentMethod>
  /** 가맹점별 페이아웃 통계 조회 (ADMIN 전용) */
  merchantPayoutStatistics: MerchantPayoutStatisticsList
  /** 가맹점별 환불 수수료 기록 조회 */
  merchantRefundFeeRecords: RefundFeeRecordList
  /** 가맹점별 통계 조회 (ADMIN 전용, 페이지네이션) */
  merchantStatistics: MerchantStatisticsList
  /** 가맹점 사용자 상세 조회 - ADMIN, MERCHANT_ADMIN만 접근 가능 */
  merchantUser: MerchantUserDetail
  /** 가맹점 사용자 목록 조회 - ADMIN, MERCHANT_ADMIN만 접근 가능 */
  merchantUsers: MerchantUserList
  /** 상점 목록 조회 - 관리자만 접근 가능 */
  merchants: MerchantList
  /** 결제수단 또는 국가별 상점 조회 */
  merchantsByPaymentMethod: MerchantPaymentMethodList
  /** Safety Withdraw 검증 송금 조회 (상태 폴링) */
  microTransfer: MicroTransferModel
  /** Query offramp detail by ID */
  offrampDetail: OfframpDetailResponse
  /** Query offramp records with pagination */
  offrampList: OfframpPage
  /** Query onramp detail by ID */
  onrampDetail: OnrampDetailResponse
  /** Query onramp records with pagination */
  onrampList: OnrampPage
  /** 결제 단건 조회 */
  payment?: Maybe<Payment>
  /** 결제 금액 조정 단건 조회 */
  paymentAdjustment: PaymentAdjustment
  /** 결제 금액 조정 목록 조회 */
  paymentAdjustments: PaymentAdjustmentList
  /** ID로 PG사 조회 */
  paymentGateway: PaymentGateway
  /** 코드로 PG사 조회 */
  paymentGatewayByCode?: Maybe<PaymentGateway>
  /** 페이지네이션된 PG사 목록 조회 */
  paymentGateways: PaymentGatewayList
  /** 결제수단을 지원하는 PG사 목록 조회 */
  paymentGatewaysByMethod: Array<PaymentGateway>
  /** Get a specific payment method configuration */
  paymentMethodConfig?: Maybe<PaymentMethodConfig>
  /** Get paginated payment method configurations */
  paymentMethodConfigs: PaymentMethodConfigList
  /** Get a single payment method routing by ID */
  paymentMethodRouting: PaymentMethodRouting
  /** Get paginated payment method routings */
  paymentMethodRoutings: PaymentMethodRoutingList
  /** 지원 결제수단 목록 조회 */
  paymentMethods: Array<PaymentMethodConfig>
  /** 결제 목록 조회 */
  payments: PaymentList
  /** 페이아웃 대시보드 요약 조회 */
  payoutSummary: PayoutSummary
  /** PG 정산 상세 조회 */
  pgSettlement: PgSettlementModel
  /** 배치 ID로 PG 정산 조회 */
  pgSettlementByBatchId: PgSettlementModel
  /** PG 정산 항목 상세 조회 */
  pgSettlementItem: PgSettlementItemModel
  /** PG 정산 프리뷰 조회 (기간별 거래 집계) */
  pgSettlementPreview: PgSettlementPreviewModel
  /** 처리된 PG 정산 기간 목록 조회 (기간 중복 검증용) */
  pgSettlementProcessedPeriods: Array<PgSettlementPeriodModel>
  /** PG 정산 타임라인 조회 */
  pgSettlementTimeline: PgSettlementTimelineModel
  /** PG 정산금 이체 요청 상세 조회 */
  pgSettlementTransfer: PgSettlementTransferModel
  /** PG 정산 지갑 설정 상세 조회 */
  pgSettlementWalletConfig: PgSettlementWalletConfigModel
  /** PG 정산 지갑 설정 목록 조회 */
  pgSettlementWalletConfigs: Array<PgSettlementWalletConfigModel>
  /** PG 정산 목록 조회 */
  pgSettlements: PgSettlementListModel
  /** Query up to 5 recent unique payout addresses from the latest 10 payout records of the current merchant on the same network resolved from the currency code */
  recentCryptoPayoutAddresses: Array<Scalars['String']['output']>
  reconciliationMismatchItem?: Maybe<ReconciliationMismatchItem>
  reconciliationMismatchItems: ReconciliationMismatchItemList
  reconciliationRun?: Maybe<ReconciliationRun>
  reconciliationRuns: ReconciliationRunList
  /** 환불 거래 단건 조회 */
  refund?: Maybe<RefundTransaction>
  refundApprovalRequest: RefundApprovalRequest
  refundApprovalRequests: RefundApprovalRequestList
  /** 환불 수수료 기록 단일 조회 */
  refundFeeRecord: RefundFeeRecord
  /** 환불 수수료 기록 목록 조회 */
  refundFeeRecords: RefundFeeRecordList
  /** 환불 거래 목록 조회 */
  refunds: RefundList
  /** AML 위험 관리 공급자 목록 조회 */
  riskManagementProviders: Array<RiskManagementProviderModel>
  /** 역할별 메뉴 권한 조회 (권한 정보만) */
  roleMenuPermissions: Array<RoleMenu>
  /** Get routings for a specific payment method */
  routingsByPaymentMethod: Array<PaymentMethodRouting>
  /** 보안 정책 조회 */
  securityPolicy: SecurityPolicyModel
  /** 정산 단건 조회 */
  settlement: Settlement
  /** 정산 목록 조회 */
  settlements: SettlementList
  /** 시스템 설정 목록 조회 (카테고리 필터 선택) */
  systemSettings: Array<SystemSettingModel>
  /** Query topup address groups by customId with pagination */
  topupAddressGroups: TopupAddressGroupPage
  /** Query topup addresses with pagination */
  topupAddresses: TopupAddressPage
  /** Query topup detail by ID */
  topupDetail: TopupDetailResponse
  /** Query topup records with pagination */
  topupList: TopupPage
  /** 충전 요청 상세 조회 */
  topupRequestDetail?: Maybe<TopupRequestDetail>
  /** 충전 요청 목록 조회 */
  topupRequestList: TopupRequestList
  /** 가맹점 암호화폐 충전 지원 Cobo 토큰 ID 조회 */
  topupSupportedCryptoTokenIds: Array<Scalars['String']['output']>
  /** 현재 사용자의 fiat 충전 지원 통화 조회 */
  topupSupportedCurrencies: Array<Scalars['String']['output']>
  /** 현재 사용자가 접근 가능한 메뉴 조회 */
  userMenus: Array<Menu>
  /** Get single webhook event by ID */
  webhookEvent?: Maybe<WebhookEvent>
  /** Get paginated webhook events */
  webhookEvents: WebhookEventList
  /** 출금 요청 단건 조회 */
  withdrawal: Withdrawal
  /** 출금 처리 미리보기 (관리자) */
  withdrawalProcessPreview: WithdrawalProcessPreview
  /** 출금 요청 목록 조회 */
  withdrawals: WithdrawalList
}

export type QueryActiveMicroTransferArgs = {
  input: ActiveMicroTransferInput
}

export type QueryAllMenusArgs = {
  filter?: InputMaybe<MenuFilterInput>
}

export type QueryAmlAlertArgs = {
  id: Scalars['String']['input']
}

export type QueryAmlAlertsArgs = {
  filter?: InputMaybe<AmlAlertFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAmlScreeningResultArgs = {
  id: Scalars['String']['input']
}

export type QueryAmlScreeningResultsArgs = {
  filter?: InputMaybe<AmlScreeningResultFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAmlScreeningResultsByPaymentArgs = {
  paymentId: Scalars['String']['input']
}

export type QueryApprovalTodoListArgs = {
  filter?: InputMaybe<ApprovalTodoFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAutoRefundsArgs = {
  filter?: InputMaybe<AutoRefundFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryBatchCryptoPayoutArgs = {
  batchId: Scalars['Int']['input']
}

export type QueryBeneficiariesArgs = {
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryChannelArgs = {
  code: Scalars['String']['input']
}

export type QueryChannelBalanceArgs = {
  channelCode: Scalars['String']['input']
}

export type QueryChannelFundFlowSyncRunsArgs = {
  channelCode?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type QueryChannelFundFlowsArgs = {
  filter?: InputMaybe<ChannelFundFlowFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryChannelRoutesArgs = {
  filter?: InputMaybe<ChannelRouteFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryChannelTopupAccountsArgs = {
  channelCode: Scalars['String']['input']
}

export type QueryChannelTransferArgs = {
  id: Scalars['String']['input']
}

export type QueryChannelTransfersArgs = {
  filter?: InputMaybe<ChannelTransferFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryChannelsArgs = {
  filter?: InputMaybe<ChannelFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCheckSchedulerRunningArgs = {
  schedulerName: SchedulerName
}

export type QueryCheckoutSessionArgs = {
  id: Scalars['String']['input']
}

export type QueryCheckoutSessionStatusArgs = {
  id: Scalars['String']['input']
}

export type QueryCoboOrderLinkArgs = {
  input: CoboOrderLinkRequest
}

export type QueryConvertAmountArgs = {
  amount: Scalars['Float']['input']
  fromCurrencyId: Scalars['Int']['input']
  toCurrencyId: Scalars['Int']['input']
  useWithdrawalRate?: Scalars['Boolean']['input']
}

export type QueryCryptoPayoutDetailArgs = {
  orderId: Scalars['String']['input']
}

export type QueryCryptoPayoutListArgs = {
  filter?: InputMaybe<CryptoPayoutListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCryptoRefundFeeArgs = {
  id: Scalars['Int']['input']
}

export type QueryCryptoRefundFeesArgs = {
  filter?: InputMaybe<CryptoRefundFeeFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCurrenciesArgs = {
  filter?: InputMaybe<CurrencyFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCurrencyArgs = {
  id: Scalars['Int']['input']
}

export type QueryCurrencyByCodeArgs = {
  code: Scalars['String']['input']
}

export type QueryCurrentExchangeRateArgs = {
  fromCurrencyId: Scalars['Int']['input']
  toCurrencyId: Scalars['Int']['input']
}

export type QueryCurrentMerchantApiKeysArgs = {
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryDailyTransactionSummariesArgs = {
  input: GetDailyTransactionSummaryInput
}

export type QueryDashboardSummaryArgs = {
  input: GetDashboardSummaryInput
}

export type QueryDispatchReconciliationItemsArgs = {
  filter?: InputMaybe<DispatchReconciliationFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryEstimateWithdrawalBridgingFeeArgs = {
  amount: Scalars['Float']['input']
  fromCurrency: Scalars['String']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
  requestedCurrency: Scalars['String']['input']
}

export type QueryExceptionalTransferArgs = {
  id: Scalars['Int']['input']
}

export type QueryExceptionalTransfersArgs = {
  filter?: InputMaybe<ExceptionalTransferFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryExchangeRateArgs = {
  id: Scalars['Int']['input']
}

export type QueryExchangeRateHistoryArgs = {
  fromCurrencyId: Scalars['Int']['input']
  limit?: Scalars['Float']['input']
  toCurrencyId: Scalars['Int']['input']
}

export type QueryExchangeRatesArgs = {
  filter?: InputMaybe<ExchangeRateFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryExchangeRatesByFromCurrencyArgs = {
  fromCurrencyId: Scalars['Int']['input']
  onlyActive?: Scalars['Boolean']['input']
}

export type QueryExchangeRatesByToCurrencyArgs = {
  onlyActive?: Scalars['Boolean']['input']
  toCurrencyId: Scalars['Int']['input']
}

export type QueryFeeSettingArgs = {
  input: FeeSettingInput
}

export type QueryFeeSettingListArgs = {
  bizType?: InputMaybe<FeeBusinessType>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryFileArgs = {
  fileId: Scalars['Int']['input']
  uploadToken?: InputMaybe<Scalars['String']['input']>
}

export type QueryFileDownloadUrlArgs = {
  fileId: Scalars['Int']['input']
  uploadToken?: InputMaybe<Scalars['String']['input']>
}

export type QueryFilesArgs = {
  fileIds: Array<Scalars['Int']['input']>
  uploadToken?: InputMaybe<Scalars['String']['input']>
}

export type QueryFundFlowChannelBalanceArgs = {
  channelCode: Scalars['String']['input']
}

export type QueryGetBinanceConnectLinkArgs = {
  input: BinanceConnectLinkRequest
}

export type QueryGetLastSuccessfulRunArgs = {
  schedulerName: SchedulerName
}

export type QueryGetPayableAmountsByTokensArgs = {
  input: GetPayableAmountsRequest
}

export type QueryGetRecentSchedulerLogsArgs = {
  limit?: Scalars['Float']['input']
  schedulerName: SchedulerName
}

export type QueryGetRecentWithdrawalsArgs = {
  limit?: Scalars['Int']['input']
}

export type QueryGetRefundLinkInfoArgs = {
  token: Scalars['String']['input']
}

export type QueryGetSchedulerLogArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetSchedulerLogsArgs = {
  filter?: InputMaybe<SchedulerLogFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGrayDecisionArgs = {
  input: GrayDecisionInput
}

export type QueryHourlyPayoutSummariesArgs = {
  input: GetHourlyPayoutSummaryInput
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryHourlyTransactionSummariesArgs = {
  input: GetHourlyTransactionSummaryInput
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryInProgressMicroTransfersArgs = {
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryInternalAccountEntryListArgs = {
  filter?: InputMaybe<InternalAccountEntryListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryIsAddressVerifiedArgs = {
  input: AddressVerifiedInput
}

export type QueryManualRefundApprovalArgs = {
  id: Scalars['String']['input']
}

export type QueryManualRefundApprovalsArgs = {
  filter?: InputMaybe<ManualRefundApprovalFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMenuArgs = {
  id: Scalars['Int']['input']
}

export type QueryMerchantArgs = {
  id?: InputMaybe<Scalars['Float']['input']>
}

export type QueryMerchantAccountAvailableBalanceArgs = {
  currency: Scalars['String']['input']
  merchantId: Scalars['Int']['input']
}

export type QueryMerchantAccountEntryListArgs = {
  filter?: InputMaybe<MerchantAccountEntryListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId: Scalars['Int']['input']
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantAccountSummaryArgs = {
  merchantId: Scalars['Int']['input']
}

export type QueryMerchantApiKeyArgs = {
  id: Scalars['Int']['input']
}

export type QueryMerchantApiKeysArgs = {
  filter?: InputMaybe<ApiKeyFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantCryptoRefundFeeArgs = {
  id: Scalars['Int']['input']
}

export type QueryMerchantCryptoRefundFeesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId: Scalars['Int']['input']
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantExchangeMarginArgs = {
  id: Scalars['Int']['input']
}

export type QueryMerchantExchangeMarginsArgs = {
  filter?: InputMaybe<MerchantExchangeMarginFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantFrequentRecipientArgs = {
  address: Scalars['String']['input']
  merchantId: Scalars['Int']['input']
  network: Scalars['String']['input']
}

export type QueryMerchantFrequentRecipientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId: Scalars['Int']['input']
  network: Scalars['String']['input']
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryMerchantIpWhitelistArgs = {
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantPaymentMethodArgs = {
  id: Scalars['Int']['input']
}

export type QueryMerchantPaymentMethodsArgs = {
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantPayoutStatisticsArgs = {
  input: GetMerchantPayoutStatisticsInput
}

export type QueryMerchantRefundFeeRecordsArgs = {
  filter?: InputMaybe<RefundFeeRecordFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId: Scalars['Int']['input']
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantStatisticsArgs = {
  input: GetMerchantStatisticsInput
}

export type QueryMerchantUserArgs = {
  userId: Scalars['Int']['input']
}

export type QueryMerchantUsersArgs = {
  filter?: InputMaybe<MerchantUserFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantsArgs = {
  filter?: InputMaybe<MerchantFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMerchantsByPaymentMethodArgs = {
  filter?: InputMaybe<MerchantPaymentMethodFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMicroTransferArgs = {
  id: Scalars['ID']['input']
}

export type QueryOfframpDetailArgs = {
  orderId: Scalars['String']['input']
}

export type QueryOfframpListArgs = {
  filter?: InputMaybe<OfframpListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryOnrampDetailArgs = {
  orderId: Scalars['String']['input']
}

export type QueryOnrampListArgs = {
  filter?: InputMaybe<OnrampListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPaymentArgs = {
  id: Scalars['String']['input']
}

export type QueryPaymentAdjustmentArgs = {
  id: Scalars['String']['input']
}

export type QueryPaymentAdjustmentsArgs = {
  filter?: InputMaybe<PaymentAdjustmentFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPaymentGatewayArgs = {
  id: Scalars['Int']['input']
}

export type QueryPaymentGatewayByCodeArgs = {
  code: Scalars['String']['input']
}

export type QueryPaymentGatewaysArgs = {
  filter?: InputMaybe<PaymentGatewayFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPaymentGatewaysByMethodArgs = {
  paymentMethod: PaymentMethod
}

export type QueryPaymentMethodConfigArgs = {
  id: Scalars['Float']['input']
}

export type QueryPaymentMethodConfigsArgs = {
  filter?: InputMaybe<PaymentMethodConfigFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPaymentMethodRoutingArgs = {
  id: Scalars['Int']['input']
}

export type QueryPaymentMethodRoutingsArgs = {
  filter?: InputMaybe<PaymentMethodRoutingFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPaymentsArgs = {
  filter?: InputMaybe<PaymentFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPayoutSummaryArgs = {
  input: GetPayoutSummaryInput
}

export type QueryPgSettlementArgs = {
  id: Scalars['String']['input']
}

export type QueryPgSettlementByBatchIdArgs = {
  batchId: Scalars['String']['input']
}

export type QueryPgSettlementItemArgs = {
  id: Scalars['String']['input']
}

export type QueryPgSettlementPreviewArgs = {
  input: PgSettlementPreviewInput
}

export type QueryPgSettlementProcessedPeriodsArgs = {
  gatewayCode: Scalars['String']['input']
  settlementType: PgSettlementType
}

export type QueryPgSettlementTimelineArgs = {
  pgSettlementId: Scalars['String']['input']
}

export type QueryPgSettlementTransferArgs = {
  id: Scalars['String']['input']
}

export type QueryPgSettlementWalletConfigArgs = {
  id: Scalars['String']['input']
}

export type QueryPgSettlementWalletConfigsArgs = {
  activeOnly?: Scalars['Boolean']['input']
  gatewayCode?: InputMaybe<Scalars['String']['input']>
}

export type QueryPgSettlementsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
  gatewayId?: InputMaybe<Scalars['Int']['input']>
  limit?: Scalars['Int']['input']
  page?: Scalars['Int']['input']
  settlementType?: InputMaybe<PgSettlementType>
  status?: InputMaybe<PgSettlementStatus>
}

export type QueryRecentCryptoPayoutAddressesArgs = {
  currency: Scalars['String']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryReconciliationMismatchItemArgs = {
  id: Scalars['String']['input']
}

export type QueryReconciliationMismatchItemsArgs = {
  filter?: InputMaybe<ReconciliationMismatchItemFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryReconciliationRunArgs = {
  id: Scalars['String']['input']
}

export type QueryReconciliationRunsArgs = {
  filter?: InputMaybe<ReconciliationRunFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryRefundArgs = {
  id: Scalars['String']['input']
}

export type QueryRefundApprovalRequestArgs = {
  id: Scalars['String']['input']
}

export type QueryRefundApprovalRequestsArgs = {
  filter?: InputMaybe<RefundApprovalFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryRefundFeeRecordArgs = {
  id: Scalars['Int']['input']
}

export type QueryRefundFeeRecordsArgs = {
  filter?: InputMaybe<RefundFeeRecordFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryRefundsArgs = {
  filter?: InputMaybe<RefundFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryRoleMenuPermissionsArgs = {
  role: UserRole
}

export type QueryRoutingsByPaymentMethodArgs = {
  paymentMethod: PaymentMethod
}

export type QuerySettlementArgs = {
  id: Scalars['Int']['input']
}

export type QuerySettlementsArgs = {
  filter?: InputMaybe<SettlementFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QuerySystemSettingsArgs = {
  category?: InputMaybe<Scalars['String']['input']>
}

export type QueryTopupAddressGroupsArgs = {
  filter?: InputMaybe<TopupAddressFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryTopupAddressesArgs = {
  filter?: InputMaybe<TopupAddressFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryTopupDetailArgs = {
  orderId: Scalars['String']['input']
}

export type QueryTopupListArgs = {
  filter?: InputMaybe<TopupListInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryTopupRequestDetailArgs = {
  requestId: Scalars['String']['input']
}

export type QueryTopupRequestListArgs = {
  filter?: InputMaybe<TopupRequestFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryTopupSupportedCurrenciesArgs = {
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryWebhookEventArgs = {
  id: Scalars['String']['input']
}

export type QueryWebhookEventsArgs = {
  filter?: InputMaybe<WebhookEventFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryWithdrawalArgs = {
  id: Scalars['String']['input']
}

export type QueryWithdrawalProcessPreviewArgs = {
  withdrawalId: Scalars['String']['input']
}

export type QueryWithdrawalsArgs = {
  filter?: InputMaybe<WithdrawalFilterInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type RecheckPayoutDispatchInput = {
  orderId: Scalars['String']['input']
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type RecheckRefundDispatchInput = {
  refundTxId: Scalars['String']['input']
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type ReconciliationMismatchItem = {
  __typename?: 'ReconciliationMismatchItem'
  alertCount: Scalars['Int']['output']
  amount?: Maybe<Scalars['String']['output']>
  currency?: Maybe<Scalars['String']['output']>
  detail?: Maybe<Scalars['JSON']['output']>
  firstDetectedAt: Scalars['DateTime']['output']
  firstRunId: Scalars['String']['output']
  gateway?: Maybe<PaymentGateway>
  gatewayId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  itemKey: Scalars['String']['output']
  kind: ReconciliationMismatchKind
  lastAlertedAt?: Maybe<Scalars['DateTime']['output']>
  lastDetectedAt: Scalars['DateTime']['output']
  lastRunId: Scalars['String']['output']
  note?: Maybe<Scalars['String']['output']>
  occurredAt?: Maybe<Scalars['DateTime']['output']>
  resolution?: Maybe<Scalars['String']['output']>
  resolvedAt?: Maybe<Scalars['DateTime']['output']>
  resolvedBy?: Maybe<Scalars['String']['output']>
  status: ReconciliationMismatchStatus
  txKind: Scalars['String']['output']
}

export type ReconciliationMismatchItemFilterInput = {
  detectedFrom?: InputMaybe<Scalars['DateTime']['input']>
  detectedTo?: InputMaybe<Scalars['DateTime']['input']>
  gatewayId?: InputMaybe<Scalars['Int']['input']>
  kind?: InputMaybe<ReconciliationMismatchKind>
  runId?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<ReconciliationMismatchStatus>>
}

export type ReconciliationMismatchItemList = {
  __typename?: 'ReconciliationMismatchItemList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ReconciliationMismatchItem>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export enum ReconciliationMismatchKind {
  AMOUNT_MISMATCH = 'AMOUNT_MISMATCH',
  OUR_ONLY = 'OUR_ONLY',
  PG_ONLY = 'PG_ONLY',
}

export enum ReconciliationMismatchStatus {
  AUTO_RESOLVED = 'AUTO_RESOLVED',
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED',
}

export type ReconciliationRun = {
  __typename?: 'ReconciliationRun'
  createdAt: Scalars['DateTime']['output']
  dateFrom: Scalars['DateTime']['output']
  dateTo: Scalars['DateTime']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  gateway?: Maybe<PaymentGateway>
  gatewayId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  ourMatchedCount: Scalars['Int']['output']
  ourTotalCount: Scalars['Int']['output']
  ourUnmatchedCount: Scalars['Int']['output']
  ourUnmatchedKeys: Scalars['JSON']['output']
  pgMatchedCount: Scalars['Int']['output']
  pgTotalCount: Scalars['Int']['output']
  pgUnmatchedCodes: Scalars['JSON']['output']
  pgUnmatchedCount: Scalars['Int']['output']
  status: Scalars['String']['output']
  totalApiCalls: Scalars['Int']['output']
  transactionMismatches?: Maybe<Scalars['JSON']['output']>
}

export type ReconciliationRunFilterInput = {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>
  createdTo?: InputMaybe<Scalars['DateTime']['input']>
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
  gatewayId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type ReconciliationRunList = {
  __typename?: 'ReconciliationRunList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<ReconciliationRun>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type ReconciliationSideResult = {
  __typename?: 'ReconciliationSideResult'
  /** 일치 건수 */
  matched: Scalars['Int']['output']
  /** 총 거래 건수 */
  total: Scalars['Int']['output']
  /** 불일치 건수 */
  unmatched: Scalars['Int']['output']
  /** 불일치 키 목록 (paymentKey 또는 psp_order_code) */
  unmatchedKeys: Array<Scalars['String']['output']>
}

export type RecordOnrampFundingTransferInput = {
  /** Amount received by the beneficiary */
  beneficiaryAmount: Scalars['Float']['input']
  memo?: InputMaybe<Scalars['String']['input']>
  /** Onramp order ID */
  orderId: Scalars['String']['input']
  /** Amount paid by the funding source */
  payerPaysAmount: Scalars['Float']['input']
  /** Provider transfer ID */
  providerRef: Scalars['String']['input']
}

export type RefreshTokenInput = {
  refreshToken: Scalars['String']['input']
}

export type RefundApprovalFilterInput = {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>
  createdTo?: InputMaybe<Scalars['DateTime']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Array<RefundApprovalRequestStatus>>
}

export enum RefundApprovalHoldReason {
  ADDRESS_MISMATCH = 'ADDRESS_MISMATCH',
  UNKNOWN_SENDER = 'UNKNOWN_SENDER',
}

export type RefundApprovalRequest = {
  __typename?: 'RefundApprovalRequest'
  amount: Scalars['Float']['output']
  createdAt: Scalars['DateTime']['output']
  currency: Scalars['String']['output']
  currencyId: Scalars['Int']['output']
  executedTransactionId?: Maybe<Scalars['String']['output']>
  executionError?: Maybe<Scalars['String']['output']>
  holdReason: RefundApprovalHoldReason
  id: Scalars['String']['output']
  merchantId: Scalars['Int']['output']
  merchantName: Scalars['String']['output']
  originalSenderAddress?: Maybe<Scalars['String']['output']>
  payment?: Maybe<Payment>
  paymentId: Scalars['String']['output']
  reason?: Maybe<Scalars['String']['output']>
  requestIp?: Maybe<Scalars['String']['output']>
  requestedByEmail: Scalars['String']['output']
  requestedById: Scalars['Int']['output']
  requesterRole: Scalars['String']['output']
  reviewNote?: Maybe<Scalars['String']['output']>
  reviewedAt?: Maybe<Scalars['DateTime']['output']>
  reviewedByEmail?: Maybe<Scalars['String']['output']>
  reviewedById?: Maybe<Scalars['Int']['output']>
  status: RefundApprovalRequestStatus
  updatedAt: Scalars['DateTime']['output']
  walletAddress: Scalars['String']['output']
}

export type RefundApprovalRequestList = {
  __typename?: 'RefundApprovalRequestList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<RefundApprovalRequest>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export enum RefundApprovalRequestStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

/** 환불 디스패치 단건 재확인 결과 */
export enum RefundDispatchRecheckOutcome {
  FINALIZED_FAILED = 'FINALIZED_FAILED',
  FINALIZED_SUCCESS = 'FINALIZED_SUCCESS',
  MARKER_CLEARED = 'MARKER_CLEARED',
  SKIPPED = 'SKIPPED',
  STILL_PENDING = 'STILL_PENDING',
  UNCERTAIN = 'UNCERTAIN',
}

export type RefundDispatchRecheckResultModel = {
  __typename?: 'RefundDispatchRecheckResultModel'
  message: Scalars['String']['output']
  outcome: RefundDispatchRecheckOutcome
}

/** 미확인 환불 디스패치 대사 결과 */
export type RefundDispatchReconciliationResult = {
  __typename?: 'RefundDispatchReconciliationResult'
  errors: Array<Scalars['String']['output']>
  finalized: Scalars['Int']['output']
  markedUncertain: Scalars['Int']['output']
  markersCleared: Scalars['Int']['output']
  message: Scalars['String']['output']
  scanned: Scalars['Int']['output']
  skipped: Scalars['Int']['output']
  verificationRequeued: Scalars['Int']['output']
}

/** 환불 엑셀 다운로드 응답 */
export type RefundExcelResponse = {
  __typename?: 'RefundExcelResponse'
  /** 즉시 다운로드 URL (1000건 이하인 경우) */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** 비동기 작업 ID (1000건 초과인 경우) */
  jobId?: Maybe<Scalars['String']['output']>
  /** 처리 메시지 */
  message: Scalars['String']['output']
  /** 처리 유형 (IMMEDIATE: 즉시, ASYNC: 비동기) */
  processType: Scalars['String']['output']
  /** 총 레코드 수 */
  recordCount: Scalars['Int']['output']
}

export type RefundFeeRecord = {
  __typename?: 'RefundFeeRecord'
  /** 적용된 수수료율 (%) */
  appliedFeeRate?: Maybe<Scalars['Float']['output']>
  /** 계산 방식 (FIXED/PERCENTAGE) */
  calculationMethod?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  /** 수수료 금액 */
  feeAmount: Scalars['Float']['output']
  /** 수수료 설정 스냅샷 */
  feeConfigSnapshot?: Maybe<Scalars['JSON']['output']>
  /** 수수료 통화 */
  feeCurrency?: Maybe<Scalars['String']['output']>
  /** 수수료 부담 주체 */
  feeType: RefundFeeType
  id: Scalars['ID']['output']
  /** 최대 수수료 적용 여부 */
  maxFeeApplied: Scalars['Boolean']['output']
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 최소 수수료 적용 여부 */
  minFeeApplied: Scalars['Boolean']['output']
  /** 실제 토큰 환불 금액 */
  payableAmount?: Maybe<Scalars['Float']['output']>
  /** 실결제 통화 ID (L3 Crypto Currency) */
  payableCurrencyId: Scalars['Int']['output']
  /** 결제 ID */
  paymentId: Scalars['String']['output']
  /** 정산 예정일 */
  settlementDate?: Maybe<Scalars['DateTime']['output']>
  /** 트랜잭션 ID */
  transactionId: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type RefundFeeRecordFilterInput = {
  /** 통화 필터 */
  feeCurrency?: InputMaybe<Scalars['String']['input']>
  /** 수수료 부담 주체 필터 */
  feeType?: InputMaybe<RefundFeeType>
  /** 가맹점 ID 필터 */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 실결제 통화 ID 필터 (L3) */
  payableCurrencyId?: InputMaybe<Scalars['Int']['input']>
  /** 결제 ID 필터 */
  paymentId?: InputMaybe<Scalars['String']['input']>
  /** 정산일 시작 (YYYY-MM-DD) */
  settlementDateFrom?: InputMaybe<Scalars['String']['input']>
  /** 정산일 종료 (YYYY-MM-DD) */
  settlementDateTo?: InputMaybe<Scalars['String']['input']>
  /** 트랜잭션 ID 필터 */
  transactionId?: InputMaybe<Scalars['String']['input']>
}

export type RefundFeeRecordList = {
  __typename?: 'RefundFeeRecordList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<RefundFeeRecord>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 환불 수수료 부담 주체 */
export enum RefundFeeType {
  MERCHANT_PAID = 'MERCHANT_PAID',
  USER_PAID = 'USER_PAID',
}

export type RefundFilterInput = {
  /** 부분 환불 여부 */
  isPartial?: InputMaybe<Scalars['Boolean']['input']>
  /** 엑셀 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 최대 환불 금액 */
  maxAmount?: InputMaybe<Scalars['Float']['input']>
  /** 가맹점 ID (내부 관리용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 최소 환불 금액 */
  minAmount?: InputMaybe<Scalars['Float']['input']>
  /** 환불 종료일 */
  refundEndDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 환불 시작일 */
  refundStartDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>
  /** 검색 영역 */
  searchField?: InputMaybe<RefundSearchField>
  /** 환불 상태 */
  status?: InputMaybe<TransactionStatus>
}

export type RefundLink = {
  __typename?: 'RefundLink'
  /** 환불 완료 일시 */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** 생성 일시 */
  createdAt: Scalars['DateTime']['output']
  /** 통화 코드 */
  currency?: Maybe<Scalars['String']['output']>
  /** 고객 이메일 */
  customerEmail?: Maybe<Scalars['String']['output']>
  /** 이메일 발송 여부 */
  emailSent: Scalars['Boolean']['output']
  /** 이메일 발송 일시 */
  emailSentAt?: Maybe<Scalars['DateTime']['output']>
  /** 만료 일시 */
  expiresAt: Scalars['DateTime']['output']
  /** 환불링크 ID */
  id: Scalars['String']['output']
  /** 연결된 결제 ID */
  paymentId: Scalars['String']['output']
  /** 환불 사유 */
  reason?: Maybe<Scalars['String']['output']>
  /** 환불 금액 */
  refundAmount: Scalars['Float']['output']
  /** 생성 소스 (MANUAL: 수동 생성, AUTO_REFUND: 자동환불) */
  source: RefundLinkSource
  /** 환불링크 상태 */
  status: RefundLinkStatus
  /** 지갑 주소 제출 일시 */
  submittedAt?: Maybe<Scalars['DateTime']['output']>
  /** 연결된 환불 트랜잭션 ID */
  transactionId?: Maybe<Scalars['String']['output']>
  /** 지갑 주소 (제출된 경우) */
  walletAddress?: Maybe<Scalars['String']['output']>
}

export type RefundLinkInfo = {
  __typename?: 'RefundLinkInfo'
  /** Currency code */
  currency: Scalars['String']['output']
  /** Link expiration date (ISO 8601) */
  expiresAt: Scalars['String']['output']
  /** Merchant order ID */
  merchantOrderId: Scalars['String']['output']
  /** Blockchain network */
  network: Scalars['String']['output']
  /** Order name */
  orderName: Scalars['String']['output']
  /** Refund amount */
  refundAmount: Scalars['Float']['output']
  /** Remaining seconds until expiration */
  remainingSeconds: Scalars['Int']['output']
  /** Refund link status */
  status: Scalars['String']['output']
  /** Total order amount */
  totalAmount: Scalars['Float']['output']
  /** Wallet address (if already submitted) */
  walletAddress?: Maybe<Scalars['String']['output']>
}

/** 환불링크 생성 소스 (MANUAL: 수동 생성, AUTO_REFUND: 자동환불 시스템) */
export enum RefundLinkSource {
  AUTO_REFUND = 'AUTO_REFUND',
  MANUAL = 'MANUAL',
}

/** 환불링크 상태 (PENDING, SUBMITTED, COMPLETED, FAILED, EXPIRED, CANCELLED) */
export enum RefundLinkStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUBMITTED = 'SUBMITTED',
}

/** 환불 목록 응답 */
export type RefundList = {
  __typename?: 'RefundList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<RefundTransaction>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 환불 방식 */
export enum RefundMethod {
  /** 직접 환불 (API 요청으로 처리) */
  DIRECT = 'DIRECT',
  /** 링크 환불 (고객이 지갑 주소 입력) */
  LINK = 'LINK',
}

/** 결제 환불 입력 */
export type RefundPaymentInput = {
  /** 환불 금액 */
  amount: Scalars['Float']['input']
  /** 환불할 결제 ID */
  paymentId: Scalars['String']['input']
  /** 환불 사유 */
  reason?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
  /** 환불 지갑주소 (암호화폐 결제만 해당, 옵션) */
  walletAddress?: InputMaybe<Scalars['String']['input']>
}

/** 결제 환불 응답 */
export type RefundPaymentResponse = {
  __typename?: 'RefundPaymentResponse'
  approvalRequestId?: Maybe<Scalars['String']['output']>
  approvalStatus: Scalars['String']['output']
  /** 처리 결과 메시지 */
  message: Scalars['String']['output']
  /** 변경된 결제 상태 */
  newPaymentStatus?: Maybe<PaymentStatus>
  /** 결제 ID */
  paymentId: Scalars['String']['output']
  /** 처리 일시 */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** 환불 금액 */
  refundAmount: Scalars['Float']['output']
  /** 환불 유형 (CANCEL: 정산 전 취소, REFUND: 정산 후 환불) */
  refundType?: Maybe<Scalars['String']['output']>
  /** 남은 결제 금액 */
  remainingAmount?: Maybe<Scalars['Float']['output']>
  /** 총 환불 금액 (기존 + 신규) */
  totalRefundedAmount?: Maybe<Scalars['Float']['output']>
  /** 생성된 환불 트랜잭션 ID */
  transactionId?: Maybe<Scalars['String']['output']>
}

/** 운영자 환불 대사 확인 결과 */
export enum RefundReconciliationResolution {
  NOT_REFUNDED = 'NOT_REFUNDED',
  REFUNDED = 'REFUNDED',
}

/** 환불 검색 필드 */
export enum RefundSearchField {
  ALL = 'ALL',
  GATEWAY_TX_ID = 'GATEWAY_TX_ID',
  MERCHANT_ORDER_ID = 'MERCHANT_ORDER_ID',
  ORIGINAL_ORDER_ID = 'ORIGINAL_ORDER_ID',
  REFUND_TX_ID = 'REFUND_TX_ID',
}

/** 환불 거래 정보 */
export type RefundTransaction = {
  __typename?: 'RefundTransaction'
  /** 환불 금액 */
  amount: Scalars['Float']['output']
  /** 환불 요청일 */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** 통화 */
  currency: Scalars['String']['output']
  /** 실패 코드 */
  failureCode?: Maybe<Scalars['String']['output']>
  /** 실패 메시지 */
  failureMessage?: Maybe<Scalars['String']['output']>
  /** PG사 정보 */
  gateway: PaymentGateway
  /** PG사 거래 ID */
  gatewayTransactionId?: Maybe<Scalars['String']['output']>
  /** 환불 거래 ID */
  id: Scalars['ID']['output']
  /** 부분 환불 여부 */
  isPartial: Scalars['Boolean']['output']
  /** 가맹점 정보 */
  merchant: Merchant
  /** 가맹점 거래 ID */
  merchantTransactionId?: Maybe<Scalars['String']['output']>
  /** 원 결제 정보 */
  originalPayment: Payment
  /** 원 거래 ID */
  originalTxId?: Maybe<Scalars['String']['output']>
  /** 환불 처리일 */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  receiveAddress?: Maybe<Scalars['String']['output']>
  /** 환불 수수료 기록 */
  refundFeeRecord?: Maybe<RefundFeeRecord>
  /** 환불 링크 정보 (링크 환불인 경우) */
  refundLink?: Maybe<RefundLink>
  /** 환불 방식 (DIRECT: 직접 환불, LINK: 링크 환불) */
  refundMethod?: Maybe<RefundMethod>
  /** 환불 사유 */
  refundReason?: Maybe<Scalars['String']['output']>
  /** 환불 상태 */
  status: TransactionStatus
  /** PG사에 전달하는 거래 키 (내부용) */
  transactionKey?: Maybe<Scalars['String']['output']>
}

/** API 키 재생성 입력 */
export type RegenerateApiKeyInput = {
  /** 새 키 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 키 환경 (CLIENT_KEY/SECRET_KEY/WEBHOOK_KEY) */
  environment: Scalars['String']['input']
  /** 새 키 만료일 (ISO 8601) */
  expiresAt?: InputMaybe<Scalars['String']['input']>
  /** 새 IP 화이트리스트 */
  ipWhitelist?: InputMaybe<Array<Scalars['String']['input']>>
  /** 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 가맹점 ID (ADMIN만 설정 가능) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 재생성 사유 */
  reason?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

/** 검증된 지갑주소를 수취인으로 등록 */
export type RegisterBeneficiaryInput = {
  /** 별칭(선택) */
  label?: InputMaybe<Scalars['String']['input']>
  /** 가맹점 ID (관리자용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 검증 송금 ID */
  microTransferId: Scalars['ID']['input']
  /** 2자리 검증 코드 */
  verificationCode: Scalars['String']['input']
}

export type RejectCryptoPayoutInput = {
  /** Crypto payout order ID */
  orderId: Scalars['String']['input']
  /** Reason for rejecting the payout approval */
  reason?: InputMaybe<Scalars['String']['input']>
}

export type RejectHoldingPaymentInput = {
  /** 거절할 PaymentAdjustment ID */
  id: Scalars['String']['input']
  /** 거절 사유 */
  reason?: InputMaybe<Scalars['String']['input']>
}

export type RejectManualRefundInput = {
  /** 거절할 수동 환불 ID */
  id: Scalars['String']['input']
  /** 거절 사유 (필수) */
  reviewNote: Scalars['String']['input']
}

export type RejectOfframpInput = {
  /** Offramp order ID */
  orderId: Scalars['String']['input']
  /** Reason for rejecting the offramp approval */
  reason?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type RejectOnrampInput = {
  /** Onramp order ID */
  orderId: Scalars['String']['input']
  /** Reason for rejecting the onramp approval */
  reason?: InputMaybe<Scalars['String']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type RejectRefundApprovalInput = {
  id: Scalars['String']['input']
  note: Scalars['String']['input']
}

export type ReorderMenusInput = {
  items: Array<MenuOrderItem>
}

/** Batch wrapper for client error events */
export type ReportClientErrorsInput = {
  errors: Array<ClientErrorInput>
}

/** Response for reportClientErrors mutation */
export type ReportClientErrorsResponse = {
  __typename?: 'ReportClientErrorsResponse'
  /** Number of error events accepted for logging */
  accepted: Scalars['Int']['output']
}

/** Safety Withdraw 검증 송금 요청 */
export type RequestMicroTransferInput = {
  /** 검증할 지갑 주소 */
  address: Scalars['String']['input']
  /** L3 통화 코드 (예: TRON_USDT) */
  currency: Scalars['String']['input']
  /** 가맹점 ID (관리자용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type ResendLoginDeviceCodeInput = {
  deviceVerificationToken: Scalars['String']['input']
}

export type ResolveReconciliationMismatchItemInput = {
  id: Scalars['ID']['input']
  note: Scalars['String']['input']
}

export type ResolveRefundReconciliationInput = {
  actualRefundedAmount?: InputMaybe<Scalars['Float']['input']>
  note: Scalars['String']['input']
  paymentId: Scalars['String']['input']
  providerRefundId?: InputMaybe<Scalars['String']['input']>
  refundTxId: Scalars['String']['input']
  resolution: RefundReconciliationResolution
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type RetryOnrampFundingTransferInput = {
  /** Onramp order ID */
  orderId: Scalars['String']['input']
}

/** 출금 재처리 입력 (ON_HOLD → PROCESSING) */
export type RetryWithdrawalInput = {
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
  /** 출금 요청 ID */
  withdrawalId: Scalars['String']['input']
}

export type RevokeUserMenuAccessInput = {
  menuId: Scalars['Int']['input']
  userId: Scalars['Int']['input']
}

/** 위험 수준 */
export enum RiskLevel {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
}

export type RiskManagementProviderModel = {
  __typename?: 'RiskManagementProviderModel'
  code: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  priority: Scalars['Int']['output']
  status: RiskProviderStatus
  updatedAt: Scalars['DateTime']['output']
}

/** AML 위험 관리 공급자 상태 */
export enum RiskProviderStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type RoleMenu = {
  __typename?: 'RoleMenu'
  canCreate: Scalars['Boolean']['output']
  canDelete: Scalars['Boolean']['output']
  canEdit: Scalars['Boolean']['output']
  canExport: Scalars['Boolean']['output']
  canView: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  isDefault: Scalars['Boolean']['output']
  isDeleted: Scalars['Boolean']['output']
  menuId: Scalars['Int']['output']
  role: UserRole
  updatedAt: Scalars['DateTime']['output']
}

export type RoleMenuPermissionInput = {
  canCreate?: Scalars['Boolean']['input']
  canDelete?: Scalars['Boolean']['input']
  canEdit?: Scalars['Boolean']['input']
  canExport?: Scalars['Boolean']['input']
  canView?: Scalars['Boolean']['input']
  isDefault?: Scalars['Boolean']['input']
  menuId: Scalars['Int']['input']
  role: UserRole
}

export type RoleMenuPermissionItem = {
  canCreate?: Scalars['Boolean']['input']
  canDelete?: Scalars['Boolean']['input']
  canEdit?: Scalars['Boolean']['input']
  canExport?: Scalars['Boolean']['input']
  canView?: Scalars['Boolean']['input']
  menuId: Scalars['Int']['input']
}

export type RollbackTopupInput = {
  /** Completed Topup ID to roll back */
  id: Scalars['Int']['input']
  /** Reason for the rollback */
  reason: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

/** 스케줄러 실행 유형 */
export enum SchedulerExecutionType {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
  RETRY = 'RETRY',
}

export type SchedulerLog = {
  __typename?: 'SchedulerLog'
  /** 완료 시간 */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  /** 실행 시간 (밀리초) */
  duration?: Maybe<Scalars['Int']['output']>
  /** 에러 메시지 */
  errorMessage?: Maybe<Scalars['String']['output']>
  /** 에러 스택 */
  errorStack?: Maybe<Scalars['String']['output']>
  /** 실행 유형 */
  executionType: SchedulerExecutionType
  id: Scalars['Int']['output']
  /** 실행 파라미터 */
  parameters?: Maybe<Scalars['JSON']['output']>
  /** 처리 데이터 */
  processedData?: Maybe<Scalars['JSON']['output']>
  /** 스케줄러 이름 */
  schedulerName: Scalars['String']['output']
  /** 시작 시간 */
  startedAt: Scalars['DateTime']['output']
  /** 실행 상태 */
  status: SchedulerStatus
  /** 실행 주체 */
  triggeredBy?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type SchedulerLogFilterInput = {
  /** 실행 유형 */
  executionType?: InputMaybe<SchedulerExecutionType>
  /** 스케줄러 이름 */
  schedulerName?: InputMaybe<SchedulerName>
  /** 시작일 (ISO 8601) */
  startedAtFrom?: InputMaybe<Scalars['String']['input']>
  /** 종료일 (ISO 8601) */
  startedAtTo?: InputMaybe<Scalars['String']['input']>
  /** 실행 상태 */
  status?: InputMaybe<SchedulerStatus>
  /** 실행 주체 */
  triggeredBy?: InputMaybe<Scalars['String']['input']>
}

/** 스케줄러 로그 목록 */
export type SchedulerLogList = {
  __typename?: 'SchedulerLogList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<SchedulerLog>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 스케줄러 이름 */
export enum SchedulerName {
  AIRWALLEX_RECONCILIATION = 'AIRWALLEX_RECONCILIATION',
  CLEANUP_OLD_LOGS = 'CLEANUP_OLD_LOGS',
  COBO_RECONCILIATION = 'COBO_RECONCILIATION',
  CRYPTO_EXCHANGE_RATE_UPDATE = 'CRYPTO_EXCHANGE_RATE_UPDATE',
  DAILY_SETTLEMENT = 'DAILY_SETTLEMENT',
  DAILY_TRANSACTION_AGGREGATION = 'DAILY_TRANSACTION_AGGREGATION',
  DATA_CLEANUP = 'DATA_CLEANUP',
  EXCHANGE_RATE_UPDATE = 'EXCHANGE_RATE_UPDATE',
  EXPORT_CLEANUP = 'EXPORT_CLEANUP',
  HOURLY_TRANSACTION_AGGREGATION = 'HOURLY_TRANSACTION_AGGREGATION',
  INTERNAL_ACCOUNT_TRIAL_BALANCE = 'INTERNAL_ACCOUNT_TRIAL_BALANCE',
  MERCHANT_CURRENCY_BALANCE_RECONCILIATION = 'MERCHANT_CURRENCY_BALANCE_RECONCILIATION',
  OFFRAMP_STALE_PROCESSING_RECONCILIATION = 'OFFRAMP_STALE_PROCESSING_RECONCILIATION',
  PAYMENT_STATUS_CHECK = 'PAYMENT_STATUS_CHECK',
  PG_DISPATCH_RECONCILIATION = 'PG_DISPATCH_RECONCILIATION',
  PG_FIAT_ORDER_CRYPTO_SETTLEMENT = 'PG_FIAT_ORDER_CRYPTO_SETTLEMENT',
  REFUND_DISPATCH_RECONCILIATION = 'REFUND_DISPATCH_RECONCILIATION',
  WEBHOOK_RETRY = 'WEBHOOK_RETRY',
}

/** 스케줄러 상태 */
export enum SchedulerStatus {
  FAILED = 'FAILED',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS',
}

export type SecurityPolicyModel = {
  __typename?: 'SecurityPolicyModel'
  adminIpWhitelistEnabled: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  requireTwoFactorForAdmin: Scalars['Boolean']['output']
  requireTwoFactorForDeveloper: Scalars['Boolean']['output']
  requireTwoFactorForMerchantAdmin: Scalars['Boolean']['output']
  requireTwoFactorForMerchantUser: Scalars['Boolean']['output']
}

export type SetAdminIpWhitelistEnabledInput = {
  enabled: Scalars['Boolean']['input']
}

export type SetMerchantIpWhitelistEnabledInput = {
  enabled: Scalars['Boolean']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type SetPasswordByTokenInput = {
  /** 새 비밀번호 */
  password: Scalars['String']['input']
  /** 비밀번호 확인 */
  passwordConfirm: Scalars['String']['input']
  /** 비밀번호 재설정 토큰 */
  token: Scalars['String']['input']
}

/** 정산 정보 */
export type Settlement = {
  __typename?: 'Settlement'
  /** 정산 완료일 */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** 생성일 */
  createdAt: Scalars['DateTime']['output']
  /** 통화 */
  currency?: Maybe<Scalars['String']['output']>
  /** Currency 테이블 참조 ID */
  currencyId: Scalars['Int']['output']
  /** 수수료 */
  feeAmount: Scalars['Float']['output']
  /** 총 거래 금액 */
  grossAmount: Scalars['Float']['output']
  /** 정산 ID */
  id: Scalars['Int']['output']
  /** 정산 대상 가맹점 정보 */
  merchant: Merchant
  /** 가맹점 ID */
  merchantId: Scalars['Int']['output']
  /** 실 정산액 */
  netAmount: Scalars['Float']['output']
  /** 결제 건수 */
  paymentCount: Scalars['Int']['output']
  /** 환불 금액 */
  refundAmount: Scalars['Float']['output']
  /** 환불 건수 */
  refundCount: Scalars['Int']['output']
  /** 환불 수수료 (가맹점 부담) */
  refundFeeAmount: Scalars['Float']['output']
  /** 환불 수수료 발생 건수 */
  refundFeeCount: Scalars['Int']['output']
  /** 정산 시작일시 */
  settlementDateFrom: Scalars['DateTime']['output']
  /** 정산 종료일시 */
  settlementDateTo: Scalars['DateTime']['output']
  /** 정산 상태 */
  status: SettlementStatus
  /** 거래 건수 */
  transactionCount: Scalars['Int']['output']
  /** 수정일 */
  updatedAt: Scalars['DateTime']['output']
}

/** 정산 엑셀 다운로드 응답 */
export type SettlementExcelResponse = {
  __typename?: 'SettlementExcelResponse'
  /** 즉시 다운로드 URL (1000건 이하인 경우) */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** 비동기 작업 ID (1000건 초과인 경우) */
  jobId?: Maybe<Scalars['String']['output']>
  /** 처리 메시지 */
  message: Scalars['String']['output']
  /** 총 레코드 수 */
  recordCount: Scalars['Int']['output']
}

export type SettlementFilterInput = {
  /** 통화 코드 */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 엑셀 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 가맹점 ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 검색 키워드 */
  searchKeyword?: InputMaybe<Scalars['String']['input']>
  /** 검색 필드 유형 */
  searchType?: InputMaybe<SettlementSearchField>
  /** 정산일 시작 */
  settlementDateFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 정산일 종료 */
  settlementDateTo?: InputMaybe<Scalars['DateTime']['input']>
  /** 정산 ID (상세페이지 단건 다운로드용) */
  settlementId?: InputMaybe<Scalars['Int']['input']>
  /** 정산 상태 */
  status?: InputMaybe<SettlementStatus>
}

export type SettlementInfoInput = {
  /** 은행 주소 */
  bankAddress?: InputMaybe<Scalars['String']['input']>
  /** 은행 지점명 */
  bankBranch?: InputMaybe<Scalars['String']['input']>
  /** 은행명 */
  bankName?: InputMaybe<Scalars['String']['input']>
  /** 정산 지역 */
  settlementArea?: InputMaybe<Scalars['String']['input']>
  /** SWIFT 코드 */
  swiftCode?: InputMaybe<Scalars['String']['input']>
}

export type SettlementList = {
  __typename?: 'SettlementList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<Settlement>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 정산 검색 필드 */
export enum SettlementSearchField {
  MERCHANT_ID = 'MERCHANT_ID',
  MERCHANT_MID = 'MERCHANT_MID',
  MERCHANT_NAME = 'MERCHANT_NAME',
}

/** 정산 상태 */
export enum SettlementStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
}

export type SignInInput = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type SignInResponse = {
  __typename?: 'SignInResponse'
  accessToken?: Maybe<Scalars['String']['output']>
  /** 코드를 보낸 이메일(마스킹) */
  deviceVerificationEmail?: Maybe<Scalars['String']['output']>
  /** 새 기기 이메일 코드 입력 필요 */
  deviceVerificationRequired?: Maybe<Scalars['Boolean']['output']>
  /** 새 기기 확인용 단기 토큰 */
  deviceVerificationToken?: Maybe<Scalars['String']['output']>
  /** 로그인 후 2FA 등록 강제 필요 */
  enrollmentRequired?: Maybe<Scalars['Boolean']['output']>
  refreshToken?: Maybe<Scalars['String']['output']>
  /** 2FA 코드 입력 필요 */
  twoFactorRequired?: Maybe<Scalars['Boolean']['output']>
  /** 2FA 검증용 단기 토큰 */
  twoFactorToken?: Maybe<Scalars['String']['output']>
}

export type SignerInfoInput = {
  /** 서명권자 생년월일 */
  signerBirthDate?: InputMaybe<Scalars['String']['input']>
  /** 신분증 파일 경로 */
  signerIdDocument?: InputMaybe<Scalars['String']['input']>
  /** 신분증 번호 */
  signerIdNumber?: InputMaybe<Scalars['String']['input']>
  /** 신분증 타입 */
  signerIdType?: InputMaybe<IdType>
  /** 신분증 유효기간 시작일 */
  signerIdValidFrom?: InputMaybe<Scalars['String']['input']>
  /** 신분증 유효기간 종료일 */
  signerIdValidTo?: InputMaybe<Scalars['String']['input']>
  /** 서명권자 이름 */
  signerName?: InputMaybe<Scalars['String']['input']>
  /** 거주지 주소 */
  signerResidentialAddress?: InputMaybe<Scalars['String']['input']>
  /** 거주 국가 */
  signerResidentialCountry?: InputMaybe<CountryCode>
}

export type SimulateTopupDepositResult = {
  __typename?: 'SimulateTopupDepositResult'
  depositId: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export type StartChannelFundFlowSyncInput = {
  channelCode: Scalars['String']['input']
  from?: InputMaybe<Scalars['DateTime']['input']>
  to?: InputMaybe<Scalars['DateTime']['input']>
}

export type StartCryptoPayoutInput = {
  /** Target address for crypto payout */
  address: Scalars['String']['input']
  /** Payout amount */
  amount: Scalars['Float']['input']
  /** Currency code for crypto payout */
  currency: Scalars['String']['input']
  /** Merchant ID. Required for admin users. */
  merchantId?: InputMaybe<Scalars['Int']['input']>
}

export type StartOfframpInput = {
  /** Merchant ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** Amount to offramp (must be greater than 0) */
  originAmount: Scalars['Float']['input']
  /** Origin currency code */
  originCurrency: Scalars['String']['input']
  /** Target currency code */
  targetCurrency: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type StartOnrampInput = {
  /** Merchant ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** Amount to onramp */
  originAmount: Scalars['Float']['input']
  /** Origin currency code */
  originCurrency: Scalars['String']['input']
  /** Target currency code */
  targetCurrency: Scalars['String']['input']
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type SubmitTopupRequestEvidenceInput = {
  bankOrderNo?: InputMaybe<Scalars['String']['input']>
  memo?: InputMaybe<Scalars['String']['input']>
  requestId: Scalars['String']['input']
}

export type SubmitWalletAddressInput = {
  /** Refund link token */
  token: Scalars['String']['input']
  /** Crypto wallet address */
  walletAddress: Scalars['String']['input']
}

export type SubmitWalletAddressResponse = {
  __typename?: 'SubmitWalletAddressResponse'
  /** Response message */
  message: Scalars['String']['output']
  /** Transaction ID (if refund was processed) */
  refundId: Scalars['String']['output']
  /** Status of the submission */
  status: Scalars['String']['output']
}

export type Subscription = {
  __typename?: 'Subscription'
  /** Subscribe to real-time cobo payment status updates */
  coboPaymentSessionStatusUpdates: CheckoutSessionStatusUpdate
  /** Subscribe to real-time exchange rate updates */
  exchangeRates: ExchangeRateUpdate
  /** Subscribe to real-time payment status updates */
  paymentStatusUpdates: PaymentStatusUpdate
}

export type SubscriptionCoboPaymentSessionStatusUpdatesArgs = {
  sessionId: Scalars['String']['input']
}

export type SubscriptionExchangeRatesArgs = {
  from: Scalars['String']['input']
  to: Array<Scalars['String']['input']>
}

export type SubscriptionPaymentStatusUpdatesArgs = {
  paymentId: Scalars['String']['input']
}

export type SyncChannelFundFlowsResult = {
  __typename?: 'SyncChannelFundFlowsResult'
  results: Array<SyncChannelResult>
}

export type SyncChannelResult = {
  __typename?: 'SyncChannelResult'
  channelCode: Scalars['String']['output']
  error?: Maybe<Scalars['String']['output']>
  fetched: Scalars['Int']['output']
  success: Scalars['Boolean']['output']
  upserted: Scalars['Int']['output']
}

export type SystemSettingModel = {
  __typename?: 'SystemSettingModel'
  category: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  value: Scalars['String']['output']
  valueType: Scalars['String']['output']
}

/** 토큰별 페이아웃 분포 항목 */
export type TokenBreakdownItem = {
  __typename?: 'TokenBreakdownItem'
  /** 금액 합 (성공) */
  amount: Scalars['Float']['output']
  /** 평균 금액 */
  avgAmount: Scalars['Float']['output']
  /** 건수 (성공) */
  count: Scalars['Int']['output']
  /** 토큰 코드 (예: USDT, USDC) */
  token: Scalars['String']['output']
}

/** 토큰-네트워크 조합 페이아웃 분포 항목 */
export type TokenNetworkBreakdownItem = {
  __typename?: 'TokenNetworkBreakdownItem'
  /** 금액 합 (성공) */
  amount: Scalars['Float']['output']
  /** 평균 금액 */
  avgAmount: Scalars['Float']['output']
  /** 건수 (성공) */
  count: Scalars['Int']['output']
  /** 네트워크 (예: TRON, ETHEREUM) */
  network: Scalars['String']['output']
  /** 토큰 코드 (예: USDT) */
  token: Scalars['String']['output']
}

/** 통화 토큰 유형 */
export enum TokenType {
  /** 네이티브 크립토 (BTC, ETH 등) */
  CRYPTO = 'CRYPTO',
  /** 법정화폐 (USD, KRW 등) */
  FIAT = 'FIAT',
  /** 스테이블코인 (네트워크 지정, TRON_USDT, ETH_USDT 등) */
  STABLECOIN = 'STABLECOIN',
  /** 스테이블코인 베이스 토큰 (네트워크 미지정, USDT/USDC - 체크아웃 세션 임시 참조용) */
  STABLECOIN_BASE = 'STABLECOIN_BASE',
}

/** 채널의 충전 입금 정보 제공 방식 */
export enum TopupAccountSource {
  ADDRESS = 'ADDRESS',
  FETCH = 'FETCH',
  MANUAL = 'MANUAL',
}

export type TopupAddressFilterInput = {
  /** 블록체인 주소 검색 */
  address?: InputMaybe<Scalars['String']['input']>
  /** 커스텀 ID 검색 */
  customId?: InputMaybe<Scalars['String']['input']>
  /** 활성 상태 필터 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 토큰 ID 필터 */
  tokenId?: InputMaybe<Scalars['String']['input']>
}

export type TopupAddressGroupPage = {
  __typename?: 'TopupAddressGroupPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<TopupAddressGroupResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type TopupAddressGroupResponse = {
  __typename?: 'TopupAddressGroupResponse'
  /** 활성 주소 수 */
  activeCount: Scalars['Int']['output']
  /** 최초 생성일 */
  createdAt: Scalars['DateTime']['output']
  /** 가맹점 커스텀 ID */
  customId: Scalars['String']['output']
  /** 가장 최근 활성 주소 */
  latestAddress?: Maybe<Scalars['String']['output']>
  /** Merchant associated with the topup address group */
  merchant?: Maybe<Merchant>
  merchantId: Scalars['Int']['output']
  /** 주문명 */
  orderName?: Maybe<Scalars['String']['output']>
  /** 포함된 토큰 목록 */
  tokenIds: Array<Scalars['String']['output']>
  /** 전체 주소 수 */
  totalCount: Scalars['Int']['output']
  /** 최근 수정일 */
  updatedAt: Scalars['DateTime']['output']
}

export type TopupAddressPage = {
  __typename?: 'TopupAddressPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<TopupAddressResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type TopupAddressResponse = {
  __typename?: 'TopupAddressResponse'
  /** 블록체인 주소 */
  address?: Maybe<Scalars['String']['output']>
  /** 블록체인 네트워크 */
  chain?: Maybe<Scalars['String']['output']>
  /** 생성일 */
  createdAt: Scalars['DateTime']['output']
  /** 가맹점 커스텀 ID */
  customId: Scalars['String']['output']
  /** 비활성 일시 */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>
  /** 비활성 사유 */
  deactivatedReason?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** 활성 상태 */
  isActive: Scalars['Boolean']['output']
  /** Merchant associated with the topup address */
  merchant?: Maybe<Merchant>
  merchantId: Scalars['Int']['output']
  /** 최소 충전 금액 */
  minAmount?: Maybe<Scalars['String']['output']>
  /** 주문명 */
  orderName?: Maybe<Scalars['String']['output']>
  /** 토큰 식별자 (e.g., TRON_USDT) */
  tokenId: Scalars['String']['output']
  /** 수정일 */
  updatedAt: Scalars['DateTime']['output']
}

/** Topup channel enum */
export enum TopupChannel {
  AIRWALLEX = 'AIRWALLEX',
  COBO = 'COBO',
  HASHKEY = 'HASHKEY',
  PYVIO = 'PYVIO',
}

export type TopupChannelAccountInfo = {
  __typename?: 'TopupChannelAccountInfo'
  accountName?: Maybe<Scalars['String']['output']>
  accountNumber?: Maybe<Scalars['String']['output']>
  bankCode?: Maybe<Scalars['String']['output']>
  bankName?: Maybe<Scalars['String']['output']>
  branchCode?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  swiftCode?: Maybe<Scalars['String']['output']>
}

export type TopupCryptoAddressInfo = {
  __typename?: 'TopupCryptoAddressInfo'
  address: Scalars['String']['output']
  chain: Scalars['String']['output']
  qrDataUrl: Scalars['String']['output']
  tokenId: Scalars['String']['output']
}

export type TopupDetailResponse = {
  __typename?: 'TopupDetailResponse'
  /** Topup channel */
  channel: TopupChannel
  /** Topup channel account number */
  channelAccountNo?: Maybe<Scalars['String']['output']>
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order ID */
  channelOrderId: Scalars['String']['output']
  /** Linked channel transfer ID */
  channelTransferId?: Maybe<Scalars['String']['output']>
  /** Completion timestamp */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** Currency code */
  currency: Scalars['String']['output']
  /** Fee amount */
  feeAmount?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  /** Merchant associated with the topup */
  merchant?: Maybe<Merchant>
  /** Merchant ID */
  merchantId?: Maybe<Scalars['Int']['output']>
  /** Metadata */
  metaData?: Maybe<Scalars['JSON']['output']>
  /** Net amount */
  netAmount?: Maybe<Scalars['Float']['output']>
  /** Topup order number */
  orderId: Scalars['String']['output']
  /** Processor user ID */
  processedBy?: Maybe<Scalars['Int']['output']>
  /** Processor name */
  processedByName?: Maybe<Scalars['String']['output']>
  /** Received amount */
  receivedAmount: Scalars['Float']['output']
  /** Resolution reason */
  resolutionReason?: Maybe<Scalars['String']['output']>
  /** Rollback reason */
  rollbackReason?: Maybe<Scalars['String']['output']>
  /** Rollback timestamp */
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>
  /** Rollback user ID */
  rolledBackBy?: Maybe<Scalars['Int']['output']>
  /** Rollback user name */
  rolledBackByName?: Maybe<Scalars['String']['output']>
  /** Topup status */
  status: TopupStatus
  /** Whether the deposit is not linked to a top-up request (administrators only) */
  unmatchedDeposit?: Maybe<Scalars['Boolean']['output']>
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output']
}

export type TopupListInput = {
  /** Topup channel */
  channel?: InputMaybe<TopupChannel>
  /** Topup order ID or channel order ID */
  orderId?: InputMaybe<Scalars['String']['input']>
  /** Topup status */
  status?: InputMaybe<TopupStatus>
}

export type TopupPage = {
  __typename?: 'TopupPage'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<TopupResponse>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type TopupRequestDetail = {
  __typename?: 'TopupRequestDetail'
  accountInfo?: Maybe<TopupChannelAccountInfo>
  amount: Scalars['Float']['output']
  bankOrderNo?: Maybe<Scalars['String']['output']>
  cancelledAt?: Maybe<Scalars['DateTime']['output']>
  channel?: Maybe<Scalars['String']['output']>
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  cryptoInfo?: Maybe<TopupCryptoAddressInfo>
  currency: Scalars['String']['output']
  evidenceMemo?: Maybe<Scalars['String']['output']>
  evidenceSubmittedAt?: Maybe<Scalars['DateTime']['output']>
  expiresAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  merchantId: Scalars['Int']['output']
  paymentReference?: Maybe<Scalars['String']['output']>
  receivedAmount?: Maybe<Scalars['Float']['output']>
  requestId: Scalars['String']['output']
  status: TopupRequestStatus
  tokenId?: Maybe<Scalars['String']['output']>
  topupId?: Maybe<Scalars['Int']['output']>
}

export type TopupRequestFilterInput = {
  channel?: InputMaybe<Scalars['String']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<TopupRequestStatus>
}

export type TopupRequestList = {
  __typename?: 'TopupRequestList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<TopupRequestModel>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

export type TopupRequestModel = {
  __typename?: 'TopupRequestModel'
  amount: Scalars['Float']['output']
  bankOrderNo?: Maybe<Scalars['String']['output']>
  cancelledAt?: Maybe<Scalars['DateTime']['output']>
  channel?: Maybe<Scalars['String']['output']>
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  currency: Scalars['String']['output']
  evidenceMemo?: Maybe<Scalars['String']['output']>
  evidenceSubmittedAt?: Maybe<Scalars['DateTime']['output']>
  expiresAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  merchantId: Scalars['Int']['output']
  paymentReference?: Maybe<Scalars['String']['output']>
  receivedAmount?: Maybe<Scalars['Float']['output']>
  requestId: Scalars['String']['output']
  status: TopupRequestStatus
  tokenId?: Maybe<Scalars['String']['output']>
  topupId?: Maybe<Scalars['Int']['output']>
}

/** 충전 요청 상태 */
export enum TopupRequestStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  EVIDENCE_SUBMITTED = 'EVIDENCE_SUBMITTED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
}

export type TopupResponse = {
  __typename?: 'TopupResponse'
  /** Topup channel */
  channel: TopupChannel
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order ID */
  channelOrderId: Scalars['String']['output']
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** Currency code */
  currency: Scalars['String']['output']
  /** Fee amount */
  feeAmount?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  /** Merchant associated with the topup */
  merchant?: Maybe<Merchant>
  /** Merchant ID */
  merchantId?: Maybe<Scalars['Int']['output']>
  /** Net amount */
  netAmount?: Maybe<Scalars['Float']['output']>
  /** Topup order number */
  orderId: Scalars['String']['output']
  /** Received amount */
  receivedAmount: Scalars['Float']['output']
  /** Topup status */
  status: TopupStatus
  /** Whether the deposit is not linked to a top-up request (administrators only) */
  unmatchedDeposit?: Maybe<Scalars['Boolean']['output']>
}

/** Topup status enum */
export enum TopupStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
  OMITTED = 'OMITTED',
  PENDING = 'PENDING',
  REFUNDING = 'REFUNDING',
  ROLLED_BACK = 'ROLLED_BACK',
  UNKNOWN = 'UNKNOWN',
  WAIT_CONFIRM = 'WAIT_CONFIRM',
}

/** 거래 정보 */
export type Transaction = {
  __typename?: 'Transaction'
  /** 거래 금액 */
  amount: Scalars['Float']['output']
  /** 자동환불 유형 */
  autoRefundType?: Maybe<AutoRefundType>
  /** 블록 번호 */
  blockNumber?: Maybe<Scalars['Int']['output']>
  /** 블록체인 트랜잭션 해시 */
  blockchainTxHash?: Maybe<Scalars['String']['output']>
  /** 컨펌 수 */
  confirmations?: Maybe<Scalars['Int']['output']>
  /** 생성일 */
  createdAt: Scalars['DateTime']['output']
  /** 통화 (레거시, currencyId 사용 권장) */
  currency?: Maybe<Scalars['String']['output']>
  /** Currency 테이블 참조 ID */
  currencyId: Scalars['Int']['output']
  /** 실패 코드 */
  failureCode?: Maybe<Scalars['String']['output']>
  /** 실패 메시지 */
  failureMessage?: Maybe<Scalars['String']['output']>
  /** 거래를 처리한 PG사 정보 */
  gateway?: Maybe<PaymentGateway>
  /** PG사 수수료 */
  gatewayFeeAmount?: Maybe<Scalars['Float']['output']>
  /** PG사 ID */
  gatewayId: Scalars['Int']['output']
  /** PG사가 생성한 거래 ID */
  gatewayTransactionId?: Maybe<Scalars['String']['output']>
  /** 거래 ID */
  id: Scalars['ID']['output']
  /** 자동환불 여부 */
  isAutoRefund: Scalars['Boolean']['output']
  /** 부분 환불 여부 */
  isPartial: Scalars['Boolean']['output']
  /** 가맹점 수수료 금액 */
  merchantFeeAmount?: Maybe<Scalars['Float']['output']>
  /** 가맹점 수수료율 */
  merchantFeeRate?: Maybe<Scalars['Float']['output']>
  /** 가맹점 순수취액 */
  merchantNetAmount?: Maybe<Scalars['Float']['output']>
  /** 가맹점 거래 ID */
  merchantTransactionId?: Maybe<Scalars['String']['output']>
  /** 원 거래 ID (환불인 경우) */
  originalTxId?: Maybe<Scalars['String']['output']>
  /** Amount to be paid */
  payableAmount?: Maybe<Scalars['Float']['output']>
  /** Currency of the payable amount */
  payableCurrency?: Maybe<Scalars['String']['output']>
  /** 실제 결제 Currency 테이블 참조 ID */
  payableCurrencyId?: Maybe<Scalars['Int']['output']>
  /** 실제 결제 네트워크 (Currency 테이블에서 resolve) */
  payableNetwork?: Maybe<Scalars['String']['output']>
  /** 거래가 속한 결제 정보 */
  payment?: Maybe<Payment>
  /** 결제 ID */
  paymentId: Scalars['String']['output']
  /** 처리 일시 */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** 환불 사유 */
  refundReason?: Maybe<Scalars['String']['output']>
  /** 정산 예정일 */
  settlementDate?: Maybe<Scalars['DateTime']['output']>
  /** 거래 상태 */
  status: TransactionStatus
  /** PG사 상태 코드 */
  statusCode?: Maybe<Scalars['String']['output']>
  /** PG사 상태 메시지 */
  statusMessage?: Maybe<Scalars['String']['output']>
  /** PG사에 전달하는 거래 키 (내부용) */
  transactionKey?: Maybe<Scalars['String']['output']>
  /** 거래 타입 */
  type: TransactionType
  /** 수정일 */
  updatedAt: Scalars['DateTime']['output']
}

export type TransactionCreator = {
  __typename?: 'TransactionCreator'
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  userId: Scalars['Int']['output']
}

/** 거래 내역 엑셀 다운로드 필터 */
export type TransactionExcelFilterInput = {
  /** 통화 */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 엑셀 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 가맹점 ID */
  merchantId: Scalars['Int']['input']
  /** 정산 기준 시작일 */
  settlementDateFrom: Scalars['DateTime']['input']
  /** 정산 기준 종료일 */
  settlementDateTo: Scalars['DateTime']['input']
}

/** 거래 엑셀 다운로드 응답 */
export type TransactionExcelResponse = {
  __typename?: 'TransactionExcelResponse'
  /** 즉시 다운로드 URL (1000건 이하인 경우) */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** 비동기 작업 ID (1000건 초과인 경우) */
  jobId?: Maybe<Scalars['String']['output']>
  /** 처리 메시지 */
  message: Scalars['String']['output']
  /** 총 레코드 수 */
  recordCount: Scalars['Int']['output']
}

/** 거래 상태 */
export enum TransactionStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

/** 거래 타입 */
export enum TransactionType {
  CANCEL = 'CANCEL',
  PAYMENT = 'PAYMENT',
  REFUND = 'REFUND',
}

/** 이체 유형 */
export enum TransferType {
  /** 은행 송금 (SWIFT 등) */
  BANK_WIRE = 'BANK_WIRE',
  /** 크립토 직접 이체 */
  CRYPTO = 'CRYPTO',
  /** 내부 이동 */
  INTERNAL = 'INTERNAL',
  /** 로컬 송금 (국내 이체) */
  LOCAL_TRANSFER = 'LOCAL_TRANSFER',
  /** 크립토→법정화폐 변환 */
  OFFRAMP = 'OFFRAMP',
}

export type UpdateChannelCapabilityInput = {
  capability: ChannelCapabilityType
  channelCode: Scalars['String']['input']
  /** 기능별 운영 설정값 (비밀값 저장 금지) */
  config?: InputMaybe<Scalars['JSON']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateChannelInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
  name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ChannelStatus>
}

export type UpdateCryptoRefundFeeInput = {
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 수수료 금액 또는 비율 */
  feeAmount?: InputMaybe<Scalars['Float']['input']>
  /** 수수료 타입 */
  feeType?: InputMaybe<CryptoRefundFeeType>
  /** 활성화 상태 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 최대 수수료 */
  maxFee?: InputMaybe<Scalars['Float']['input']>
  /** 최소 수수료 */
  minFee?: InputMaybe<Scalars['Float']['input']>
}

export type UpdateCurrencyInput = {
  /** 내부용 기본 토큰 (USDT, USD 등) */
  baseToken?: InputMaybe<Scalars['String']['input']>
  /** 소수점 자리수 */
  decimals?: InputMaybe<Scalars['Int']['input']>
  /** 통화 ID */
  id: Scalars['Int']['input']
  /** 활성 상태 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 환율 조회 대상 통화 여부 */
  isExchangeRateEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** 정산 가능 통화 여부 */
  isSettleable?: InputMaybe<Scalars['Boolean']['input']>
  /** 출금 가능 통화 여부 */
  isWithdrawable?: InputMaybe<Scalars['Boolean']['input']>
  /** AML 스크리닝 최소 금액 (null이면 전액 스크리닝) */
  minAmlScreeningAmount?: InputMaybe<Scalars['Float']['input']>
  /** 통화 이름 (US Dollar, Korean Won 등) */
  name?: InputMaybe<Scalars['String']['input']>
  /** 블록체인 네트워크 (TRON, ETH 등, Fiat은 null) */
  network?: InputMaybe<Scalars['String']['input']>
  /** 통화 기호 ($, ₩, ¥ 등) */
  symbol?: InputMaybe<Scalars['String']['input']>
  /** 통화 토큰 유형 (FIAT, STABLECOIN, CRYPTO) */
  tokenType?: InputMaybe<TokenType>
}

export type UpdateExceptionalTransferStatusInput = {
  /** 비정상 입금 ID */
  id: Scalars['Int']['input']
  /** 처리 메모 (외부에서 어떤 처리를 했는지 기록). undefined: 기존 메모 유지, 빈 문자열: 기존 메모 삭제, 일반 문자열: 새 값으로 덮어씀. */
  resolutionNote?: InputMaybe<Scalars['String']['input']>
  /** 변경할 상태 (RESOLVED 또는 IGNORED만 허용) */
  status: ExceptionalTransferStatus
}

export type UpdateExchangeRateInput = {
  /** 예금 마진 (%) - 예금 시 적용 */
  depositMargin?: InputMaybe<Scalars['Float']['input']>
  /** 환율 ID */
  id: Scalars['Int']['input']
  /** 결제 마진 (%) - 고객 결제 시 적용 */
  paymentMargin?: InputMaybe<Scalars['Float']['input']>
  /** 환율 */
  rate?: InputMaybe<Scalars['Float']['input']>
  /** 환율 출처 */
  source?: InputMaybe<ExchangeRateSource>
  /** 유효 시작일 (ISO 8601) */
  validFrom?: InputMaybe<Scalars['String']['input']>
  /** 유효 종료일 (ISO 8601) */
  validTo?: InputMaybe<Scalars['String']['input']>
  /** 출금 마진 (%) - 가맹점 출금 시 적용 */
  withdrawalMargin?: InputMaybe<Scalars['Float']['input']>
}

export type UpdateMenuInput = {
  code?: InputMaybe<Scalars['String']['input']>
  component?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  excludeRoles?: InputMaybe<Array<UserRole>>
  icon?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
  isPublic?: InputMaybe<Scalars['Boolean']['input']>
  isVisible?: InputMaybe<Scalars['Boolean']['input']>
  menuType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  parentId?: InputMaybe<Scalars['Int']['input']>
  path?: InputMaybe<Scalars['String']['input']>
  sortOrder?: InputMaybe<Scalars['Int']['input']>
  target?: InputMaybe<Scalars['String']['input']>
}

export type UpdateMerchantExchangeMarginInput = {
  /** 예금 마진율 (0~100%) */
  depositMarginRate?: InputMaybe<Scalars['Float']['input']>
  /** 활성화 상태 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 결제 마진율 (0~100%) */
  paymentMarginRate?: InputMaybe<Scalars['Float']['input']>
  /** 출금 마진율 (0~100%) */
  withdrawalMarginRate?: InputMaybe<Scalars['Float']['input']>
}

/** 가맹점 자주 쓰는 수취인 수정 */
export type UpdateMerchantFrequentRecipientInput = {
  /** 주소 */
  address: Scalars['String']['input']
  /** 네트워크 */
  network: Scalars['String']['input']
  /** 수취인 이름 */
  recipientName: Scalars['String']['input']
}

export type UpdateMerchantInput = {
  /** 추가 정보 */
  additionalInfo?: InputMaybe<Scalars['String']['input']>
  /** 관리자 이메일 (변경 불가 — 현재 값과 다르면 거부) */
  adminEmail?: InputMaybe<Scalars['String']['input']>
  /** 관리자 이름 - 시스템 관리자만 수정 가능 */
  adminName?: InputMaybe<Scalars['String']['input']>
  /** 관리자 전화 국가코드 - 시스템 관리자만 수정 가능 */
  adminPhoneCountryCode?: InputMaybe<Scalars['String']['input']>
  /** 관리자 전화번호 - 시스템 관리자만 수정 가능 */
  adminPhoneNumber?: InputMaybe<Scalars['String']['input']>
  /** 사업장 주소 */
  businessAddress?: InputMaybe<Scalars['String']['input']>
  /** 업종 */
  businessCategory?: InputMaybe<Scalars['String']['input']>
  /** 상호명 */
  businessName?: InputMaybe<Scalars['String']['input']>
  /** 사업자등록번호 */
  businessNumber?: InputMaybe<Scalars['String']['input']>
  /** 사업장 전화 국가코드 */
  businessPhoneCountryCode?: InputMaybe<Scalars['String']['input']>
  /** 사업장 전화번호 */
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>
  /** 회사 추가 정보 */
  companyInfo?: InputMaybe<CompanyInfoInput>
  /** 삭제할 문서 ID 목록 */
  deleteDocumentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  /** 첨부 서류 - 추가/수정할 문서들 */
  documents?: InputMaybe<Array<DocumentInput>>
  /** 상점 이메일 */
  email?: InputMaybe<Scalars['String']['input']>
  /** incorrect transfer 처리 모드 (AUTO_REFUND | UPDATE_PAYMENT) */
  exceptionHandlingMode?: InputMaybe<ExceptionHandlingMode>
  /** 상점 배경 설명 */
  merchantBackground?: InputMaybe<Scalars['String']['input']>
  /** 상점 ID - 관리자만 필요 */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 상점명 */
  name?: InputMaybe<Scalars['String']['input']>
  /** 관련 회사 */
  relevantCompany?: InputMaybe<Scalars['String']['input']>
  /** 대표자명 */
  representativeName?: InputMaybe<Scalars['String']['input']>
  /** 위험 수준 - 관리자만 수정 가능 */
  riskLevel?: InputMaybe<RiskLevel>
  /** 정산 상세 정보 */
  settlementInfo?: InputMaybe<SettlementInfoInput>
  /** 서명권자 정보 */
  signerInfo?: InputMaybe<SignerInfoInput>
  /** 상점 상태 - 관리자만 수정 가능 */
  status?: InputMaybe<MerchantStatus>
  /** 상점 타입 - 관리자만 수정 가능 */
  type?: InputMaybe<MerchantType>
  /** 웹훅 URL - 가맹점 관리자와 시스템 관리자 수정 가능 */
  webhookUrl?: InputMaybe<Scalars['String']['input']>
}

export type UpdateMerchantPaymentMethodInput = {
  /** 통화별 수수료 설정 */
  currencyFees?: InputMaybe<Scalars['JSON']['input']>
  /** 커스텀 라우팅 ID */
  customRoutingId?: InputMaybe<Scalars['Int']['input']>
  /** 일일 한도 금액 */
  dailyLimitAmount?: InputMaybe<Scalars['Int']['input']>
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 표시 이름 */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** 수수료율 (%) */
  feeRate?: InputMaybe<Scalars['Float']['input']>
  /** 고정 수수료 (원) */
  fixedFee?: InputMaybe<Scalars['Float']['input']>
  /** 결제수단 ID */
  id: Scalars['Int']['input']
  /** 활성화 여부 */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** 최대 결제 금액 */
  maxAmount?: InputMaybe<Scalars['Float']['input']>
  /** 최대 수수료 (원) */
  maxFee?: InputMaybe<Scalars['Float']['input']>
  /** 최소 결제 금액 */
  minAmount?: InputMaybe<Scalars['Float']['input']>
  /** 최소 수수료 (원) */
  minFee?: InputMaybe<Scalars['Float']['input']>
  /** 월 한도 금액 */
  monthlyLimitAmount?: InputMaybe<Scalars['Int']['input']>
  /** 정산 주기 (일) - 관리자만 설정 가능 */
  settlementCycle?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateMerchantPaymentMethodResponse = {
  __typename?: 'UpdateMerchantPaymentMethodResponse'
  /** 수정된 가맹점 결제수단 */
  merchantPaymentMethod: MerchantPaymentMethod
  /** 응답 메시지 */
  message: Scalars['String']['output']
}

export type UpdateMerchantUserInput = {
  /** 이름 */
  name?: InputMaybe<Scalars['String']['input']>
  /** 전화 국가코드 */
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>
  /** 전화번호 */
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  /** 사용자 상태 (ADMIN만 변경 가능) */
  status?: InputMaybe<UserStatus>
  /** 수정할 사용자 ID */
  userId: Scalars['Int']['input']
}

export type UpdatePaymentGatewayInput = {
  /** API 버전 */
  apiVersion?: InputMaybe<Scalars['String']['input']>
  /** 기본 수수료율 (0% ~ 100%) */
  baseFeeRate?: InputMaybe<Scalars['Float']['input']>
  /** PG사 API 기본 URL */
  baseUrl?: InputMaybe<Scalars['String']['input']>
  /** 최대 결제 금액 */
  maxAmount?: InputMaybe<Scalars['Int']['input']>
  /** 최소 결제 금액 */
  minAmount?: InputMaybe<Scalars['Int']['input']>
  /** PG사 이름 */
  name?: InputMaybe<Scalars['String']['input']>
  /** 정산 주기 (일 단위) */
  settlementCycle?: InputMaybe<Scalars['Int']['input']>
  /** PG사 상태 */
  status?: InputMaybe<GatewayStatus>
  /** 지원하는 통화 목록 */
  supportedCurrencies?: InputMaybe<Array<Scalars['String']['input']>>
  /** 지원하는 결제 수단 목록 */
  supportedMethods?: InputMaybe<Array<PaymentMethod>>
  /** 즉시 정산 지원 여부 */
  supportsInstantSettlement?: InputMaybe<Scalars['Boolean']['input']>
  /** 부분 환불 지원 여부 */
  supportsPartialRefund?: InputMaybe<Scalars['Boolean']['input']>
  /** 정기 결제 지원 여부 */
  supportsRecurring?: InputMaybe<Scalars['Boolean']['input']>
  /** 웹훅 지원 여부 */
  supportsWebhook?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdatePaymentMethodConfigInput = {
  /** 기본 최대 결제 금액 */
  defaultMaxAmount?: InputMaybe<Scalars['Int']['input']>
  /** 기본 최소 결제 금액 */
  defaultMinAmount?: InputMaybe<Scalars['Int']['input']>
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 표시 이름 */
  displayName?: InputMaybe<Scalars['String']['input']>
  /** 아이콘 URL */
  icon?: InputMaybe<Scalars['String']['input']>
  /** 활성화 여부 */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** 추가 메타데이터 */
  metadata?: InputMaybe<Scalars['JSON']['input']>
  /** 우선순위 (높을수록 우선) */
  priority?: InputMaybe<Scalars['Int']['input']>
}

export type UpdatePaymentMethodRoutingInput = {
  /** 가용성 (0.0 ~ 1.0) */
  availability?: InputMaybe<Scalars['Float']['input']>
  /** 평균 응답시간 (ms) */
  avgResponseTime?: InputMaybe<Scalars['Int']['input']>
  /** 활성 상태 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 기본 라우팅 여부 */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  /** 우선순위 (높을수록 선호) */
  priority?: InputMaybe<Scalars['Int']['input']>
  /** 성공률 (0.0 ~ 1.0) */
  successRate?: InputMaybe<Scalars['Float']['input']>
}

export type UpdatePaymentRoutingInput = {
  gatewayId: Scalars['Int']['input']
  paymentMethod: PaymentMethod
  priority: Scalars['Int']['input']
}

/** 수수료 수정 입력 */
export type UpdatePgSettlementFeeInput = {
  /** 수수료 금액 */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** 통화 */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>
  /** 수수료 유형 */
  feeType?: InputMaybe<FeeType>
  /** 수수료 ID */
  id: Scalars['String']['input']
  /** 트랜잭션 해시 */
  txHash?: InputMaybe<Scalars['String']['input']>
}

/** PG 정산금 이체 요청 상태 업데이트 입력 */
export type UpdatePgSettlementTransferStatusInput = {
  /** 블록 번호 */
  blockNumber?: InputMaybe<Scalars['Int']['input']>
  /** 에러 코드 */
  errorCode?: InputMaybe<Scalars['String']['input']>
  /** 에러 메시지 */
  errorMessage?: InputMaybe<Scalars['String']['input']>
  /** 환율 (OFFRAMP용) */
  exchangeRate?: InputMaybe<Scalars['Float']['input']>
  /** 이체 요청 ID */
  id: Scalars['String']['input']
  /** 메모 */
  notes?: InputMaybe<Scalars['String']['input']>
  /** 수령 금액 (OFFRAMP용) */
  receivedAmount?: InputMaybe<Scalars['Float']['input']>
  /** 수령 통화 (OFFRAMP용) */
  receivedCurrency?: InputMaybe<Scalars['String']['input']>
  /** 새 상태 */
  status: PgSettlementTransferStatus
  /** 변환 목표 금액 (OFFRAMP용) */
  targetAmount?: InputMaybe<Scalars['Float']['input']>
  /** 트랜잭션 해시 */
  txHash?: InputMaybe<Scalars['String']['input']>
}

/** 환불 링크 고객 이메일 수정 입력 */
export type UpdateRefundLinkEmailInput = {
  /** 새 고객 이메일 주소 */
  customerEmail: Scalars['String']['input']
  /** 수정할 환불 링크 ID */
  refundLinkId: Scalars['String']['input']
}

/** 환불 링크 이메일 수정 응답 */
export type UpdateRefundLinkEmailResponse = {
  __typename?: 'UpdateRefundLinkEmailResponse'
  /** 새 고객 이메일 */
  customerEmail: Scalars['String']['output']
  /** 이메일 재발송 여부 */
  emailResent: Scalars['Boolean']['output']
  /** 메시지 (성공 또는 실패 사유) */
  message?: Maybe<Scalars['String']['output']>
  /** 수정된 환불 링크 ID */
  refundLinkId: Scalars['String']['output']
  /** 수정 성공 여부 */
  success: Scalars['Boolean']['output']
}

export type UpdateSecurityPolicyInput = {
  requireTwoFactorForAdmin?: InputMaybe<Scalars['Boolean']['input']>
  requireTwoFactorForDeveloper?: InputMaybe<Scalars['Boolean']['input']>
  requireTwoFactorForMerchantAdmin?: InputMaybe<Scalars['Boolean']['input']>
  requireTwoFactorForMerchantUser?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateSystemSettingInput = {
  category: Scalars['String']['input']
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

/** 사용자 정보 수정 입력 */
export type UpdateUserInput = {
  /** 이메일 (변경 불가 — 현재 값과 다르면 거부) */
  email?: InputMaybe<Scalars['String']['input']>
  /** 가맹점 ID (관리자용) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 이름 */
  name?: InputMaybe<Scalars['String']['input']>
  /** 휴대폰 국가코드 (예: +82, +1) */
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>
  /** 휴대폰 번호 */
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  /** 사용자 역할 (관리자용) */
  role?: InputMaybe<UserRole>
  /** 사용자 상태 (관리자용) */
  status?: InputMaybe<UserStatus>
  /** 수정할 사용자 ID (관리자용) */
  userId?: InputMaybe<Scalars['Int']['input']>
}

/** 출금 요청 수정 입력 */
export type UpdateWithdrawalInput = {
  /** 요청 금액 */
  requestedAmount?: InputMaybe<Scalars['Float']['input']>
  /** 2FA 코드 (정책 ON 시 필수) */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

export type UploadBatchCryptoPayoutInput = {
  /** Merchant payout batch number. Generated when omitted. */
  batchNo?: InputMaybe<Scalars['String']['input']>
  /** Confirmed FileUpload ID */
  fileId: Scalars['Int']['input']
  /** Merchant ID. Required for admin users. */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** Batch remark */
  remark?: InputMaybe<Scalars['String']['input']>
  /** 2FA code. Required when the security policy is enabled. */
  totpCode?: InputMaybe<Scalars['String']['input']>
}

/** PG 정산 지갑 설정 생성/수정 입력 */
export type UpsertPgSettlementWalletConfigInput = {
  /** Currency ID (Currency 테이블 참조) */
  currencyId: Scalars['Int']['input']
  /** Gateway ID */
  gatewayId: Scalars['Int']['input']
  /** 지갑 설정 ID (수정 시 필수) */
  id?: InputMaybe<Scalars['String']['input']>
  /** 활성화 여부 */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** 이 지갑이 속한 회계 채널 코드 (cobo, pyvio, hashkey, bank 등). 이체 완료 시 해당 채널로 내부 회계 분개가 기록됩니다. */
  targetChannelCode: Scalars['String']['input']
  /** 이체 대상 지갑 주소 */
  walletAddress: Scalars['String']['input']
  /** 지갑 메모 (일부 체인에 필요) */
  walletMemo?: InputMaybe<Scalars['String']['input']>
}

/** 사용자 */
export type User = {
  __typename?: 'User'
  /** 생성 일시 */
  createdAt: Scalars['DateTime']['output']
  /** 삭제 일시 */
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  /** 이메일 */
  email: Scalars['String']['output']
  /** 이메일 인증 여부 */
  emailVerified: Scalars['Boolean']['output']
  /** 이메일 인증 일시 */
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>
  /** 사용자 ID */
  id: Scalars['Int']['output']
  /** 삭제 여부 */
  isDeleted: Scalars['Boolean']['output']
  /** 마지막 로그인 일시 */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>
  /** 소속 가맹점 */
  merchant?: Maybe<Merchant>
  /** 가맹점 ID */
  merchantId?: Maybe<Scalars['Int']['output']>
  /** 이름 */
  name: Scalars['String']['output']
  /** 전화번호 국가코드 */
  phoneCountryCode?: Maybe<Scalars['String']['output']>
  /** 전화번호 */
  phoneNumber?: Maybe<Scalars['String']['output']>
  /** 전화번호 인증 여부 */
  phoneVerified: Scalars['Boolean']['output']
  /** 전화번호 인증 일시 */
  phoneVerifiedAt?: Maybe<Scalars['DateTime']['output']>
  /** 역할 */
  role: UserRole
  /** 상태 */
  status: UserStatus
  /** 현재 역할 정책상 로그인·자금 작업에 2FA 코드 입력이 필요한지 (정책 ON + 등록 완료) */
  twoFactorCodeRequired: Scalars['Boolean']['output']
  /** 2단계 인증 활성화 여부 */
  twoFactorEnabled: Scalars['Boolean']['output']
  /** 수정 일시 */
  updatedAt: Scalars['DateTime']['output']
}

export type UserMenu = {
  __typename?: 'UserMenu'
  canCreate: Scalars['Boolean']['output']
  canDelete: Scalars['Boolean']['output']
  canEdit: Scalars['Boolean']['output']
  canExport: Scalars['Boolean']['output']
  canView: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  expiresAt?: Maybe<Scalars['DateTime']['output']>
  grantedAt: Scalars['DateTime']['output']
  grantedBy?: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  isDeleted: Scalars['Boolean']['output']
  menuId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
  userId: Scalars['Int']['output']
}

export type UserMenuPermission = {
  __typename?: 'UserMenuPermission'
  /** 생성 권한 */
  canCreate: Scalars['Boolean']['output']
  /** 삭제 권한 */
  canDelete: Scalars['Boolean']['output']
  /** 수정 권한 */
  canEdit: Scalars['Boolean']['output']
  /** 내보내기 권한 */
  canExport: Scalars['Boolean']['output']
  /** 조회 권한 */
  canView: Scalars['Boolean']['output']
  /** 메뉴 코드 */
  menuCode: Scalars['String']['output']
  /** 메뉴 ID */
  menuId: Scalars['Int']['output']
  /** 메뉴 이름 */
  menuName: Scalars['String']['output']
  /** 메뉴 경로 */
  menuPath?: Maybe<Scalars['String']['output']>
}

export type UserMenuPermissionInput = {
  canCreate?: Scalars['Boolean']['input']
  canDelete?: Scalars['Boolean']['input']
  canEdit?: Scalars['Boolean']['input']
  canExport?: Scalars['Boolean']['input']
  canView?: Scalars['Boolean']['input']
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>
  menuId: Scalars['Int']['input']
  userId: Scalars['Int']['input']
}

/** 사용자 역할 */
export enum UserRole {
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
  MERCHANT_ADMIN = 'MERCHANT_ADMIN',
  MERCHANT_USER = 'MERCHANT_USER',
}

/** 사용자 상태 */
export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  SUSPENDED = 'SUSPENDED',
}

export type VerifyLoginDeviceInput = {
  code: Scalars['String']['input']
  deviceVerificationToken: Scalars['String']['input']
}

export type VerifyLoginTwoFactorInput = {
  code: Scalars['String']['input']
  twoFactorToken: Scalars['String']['input']
}

/** Safety Withdraw 검증 코드 단독 검증 입력 */
export type VerifyMicroTransferCodeInput = {
  /** Micro Transfer ID */
  microTransferId: Scalars['ID']['input']
  /** 2자리 검증 코드 */
  verificationCode: Scalars['String']['input']
}

/** Safety Withdraw 검증 코드 단독 검증 결과 */
export type VerifyMicroTransferCodeModel = {
  __typename?: 'VerifyMicroTransferCodeModel'
  /** 남은 코드 시도 횟수 */
  remainingAttempts: Scalars['Int']['output']
  /** 현재 micro-transfer 상태 */
  status: MicroTransferStatus
  /** 검증 성공 여부 */
  success: Scalars['Boolean']['output']
}

/** 지갑 스크리닝 방향 (SENDER/RECEIVER) */
export enum WalletScreeningDirection {
  RECEIVER = 'RECEIVER',
  SENDER = 'SENDER',
}

/** 웹훅 방향 */
export enum WebhookDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

/** Webhook event */
export type WebhookEvent = {
  __typename?: 'WebhookEvent'
  /** Number of attempts */
  attempts: Scalars['Int']['output']
  /** Direction of webhook */
  direction: WebhookDirection
  /** Event ID for deduplication */
  eventId: Scalars['String']['output']
  /** Event type */
  eventType: Scalars['String']['output']
  /** Gateway ID for INBOUND */
  gatewayId?: Maybe<Scalars['Int']['output']>
  /** HTTP headers */
  headers: Scalars['JSON']['output']
  /** HTTP response status code */
  httpStatus?: Maybe<Scalars['Int']['output']>
  /** Unique identifier */
  id: Scalars['String']['output']
  /** Last attempt time */
  lastAttemptAt?: Maybe<Scalars['DateTime']['output']>
  /** Merchant ID for OUTBOUND */
  merchantId?: Maybe<Scalars['Int']['output']>
  /** Next retry time */
  nextRetryAt?: Maybe<Scalars['DateTime']['output']>
  /** Event payload */
  payload: Scalars['JSON']['output']
  /** Payment ID */
  paymentId?: Maybe<Scalars['String']['output']>
  /** Processed date */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** Received date */
  receivedAt: Scalars['DateTime']['output']
  /** Response content */
  response?: Maybe<Scalars['String']['output']>
  /** Signature for verification */
  signature?: Maybe<Scalars['String']['output']>
  /** Processing status */
  status: WebhookStatus
  /** Transaction ID */
  transactionId?: Maybe<Scalars['String']['output']>
  /** Target URL for OUTBOUND */
  url?: Maybe<Scalars['String']['output']>
}

/** Filter for webhook events */
export type WebhookEventFilterInput = {
  /** Webhook direction */
  direction?: InputMaybe<WebhookDirection>
  /** Event ID */
  eventId?: InputMaybe<Scalars['String']['input']>
  /** Event type */
  eventType?: InputMaybe<Scalars['String']['input']>
  /** Gateway ID */
  gatewayId?: InputMaybe<Scalars['Int']['input']>
  /** Last attempt from date */
  lastAttemptAtFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** Last attempt to date */
  lastAttemptAtTo?: InputMaybe<Scalars['DateTime']['input']>
  /** Merchant ID (Admin only) */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** Payment ID */
  paymentId?: InputMaybe<Scalars['String']['input']>
  /** Webhook status */
  status?: InputMaybe<WebhookStatus>
  /** Transaction ID */
  transactionId?: InputMaybe<Scalars['String']['input']>
}

/** 웹훅 이벤트 목록 응답 */
export type WebhookEventList = {
  __typename?: 'WebhookEventList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<WebhookEvent>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 웹훅 상태 */
export enum WebhookStatus {
  FAILED = 'FAILED',
  IGNORED = 'IGNORED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

/** 출금 요청 */
export type Withdrawal = {
  __typename?: 'Withdrawal'
  /** 도착 토큰 기준 실제 수령액 */
  actualPayoutAmount?: Maybe<Scalars['Float']['output']>
  /** 채널 송금 시도 번호 */
  attemptNo: Scalars['Int']['output']
  /** 사용된 수취인 ID */
  beneficiaryId?: Maybe<Scalars['Int']['output']>
  /** 실제 브리징 수수료 */
  bridgingFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel */
  channel?: Maybe<Scalars['String']['output']>
  /** Channel fee amount */
  channelFeeAmount?: Maybe<Scalars['Float']['output']>
  /** Channel order number */
  channelOrderId?: Maybe<Scalars['String']['output']>
  /** 완료 시간 */
  completedAt?: Maybe<Scalars['DateTime']['output']>
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<TransactionCreator>
  /** 요청 시점의 예상 브리징 수수료 */
  estimatedBridgingFee?: Maybe<Scalars['Float']['output']>
  /** 적용된 환율 */
  exchangeRate?: Maybe<Scalars['Float']['output']>
  /** 사용된 환율 ID */
  exchangeRateId?: Maybe<Scalars['Int']['output']>
  /** 실패 사유 */
  failureReason?: Maybe<Scalars['String']['output']>
  /** 출금 수수료 */
  feeAmount: Scalars['Float']['output']
  /** 원 금액 (통화 변환 시 totalAmount × exchangeRate) */
  fromAmount?: Maybe<Scalars['Float']['output']>
  /** 원 통화 (통화 변환시) */
  fromCurrency?: Maybe<Scalars['String']['output']>
  /** 원 Currency 테이블 참조 ID */
  fromCurrencyId?: Maybe<Scalars['Int']['output']>
  /** 보류 사유 (관리자 전용) */
  holdReason?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** 가맹점 정보 */
  merchant?: Maybe<Merchant>
  merchantId: Scalars['Int']['output']
  /** metaData */
  metaData?: Maybe<Scalars['JSON']['output']>
  /** 출금 방법 */
  method: WithdrawalMethod
  /** 처리 시작 시간 */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /** 처리자 User ID */
  processedBy?: Maybe<Scalars['Int']['output']>
  /** 처리자 이름 */
  processedByName?: Maybe<Scalars['String']['output']>
  /** 수취인 정보 (은행 정보 등) */
  recipientInfo: Scalars['JSON']['output']
  /** 사용자 수령액 (받고 싶은 금액) */
  requestedAmount: Scalars['Float']['output']
  /** 수령 통화 */
  requestedCurrency?: Maybe<Scalars['String']['output']>
  /** 수령 Currency 테이블 참조 ID */
  requestedCurrencyId: Scalars['Int']['output']
  /** 출금 상태 */
  status: WithdrawalStatus
  /** 총 차감액 (requestedAmount + feeAmount) */
  totalAmount: Scalars['Float']['output']
  /** 은행/PG사 거래 참조번호 or chain transaction hash */
  transactionRef?: Maybe<Scalars['String']['output']>
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output']
}

export type WithdrawalBridgingFeeEstimate = {
  __typename?: 'WithdrawalBridgingFeeEstimate'
  feeAmount?: Maybe<Scalars['String']['output']>
  isEstimate: Scalars['Boolean']['output']
  maxAmount: Scalars['String']['output']
  minAmount: Scalars['String']['output']
  receivedAmount?: Maybe<Scalars['String']['output']>
  receivedCurrency: Scalars['String']['output']
}

/** 출금 내역 엑셀 다운로드 응답 */
export type WithdrawalExportResponse = {
  __typename?: 'WithdrawalExportResponse'
  /** 즉시 다운로드 URL (1000건 이하) */
  downloadUrl?: Maybe<Scalars['String']['output']>
  /** 비동기 작업 ID (1000건 초과) */
  jobId?: Maybe<Scalars['String']['output']>
  /** 안내 메시지 */
  message?: Maybe<Scalars['String']['output']>
  /** 처리 방식: IMMEDIATE 또는 ASYNC */
  processType: Scalars['String']['output']
  /** 총 레코드 수 */
  recordCount: Scalars['Int']['output']
}

/** 출금 요청 필터 */
export type WithdrawalFilterInput = {
  /** 완료 시작일 */
  completedFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 완료 종료일 */
  completedTo?: InputMaybe<Scalars['DateTime']['input']>
  /** 시작일 (생성일 기준) */
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>
  /** 종료일 (생성일 기준) */
  createdTo?: InputMaybe<Scalars['DateTime']['input']>
  /** 통화 코드 */
  currency?: InputMaybe<Scalars['String']['input']>
  /** 시작일 (별칭) */
  fromDate?: InputMaybe<Scalars['DateTime']['input']>
  /** 출금 ID */
  id?: InputMaybe<Scalars['String']['input']>
  /** 엑셀 이메일 언어 설정. 기본값: en */
  locale?: InputMaybe<EmailLocale>
  /** 최대 금액 */
  maxAmount?: InputMaybe<Scalars['Float']['input']>
  /** 가맹점 ID */
  merchantId?: InputMaybe<Scalars['Int']['input']>
  /** 출금 방법 */
  method?: InputMaybe<WithdrawalMethod>
  /** 최소 금액 */
  minAmount?: InputMaybe<Scalars['Float']['input']>
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>
  /** 출금 상태 */
  status?: InputMaybe<WithdrawalStatus>
  /** 출금 상태 목록 */
  statusIn?: InputMaybe<Array<WithdrawalStatus>>
  /** 종료일 (별칭) */
  toDate?: InputMaybe<Scalars['DateTime']['input']>
}

/** 출금 요청 목록 응답 */
export type WithdrawalList = {
  __typename?: 'WithdrawalList'
  /** 다음 페이지 존재 여부 */
  hasNext: Scalars['Boolean']['output']
  /** 이전 페이지 존재 여부 */
  hasPrev: Scalars['Boolean']['output']
  /** 항목 목록 */
  items: Array<Withdrawal>
  /** 페이지당 항목 수 */
  limit: Scalars['Int']['output']
  /** 현재 페이지 */
  page: Scalars['Int']['output']
  /** 전체 항목 수 */
  totalCount: Scalars['Int']['output']
  /** 전체 페이지 수 */
  totalPages: Scalars['Int']['output']
}

/** 출금 방법 */
export enum WithdrawalMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CRYPTO = 'CRYPTO',
  E_WALLET = 'E_WALLET',
  SWIFT = 'SWIFT',
}

/** 출금 처리 미리보기 — 라우트로 정해진 채널과 그 채널의 출발 통화 잔액 */
export type WithdrawalProcessPreview = {
  __typename?: 'WithdrawalProcessPreview'
  /** 라우트로 정해진 채널 코드 */
  channel: Scalars['String']['output']
  /** 채널 가용 잔액 */
  channelAvailable: Scalars['Float']['output']
  /** 채널에서 나가는 통화 (fromCurrency) */
  currency: Scalars['String']['output']
  /** 채널에서 나가는 금액 (requestedAmount) */
  requiredAmount: Scalars['Float']['output']
  /** 잔액이 충분한지 */
  sufficient: Scalars['Boolean']['output']
}

/** 출금 상태 */
export enum WithdrawalStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ON_HOLD = 'ON_HOLD',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
}

export type SetPasswordByTokenMutationVariables = Exact<{
  input: SetPasswordByTokenInput
}>

export type SetPasswordByTokenMutation = { setPasswordByToken: boolean }

export type MenuBasicInfoFragment = {
  __typename?: 'Menu'
  id: string
  code: string
  name: string
  path?: string | null
  icon?: string | null
  component?: string | null
  menuType: string
  sortOrder: number
  isVisible: boolean
  isPublic: boolean
  target: string
  description?: string | null
  excludeRoles: Array<string>
  parentId?: number | null
}

export type MenuWithPermissionsFragment = {
  __typename?: 'Menu'
  permissions?: {
    __typename?: 'MenuPermissions'
    canView: boolean
    canCreate: boolean
    canEdit: boolean
    canDelete: boolean
    canExport: boolean
  } | null
} & MenuBasicInfoFragment

export type SidebarMenuFieldsFragment = {
  __typename?: 'Menu'
  id: string
  name: string
  path?: string | null
  icon?: string | null
  sortOrder: number
  isVisible: boolean
  parentId?: number | null
}

export type SidebarMenuWithChildrenFragment = {
  __typename?: 'Menu'
  children?: Array<{ __typename?: 'Menu' } & SidebarMenuFieldsFragment> | null
} & SidebarMenuFieldsFragment

export type AdminIpWhitelistQueryVariables = Exact<{ [key: string]: never }>

export type AdminIpWhitelistQuery = {
  adminIpWhitelist: {
    __typename?: 'IpWhitelistStatusModel'
    enabled: boolean
    currentIp?: string | null
    entries: Array<{
      __typename?: 'IpWhitelistEntryModel'
      id: number
      ipCidr: string
      label?: string | null
      createdAt: string
    }>
  }
}

export type AddAdminIpWhitelistMutationVariables = Exact<{
  input: AddIpWhitelistInput
}>

export type AddAdminIpWhitelistMutation = {
  addAdminIpWhitelist: {
    __typename?: 'IpWhitelistEntryModel'
    id: number
    ipCidr: string
    label?: string | null
    createdAt: string
  }
}

export type RemoveAdminIpWhitelistMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type RemoveAdminIpWhitelistMutation = { removeAdminIpWhitelist: boolean }

export type SetAdminIpWhitelistEnabledMutationVariables = Exact<{
  input: SetAdminIpWhitelistEnabledInput
}>

export type SetAdminIpWhitelistEnabledMutation = {
  setAdminIpWhitelistEnabled: boolean
}

export type MerchantIpWhitelistQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['Int']['input']>
}>

export type MerchantIpWhitelistQuery = {
  merchantIpWhitelist: {
    __typename?: 'IpWhitelistStatusModel'
    enabled: boolean
    currentIp?: string | null
    entries: Array<{
      __typename?: 'IpWhitelistEntryModel'
      id: number
      ipCidr: string
      label?: string | null
      createdAt: string
    }>
  }
}

export type AddMerchantIpWhitelistMutationVariables = Exact<{
  input: AddIpWhitelistInput
}>

export type AddMerchantIpWhitelistMutation = {
  addMerchantIpWhitelist: {
    __typename?: 'IpWhitelistEntryModel'
    id: number
    ipCidr: string
    label?: string | null
    createdAt: string
  }
}

export type RemoveMerchantIpWhitelistMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type RemoveMerchantIpWhitelistMutation = {
  removeMerchantIpWhitelist: boolean
}

export type SetMerchantIpWhitelistEnabledMutationVariables = Exact<{
  input: SetMerchantIpWhitelistEnabledInput
}>

export type SetMerchantIpWhitelistEnabledMutation = {
  setMerchantIpWhitelistEnabled: boolean
}

export type GetMerchantUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<MerchantUserFilterInput>
}>

export type GetMerchantUsersQuery = {
  merchantUsers: {
    __typename?: 'MerchantUserList'
    page: number
    hasNext: boolean
    hasPrev: boolean
    limit: number
    totalCount: number
    totalPages: number
    items: Array<{
      __typename?: 'User'
      id: number
      email: string
      name: string
      role: UserRole
      status: UserStatus
      phoneCountryCode?: string | null
      phoneNumber?: string | null
      createdAt: string
      updatedAt: string
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type GetMerchantUserQueryVariables = Exact<{
  userId: Scalars['Int']['input']
}>

export type GetMerchantUserQuery = {
  merchantUser: {
    __typename?: 'MerchantUserDetail'
    id: number
    email: string
    name: string
    role: UserRole
    status: UserStatus
    phoneCountryCode?: string | null
    phoneNumber?: string | null
    createdAt: string
    updatedAt: string
    merchant?: {
      __typename?: 'Merchant'
      id: string
      name: string
      mid: string
    } | null
    menuPermissions?: Array<{
      __typename?: 'UserMenuPermission'
      menuId: number
      menuCode: string
      menuName: string
      canView: boolean
      canCreate: boolean
      canEdit: boolean
      canDelete: boolean
      canExport: boolean
    }> | null
  }
}

export type GetAvailableMenusQueryVariables = Exact<{ [key: string]: never }>

export type GetAvailableMenusQuery = {
  availableMenusForMerchantUser: Array<{
    __typename?: 'Menu'
    id: string
    code: string
    name: string
    description?: string | null
    parentId?: number | null
    sortOrder: number
    children?: Array<{
      __typename?: 'Menu'
      id: string
      code: string
      name: string
      description?: string | null
      parentId?: number | null
      sortOrder: number
      children?: Array<{
        __typename?: 'Menu'
        id: string
        code: string
        name: string
        description?: string | null
        parentId?: number | null
        sortOrder: number
      }> | null
    }> | null
  }>
}

export type CreateMerchantUserMutationVariables = Exact<{
  input: CreateMerchantUserInput
}>

export type CreateMerchantUserMutation = {
  createMerchantUser: {
    __typename?: 'CreateMerchantUserResponse'
    passwordSetupUrl: string
    tokenExpiresAt: string
    emailSent: boolean
    message?: string | null
    user: {
      __typename?: 'User'
      id: number
      email: string
      name: string
      role: UserRole
      status: UserStatus
    }
  }
}

export type UpdateMerchantUserMutationVariables = Exact<{
  input: UpdateMerchantUserInput
}>

export type UpdateMerchantUserMutation = {
  updateMerchantUser: {
    __typename?: 'User'
    id: number
    email: string
    name: string
    status: UserStatus
    phoneCountryCode?: string | null
    phoneNumber?: string | null
    updatedAt: string
  }
}

export type DeleteMerchantUserMutationVariables = Exact<{
  userId: Scalars['Int']['input']
}>

export type DeleteMerchantUserMutation = { deleteMerchantUser: boolean }

export type AssignUserMenusMutationVariables = Exact<{
  input: AssignUserMenusInput
}>

export type AssignUserMenusMutation = { assignUserMenus: boolean }

export type ResendPasswordSetupEmailMutationVariables = Exact<{
  userId: Scalars['Int']['input']
  locale?: InputMaybe<EmailLocale>
}>

export type ResendPasswordSetupEmailMutation = {
  resendPasswordSetupEmail: boolean
}

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput
}>

export type CreateApiKeyMutation = {
  createMerchantApiKey: {
    __typename?: 'CreateApiKeyResponse'
    plainTextKey: string
    message: string
    apiKey: {
      __typename?: 'MerchantApiKey'
      id: number
      keyType: string
      environment: string
      keyMasked: string
      displayName: string
      status: string
      createdAt: string
    }
  }
}

export type CreateManualRefundMutationVariables = Exact<{
  input: CreateManualRefundInput
}>

export type CreateManualRefundMutation = {
  createManualRefund: {
    __typename?: 'ManualRefundResponse'
    transactionId: string
    paymentId: string
    transactionKey: string
    refundAmount: number
    newPaymentStatus: PaymentStatus
    totalRefundedAmount: number
    remainingAmount: number
    message: string
    processedAt: string
  }
}

export type CreateMerchantPaymentMethodMutationVariables = Exact<{
  input: CreateMerchantPaymentMethodInput
}>

export type CreateMerchantPaymentMethodMutation = {
  createMerchantPaymentMethod: {
    __typename?: 'CreateMerchantPaymentMethodResponse'
    message: string
    merchantPaymentMethod: {
      __typename?: 'MerchantPaymentMethod'
      id: string
      paymentMethod: PaymentMethod
      displayName: string
      isEnabled: boolean
      feeRate: number
      fixedFee: number
      minAmount: number
      maxAmount: number
      minFee: number
      maxFee?: number | null
      dailyLimitAmount?: number | null
      monthlyLimitAmount?: number | null
      customRoutingId?: number | null
      settlementCycle: number
      description?: string | null
      createdAt: string
    }
  }
}

export type DeleteMerchantPaymentMethodMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteMerchantPaymentMethodMutation = {
  deleteMerchantPaymentMethod: {
    __typename?: 'DeleteMerchantPaymentMethodResponse'
    success: boolean
    message: string
  }
}

export type DownloadAutoRefundExcelMutationVariables = Exact<{
  filter?: InputMaybe<AutoRefundFilterInput>
}>

export type DownloadAutoRefundExcelMutation = {
  downloadAutoRefundExcel: {
    __typename?: 'AutoRefundExcelResponse'
    downloadUrl?: string | null
    jobId?: string | null
    recordCount: number
    processType: string
    message: string
  }
}

export type DownloadRefundExcelMutationVariables = Exact<{
  filter?: InputMaybe<RefundFilterInput>
}>

export type DownloadRefundExcelMutation = {
  downloadRefundExcel: {
    __typename?: 'RefundExcelResponse'
    downloadUrl?: string | null
    recordCount: number
    jobId?: string | null
    processType: string
    message: string
  }
}

export type RefundPaymentMutationVariables = Exact<{
  input: RefundPaymentInput
}>

export type RefundPaymentMutation = {
  refundPayment: {
    __typename?: 'RefundPaymentResponse'
    transactionId?: string | null
    paymentId: string
    refundAmount: number
    refundType?: string | null
    newPaymentStatus?: PaymentStatus | null
    totalRefundedAmount?: number | null
    remainingAmount?: number | null
    message: string
    processedAt?: string | null
  }
}

export type RegenerateApiKeyMutationVariables = Exact<{
  input: RegenerateApiKeyInput
}>

export type RegenerateApiKeyMutation = {
  regenerateMerchantApiKey: {
    __typename?: 'CreateApiKeyResponse'
    plainTextKey: string
    message: string
    apiKey: {
      __typename?: 'MerchantApiKey'
      id: number
      keyType: string
      environment: string
      keyMasked: string
      displayName: string
      status: string
      createdAt: string
    }
  }
}

export type RevokeApiKeyMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type RevokeApiKeyMutation = {
  revokeMerchantApiKey: {
    __typename?: 'MerchantApiKey'
    id: number
    status: string
    revokedAt?: string | null
  }
}

export type ToggleApiKeyMutationVariables = Exact<{
  id: Scalars['Int']['input']
  totpCode?: InputMaybe<Scalars['String']['input']>
}>

export type ToggleApiKeyMutation = {
  toggleMerchantApiKey: {
    __typename?: 'MerchantApiKey'
    id: number
    status: string
    updatedAt: string
  }
}

export type UpdateMerchantPaymentMethodMutationVariables = Exact<{
  input: UpdateMerchantPaymentMethodInput
}>

export type UpdateMerchantPaymentMethodMutation = {
  updateMerchantPaymentMethod: {
    __typename?: 'UpdateMerchantPaymentMethodResponse'
    message: string
    merchantPaymentMethod: {
      __typename?: 'MerchantPaymentMethod'
      id: string
      paymentMethod: PaymentMethod
      displayName: string
      isEnabled: boolean
      feeRate: number
      fixedFee: number
      minAmount: number
      maxAmount: number
      minFee: number
      maxFee?: number | null
      dailyLimitAmount?: number | null
      monthlyLimitAmount?: number | null
      customRoutingId?: number | null
      settlementCycle: number
      description?: string | null
      createdAt: string
      updatedAt: string
    }
  }
}

export type UpdateMerchantWebhookMutationVariables = Exact<{
  input: UpdateMerchantInput
}>

export type UpdateMerchantWebhookMutation = {
  updateMerchant: {
    __typename?: 'Merchant'
    id: string
    name: string
    mid: string
    webhookUrl?: string | null
    updatedAt: string
  }
}

export type UpdateAmlAlertStatusMutationVariables = Exact<{
  id: Scalars['String']['input']
  status: AmlAlertStatus
  notes?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateAmlAlertStatusMutation = {
  updateAmlAlertStatus: {
    __typename?: 'AmlAlertModel'
    id: string
    status: AmlAlertStatus
    notes?: string | null
    resolvedAt?: string | null
    resolvedById?: number | null
    updatedAt: string
  }
}

export type UpdateRiskProviderStatusMutationVariables = Exact<{
  id: Scalars['Int']['input']
  status: RiskProviderStatus
}>

export type UpdateRiskProviderStatusMutation = {
  updateRiskProviderStatus: {
    __typename?: 'RiskManagementProviderModel'
    id: number
    code: string
    name: string
    status: RiskProviderStatus
    priority: number
    updatedAt: string
  }
}

export type CreateRiskManagementProviderMutationVariables = Exact<{
  code: Scalars['String']['input']
  name: Scalars['String']['input']
  priority?: InputMaybe<Scalars['Int']['input']>
}>

export type CreateRiskManagementProviderMutation = {
  createRiskManagementProvider: {
    __typename?: 'RiskManagementProviderModel'
    id: number
    code: string
    name: string
    status: RiskProviderStatus
    priority: number
    createdAt: string
    updatedAt: string
  }
}

export type SignInMutationVariables = Exact<{
  input: SignInInput
}>

export type SignInMutation = {
  signIn: {
    __typename?: 'SignInResponse'
    accessToken?: string | null
    refreshToken?: string | null
    twoFactorRequired?: boolean | null
    twoFactorToken?: string | null
    enrollmentRequired?: boolean | null
    deviceVerificationRequired?: boolean | null
    deviceVerificationToken?: string | null
    deviceVerificationEmail?: string | null
  }
}

export type VerifyLoginDeviceMutationVariables = Exact<{
  input: VerifyLoginDeviceInput
}>

export type VerifyLoginDeviceMutation = {
  verifyLoginDevice: {
    __typename?: 'SignInResponse'
    accessToken?: string | null
    refreshToken?: string | null
    enrollmentRequired?: boolean | null
  }
}

export type ResendLoginDeviceCodeMutationVariables = Exact<{
  input: ResendLoginDeviceCodeInput
}>

export type ResendLoginDeviceCodeMutation = { resendLoginDeviceCode: boolean }

export type RefreshAccessTokenMutationVariables = Exact<{
  input: RefreshTokenInput
}>

export type RefreshAccessTokenMutation = {
  refreshAccessToken: {
    __typename?: 'SignInResponse'
    accessToken?: string | null
    refreshToken?: string | null
  }
}

export type AdminSignUpMutationVariables = Exact<{
  input: AdminSignUpInput
}>

export type AdminSignUpMutation = {
  adminSignUp: { __typename?: 'AdminSignUpResponse'; success: boolean }
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = { logout: boolean }

export type StartChannelFundFlowSyncMutationVariables = Exact<{
  input: StartChannelFundFlowSyncInput
}>

export type StartChannelFundFlowSyncMutation = {
  startChannelFundFlowSync: {
    __typename?: 'ChannelFundFlowSyncRun'
    id: string
    channelCode: string
    status: ChannelFundFlowSyncStatus
    rangeMode: ChannelFundFlowSyncRangeMode
    rangeFrom: string
    rangeTo: string
  }
}

export type RetryChannelFundFlowSyncMutationVariables = Exact<{
  runId: Scalars['String']['input']
}>

export type RetryChannelFundFlowSyncMutation = {
  retryChannelFundFlowSync: {
    __typename?: 'ChannelFundFlowSyncRun'
    id: string
    channelCode: string
    status: ChannelFundFlowSyncStatus
  }
}

export type CreateChannelMutationVariables = Exact<{
  input: CreateChannelInput
}>

export type CreateChannelMutation = {
  createChannel: {
    __typename?: 'Channel'
    id: number
    code: string
    name: string
    status: ChannelStatus
  }
}

export type UpdateChannelMutationVariables = Exact<{
  input: UpdateChannelInput
}>

export type UpdateChannelMutation = {
  updateChannel: {
    __typename?: 'Channel'
    id: number
    code: string
    name: string
    description?: string | null
    status: ChannelStatus
  }
}

export type UpdateChannelCapabilityMutationVariables = Exact<{
  input: UpdateChannelCapabilityInput
}>

export type UpdateChannelCapabilityMutation = {
  updateChannelCapability: {
    __typename?: 'ChannelCapability'
    id: number
    capability: ChannelCapabilityType
    enabled: boolean
    config?: any | null
  }
}

export type CreateChannelRouteMutationVariables = Exact<{
  input: CreateChannelRouteInput
}>

export type CreateChannelRouteMutation = {
  createChannelRoute: {
    __typename?: 'ChannelRoute'
    id: number
    businessType: ChannelRouteBusinessType
    channel: string
    merchantId?: number | null
    createdAt: string
    merchant?: {
      __typename?: 'Merchant'
      id: string
      name: string
      mid: string
    } | null
  }
}

export type DeleteChannelRouteMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteChannelRouteMutation = {
  deleteChannelRoute: { __typename?: 'ChannelRoute'; id: number }
}

export type CreateOfframpTransferMutationVariables = Exact<{
  input: CreateOfframpTransferInput
}>

export type CreateOfframpTransferMutation = {
  createOfframpTransfer: {
    __typename?: 'ChannelTransferModel'
    id: string
    transferId: string
    type: ChannelTransferType
    status: ChannelTransferStatus
    sourceChannel: string
    targetChannel: string
    requestedAmount?: number | null
    requestedCurrency?: string | null
    destinationAddress?: string | null
    destinationMemo?: string | null
    createdAt: string
  }
}

export type CompleteOfframpTransferMutationVariables = Exact<{
  input: CompleteOfframpTransferInput
}>

export type CompleteOfframpTransferMutation = {
  completeOfframpTransfer: {
    __typename?: 'ChannelTransferModel'
    id: string
    transferId: string
    status: ChannelTransferStatus
    sourceAmount?: number | null
    sourceCurrency?: string | null
    targetAmount?: number | null
    targetCurrency?: string | null
    feeAmount?: number | null
    succeededAt?: string | null
    completedAt?: string | null
  }
}

export type FailOfframpTransferMutationVariables = Exact<{
  id: Scalars['String']['input']
  errorMessage: Scalars['String']['input']
  totpCode?: InputMaybe<Scalars['String']['input']>
}>

export type FailOfframpTransferMutation = {
  failOfframpTransfer: {
    __typename?: 'ChannelTransferModel'
    id: string
    transferId: string
    status: ChannelTransferStatus
    errorMessage?: string | null
    failedAt?: string | null
  }
}

export type CreateManualTransferMutationVariables = Exact<{
  input: CreateManualTransferInput
}>

export type CreateManualTransferMutation = {
  createManualTransfer: {
    __typename?: 'ChannelTransferModel'
    id: string
    transferId: string
    type: ChannelTransferType
    status: ChannelTransferStatus
    sourceChannel: string
    targetChannel: string
    requestedAmount?: number | null
    requestedCurrency?: string | null
    destinationAddress?: string | null
    providerRef?: string | null
    processedAt?: string | null
    createdAt: string
  }
}

export type ConfirmTransferReceiptMutationVariables = Exact<{
  input: ConfirmReceiptInput
}>

export type ConfirmTransferReceiptMutation = {
  confirmTransferReceipt: {
    __typename?: 'ChannelTransferModel'
    id: string
    transferId: string
    status: ChannelTransferStatus
    completedBy?: string | null
    completedAt?: string | null
  }
}

export type CreateCryptoRefundFeeMutationVariables = Exact<{
  input: CreateCryptoRefundFeeInput
}>

export type CreateCryptoRefundFeeMutation = {
  createCryptoRefundFee: {
    __typename?: 'CryptoRefundFee'
    id: string
    payableCurrencyId: number
    currencyId: number
    feeType: CryptoRefundFeeType
    feeAmount: number
    minFee?: number | null
    maxFee?: number | null
    isActive: boolean
    description?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type UpdateCryptoRefundFeeMutationVariables = Exact<{
  id: Scalars['Int']['input']
  input: UpdateCryptoRefundFeeInput
}>

export type UpdateCryptoRefundFeeMutation = {
  updateCryptoRefundFee: {
    __typename?: 'CryptoRefundFee'
    id: string
    payableCurrencyId: number
    currencyId: number
    feeType: CryptoRefundFeeType
    feeAmount: number
    minFee?: number | null
    maxFee?: number | null
    isActive: boolean
    description?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type DeleteCryptoRefundFeeMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteCryptoRefundFeeMutation = {
  deleteCryptoRefundFee: {
    __typename?: 'CryptoRefundFee'
    id: string
    payableCurrencyId: number
    currencyId: number
  }
}

export type RecheckRefundDispatchMutationVariables = Exact<{
  input: RecheckRefundDispatchInput
}>

export type RecheckRefundDispatchMutation = {
  recheckRefundDispatch: {
    __typename?: 'RefundDispatchRecheckResultModel'
    outcome: RefundDispatchRecheckOutcome
    message: string
  }
}

export type ResolveRefundReconciliationMutationVariables = Exact<{
  input: ResolveRefundReconciliationInput
}>

export type ResolveRefundReconciliationMutation = {
  resolveRefundReconciliation: {
    __typename?: 'RefundDispatchRecheckResultModel'
    outcome: RefundDispatchRecheckOutcome
    message: string
  }
}

export type RecheckPayoutDispatchMutationVariables = Exact<{
  input: RecheckPayoutDispatchInput
}>

export type RecheckPayoutDispatchMutation = {
  recheckPayoutDispatch: {
    __typename?: 'PayoutDispatchRecheckResultModel'
    outcome: PayoutDispatchRecheckOutcome
    message: string
  }
}

export type CreateFeeSettingMutationVariables = Exact<{
  input: FeeSettingUpdateInput
}>

export type CreateFeeSettingMutation = { createFeeSetting: boolean }

export type UpdateFeeSettingMutationVariables = Exact<{
  input: FeeSettingUpdateInput
}>

export type UpdateFeeSettingMutation = { updateFeeSetting: boolean }

export type DeleteFeeSettingMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteFeeSettingMutation = { deleteFeeSetting: boolean }

export type CreateMenuMutationVariables = Exact<{
  input: CreateMenuInput
}>

export type CreateMenuMutation = {
  createMenu: {
    __typename?: 'Menu'
    id: string
    code: string
    name: string
    description?: string | null
    parentId?: number | null
    path?: string | null
    icon?: string | null
    component?: string | null
    sortOrder: number
    isVisible: boolean
    isPublic: boolean
    excludeRoles: Array<string>
    menuType: string
    target: string
  }
}

export type UpdateMenuMutationVariables = Exact<{
  input: UpdateMenuInput
}>

export type UpdateMenuMutation = {
  updateMenu: {
    __typename?: 'Menu'
    id: string
    code: string
    name: string
    description?: string | null
    parentId?: number | null
    path?: string | null
    icon?: string | null
    component?: string | null
    sortOrder: number
    isVisible: boolean
    isPublic: boolean
    excludeRoles: Array<string>
    menuType: string
    target: string
  }
}

export type DeleteMenuMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteMenuMutation = {
  deleteMenu: {
    __typename?: 'Menu'
    id: string
    code: string
    isDeleted: boolean
  }
}

export type ReorderMenusMutationVariables = Exact<{
  input: ReorderMenusInput
}>

export type ReorderMenusMutation = { reorderMenus: boolean }

export type SetRoleMenuPermissionsMutationVariables = Exact<{
  input: RoleMenuPermissionInput
}>

export type SetRoleMenuPermissionsMutation = {
  setRoleMenuPermissions: {
    __typename?: 'RoleMenu'
    id: number
    role: UserRole
    menuId: number
    canView: boolean
    canCreate: boolean
    canEdit: boolean
    canDelete: boolean
    canExport: boolean
  }
}

export type SetBulkRoleMenuPermissionsMutationVariables = Exact<{
  input: BulkRoleMenuPermissionInput
}>

export type SetBulkRoleMenuPermissionsMutation = {
  setBulkRoleMenuPermissions: Array<{
    __typename?: 'RoleMenu'
    id: number
    menuId: number
    canView: boolean
    canCreate: boolean
    canEdit: boolean
    canDelete: boolean
    canExport: boolean
  }>
}

export type GrantUserMenuAccessMutationVariables = Exact<{
  input: GrantUserMenuAccessInput
}>

export type GrantUserMenuAccessMutation = {
  grantUserMenuAccess: {
    __typename?: 'UserMenu'
    id: number
    userId: number
    menuId: number
    canView: boolean
    canCreate: boolean
    canEdit: boolean
    canDelete: boolean
    canExport: boolean
    expiresAt?: string | null
  }
}

export type SetUserMenuPermissionsMutationVariables = Exact<{
  input: UserMenuPermissionInput
}>

export type SetUserMenuPermissionsMutation = {
  setUserMenuPermissions: {
    __typename?: 'UserMenu'
    id: number
    userId: number
    menuId: number
    canView: boolean
    canCreate: boolean
    canEdit: boolean
    canDelete: boolean
    canExport: boolean
    expiresAt?: string | null
  }
}

export type RevokeUserMenuAccessMutationVariables = Exact<{
  input: RevokeUserMenuAccessInput
}>

export type RevokeUserMenuAccessMutation = { revokeUserMenuAccess: boolean }

export type CreateMerchantCryptoRefundFeeMutationVariables = Exact<{
  input: CreateCryptoRefundFeeInput
}>

export type CreateMerchantCryptoRefundFeeMutation = {
  createMerchantCryptoRefundFee: {
    __typename?: 'MerchantCryptoRefundFee'
    id: string
    merchantId: number
    payableCurrencyId: number
    currencyId: number
    feeType: CryptoRefundFeeType
    feeAmount: number
    minFee?: number | null
    maxFee?: number | null
    isActive: boolean
    description?: string | null
    createdAt: string
  }
}

export type UpdateMerchantCryptoRefundFeeMutationVariables = Exact<{
  id: Scalars['Int']['input']
  input: UpdateCryptoRefundFeeInput
}>

export type UpdateMerchantCryptoRefundFeeMutation = {
  updateMerchantCryptoRefundFee: {
    __typename?: 'MerchantCryptoRefundFee'
    id: string
    merchantId: number
    payableCurrencyId: number
    currencyId: number
    feeType: CryptoRefundFeeType
    feeAmount: number
    minFee?: number | null
    maxFee?: number | null
    isActive: boolean
    description?: string | null
    createdAt: string
  }
}

export type DeleteMerchantCryptoRefundFeeMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteMerchantCryptoRefundFeeMutation = {
  deleteMerchantCryptoRefundFee: {
    __typename?: 'MerchantCryptoRefundFee'
    id: string
    merchantId: number
    payableCurrencyId: number
    currencyId: number
  }
}

export type CreateMerchantMutationVariables = Exact<{
  input: CreateMerchantInput
}>

export type CreateMerchantMutation = {
  createMerchant: {
    __typename?: 'CreateMerchantResponse'
    merchantId: string
    mid: string
    adminUserId: string
  }
}

export type StartOfframpMutationVariables = Exact<{
  input: StartOfframpInput
}>

export type StartOfframpMutation = { startOfframp: boolean }

export type ApproveOfframpMutationVariables = Exact<{
  input: ApproveOfframpInput
}>

export type ApproveOfframpMutation = { approveOfframp: boolean }

export type CompleteOfframpManuallyMutationVariables = Exact<{
  input: CompleteOfframpManuallyInput
}>

export type CompleteOfframpManuallyMutation = {
  completeOfframpManually: boolean
}

export type RejectOfframpMutationVariables = Exact<{
  input: RejectOfframpInput
}>

export type RejectOfframpMutation = { rejectOfframp: boolean }

export type StartOnrampMutationVariables = Exact<{
  input: StartOnrampInput
}>

export type StartOnrampMutation = { startOnramp: boolean }

export type ApproveOnrampMutationVariables = Exact<{
  input: ApproveOnrampInput
}>

export type ApproveOnrampMutation = { approveOnramp: boolean }

export type RetryOnrampFundingTransferMutationVariables = Exact<{
  input: RetryOnrampFundingTransferInput
}>

export type RetryOnrampFundingTransferMutation = {
  retryOnrampFundingTransfer: boolean
}

export type RecordOnrampFundingTransferMutationVariables = Exact<{
  input: RecordOnrampFundingTransferInput
}>

export type RecordOnrampFundingTransferMutation = {
  recordOnrampFundingTransfer: {
    __typename?: 'OnrampFundingTransfer'
    id: string
    transferId: string
    sourceChannel: string
    targetChannel: string
    requestedAmount?: number | null
    requestedCurrency?: string | null
    targetAmount?: number | null
    targetCurrency?: string | null
    providerRef?: string | null
    status: ChannelTransferStatus
    errorMessage?: string | null
  }
}

export type SimulateOnrampFundingTransferPaidMutationVariables = Exact<{
  orderId: Scalars['String']['input']
}>

export type SimulateOnrampFundingTransferPaidMutation = {
  simulateOnrampFundingTransferPaid: boolean
}

export type SimulateOnrampFundingTransferFailedMutationVariables = Exact<{
  orderId: Scalars['String']['input']
  failureType?: InputMaybe<Scalars['String']['input']>
}>

export type SimulateOnrampFundingTransferFailedMutation = {
  simulateOnrampFundingTransferFailed: boolean
}

export type CompleteOnrampManuallyMutationVariables = Exact<{
  input: CompleteOnrampManuallyInput
}>

export type CompleteOnrampManuallyMutation = { completeOnrampManually: boolean }

export type RejectOnrampMutationVariables = Exact<{
  input: RejectOnrampInput
}>

export type RejectOnrampMutation = { rejectOnramp: boolean }

export type AcceptHoldingPaymentMutationVariables = Exact<{
  input: AcceptHoldingPaymentInput
}>

export type AcceptHoldingPaymentMutation = {
  acceptHoldingPayment: {
    __typename?: 'PaymentAdjustment'
    id: string
    decision: AdjustmentDecision
    finalAmount?: number | null
    decidedAt?: string | null
  }
}

export type RejectHoldingPaymentMutationVariables = Exact<{
  input: RejectHoldingPaymentInput
}>

export type RejectHoldingPaymentMutation = {
  rejectHoldingPayment: {
    __typename?: 'PaymentAdjustment'
    id: string
    decision: AdjustmentDecision
    rejectReason?: string | null
    decidedAt?: string | null
    finalAmount?: number | null
  }
}

export type CreatePaymentGatewayMutationVariables = Exact<{
  input: CreatePaymentGatewayInput
}>

export type CreatePaymentGatewayMutation = {
  createPaymentGateway: {
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
    status?: GatewayStatus | null
    baseUrl?: string | null
    apiVersion?: string | null
    supportedMethods?: Array<PaymentMethod> | null
    supportedCurrencies?: Array<string> | null
    baseFeeRate?: number | null
    minAmount?: number | null
    maxAmount?: number | null
    settlementCycle?: number | null
    supportsPartialRefund?: boolean | null
    supportsWebhook?: boolean | null
    supportsRecurring?: boolean | null
    supportsInstantSettlement?: boolean | null
    createdAt?: string | null
  }
}

export type UpdatePaymentGatewayMutationVariables = Exact<{
  id: Scalars['Int']['input']
  input: UpdatePaymentGatewayInput
}>

export type UpdatePaymentGatewayMutation = {
  updatePaymentGateway: {
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
    status?: GatewayStatus | null
    baseUrl?: string | null
    apiVersion?: string | null
    supportedMethods?: Array<PaymentMethod> | null
    supportedCurrencies?: Array<string> | null
    baseFeeRate?: number | null
    minAmount?: number | null
    maxAmount?: number | null
    settlementCycle?: number | null
    supportsPartialRefund?: boolean | null
    supportsWebhook?: boolean | null
    supportsRecurring?: boolean | null
    supportsInstantSettlement?: boolean | null
    updatedAt?: string | null
  }
}

export type DeletePaymentGatewayMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeletePaymentGatewayMutation = {
  deletePaymentGateway: {
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
  }
}

export type UpdatePaymentGatewayStatusMutationVariables = Exact<{
  id: Scalars['Int']['input']
  status: GatewayStatus
}>

export type UpdatePaymentGatewayStatusMutation = {
  updatePaymentGatewayStatus: {
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
    status?: GatewayStatus | null
    updatedAt?: string | null
  }
}

export type CreatePaymentMethodRoutingMutationVariables = Exact<{
  input: CreatePaymentMethodRoutingInput
}>

export type CreatePaymentMethodRoutingMutation = {
  createPaymentMethodRouting: {
    __typename?: 'PaymentMethodRouting'
    id: number
    paymentMethod: PaymentMethod
    priority: number
    isActive: boolean
    isDefault: boolean
    createdAt: string
    gateway?: {
      __typename?: 'PaymentGateway'
      id: number
      code: string
      name: string
      status?: GatewayStatus | null
    } | null
  }
}

export type UpdatePaymentMethodRoutingMutationVariables = Exact<{
  id: Scalars['Int']['input']
  input: UpdatePaymentMethodRoutingInput
}>

export type UpdatePaymentMethodRoutingMutation = {
  updatePaymentMethodRouting: {
    __typename?: 'PaymentMethodRouting'
    id: number
    paymentMethod: PaymentMethod
    priority: number
    isActive: boolean
    isDefault: boolean
    successRate?: number | null
    avgResponseTime?: number | null
    availability?: number | null
    updatedAt: string
    gateway?: {
      __typename?: 'PaymentGateway'
      id: number
      code: string
      name: string
      status?: GatewayStatus | null
    } | null
  }
}

export type DeletePaymentMethodRoutingMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeletePaymentMethodRoutingMutation = {
  deletePaymentMethodRouting: {
    __typename?: 'PaymentMethodRouting'
    id: number
  }
}

export type UpdateRoutingPriorityMutationVariables = Exact<{
  id: Scalars['Int']['input']
  priority: Scalars['Int']['input']
}>

export type UpdateRoutingPriorityMutation = {
  updateRoutingPriority: {
    __typename?: 'PaymentMethodRouting'
    id: number
    priority: number
    updatedAt: string
  }
}

export type RetryPayoutMutationVariables = Exact<{
  orderId: Scalars['String']['input']
}>

export type RetryPayoutMutation = { retryPayout: boolean }

export type CancelPayoutMutationVariables = Exact<{
  orderId: Scalars['String']['input']
}>

export type CancelPayoutMutation = { cancelPayout: boolean }

export type ApproveCryptoPayoutMutationVariables = Exact<{
  input: ApproveCryptoPayoutInput
}>

export type ApproveCryptoPayoutMutation = { approveCryptoPayout: boolean }

export type CompleteCryptoPayoutManuallyMutationVariables = Exact<{
  input: CompleteCryptoPayoutManuallyInput
}>

export type CompleteCryptoPayoutManuallyMutation = {
  completeCryptoPayoutManually: boolean
}

export type RejectCryptoPayoutMutationVariables = Exact<{
  input: RejectCryptoPayoutInput
}>

export type RejectCryptoPayoutMutation = { rejectCryptoPayout: boolean }

export type StartCryptoPayoutMutationVariables = Exact<{
  input: StartCryptoPayoutInput
}>

export type StartCryptoPayoutMutation = { startCryptoPayout: boolean }

export type UploadBatchCryptoPayoutMutationVariables = Exact<{
  input: UploadBatchCryptoPayoutInput
}>

export type UploadBatchCryptoPayoutMutation = {
  uploadBatchCryptoPayout: {
    __typename?: 'BatchCryptoPayoutUploadResponse'
    batchId: number
    batchNo: string
    rowCount: number
  }
}

export type CreateMerchantFrequentRecipientMutationVariables = Exact<{
  input: CreateMerchantFrequentRecipientInput
}>

export type CreateMerchantFrequentRecipientMutation = {
  createMerchantFrequentRecipient: {
    __typename?: 'MerchantFrequentRecipientModel'
    id: number
    merchantId: number
    recipientName: string
    network: string
    address: string
    createdAt: string
    updatedAt: string
  }
}

export type DeleteMerchantFrequentRecipientMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteMerchantFrequentRecipientMutation = {
  deleteMerchantFrequentRecipient: boolean
}

export type UpdatePgSettlementTransferStatusMutationVariables = Exact<{
  input: UpdatePgSettlementTransferStatusInput
}>

export type UpdatePgSettlementTransferStatusMutation = {
  updatePgSettlementTransferStatus: {
    __typename?: 'PgSettlementTransferModel'
    id: string
    status: PgSettlementTransferStatus
    txHash?: string | null
    blockNumber?: number | null
    errorCode?: string | null
    errorMessage?: string | null
    notes?: string | null
    targetAmount?: number | null
    exchangeRate?: number | null
    receivedAmount?: number | null
    receivedCurrency?: string | null
    submittedAt?: string | null
    processedAt?: string | null
    completedAt?: string | null
    updatedAt: string
  }
}

export type AddPgSettlementEventMutationVariables = Exact<{
  input: AddPgSettlementEventInput
}>

export type AddPgSettlementEventMutation = {
  addPgSettlementEvent: {
    __typename?: 'PgSettlementEventModel'
    id: string
    pgSettlementId?: string | null
    pgSettlementTransferId?: string | null
    eventType: PgSettlementEventType
    eventSource: string
    title: string
    description?: string | null
    metadata?: any | null
    occurredAt: string
    createdAt: string
    createdBy?: string | null
  }
}

export type AddPgSettlementFeeMutationVariables = Exact<{
  input: AddPgSettlementFeeInput
}>

export type AddPgSettlementFeeMutation = {
  addPgSettlementFee: {
    __typename?: 'PgSettlementFeeModel'
    id: string
    pgSettlementItemId: string
    feeType: FeeType
    amount: number
    currency?: string | null
    txHash?: string | null
    description?: string | null
    createdAt: string
  }
}

export type UpdatePgSettlementFeeMutationVariables = Exact<{
  input: UpdatePgSettlementFeeInput
}>

export type UpdatePgSettlementFeeMutation = {
  updatePgSettlementFee: {
    __typename?: 'PgSettlementFeeModel'
    id: string
    pgSettlementItemId: string
    feeType: FeeType
    amount: number
    currency?: string | null
    txHash?: string | null
    description?: string | null
    createdAt: string
  }
}

export type DeletePgSettlementFeeMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeletePgSettlementFeeMutation = {
  deletePgSettlementFee: {
    __typename?: 'DeleteResult'
    success: boolean
    id: string
  }
}

export type CreatePgSettlementsMutationVariables = Exact<{
  input: CreatePgSettlementInput
}>

export type CreatePgSettlementsMutation = {
  createPgSettlements: Array<{
    __typename?: 'PgSettlementModel'
    id: string
    batchId: string
    gatewayId: number
    dateFrom: string
    dateTo: string
    currency: string
    settlementType: PgSettlementType
    status: PgSettlementStatus
    requestedAt: string
    submittedAt?: string | null
    errorCode?: string | null
    errorMessage?: string | null
    createdAt: string
  }>
}

export type UpsertPgSettlementWalletConfigMutationVariables = Exact<{
  input: UpsertPgSettlementWalletConfigInput
}>

export type UpsertPgSettlementWalletConfigMutation = {
  upsertPgSettlementWalletConfig: {
    __typename?: 'PgSettlementWalletConfigModel'
    id: string
    gatewayId: number
    currencyId: number
    currencyCode: string
    network?: string | null
    walletAddress: string
    walletMemo?: string | null
    isActive: boolean
    targetChannelCode?: string | null
    createdAt: string
    updatedAt: string
    createdBy?: number | null
  }
}

export type DeletePgSettlementWalletConfigMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeletePgSettlementWalletConfigMutation = {
  deletePgSettlementWalletConfig: boolean
}

export type ResolveReconciliationMismatchItemMutationVariables = Exact<{
  input: ResolveReconciliationMismatchItemInput
}>

export type ResolveReconciliationMismatchItemMutation = {
  resolveReconciliationMismatchItem: {
    __typename?: 'ReconciliationMismatchItem'
  } & ReconciliationMismatchItemFieldsFragment
}

export type ApproveRefundApprovalRequestMutationVariables = Exact<{
  input: ApproveRefundApprovalInput
}>

export type ApproveRefundApprovalRequestMutation = {
  approveRefundApprovalRequest: {
    __typename?: 'RefundApprovalRequest'
  } & RefundApprovalRequestFieldsFragment
}

export type RejectRefundApprovalRequestMutationVariables = Exact<{
  input: RejectRefundApprovalInput
}>

export type RejectRefundApprovalRequestMutation = {
  rejectRefundApprovalRequest: {
    __typename?: 'RefundApprovalRequest'
  } & RefundApprovalRequestFieldsFragment
}

export type CreateRefundLinkMutationVariables = Exact<{
  input: CreateRefundLinkInput
}>

export type CreateRefundLinkMutation = {
  createRefundLink: {
    __typename?: 'CreateRefundLinkResponse'
    refundLinkId: string
    refundUrl: string
    expiresAt: string
    emailQueued: boolean
  }
}

export type CancelRefundLinkMutationVariables = Exact<{
  input: CancelRefundLinkInput
}>

export type CancelRefundLinkMutation = {
  cancelRefundLink: {
    __typename?: 'CancelRefundLinkResponse'
    success: boolean
    refundLinkId: string
    status: RefundLinkStatus
    message?: string | null
  }
}

export type UpdateRefundLinkEmailMutationVariables = Exact<{
  input: UpdateRefundLinkEmailInput
}>

export type UpdateRefundLinkEmailMutation = {
  updateRefundLinkEmail: {
    __typename?: 'UpdateRefundLinkEmailResponse'
    success: boolean
    refundLinkId: string
    customerEmail: string
    emailResent: boolean
    message?: string | null
  }
}

export type UpdateSystemSettingMutationVariables = Exact<{
  input: UpdateSystemSettingInput
}>

export type UpdateSystemSettingMutation = {
  updateSystemSetting: {
    __typename?: 'SystemSettingModel'
    id: string
    category: string
    key: string
    value: string
    valueType: string
    description?: string | null
    updatedAt: string
  }
}

export type UpdateSystemSettingsMutationVariables = Exact<{
  inputs: Array<UpdateSystemSettingInput> | UpdateSystemSettingInput
}>

export type UpdateSystemSettingsMutation = {
  updateSystemSettings: Array<{
    __typename?: 'SystemSettingModel'
    id: string
    category: string
    key: string
    value: string
    valueType: string
    description?: string | null
    updatedAt: string
  }>
}

export type ConfirmTopupMutationVariables = Exact<{
  id: Scalars['Int']['input']
  merchantId: Scalars['Int']['input']
  totpCode?: InputMaybe<Scalars['String']['input']>
}>

export type ConfirmTopupMutation = { confirmTopup: boolean }

export type RollbackTopupMutationVariables = Exact<{
  input: RollbackTopupInput
}>

export type RollbackTopupMutation = { rollbackTopup: boolean }

export type OmitTopupMutationVariables = Exact<{
  input: OmitTopupInput
}>

export type OmitTopupMutation = { omitTopup: boolean }

export type AssignTopupToInternalTransferMutationVariables = Exact<{
  input: AssignTopupToInternalTransferInput
}>

export type AssignTopupToInternalTransferMutation = {
  assignTopupToInternalTransfer: boolean
}

export type CreateTopupRequestMutationVariables = Exact<{
  input: CreateTopupRequestInput
}>

export type CreateTopupRequestMutation = {
  createTopupRequest: {
    __typename?: 'TopupRequestDetail'
    requestId: string
    paymentReference?: string | null
    amount: number
    currency: string
    expiresAt: string
    status: TopupRequestStatus
    accountInfo?: {
      __typename?: 'TopupChannelAccountInfo'
      accountName?: string | null
      accountNumber?: string | null
      bankName?: string | null
      bankCode?: string | null
      branchCode?: string | null
      swiftCode?: string | null
      location?: string | null
    } | null
    cryptoInfo?: {
      __typename?: 'TopupCryptoAddressInfo'
      tokenId: string
      chain: string
      address: string
      qrDataUrl: string
    } | null
  }
}

export type CancelTopupRequestMutationVariables = Exact<{
  input: CancelTopupRequestInput
}>

export type CancelTopupRequestMutation = { cancelTopupRequest: boolean }

export type SubmitTopupRequestEvidenceMutationVariables = Exact<{
  input: SubmitTopupRequestEvidenceInput
}>

export type SubmitTopupRequestEvidenceMutation = {
  submitTopupRequestEvidence: boolean
}

export type UpdateMerchantMutationVariables = Exact<{
  input: UpdateMerchantInput
}>

export type UpdateMerchantMutation = {
  updateMerchant: {
    __typename?: 'Merchant'
    id: string
    mid: string
    name: string
    email: string
    status: MerchantStatus
    type: MerchantType
    riskLevel: string
    exceptionHandlingMode: ExceptionHandlingMode
    businessName?: string | null
    businessNumber?: string | null
    businessAddress?: string | null
    businessPhoneCountryCode?: string | null
    businessPhoneNumber?: string | null
    businessCategory?: string | null
    representativeName?: string | null
    merchantBackground?: string | null
    additionalInfo?: string | null
    relevantCompany?: string | null
    companyName?: string | null
    countryCode?: CountryCode | null
    employeeCount?: number | null
    registeredDate?: string | null
    taxNumber?: string | null
    websiteUrl?: string | null
    bankName?: string | null
    bankBranch?: string | null
    bankAddress?: string | null
    settlementArea?: string | null
    swiftCode?: string | null
    signerName?: string | null
    signerBirthDate?: string | null
    signerIdType?: IdType | null
    signerIdNumber?: string | null
    signerIdDocument?: string | null
    signerIdValidFrom?: string | null
    signerIdValidTo?: string | null
    signerResidentialAddress?: string | null
    signerResidentialCountry?: CountryCode | null
    createdAt: string
    updatedAt: string
    merchantAdminUser?: {
      __typename?: 'MerchantUser'
      id: string
      email: string
      name: string
      phoneCountryCode?: string | null
      phoneNumber?: string | null
      lastLoginAt?: string | null
      createdAt?: string | null
      updatedAt?: string | null
    } | null
  }
}

export type GetApiKeyListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<ApiKeyFilterInput>
}>

export type GetApiKeyListQuery = {
  merchantApiKeys: {
    __typename?: 'ApiKeyList'
    totalCount: number
    page: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'MerchantApiKey'
      id: number
      keyType: string
      environment: string
      keyMasked: string
      displayName: string
      description?: string | null
      status: string
      lastUsedAt?: string | null
      usageCount: number
      expiresAt?: string | null
      createdAt: string
      merchant?: { __typename?: 'Merchant'; id: string; name: string } | null
    }>
  }
}

export type GetAutoRefundsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<AutoRefundFilterInput>
}>

export type GetAutoRefundsQuery = {
  autoRefunds: {
    __typename?: 'AutoRefundList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'Transaction'
      id: string
      paymentId: string
      gatewayId: number
      type: TransactionType
      gatewayTransactionId?: string | null
      merchantTransactionId?: string | null
      amount: number
      currency?: string | null
      settlementDate?: string | null
      status: TransactionStatus
      statusCode?: string | null
      statusMessage?: string | null
      originalTxId?: string | null
      refundReason?: string | null
      isPartial: boolean
      blockchainTxHash?: string | null
      blockNumber?: number | null
      confirmations?: number | null
      processedAt?: string | null
      failureCode?: string | null
      failureMessage?: string | null
      isAutoRefund: boolean
      autoRefundType?: AutoRefundType | null
      createdAt: string
      updatedAt: string
      payment?: {
        __typename?: 'Payment'
        id: string
        gatewayOrderId?: string | null
        merchantOrderId: string
        amount: number
        currency?: string | null
      } | null
      gateway?: {
        __typename?: 'PaymentGateway'
        id: number
        code: string
        name: string
      } | null
    }>
  }
}

export type GetCurrentApiKeysQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetCurrentApiKeysQuery = {
  currentMerchantApiKeys: {
    __typename?: 'CurrentApiKeys'
    keyType: string
    clientKey?: {
      __typename?: 'MerchantApiKey'
      id: number
      keyMasked: string
      displayName: string
      status: string
      lastUsedAt?: string | null
      usageCount: number
      createdAt: string
    } | null
    secretKey?: {
      __typename?: 'MerchantApiKey'
      id: number
      keyMasked: string
      displayName: string
      status: string
      lastUsedAt?: string | null
      usageCount: number
      createdAt: string
    } | null
    webhookKey?: {
      __typename?: 'MerchantApiKey'
      id: number
      keyMasked: string
      displayName: string
      status: string
      lastUsedAt?: string | null
      usageCount: number
      createdAt: string
    } | null
  }
}

export type GetMerchantPaymentMethodsQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Float']['input']>
}>

export type GetMerchantPaymentMethodsQuery = {
  merchantPaymentMethods: Array<{
    __typename?: 'MerchantPaymentMethod'
    id: string
    paymentMethod: PaymentMethod
    displayName: string
    isEnabled: boolean
    feeRate: number
    fixedFee: number
    minAmount: number
    maxAmount: number
    minFee: number
    maxFee?: number | null
    dailyLimitAmount?: number | null
    monthlyLimitAmount?: number | null
    customRoutingId?: number | null
    settlementCycle: number
    description?: string | null
    createdAt: string
    updatedAt: string
  }>
  merchant: {
    __typename?: 'Merchant'
    id: string
    mid: string
    name: string
    businessName?: string | null
    email: string
    status: MerchantStatus
    type: MerchantType
    businessNumber?: string | null
    businessAddress?: string | null
    businessCategory?: string | null
    representativeName?: string | null
  }
}

export type GetMerchantWebhookUrlQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['Float']['input']>
}>

export type GetMerchantWebhookUrlQuery = {
  merchant: {
    __typename?: 'Merchant'
    id: string
    mid: string
    name: string
    webhookUrl?: string | null
  }
}

export type GetMerchantsByPaymentMethodQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<MerchantPaymentMethodFilterInput>
}>

export type GetMerchantsByPaymentMethodQuery = {
  merchantsByPaymentMethod: {
    __typename?: 'MerchantPaymentMethodList'
    totalCount: number
    totalPages: number
    page: number
    limit: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'MerchantWithPaymentMethods'
      id: string
      mid: string
      name: string
      email: string
      status: MerchantStatus
      type: MerchantType
      createdAt: string
      activePaymentMethodsCount: number
      paymentMethods: Array<{
        __typename?: 'MerchantPaymentMethod'
        id: string
        paymentMethod: PaymentMethod
        displayName: string
        isEnabled: boolean
        feeRate: number
        fixedFee: number
        minAmount: number
        maxAmount: number
        minFee: number
        maxFee?: number | null
      }>
    }>
  }
}

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetPaymentQuery = {
  payment?: {
    __typename?: 'Payment'
    id: string
    merchantOrderId: string
    merchantId: number
    amount: number
    paidAmount: number
    netAmount: number
    refundedAmount: number
    pendingRefundApprovalAmount: string
    currency?: string | null
    status: PaymentStatus
    paymentMethod: PaymentMethod
    paymentType: PaymentType
    payableCurrency?: string | null
    payableAmount?: number | null
    payableNetwork?: string | null
    description?: string | null
    createdAt: string
    updatedAt: string
    paidAt?: string | null
    lastRefundedAt?: string | null
    metadata?: any | null
    merchant?: {
      __typename?: 'Merchant'
      id: string
      name: string
      mid: string
    } | null
    transactions?: Array<{
      __typename?: 'Transaction'
      id: string
      type: TransactionType
      status: TransactionStatus
      amount: number
      currency?: string | null
      payableAmount?: number | null
      payableCurrency?: string | null
      payableNetwork?: string | null
      gatewayId: number
      gatewayTransactionId?: string | null
      merchantTransactionId?: string | null
      processedAt?: string | null
      failureCode?: string | null
      failureMessage?: string | null
    }> | null
    refundLinks?: Array<{
      __typename?: 'RefundLink'
      id: string
      status: RefundLinkStatus
      source: RefundLinkSource
      refundAmount: number
      currency?: string | null
      walletAddress?: string | null
      customerEmail?: string | null
      reason?: string | null
      expiresAt: string
      createdAt: string
      submittedAt?: string | null
      completedAt?: string | null
      transactionId?: string | null
    }> | null
  } | null
}

export type GetPaymentsQueryVariables = Exact<{
  filter?: InputMaybe<PaymentFilterInput>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetPaymentsQuery = {
  payments: {
    __typename?: 'PaymentList'
    hasNext: boolean
    hasPrev: boolean
    page: number
    limit: number
    totalCount: number
    totalPages: number
    items: Array<{
      __typename?: 'Payment'
      id: string
      merchantOrderId: string
      merchantId: number
      amount: number
      paidAmount: number
      netAmount: number
      refundedAmount: number
      currency?: string | null
      status: PaymentStatus
      paymentMethod: PaymentMethod
      paymentType: PaymentType
      description?: string | null
      createdAt: string
      updatedAt: string
      paidAt?: string | null
      lastRefundedAt?: string | null
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type DownloadPaymentExcelMutationVariables = Exact<{
  filter?: InputMaybe<PaymentFilterInput>
}>

export type DownloadPaymentExcelMutation = {
  downloadPaymentExcel: {
    __typename?: 'PaymentExportResponse'
    downloadUrl?: string | null
    jobId?: string | null
    message?: string | null
    processType: string
    recordCount: number
  }
}

export type GetRefundQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetRefundQuery = {
  refund?: {
    __typename?: 'RefundTransaction'
    id: string
    gatewayTransactionId?: string | null
    merchantTransactionId?: string | null
    amount: number
    currency: string
    status: TransactionStatus
    isPartial: boolean
    refundReason?: string | null
    originalTxId?: string | null
    failureCode?: string | null
    failureMessage?: string | null
    createdAt: string
    receiveAddress?: string | null
    processedAt?: string | null
    refundMethod?: RefundMethod | null
    gateway: { __typename?: 'PaymentGateway'; code: string; name: string }
    originalPayment: {
      __typename?: 'Payment'
      id: string
      merchantOrderId: string
      amount: number
      currency?: string | null
      paidAmount: number
      paymentMethod: PaymentMethod
      status: PaymentStatus
      createdAt: string
    }
    merchant: { __typename?: 'Merchant'; id: string; name: string; mid: string }
    createdBy?: {
      __typename?: 'TransactionCreator'
      userId: number
      name?: string | null
      email: string
    } | null
    refundFeeRecord?: {
      __typename?: 'RefundFeeRecord'
      id: string
      feeAmount: number
      feeCurrency?: string | null
      feeType: RefundFeeType
      payableAmount?: number | null
      calculationMethod?: string | null
      appliedFeeRate?: number | null
      minFeeApplied: boolean
      maxFeeApplied: boolean
      createdAt: string
    } | null
    refundLink?: {
      __typename?: 'RefundLink'
      id: string
      status: RefundLinkStatus
      refundAmount: number
      currency?: string | null
      walletAddress?: string | null
      reason?: string | null
      customerEmail?: string | null
      expiresAt: string
      createdAt: string
      submittedAt?: string | null
      completedAt?: string | null
    } | null
  } | null
}

export type GetRefundsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<RefundFilterInput>
}>

export type GetRefundsQuery = {
  refunds: {
    __typename?: 'RefundList'
    totalCount: number
    page: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'RefundTransaction'
      id: string
      gatewayTransactionId?: string | null
      amount: number
      currency: string
      status: TransactionStatus
      isPartial: boolean
      refundReason?: string | null
      refundMethod?: RefundMethod | null
      createdAt: string
      receiveAddress?: string | null
      gateway: { __typename?: 'PaymentGateway'; code: string; name: string }
      originalPayment: {
        __typename?: 'Payment'
        merchantOrderId: string
        amount: number
        currency?: string | null
      }
      merchant: { __typename?: 'Merchant'; name: string; mid: string }
      createdBy?: {
        __typename?: 'TransactionCreator'
        userId: number
        name?: string | null
        email: string
      } | null
    }>
  }
}

export type GetTopupAddressGroupsQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<TopupAddressFilterInput>
}>

export type GetTopupAddressGroupsQuery = {
  topupAddressGroups: {
    __typename?: 'TopupAddressGroupPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'TopupAddressGroupResponse'
      customId: string
      merchantId: number
      totalCount: number
      activeCount: number
      latestAddress?: string | null
      tokenIds: Array<string>
      orderName?: string | null
      createdAt: string
      updatedAt: string
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type GetTopupAddressesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  merchantId?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<TopupAddressFilterInput>
}>

export type GetTopupAddressesQuery = {
  topupAddresses: {
    __typename?: 'TopupAddressPage'
    hasNext: boolean
    hasPrev: boolean
    page: number
    limit: number
    totalCount: number
    totalPages: number
    items: Array<{
      __typename?: 'TopupAddressResponse'
      id: string
      merchantId: number
      customId: string
      tokenId: string
      chain?: string | null
      address?: string | null
      isActive: boolean
      minAmount?: string | null
      orderName?: string | null
      createdAt: string
      updatedAt: string
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type GetTopupAddressesByCustomIdQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<TopupAddressFilterInput>
}>

export type GetTopupAddressesByCustomIdQuery = {
  topupAddresses: {
    __typename?: 'TopupAddressPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'TopupAddressResponse'
      id: string
      merchantId: number
      customId: string
      tokenId: string
      chain?: string | null
      address?: string | null
      isActive: boolean
      minAmount?: string | null
      orderName?: string | null
      deactivatedReason?: string | null
      deactivatedAt?: string | null
      createdAt: string
      updatedAt: string
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type GetWebhookEventQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetWebhookEventQuery = {
  webhookEvent?: {
    __typename?: 'WebhookEvent'
    id: string
    direction: WebhookDirection
    gatewayId?: number | null
    merchantId?: number | null
    eventType: string
    eventId: string
    url?: string | null
    headers: any
    payload: any
    signature?: string | null
    status: WebhookStatus
    httpStatus?: number | null
    response?: string | null
    attempts: number
    nextRetryAt?: string | null
    lastAttemptAt?: string | null
    paymentId?: string | null
    transactionId?: string | null
    receivedAt: string
    processedAt?: string | null
  } | null
}

export type GetWebhookEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<WebhookEventFilterInput>
}>

export type GetWebhookEventsQuery = {
  webhookEvents: {
    __typename?: 'WebhookEventList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'WebhookEvent'
      id: string
      direction: WebhookDirection
      gatewayId?: number | null
      merchantId?: number | null
      eventType: string
      eventId: string
      url?: string | null
      status: WebhookStatus
      httpStatus?: number | null
      attempts: number
      nextRetryAt?: string | null
      lastAttemptAt?: string | null
      paymentId?: string | null
      transactionId?: string | null
      receivedAt: string
      processedAt?: string | null
    }>
  }
}

export type GetAmlAlertsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<AmlAlertFilterInput>
}>

export type GetAmlAlertsQuery = {
  amlAlerts: {
    __typename?: 'AmlAlertListModel'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'AmlAlertModel'
      id: string
      merchantId: number
      paymentId?: string | null
      alertType: AmlAlertType
      severity: RiskLevel
      status: AmlAlertStatus
      notes?: string | null
      resolvedAt?: string | null
      createdAt: string
      screeningResult?: {
        __typename?: 'AmlScreeningResultModel'
        id: string
        walletAddress: string
        blockchain: string
        direction: WalletScreeningDirection
        riskScore?: number | null
        riskLevel: RiskLevel
        detectedCategories?: any | null
        status: AmlScreeningStatus
        screenedAt?: string | null
      } | null
    }>
  }
}

export type GetAmlAlertQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetAmlAlertQuery = {
  amlAlert?: {
    __typename?: 'AmlAlertModel'
    id: string
    merchantId: number
    merchantName?: string | null
    paymentId?: string | null
    alertType: AmlAlertType
    severity: RiskLevel
    status: AmlAlertStatus
    notes?: string | null
    assigneeId?: number | null
    resolvedAt?: string | null
    resolvedById?: number | null
    createdAt: string
    updatedAt: string
    screeningResult?: {
      __typename?: 'AmlScreeningResultModel'
      id: string
      walletAddress: string
      blockchain: string
      direction: WalletScreeningDirection
      riskScore?: number | null
      riskLevel: RiskLevel
      detectedCategories?: any | null
      rawResponse?: any | null
      status: AmlScreeningStatus
      screenedAt?: string | null
      providerId: number
      providerName?: string | null
    } | null
  } | null
}

export type GetRiskManagementProvidersQueryVariables = Exact<{
  [key: string]: never
}>

export type GetRiskManagementProvidersQuery = {
  riskManagementProviders: Array<{
    __typename?: 'RiskManagementProviderModel'
    id: number
    code: string
    name: string
    status: RiskProviderStatus
    priority: number
    createdAt: string
    updatedAt: string
  }>
}

export type GetAmlScreeningResultsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<AmlScreeningResultFilterInput>
}>

export type GetAmlScreeningResultsQuery = {
  amlScreeningResults: {
    __typename?: 'AmlScreeningResultListModel'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'AmlScreeningResultModel'
      id: string
      paymentId?: string | null
      blockchain: string
      riskLevel: RiskLevel
      riskScore?: number | null
      status: AmlScreeningStatus
      screenedAt?: string | null
      createdAt: string
    }>
  }
}

export type GetAmlScreeningResultQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetAmlScreeningResultQuery = {
  amlScreeningResult?: {
    __typename?: 'AmlScreeningResultModel'
    id: string
    paymentId?: string | null
    transactionId?: string | null
    walletAddress: string
    blockchain: string
    direction: WalletScreeningDirection
    providerId: number
    providerName?: string | null
    riskScore?: number | null
    riskLevel: RiskLevel
    detectedCategories?: any | null
    rawResponse?: any | null
    status: AmlScreeningStatus
    screenedAt?: string | null
    createdAt: string
    updatedAt: string
  } | null
}

export type GetAmlScreeningResultsByPaymentQueryVariables = Exact<{
  paymentId: Scalars['String']['input']
}>

export type GetAmlScreeningResultsByPaymentQuery = {
  amlScreeningResultsByPayment: Array<{
    __typename?: 'AmlScreeningResultModel'
    id: string
    transactionId?: string | null
    riskLevel: RiskLevel
    status: AmlScreeningStatus
  }>
}

export type ApprovalTodoSummaryQueryVariables = Exact<{ [key: string]: never }>

export type ApprovalTodoSummaryQuery = {
  approvalTodoSummary: {
    __typename?: 'ApprovalTodoSummary'
    topupCount: number
    withdrawalCount: number
    onrampCount: number
    offrampCount: number
    payoutCount: number
    channelFeeCount: number
    reconciliationCount: number
    refundCount: number
    totalCount: number
  }
}

export type ApprovalTodoListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<ApprovalTodoFilterInput>
}>

export type ApprovalTodoListQuery = {
  approvalTodoList: {
    __typename?: 'ApprovalTodoList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'ApprovalTodoItem'
      category: ApprovalTodoCategory
      orderId: string
      merchantId?: number | null
      merchantName?: string | null
      amount: number
      currency: string
      createdAt: string
    }>
  }
}

export type BeneficiariesQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['Int']['input']>
}>

export type BeneficiariesQuery = {
  beneficiaries: Array<{
    __typename?: 'BeneficiaryModel'
    id: number
    type: string
    label?: string | null
    network?: string | null
    address?: string | null
    details?: any | null
    verifiedAt?: string | null
    lastUsedAt?: string | null
    createdAt: string
  }>
}

export type RegisterBeneficiaryMutationVariables = Exact<{
  input: RegisterBeneficiaryInput
}>

export type RegisterBeneficiaryMutation = {
  registerBeneficiary: {
    __typename?: 'BeneficiaryModel'
    id: number
    type: string
    label?: string | null
    network?: string | null
    address?: string | null
    details?: any | null
    verifiedAt?: string | null
    createdAt: string
  }
}

export type CreateBankBeneficiaryMutationVariables = Exact<{
  input: CreateBankBeneficiaryInput
}>

export type CreateBankBeneficiaryMutation = {
  createBankBeneficiary: {
    __typename?: 'BeneficiaryModel'
    id: number
    type: string
    label?: string | null
    network?: string | null
    address?: string | null
    details?: any | null
    verifiedAt?: string | null
    createdAt: string
  }
}

export type DeleteBeneficiaryMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteBeneficiaryMutation = { deleteBeneficiary: boolean }

export type FundFlowChannelsQueryVariables = Exact<{ [key: string]: never }>

export type FundFlowChannelsQuery = {
  fundFlowChannels: Array<{
    __typename?: 'FundFlowChannel'
    code: string
    name: string
    status: ChannelStatus
    lastSyncedAt?: string | null
  }>
}

export type FundFlowChannelBalanceQueryVariables = Exact<{
  channelCode: Scalars['String']['input']
}>

export type FundFlowChannelBalanceQuery = {
  fundFlowChannelBalance: {
    __typename?: 'FundFlowChannelBalance'
    channelCode: string
    balances: Array<{
      __typename?: 'FundFlowBalanceItem'
      currency: string
      availableBalance: string
      totalBalance?: string | null
      frozenBalance?: string | null
    }>
    feeStationBalances?: Array<{
      __typename?: 'FundFlowBalanceItem'
      currency: string
      availableBalance: string
      totalBalance?: string | null
      frozenBalance?: string | null
    }> | null
  }
}

export type ChannelFundFlowsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<ChannelFundFlowFilterInput>
}>

export type ChannelFundFlowsQuery = {
  channelFundFlows: {
    __typename?: 'ChannelFundFlowList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'ChannelFundFlow'
      id: string
      channelCode: string
      direction: FundFlowDirection
      externalId: string
      amount: number
      feeAmount?: number | null
      currency: string
      status: ChannelFundFlowStatus
      externalStatus?: string | null
      source: string
      occurredAt: string
      syncedAt: string
    }>
  }
}

export type ChannelFundFlowSyncRunsQueryVariables = Exact<{
  channelCode?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ChannelFundFlowSyncRunsQuery = {
  channelFundFlowSyncRuns: Array<{
    __typename?: 'ChannelFundFlowSyncRun'
    id: string
    channelCode: string
    status: ChannelFundFlowSyncStatus
    rangeMode: ChannelFundFlowSyncRangeMode
    rangeFrom: string
    rangeTo: string
    stepsDone: number
    fetched: number
    upserted: number
    error?: string | null
    startedAt?: string | null
    finishedAt?: string | null
    createdAt: string
  }>
}

export type ChannelsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<ChannelFilterInput>
}>

export type ChannelsQuery = {
  channels: {
    __typename?: 'ChannelList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'Channel'
      id: number
      code: string
      name: string
      description?: string | null
      status: ChannelStatus
      gatewayId?: number | null
      gatewayStatus?: GatewayStatus | null
      topupAccountSource: TopupAccountSource
      createdAt: string
      updatedAt: string
      capabilities: Array<{
        __typename?: 'ChannelCapability'
        id: number
        capability: ChannelCapabilityType
        enabled: boolean
        config?: any | null
      }>
    }>
  }
}

export type ChannelQueryVariables = Exact<{
  code: Scalars['String']['input']
}>

export type ChannelQuery = {
  channel: {
    __typename?: 'Channel'
    id: number
    code: string
    name: string
    description?: string | null
    status: ChannelStatus
    gatewayId?: number | null
    gatewayStatus?: GatewayStatus | null
    createdAt: string
    updatedAt: string
    capabilities: Array<{
      __typename?: 'ChannelCapability'
      id: number
      capability: ChannelCapabilityType
      enabled: boolean
      config?: any | null
    }>
  }
}

export type ChannelTopupAccountsQueryVariables = Exact<{
  channelCode: Scalars['String']['input']
}>

export type ChannelTopupAccountsQuery = {
  channelTopupAccounts: Array<{
    __typename?: 'ChannelTopupAccount'
    externalId: string
    nickName?: string | null
    currency: string
    accountName: string
    accountNumber: string
    bankName: string
    bankCode?: string | null
    branchCode?: string | null
    swiftCode?: string | null
    location?: string | null
  }>
}

export type ChannelRoutesQueryVariables = Exact<{
  filter?: InputMaybe<ChannelRouteFilterInput>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ChannelRoutesQuery = {
  channelRoutes: {
    __typename?: 'ChannelRouteList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'ChannelRoute'
      id: number
      businessType: ChannelRouteBusinessType
      channel: string
      merchantId?: number | null
      createdAt: string
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type GetChannelTransfersQueryVariables = Exact<{
  filter?: InputMaybe<ChannelTransferFilterInput>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetChannelTransfersQuery = {
  channelTransfers: {
    __typename?: 'ChannelTransferPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'ChannelTransferModel'
      id: string
      transferId: string
      type: ChannelTransferType
      sourceChannel: string
      targetChannel: string
      gatewayCode?: string | null
      requestedAmount?: number | null
      requestedCurrency?: string | null
      sourceAmount?: number | null
      sourceCurrency?: string | null
      targetAmount?: number | null
      targetCurrency?: string | null
      feeAmount?: number | null
      feeCurrency?: string | null
      providerRef?: string | null
      txHash?: string | null
      destinationAddress?: string | null
      status: ChannelTransferStatus
      errorMessage?: string | null
      createdBy?: string | null
      completedBy?: string | null
      memo?: string | null
      requestedAt: string
      processedAt?: string | null
      succeededAt?: string | null
      completedAt?: string | null
      failedAt?: string | null
      createdAt: string
    }>
  }
}

export type GetChannelTransferQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetChannelTransferQuery = {
  channelTransfer: {
    __typename?: 'ChannelTransferModel'
    id: string
    transferId: string
    type: ChannelTransferType
    sourceChannel: string
    targetChannel: string
    gatewayCode?: string | null
    requestedAmount?: number | null
    requestedCurrency?: string | null
    sourceAmount?: number | null
    sourceCurrency?: string | null
    targetAmount?: number | null
    targetCurrency?: string | null
    feeAmount?: number | null
    feeCurrency?: string | null
    providerRef?: string | null
    txHash?: string | null
    destinationAddress?: string | null
    destinationMemo?: string | null
    status: ChannelTransferStatus
    errorCode?: string | null
    errorMessage?: string | null
    createdBy?: string | null
    completedBy?: string | null
    memo?: string | null
    metadata?: any | null
    requestedAt: string
    processedAt?: string | null
    succeededAt?: string | null
    completedAt?: string | null
    failedAt?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type GetChannelBalanceQueryVariables = Exact<{
  channelCode: Scalars['String']['input']
}>

export type GetChannelBalanceQuery = {
  channelBalance: {
    __typename?: 'ChannelBalance'
    channelCode: string
    channelLabel: string
    balances: Array<{
      __typename?: 'ChannelBalanceItem'
      currency: string
      availableBalance: string
      frozenBalance?: string | null
      totalBalance?: string | null
    }>
  }
}

export type ConvertAmountQueryVariables = Exact<{
  amount: Scalars['Float']['input']
  fromCurrencyId: Scalars['Int']['input']
  toCurrencyId: Scalars['Int']['input']
  useWithdrawalRate?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ConvertAmountQuery = { convertAmount: number }

export type GetCryptoRefundFeesQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<CryptoRefundFeeFilterInput>
}>

export type GetCryptoRefundFeesQuery = {
  cryptoRefundFees: {
    __typename?: 'CryptoRefundFeeList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'CryptoRefundFee'
      id: string
      payableCurrencyId: number
      currencyId: number
      feeType: CryptoRefundFeeType
      feeAmount: number
      minFee?: number | null
      maxFee?: number | null
      isActive: boolean
      description?: string | null
      createdAt: string
      updatedAt: string
    }>
  }
}

export type GetCryptoRefundFeeQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetCryptoRefundFeeQuery = {
  cryptoRefundFee: {
    __typename?: 'CryptoRefundFee'
    id: string
    payableCurrencyId: number
    currencyId: number
    feeType: CryptoRefundFeeType
    feeAmount: number
    minFee?: number | null
    maxFee?: number | null
    isActive: boolean
    description?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type GetCurrenciesQueryVariables = Exact<{
  filter?: InputMaybe<CurrencyFilterInput>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetCurrenciesQuery = {
  currencies: {
    __typename?: 'CurrencyList'
    totalCount: number
    totalPages: number
    page: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'Currency'
      id: string
      code: string
      name: string
      symbol: string
      decimals: number
      baseToken: string
      network?: string | null
      tokenType: TokenType
      minAmlScreeningAmount?: number | null
      isActive: boolean
      isSettleable: boolean
      isWithdrawable: boolean
      isExchangeRateEnabled: boolean
      createdAt: string
      updatedAt: string
    }>
  }
}

export type GetCurrencyQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetCurrencyQuery = {
  currency: {
    __typename?: 'Currency'
    id: string
    code: string
    name: string
    symbol: string
    decimals: number
    baseToken: string
    network?: string | null
    tokenType: TokenType
    minAmlScreeningAmount?: number | null
    isActive: boolean
    isSettleable: boolean
    isWithdrawable: boolean
    isExchangeRateEnabled: boolean
    createdAt: string
    updatedAt: string
  }
}

export type CreateCurrencyMutationVariables = Exact<{
  input: CreateCurrencyInput
}>

export type CreateCurrencyMutation = {
  createCurrency: {
    __typename?: 'Currency'
    id: string
    code: string
    name: string
    symbol: string
    decimals: number
    baseToken: string
    network?: string | null
    tokenType: TokenType
    minAmlScreeningAmount?: number | null
    isActive: boolean
    isSettleable: boolean
    isWithdrawable: boolean
    isExchangeRateEnabled: boolean
    createdAt: string
    updatedAt: string
  }
}

export type UpdateCurrencyMutationVariables = Exact<{
  input: UpdateCurrencyInput
}>

export type UpdateCurrencyMutation = {
  updateCurrency: {
    __typename?: 'Currency'
    id: string
    code: string
    name: string
    symbol: string
    decimals: number
    baseToken: string
    network?: string | null
    tokenType: TokenType
    minAmlScreeningAmount?: number | null
    isActive: boolean
    isSettleable: boolean
    isWithdrawable: boolean
    isExchangeRateEnabled: boolean
    createdAt: string
    updatedAt: string
  }
}

export type DeleteCurrencyMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteCurrencyMutation = { deleteCurrency: boolean }

export type DashboardSummaryQueryVariables = Exact<{
  input: GetDashboardSummaryInput
}>

export type DashboardSummaryQuery = {
  dashboardSummary: {
    __typename?: 'DashboardSummary'
    paymentStats: {
      __typename?: 'PaymentStats'
      paymentCount: number
      paymentSuccessCount: number
      paymentFailedCount: number
      paymentPendingCount: number
      paymentTotalAmount: number
      paymentSuccessAmount: number
      paymentAvgAmount?: number | null
      paymentSuccessRate?: number | null
    }
    cancellationStats: {
      __typename?: 'CancellationStats'
      cancellationCount: number
      cancellationSuccessCount: number
      cancellationTotalAmount: number
      cancellationFullCount: number
      cancellationPartialCount: number
      cancellationAutoCount: number
      cancellationRate?: number | null
      autoRefundOverpayment: number
      autoRefundExpired: number
      autoRefundUnderpaid: number
      autoRefundTimeout: number
    }
    hourlyBreakdown: Array<{
      __typename?: 'HourlyBreakdownItem'
      hour: number
      count: number
      successCount: number
      successAmount: number
    }>
    cryptoBreakdown: Array<{
      __typename?: 'CryptoBreakdownItem'
      crypto: string
      count: number
      amount: number
      avgAmount: number
    }>
    networkBreakdown: Array<{
      __typename?: 'NetworkBreakdownItem'
      network: string
      count: number
      amount: number
    }>
    cryptoNetworkBreakdown: Array<{
      __typename?: 'CryptoNetworkBreakdownItem'
      crypto: string
      network: string
      count: number
      amount: number
      avgAmount: number
    }>
  }
}

export type DailyTransactionSummariesQueryVariables = Exact<{
  input: GetDailyTransactionSummaryInput
}>

export type DailyTransactionSummariesQuery = {
  dailyTransactionSummaries: Array<{
    __typename?: 'DailyTransactionSummary'
    id: number
    merchantId?: number | null
    aggregationDate: string
    currency: string
    aggregatedAt: string
    createdAt: string
    updatedAt: string
    paymentStats: {
      __typename?: 'PaymentStats'
      paymentCount: number
      paymentSuccessCount: number
      paymentFailedCount: number
      paymentPendingCount: number
      paymentTotalAmount: number
      paymentSuccessAmount: number
      paymentAvgAmount?: number | null
      paymentSuccessRate?: number | null
    }
    cancellationStats: {
      __typename?: 'CancellationStats'
      cancellationCount: number
      cancellationSuccessCount: number
      cancellationTotalAmount: number
      cancellationFullCount: number
      cancellationPartialCount: number
      cancellationAutoCount: number
      cancellationRate?: number | null
      autoRefundOverpayment: number
      autoRefundExpired: number
      autoRefundUnderpaid: number
      autoRefundTimeout: number
    }
  }>
}

export type ActiveCurrenciesQueryVariables = Exact<{ [key: string]: never }>

export type ActiveCurrenciesQuery = {
  activeCurrencies: Array<{
    __typename?: 'Currency'
    id: string
    code: string
    name: string
    symbol: string
    decimals: number
    isActive: boolean
    tokenType: TokenType
  }>
}

export type HourlyTransactionSummariesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  input: GetHourlyTransactionSummaryInput
}>

export type HourlyTransactionSummariesQuery = {
  hourlyTransactionSummaries: {
    __typename?: 'HourlyTransactionSummaryList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'HourlyTransactionSummary'
      id: number
      merchantId: number
      aggregationHour: string
      currency: string
      paymentCount: number
      paymentSuccessCount: number
      paymentFailedCount: number
      paymentPendingCount: number
      paymentSuccessAmount: number
      paymentAvgAmount?: number | null
      cancellationCount: number
      cancellationAmount: number
      cancellationFullCount: number
      cancellationPartialCount: number
      autoRefundOverpayment: number
      autoRefundExpired: number
      autoRefundUnderpaid: number
      autoRefundTimeout: number
      cryptoBreakdown?: any | null
      networkBreakdown?: any | null
      cryptoNetworkBreakdown?: any | null
      aggregatedAt: string
      isReconciled: boolean
      createdAt: string
      updatedAt: string
    }>
  }
}

export type DownloadDailySummaryExcelMutationVariables = Exact<{
  input: GetDailyTransactionSummaryInput
}>

export type DownloadDailySummaryExcelMutation = {
  downloadDailySummaryExcel: {
    __typename?: 'DailySummaryExcelResponse'
    downloadUrl: string
    recordCount: number
    message: string
  }
}

export type MerchantStatisticsQueryVariables = Exact<{
  input: GetMerchantStatisticsInput
}>

export type MerchantStatisticsQuery = {
  merchantStatistics: {
    __typename?: 'MerchantStatisticsList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    items: Array<{
      __typename?: 'MerchantStatisticsItem'
      id: number
      merchantId: number
      merchantName: string
      aggregationDate: string
      currency: string
      aggregatedAt: string
      createdAt: string
      updatedAt: string
      paymentStats: {
        __typename?: 'PaymentStats'
        paymentCount: number
        paymentSuccessCount: number
        paymentFailedCount: number
        paymentPendingCount: number
        paymentTotalAmount: number
        paymentSuccessAmount: number
        paymentAvgAmount?: number | null
        paymentSuccessRate?: number | null
      }
      cancellationStats: {
        __typename?: 'CancellationStats'
        cancellationCount: number
        cancellationSuccessCount: number
        cancellationTotalAmount: number
        cancellationFullCount: number
        cancellationPartialCount: number
        cancellationAutoCount: number
        cancellationRate?: number | null
        autoRefundOverpayment: number
        autoRefundExpired: number
        autoRefundUnderpaid: number
        autoRefundTimeout: number
      }
    }>
  }
}

export type DownloadMerchantStatisticsExcelMutationVariables = Exact<{
  input: GetMerchantStatisticsInput
}>

export type DownloadMerchantStatisticsExcelMutation = {
  downloadMerchantStatisticsExcel: {
    __typename?: 'MerchantStatisticsExcelResponse'
    downloadUrl: string
    recordCount: number
    message: string
  }
}

export type MerchantPayoutStatisticsQueryVariables = Exact<{
  input: GetMerchantPayoutStatisticsInput
}>

export type MerchantPayoutStatisticsQuery = {
  merchantPayoutStatistics: {
    __typename?: 'MerchantPayoutStatisticsList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'MerchantPayoutStatisticsItem'
      id: number
      merchantId: number
      merchantName: string
      aggregationDate: string
      currency: string
      aggregatedAt: string
      createdAt: string
      updatedAt: string
      payoutStats: {
        __typename?: 'PayoutStats'
        payoutCount: number
        payoutSuccessCount: number
        payoutFailedCount: number
        payoutSuccessAmount: number
        payoutAvgAmount: number
        payoutSuccessRate: number
        payoutFeeAmount: number
        payoutChannelFeeAmount?: number | null
      }
    }>
  }
}

export type DownloadMerchantPayoutStatisticsExcelMutationVariables = Exact<{
  input: GetMerchantPayoutStatisticsInput
}>

export type DownloadMerchantPayoutStatisticsExcelMutation = {
  downloadMerchantPayoutStatisticsExcel: {
    __typename?: 'MerchantPayoutStatisticsExcelResponse'
    downloadUrl: string
    recordCount: number
    message: string
  }
}

export type PayoutSummaryQueryVariables = Exact<{
  input: GetPayoutSummaryInput
}>

export type PayoutSummaryQuery = {
  payoutSummary: {
    __typename?: 'PayoutSummary'
    payoutStats: {
      __typename?: 'PayoutStats'
      payoutCount: number
      payoutSuccessCount: number
      payoutFailedCount: number
      payoutSuccessAmount: number
      payoutAvgAmount: number
      payoutSuccessRate: number
      payoutFeeAmount: number
      payoutChannelFeeAmount?: number | null
    }
    hourlyBreakdown: Array<{
      __typename?: 'HourlyPayoutBreakdownItem'
      hour: number
      count: number
      successCount: number
      successAmount: number
    }>
    tokenBreakdown: Array<{
      __typename?: 'TokenBreakdownItem'
      token: string
      count: number
      amount: number
      avgAmount: number
    }>
    networkBreakdown: Array<{
      __typename?: 'NetworkBreakdownItem'
      network: string
      count: number
      amount: number
    }>
    tokenNetworkBreakdown: Array<{
      __typename?: 'TokenNetworkBreakdownItem'
      token: string
      network: string
      count: number
      amount: number
      avgAmount: number
    }>
    channelBreakdown: Array<{
      __typename?: 'ChannelBreakdownItem'
      channel: string
      count: number
      successCount: number
      amount: number
      feeAmount: number
      channelFeeAmount: number
    }>
  }
}

export type HourlyPayoutSummariesQueryVariables = Exact<{
  input: GetHourlyPayoutSummaryInput
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type HourlyPayoutSummariesQuery = {
  hourlyPayoutSummaries: {
    __typename?: 'HourlyPayoutSummaryList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'HourlyPayoutSummary'
      id: number
      merchantId: number
      aggregationHour: string
      currency: string
      payoutCount: number
      payoutSuccessCount: number
      payoutFailedCount: number
      payoutSuccessAmount: number
      payoutAvgAmount?: number | null
      payoutFeeAmount: number
      payoutChannelFeeAmount?: number | null
      tokenBreakdown?: any | null
      networkBreakdown?: any | null
      tokenNetworkBreakdown?: any | null
      channelBreakdown?: any | null
      aggregatedAt: string
      isReconciled: boolean
      createdAt: string
      updatedAt: string
    }>
  }
}

export type GetDispatchReconciliationItemsQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<DispatchReconciliationFilterInput>
}>

export type GetDispatchReconciliationItemsQuery = {
  dispatchReconciliationItems: {
    __typename?: 'DispatchReconciliationItemList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'DispatchReconciliationItem'
      kind: DispatchReconciliationKind
      recordId: string
      paymentId?: string | null
      merchantId?: number | null
      merchantName?: string | null
      amount?: number | null
      currency?: string | null
      status: string
      state: string
      reason?: string | null
      since: string
      providerReference?: string | null
    }>
  }
}

export type GetExceptionalTransfersQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<ExceptionalTransferFilterInput>
}>

export type GetExceptionalTransfersQuery = {
  exceptionalTransfers: {
    __typename?: 'ExceptionalTransferList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'ExceptionalTransfer'
      id: string
      pgTransactionId: string
      blockchainTxHash?: string | null
      eventType: string
      receivedTokenId: string
      receivedAmount: string
      fromAddress?: string | null
      toAddress: string
      topupAddressId: number
      expectedTokenId: string
      merchantId: number
      status: ExceptionalTransferStatus
      resolutionNote?: string | null
      resolvedById?: number | null
      resolvedAt?: string | null
      detectedAt: string
      createdAt: string
      updatedAt: string
      merchantName?: string | null
      merchantNo?: string | null
      topupAddressChain?: string | null
      resolvedByName?: string | null
    }>
  }
}

export type GetExceptionalTransferQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetExceptionalTransferQuery = {
  exceptionalTransfer: {
    __typename?: 'ExceptionalTransfer'
    id: string
    pgTransactionId: string
    blockchainTxHash?: string | null
    eventType: string
    receivedTokenId: string
    receivedAmount: string
    fromAddress?: string | null
    toAddress: string
    topupAddressId: number
    expectedTokenId: string
    merchantId: number
    status: ExceptionalTransferStatus
    resolutionNote?: string | null
    resolvedById?: number | null
    resolvedAt?: string | null
    rawWebhookData: any
    detectedAt: string
    createdAt: string
    updatedAt: string
    merchantName?: string | null
    merchantNo?: string | null
    topupAddressChain?: string | null
    resolvedByName?: string | null
  }
}

export type UpdateExceptionalTransferStatusMutationVariables = Exact<{
  input: UpdateExceptionalTransferStatusInput
}>

export type UpdateExceptionalTransferStatusMutation = {
  updateExceptionalTransferStatus: {
    __typename?: 'ExceptionalTransfer'
    id: string
    status: ExceptionalTransferStatus
    resolutionNote?: string | null
    resolvedById?: number | null
    resolvedAt?: string | null
    resolvedByName?: string | null
  }
}

export type GetExchangeRatesQueryVariables = Exact<{
  filter?: InputMaybe<ExchangeRateFilterInput>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetExchangeRatesQuery = {
  exchangeRates: {
    __typename?: 'ExchangeRateList'
    totalCount: number
    totalPages: number
    page: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'ExchangeRate'
      id: string
      currencyPair: string
      rate: number
      depositRate: number
      paymentRate: number
      withdrawalRate: number
      depositMargin: number
      paymentMargin: number
      withdrawalMargin: number
      source: ExchangeRateSource
      isActive: boolean
      isCurrentlyValid: boolean
      validFrom: string
      validTo?: string | null
      createdAt: string
      updatedAt: string
      fromCurrency: {
        __typename?: 'Currency'
        id: string
        code: string
        name: string
        symbol: string
      }
      toCurrency: {
        __typename?: 'Currency'
        id: string
        code: string
        name: string
        symbol: string
      }
    }>
  }
}

export type GetExchangeRateQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetExchangeRateQuery = {
  exchangeRate: {
    __typename?: 'ExchangeRate'
    id: string
    currencyPair: string
    rate: number
    depositRate: number
    paymentRate: number
    withdrawalRate: number
    depositMargin: number
    paymentMargin: number
    withdrawalMargin: number
    source: ExchangeRateSource
    isActive: boolean
    isCurrentlyValid: boolean
    validFrom: string
    validTo?: string | null
    createdAt: string
    updatedAt: string
    fromCurrency: {
      __typename?: 'Currency'
      id: string
      code: string
      name: string
      symbol: string
    }
    toCurrency: {
      __typename?: 'Currency'
      id: string
      code: string
      name: string
      symbol: string
    }
  }
}

export type GetCurrenciesForExchangeQueryVariables = Exact<{
  [key: string]: never
}>

export type GetCurrenciesForExchangeQuery = {
  currencies: {
    __typename?: 'CurrencyList'
    items: Array<{
      __typename?: 'Currency'
      id: string
      code: string
      name: string
      symbol: string
      isActive: boolean
      tokenType: TokenType
      isExchangeRateEnabled: boolean
    }>
  }
}

export type CreateExchangeRateMutationVariables = Exact<{
  input: CreateExchangeRateInput
}>

export type CreateExchangeRateMutation = {
  createExchangeRate: {
    __typename?: 'ExchangeRate'
    id: string
    currencyPair: string
    rate: number
    depositRate: number
    paymentRate: number
    withdrawalRate: number
    depositMargin: number
    paymentMargin: number
    withdrawalMargin: number
    source: ExchangeRateSource
    isActive: boolean
    validFrom: string
    validTo?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type UpdateExchangeRateMutationVariables = Exact<{
  input: UpdateExchangeRateInput
}>

export type UpdateExchangeRateMutation = {
  updateExchangeRate: {
    __typename?: 'ExchangeRate'
    id: string
    currencyPair: string
    rate: number
    depositRate: number
    paymentRate: number
    withdrawalRate: number
    depositMargin: number
    paymentMargin: number
    withdrawalMargin: number
    source: ExchangeRateSource
    isActive: boolean
    validFrom: string
    validTo?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type DeleteExchangeRateMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteExchangeRateMutation = { deleteExchangeRate: boolean }

export type ActivateExchangeRateMutationVariables = Exact<{
  input: ActivateExchangeRateInput
}>

export type ActivateExchangeRateMutation = {
  activateExchangeRate: {
    __typename?: 'ExchangeRate'
    id: string
    isActive: boolean
  }
}

export type FeeSettingListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
  bizType?: InputMaybe<FeeBusinessType>
}>

export type FeeSettingListQuery = {
  feeSettingList: {
    __typename?: 'FeeSettingPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'FeeSettingResponse'
      id: string
      bizType: FeeBusinessType
      merchantId?: number | null
      currency?: string | null
      feeRate: number
      fixedFee: number
      minFee: number
      maxFee?: number | null
      metadata?: any | null
      updatedAt: string
    }>
  }
}

export type FeeSettingQueryVariables = Exact<{
  input: FeeSettingInput
}>

export type FeeSettingQuery = {
  feeSetting: {
    __typename?: 'FeeSettingResponse'
    id: string
    bizType: FeeBusinessType
    merchantId?: number | null
    currency?: string | null
    feeRate: number
    fixedFee: number
    minFee: number
    maxFee?: number | null
    metadata?: any | null
  }
}

export type GetFileQueryVariables = Exact<{
  fileId: Scalars['Int']['input']
}>

export type GetFileQuery = {
  file: {
    __typename?: 'FileAccessResponse'
    id: number
    fileName: string
    size: number
    mimeType: string
    uploadedAt: string
    signedUrl: string
    description?: string | null
  }
}

export type GetFilesQueryVariables = Exact<{
  fileIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type GetFilesQuery = {
  files: Array<{
    __typename?: 'FileAccessResponse'
    id: number
    fileName: string
    size: number
    mimeType: string
    uploadedAt: string
    signedUrl: string
    description?: string | null
  }>
}

export type GetAccountingChannelsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAccountingChannelsQuery = {
  accountingChannels: Array<{
    __typename?: 'AccountingChannelResponse'
    code: string
    label: string
  }>
}

export type InternalAccountEntryListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<InternalAccountEntryListInput>
}>

export type InternalAccountEntryListQuery = {
  internalAccountEntryList: {
    __typename?: 'InternalAccountEntryPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'InternalAccountEntryResponse'
      entryNo: string
      voucherNo: string
      bizOrderNo: string
      bizType: BusinessType
      bizStep: BusinessStep
      accountNo: string
      accountType: string
      amount: number
      dcFlag: DcFlag
      currency: string
      createdAt: string
      remark?: string | null
    }>
  }
}

export type GetManualRefundApprovalQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetManualRefundApprovalQuery = {
  manualRefundApproval: {
    __typename?: 'ManualRefundApproval'
    id: string
    paymentId: string
    refundAmount: number
    reason: string
    currency?: string | null
    requestedAt: string
    requestedBy: string
    status: ManualRefundApprovalStatus
    reviewedAt?: string | null
    reviewedBy?: string | null
    reviewNote?: string | null
    walletAddress?: string | null
    autoRefundJobId: string
    createdAt: string
    updatedAt: string
    refundLinkId?: string | null
    refundLink?: {
      __typename?: 'RefundLink'
      id: string
      status: RefundLinkStatus
      source: RefundLinkSource
      customerEmail?: string | null
      emailSent: boolean
      emailSentAt?: string | null
      expiresAt: string
      walletAddress?: string | null
      submittedAt?: string | null
      completedAt?: string | null
    } | null
    payment?: {
      __typename?: 'Payment'
      id: string
      paymentKey?: string | null
      amount: number
      currency?: string | null
      status: PaymentStatus
      merchantOrderId: string
      customerEmail?: string | null
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    } | null
  }
}

export type GetManualRefundApprovalsQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<ManualRefundApprovalFilterInput>
}>

export type GetManualRefundApprovalsQuery = {
  manualRefundApprovals: {
    __typename?: 'ManualRefundApprovalList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'ManualRefundApproval'
      id: string
      paymentId: string
      refundAmount: number
      reason: string
      currency?: string | null
      requestedAt: string
      requestedBy: string
      status: ManualRefundApprovalStatus
      reviewedAt?: string | null
      reviewedBy?: string | null
      reviewNote?: string | null
      walletAddress?: string | null
      autoRefundJobId: string
      createdAt: string
      updatedAt: string
      refundLinkId?: string | null
      refundLink?: {
        __typename?: 'RefundLink'
        id: string
        status: RefundLinkStatus
        source: RefundLinkSource
        customerEmail?: string | null
        emailSent: boolean
        emailSentAt?: string | null
        expiresAt: string
        walletAddress?: string | null
        submittedAt?: string | null
        completedAt?: string | null
      } | null
      payment?: {
        __typename?: 'Payment'
        id: string
        paymentKey?: string | null
        amount: number
        currency?: string | null
        status: PaymentStatus
        merchantOrderId: string
        customerEmail?: string | null
        merchant?: {
          __typename?: 'Merchant'
          id: string
          name: string
          mid: string
        } | null
      } | null
    }>
  }
}

export type ApproveManualRefundMutationVariables = Exact<{
  input: ApproveManualRefundInput
}>

export type ApproveManualRefundMutation = {
  approveManualRefund: {
    __typename?: 'ManualRefundApproval'
    id: string
    status: ManualRefundApprovalStatus
    reviewedAt?: string | null
    reviewedBy?: string | null
    reviewNote?: string | null
    walletAddress?: string | null
  }
}

export type RejectManualRefundMutationVariables = Exact<{
  input: RejectManualRefundInput
}>

export type RejectManualRefundMutation = {
  rejectManualRefund: {
    __typename?: 'ManualRefundApproval'
    id: string
    status: ManualRefundApprovalStatus
    reviewedAt?: string | null
    reviewedBy?: string | null
    reviewNote?: string | null
  }
}

export type ResendRefundEmailMutationVariables = Exact<{
  approvalId: Scalars['String']['input']
}>

export type ResendRefundEmailMutation = {
  resendRefundEmail: {
    __typename?: 'ManualRefundApproval'
    id: string
    refundLinkId?: string | null
    refundLink?: {
      __typename?: 'RefundLink'
      id: string
      status: RefundLinkStatus
      source: RefundLinkSource
      customerEmail?: string | null
      emailSent: boolean
      emailSentAt?: string | null
      expiresAt: string
    } | null
  }
}

export type GetUserMenusQueryVariables = Exact<{ [key: string]: never }>

export type GetUserMenusQuery = {
  userMenus: Array<{
    __typename?: 'Menu'
    id: string
    code: string
    name: string
    path?: string | null
    icon?: string | null
    component?: string | null
    menuType: string
    sortOrder: number
    isVisible: boolean
    isPublic: boolean
    target: string
    description?: string | null
    excludeRoles: Array<string>
    parentId?: number | null
    permissions?: {
      __typename?: 'MenuPermissions'
      canView: boolean
      canCreate: boolean
      canEdit: boolean
      canDelete: boolean
      canExport: boolean
    } | null
    children?: Array<{
      __typename?: 'Menu'
      id: string
      code: string
      name: string
      path?: string | null
      icon?: string | null
      component?: string | null
      menuType: string
      sortOrder: number
      isVisible: boolean
      isPublic: boolean
      target: string
      description?: string | null
      excludeRoles: Array<string>
      parentId?: number | null
    }> | null
  }>
}

export type GetAllMenusQueryVariables = Exact<{
  filter?: InputMaybe<MenuFilterInput>
}>

export type GetAllMenusQuery = {
  allMenus: Array<{
    __typename?: 'Menu'
    id: string
    code: string
    name: string
    description?: string | null
    parentId?: number | null
    path?: string | null
    icon?: string | null
    component?: string | null
    sortOrder: number
    isVisible: boolean
    isPublic: boolean
    excludeRoles: Array<string>
    menuType: string
    target: string
    children?: Array<{
      __typename?: 'Menu'
      id: string
      code: string
      name: string
      description?: string | null
      parentId?: number | null
      path?: string | null
      icon?: string | null
      component?: string | null
      sortOrder: number
      isVisible: boolean
      isPublic: boolean
      excludeRoles: Array<string>
      menuType: string
      target: string
      children?: Array<{
        __typename?: 'Menu'
        id: string
        code: string
        name: string
        path?: string | null
        icon?: string | null
        sortOrder: number
        isVisible: boolean
        parentId?: number | null
      }> | null
    }> | null
  }>
}

export type GetMenuDetailQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetMenuDetailQuery = {
  menu?: {
    __typename?: 'Menu'
    id: string
    code: string
    name: string
    description?: string | null
    parentId?: number | null
    path?: string | null
    icon?: string | null
    component?: string | null
    sortOrder: number
    isVisible: boolean
    isPublic: boolean
    excludeRoles: Array<string>
    menuType: string
    target: string
  } | null
}

export type GetUserMenusForManagementQueryVariables = Exact<{
  [key: string]: never
}>

export type GetUserMenusForManagementQuery = {
  userMenus: Array<{
    __typename?: 'Menu'
    id: string
    code: string
    name: string
    description?: string | null
    parentId?: number | null
    path?: string | null
    icon?: string | null
    component?: string | null
    sortOrder: number
    isVisible: boolean
    isPublic: boolean
    excludeRoles: Array<string>
    menuType: string
    target: string
    permissions?: {
      __typename?: 'MenuPermissions'
      canView: boolean
      canCreate: boolean
      canEdit: boolean
      canDelete: boolean
      canExport: boolean
    } | null
    children?: Array<{
      __typename?: 'Menu'
      id: string
      code: string
      name: string
      description?: string | null
      parentId?: number | null
      path?: string | null
      icon?: string | null
      component?: string | null
      sortOrder: number
      isVisible: boolean
      isPublic: boolean
      excludeRoles: Array<string>
      menuType: string
      target: string
      permissions?: {
        __typename?: 'MenuPermissions'
        canView: boolean
        canCreate: boolean
        canEdit: boolean
        canDelete: boolean
        canExport: boolean
      } | null
      children?: Array<{
        __typename?: 'Menu'
        id: string
        code: string
        name: string
        path?: string | null
        icon?: string | null
        sortOrder: number
        isVisible: boolean
        parentId?: number | null
        permissions?: {
          __typename?: 'MenuPermissions'
          canView: boolean
          canCreate: boolean
          canEdit: boolean
          canDelete: boolean
          canExport: boolean
        } | null
      }> | null
    }> | null
  }>
}

export type GetMerchantQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Float']['input']>
}>

export type GetMerchantQuery = {
  merchant: {
    __typename?: 'Merchant'
    id: string
    mid: string
    name: string
    email: string
    status: MerchantStatus
    type: MerchantType
    riskLevel: string
    exceptionHandlingMode: ExceptionHandlingMode
    businessName?: string | null
    businessNumber?: string | null
    businessAddress?: string | null
    businessPhoneCountryCode?: string | null
    businessPhoneNumber?: string | null
    businessCategory?: string | null
    representativeName?: string | null
    merchantBackground?: string | null
    additionalInfo?: string | null
    relevantCompany?: string | null
    companyName?: string | null
    countryCode?: CountryCode | null
    employeeCount?: number | null
    registeredDate?: string | null
    taxNumber?: string | null
    websiteUrl?: string | null
    bankName?: string | null
    bankBranch?: string | null
    bankAddress?: string | null
    settlementArea?: string | null
    swiftCode?: string | null
    signerName?: string | null
    signerBirthDate?: string | null
    signerIdType?: IdType | null
    signerIdNumber?: string | null
    signerIdDocument?: string | null
    signerIdValidFrom?: string | null
    signerIdValidTo?: string | null
    signerResidentialAddress?: string | null
    signerResidentialCountry?: CountryCode | null
    createdAt: string
    updatedAt: string
    merchantDocuments: Array<{
      __typename?: 'MerchantDocument'
      id: string
      description?: string | null
      expiresAt?: string | null
      fileUploadId: number
      isVerified: boolean
      verifiedAt?: string | null
      createdAt: string
      updatedAt: string
      fileUpload?: {
        __typename?: 'FileInfo'
        id: number
        fileName: string
        fileSize?: number | null
        mimeType: string
        signedUrl?: string | null
        description?: string | null
      } | null
    }>
    merchantAdminUser?: {
      __typename?: 'MerchantUser'
      id: string
      email: string
      name: string
      phoneCountryCode?: string | null
      phoneNumber?: string | null
      lastLoginAt?: string | null
      createdAt?: string | null
      updatedAt?: string | null
    } | null
  }
}

export type MerchantAccountSummaryQueryVariables = Exact<{
  merchantId: Scalars['Int']['input']
}>

export type MerchantAccountSummaryQuery = {
  merchantAccountSummary: {
    __typename?: 'MerchantAccountSummaryResponse'
    summary: {
      __typename?: 'MerchantAccountResponse'
      currency: string
      balanceAmount: number
      pendingSettlementAmount: number
      frozenAmount: number
      frozenDetails: Array<{
        __typename?: 'FrozenAmountDetailResponse'
        type: MerchantAccountFrozen
        amount: number
      }>
    }
    details: Array<{
      __typename?: 'MerchantAccountResponse'
      currency: string
      balanceAmount: number
      pendingSettlementAmount: number
      frozenAmount: number
      frozenDetails: Array<{
        __typename?: 'FrozenAmountDetailResponse'
        type: MerchantAccountFrozen
        amount: number
      }>
    }>
  }
}

export type MerchantAccountEntryListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId: Scalars['Int']['input']
  filter?: InputMaybe<MerchantAccountEntryListInput>
}>

export type MerchantAccountEntryListQuery = {
  merchantAccountEntryList: {
    __typename?: 'MerchantAccountEntryPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'MerchantAccountEntryResponse'
      entryNo: string
      voucherNo: string
      bizOrderNo: string
      bizType: BusinessType
      bizStep: BusinessStep
      accountNo: string
      accountType: string
      amount: number
      balance: number
      currency: string
      remark?: string | null
      createdAt: string
    }>
  }
}

export type MerchantAccountAvailableBalanceQueryVariables = Exact<{
  merchantId: Scalars['Int']['input']
  currency: Scalars['String']['input']
}>

export type MerchantAccountAvailableBalanceQuery = {
  merchantAccountAvailableBalance: number
}

export type DownloadMerchantAccountEntryExcelMutationVariables = Exact<{
  merchantId?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<MerchantAccountEntryListInput>
}>

export type DownloadMerchantAccountEntryExcelMutation = {
  downloadMerchantAccountEntryExcel: {
    __typename?: 'AccountExportResponse'
    downloadUrl?: string | null
    jobId?: string | null
    recordCount: number
    processType: string
    message?: string | null
  }
}

export type GetMerchantCryptoRefundFeesQueryVariables = Exact<{
  merchantId: Scalars['Int']['input']
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
}>

export type GetMerchantCryptoRefundFeesQuery = {
  merchantCryptoRefundFees: {
    __typename?: 'MerchantCryptoRefundFeeList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'MerchantCryptoRefundFee'
      id: string
      merchantId: number
      payableCurrencyId: number
      currencyId: number
      feeType: CryptoRefundFeeType
      feeAmount: number
      minFee?: number | null
      maxFee?: number | null
      isActive: boolean
      description?: string | null
      createdAt: string
    }>
  }
}

export type GetMerchantCryptoRefundFeeQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetMerchantCryptoRefundFeeQuery = {
  merchantCryptoRefundFee: {
    __typename?: 'MerchantCryptoRefundFee'
    id: string
    merchantId: number
    payableCurrencyId: number
    currencyId: number
    feeType: CryptoRefundFeeType
    feeAmount: number
    minFee?: number | null
    maxFee?: number | null
    isActive: boolean
    description?: string | null
    createdAt: string
  }
}

export type GetMerchantExchangeMarginsQueryVariables = Exact<{
  filter?: InputMaybe<MerchantExchangeMarginFilterInput>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetMerchantExchangeMarginsQuery = {
  merchantExchangeMargins: {
    __typename?: 'MerchantExchangeMarginList'
    totalCount: number
    totalPages: number
    page: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'MerchantExchangeMargin'
      id: string
      merchantId: number
      fromCurrencyId: number
      toCurrencyId: number
      paymentMarginRate?: number | null
      depositMarginRate?: number | null
      withdrawalMarginRate?: number | null
      effectivePaymentMargin: number
      effectiveDepositMargin: number
      effectiveWithdrawalMargin: number
      isActive: boolean
      createdAt: string
      updatedAt: string
      fromCurrency: {
        __typename?: 'Currency'
        id: string
        code: string
        name: string
        symbol: string
      }
      toCurrency: {
        __typename?: 'Currency'
        id: string
        code: string
        name: string
        symbol: string
      }
    }>
  }
}

export type GetMerchantExchangeMarginQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetMerchantExchangeMarginQuery = {
  merchantExchangeMargin?: {
    __typename?: 'MerchantExchangeMargin'
    id: string
    merchantId: number
    fromCurrencyId: number
    toCurrencyId: number
    paymentMarginRate?: number | null
    depositMarginRate?: number | null
    withdrawalMarginRate?: number | null
    effectivePaymentMargin: number
    effectiveDepositMargin: number
    effectiveWithdrawalMargin: number
    isActive: boolean
    createdAt: string
    updatedAt: string
    fromCurrency: {
      __typename?: 'Currency'
      id: string
      code: string
      name: string
      symbol: string
    }
    toCurrency: {
      __typename?: 'Currency'
      id: string
      code: string
      name: string
      symbol: string
    }
  } | null
}

export type CreateMerchantExchangeMarginMutationVariables = Exact<{
  input: CreateMerchantExchangeMarginInput
}>

export type CreateMerchantExchangeMarginMutation = {
  createMerchantExchangeMargin: {
    __typename?: 'MerchantExchangeMargin'
    id: string
    merchantId: number
    fromCurrencyId: number
    toCurrencyId: number
    paymentMarginRate?: number | null
    depositMarginRate?: number | null
    withdrawalMarginRate?: number | null
    isActive: boolean
    createdAt: string
    updatedAt: string
    fromCurrency: {
      __typename?: 'Currency'
      id: string
      code: string
      name: string
    }
    toCurrency: {
      __typename?: 'Currency'
      id: string
      code: string
      name: string
    }
  }
}

export type UpdateMerchantExchangeMarginMutationVariables = Exact<{
  id: Scalars['Int']['input']
  input: UpdateMerchantExchangeMarginInput
}>

export type UpdateMerchantExchangeMarginMutation = {
  updateMerchantExchangeMargin: {
    __typename?: 'MerchantExchangeMargin'
    id: string
    merchantId: number
    fromCurrencyId: number
    toCurrencyId: number
    paymentMarginRate?: number | null
    depositMarginRate?: number | null
    withdrawalMarginRate?: number | null
    isActive: boolean
    createdAt: string
    updatedAt: string
    fromCurrency: {
      __typename?: 'Currency'
      id: string
      code: string
      name: string
    }
    toCurrency: {
      __typename?: 'Currency'
      id: string
      code: string
      name: string
    }
  }
}

export type DeleteMerchantExchangeMarginMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteMerchantExchangeMarginMutation = {
  deleteMerchantExchangeMargin: boolean
}

export type GetFilteredMerchantsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<MerchantFilterInput>
}>

export type GetFilteredMerchantsQuery = {
  merchants: {
    __typename?: 'MerchantList'
    totalCount: number
    page: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    limit: number
    items: Array<{
      __typename?: 'Merchant'
      id: string
      name: string
      email: string
      mid: string
      status: MerchantStatus
      type: MerchantType
      businessNumber?: string | null
      businessName?: string | null
      representativeName?: string | null
      businessPhoneCountryCode?: string | null
      businessPhoneNumber?: string | null
      createdAt: string
      riskLevel: string
    }>
  }
}

export type IsAddressVerifiedQueryVariables = Exact<{
  input: AddressVerifiedInput
}>

export type IsAddressVerifiedQuery = { isAddressVerified: boolean }

export type MicroTransferQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type MicroTransferQuery = {
  microTransfer: {
    __typename?: 'MicroTransferModel'
    id: string
    currency: string
    network: string
    address: string
    feeAmount: number
    status: MicroTransferStatus
    attempts: number
    expiresAt?: string | null
    createdAt: string
  }
}

export type ActiveMicroTransferQueryVariables = Exact<{
  input: ActiveMicroTransferInput
}>

export type ActiveMicroTransferQuery = {
  activeMicroTransfer?: {
    __typename?: 'MicroTransferModel'
    id: string
    currency: string
    network: string
    address: string
    feeAmount: number
    status: MicroTransferStatus
    attempts: number
    expiresAt?: string | null
    createdAt: string
  } | null
}

export type RequestMicroTransferMutationVariables = Exact<{
  input: RequestMicroTransferInput
}>

export type RequestMicroTransferMutation = {
  requestMicroTransfer: {
    __typename?: 'MicroTransferModel'
    id: string
    feeAmount: number
    status: MicroTransferStatus
    attempts: number
    expiresAt?: string | null
  }
}

export type VerifyMicroTransferCodeMutationVariables = Exact<{
  input: VerifyMicroTransferCodeInput
}>

export type VerifyMicroTransferCodeMutation = {
  verifyMicroTransferCode: {
    __typename?: 'VerifyMicroTransferCodeModel'
    success: boolean
    status: MicroTransferStatus
    remainingAttempts: number
  }
}

export type InProgressMicroTransfersQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['Int']['input']>
}>

export type InProgressMicroTransfersQuery = {
  inProgressMicroTransfers: Array<{
    __typename?: 'MicroTransferModel'
    id: string
    currency: string
    network: string
    address: string
    status: MicroTransferStatus
    attempts: number
    expiresAt?: string | null
    createdAt: string
  }>
}

export type RecheckMicroTransferMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type RecheckMicroTransferMutation = {
  recheckMicroTransfer: {
    __typename?: 'MicroTransferModel'
    id: string
    currency: string
    network: string
    address: string
    status: MicroTransferStatus
    attempts: number
    expiresAt?: string | null
    createdAt: string
  }
}

export type OfframpListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<OfframpListInput>
}>

export type OfframpListQuery = {
  offrampList: {
    __typename?: 'OfframpPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'OfframpResponse'
      id: string
      merchantId: number
      orderId: string
      channel?: OfframpChannel | null
      channelOrderId?: string | null
      originAmount: number
      originCurrency: string
      targetAmount: number
      targetCurrency: string
      channelFeeAmount?: number | null
      feeAmount?: number | null
      failedReason?: string | null
      netAmount?: number | null
      status: OfframpStatus
      createdAt: string
      createdBy?: {
        __typename?: 'TransactionCreator'
        userId: number
        name?: string | null
        email: string
      } | null
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type OfframpDetailQueryVariables = Exact<{
  orderId: Scalars['String']['input']
}>

export type OfframpDetailQuery = {
  offrampDetail: {
    __typename?: 'OfframpDetailResponse'
    id: string
    merchantId: number
    orderId: string
    channel?: OfframpChannel | null
    channelOrderId?: string | null
    originAmount: number
    originCurrency: string
    targetAmount: number
    targetCurrency: string
    channelFeeAmount?: number | null
    feeAmount?: number | null
    failedReason?: string | null
    netAmount?: number | null
    status: OfframpStatus
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    metaData?: any | null
    createdBy?: {
      __typename?: 'TransactionCreator'
      userId: number
      name?: string | null
      email: string
    } | null
    merchant?: {
      __typename?: 'Merchant'
      id: string
      name: string
      mid: string
    } | null
  }
}

export type DownloadOfframpExcelMutationVariables = Exact<{
  filter?: InputMaybe<OfframpListInput>
}>

export type DownloadOfframpExcelMutation = {
  downloadOfframpExcel: {
    __typename?: 'OfframpExportResponse'
    downloadUrl?: string | null
    jobId?: string | null
    message?: string | null
    processType: string
    recordCount: number
  }
}

export type OnrampListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<OnrampListInput>
}>

export type OnrampListQuery = {
  onrampList: {
    __typename?: 'OnrampPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'OnrampResponse'
      id: string
      merchantId: number
      orderId: string
      channel?: OnrampChannel | null
      channelOrderId?: string | null
      originAmount: number
      originCurrency: string
      targetAmount: number
      targetCurrency: string
      channelFeeAmount?: number | null
      feeAmount?: number | null
      failedReason?: string | null
      netAmount?: number | null
      status: OnrampStatus
      createdAt: string
      createdBy?: {
        __typename?: 'TransactionCreator'
        userId: number
        name?: string | null
        email: string
      } | null
      fundingTransfer?: {
        __typename?: 'OnrampFundingTransfer'
        status: ChannelTransferStatus
      } | null
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type OnrampDetailQueryVariables = Exact<{
  orderId: Scalars['String']['input']
}>

export type OnrampDetailQuery = {
  onrampDetail: {
    __typename?: 'OnrampDetailResponse'
    id: string
    merchantId: number
    orderId: string
    channel?: OnrampChannel | null
    channelOrderId?: string | null
    originAmount: number
    originCurrency: string
    targetAmount: number
    targetCurrency: string
    channelFeeAmount?: number | null
    feeAmount?: number | null
    failedReason?: string | null
    netAmount?: number | null
    status: OnrampStatus
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    metaData?: any | null
    onrampChannel?: string | null
    fundingSource?: string | null
    createdBy?: {
      __typename?: 'TransactionCreator'
      userId: number
      name?: string | null
      email: string
    } | null
    fundingTransfer?: {
      __typename?: 'OnrampFundingTransfer'
      id: string
      transferId: string
      sourceChannel: string
      targetChannel: string
      requestedAmount?: number | null
      requestedCurrency?: string | null
      targetAmount?: number | null
      targetCurrency?: string | null
      providerRef?: string | null
      status: ChannelTransferStatus
      errorMessage?: string | null
      canSimulate: boolean
    } | null
    merchant?: {
      __typename?: 'Merchant'
      id: string
      name: string
      mid: string
    } | null
  }
}

export type DownloadOnrampExcelMutationVariables = Exact<{
  filter?: InputMaybe<OnrampListInput>
}>

export type DownloadOnrampExcelMutation = {
  downloadOnrampExcel: {
    __typename?: 'OnrampExportResponse'
    downloadUrl?: string | null
    jobId?: string | null
    message?: string | null
    processType: string
    recordCount: number
  }
}

export type GetPaymentAdjustmentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<PaymentAdjustmentFilterInput>
}>

export type GetPaymentAdjustmentsQuery = {
  paymentAdjustments: {
    __typename?: 'PaymentAdjustmentList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'PaymentAdjustment'
      id: string
      paymentId: string
      transactionId: string
      merchantId: number
      reason: AdjustmentReason
      decision: AdjustmentDecision
      decisionSource?: DecisionSource | null
      decidedAt?: string | null
      originalAmount: number
      originalCurrencyId: number
      originalCurrency?: string | null
      originalPayableAmount?: number | null
      originalPayableCurrencyId?: number | null
      originalPayableCurrency?: string | null
      actualReceivedAmount: number
      actualCurrencyId: number
      actualCurrency?: string | null
      finalAmount?: number | null
      finalCurrencyId?: number | null
      finalCurrency?: string | null
      fxRateSnapshotInit?: number | null
      fxRateSnapshotFinal?: number | null
      rejectReason?: string | null
      createdAt: string
      updatedAt: string
    }>
  }
}

export type GetPaymentAdjustmentQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetPaymentAdjustmentQuery = {
  paymentAdjustment: {
    __typename?: 'PaymentAdjustment'
    id: string
    paymentId: string
    transactionId: string
    merchantId: number
    reason: AdjustmentReason
    decision: AdjustmentDecision
    decisionSource?: DecisionSource | null
    decidedAt?: string | null
    originalAmount: number
    originalCurrencyId: number
    originalCurrency?: string | null
    actualReceivedAmount: number
    actualCurrencyId: number
    actualCurrency?: string | null
    finalAmount?: number | null
    finalCurrencyId?: number | null
    finalCurrency?: string | null
    fxRateSnapshotInit?: number | null
    fxRateSnapshotFinal?: number | null
    rejectReason?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type PaymentGatewaysQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<PaymentGatewayFilterInput>
}>

export type PaymentGatewaysQuery = {
  paymentGateways: {
    __typename?: 'PaymentGatewayList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'PaymentGateway'
      id: number
      code: string
      name: string
      status?: GatewayStatus | null
      supportedMethods?: Array<PaymentMethod> | null
      supportedCurrencies?: Array<string> | null
      baseFeeRate?: number | null
      supportsPartialRefund?: boolean | null
      supportsWebhook?: boolean | null
      supportsRecurring?: boolean | null
      supportsInstantSettlement?: boolean | null
      createdAt?: string | null
      updatedAt?: string | null
    }>
  }
}

export type ActivePaymentGatewaysQueryVariables = Exact<{
  [key: string]: never
}>

export type ActivePaymentGatewaysQuery = {
  activePaymentGateways: Array<{
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
    supportedMethods?: Array<PaymentMethod> | null
    supportedCurrencies?: Array<string> | null
    baseFeeRate?: number | null
    status?: GatewayStatus | null
  }>
}

export type PaymentGatewayQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type PaymentGatewayQuery = {
  paymentGateway: {
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
    status?: GatewayStatus | null
    baseUrl?: string | null
    apiVersion?: string | null
    supportedMethods?: Array<PaymentMethod> | null
    supportedCurrencies?: Array<string> | null
    baseFeeRate?: number | null
    minAmount?: number | null
    maxAmount?: number | null
    settlementCycle?: number | null
    supportsPartialRefund?: boolean | null
    supportsWebhook?: boolean | null
    supportsRecurring?: boolean | null
    supportsInstantSettlement?: boolean | null
    createdAt?: string | null
    updatedAt?: string | null
  }
}

export type PaymentGatewayByCodeQueryVariables = Exact<{
  code: Scalars['String']['input']
}>

export type PaymentGatewayByCodeQuery = {
  paymentGatewayByCode?: {
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
    status?: GatewayStatus | null
    supportedMethods?: Array<PaymentMethod> | null
    supportedCurrencies?: Array<string> | null
    baseFeeRate?: number | null
    minAmount?: number | null
    maxAmount?: number | null
    settlementCycle?: number | null
    supportsPartialRefund?: boolean | null
    supportsWebhook?: boolean | null
    supportsRecurring?: boolean | null
    supportsInstantSettlement?: boolean | null
  } | null
}

export type PaymentGatewaysByMethodQueryVariables = Exact<{
  paymentMethod: PaymentMethod
}>

export type PaymentGatewaysByMethodQuery = {
  paymentGatewaysByMethod: Array<{
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
    supportedMethods?: Array<PaymentMethod> | null
    supportedCurrencies?: Array<string> | null
    status?: GatewayStatus | null
  }>
}

export type GetPaymentMethodConfigsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<PaymentMethodConfigFilterInput>
}>

export type GetPaymentMethodConfigsQuery = {
  paymentMethodConfigs: {
    __typename?: 'PaymentMethodConfigList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'PaymentMethodConfig'
      id: number
      paymentMethod: PaymentMethod
      displayName: string
      icon?: string | null
      description?: string | null
      priority: number
      defaultMinAmount?: number | null
      defaultMaxAmount?: number | null
      isEnabled: boolean
      metadata?: any | null
      createdAt: string
      updatedAt: string
    }>
  }
}

export type GetPaymentMethodConfigQueryVariables = Exact<{
  id: Scalars['Float']['input']
}>

export type GetPaymentMethodConfigQuery = {
  paymentMethodConfig?: {
    __typename?: 'PaymentMethodConfig'
    id: number
    paymentMethod: PaymentMethod
    displayName: string
    icon?: string | null
    description?: string | null
    priority: number
    defaultMinAmount?: number | null
    defaultMaxAmount?: number | null
    isEnabled: boolean
    metadata?: any | null
    createdAt: string
    updatedAt: string
  } | null
}

export type CreatePaymentMethodConfigMutationVariables = Exact<{
  input: CreatePaymentMethodConfigInput
}>

export type CreatePaymentMethodConfigMutation = {
  createPaymentMethodConfig: {
    __typename?: 'PaymentMethodConfig'
    id: number
    paymentMethod: PaymentMethod
    displayName: string
    icon?: string | null
    description?: string | null
    priority: number
    defaultMinAmount?: number | null
    defaultMaxAmount?: number | null
    isEnabled: boolean
    metadata?: any | null
  }
}

export type UpdatePaymentMethodConfigMutationVariables = Exact<{
  id: Scalars['Float']['input']
  input: UpdatePaymentMethodConfigInput
}>

export type UpdatePaymentMethodConfigMutation = {
  updatePaymentMethodConfig: {
    __typename?: 'PaymentMethodConfig'
    id: number
    paymentMethod: PaymentMethod
    displayName: string
    icon?: string | null
    description?: string | null
    priority: number
    defaultMinAmount?: number | null
    defaultMaxAmount?: number | null
    isEnabled: boolean
    metadata?: any | null
  }
}

export type DeletePaymentMethodConfigMutationVariables = Exact<{
  id: Scalars['Float']['input']
}>

export type DeletePaymentMethodConfigMutation = {
  deletePaymentMethodConfig: { __typename?: 'PaymentMethodConfig'; id: number }
}

export type PaymentMethodRoutingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<PaymentMethodRoutingFilterInput>
}>

export type PaymentMethodRoutingsQuery = {
  paymentMethodRoutings: {
    __typename?: 'PaymentMethodRoutingList'
    totalCount: number
    page: number
    limit: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'PaymentMethodRouting'
      id: number
      paymentMethod: PaymentMethod
      priority: number
      isActive: boolean
      isDefault: boolean
      successRate?: number | null
      avgResponseTime?: number | null
      availability?: number | null
      gateway?: {
        __typename?: 'PaymentGateway'
        id: number
        code: string
        name: string
        status?: GatewayStatus | null
      } | null
    }>
  }
}

export type PaymentMethodRoutingQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type PaymentMethodRoutingQuery = {
  paymentMethodRouting: {
    __typename?: 'PaymentMethodRouting'
    id: number
    paymentMethod: PaymentMethod
    priority: number
    isActive: boolean
    isDefault: boolean
    successRate?: number | null
    avgResponseTime?: number | null
    availability?: number | null
    createdAt: string
    updatedAt: string
    gateway?: {
      __typename?: 'PaymentGateway'
      id: number
      code: string
      name: string
      status?: GatewayStatus | null
      baseFeeRate?: number | null
      minAmount?: number | null
      maxAmount?: number | null
      settlementCycle?: number | null
    } | null
  }
}

export type RoutingsByPaymentMethodQueryVariables = Exact<{
  paymentMethod: PaymentMethod
}>

export type RoutingsByPaymentMethodQuery = {
  routingsByPaymentMethod: Array<{
    __typename?: 'PaymentMethodRouting'
    id: number
    priority: number
    isActive: boolean
    isDefault: boolean
    successRate?: number | null
    avgResponseTime?: number | null
    availability?: number | null
    gateway?: {
      __typename?: 'PaymentGateway'
      id: number
      code: string
      name: string
      status?: GatewayStatus | null
    } | null
  }>
}

export type CryptoPayoutListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<CryptoPayoutListInput>
}>

export type CryptoPayoutListQuery = {
  cryptoPayoutList: {
    __typename?: 'CryptoPayoutPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'CryptoPayoutResponse'
      id: string
      merchantId: number
      batchNo?: string | null
      orderId: string
      merchantOrderId?: string | null
      channel?: CryptoPayoutChannel | null
      channelOrderId?: string | null
      currency: string
      address: string
      targetAmount: number
      feeAmount?: number | null
      channelFeeAmount?: number | null
      totalAmount?: number | null
      status: CryptoPayoutStatus
      createdAt: string
      createdBy?: {
        __typename?: 'TransactionCreator'
        userId: number
        name?: string | null
        email: string
      } | null
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type CryptoPayoutDetailQueryVariables = Exact<{
  orderId: Scalars['String']['input']
}>

export type CryptoPayoutDetailQuery = {
  cryptoPayoutDetail: {
    __typename?: 'CryptoPayoutDetailResponse'
    id: string
    merchantId: number
    orderId: string
    merchantOrderId?: string | null
    channel?: CryptoPayoutChannel | null
    channelOrderId?: string | null
    currency: string
    network: string
    address: string
    targetAmount: number
    feeAmount?: number | null
    totalAmount?: number | null
    channelFeeAmount?: number | null
    status: CryptoPayoutStatus
    failedReason?: string | null
    chainTx?: string | null
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    batchId?: number | null
    metaData?: any | null
    createdBy?: {
      __typename?: 'TransactionCreator'
      userId: number
      name?: string | null
      email: string
    } | null
    merchant?: {
      __typename?: 'Merchant'
      id: string
      name: string
      mid: string
    } | null
  }
}

export type BatchCryptoPayoutQueryVariables = Exact<{
  batchId: Scalars['Int']['input']
}>

export type BatchCryptoPayoutQuery = {
  batchCryptoPayout: {
    __typename?: 'BatchCryptoPayoutResponse'
    id: number
    batchNo: string
    remark?: string | null
    createdBy?: {
      __typename?: 'TransactionCreator'
      userId: number
      name?: string | null
      email: string
    } | null
  }
}

export type RecentCryptoPayoutAddressesQueryVariables = Exact<{
  currency: Scalars['String']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
}>

export type RecentCryptoPayoutAddressesQuery = {
  recentCryptoPayoutAddresses: Array<string>
}

export type MerchantFrequentRecipientsQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId: Scalars['Int']['input']
  network: Scalars['String']['input']
  search?: InputMaybe<Scalars['String']['input']>
}>

export type MerchantFrequentRecipientsQuery = {
  merchantFrequentRecipients: {
    __typename?: 'MerchantFrequentRecipientPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'MerchantFrequentRecipientModel'
      id: number
      merchantId: number
      recipientName: string
      network: string
      address: string
      createdAt: string
      updatedAt: string
    }>
  }
}

export type MerchantFrequentRecipientQueryVariables = Exact<{
  merchantId: Scalars['Int']['input']
  network: Scalars['String']['input']
  address: Scalars['String']['input']
}>

export type MerchantFrequentRecipientQuery = {
  merchantFrequentRecipient?: {
    __typename?: 'MerchantFrequentRecipientModel'
    id: number
    merchantId: number
    recipientName: string
    network: string
    address: string
    createdAt: string
    updatedAt: string
  } | null
}

export type DownloadCryptoPayoutExcelMutationVariables = Exact<{
  filter?: InputMaybe<CryptoPayoutListInput>
}>

export type DownloadCryptoPayoutExcelMutation = {
  downloadCryptoPayoutExcel: {
    __typename?: 'CryptoPayoutExportResponse'
    downloadUrl?: string | null
    jobId?: string | null
    message?: string | null
    processType: string
    recordCount: number
  }
}

export type GetPgSettlementsQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  gatewayId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<PgSettlementStatus>
  settlementType?: InputMaybe<PgSettlementType>
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>
  dateTo?: InputMaybe<Scalars['DateTime']['input']>
}>

export type GetPgSettlementsQuery = {
  pgSettlements: {
    __typename?: 'PgSettlementListModel'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'PgSettlementModel'
      id: string
      batchId: string
      gatewayId: number
      dateFrom: string
      dateTo: string
      currency: string
      settlementType: PgSettlementType
      triggeredBy?: string | null
      status: PgSettlementStatus
      requestedAt: string
      completedAt?: string | null
      createdAt: string
      updatedAt: string
      itemCount: number
    }>
  }
}

export type GetPgSettlementQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetPgSettlementQuery = {
  pgSettlement: {
    __typename?: 'PgSettlementModel'
    id: string
    batchId: string
    gatewayId: number
    dateFrom: string
    dateTo: string
    currency: string
    status: PgSettlementStatus
    requestedAt: string
    submittedAt?: string | null
    completedAt?: string | null
    errorCode?: string | null
    errorMessage?: string | null
    createdAt: string
    updatedAt: string
    gateway?: {
      __typename?: 'PaymentGateway'
      id: number
      code: string
      name: string
    } | null
    items: Array<{
      __typename?: 'PgSettlementItemModel'
      id: string
      pgSettlementId: string
      payableCurrencyCode: string
      orderCurrencyCode?: string | null
      requestedAmount: number
      settledAmount?: number | null
      transactionCount?: number | null
      pgSettlementRef?: string | null
      txHash?: string | null
      status: PgSettlementItemStatus
      createdAt: string
      updatedAt: string
      transfers: Array<{
        __typename?: 'PgSettlementTransferModel'
        id: string
        pgSettlementItemId: string
        requestId: string
        providerRef?: string | null
        transferType: TransferType
        sourceAmount: number
        sourceCurrency: string
        sourceNetwork?: string | null
        sourceChannelCode?: string | null
        destChannelCode?: string | null
        destinationType: DestinationType
        destinationId?: string | null
        destinationInfo?: any | null
        txHash?: string | null
        blockNumber?: number | null
        status: PgSettlementTransferStatus
        requestedAt: string
        submittedAt?: string | null
        processedAt?: string | null
        completedAt?: string | null
        errorCode?: string | null
        errorMessage?: string | null
        retryCount: number
        notes?: string | null
        targetAmount?: number | null
        targetCurrency?: string | null
        exchangeRate?: number | null
        receivedAmount?: number | null
        receivedCurrency?: string | null
      }>
      feeRecords?: Array<{
        __typename?: 'PgSettlementFeeModel'
        id: string
        feeType: FeeType
        amount: number
        currency?: string | null
        txHash?: string | null
        blockNumber?: number | null
        description?: string | null
      }> | null
    }>
    timeline: {
      __typename?: 'PgSettlementTimelineModel'
      totalCount: number
      events: Array<{
        __typename?: 'PgSettlementEventModel'
        id: string
        pgSettlementId?: string | null
        pgSettlementTransferId?: string | null
        eventType: PgSettlementEventType
        eventSource: string
        previousStatus?: string | null
        newStatus?: string | null
        title: string
        description?: string | null
        metadata?: any | null
        occurredAt: string
        createdAt: string
        createdBy?: string | null
      }>
    }
  }
}

export type GetPgSettlementByBatchIdQueryVariables = Exact<{
  batchId: Scalars['String']['input']
}>

export type GetPgSettlementByBatchIdQuery = {
  pgSettlementByBatchId: {
    __typename?: 'PgSettlementModel'
    id: string
    batchId: string
    gatewayId: number
    status: PgSettlementStatus
    dateFrom: string
    dateTo: string
    currency: string
    requestedAt: string
    completedAt?: string | null
    createdAt: string
    updatedAt: string
  }
}

export type GetPgSettlementTransferQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetPgSettlementTransferQuery = {
  pgSettlementTransfer: {
    __typename?: 'PgSettlementTransferModel'
    id: string
    pgSettlementItemId: string
    requestId: string
    providerRef?: string | null
    transferType: TransferType
    sourceAmount: number
    sourceCurrency: string
    sourceNetwork?: string | null
    sourceChannelCode?: string | null
    destChannelCode?: string | null
    destinationType: DestinationType
    destinationId?: string | null
    destinationInfo?: any | null
    txHash?: string | null
    blockNumber?: number | null
    status: PgSettlementTransferStatus
    requestedAt: string
    submittedAt?: string | null
    processedAt?: string | null
    completedAt?: string | null
    errorCode?: string | null
    errorMessage?: string | null
    retryCount: number
    notes?: string | null
    targetAmount?: number | null
    targetCurrency?: string | null
    exchangeRate?: number | null
    receivedAmount?: number | null
    receivedCurrency?: string | null
    providerRequest?: any | null
    providerResponse?: any | null
    createdAt: string
    updatedAt: string
  }
}

export type GetPgSettlementPreviewQueryVariables = Exact<{
  input: PgSettlementPreviewInput
}>

export type GetPgSettlementPreviewQuery = {
  pgSettlementPreview: {
    __typename?: 'PgSettlementPreviewModel'
    dateFrom: string
    dateTo: string
    totalItems: number
    items: Array<{
      __typename?: 'PgSettlementPreviewItemModel'
      gatewayId: number
      gatewayName: string
      gatewayCode: string
      payableCurrencyId: number
      payableCurrencyCode: string
      payableCurrencyName: string
      orderCurrencyId: number
      orderCurrencyCode: string
      originalPaymentAmount: number
      originalRefundAmount: number
      originalNetAmount: number
      payablePaymentAmount: number
      payableRefundAmount: number
      payableNetAmount: number
      paymentCount: number
      refundCount: number
      totalTransactionCount: number
    }>
  }
}

export type GetPgSettlementWalletConfigsQueryVariables = Exact<{
  gatewayCode?: InputMaybe<Scalars['String']['input']>
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetPgSettlementWalletConfigsQuery = {
  pgSettlementWalletConfigs: Array<{
    __typename?: 'PgSettlementWalletConfigModel'
    id: string
    gatewayId: number
    gatewayCode: string
    gatewayName: string
    currencyId: number
    currencyCode: string
    network?: string | null
    walletAddress: string
    walletMemo?: string | null
    isActive: boolean
    targetChannelCode?: string | null
    createdAt: string
    updatedAt: string
    createdBy?: number | null
  }>
}

export type GetPgSettlementWalletConfigQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetPgSettlementWalletConfigQuery = {
  pgSettlementWalletConfig: {
    __typename?: 'PgSettlementWalletConfigModel'
    id: string
    gatewayId: number
    gatewayCode: string
    gatewayName: string
    currencyId: number
    currencyCode: string
    network?: string | null
    walletAddress: string
    walletMemo?: string | null
    isActive: boolean
    targetChannelCode?: string | null
    createdAt: string
    updatedAt: string
    createdBy?: number | null
  }
}

export type GetAllActiveWalletConfigsQueryVariables = Exact<{
  [key: string]: never
}>

export type GetAllActiveWalletConfigsQuery = {
  pgSettlementWalletConfigs: Array<{
    __typename?: 'PgSettlementWalletConfigModel'
    id: string
    gatewayId: number
    gatewayCode: string
    gatewayName: string
    currencyId: number
    currencyCode: string
    network?: string | null
    walletAddress: string
    walletMemo?: string | null
  }>
}

export type GetPgSettlementProcessedPeriodsQueryVariables = Exact<{
  gatewayCode: Scalars['String']['input']
  settlementType: PgSettlementType
}>

export type GetPgSettlementProcessedPeriodsQuery = {
  pgSettlementProcessedPeriods: Array<{
    __typename?: 'PgSettlementPeriodModel'
    dateFrom: string
    dateTo: string
    status: PgSettlementStatus
  }>
}

export type GetReconciliationMismatchItemsQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<ReconciliationMismatchItemFilterInput>
}>

export type GetReconciliationMismatchItemsQuery = {
  reconciliationMismatchItems: {
    __typename?: 'ReconciliationMismatchItemList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<
      {
        __typename?: 'ReconciliationMismatchItem'
      } & ReconciliationMismatchItemFieldsFragment
    >
  }
}

export type GetReconciliationMismatchItemQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetReconciliationMismatchItemQuery = {
  reconciliationMismatchItem?:
    | ({
        __typename?: 'ReconciliationMismatchItem'
      } & ReconciliationMismatchItemFieldsFragment)
    | null
}

export type ReconciliationMismatchItemFieldsFragment = {
  __typename?: 'ReconciliationMismatchItem'
  id: string
  gatewayId: number
  kind: ReconciliationMismatchKind
  txKind: string
  itemKey: string
  amount?: string | null
  currency?: string | null
  occurredAt?: string | null
  detail?: any | null
  status: ReconciliationMismatchStatus
  resolution?: string | null
  note?: string | null
  resolvedBy?: string | null
  resolvedAt?: string | null
  firstRunId: string
  lastRunId: string
  firstDetectedAt: string
  lastDetectedAt: string
  lastAlertedAt?: string | null
  alertCount: number
  gateway?: {
    __typename?: 'PaymentGateway'
    id: number
    code: string
    name: string
  } | null
}

export type GetReconciliationRunsQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<ReconciliationRunFilterInput>
}>

export type GetReconciliationRunsQuery = {
  reconciliationRuns: {
    __typename?: 'ReconciliationRunList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'ReconciliationRun'
      id: string
      gatewayId: number
      dateFrom: string
      dateTo: string
      ourTotalCount: number
      ourMatchedCount: number
      ourUnmatchedCount: number
      pgTotalCount: number
      pgMatchedCount: number
      pgUnmatchedCount: number
      totalApiCalls: number
      status: string
      errorMessage?: string | null
      createdAt: string
      gateway?: {
        __typename?: 'PaymentGateway'
        id: number
        code: string
        name: string
      } | null
    }>
  }
}

export type GetReconciliationRunQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetReconciliationRunQuery = {
  reconciliationRun?: {
    __typename?: 'ReconciliationRun'
    id: string
    gatewayId: number
    dateFrom: string
    dateTo: string
    ourTotalCount: number
    ourMatchedCount: number
    ourUnmatchedCount: number
    ourUnmatchedKeys: any
    pgTotalCount: number
    pgMatchedCount: number
    pgUnmatchedCount: number
    pgUnmatchedCodes: any
    transactionMismatches?: any | null
    totalApiCalls: number
    status: string
    errorMessage?: string | null
    createdAt: string
    gateway?: {
      __typename?: 'PaymentGateway'
      id: number
      code: string
      name: string
      baseUrl?: string | null
    } | null
  } | null
}

export type GetRefundApprovalRequestsQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<RefundApprovalFilterInput>
}>

export type GetRefundApprovalRequestsQuery = {
  refundApprovalRequests: {
    __typename?: 'RefundApprovalRequestList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<
      {
        __typename?: 'RefundApprovalRequest'
      } & RefundApprovalRequestFieldsFragment
    >
  }
}

export type GetRefundApprovalRequestQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetRefundApprovalRequestQuery = {
  refundApprovalRequest: {
    __typename?: 'RefundApprovalRequest'
  } & RefundApprovalRequestFieldsFragment
}

export type RefundApprovalRequestFieldsFragment = {
  __typename?: 'RefundApprovalRequest'
  id: string
  paymentId: string
  merchantId: number
  merchantName: string
  amount: number
  currencyId: number
  currency: string
  reason?: string | null
  walletAddress: string
  originalSenderAddress?: string | null
  holdReason: RefundApprovalHoldReason
  requestedById: number
  requestedByEmail: string
  requesterRole: string
  requestIp?: string | null
  status: RefundApprovalRequestStatus
  reviewedById?: number | null
  reviewedByEmail?: string | null
  reviewedAt?: string | null
  reviewNote?: string | null
  executedTransactionId?: string | null
  executionError?: string | null
  createdAt: string
  updatedAt: string
}

export type RoleMenuPermissionsQueryVariables = Exact<{
  role: UserRole
}>

export type RoleMenuPermissionsQuery = {
  roleMenuPermissions: Array<{
    __typename?: 'RoleMenu'
    id: number
    menuId: number
    role: UserRole
    canView: boolean
    canCreate: boolean
    canEdit: boolean
    canDelete: boolean
    canExport: boolean
    isDefault: boolean
  }>
}

export type GetSettlementsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<SettlementFilterInput>
}>

export type GetSettlementsQuery = {
  settlements: {
    __typename?: 'SettlementList'
    totalCount: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'Settlement'
      id: number
      merchantId: number
      settlementDateFrom: string
      settlementDateTo: string
      grossAmount: number
      feeAmount: number
      netAmount: number
      refundAmount: number
      refundFeeAmount: number
      currency?: string | null
      status: SettlementStatus
      completedAt?: string | null
      createdAt: string
      updatedAt: string
      transactionCount: number
      paymentCount: number
      refundCount: number
      merchant: {
        __typename?: 'Merchant'
        id: string
        name: string
        businessName?: string | null
        companyName?: string | null
        mid: string
      }
    }>
  }
}

export type GetSettlementQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetSettlementQuery = {
  settlement: {
    __typename?: 'Settlement'
    id: number
    merchantId: number
    settlementDateFrom: string
    settlementDateTo: string
    grossAmount: number
    feeAmount: number
    netAmount: number
    refundAmount: number
    refundFeeAmount: number
    refundFeeCount: number
    currency?: string | null
    status: SettlementStatus
    completedAt?: string | null
    createdAt: string
    updatedAt: string
    transactionCount: number
    paymentCount: number
    refundCount: number
    merchant: {
      __typename?: 'Merchant'
      id: string
      name: string
      businessName?: string | null
      companyName?: string | null
      mid: string
      businessAddress?: string | null
      businessNumber?: string | null
      businessCategory?: string | null
    }
  }
}

export type DownloadSettlementExcelMutationVariables = Exact<{
  filter?: InputMaybe<SettlementFilterInput>
}>

export type DownloadSettlementExcelMutation = {
  downloadSettlementExcel: {
    __typename?: 'SettlementExcelResponse'
    downloadUrl?: string | null
    jobId?: string | null
    message: string
    recordCount: number
  }
}

export type DownloadTransactionExcelMutationVariables = Exact<{
  filter: TransactionExcelFilterInput
}>

export type DownloadTransactionExcelMutation = {
  downloadTransactionExcel: {
    __typename?: 'TransactionExcelResponse'
    downloadUrl?: string | null
    jobId?: string | null
    message: string
    recordCount: number
  }
}

export type GetPgSettlementTimelineQueryVariables = Exact<{
  pgSettlementId: Scalars['String']['input']
}>

export type GetPgSettlementTimelineQuery = {
  pgSettlementTimeline: {
    __typename?: 'PgSettlementTimelineModel'
    totalCount: number
    events: Array<{
      __typename?: 'PgSettlementEventModel'
      id: string
      pgSettlementId?: string | null
      pgSettlementTransferId?: string | null
      eventType: PgSettlementEventType
      eventSource: string
      previousStatus?: string | null
      newStatus?: string | null
      title: string
      description?: string | null
      metadata?: any | null
      occurredAt: string
      createdAt: string
      createdBy?: string | null
    }>
  }
}

export type GetSidebarMenusQueryVariables = Exact<{ [key: string]: never }>

export type GetSidebarMenusQuery = {
  userMenus: Array<{
    __typename?: 'Menu'
    id: string
    code: string
    name: string
    path?: string | null
    icon?: string | null
    sortOrder: number
    isVisible: boolean
    parentId?: number | null
    children?: Array<{
      __typename?: 'Menu'
      id: string
      code: string
      name: string
      path?: string | null
      icon?: string | null
      sortOrder: number
      isVisible: boolean
      parentId?: number | null
    }> | null
  }>
}

export type SystemSettingsQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']['input']>
}>

export type SystemSettingsQuery = {
  systemSettings: Array<{
    __typename?: 'SystemSettingModel'
    id: string
    category: string
    key: string
    value: string
    valueType: string
    description?: string | null
    updatedAt: string
  }>
}

export type TopupListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
  filter?: InputMaybe<TopupListInput>
}>

export type TopupListQuery = {
  topupList: {
    __typename?: 'TopupPage'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'TopupResponse'
      id: string
      merchantId?: number | null
      orderId: string
      channel: TopupChannel
      channelOrderId: string
      receivedAmount: number
      channelFeeAmount?: number | null
      currency: string
      feeAmount?: number | null
      netAmount?: number | null
      status: TopupStatus
      unmatchedDeposit?: boolean | null
      createdAt: string
      createdBy?: {
        __typename?: 'TransactionCreator'
        userId: number
        name?: string | null
        email: string
      } | null
      merchant?: {
        __typename?: 'Merchant'
        id: string
        name: string
        mid: string
      } | null
    }>
  }
}

export type TopupDetailQueryVariables = Exact<{
  orderId: Scalars['String']['input']
}>

export type TopupDetailQuery = {
  topupDetail: {
    __typename?: 'TopupDetailResponse'
    id: string
    merchantId?: number | null
    orderId: string
    channel: TopupChannel
    channelOrderId: string
    channelAccountNo?: string | null
    receivedAmount: number
    channelFeeAmount?: number | null
    currency: string
    feeAmount?: number | null
    netAmount?: number | null
    status: TopupStatus
    createdAt: string
    updatedAt: string
    completedAt?: string | null
    metaData?: any | null
    createdBy?: {
      __typename?: 'TransactionCreator'
      userId: number
      name?: string | null
      email: string
    } | null
    merchant?: {
      __typename?: 'Merchant'
      id: string
      name: string
      mid: string
    } | null
  }
}

export type TopupRequestListQueryVariables = Exact<{
  page: Scalars['Int']['input']
  limit: Scalars['Int']['input']
  filter?: InputMaybe<TopupRequestFilterInput>
}>

export type TopupRequestListQuery = {
  topupRequestList: {
    __typename?: 'TopupRequestList'
    totalCount: number
    page: number
    limit: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'TopupRequestModel'
      id: number
      requestId: string
      merchantId: number
      channel?: string | null
      amount: number
      currency: string
      tokenId?: string | null
      paymentReference?: string | null
      status: TopupRequestStatus
      topupId?: number | null
      receivedAmount?: number | null
      bankOrderNo?: string | null
      evidenceMemo?: string | null
      evidenceSubmittedAt?: string | null
      expiresAt: string
      completedAt?: string | null
      cancelledAt?: string | null
      createdAt: string
      createdBy?: {
        __typename?: 'TransactionCreator'
        userId: number
        name?: string | null
        email: string
      } | null
    }>
  }
}

export type TopupRequestDetailQueryVariables = Exact<{
  requestId: Scalars['String']['input']
}>

export type TopupRequestDetailQuery = {
  topupRequestDetail?: {
    __typename?: 'TopupRequestDetail'
    id: number
    requestId: string
    merchantId: number
    amount: number
    currency: string
    tokenId?: string | null
    paymentReference?: string | null
    status: TopupRequestStatus
    topupId?: number | null
    receivedAmount?: number | null
    bankOrderNo?: string | null
    evidenceMemo?: string | null
    evidenceSubmittedAt?: string | null
    expiresAt: string
    completedAt?: string | null
    cancelledAt?: string | null
    createdAt: string
    createdBy?: {
      __typename?: 'TransactionCreator'
      userId: number
      name?: string | null
      email: string
    } | null
    accountInfo?: {
      __typename?: 'TopupChannelAccountInfo'
      accountName?: string | null
      accountNumber?: string | null
      bankName?: string | null
      bankCode?: string | null
      branchCode?: string | null
      swiftCode?: string | null
      location?: string | null
    } | null
    cryptoInfo?: {
      __typename?: 'TopupCryptoAddressInfo'
      tokenId: string
      chain: string
      address: string
      qrDataUrl: string
    } | null
  } | null
}

export type TopupSupportedCurrenciesQueryVariables = Exact<{
  merchantId?: InputMaybe<Scalars['Int']['input']>
}>

export type TopupSupportedCurrenciesQuery = {
  topupSupportedCurrencies: Array<string>
  topupSupportedCryptoTokenIds: Array<string>
}

export type SimulateTopupDepositMutationVariables = Exact<{
  requestId: Scalars['String']['input']
}>

export type SimulateTopupDepositMutation = {
  simulateTopupDeposit: {
    __typename?: 'SimulateTopupDepositResult'
    depositId: string
    success: boolean
  }
}

export type GetMyInfoQueryVariables = Exact<{ [key: string]: never }>

export type GetMyInfoQuery = {
  me: {
    __typename?: 'User'
    id: number
    email: string
    emailVerified: boolean
    name: string
    phoneNumber?: string | null
    phoneCountryCode?: string | null
    phoneVerified: boolean
    role: UserRole
    status: UserStatus
    merchantId?: number | null
    twoFactorEnabled: boolean
    twoFactorCodeRequired: boolean
    lastLoginAt?: string | null
    createdAt: string
    updatedAt: string
    merchant?: {
      __typename?: 'Merchant'
      id: string
      name: string
      businessName?: string | null
      businessNumber?: string | null
      status: MerchantStatus
    } | null
  }
}

export type UpdateMyInfoMutationVariables = Exact<{
  input: UpdateUserInput
}>

export type UpdateMyInfoMutation = {
  updateUser: {
    __typename?: 'User'
    id: number
    name: string
    email: string
    phoneNumber?: string | null
    phoneCountryCode?: string | null
    updatedAt: string
  }
}

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput
}>

export type ChangePasswordMutation = { changePassword: boolean }

export type GetWithdrawalsQueryVariables = Exact<{
  filter?: InputMaybe<WithdrawalFilterInput>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetWithdrawalsQuery = {
  withdrawals: {
    __typename?: 'WithdrawalList'
    totalCount: number
    totalPages: number
    page: number
    limit: number
    hasNext: boolean
    hasPrev: boolean
    items: Array<{
      __typename?: 'Withdrawal'
      id: string
      requestedAmount: number
      requestedCurrency?: string | null
      feeAmount: number
      totalAmount: number
      status: WithdrawalStatus
      method: WithdrawalMethod
      createdAt: string
      processedAt?: string | null
      completedAt?: string | null
      failureReason?: string | null
      transactionRef?: string | null
      beneficiaryId?: number | null
      recipientInfo: any
      exchangeRate?: number | null
      fromAmount?: number | null
      fromCurrency?: string | null
      createdBy?: {
        __typename?: 'TransactionCreator'
        userId: number
        name?: string | null
        email: string
      } | null
      merchant?: { __typename?: 'Merchant'; id: string; name: string } | null
    }>
  }
}

export type GetWithdrawalQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetWithdrawalQuery = {
  withdrawal: {
    __typename?: 'Withdrawal'
    id: string
    requestedAmount: number
    requestedCurrency?: string | null
    feeAmount: number
    totalAmount: number
    status: WithdrawalStatus
    method: WithdrawalMethod
    createdAt: string
    processedAt?: string | null
    completedAt?: string | null
    failureReason?: string | null
    transactionRef?: string | null
    beneficiaryId?: number | null
    recipientInfo: any
    exchangeRate?: number | null
    fromAmount?: number | null
    fromCurrency?: string | null
    channel?: string | null
    channelOrderId?: string | null
    channelFeeAmount?: number | null
    metaData?: any | null
    attemptNo: number
    holdReason?: string | null
    estimatedBridgingFee?: number | null
    bridgingFeeAmount?: number | null
    actualPayoutAmount?: number | null
    createdBy?: {
      __typename?: 'TransactionCreator'
      userId: number
      name?: string | null
      email: string
    } | null
    merchant?: { __typename?: 'Merchant'; id: string; name: string } | null
  }
}

export type EstimateWithdrawalBridgingFeeQueryVariables = Exact<{
  fromCurrency: Scalars['String']['input']
  requestedCurrency: Scalars['String']['input']
  amount: Scalars['Float']['input']
  merchantId?: InputMaybe<Scalars['Int']['input']>
}>

export type EstimateWithdrawalBridgingFeeQuery = {
  estimateWithdrawalBridgingFee: {
    __typename?: 'WithdrawalBridgingFeeEstimate'
    feeAmount?: string | null
    receivedAmount?: string | null
    receivedCurrency: string
    minAmount: string
    maxAmount: string
    isEstimate: boolean
  }
}

export type WithdrawalProcessPreviewQueryVariables = Exact<{
  withdrawalId: Scalars['String']['input']
}>

export type WithdrawalProcessPreviewQuery = {
  withdrawalProcessPreview: {
    __typename?: 'WithdrawalProcessPreview'
    channel: string
    currency: string
    requiredAmount: number
    channelAvailable: number
    sufficient: boolean
  }
}

export type GetRecentWithdrawalsQueryVariables = Exact<{
  limit?: Scalars['Int']['input']
}>

export type GetRecentWithdrawalsQuery = {
  getRecentWithdrawals: Array<{
    __typename?: 'Withdrawal'
    id: string
    requestedAmount: number
    requestedCurrency?: string | null
    status: WithdrawalStatus
    method: WithdrawalMethod
    beneficiaryId?: number | null
    createdAt: string
    merchant?: {
      __typename?: 'Merchant'
      id: string
      companyName?: string | null
    } | null
  }>
}

export type CreateWithdrawalMutationVariables = Exact<{
  input: CreateWithdrawalInput
}>

export type CreateWithdrawalMutation = {
  createWithdrawal: {
    __typename?: 'Withdrawal'
    id: string
    requestedAmount: number
    requestedCurrency?: string | null
    feeAmount: number
    totalAmount: number
    status: WithdrawalStatus
    method: WithdrawalMethod
    createdAt: string
    beneficiaryId?: number | null
    recipientInfo: any
  }
}

export type UpdateWithdrawalMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: UpdateWithdrawalInput
}>

export type UpdateWithdrawalMutation = {
  updateWithdrawal: {
    __typename?: 'Withdrawal'
    id: string
    requestedAmount: number
    requestedCurrency?: string | null
    status: WithdrawalStatus
    method: WithdrawalMethod
    beneficiaryId?: number | null
    recipientInfo: any
    updatedAt: string
  }
}

export type CancelWithdrawalMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type CancelWithdrawalMutation = {
  cancelWithdrawal: {
    __typename?: 'Withdrawal'
    id: string
    status: WithdrawalStatus
    updatedAt: string
  }
}

export type ProcessWithdrawalMutationVariables = Exact<{
  input: ProcessWithdrawalInput
}>

export type ProcessWithdrawalMutation = {
  processWithdrawal: {
    __typename?: 'Withdrawal'
    id: string
    status: WithdrawalStatus
    processedAt?: string | null
    updatedAt: string
  }
}

export type CompleteWithdrawalMutationVariables = Exact<{
  input: CompleteWithdrawalInput
}>

export type CompleteWithdrawalMutation = {
  completeWithdrawal: {
    __typename?: 'Withdrawal'
    id: string
    status: WithdrawalStatus
    completedAt?: string | null
    transactionRef?: string | null
    updatedAt: string
  }
}

export type FailWithdrawalMutationVariables = Exact<{
  input: FailWithdrawalInput
}>

export type FailWithdrawalMutation = {
  failWithdrawal: {
    __typename?: 'Withdrawal'
    id: string
    status: WithdrawalStatus
    failureReason?: string | null
    updatedAt: string
  }
}

export type DownloadWithdrawalExcelMutationVariables = Exact<{
  filter?: InputMaybe<WithdrawalFilterInput>
}>

export type DownloadWithdrawalExcelMutation = {
  downloadWithdrawalExcel: {
    __typename?: 'WithdrawalExportResponse'
    downloadUrl?: string | null
    jobId?: string | null
    message?: string | null
    recordCount: number
  }
}

export type RetryWithdrawalMutationVariables = Exact<{
  input: RetryWithdrawalInput
}>

export type RetryWithdrawalMutation = {
  retryWithdrawal: {
    __typename?: 'Withdrawal'
    id: string
    status: WithdrawalStatus
    attemptNo: number
    updatedAt: string
  }
}

export type StartTwoFactorEnrollmentMutationVariables = Exact<{
  [key: string]: never
}>

export type StartTwoFactorEnrollmentMutation = {
  startTwoFactorEnrollment: {
    __typename?: 'EnrollmentStartModel'
    qrDataUrl: string
    manualKey: string
  }
}

export type ConfirmTwoFactorEnrollmentMutationVariables = Exact<{
  input: ConfirmEnrollmentInput
}>

export type ConfirmTwoFactorEnrollmentMutation = {
  confirmTwoFactorEnrollment: boolean
}

export type VerifyLoginTwoFactorMutationVariables = Exact<{
  input: VerifyLoginTwoFactorInput
}>

export type VerifyLoginTwoFactorMutation = {
  verifyLoginTwoFactor: {
    __typename?: 'SignInResponse'
    accessToken?: string | null
    refreshToken?: string | null
  }
}

export type ResetUserTwoFactorMutationVariables = Exact<{
  userId: Scalars['Int']['input']
}>

export type ResetUserTwoFactorMutation = { resetUserTwoFactor: boolean }

export type SecurityPolicyQueryVariables = Exact<{ [key: string]: never }>

export type SecurityPolicyQuery = {
  securityPolicy: {
    __typename?: 'SecurityPolicyModel'
    id: number
    requireTwoFactorForAdmin: boolean
    requireTwoFactorForMerchantAdmin: boolean
    requireTwoFactorForMerchantUser: boolean
    requireTwoFactorForDeveloper: boolean
  }
}

export type UpdateSecurityPolicyMutationVariables = Exact<{
  input: UpdateSecurityPolicyInput
}>

export type UpdateSecurityPolicyMutation = {
  updateSecurityPolicy: {
    __typename?: 'SecurityPolicyModel'
    id: number
    requireTwoFactorForAdmin: boolean
    requireTwoFactorForMerchantAdmin: boolean
    requireTwoFactorForMerchantUser: boolean
    requireTwoFactorForDeveloper: boolean
  }
}

export const MenuBasicInfoFragmentDoc = gql`
  fragment MenuBasicInfo on Menu {
    id
    code
    name
    path
    icon
    component
    menuType
    sortOrder
    isVisible
    isPublic
    target
    description
    excludeRoles
    parentId
  }
`
export const MenuWithPermissionsFragmentDoc = gql`
  fragment MenuWithPermissions on Menu {
    ...MenuBasicInfo
    permissions {
      canView
      canCreate
      canEdit
      canDelete
      canExport
    }
  }
`
export const SidebarMenuFieldsFragmentDoc = gql`
  fragment SidebarMenuFields on Menu {
    id
    name
    path
    icon
    sortOrder
    isVisible
    parentId
  }
`
export const SidebarMenuWithChildrenFragmentDoc = gql`
  fragment SidebarMenuWithChildren on Menu {
    ...SidebarMenuFields
    children {
      ...SidebarMenuFields
    }
  }
`
export const ReconciliationMismatchItemFieldsFragmentDoc = gql`
  fragment ReconciliationMismatchItemFields on ReconciliationMismatchItem {
    id
    gatewayId
    gateway {
      id
      code
      name
    }
    kind
    txKind
    itemKey
    amount
    currency
    occurredAt
    detail
    status
    resolution
    note
    resolvedBy
    resolvedAt
    firstRunId
    lastRunId
    firstDetectedAt
    lastDetectedAt
    lastAlertedAt
    alertCount
  }
`
export const RefundApprovalRequestFieldsFragmentDoc = gql`
  fragment RefundApprovalRequestFields on RefundApprovalRequest {
    id
    paymentId
    merchantId
    merchantName
    amount
    currencyId
    currency
    reason
    walletAddress
    originalSenderAddress
    holdReason
    requestedById
    requestedByEmail
    requesterRole
    requestIp
    status
    reviewedById
    reviewedByEmail
    reviewedAt
    reviewNote
    executedTransactionId
    executionError
    createdAt
    updatedAt
  }
`
export const SetPasswordByTokenDocument = gql`
  mutation SetPasswordByToken($input: SetPasswordByTokenInput!) {
    setPasswordByToken(input: $input)
  }
`
export function useSetPasswordByTokenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetPasswordByTokenMutation,
    SetPasswordByTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetPasswordByTokenMutation,
    SetPasswordByTokenMutationVariables
  >(SetPasswordByTokenDocument, options)
}
export type SetPasswordByTokenMutationHookResult = ReturnType<
  typeof useSetPasswordByTokenMutation
>
export type SetPasswordByTokenMutationResult =
  ApolloReactCommon.MutationResult<SetPasswordByTokenMutation>
export const AdminIpWhitelistDocument = gql`
  query AdminIpWhitelist {
    adminIpWhitelist {
      enabled
      currentIp
      entries {
        id
        ipCidr
        label
        createdAt
      }
    }
  }
`
export function useAdminIpWhitelistQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AdminIpWhitelistQuery,
    AdminIpWhitelistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    AdminIpWhitelistQuery,
    AdminIpWhitelistQueryVariables
  >(AdminIpWhitelistDocument, options)
}
export function useAdminIpWhitelistLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminIpWhitelistQuery,
    AdminIpWhitelistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    AdminIpWhitelistQuery,
    AdminIpWhitelistQueryVariables
  >(AdminIpWhitelistDocument, options)
}
export type AdminIpWhitelistQueryHookResult = ReturnType<
  typeof useAdminIpWhitelistQuery
>
export type AdminIpWhitelistLazyQueryHookResult = ReturnType<
  typeof useAdminIpWhitelistLazyQuery
>
export type AdminIpWhitelistQueryResult = ApolloReactCommon.QueryResult<
  AdminIpWhitelistQuery,
  AdminIpWhitelistQueryVariables
>
export const AddAdminIpWhitelistDocument = gql`
  mutation AddAdminIpWhitelist($input: AddIpWhitelistInput!) {
    addAdminIpWhitelist(input: $input) {
      id
      ipCidr
      label
      createdAt
    }
  }
`
export function useAddAdminIpWhitelistMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddAdminIpWhitelistMutation,
    AddAdminIpWhitelistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddAdminIpWhitelistMutation,
    AddAdminIpWhitelistMutationVariables
  >(AddAdminIpWhitelistDocument, options)
}
export type AddAdminIpWhitelistMutationHookResult = ReturnType<
  typeof useAddAdminIpWhitelistMutation
>
export type AddAdminIpWhitelistMutationResult =
  ApolloReactCommon.MutationResult<AddAdminIpWhitelistMutation>
export const RemoveAdminIpWhitelistDocument = gql`
  mutation RemoveAdminIpWhitelist($id: Int!) {
    removeAdminIpWhitelist(id: $id)
  }
`
export function useRemoveAdminIpWhitelistMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveAdminIpWhitelistMutation,
    RemoveAdminIpWhitelistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RemoveAdminIpWhitelistMutation,
    RemoveAdminIpWhitelistMutationVariables
  >(RemoveAdminIpWhitelistDocument, options)
}
export type RemoveAdminIpWhitelistMutationHookResult = ReturnType<
  typeof useRemoveAdminIpWhitelistMutation
>
export type RemoveAdminIpWhitelistMutationResult =
  ApolloReactCommon.MutationResult<RemoveAdminIpWhitelistMutation>
export const SetAdminIpWhitelistEnabledDocument = gql`
  mutation SetAdminIpWhitelistEnabled(
    $input: SetAdminIpWhitelistEnabledInput!
  ) {
    setAdminIpWhitelistEnabled(input: $input)
  }
`
export function useSetAdminIpWhitelistEnabledMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetAdminIpWhitelistEnabledMutation,
    SetAdminIpWhitelistEnabledMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetAdminIpWhitelistEnabledMutation,
    SetAdminIpWhitelistEnabledMutationVariables
  >(SetAdminIpWhitelistEnabledDocument, options)
}
export type SetAdminIpWhitelistEnabledMutationHookResult = ReturnType<
  typeof useSetAdminIpWhitelistEnabledMutation
>
export type SetAdminIpWhitelistEnabledMutationResult =
  ApolloReactCommon.MutationResult<SetAdminIpWhitelistEnabledMutation>
export const MerchantIpWhitelistDocument = gql`
  query MerchantIpWhitelist($merchantId: Int) {
    merchantIpWhitelist(merchantId: $merchantId) {
      enabled
      currentIp
      entries {
        id
        ipCidr
        label
        createdAt
      }
    }
  }
`
export function useMerchantIpWhitelistQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MerchantIpWhitelistQuery,
    MerchantIpWhitelistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MerchantIpWhitelistQuery,
    MerchantIpWhitelistQueryVariables
  >(MerchantIpWhitelistDocument, options)
}
export function useMerchantIpWhitelistLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MerchantIpWhitelistQuery,
    MerchantIpWhitelistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MerchantIpWhitelistQuery,
    MerchantIpWhitelistQueryVariables
  >(MerchantIpWhitelistDocument, options)
}
export type MerchantIpWhitelistQueryHookResult = ReturnType<
  typeof useMerchantIpWhitelistQuery
>
export type MerchantIpWhitelistLazyQueryHookResult = ReturnType<
  typeof useMerchantIpWhitelistLazyQuery
>
export type MerchantIpWhitelistQueryResult = ApolloReactCommon.QueryResult<
  MerchantIpWhitelistQuery,
  MerchantIpWhitelistQueryVariables
>
export const AddMerchantIpWhitelistDocument = gql`
  mutation AddMerchantIpWhitelist($input: AddIpWhitelistInput!) {
    addMerchantIpWhitelist(input: $input) {
      id
      ipCidr
      label
      createdAt
    }
  }
`
export function useAddMerchantIpWhitelistMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddMerchantIpWhitelistMutation,
    AddMerchantIpWhitelistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddMerchantIpWhitelistMutation,
    AddMerchantIpWhitelistMutationVariables
  >(AddMerchantIpWhitelistDocument, options)
}
export type AddMerchantIpWhitelistMutationHookResult = ReturnType<
  typeof useAddMerchantIpWhitelistMutation
>
export type AddMerchantIpWhitelistMutationResult =
  ApolloReactCommon.MutationResult<AddMerchantIpWhitelistMutation>
export const RemoveMerchantIpWhitelistDocument = gql`
  mutation RemoveMerchantIpWhitelist($id: Int!) {
    removeMerchantIpWhitelist(id: $id)
  }
`
export function useRemoveMerchantIpWhitelistMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveMerchantIpWhitelistMutation,
    RemoveMerchantIpWhitelistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RemoveMerchantIpWhitelistMutation,
    RemoveMerchantIpWhitelistMutationVariables
  >(RemoveMerchantIpWhitelistDocument, options)
}
export type RemoveMerchantIpWhitelistMutationHookResult = ReturnType<
  typeof useRemoveMerchantIpWhitelistMutation
>
export type RemoveMerchantIpWhitelistMutationResult =
  ApolloReactCommon.MutationResult<RemoveMerchantIpWhitelistMutation>
export const SetMerchantIpWhitelistEnabledDocument = gql`
  mutation SetMerchantIpWhitelistEnabled(
    $input: SetMerchantIpWhitelistEnabledInput!
  ) {
    setMerchantIpWhitelistEnabled(input: $input)
  }
`
export function useSetMerchantIpWhitelistEnabledMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetMerchantIpWhitelistEnabledMutation,
    SetMerchantIpWhitelistEnabledMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetMerchantIpWhitelistEnabledMutation,
    SetMerchantIpWhitelistEnabledMutationVariables
  >(SetMerchantIpWhitelistEnabledDocument, options)
}
export type SetMerchantIpWhitelistEnabledMutationHookResult = ReturnType<
  typeof useSetMerchantIpWhitelistEnabledMutation
>
export type SetMerchantIpWhitelistEnabledMutationResult =
  ApolloReactCommon.MutationResult<SetMerchantIpWhitelistEnabledMutation>
export const GetMerchantUsersDocument = gql`
  query GetMerchantUsers(
    $page: Int
    $limit: Int
    $filter: MerchantUserFilterInput
  ) {
    merchantUsers(page: $page, limit: $limit, filter: $filter) {
      page
      hasNext
      hasPrev
      limit
      totalCount
      totalPages
      items {
        id
        email
        name
        role
        status
        phoneCountryCode
        phoneNumber
        merchant {
          id
          name
          mid
        }
        createdAt
        updatedAt
      }
    }
  }
`
export function useGetMerchantUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMerchantUsersQuery,
    GetMerchantUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantUsersQuery,
    GetMerchantUsersQueryVariables
  >(GetMerchantUsersDocument, options)
}
export function useGetMerchantUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantUsersQuery,
    GetMerchantUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantUsersQuery,
    GetMerchantUsersQueryVariables
  >(GetMerchantUsersDocument, options)
}
export type GetMerchantUsersQueryHookResult = ReturnType<
  typeof useGetMerchantUsersQuery
>
export type GetMerchantUsersLazyQueryHookResult = ReturnType<
  typeof useGetMerchantUsersLazyQuery
>
export type GetMerchantUsersQueryResult = ApolloReactCommon.QueryResult<
  GetMerchantUsersQuery,
  GetMerchantUsersQueryVariables
>
export const GetMerchantUserDocument = gql`
  query GetMerchantUser($userId: Int!) {
    merchantUser(userId: $userId) {
      id
      email
      name
      role
      status
      phoneCountryCode
      phoneNumber
      merchant {
        id
        name
        mid
      }
      createdAt
      updatedAt
      menuPermissions {
        menuId
        menuCode
        menuName
        canView
        canCreate
        canEdit
        canDelete
        canExport
      }
    }
  }
`
export function useGetMerchantUserQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetMerchantUserQuery,
    GetMerchantUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantUserQuery,
    GetMerchantUserQueryVariables
  >(GetMerchantUserDocument, options)
}
export function useGetMerchantUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantUserQuery,
    GetMerchantUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantUserQuery,
    GetMerchantUserQueryVariables
  >(GetMerchantUserDocument, options)
}
export type GetMerchantUserQueryHookResult = ReturnType<
  typeof useGetMerchantUserQuery
>
export type GetMerchantUserLazyQueryHookResult = ReturnType<
  typeof useGetMerchantUserLazyQuery
>
export type GetMerchantUserQueryResult = ApolloReactCommon.QueryResult<
  GetMerchantUserQuery,
  GetMerchantUserQueryVariables
>
export const GetAvailableMenusDocument = gql`
  query GetAvailableMenus {
    availableMenusForMerchantUser {
      id
      code
      name
      description
      parentId
      sortOrder
      children {
        id
        code
        name
        description
        parentId
        sortOrder
        children {
          id
          code
          name
          description
          parentId
          sortOrder
        }
      }
    }
  }
`
export function useGetAvailableMenusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAvailableMenusQuery,
    GetAvailableMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAvailableMenusQuery,
    GetAvailableMenusQueryVariables
  >(GetAvailableMenusDocument, options)
}
export function useGetAvailableMenusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAvailableMenusQuery,
    GetAvailableMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAvailableMenusQuery,
    GetAvailableMenusQueryVariables
  >(GetAvailableMenusDocument, options)
}
export type GetAvailableMenusQueryHookResult = ReturnType<
  typeof useGetAvailableMenusQuery
>
export type GetAvailableMenusLazyQueryHookResult = ReturnType<
  typeof useGetAvailableMenusLazyQuery
>
export type GetAvailableMenusQueryResult = ApolloReactCommon.QueryResult<
  GetAvailableMenusQuery,
  GetAvailableMenusQueryVariables
>
export const CreateMerchantUserDocument = gql`
  mutation CreateMerchantUser($input: CreateMerchantUserInput!) {
    createMerchantUser(input: $input) {
      user {
        id
        email
        name
        role
        status
      }
      passwordSetupUrl
      tokenExpiresAt
      emailSent
      message
    }
  }
`
export function useCreateMerchantUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMerchantUserMutation,
    CreateMerchantUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateMerchantUserMutation,
    CreateMerchantUserMutationVariables
  >(CreateMerchantUserDocument, options)
}
export type CreateMerchantUserMutationHookResult = ReturnType<
  typeof useCreateMerchantUserMutation
>
export type CreateMerchantUserMutationResult =
  ApolloReactCommon.MutationResult<CreateMerchantUserMutation>
export const UpdateMerchantUserDocument = gql`
  mutation UpdateMerchantUser($input: UpdateMerchantUserInput!) {
    updateMerchantUser(input: $input) {
      id
      email
      name
      status
      phoneCountryCode
      phoneNumber
      updatedAt
    }
  }
`
export function useUpdateMerchantUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMerchantUserMutation,
    UpdateMerchantUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateMerchantUserMutation,
    UpdateMerchantUserMutationVariables
  >(UpdateMerchantUserDocument, options)
}
export type UpdateMerchantUserMutationHookResult = ReturnType<
  typeof useUpdateMerchantUserMutation
>
export type UpdateMerchantUserMutationResult =
  ApolloReactCommon.MutationResult<UpdateMerchantUserMutation>
export const DeleteMerchantUserDocument = gql`
  mutation DeleteMerchantUser($userId: Int!) {
    deleteMerchantUser(userId: $userId)
  }
`
export function useDeleteMerchantUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMerchantUserMutation,
    DeleteMerchantUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteMerchantUserMutation,
    DeleteMerchantUserMutationVariables
  >(DeleteMerchantUserDocument, options)
}
export type DeleteMerchantUserMutationHookResult = ReturnType<
  typeof useDeleteMerchantUserMutation
>
export type DeleteMerchantUserMutationResult =
  ApolloReactCommon.MutationResult<DeleteMerchantUserMutation>
export const AssignUserMenusDocument = gql`
  mutation AssignUserMenus($input: AssignUserMenusInput!) {
    assignUserMenus(input: $input)
  }
`
export function useAssignUserMenusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AssignUserMenusMutation,
    AssignUserMenusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AssignUserMenusMutation,
    AssignUserMenusMutationVariables
  >(AssignUserMenusDocument, options)
}
export type AssignUserMenusMutationHookResult = ReturnType<
  typeof useAssignUserMenusMutation
>
export type AssignUserMenusMutationResult =
  ApolloReactCommon.MutationResult<AssignUserMenusMutation>
export const ResendPasswordSetupEmailDocument = gql`
  mutation ResendPasswordSetupEmail($userId: Int!, $locale: EmailLocale) {
    resendPasswordSetupEmail(userId: $userId, locale: $locale)
  }
`
export function useResendPasswordSetupEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResendPasswordSetupEmailMutation,
    ResendPasswordSetupEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResendPasswordSetupEmailMutation,
    ResendPasswordSetupEmailMutationVariables
  >(ResendPasswordSetupEmailDocument, options)
}
export type ResendPasswordSetupEmailMutationHookResult = ReturnType<
  typeof useResendPasswordSetupEmailMutation
>
export type ResendPasswordSetupEmailMutationResult =
  ApolloReactCommon.MutationResult<ResendPasswordSetupEmailMutation>
export const CreateApiKeyDocument = gql`
  mutation CreateApiKey($input: CreateApiKeyInput!) {
    createMerchantApiKey(input: $input) {
      apiKey {
        id
        keyType
        environment
        keyMasked
        displayName
        status
        createdAt
      }
      plainTextKey
      message
    }
  }
`
export function useCreateApiKeyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateApiKeyMutation,
    CreateApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateApiKeyMutation,
    CreateApiKeyMutationVariables
  >(CreateApiKeyDocument, options)
}
export type CreateApiKeyMutationHookResult = ReturnType<
  typeof useCreateApiKeyMutation
>
export type CreateApiKeyMutationResult =
  ApolloReactCommon.MutationResult<CreateApiKeyMutation>
export const CreateManualRefundDocument = gql`
  mutation CreateManualRefund($input: CreateManualRefundInput!) {
    createManualRefund(input: $input) {
      transactionId
      paymentId
      transactionKey
      refundAmount
      newPaymentStatus
      totalRefundedAmount
      remainingAmount
      message
      processedAt
    }
  }
`
export function useCreateManualRefundMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateManualRefundMutation,
    CreateManualRefundMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateManualRefundMutation,
    CreateManualRefundMutationVariables
  >(CreateManualRefundDocument, options)
}
export type CreateManualRefundMutationHookResult = ReturnType<
  typeof useCreateManualRefundMutation
>
export type CreateManualRefundMutationResult =
  ApolloReactCommon.MutationResult<CreateManualRefundMutation>
export const CreateMerchantPaymentMethodDocument = gql`
  mutation CreateMerchantPaymentMethod(
    $input: CreateMerchantPaymentMethodInput!
  ) {
    createMerchantPaymentMethod(input: $input) {
      merchantPaymentMethod {
        id
        paymentMethod
        displayName
        isEnabled
        feeRate
        fixedFee
        minAmount
        maxAmount
        minFee
        maxFee
        dailyLimitAmount
        monthlyLimitAmount
        customRoutingId
        settlementCycle
        description
        createdAt
      }
      message
    }
  }
`
export function useCreateMerchantPaymentMethodMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMerchantPaymentMethodMutation,
    CreateMerchantPaymentMethodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateMerchantPaymentMethodMutation,
    CreateMerchantPaymentMethodMutationVariables
  >(CreateMerchantPaymentMethodDocument, options)
}
export type CreateMerchantPaymentMethodMutationHookResult = ReturnType<
  typeof useCreateMerchantPaymentMethodMutation
>
export type CreateMerchantPaymentMethodMutationResult =
  ApolloReactCommon.MutationResult<CreateMerchantPaymentMethodMutation>
export const DeleteMerchantPaymentMethodDocument = gql`
  mutation DeleteMerchantPaymentMethod($id: Int!) {
    deleteMerchantPaymentMethod(id: $id) {
      success
      message
    }
  }
`
export function useDeleteMerchantPaymentMethodMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMerchantPaymentMethodMutation,
    DeleteMerchantPaymentMethodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteMerchantPaymentMethodMutation,
    DeleteMerchantPaymentMethodMutationVariables
  >(DeleteMerchantPaymentMethodDocument, options)
}
export type DeleteMerchantPaymentMethodMutationHookResult = ReturnType<
  typeof useDeleteMerchantPaymentMethodMutation
>
export type DeleteMerchantPaymentMethodMutationResult =
  ApolloReactCommon.MutationResult<DeleteMerchantPaymentMethodMutation>
export const DownloadAutoRefundExcelDocument = gql`
  mutation DownloadAutoRefundExcel($filter: AutoRefundFilterInput) {
    downloadAutoRefundExcel(filter: $filter) {
      downloadUrl
      jobId
      recordCount
      processType
      message
    }
  }
`
export function useDownloadAutoRefundExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadAutoRefundExcelMutation,
    DownloadAutoRefundExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadAutoRefundExcelMutation,
    DownloadAutoRefundExcelMutationVariables
  >(DownloadAutoRefundExcelDocument, options)
}
export type DownloadAutoRefundExcelMutationHookResult = ReturnType<
  typeof useDownloadAutoRefundExcelMutation
>
export type DownloadAutoRefundExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadAutoRefundExcelMutation>
export const DownloadRefundExcelDocument = gql`
  mutation DownloadRefundExcel($filter: RefundFilterInput) {
    downloadRefundExcel(filter: $filter) {
      downloadUrl
      recordCount
      jobId
      processType
      message
    }
  }
`
export function useDownloadRefundExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadRefundExcelMutation,
    DownloadRefundExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadRefundExcelMutation,
    DownloadRefundExcelMutationVariables
  >(DownloadRefundExcelDocument, options)
}
export type DownloadRefundExcelMutationHookResult = ReturnType<
  typeof useDownloadRefundExcelMutation
>
export type DownloadRefundExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadRefundExcelMutation>
export const RefundPaymentDocument = gql`
  mutation RefundPayment($input: RefundPaymentInput!) {
    refundPayment(input: $input) {
      transactionId
      paymentId
      refundAmount
      refundType
      newPaymentStatus
      totalRefundedAmount
      remainingAmount
      message
      processedAt
    }
  }
`
export function useRefundPaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RefundPaymentMutation,
    RefundPaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RefundPaymentMutation,
    RefundPaymentMutationVariables
  >(RefundPaymentDocument, options)
}
export type RefundPaymentMutationHookResult = ReturnType<
  typeof useRefundPaymentMutation
>
export type RefundPaymentMutationResult =
  ApolloReactCommon.MutationResult<RefundPaymentMutation>
export const RegenerateApiKeyDocument = gql`
  mutation RegenerateApiKey($input: RegenerateApiKeyInput!) {
    regenerateMerchantApiKey(input: $input) {
      apiKey {
        id
        keyType
        environment
        keyMasked
        displayName
        status
        createdAt
      }
      plainTextKey
      message
    }
  }
`
export function useRegenerateApiKeyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RegenerateApiKeyMutation,
    RegenerateApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RegenerateApiKeyMutation,
    RegenerateApiKeyMutationVariables
  >(RegenerateApiKeyDocument, options)
}
export type RegenerateApiKeyMutationHookResult = ReturnType<
  typeof useRegenerateApiKeyMutation
>
export type RegenerateApiKeyMutationResult =
  ApolloReactCommon.MutationResult<RegenerateApiKeyMutation>
export const RevokeApiKeyDocument = gql`
  mutation RevokeApiKey($id: Int!) {
    revokeMerchantApiKey(id: $id) {
      id
      status
      revokedAt
    }
  }
`
export function useRevokeApiKeyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RevokeApiKeyMutation,
    RevokeApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RevokeApiKeyMutation,
    RevokeApiKeyMutationVariables
  >(RevokeApiKeyDocument, options)
}
export type RevokeApiKeyMutationHookResult = ReturnType<
  typeof useRevokeApiKeyMutation
>
export type RevokeApiKeyMutationResult =
  ApolloReactCommon.MutationResult<RevokeApiKeyMutation>
export const ToggleApiKeyDocument = gql`
  mutation ToggleApiKey($id: Int!, $totpCode: String) {
    toggleMerchantApiKey(id: $id, totpCode: $totpCode) {
      id
      status
      updatedAt
    }
  }
`
export function useToggleApiKeyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ToggleApiKeyMutation,
    ToggleApiKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ToggleApiKeyMutation,
    ToggleApiKeyMutationVariables
  >(ToggleApiKeyDocument, options)
}
export type ToggleApiKeyMutationHookResult = ReturnType<
  typeof useToggleApiKeyMutation
>
export type ToggleApiKeyMutationResult =
  ApolloReactCommon.MutationResult<ToggleApiKeyMutation>
export const UpdateMerchantPaymentMethodDocument = gql`
  mutation UpdateMerchantPaymentMethod(
    $input: UpdateMerchantPaymentMethodInput!
  ) {
    updateMerchantPaymentMethod(input: $input) {
      merchantPaymentMethod {
        id
        paymentMethod
        displayName
        isEnabled
        feeRate
        fixedFee
        minAmount
        maxAmount
        minFee
        maxFee
        dailyLimitAmount
        monthlyLimitAmount
        customRoutingId
        settlementCycle
        description
        createdAt
        updatedAt
      }
      message
    }
  }
`
export function useUpdateMerchantPaymentMethodMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMerchantPaymentMethodMutation,
    UpdateMerchantPaymentMethodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateMerchantPaymentMethodMutation,
    UpdateMerchantPaymentMethodMutationVariables
  >(UpdateMerchantPaymentMethodDocument, options)
}
export type UpdateMerchantPaymentMethodMutationHookResult = ReturnType<
  typeof useUpdateMerchantPaymentMethodMutation
>
export type UpdateMerchantPaymentMethodMutationResult =
  ApolloReactCommon.MutationResult<UpdateMerchantPaymentMethodMutation>
export const UpdateMerchantWebhookDocument = gql`
  mutation UpdateMerchantWebhook($input: UpdateMerchantInput!) {
    updateMerchant(input: $input) {
      id
      name
      mid
      webhookUrl
      updatedAt
    }
  }
`
export function useUpdateMerchantWebhookMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMerchantWebhookMutation,
    UpdateMerchantWebhookMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateMerchantWebhookMutation,
    UpdateMerchantWebhookMutationVariables
  >(UpdateMerchantWebhookDocument, options)
}
export type UpdateMerchantWebhookMutationHookResult = ReturnType<
  typeof useUpdateMerchantWebhookMutation
>
export type UpdateMerchantWebhookMutationResult =
  ApolloReactCommon.MutationResult<UpdateMerchantWebhookMutation>
export const UpdateAmlAlertStatusDocument = gql`
  mutation UpdateAmlAlertStatus(
    $id: String!
    $status: AmlAlertStatus!
    $notes: String
  ) {
    updateAmlAlertStatus(id: $id, status: $status, notes: $notes) {
      id
      status
      notes
      resolvedAt
      resolvedById
      updatedAt
    }
  }
`
export function useUpdateAmlAlertStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateAmlAlertStatusMutation,
    UpdateAmlAlertStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateAmlAlertStatusMutation,
    UpdateAmlAlertStatusMutationVariables
  >(UpdateAmlAlertStatusDocument, options)
}
export type UpdateAmlAlertStatusMutationHookResult = ReturnType<
  typeof useUpdateAmlAlertStatusMutation
>
export type UpdateAmlAlertStatusMutationResult =
  ApolloReactCommon.MutationResult<UpdateAmlAlertStatusMutation>
export const UpdateRiskProviderStatusDocument = gql`
  mutation UpdateRiskProviderStatus($id: Int!, $status: RiskProviderStatus!) {
    updateRiskProviderStatus(id: $id, status: $status) {
      id
      code
      name
      status
      priority
      updatedAt
    }
  }
`
export function useUpdateRiskProviderStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRiskProviderStatusMutation,
    UpdateRiskProviderStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRiskProviderStatusMutation,
    UpdateRiskProviderStatusMutationVariables
  >(UpdateRiskProviderStatusDocument, options)
}
export type UpdateRiskProviderStatusMutationHookResult = ReturnType<
  typeof useUpdateRiskProviderStatusMutation
>
export type UpdateRiskProviderStatusMutationResult =
  ApolloReactCommon.MutationResult<UpdateRiskProviderStatusMutation>
export const CreateRiskManagementProviderDocument = gql`
  mutation CreateRiskManagementProvider(
    $code: String!
    $name: String!
    $priority: Int
  ) {
    createRiskManagementProvider(
      code: $code
      name: $name
      priority: $priority
    ) {
      id
      code
      name
      status
      priority
      createdAt
      updatedAt
    }
  }
`
export function useCreateRiskManagementProviderMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateRiskManagementProviderMutation,
    CreateRiskManagementProviderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateRiskManagementProviderMutation,
    CreateRiskManagementProviderMutationVariables
  >(CreateRiskManagementProviderDocument, options)
}
export type CreateRiskManagementProviderMutationHookResult = ReturnType<
  typeof useCreateRiskManagementProviderMutation
>
export type CreateRiskManagementProviderMutationResult =
  ApolloReactCommon.MutationResult<CreateRiskManagementProviderMutation>
export const SignInDocument = gql`
  mutation SignIn($input: SignInInput!) {
    signIn(input: $input) {
      accessToken
      refreshToken
      twoFactorRequired
      twoFactorToken
      enrollmentRequired
      deviceVerificationRequired
      deviceVerificationToken
      deviceVerificationEmail
    }
  }
`
export function useSignInMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SignInMutation,
    SignInMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<SignInMutation, SignInMutationVariables>(
    SignInDocument,
    options
  )
}
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>
export type SignInMutationResult =
  ApolloReactCommon.MutationResult<SignInMutation>
export const VerifyLoginDeviceDocument = gql`
  mutation VerifyLoginDevice($input: VerifyLoginDeviceInput!) {
    verifyLoginDevice(input: $input) {
      accessToken
      refreshToken
      enrollmentRequired
    }
  }
`
export function useVerifyLoginDeviceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerifyLoginDeviceMutation,
    VerifyLoginDeviceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    VerifyLoginDeviceMutation,
    VerifyLoginDeviceMutationVariables
  >(VerifyLoginDeviceDocument, options)
}
export type VerifyLoginDeviceMutationHookResult = ReturnType<
  typeof useVerifyLoginDeviceMutation
>
export type VerifyLoginDeviceMutationResult =
  ApolloReactCommon.MutationResult<VerifyLoginDeviceMutation>
export const ResendLoginDeviceCodeDocument = gql`
  mutation ResendLoginDeviceCode($input: ResendLoginDeviceCodeInput!) {
    resendLoginDeviceCode(input: $input)
  }
`
export function useResendLoginDeviceCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResendLoginDeviceCodeMutation,
    ResendLoginDeviceCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResendLoginDeviceCodeMutation,
    ResendLoginDeviceCodeMutationVariables
  >(ResendLoginDeviceCodeDocument, options)
}
export type ResendLoginDeviceCodeMutationHookResult = ReturnType<
  typeof useResendLoginDeviceCodeMutation
>
export type ResendLoginDeviceCodeMutationResult =
  ApolloReactCommon.MutationResult<ResendLoginDeviceCodeMutation>
export const RefreshAccessTokenDocument = gql`
  mutation RefreshAccessToken($input: RefreshTokenInput!) {
    refreshAccessToken(input: $input) {
      accessToken
      refreshToken
    }
  }
`
export function useRefreshAccessTokenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RefreshAccessTokenMutation,
    RefreshAccessTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RefreshAccessTokenMutation,
    RefreshAccessTokenMutationVariables
  >(RefreshAccessTokenDocument, options)
}
export type RefreshAccessTokenMutationHookResult = ReturnType<
  typeof useRefreshAccessTokenMutation
>
export type RefreshAccessTokenMutationResult =
  ApolloReactCommon.MutationResult<RefreshAccessTokenMutation>
export const AdminSignUpDocument = gql`
  mutation AdminSignUp($input: AdminSignUpInput!) {
    adminSignUp(input: $input) {
      success
    }
  }
`
export function useAdminSignUpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminSignUpMutation,
    AdminSignUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AdminSignUpMutation,
    AdminSignUpMutationVariables
  >(AdminSignUpDocument, options)
}
export type AdminSignUpMutationHookResult = ReturnType<
  typeof useAdminSignUpMutation
>
export type AdminSignUpMutationResult =
  ApolloReactCommon.MutationResult<AdminSignUpMutation>
export const LogoutDocument = gql`
  mutation Logout {
    logout
  }
`
export function useLogoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    LogoutMutation,
    LogoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
    options
  )
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>
export type LogoutMutationResult =
  ApolloReactCommon.MutationResult<LogoutMutation>
export const StartChannelFundFlowSyncDocument = gql`
  mutation StartChannelFundFlowSync($input: StartChannelFundFlowSyncInput!) {
    startChannelFundFlowSync(input: $input) {
      id
      channelCode
      status
      rangeMode
      rangeFrom
      rangeTo
    }
  }
`
export function useStartChannelFundFlowSyncMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartChannelFundFlowSyncMutation,
    StartChannelFundFlowSyncMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StartChannelFundFlowSyncMutation,
    StartChannelFundFlowSyncMutationVariables
  >(StartChannelFundFlowSyncDocument, options)
}
export type StartChannelFundFlowSyncMutationHookResult = ReturnType<
  typeof useStartChannelFundFlowSyncMutation
>
export type StartChannelFundFlowSyncMutationResult =
  ApolloReactCommon.MutationResult<StartChannelFundFlowSyncMutation>
export const RetryChannelFundFlowSyncDocument = gql`
  mutation RetryChannelFundFlowSync($runId: String!) {
    retryChannelFundFlowSync(runId: $runId) {
      id
      channelCode
      status
    }
  }
`
export function useRetryChannelFundFlowSyncMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RetryChannelFundFlowSyncMutation,
    RetryChannelFundFlowSyncMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RetryChannelFundFlowSyncMutation,
    RetryChannelFundFlowSyncMutationVariables
  >(RetryChannelFundFlowSyncDocument, options)
}
export type RetryChannelFundFlowSyncMutationHookResult = ReturnType<
  typeof useRetryChannelFundFlowSyncMutation
>
export type RetryChannelFundFlowSyncMutationResult =
  ApolloReactCommon.MutationResult<RetryChannelFundFlowSyncMutation>
export const CreateChannelDocument = gql`
  mutation CreateChannel($input: CreateChannelInput!) {
    createChannel(input: $input) {
      id
      code
      name
      status
    }
  }
`
export function useCreateChannelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateChannelMutation,
    CreateChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateChannelMutation,
    CreateChannelMutationVariables
  >(CreateChannelDocument, options)
}
export type CreateChannelMutationHookResult = ReturnType<
  typeof useCreateChannelMutation
>
export type CreateChannelMutationResult =
  ApolloReactCommon.MutationResult<CreateChannelMutation>
export const UpdateChannelDocument = gql`
  mutation UpdateChannel($input: UpdateChannelInput!) {
    updateChannel(input: $input) {
      id
      code
      name
      description
      status
    }
  }
`
export function useUpdateChannelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateChannelMutation,
    UpdateChannelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateChannelMutation,
    UpdateChannelMutationVariables
  >(UpdateChannelDocument, options)
}
export type UpdateChannelMutationHookResult = ReturnType<
  typeof useUpdateChannelMutation
>
export type UpdateChannelMutationResult =
  ApolloReactCommon.MutationResult<UpdateChannelMutation>
export const UpdateChannelCapabilityDocument = gql`
  mutation UpdateChannelCapability($input: UpdateChannelCapabilityInput!) {
    updateChannelCapability(input: $input) {
      id
      capability
      enabled
      config
    }
  }
`
export function useUpdateChannelCapabilityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateChannelCapabilityMutation,
    UpdateChannelCapabilityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateChannelCapabilityMutation,
    UpdateChannelCapabilityMutationVariables
  >(UpdateChannelCapabilityDocument, options)
}
export type UpdateChannelCapabilityMutationHookResult = ReturnType<
  typeof useUpdateChannelCapabilityMutation
>
export type UpdateChannelCapabilityMutationResult =
  ApolloReactCommon.MutationResult<UpdateChannelCapabilityMutation>
export const CreateChannelRouteDocument = gql`
  mutation CreateChannelRoute($input: CreateChannelRouteInput!) {
    createChannelRoute(input: $input) {
      id
      businessType
      channel
      merchantId
      merchant {
        id
        name
        mid
      }
      createdAt
    }
  }
`
export function useCreateChannelRouteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateChannelRouteMutation,
    CreateChannelRouteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateChannelRouteMutation,
    CreateChannelRouteMutationVariables
  >(CreateChannelRouteDocument, options)
}
export type CreateChannelRouteMutationHookResult = ReturnType<
  typeof useCreateChannelRouteMutation
>
export type CreateChannelRouteMutationResult =
  ApolloReactCommon.MutationResult<CreateChannelRouteMutation>
export const DeleteChannelRouteDocument = gql`
  mutation DeleteChannelRoute($id: Int!) {
    deleteChannelRoute(id: $id) {
      id
    }
  }
`
export function useDeleteChannelRouteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteChannelRouteMutation,
    DeleteChannelRouteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteChannelRouteMutation,
    DeleteChannelRouteMutationVariables
  >(DeleteChannelRouteDocument, options)
}
export type DeleteChannelRouteMutationHookResult = ReturnType<
  typeof useDeleteChannelRouteMutation
>
export type DeleteChannelRouteMutationResult =
  ApolloReactCommon.MutationResult<DeleteChannelRouteMutation>
export const CreateOfframpTransferDocument = gql`
  mutation CreateOfframpTransfer($input: CreateOfframpTransferInput!) {
    createOfframpTransfer(input: $input) {
      id
      transferId
      type
      status
      sourceChannel
      targetChannel
      requestedAmount
      requestedCurrency
      destinationAddress
      destinationMemo
      createdAt
    }
  }
`
export function useCreateOfframpTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateOfframpTransferMutation,
    CreateOfframpTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateOfframpTransferMutation,
    CreateOfframpTransferMutationVariables
  >(CreateOfframpTransferDocument, options)
}
export type CreateOfframpTransferMutationHookResult = ReturnType<
  typeof useCreateOfframpTransferMutation
>
export type CreateOfframpTransferMutationResult =
  ApolloReactCommon.MutationResult<CreateOfframpTransferMutation>
export const CompleteOfframpTransferDocument = gql`
  mutation CompleteOfframpTransfer($input: CompleteOfframpTransferInput!) {
    completeOfframpTransfer(input: $input) {
      id
      transferId
      status
      sourceAmount
      sourceCurrency
      targetAmount
      targetCurrency
      feeAmount
      succeededAt
      completedAt
    }
  }
`
export function useCompleteOfframpTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CompleteOfframpTransferMutation,
    CompleteOfframpTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CompleteOfframpTransferMutation,
    CompleteOfframpTransferMutationVariables
  >(CompleteOfframpTransferDocument, options)
}
export type CompleteOfframpTransferMutationHookResult = ReturnType<
  typeof useCompleteOfframpTransferMutation
>
export type CompleteOfframpTransferMutationResult =
  ApolloReactCommon.MutationResult<CompleteOfframpTransferMutation>
export const FailOfframpTransferDocument = gql`
  mutation FailOfframpTransfer(
    $id: String!
    $errorMessage: String!
    $totpCode: String
  ) {
    failOfframpTransfer(
      id: $id
      errorMessage: $errorMessage
      totpCode: $totpCode
    ) {
      id
      transferId
      status
      errorMessage
      failedAt
    }
  }
`
export function useFailOfframpTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    FailOfframpTransferMutation,
    FailOfframpTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    FailOfframpTransferMutation,
    FailOfframpTransferMutationVariables
  >(FailOfframpTransferDocument, options)
}
export type FailOfframpTransferMutationHookResult = ReturnType<
  typeof useFailOfframpTransferMutation
>
export type FailOfframpTransferMutationResult =
  ApolloReactCommon.MutationResult<FailOfframpTransferMutation>
export const CreateManualTransferDocument = gql`
  mutation CreateManualTransfer($input: CreateManualTransferInput!) {
    createManualTransfer(input: $input) {
      id
      transferId
      type
      status
      sourceChannel
      targetChannel
      requestedAmount
      requestedCurrency
      destinationAddress
      providerRef
      processedAt
      createdAt
    }
  }
`
export function useCreateManualTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateManualTransferMutation,
    CreateManualTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateManualTransferMutation,
    CreateManualTransferMutationVariables
  >(CreateManualTransferDocument, options)
}
export type CreateManualTransferMutationHookResult = ReturnType<
  typeof useCreateManualTransferMutation
>
export type CreateManualTransferMutationResult =
  ApolloReactCommon.MutationResult<CreateManualTransferMutation>
export const ConfirmTransferReceiptDocument = gql`
  mutation ConfirmTransferReceipt($input: ConfirmReceiptInput!) {
    confirmTransferReceipt(input: $input) {
      id
      transferId
      status
      completedBy
      completedAt
    }
  }
`
export function useConfirmTransferReceiptMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConfirmTransferReceiptMutation,
    ConfirmTransferReceiptMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ConfirmTransferReceiptMutation,
    ConfirmTransferReceiptMutationVariables
  >(ConfirmTransferReceiptDocument, options)
}
export type ConfirmTransferReceiptMutationHookResult = ReturnType<
  typeof useConfirmTransferReceiptMutation
>
export type ConfirmTransferReceiptMutationResult =
  ApolloReactCommon.MutationResult<ConfirmTransferReceiptMutation>
export const CreateCryptoRefundFeeDocument = gql`
  mutation CreateCryptoRefundFee($input: CreateCryptoRefundFeeInput!) {
    createCryptoRefundFee(input: $input) {
      id
      payableCurrencyId
      currencyId
      feeType
      feeAmount
      minFee
      maxFee
      isActive
      description
      createdAt
      updatedAt
    }
  }
`
export function useCreateCryptoRefundFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateCryptoRefundFeeMutation,
    CreateCryptoRefundFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateCryptoRefundFeeMutation,
    CreateCryptoRefundFeeMutationVariables
  >(CreateCryptoRefundFeeDocument, options)
}
export type CreateCryptoRefundFeeMutationHookResult = ReturnType<
  typeof useCreateCryptoRefundFeeMutation
>
export type CreateCryptoRefundFeeMutationResult =
  ApolloReactCommon.MutationResult<CreateCryptoRefundFeeMutation>
export const UpdateCryptoRefundFeeDocument = gql`
  mutation UpdateCryptoRefundFee(
    $id: Int!
    $input: UpdateCryptoRefundFeeInput!
  ) {
    updateCryptoRefundFee(id: $id, input: $input) {
      id
      payableCurrencyId
      currencyId
      feeType
      feeAmount
      minFee
      maxFee
      isActive
      description
      createdAt
      updatedAt
    }
  }
`
export function useUpdateCryptoRefundFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateCryptoRefundFeeMutation,
    UpdateCryptoRefundFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateCryptoRefundFeeMutation,
    UpdateCryptoRefundFeeMutationVariables
  >(UpdateCryptoRefundFeeDocument, options)
}
export type UpdateCryptoRefundFeeMutationHookResult = ReturnType<
  typeof useUpdateCryptoRefundFeeMutation
>
export type UpdateCryptoRefundFeeMutationResult =
  ApolloReactCommon.MutationResult<UpdateCryptoRefundFeeMutation>
export const DeleteCryptoRefundFeeDocument = gql`
  mutation DeleteCryptoRefundFee($id: Int!) {
    deleteCryptoRefundFee(id: $id) {
      id
      payableCurrencyId
      currencyId
    }
  }
`
export function useDeleteCryptoRefundFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteCryptoRefundFeeMutation,
    DeleteCryptoRefundFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteCryptoRefundFeeMutation,
    DeleteCryptoRefundFeeMutationVariables
  >(DeleteCryptoRefundFeeDocument, options)
}
export type DeleteCryptoRefundFeeMutationHookResult = ReturnType<
  typeof useDeleteCryptoRefundFeeMutation
>
export type DeleteCryptoRefundFeeMutationResult =
  ApolloReactCommon.MutationResult<DeleteCryptoRefundFeeMutation>
export const RecheckRefundDispatchDocument = gql`
  mutation RecheckRefundDispatch($input: RecheckRefundDispatchInput!) {
    recheckRefundDispatch(input: $input) {
      outcome
      message
    }
  }
`
export function useRecheckRefundDispatchMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RecheckRefundDispatchMutation,
    RecheckRefundDispatchMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RecheckRefundDispatchMutation,
    RecheckRefundDispatchMutationVariables
  >(RecheckRefundDispatchDocument, options)
}
export type RecheckRefundDispatchMutationHookResult = ReturnType<
  typeof useRecheckRefundDispatchMutation
>
export type RecheckRefundDispatchMutationResult =
  ApolloReactCommon.MutationResult<RecheckRefundDispatchMutation>
export const ResolveRefundReconciliationDocument = gql`
  mutation ResolveRefundReconciliation(
    $input: ResolveRefundReconciliationInput!
  ) {
    resolveRefundReconciliation(input: $input) {
      outcome
      message
    }
  }
`
export function useResolveRefundReconciliationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResolveRefundReconciliationMutation,
    ResolveRefundReconciliationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResolveRefundReconciliationMutation,
    ResolveRefundReconciliationMutationVariables
  >(ResolveRefundReconciliationDocument, options)
}
export type ResolveRefundReconciliationMutationHookResult = ReturnType<
  typeof useResolveRefundReconciliationMutation
>
export type ResolveRefundReconciliationMutationResult =
  ApolloReactCommon.MutationResult<ResolveRefundReconciliationMutation>
export const RecheckPayoutDispatchDocument = gql`
  mutation RecheckPayoutDispatch($input: RecheckPayoutDispatchInput!) {
    recheckPayoutDispatch(input: $input) {
      outcome
      message
    }
  }
`
export function useRecheckPayoutDispatchMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RecheckPayoutDispatchMutation,
    RecheckPayoutDispatchMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RecheckPayoutDispatchMutation,
    RecheckPayoutDispatchMutationVariables
  >(RecheckPayoutDispatchDocument, options)
}
export type RecheckPayoutDispatchMutationHookResult = ReturnType<
  typeof useRecheckPayoutDispatchMutation
>
export type RecheckPayoutDispatchMutationResult =
  ApolloReactCommon.MutationResult<RecheckPayoutDispatchMutation>
export const CreateFeeSettingDocument = gql`
  mutation createFeeSetting($input: FeeSettingUpdateInput!) {
    createFeeSetting(input: $input)
  }
`
export function useCreateFeeSettingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateFeeSettingMutation,
    CreateFeeSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateFeeSettingMutation,
    CreateFeeSettingMutationVariables
  >(CreateFeeSettingDocument, options)
}
export type CreateFeeSettingMutationHookResult = ReturnType<
  typeof useCreateFeeSettingMutation
>
export type CreateFeeSettingMutationResult =
  ApolloReactCommon.MutationResult<CreateFeeSettingMutation>
export const UpdateFeeSettingDocument = gql`
  mutation updateFeeSetting($input: FeeSettingUpdateInput!) {
    updateFeeSetting(input: $input)
  }
`
export function useUpdateFeeSettingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateFeeSettingMutation,
    UpdateFeeSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateFeeSettingMutation,
    UpdateFeeSettingMutationVariables
  >(UpdateFeeSettingDocument, options)
}
export type UpdateFeeSettingMutationHookResult = ReturnType<
  typeof useUpdateFeeSettingMutation
>
export type UpdateFeeSettingMutationResult =
  ApolloReactCommon.MutationResult<UpdateFeeSettingMutation>
export const DeleteFeeSettingDocument = gql`
  mutation deleteFeeSetting($id: Int!) {
    deleteFeeSetting(id: $id)
  }
`
export function useDeleteFeeSettingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteFeeSettingMutation,
    DeleteFeeSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteFeeSettingMutation,
    DeleteFeeSettingMutationVariables
  >(DeleteFeeSettingDocument, options)
}
export type DeleteFeeSettingMutationHookResult = ReturnType<
  typeof useDeleteFeeSettingMutation
>
export type DeleteFeeSettingMutationResult =
  ApolloReactCommon.MutationResult<DeleteFeeSettingMutation>
export const CreateMenuDocument = gql`
  mutation CreateMenu($input: CreateMenuInput!) {
    createMenu(input: $input) {
      id
      code
      name
      description
      parentId
      path
      icon
      component
      sortOrder
      isVisible
      isPublic
      excludeRoles
      menuType
      target
    }
  }
`
export function useCreateMenuMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMenuMutation,
    CreateMenuMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateMenuMutation,
    CreateMenuMutationVariables
  >(CreateMenuDocument, options)
}
export type CreateMenuMutationHookResult = ReturnType<
  typeof useCreateMenuMutation
>
export type CreateMenuMutationResult =
  ApolloReactCommon.MutationResult<CreateMenuMutation>
export const UpdateMenuDocument = gql`
  mutation UpdateMenu($input: UpdateMenuInput!) {
    updateMenu(input: $input) {
      id
      code
      name
      description
      parentId
      path
      icon
      component
      sortOrder
      isVisible
      isPublic
      excludeRoles
      menuType
      target
    }
  }
`
export function useUpdateMenuMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMenuMutation,
    UpdateMenuMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateMenuMutation,
    UpdateMenuMutationVariables
  >(UpdateMenuDocument, options)
}
export type UpdateMenuMutationHookResult = ReturnType<
  typeof useUpdateMenuMutation
>
export type UpdateMenuMutationResult =
  ApolloReactCommon.MutationResult<UpdateMenuMutation>
export const DeleteMenuDocument = gql`
  mutation DeleteMenu($id: Int!) {
    deleteMenu(id: $id) {
      id
      code
      isDeleted
    }
  }
`
export function useDeleteMenuMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMenuMutation,
    DeleteMenuMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteMenuMutation,
    DeleteMenuMutationVariables
  >(DeleteMenuDocument, options)
}
export type DeleteMenuMutationHookResult = ReturnType<
  typeof useDeleteMenuMutation
>
export type DeleteMenuMutationResult =
  ApolloReactCommon.MutationResult<DeleteMenuMutation>
export const ReorderMenusDocument = gql`
  mutation ReorderMenus($input: ReorderMenusInput!) {
    reorderMenus(input: $input)
  }
`
export function useReorderMenusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ReorderMenusMutation,
    ReorderMenusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ReorderMenusMutation,
    ReorderMenusMutationVariables
  >(ReorderMenusDocument, options)
}
export type ReorderMenusMutationHookResult = ReturnType<
  typeof useReorderMenusMutation
>
export type ReorderMenusMutationResult =
  ApolloReactCommon.MutationResult<ReorderMenusMutation>
export const SetRoleMenuPermissionsDocument = gql`
  mutation SetRoleMenuPermissions($input: RoleMenuPermissionInput!) {
    setRoleMenuPermissions(input: $input) {
      id
      role
      menuId
      canView
      canCreate
      canEdit
      canDelete
      canExport
    }
  }
`
export function useSetRoleMenuPermissionsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetRoleMenuPermissionsMutation,
    SetRoleMenuPermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetRoleMenuPermissionsMutation,
    SetRoleMenuPermissionsMutationVariables
  >(SetRoleMenuPermissionsDocument, options)
}
export type SetRoleMenuPermissionsMutationHookResult = ReturnType<
  typeof useSetRoleMenuPermissionsMutation
>
export type SetRoleMenuPermissionsMutationResult =
  ApolloReactCommon.MutationResult<SetRoleMenuPermissionsMutation>
export const SetBulkRoleMenuPermissionsDocument = gql`
  mutation SetBulkRoleMenuPermissions($input: BulkRoleMenuPermissionInput!) {
    setBulkRoleMenuPermissions(input: $input) {
      id
      menuId
      canView
      canCreate
      canEdit
      canDelete
      canExport
    }
  }
`
export function useSetBulkRoleMenuPermissionsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetBulkRoleMenuPermissionsMutation,
    SetBulkRoleMenuPermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetBulkRoleMenuPermissionsMutation,
    SetBulkRoleMenuPermissionsMutationVariables
  >(SetBulkRoleMenuPermissionsDocument, options)
}
export type SetBulkRoleMenuPermissionsMutationHookResult = ReturnType<
  typeof useSetBulkRoleMenuPermissionsMutation
>
export type SetBulkRoleMenuPermissionsMutationResult =
  ApolloReactCommon.MutationResult<SetBulkRoleMenuPermissionsMutation>
export const GrantUserMenuAccessDocument = gql`
  mutation GrantUserMenuAccess($input: GrantUserMenuAccessInput!) {
    grantUserMenuAccess(input: $input) {
      id
      userId
      menuId
      canView
      canCreate
      canEdit
      canDelete
      canExport
      expiresAt
    }
  }
`
export function useGrantUserMenuAccessMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GrantUserMenuAccessMutation,
    GrantUserMenuAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    GrantUserMenuAccessMutation,
    GrantUserMenuAccessMutationVariables
  >(GrantUserMenuAccessDocument, options)
}
export type GrantUserMenuAccessMutationHookResult = ReturnType<
  typeof useGrantUserMenuAccessMutation
>
export type GrantUserMenuAccessMutationResult =
  ApolloReactCommon.MutationResult<GrantUserMenuAccessMutation>
export const SetUserMenuPermissionsDocument = gql`
  mutation SetUserMenuPermissions($input: UserMenuPermissionInput!) {
    setUserMenuPermissions(input: $input) {
      id
      userId
      menuId
      canView
      canCreate
      canEdit
      canDelete
      canExport
      expiresAt
    }
  }
`
export function useSetUserMenuPermissionsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SetUserMenuPermissionsMutation,
    SetUserMenuPermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SetUserMenuPermissionsMutation,
    SetUserMenuPermissionsMutationVariables
  >(SetUserMenuPermissionsDocument, options)
}
export type SetUserMenuPermissionsMutationHookResult = ReturnType<
  typeof useSetUserMenuPermissionsMutation
>
export type SetUserMenuPermissionsMutationResult =
  ApolloReactCommon.MutationResult<SetUserMenuPermissionsMutation>
export const RevokeUserMenuAccessDocument = gql`
  mutation RevokeUserMenuAccess($input: RevokeUserMenuAccessInput!) {
    revokeUserMenuAccess(input: $input)
  }
`
export function useRevokeUserMenuAccessMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RevokeUserMenuAccessMutation,
    RevokeUserMenuAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RevokeUserMenuAccessMutation,
    RevokeUserMenuAccessMutationVariables
  >(RevokeUserMenuAccessDocument, options)
}
export type RevokeUserMenuAccessMutationHookResult = ReturnType<
  typeof useRevokeUserMenuAccessMutation
>
export type RevokeUserMenuAccessMutationResult =
  ApolloReactCommon.MutationResult<RevokeUserMenuAccessMutation>
export const CreateMerchantCryptoRefundFeeDocument = gql`
  mutation CreateMerchantCryptoRefundFee($input: CreateCryptoRefundFeeInput!) {
    createMerchantCryptoRefundFee(input: $input) {
      id
      merchantId
      payableCurrencyId
      currencyId
      feeType
      feeAmount
      minFee
      maxFee
      isActive
      description
      createdAt
    }
  }
`
export function useCreateMerchantCryptoRefundFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMerchantCryptoRefundFeeMutation,
    CreateMerchantCryptoRefundFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateMerchantCryptoRefundFeeMutation,
    CreateMerchantCryptoRefundFeeMutationVariables
  >(CreateMerchantCryptoRefundFeeDocument, options)
}
export type CreateMerchantCryptoRefundFeeMutationHookResult = ReturnType<
  typeof useCreateMerchantCryptoRefundFeeMutation
>
export type CreateMerchantCryptoRefundFeeMutationResult =
  ApolloReactCommon.MutationResult<CreateMerchantCryptoRefundFeeMutation>
export const UpdateMerchantCryptoRefundFeeDocument = gql`
  mutation UpdateMerchantCryptoRefundFee(
    $id: Int!
    $input: UpdateCryptoRefundFeeInput!
  ) {
    updateMerchantCryptoRefundFee(id: $id, input: $input) {
      id
      merchantId
      payableCurrencyId
      currencyId
      feeType
      feeAmount
      minFee
      maxFee
      isActive
      description
      createdAt
    }
  }
`
export function useUpdateMerchantCryptoRefundFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMerchantCryptoRefundFeeMutation,
    UpdateMerchantCryptoRefundFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateMerchantCryptoRefundFeeMutation,
    UpdateMerchantCryptoRefundFeeMutationVariables
  >(UpdateMerchantCryptoRefundFeeDocument, options)
}
export type UpdateMerchantCryptoRefundFeeMutationHookResult = ReturnType<
  typeof useUpdateMerchantCryptoRefundFeeMutation
>
export type UpdateMerchantCryptoRefundFeeMutationResult =
  ApolloReactCommon.MutationResult<UpdateMerchantCryptoRefundFeeMutation>
export const DeleteMerchantCryptoRefundFeeDocument = gql`
  mutation DeleteMerchantCryptoRefundFee($id: Int!) {
    deleteMerchantCryptoRefundFee(id: $id) {
      id
      merchantId
      payableCurrencyId
      currencyId
    }
  }
`
export function useDeleteMerchantCryptoRefundFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMerchantCryptoRefundFeeMutation,
    DeleteMerchantCryptoRefundFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteMerchantCryptoRefundFeeMutation,
    DeleteMerchantCryptoRefundFeeMutationVariables
  >(DeleteMerchantCryptoRefundFeeDocument, options)
}
export type DeleteMerchantCryptoRefundFeeMutationHookResult = ReturnType<
  typeof useDeleteMerchantCryptoRefundFeeMutation
>
export type DeleteMerchantCryptoRefundFeeMutationResult =
  ApolloReactCommon.MutationResult<DeleteMerchantCryptoRefundFeeMutation>
export const CreateMerchantDocument = gql`
  mutation CreateMerchant($input: CreateMerchantInput!) {
    createMerchant(input: $input) {
      merchantId
      mid
      adminUserId
    }
  }
`
export function useCreateMerchantMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMerchantMutation,
    CreateMerchantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateMerchantMutation,
    CreateMerchantMutationVariables
  >(CreateMerchantDocument, options)
}
export type CreateMerchantMutationHookResult = ReturnType<
  typeof useCreateMerchantMutation
>
export type CreateMerchantMutationResult =
  ApolloReactCommon.MutationResult<CreateMerchantMutation>
export const StartOfframpDocument = gql`
  mutation startOfframp($input: StartOfframpInput!) {
    startOfframp(input: $input)
  }
`
export function useStartOfframpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartOfframpMutation,
    StartOfframpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StartOfframpMutation,
    StartOfframpMutationVariables
  >(StartOfframpDocument, options)
}
export type StartOfframpMutationHookResult = ReturnType<
  typeof useStartOfframpMutation
>
export type StartOfframpMutationResult =
  ApolloReactCommon.MutationResult<StartOfframpMutation>
export const ApproveOfframpDocument = gql`
  mutation approveOfframp($input: ApproveOfframpInput!) {
    approveOfframp(input: $input)
  }
`
export function useApproveOfframpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ApproveOfframpMutation,
    ApproveOfframpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ApproveOfframpMutation,
    ApproveOfframpMutationVariables
  >(ApproveOfframpDocument, options)
}
export type ApproveOfframpMutationHookResult = ReturnType<
  typeof useApproveOfframpMutation
>
export type ApproveOfframpMutationResult =
  ApolloReactCommon.MutationResult<ApproveOfframpMutation>
export const CompleteOfframpManuallyDocument = gql`
  mutation completeOfframpManually($input: CompleteOfframpManuallyInput!) {
    completeOfframpManually(input: $input)
  }
`
export function useCompleteOfframpManuallyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CompleteOfframpManuallyMutation,
    CompleteOfframpManuallyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CompleteOfframpManuallyMutation,
    CompleteOfframpManuallyMutationVariables
  >(CompleteOfframpManuallyDocument, options)
}
export type CompleteOfframpManuallyMutationHookResult = ReturnType<
  typeof useCompleteOfframpManuallyMutation
>
export type CompleteOfframpManuallyMutationResult =
  ApolloReactCommon.MutationResult<CompleteOfframpManuallyMutation>
export const RejectOfframpDocument = gql`
  mutation rejectOfframp($input: RejectOfframpInput!) {
    rejectOfframp(input: $input)
  }
`
export function useRejectOfframpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RejectOfframpMutation,
    RejectOfframpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RejectOfframpMutation,
    RejectOfframpMutationVariables
  >(RejectOfframpDocument, options)
}
export type RejectOfframpMutationHookResult = ReturnType<
  typeof useRejectOfframpMutation
>
export type RejectOfframpMutationResult =
  ApolloReactCommon.MutationResult<RejectOfframpMutation>
export const StartOnrampDocument = gql`
  mutation startOnramp($input: StartOnrampInput!) {
    startOnramp(input: $input)
  }
`
export function useStartOnrampMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartOnrampMutation,
    StartOnrampMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StartOnrampMutation,
    StartOnrampMutationVariables
  >(StartOnrampDocument, options)
}
export type StartOnrampMutationHookResult = ReturnType<
  typeof useStartOnrampMutation
>
export type StartOnrampMutationResult =
  ApolloReactCommon.MutationResult<StartOnrampMutation>
export const ApproveOnrampDocument = gql`
  mutation approveOnramp($input: ApproveOnrampInput!) {
    approveOnramp(input: $input)
  }
`
export function useApproveOnrampMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ApproveOnrampMutation,
    ApproveOnrampMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ApproveOnrampMutation,
    ApproveOnrampMutationVariables
  >(ApproveOnrampDocument, options)
}
export type ApproveOnrampMutationHookResult = ReturnType<
  typeof useApproveOnrampMutation
>
export type ApproveOnrampMutationResult =
  ApolloReactCommon.MutationResult<ApproveOnrampMutation>
export const RetryOnrampFundingTransferDocument = gql`
  mutation retryOnrampFundingTransfer(
    $input: RetryOnrampFundingTransferInput!
  ) {
    retryOnrampFundingTransfer(input: $input)
  }
`
export function useRetryOnrampFundingTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RetryOnrampFundingTransferMutation,
    RetryOnrampFundingTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RetryOnrampFundingTransferMutation,
    RetryOnrampFundingTransferMutationVariables
  >(RetryOnrampFundingTransferDocument, options)
}
export type RetryOnrampFundingTransferMutationHookResult = ReturnType<
  typeof useRetryOnrampFundingTransferMutation
>
export type RetryOnrampFundingTransferMutationResult =
  ApolloReactCommon.MutationResult<RetryOnrampFundingTransferMutation>
export const RecordOnrampFundingTransferDocument = gql`
  mutation RecordOnrampFundingTransfer(
    $input: RecordOnrampFundingTransferInput!
  ) {
    recordOnrampFundingTransfer(input: $input) {
      id
      transferId
      sourceChannel
      targetChannel
      requestedAmount
      requestedCurrency
      targetAmount
      targetCurrency
      providerRef
      status
      errorMessage
    }
  }
`
export function useRecordOnrampFundingTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RecordOnrampFundingTransferMutation,
    RecordOnrampFundingTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RecordOnrampFundingTransferMutation,
    RecordOnrampFundingTransferMutationVariables
  >(RecordOnrampFundingTransferDocument, options)
}
export type RecordOnrampFundingTransferMutationHookResult = ReturnType<
  typeof useRecordOnrampFundingTransferMutation
>
export type RecordOnrampFundingTransferMutationResult =
  ApolloReactCommon.MutationResult<RecordOnrampFundingTransferMutation>
export const SimulateOnrampFundingTransferPaidDocument = gql`
  mutation simulateOnrampFundingTransferPaid($orderId: String!) {
    simulateOnrampFundingTransferPaid(orderId: $orderId)
  }
`
export function useSimulateOnrampFundingTransferPaidMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SimulateOnrampFundingTransferPaidMutation,
    SimulateOnrampFundingTransferPaidMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SimulateOnrampFundingTransferPaidMutation,
    SimulateOnrampFundingTransferPaidMutationVariables
  >(SimulateOnrampFundingTransferPaidDocument, options)
}
export type SimulateOnrampFundingTransferPaidMutationHookResult = ReturnType<
  typeof useSimulateOnrampFundingTransferPaidMutation
>
export type SimulateOnrampFundingTransferPaidMutationResult =
  ApolloReactCommon.MutationResult<SimulateOnrampFundingTransferPaidMutation>
export const SimulateOnrampFundingTransferFailedDocument = gql`
  mutation simulateOnrampFundingTransferFailed(
    $orderId: String!
    $failureType: String
  ) {
    simulateOnrampFundingTransferFailed(
      orderId: $orderId
      failureType: $failureType
    )
  }
`
export function useSimulateOnrampFundingTransferFailedMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SimulateOnrampFundingTransferFailedMutation,
    SimulateOnrampFundingTransferFailedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SimulateOnrampFundingTransferFailedMutation,
    SimulateOnrampFundingTransferFailedMutationVariables
  >(SimulateOnrampFundingTransferFailedDocument, options)
}
export type SimulateOnrampFundingTransferFailedMutationHookResult = ReturnType<
  typeof useSimulateOnrampFundingTransferFailedMutation
>
export type SimulateOnrampFundingTransferFailedMutationResult =
  ApolloReactCommon.MutationResult<SimulateOnrampFundingTransferFailedMutation>
export const CompleteOnrampManuallyDocument = gql`
  mutation completeOnrampManually($input: CompleteOnrampManuallyInput!) {
    completeOnrampManually(input: $input)
  }
`
export function useCompleteOnrampManuallyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CompleteOnrampManuallyMutation,
    CompleteOnrampManuallyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CompleteOnrampManuallyMutation,
    CompleteOnrampManuallyMutationVariables
  >(CompleteOnrampManuallyDocument, options)
}
export type CompleteOnrampManuallyMutationHookResult = ReturnType<
  typeof useCompleteOnrampManuallyMutation
>
export type CompleteOnrampManuallyMutationResult =
  ApolloReactCommon.MutationResult<CompleteOnrampManuallyMutation>
export const RejectOnrampDocument = gql`
  mutation rejectOnramp($input: RejectOnrampInput!) {
    rejectOnramp(input: $input)
  }
`
export function useRejectOnrampMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RejectOnrampMutation,
    RejectOnrampMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RejectOnrampMutation,
    RejectOnrampMutationVariables
  >(RejectOnrampDocument, options)
}
export type RejectOnrampMutationHookResult = ReturnType<
  typeof useRejectOnrampMutation
>
export type RejectOnrampMutationResult =
  ApolloReactCommon.MutationResult<RejectOnrampMutation>
export const AcceptHoldingPaymentDocument = gql`
  mutation AcceptHoldingPayment($input: AcceptHoldingPaymentInput!) {
    acceptHoldingPayment(input: $input) {
      id
      decision
      finalAmount
      decidedAt
    }
  }
`
export function useAcceptHoldingPaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AcceptHoldingPaymentMutation,
    AcceptHoldingPaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AcceptHoldingPaymentMutation,
    AcceptHoldingPaymentMutationVariables
  >(AcceptHoldingPaymentDocument, options)
}
export type AcceptHoldingPaymentMutationHookResult = ReturnType<
  typeof useAcceptHoldingPaymentMutation
>
export type AcceptHoldingPaymentMutationResult =
  ApolloReactCommon.MutationResult<AcceptHoldingPaymentMutation>
export const RejectHoldingPaymentDocument = gql`
  mutation RejectHoldingPayment($input: RejectHoldingPaymentInput!) {
    rejectHoldingPayment(input: $input) {
      id
      decision
      rejectReason
      decidedAt
      finalAmount
    }
  }
`
export function useRejectHoldingPaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RejectHoldingPaymentMutation,
    RejectHoldingPaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RejectHoldingPaymentMutation,
    RejectHoldingPaymentMutationVariables
  >(RejectHoldingPaymentDocument, options)
}
export type RejectHoldingPaymentMutationHookResult = ReturnType<
  typeof useRejectHoldingPaymentMutation
>
export type RejectHoldingPaymentMutationResult =
  ApolloReactCommon.MutationResult<RejectHoldingPaymentMutation>
export const CreatePaymentGatewayDocument = gql`
  mutation CreatePaymentGateway($input: CreatePaymentGatewayInput!) {
    createPaymentGateway(input: $input) {
      id
      code
      name
      status
      baseUrl
      apiVersion
      supportedMethods
      supportedCurrencies
      baseFeeRate
      minAmount
      maxAmount
      settlementCycle
      supportsPartialRefund
      supportsWebhook
      supportsRecurring
      supportsInstantSettlement
      createdAt
    }
  }
`
export function useCreatePaymentGatewayMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePaymentGatewayMutation,
    CreatePaymentGatewayMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreatePaymentGatewayMutation,
    CreatePaymentGatewayMutationVariables
  >(CreatePaymentGatewayDocument, options)
}
export type CreatePaymentGatewayMutationHookResult = ReturnType<
  typeof useCreatePaymentGatewayMutation
>
export type CreatePaymentGatewayMutationResult =
  ApolloReactCommon.MutationResult<CreatePaymentGatewayMutation>
export const UpdatePaymentGatewayDocument = gql`
  mutation UpdatePaymentGateway($id: Int!, $input: UpdatePaymentGatewayInput!) {
    updatePaymentGateway(id: $id, input: $input) {
      id
      code
      name
      status
      baseUrl
      apiVersion
      supportedMethods
      supportedCurrencies
      baseFeeRate
      minAmount
      maxAmount
      settlementCycle
      supportsPartialRefund
      supportsWebhook
      supportsRecurring
      supportsInstantSettlement
      updatedAt
    }
  }
`
export function useUpdatePaymentGatewayMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePaymentGatewayMutation,
    UpdatePaymentGatewayMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePaymentGatewayMutation,
    UpdatePaymentGatewayMutationVariables
  >(UpdatePaymentGatewayDocument, options)
}
export type UpdatePaymentGatewayMutationHookResult = ReturnType<
  typeof useUpdatePaymentGatewayMutation
>
export type UpdatePaymentGatewayMutationResult =
  ApolloReactCommon.MutationResult<UpdatePaymentGatewayMutation>
export const DeletePaymentGatewayDocument = gql`
  mutation DeletePaymentGateway($id: Int!) {
    deletePaymentGateway(id: $id) {
      id
      code
      name
    }
  }
`
export function useDeletePaymentGatewayMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeletePaymentGatewayMutation,
    DeletePaymentGatewayMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeletePaymentGatewayMutation,
    DeletePaymentGatewayMutationVariables
  >(DeletePaymentGatewayDocument, options)
}
export type DeletePaymentGatewayMutationHookResult = ReturnType<
  typeof useDeletePaymentGatewayMutation
>
export type DeletePaymentGatewayMutationResult =
  ApolloReactCommon.MutationResult<DeletePaymentGatewayMutation>
export const UpdatePaymentGatewayStatusDocument = gql`
  mutation UpdatePaymentGatewayStatus($id: Int!, $status: GatewayStatus!) {
    updatePaymentGatewayStatus(id: $id, status: $status) {
      id
      code
      name
      status
      updatedAt
    }
  }
`
export function useUpdatePaymentGatewayStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePaymentGatewayStatusMutation,
    UpdatePaymentGatewayStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePaymentGatewayStatusMutation,
    UpdatePaymentGatewayStatusMutationVariables
  >(UpdatePaymentGatewayStatusDocument, options)
}
export type UpdatePaymentGatewayStatusMutationHookResult = ReturnType<
  typeof useUpdatePaymentGatewayStatusMutation
>
export type UpdatePaymentGatewayStatusMutationResult =
  ApolloReactCommon.MutationResult<UpdatePaymentGatewayStatusMutation>
export const CreatePaymentMethodRoutingDocument = gql`
  mutation CreatePaymentMethodRouting(
    $input: CreatePaymentMethodRoutingInput!
  ) {
    createPaymentMethodRouting(input: $input) {
      id
      paymentMethod
      gateway {
        id
        code
        name
        status
      }
      priority
      isActive
      isDefault
      createdAt
    }
  }
`
export function useCreatePaymentMethodRoutingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePaymentMethodRoutingMutation,
    CreatePaymentMethodRoutingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreatePaymentMethodRoutingMutation,
    CreatePaymentMethodRoutingMutationVariables
  >(CreatePaymentMethodRoutingDocument, options)
}
export type CreatePaymentMethodRoutingMutationHookResult = ReturnType<
  typeof useCreatePaymentMethodRoutingMutation
>
export type CreatePaymentMethodRoutingMutationResult =
  ApolloReactCommon.MutationResult<CreatePaymentMethodRoutingMutation>
export const UpdatePaymentMethodRoutingDocument = gql`
  mutation UpdatePaymentMethodRouting(
    $id: Int!
    $input: UpdatePaymentMethodRoutingInput!
  ) {
    updatePaymentMethodRouting(id: $id, input: $input) {
      id
      paymentMethod
      gateway {
        id
        code
        name
        status
      }
      priority
      isActive
      isDefault
      successRate
      avgResponseTime
      availability
      updatedAt
    }
  }
`
export function useUpdatePaymentMethodRoutingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePaymentMethodRoutingMutation,
    UpdatePaymentMethodRoutingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePaymentMethodRoutingMutation,
    UpdatePaymentMethodRoutingMutationVariables
  >(UpdatePaymentMethodRoutingDocument, options)
}
export type UpdatePaymentMethodRoutingMutationHookResult = ReturnType<
  typeof useUpdatePaymentMethodRoutingMutation
>
export type UpdatePaymentMethodRoutingMutationResult =
  ApolloReactCommon.MutationResult<UpdatePaymentMethodRoutingMutation>
export const DeletePaymentMethodRoutingDocument = gql`
  mutation DeletePaymentMethodRouting($id: Int!) {
    deletePaymentMethodRouting(id: $id) {
      id
    }
  }
`
export function useDeletePaymentMethodRoutingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeletePaymentMethodRoutingMutation,
    DeletePaymentMethodRoutingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeletePaymentMethodRoutingMutation,
    DeletePaymentMethodRoutingMutationVariables
  >(DeletePaymentMethodRoutingDocument, options)
}
export type DeletePaymentMethodRoutingMutationHookResult = ReturnType<
  typeof useDeletePaymentMethodRoutingMutation
>
export type DeletePaymentMethodRoutingMutationResult =
  ApolloReactCommon.MutationResult<DeletePaymentMethodRoutingMutation>
export const UpdateRoutingPriorityDocument = gql`
  mutation UpdateRoutingPriority($id: Int!, $priority: Int!) {
    updateRoutingPriority(id: $id, priority: $priority) {
      id
      priority
      updatedAt
    }
  }
`
export function useUpdateRoutingPriorityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRoutingPriorityMutation,
    UpdateRoutingPriorityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRoutingPriorityMutation,
    UpdateRoutingPriorityMutationVariables
  >(UpdateRoutingPriorityDocument, options)
}
export type UpdateRoutingPriorityMutationHookResult = ReturnType<
  typeof useUpdateRoutingPriorityMutation
>
export type UpdateRoutingPriorityMutationResult =
  ApolloReactCommon.MutationResult<UpdateRoutingPriorityMutation>
export const RetryPayoutDocument = gql`
  mutation retryPayout($orderId: String!) {
    retryPayout(orderId: $orderId)
  }
`
export function useRetryPayoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RetryPayoutMutation,
    RetryPayoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RetryPayoutMutation,
    RetryPayoutMutationVariables
  >(RetryPayoutDocument, options)
}
export type RetryPayoutMutationHookResult = ReturnType<
  typeof useRetryPayoutMutation
>
export type RetryPayoutMutationResult =
  ApolloReactCommon.MutationResult<RetryPayoutMutation>
export const CancelPayoutDocument = gql`
  mutation cancelPayout($orderId: String!) {
    cancelPayout(orderId: $orderId)
  }
`
export function useCancelPayoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelPayoutMutation,
    CancelPayoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CancelPayoutMutation,
    CancelPayoutMutationVariables
  >(CancelPayoutDocument, options)
}
export type CancelPayoutMutationHookResult = ReturnType<
  typeof useCancelPayoutMutation
>
export type CancelPayoutMutationResult =
  ApolloReactCommon.MutationResult<CancelPayoutMutation>
export const ApproveCryptoPayoutDocument = gql`
  mutation approveCryptoPayout($input: ApproveCryptoPayoutInput!) {
    approveCryptoPayout(input: $input)
  }
`
export function useApproveCryptoPayoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ApproveCryptoPayoutMutation,
    ApproveCryptoPayoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ApproveCryptoPayoutMutation,
    ApproveCryptoPayoutMutationVariables
  >(ApproveCryptoPayoutDocument, options)
}
export type ApproveCryptoPayoutMutationHookResult = ReturnType<
  typeof useApproveCryptoPayoutMutation
>
export type ApproveCryptoPayoutMutationResult =
  ApolloReactCommon.MutationResult<ApproveCryptoPayoutMutation>
export const CompleteCryptoPayoutManuallyDocument = gql`
  mutation completeCryptoPayoutManually(
    $input: CompleteCryptoPayoutManuallyInput!
  ) {
    completeCryptoPayoutManually(input: $input)
  }
`
export function useCompleteCryptoPayoutManuallyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CompleteCryptoPayoutManuallyMutation,
    CompleteCryptoPayoutManuallyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CompleteCryptoPayoutManuallyMutation,
    CompleteCryptoPayoutManuallyMutationVariables
  >(CompleteCryptoPayoutManuallyDocument, options)
}
export type CompleteCryptoPayoutManuallyMutationHookResult = ReturnType<
  typeof useCompleteCryptoPayoutManuallyMutation
>
export type CompleteCryptoPayoutManuallyMutationResult =
  ApolloReactCommon.MutationResult<CompleteCryptoPayoutManuallyMutation>
export const RejectCryptoPayoutDocument = gql`
  mutation rejectCryptoPayout($input: RejectCryptoPayoutInput!) {
    rejectCryptoPayout(input: $input)
  }
`
export function useRejectCryptoPayoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RejectCryptoPayoutMutation,
    RejectCryptoPayoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RejectCryptoPayoutMutation,
    RejectCryptoPayoutMutationVariables
  >(RejectCryptoPayoutDocument, options)
}
export type RejectCryptoPayoutMutationHookResult = ReturnType<
  typeof useRejectCryptoPayoutMutation
>
export type RejectCryptoPayoutMutationResult =
  ApolloReactCommon.MutationResult<RejectCryptoPayoutMutation>
export const StartCryptoPayoutDocument = gql`
  mutation startCryptoPayout($input: StartCryptoPayoutInput!) {
    startCryptoPayout(input: $input)
  }
`
export function useStartCryptoPayoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartCryptoPayoutMutation,
    StartCryptoPayoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StartCryptoPayoutMutation,
    StartCryptoPayoutMutationVariables
  >(StartCryptoPayoutDocument, options)
}
export type StartCryptoPayoutMutationHookResult = ReturnType<
  typeof useStartCryptoPayoutMutation
>
export type StartCryptoPayoutMutationResult =
  ApolloReactCommon.MutationResult<StartCryptoPayoutMutation>
export const UploadBatchCryptoPayoutDocument = gql`
  mutation UploadBatchCryptoPayout($input: UploadBatchCryptoPayoutInput!) {
    uploadBatchCryptoPayout(input: $input) {
      batchId
      batchNo
      rowCount
    }
  }
`
export function useUploadBatchCryptoPayoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UploadBatchCryptoPayoutMutation,
    UploadBatchCryptoPayoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UploadBatchCryptoPayoutMutation,
    UploadBatchCryptoPayoutMutationVariables
  >(UploadBatchCryptoPayoutDocument, options)
}
export type UploadBatchCryptoPayoutMutationHookResult = ReturnType<
  typeof useUploadBatchCryptoPayoutMutation
>
export type UploadBatchCryptoPayoutMutationResult =
  ApolloReactCommon.MutationResult<UploadBatchCryptoPayoutMutation>
export const CreateMerchantFrequentRecipientDocument = gql`
  mutation CreateMerchantFrequentRecipient(
    $input: CreateMerchantFrequentRecipientInput!
  ) {
    createMerchantFrequentRecipient(input: $input) {
      id
      merchantId
      recipientName
      network
      address
      createdAt
      updatedAt
    }
  }
`
export function useCreateMerchantFrequentRecipientMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMerchantFrequentRecipientMutation,
    CreateMerchantFrequentRecipientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateMerchantFrequentRecipientMutation,
    CreateMerchantFrequentRecipientMutationVariables
  >(CreateMerchantFrequentRecipientDocument, options)
}
export type CreateMerchantFrequentRecipientMutationHookResult = ReturnType<
  typeof useCreateMerchantFrequentRecipientMutation
>
export type CreateMerchantFrequentRecipientMutationResult =
  ApolloReactCommon.MutationResult<CreateMerchantFrequentRecipientMutation>
export const DeleteMerchantFrequentRecipientDocument = gql`
  mutation DeleteMerchantFrequentRecipient($id: Int!) {
    deleteMerchantFrequentRecipient(id: $id)
  }
`
export function useDeleteMerchantFrequentRecipientMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMerchantFrequentRecipientMutation,
    DeleteMerchantFrequentRecipientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteMerchantFrequentRecipientMutation,
    DeleteMerchantFrequentRecipientMutationVariables
  >(DeleteMerchantFrequentRecipientDocument, options)
}
export type DeleteMerchantFrequentRecipientMutationHookResult = ReturnType<
  typeof useDeleteMerchantFrequentRecipientMutation
>
export type DeleteMerchantFrequentRecipientMutationResult =
  ApolloReactCommon.MutationResult<DeleteMerchantFrequentRecipientMutation>
export const UpdatePgSettlementTransferStatusDocument = gql`
  mutation UpdatePgSettlementTransferStatus(
    $input: UpdatePgSettlementTransferStatusInput!
  ) {
    updatePgSettlementTransferStatus(input: $input) {
      id
      status
      txHash
      blockNumber
      errorCode
      errorMessage
      notes
      targetAmount
      exchangeRate
      receivedAmount
      receivedCurrency
      submittedAt
      processedAt
      completedAt
      updatedAt
    }
  }
`
export function useUpdatePgSettlementTransferStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePgSettlementTransferStatusMutation,
    UpdatePgSettlementTransferStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePgSettlementTransferStatusMutation,
    UpdatePgSettlementTransferStatusMutationVariables
  >(UpdatePgSettlementTransferStatusDocument, options)
}
export type UpdatePgSettlementTransferStatusMutationHookResult = ReturnType<
  typeof useUpdatePgSettlementTransferStatusMutation
>
export type UpdatePgSettlementTransferStatusMutationResult =
  ApolloReactCommon.MutationResult<UpdatePgSettlementTransferStatusMutation>
export const AddPgSettlementEventDocument = gql`
  mutation AddPgSettlementEvent($input: AddPgSettlementEventInput!) {
    addPgSettlementEvent(input: $input) {
      id
      pgSettlementId
      pgSettlementTransferId
      eventType
      eventSource
      title
      description
      metadata
      occurredAt
      createdAt
      createdBy
    }
  }
`
export function useAddPgSettlementEventMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddPgSettlementEventMutation,
    AddPgSettlementEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddPgSettlementEventMutation,
    AddPgSettlementEventMutationVariables
  >(AddPgSettlementEventDocument, options)
}
export type AddPgSettlementEventMutationHookResult = ReturnType<
  typeof useAddPgSettlementEventMutation
>
export type AddPgSettlementEventMutationResult =
  ApolloReactCommon.MutationResult<AddPgSettlementEventMutation>
export const AddPgSettlementFeeDocument = gql`
  mutation AddPgSettlementFee($input: AddPgSettlementFeeInput!) {
    addPgSettlementFee(input: $input) {
      id
      pgSettlementItemId
      feeType
      amount
      currency
      txHash
      description
      createdAt
    }
  }
`
export function useAddPgSettlementFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddPgSettlementFeeMutation,
    AddPgSettlementFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AddPgSettlementFeeMutation,
    AddPgSettlementFeeMutationVariables
  >(AddPgSettlementFeeDocument, options)
}
export type AddPgSettlementFeeMutationHookResult = ReturnType<
  typeof useAddPgSettlementFeeMutation
>
export type AddPgSettlementFeeMutationResult =
  ApolloReactCommon.MutationResult<AddPgSettlementFeeMutation>
export const UpdatePgSettlementFeeDocument = gql`
  mutation UpdatePgSettlementFee($input: UpdatePgSettlementFeeInput!) {
    updatePgSettlementFee(input: $input) {
      id
      pgSettlementItemId
      feeType
      amount
      currency
      txHash
      description
      createdAt
    }
  }
`
export function useUpdatePgSettlementFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePgSettlementFeeMutation,
    UpdatePgSettlementFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePgSettlementFeeMutation,
    UpdatePgSettlementFeeMutationVariables
  >(UpdatePgSettlementFeeDocument, options)
}
export type UpdatePgSettlementFeeMutationHookResult = ReturnType<
  typeof useUpdatePgSettlementFeeMutation
>
export type UpdatePgSettlementFeeMutationResult =
  ApolloReactCommon.MutationResult<UpdatePgSettlementFeeMutation>
export const DeletePgSettlementFeeDocument = gql`
  mutation DeletePgSettlementFee($id: String!) {
    deletePgSettlementFee(id: $id) {
      success
      id
    }
  }
`
export function useDeletePgSettlementFeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeletePgSettlementFeeMutation,
    DeletePgSettlementFeeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeletePgSettlementFeeMutation,
    DeletePgSettlementFeeMutationVariables
  >(DeletePgSettlementFeeDocument, options)
}
export type DeletePgSettlementFeeMutationHookResult = ReturnType<
  typeof useDeletePgSettlementFeeMutation
>
export type DeletePgSettlementFeeMutationResult =
  ApolloReactCommon.MutationResult<DeletePgSettlementFeeMutation>
export const CreatePgSettlementsDocument = gql`
  mutation CreatePgSettlements($input: CreatePgSettlementInput!) {
    createPgSettlements(input: $input) {
      id
      batchId
      gatewayId
      dateFrom
      dateTo
      currency
      settlementType
      status
      requestedAt
      submittedAt
      errorCode
      errorMessage
      createdAt
    }
  }
`
export function useCreatePgSettlementsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePgSettlementsMutation,
    CreatePgSettlementsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreatePgSettlementsMutation,
    CreatePgSettlementsMutationVariables
  >(CreatePgSettlementsDocument, options)
}
export type CreatePgSettlementsMutationHookResult = ReturnType<
  typeof useCreatePgSettlementsMutation
>
export type CreatePgSettlementsMutationResult =
  ApolloReactCommon.MutationResult<CreatePgSettlementsMutation>
export const UpsertPgSettlementWalletConfigDocument = gql`
  mutation UpsertPgSettlementWalletConfig(
    $input: UpsertPgSettlementWalletConfigInput!
  ) {
    upsertPgSettlementWalletConfig(input: $input) {
      id
      gatewayId
      currencyId
      currencyCode
      network
      walletAddress
      walletMemo
      isActive
      targetChannelCode
      createdAt
      updatedAt
      createdBy
    }
  }
`
export function useUpsertPgSettlementWalletConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertPgSettlementWalletConfigMutation,
    UpsertPgSettlementWalletConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpsertPgSettlementWalletConfigMutation,
    UpsertPgSettlementWalletConfigMutationVariables
  >(UpsertPgSettlementWalletConfigDocument, options)
}
export type UpsertPgSettlementWalletConfigMutationHookResult = ReturnType<
  typeof useUpsertPgSettlementWalletConfigMutation
>
export type UpsertPgSettlementWalletConfigMutationResult =
  ApolloReactCommon.MutationResult<UpsertPgSettlementWalletConfigMutation>
export const DeletePgSettlementWalletConfigDocument = gql`
  mutation DeletePgSettlementWalletConfig($id: String!) {
    deletePgSettlementWalletConfig(id: $id)
  }
`
export function useDeletePgSettlementWalletConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeletePgSettlementWalletConfigMutation,
    DeletePgSettlementWalletConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeletePgSettlementWalletConfigMutation,
    DeletePgSettlementWalletConfigMutationVariables
  >(DeletePgSettlementWalletConfigDocument, options)
}
export type DeletePgSettlementWalletConfigMutationHookResult = ReturnType<
  typeof useDeletePgSettlementWalletConfigMutation
>
export type DeletePgSettlementWalletConfigMutationResult =
  ApolloReactCommon.MutationResult<DeletePgSettlementWalletConfigMutation>
export const ResolveReconciliationMismatchItemDocument = gql`
  mutation ResolveReconciliationMismatchItem(
    $input: ResolveReconciliationMismatchItemInput!
  ) {
    resolveReconciliationMismatchItem(input: $input) {
      ...ReconciliationMismatchItemFields
    }
  }
  ${ReconciliationMismatchItemFieldsFragmentDoc}
`
export function useResolveReconciliationMismatchItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResolveReconciliationMismatchItemMutation,
    ResolveReconciliationMismatchItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResolveReconciliationMismatchItemMutation,
    ResolveReconciliationMismatchItemMutationVariables
  >(ResolveReconciliationMismatchItemDocument, options)
}
export type ResolveReconciliationMismatchItemMutationHookResult = ReturnType<
  typeof useResolveReconciliationMismatchItemMutation
>
export type ResolveReconciliationMismatchItemMutationResult =
  ApolloReactCommon.MutationResult<ResolveReconciliationMismatchItemMutation>
export const ApproveRefundApprovalRequestDocument = gql`
  mutation ApproveRefundApprovalRequest($input: ApproveRefundApprovalInput!) {
    approveRefundApprovalRequest(input: $input) {
      ...RefundApprovalRequestFields
    }
  }
  ${RefundApprovalRequestFieldsFragmentDoc}
`
export function useApproveRefundApprovalRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ApproveRefundApprovalRequestMutation,
    ApproveRefundApprovalRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ApproveRefundApprovalRequestMutation,
    ApproveRefundApprovalRequestMutationVariables
  >(ApproveRefundApprovalRequestDocument, options)
}
export type ApproveRefundApprovalRequestMutationHookResult = ReturnType<
  typeof useApproveRefundApprovalRequestMutation
>
export type ApproveRefundApprovalRequestMutationResult =
  ApolloReactCommon.MutationResult<ApproveRefundApprovalRequestMutation>
export const RejectRefundApprovalRequestDocument = gql`
  mutation RejectRefundApprovalRequest($input: RejectRefundApprovalInput!) {
    rejectRefundApprovalRequest(input: $input) {
      ...RefundApprovalRequestFields
    }
  }
  ${RefundApprovalRequestFieldsFragmentDoc}
`
export function useRejectRefundApprovalRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RejectRefundApprovalRequestMutation,
    RejectRefundApprovalRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RejectRefundApprovalRequestMutation,
    RejectRefundApprovalRequestMutationVariables
  >(RejectRefundApprovalRequestDocument, options)
}
export type RejectRefundApprovalRequestMutationHookResult = ReturnType<
  typeof useRejectRefundApprovalRequestMutation
>
export type RejectRefundApprovalRequestMutationResult =
  ApolloReactCommon.MutationResult<RejectRefundApprovalRequestMutation>
export const CreateRefundLinkDocument = gql`
  mutation CreateRefundLink($input: CreateRefundLinkInput!) {
    createRefundLink(input: $input) {
      refundLinkId
      refundUrl
      expiresAt
      emailQueued
    }
  }
`
export function useCreateRefundLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateRefundLinkMutation,
    CreateRefundLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateRefundLinkMutation,
    CreateRefundLinkMutationVariables
  >(CreateRefundLinkDocument, options)
}
export type CreateRefundLinkMutationHookResult = ReturnType<
  typeof useCreateRefundLinkMutation
>
export type CreateRefundLinkMutationResult =
  ApolloReactCommon.MutationResult<CreateRefundLinkMutation>
export const CancelRefundLinkDocument = gql`
  mutation CancelRefundLink($input: CancelRefundLinkInput!) {
    cancelRefundLink(input: $input) {
      success
      refundLinkId
      status
      message
    }
  }
`
export function useCancelRefundLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelRefundLinkMutation,
    CancelRefundLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CancelRefundLinkMutation,
    CancelRefundLinkMutationVariables
  >(CancelRefundLinkDocument, options)
}
export type CancelRefundLinkMutationHookResult = ReturnType<
  typeof useCancelRefundLinkMutation
>
export type CancelRefundLinkMutationResult =
  ApolloReactCommon.MutationResult<CancelRefundLinkMutation>
export const UpdateRefundLinkEmailDocument = gql`
  mutation UpdateRefundLinkEmail($input: UpdateRefundLinkEmailInput!) {
    updateRefundLinkEmail(input: $input) {
      success
      refundLinkId
      customerEmail
      emailResent
      message
    }
  }
`
export function useUpdateRefundLinkEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateRefundLinkEmailMutation,
    UpdateRefundLinkEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateRefundLinkEmailMutation,
    UpdateRefundLinkEmailMutationVariables
  >(UpdateRefundLinkEmailDocument, options)
}
export type UpdateRefundLinkEmailMutationHookResult = ReturnType<
  typeof useUpdateRefundLinkEmailMutation
>
export type UpdateRefundLinkEmailMutationResult =
  ApolloReactCommon.MutationResult<UpdateRefundLinkEmailMutation>
export const UpdateSystemSettingDocument = gql`
  mutation UpdateSystemSetting($input: UpdateSystemSettingInput!) {
    updateSystemSetting(input: $input) {
      id
      category
      key
      value
      valueType
      description
      updatedAt
    }
  }
`
export function useUpdateSystemSettingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateSystemSettingMutation,
    UpdateSystemSettingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateSystemSettingMutation,
    UpdateSystemSettingMutationVariables
  >(UpdateSystemSettingDocument, options)
}
export type UpdateSystemSettingMutationHookResult = ReturnType<
  typeof useUpdateSystemSettingMutation
>
export type UpdateSystemSettingMutationResult =
  ApolloReactCommon.MutationResult<UpdateSystemSettingMutation>
export const UpdateSystemSettingsDocument = gql`
  mutation UpdateSystemSettings($inputs: [UpdateSystemSettingInput!]!) {
    updateSystemSettings(inputs: $inputs) {
      id
      category
      key
      value
      valueType
      description
      updatedAt
    }
  }
`
export function useUpdateSystemSettingsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateSystemSettingsMutation,
    UpdateSystemSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateSystemSettingsMutation,
    UpdateSystemSettingsMutationVariables
  >(UpdateSystemSettingsDocument, options)
}
export type UpdateSystemSettingsMutationHookResult = ReturnType<
  typeof useUpdateSystemSettingsMutation
>
export type UpdateSystemSettingsMutationResult =
  ApolloReactCommon.MutationResult<UpdateSystemSettingsMutation>
export const ConfirmTopupDocument = gql`
  mutation confirmTopup($id: Int!, $merchantId: Int!, $totpCode: String) {
    confirmTopup(id: $id, merchantId: $merchantId, totpCode: $totpCode)
  }
`
export function useConfirmTopupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConfirmTopupMutation,
    ConfirmTopupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ConfirmTopupMutation,
    ConfirmTopupMutationVariables
  >(ConfirmTopupDocument, options)
}
export type ConfirmTopupMutationHookResult = ReturnType<
  typeof useConfirmTopupMutation
>
export type ConfirmTopupMutationResult =
  ApolloReactCommon.MutationResult<ConfirmTopupMutation>
export const RollbackTopupDocument = gql`
  mutation rollbackTopup($input: RollbackTopupInput!) {
    rollbackTopup(input: $input)
  }
`
export function useRollbackTopupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RollbackTopupMutation,
    RollbackTopupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RollbackTopupMutation,
    RollbackTopupMutationVariables
  >(RollbackTopupDocument, options)
}
export type RollbackTopupMutationHookResult = ReturnType<
  typeof useRollbackTopupMutation
>
export type RollbackTopupMutationResult =
  ApolloReactCommon.MutationResult<RollbackTopupMutation>
export const OmitTopupDocument = gql`
  mutation OmitTopup($input: OmitTopupInput!) {
    omitTopup(input: $input)
  }
`
export function useOmitTopupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    OmitTopupMutation,
    OmitTopupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    OmitTopupMutation,
    OmitTopupMutationVariables
  >(OmitTopupDocument, options)
}
export type OmitTopupMutationHookResult = ReturnType<
  typeof useOmitTopupMutation
>
export type OmitTopupMutationResult =
  ApolloReactCommon.MutationResult<OmitTopupMutation>
export const AssignTopupToInternalTransferDocument = gql`
  mutation AssignTopupToInternalTransfer(
    $input: AssignTopupToInternalTransferInput!
  ) {
    assignTopupToInternalTransfer(input: $input)
  }
`
export function useAssignTopupToInternalTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AssignTopupToInternalTransferMutation,
    AssignTopupToInternalTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AssignTopupToInternalTransferMutation,
    AssignTopupToInternalTransferMutationVariables
  >(AssignTopupToInternalTransferDocument, options)
}
export type AssignTopupToInternalTransferMutationHookResult = ReturnType<
  typeof useAssignTopupToInternalTransferMutation
>
export type AssignTopupToInternalTransferMutationResult =
  ApolloReactCommon.MutationResult<AssignTopupToInternalTransferMutation>
export const CreateTopupRequestDocument = gql`
  mutation CreateTopupRequest($input: CreateTopupRequestInput!) {
    createTopupRequest(input: $input) {
      requestId
      paymentReference
      amount
      currency
      expiresAt
      status
      accountInfo {
        accountName
        accountNumber
        bankName
        bankCode
        branchCode
        swiftCode
        location
      }
      cryptoInfo {
        tokenId
        chain
        address
        qrDataUrl
      }
    }
  }
`
export function useCreateTopupRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateTopupRequestMutation,
    CreateTopupRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateTopupRequestMutation,
    CreateTopupRequestMutationVariables
  >(CreateTopupRequestDocument, options)
}
export type CreateTopupRequestMutationHookResult = ReturnType<
  typeof useCreateTopupRequestMutation
>
export type CreateTopupRequestMutationResult =
  ApolloReactCommon.MutationResult<CreateTopupRequestMutation>
export const CancelTopupRequestDocument = gql`
  mutation CancelTopupRequest($input: CancelTopupRequestInput!) {
    cancelTopupRequest(input: $input)
  }
`
export function useCancelTopupRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelTopupRequestMutation,
    CancelTopupRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CancelTopupRequestMutation,
    CancelTopupRequestMutationVariables
  >(CancelTopupRequestDocument, options)
}
export type CancelTopupRequestMutationHookResult = ReturnType<
  typeof useCancelTopupRequestMutation
>
export type CancelTopupRequestMutationResult =
  ApolloReactCommon.MutationResult<CancelTopupRequestMutation>
export const SubmitTopupRequestEvidenceDocument = gql`
  mutation SubmitTopupRequestEvidence(
    $input: SubmitTopupRequestEvidenceInput!
  ) {
    submitTopupRequestEvidence(input: $input)
  }
`
export function useSubmitTopupRequestEvidenceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubmitTopupRequestEvidenceMutation,
    SubmitTopupRequestEvidenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SubmitTopupRequestEvidenceMutation,
    SubmitTopupRequestEvidenceMutationVariables
  >(SubmitTopupRequestEvidenceDocument, options)
}
export type SubmitTopupRequestEvidenceMutationHookResult = ReturnType<
  typeof useSubmitTopupRequestEvidenceMutation
>
export type SubmitTopupRequestEvidenceMutationResult =
  ApolloReactCommon.MutationResult<SubmitTopupRequestEvidenceMutation>
export const UpdateMerchantDocument = gql`
  mutation UpdateMerchant($input: UpdateMerchantInput!) {
    updateMerchant(input: $input) {
      id
      mid
      name
      email
      status
      type
      riskLevel
      exceptionHandlingMode
      businessName
      businessNumber
      businessAddress
      businessPhoneCountryCode
      businessPhoneNumber
      businessCategory
      representativeName
      merchantBackground
      additionalInfo
      relevantCompany
      companyName
      countryCode
      employeeCount
      registeredDate
      taxNumber
      websiteUrl
      bankName
      bankBranch
      bankAddress
      settlementArea
      swiftCode
      signerName
      signerBirthDate
      signerIdType
      signerIdNumber
      signerIdDocument
      signerIdValidFrom
      signerIdValidTo
      signerResidentialAddress
      signerResidentialCountry
      createdAt
      updatedAt
      merchantAdminUser {
        id
        email
        name
        phoneCountryCode
        phoneNumber
        lastLoginAt
        createdAt
        updatedAt
      }
    }
  }
`
export function useUpdateMerchantMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMerchantMutation,
    UpdateMerchantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateMerchantMutation,
    UpdateMerchantMutationVariables
  >(UpdateMerchantDocument, options)
}
export type UpdateMerchantMutationHookResult = ReturnType<
  typeof useUpdateMerchantMutation
>
export type UpdateMerchantMutationResult =
  ApolloReactCommon.MutationResult<UpdateMerchantMutation>
export const GetApiKeyListDocument = gql`
  query GetApiKeyList($page: Int!, $limit: Int!, $filter: ApiKeyFilterInput) {
    merchantApiKeys(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        keyType
        environment
        keyMasked
        displayName
        description
        status
        lastUsedAt
        usageCount
        expiresAt
        createdAt
        merchant {
          id
          name
        }
      }
      totalCount
      page
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetApiKeyListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetApiKeyListQuery,
    GetApiKeyListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetApiKeyListQuery,
    GetApiKeyListQueryVariables
  >(GetApiKeyListDocument, options)
}
export function useGetApiKeyListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetApiKeyListQuery,
    GetApiKeyListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetApiKeyListQuery,
    GetApiKeyListQueryVariables
  >(GetApiKeyListDocument, options)
}
export type GetApiKeyListQueryHookResult = ReturnType<
  typeof useGetApiKeyListQuery
>
export type GetApiKeyListLazyQueryHookResult = ReturnType<
  typeof useGetApiKeyListLazyQuery
>
export type GetApiKeyListQueryResult = ApolloReactCommon.QueryResult<
  GetApiKeyListQuery,
  GetApiKeyListQueryVariables
>
export const GetAutoRefundsDocument = gql`
  query GetAutoRefunds(
    $page: Int
    $limit: Int
    $filter: AutoRefundFilterInput
  ) {
    autoRefunds(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        paymentId
        gatewayId
        type
        gatewayTransactionId
        merchantTransactionId
        amount
        currency
        settlementDate
        status
        statusCode
        statusMessage
        originalTxId
        refundReason
        isPartial
        blockchainTxHash
        blockNumber
        confirmations
        processedAt
        failureCode
        failureMessage
        isAutoRefund
        autoRefundType
        createdAt
        updatedAt
        payment {
          id
          gatewayOrderId
          merchantOrderId
          amount
          currency
        }
        gateway {
          id
          code
          name
        }
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetAutoRefundsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAutoRefundsQuery,
    GetAutoRefundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAutoRefundsQuery,
    GetAutoRefundsQueryVariables
  >(GetAutoRefundsDocument, options)
}
export function useGetAutoRefundsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAutoRefundsQuery,
    GetAutoRefundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAutoRefundsQuery,
    GetAutoRefundsQueryVariables
  >(GetAutoRefundsDocument, options)
}
export type GetAutoRefundsQueryHookResult = ReturnType<
  typeof useGetAutoRefundsQuery
>
export type GetAutoRefundsLazyQueryHookResult = ReturnType<
  typeof useGetAutoRefundsLazyQuery
>
export type GetAutoRefundsQueryResult = ApolloReactCommon.QueryResult<
  GetAutoRefundsQuery,
  GetAutoRefundsQueryVariables
>
export const GetCurrentApiKeysDocument = gql`
  query GetCurrentApiKeys($merchantId: Int) {
    currentMerchantApiKeys(merchantId: $merchantId) {
      keyType
      clientKey {
        id
        keyMasked
        displayName
        status
        lastUsedAt
        usageCount
        createdAt
      }
      secretKey {
        id
        keyMasked
        displayName
        status
        lastUsedAt
        usageCount
        createdAt
      }
      webhookKey {
        id
        keyMasked
        displayName
        status
        lastUsedAt
        usageCount
        createdAt
      }
    }
  }
`
export function useGetCurrentApiKeysQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetCurrentApiKeysQuery,
    GetCurrentApiKeysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetCurrentApiKeysQuery,
    GetCurrentApiKeysQueryVariables
  >(GetCurrentApiKeysDocument, options)
}
export function useGetCurrentApiKeysLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCurrentApiKeysQuery,
    GetCurrentApiKeysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetCurrentApiKeysQuery,
    GetCurrentApiKeysQueryVariables
  >(GetCurrentApiKeysDocument, options)
}
export type GetCurrentApiKeysQueryHookResult = ReturnType<
  typeof useGetCurrentApiKeysQuery
>
export type GetCurrentApiKeysLazyQueryHookResult = ReturnType<
  typeof useGetCurrentApiKeysLazyQuery
>
export type GetCurrentApiKeysQueryResult = ApolloReactCommon.QueryResult<
  GetCurrentApiKeysQuery,
  GetCurrentApiKeysQueryVariables
>
export const GetMerchantPaymentMethodsDocument = gql`
  query GetMerchantPaymentMethods($merchantId: Int, $id: Float) {
    merchantPaymentMethods(merchantId: $merchantId) {
      id
      paymentMethod
      displayName
      isEnabled
      feeRate
      fixedFee
      minAmount
      maxAmount
      minFee
      maxFee
      dailyLimitAmount
      monthlyLimitAmount
      customRoutingId
      settlementCycle
      description
      createdAt
      updatedAt
    }
    merchant(id: $id) {
      id
      mid
      name
      businessName
      email
      status
      type
      businessNumber
      businessAddress
      businessCategory
      representativeName
    }
  }
`
export function useGetMerchantPaymentMethodsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMerchantPaymentMethodsQuery,
    GetMerchantPaymentMethodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantPaymentMethodsQuery,
    GetMerchantPaymentMethodsQueryVariables
  >(GetMerchantPaymentMethodsDocument, options)
}
export function useGetMerchantPaymentMethodsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantPaymentMethodsQuery,
    GetMerchantPaymentMethodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantPaymentMethodsQuery,
    GetMerchantPaymentMethodsQueryVariables
  >(GetMerchantPaymentMethodsDocument, options)
}
export type GetMerchantPaymentMethodsQueryHookResult = ReturnType<
  typeof useGetMerchantPaymentMethodsQuery
>
export type GetMerchantPaymentMethodsLazyQueryHookResult = ReturnType<
  typeof useGetMerchantPaymentMethodsLazyQuery
>
export type GetMerchantPaymentMethodsQueryResult =
  ApolloReactCommon.QueryResult<
    GetMerchantPaymentMethodsQuery,
    GetMerchantPaymentMethodsQueryVariables
  >
export const GetMerchantWebhookUrlDocument = gql`
  query GetMerchantWebhookUrl($merchantId: Float) {
    merchant(id: $merchantId) {
      id
      mid
      name
      webhookUrl
    }
  }
`
export function useGetMerchantWebhookUrlQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMerchantWebhookUrlQuery,
    GetMerchantWebhookUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantWebhookUrlQuery,
    GetMerchantWebhookUrlQueryVariables
  >(GetMerchantWebhookUrlDocument, options)
}
export function useGetMerchantWebhookUrlLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantWebhookUrlQuery,
    GetMerchantWebhookUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantWebhookUrlQuery,
    GetMerchantWebhookUrlQueryVariables
  >(GetMerchantWebhookUrlDocument, options)
}
export type GetMerchantWebhookUrlQueryHookResult = ReturnType<
  typeof useGetMerchantWebhookUrlQuery
>
export type GetMerchantWebhookUrlLazyQueryHookResult = ReturnType<
  typeof useGetMerchantWebhookUrlLazyQuery
>
export type GetMerchantWebhookUrlQueryResult = ApolloReactCommon.QueryResult<
  GetMerchantWebhookUrlQuery,
  GetMerchantWebhookUrlQueryVariables
>
export const GetMerchantsByPaymentMethodDocument = gql`
  query GetMerchantsByPaymentMethod(
    $page: Int
    $limit: Int
    $filter: MerchantPaymentMethodFilterInput
  ) {
    merchantsByPaymentMethod(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        mid
        name
        email
        status
        type
        createdAt
        activePaymentMethodsCount
        paymentMethods {
          id
          paymentMethod
          displayName
          isEnabled
          feeRate
          fixedFee
          minAmount
          maxAmount
          minFee
          maxFee
        }
      }
      totalCount
      totalPages
      page
      limit
      hasNext
      hasPrev
    }
  }
`
export function useGetMerchantsByPaymentMethodQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMerchantsByPaymentMethodQuery,
    GetMerchantsByPaymentMethodQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantsByPaymentMethodQuery,
    GetMerchantsByPaymentMethodQueryVariables
  >(GetMerchantsByPaymentMethodDocument, options)
}
export function useGetMerchantsByPaymentMethodLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantsByPaymentMethodQuery,
    GetMerchantsByPaymentMethodQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantsByPaymentMethodQuery,
    GetMerchantsByPaymentMethodQueryVariables
  >(GetMerchantsByPaymentMethodDocument, options)
}
export type GetMerchantsByPaymentMethodQueryHookResult = ReturnType<
  typeof useGetMerchantsByPaymentMethodQuery
>
export type GetMerchantsByPaymentMethodLazyQueryHookResult = ReturnType<
  typeof useGetMerchantsByPaymentMethodLazyQuery
>
export type GetMerchantsByPaymentMethodQueryResult =
  ApolloReactCommon.QueryResult<
    GetMerchantsByPaymentMethodQuery,
    GetMerchantsByPaymentMethodQueryVariables
  >
export const GetPaymentDocument = gql`
  query GetPayment($id: String!) {
    payment(id: $id) {
      id
      merchantOrderId
      merchantId
      amount
      paidAmount
      netAmount
      refundedAmount
      pendingRefundApprovalAmount
      currency
      status
      paymentMethod
      paymentType
      payableCurrency
      payableAmount
      payableNetwork
      description
      merchant {
        id
        name
        mid
      }
      transactions {
        id
        type
        status
        amount
        currency
        payableAmount
        payableCurrency
        payableNetwork
        gatewayId
        gatewayTransactionId
        merchantTransactionId
        processedAt
        failureCode
        failureMessage
      }
      refundLinks {
        id
        status
        source
        refundAmount
        currency
        walletAddress
        customerEmail
        reason
        expiresAt
        createdAt
        submittedAt
        completedAt
        transactionId
      }
      createdAt
      updatedAt
      paidAt
      lastRefundedAt
      metadata
    }
  }
`
export function useGetPaymentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPaymentQuery,
    GetPaymentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(
    GetPaymentDocument,
    options
  )
}
export function useGetPaymentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPaymentQuery,
    GetPaymentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPaymentQuery,
    GetPaymentQueryVariables
  >(GetPaymentDocument, options)
}
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>
export type GetPaymentLazyQueryHookResult = ReturnType<
  typeof useGetPaymentLazyQuery
>
export type GetPaymentQueryResult = ApolloReactCommon.QueryResult<
  GetPaymentQuery,
  GetPaymentQueryVariables
>
export const GetPaymentsDocument = gql`
  query GetPayments(
    $filter: PaymentFilterInput
    $page: Int = 1
    $limit: Int = 20
  ) {
    payments(filter: $filter, page: $page, limit: $limit) {
      hasNext
      hasPrev
      page
      limit
      totalCount
      totalPages
      items {
        id
        merchantOrderId
        merchantId
        amount
        paidAmount
        netAmount
        refundedAmount
        currency
        status
        paymentMethod
        paymentType
        description
        merchant {
          id
          name
          mid
        }
        createdAt
        updatedAt
        paidAt
        lastRefundedAt
      }
    }
  }
`
export function useGetPaymentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPaymentsQuery,
    GetPaymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetPaymentsQuery, GetPaymentsQueryVariables>(
    GetPaymentsDocument,
    options
  )
}
export function useGetPaymentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPaymentsQuery,
    GetPaymentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPaymentsQuery,
    GetPaymentsQueryVariables
  >(GetPaymentsDocument, options)
}
export type GetPaymentsQueryHookResult = ReturnType<typeof useGetPaymentsQuery>
export type GetPaymentsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentsLazyQuery
>
export type GetPaymentsQueryResult = ApolloReactCommon.QueryResult<
  GetPaymentsQuery,
  GetPaymentsQueryVariables
>
export const DownloadPaymentExcelDocument = gql`
  mutation DownloadPaymentExcel($filter: PaymentFilterInput) {
    downloadPaymentExcel(filter: $filter) {
      downloadUrl
      jobId
      message
      processType
      recordCount
    }
  }
`
export function useDownloadPaymentExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadPaymentExcelMutation,
    DownloadPaymentExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadPaymentExcelMutation,
    DownloadPaymentExcelMutationVariables
  >(DownloadPaymentExcelDocument, options)
}
export type DownloadPaymentExcelMutationHookResult = ReturnType<
  typeof useDownloadPaymentExcelMutation
>
export type DownloadPaymentExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadPaymentExcelMutation>
export const GetRefundDocument = gql`
  query GetRefund($id: String!) {
    refund(id: $id) {
      id
      gatewayTransactionId
      merchantTransactionId
      amount
      currency
      status
      isPartial
      refundReason
      gateway {
        code
        name
      }
      originalPayment {
        id
        merchantOrderId
        amount
        currency
        paidAmount
        paymentMethod
        status
        createdAt
      }
      merchant {
        id
        name
        mid
      }
      originalTxId
      failureCode
      failureMessage
      createdAt
      createdBy {
        userId
        name
        email
      }
      receiveAddress
      processedAt
      refundMethod
      refundFeeRecord {
        id
        feeAmount
        feeCurrency
        feeType
        payableAmount
        calculationMethod
        appliedFeeRate
        minFeeApplied
        maxFeeApplied
        createdAt
      }
      refundLink {
        id
        status
        refundAmount
        currency
        walletAddress
        reason
        customerEmail
        expiresAt
        createdAt
        submittedAt
        completedAt
      }
    }
  }
`
export function useGetRefundQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetRefundQuery,
    GetRefundQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetRefundQuery, GetRefundQueryVariables>(
    GetRefundDocument,
    options
  )
}
export function useGetRefundLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRefundQuery,
    GetRefundQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetRefundQuery, GetRefundQueryVariables>(
    GetRefundDocument,
    options
  )
}
export type GetRefundQueryHookResult = ReturnType<typeof useGetRefundQuery>
export type GetRefundLazyQueryHookResult = ReturnType<
  typeof useGetRefundLazyQuery
>
export type GetRefundQueryResult = ApolloReactCommon.QueryResult<
  GetRefundQuery,
  GetRefundQueryVariables
>
export const GetRefundsDocument = gql`
  query GetRefunds($page: Int, $limit: Int, $filter: RefundFilterInput) {
    refunds(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        gatewayTransactionId
        amount
        currency
        status
        isPartial
        refundReason
        refundMethod
        gateway {
          code
          name
        }
        originalPayment {
          merchantOrderId
          amount
          currency
        }
        merchant {
          name
          mid
        }
        createdAt
        createdBy {
          userId
          name
          email
        }
        receiveAddress
      }
      totalCount
      page
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetRefundsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetRefundsQuery,
    GetRefundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetRefundsQuery, GetRefundsQueryVariables>(
    GetRefundsDocument,
    options
  )
}
export function useGetRefundsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRefundsQuery,
    GetRefundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetRefundsQuery,
    GetRefundsQueryVariables
  >(GetRefundsDocument, options)
}
export type GetRefundsQueryHookResult = ReturnType<typeof useGetRefundsQuery>
export type GetRefundsLazyQueryHookResult = ReturnType<
  typeof useGetRefundsLazyQuery
>
export type GetRefundsQueryResult = ApolloReactCommon.QueryResult<
  GetRefundsQuery,
  GetRefundsQueryVariables
>
export const GetTopupAddressGroupsDocument = gql`
  query GetTopupAddressGroups(
    $page: Int!
    $limit: Int!
    $merchantId: Int
    $filter: TopupAddressFilterInput
  ) {
    topupAddressGroups(
      page: $page
      limit: $limit
      merchantId: $merchantId
      filter: $filter
    ) {
      items {
        customId
        merchantId
        merchant {
          id
          name
          mid
        }
        totalCount
        activeCount
        latestAddress
        tokenIds
        orderName
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetTopupAddressGroupsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTopupAddressGroupsQuery,
    GetTopupAddressGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetTopupAddressGroupsQuery,
    GetTopupAddressGroupsQueryVariables
  >(GetTopupAddressGroupsDocument, options)
}
export function useGetTopupAddressGroupsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTopupAddressGroupsQuery,
    GetTopupAddressGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetTopupAddressGroupsQuery,
    GetTopupAddressGroupsQueryVariables
  >(GetTopupAddressGroupsDocument, options)
}
export type GetTopupAddressGroupsQueryHookResult = ReturnType<
  typeof useGetTopupAddressGroupsQuery
>
export type GetTopupAddressGroupsLazyQueryHookResult = ReturnType<
  typeof useGetTopupAddressGroupsLazyQuery
>
export type GetTopupAddressGroupsQueryResult = ApolloReactCommon.QueryResult<
  GetTopupAddressGroupsQuery,
  GetTopupAddressGroupsQueryVariables
>
export const GetTopupAddressesDocument = gql`
  query GetTopupAddresses(
    $page: Int = 1
    $limit: Int = 20
    $merchantId: Int
    $filter: TopupAddressFilterInput
  ) {
    topupAddresses(
      page: $page
      limit: $limit
      merchantId: $merchantId
      filter: $filter
    ) {
      hasNext
      hasPrev
      page
      limit
      totalCount
      totalPages
      items {
        id
        merchantId
        customId
        tokenId
        chain
        address
        isActive
        minAmount
        orderName
        merchant {
          id
          name
          mid
        }
        createdAt
        updatedAt
      }
    }
  }
`
export function useGetTopupAddressesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetTopupAddressesQuery,
    GetTopupAddressesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetTopupAddressesQuery,
    GetTopupAddressesQueryVariables
  >(GetTopupAddressesDocument, options)
}
export function useGetTopupAddressesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTopupAddressesQuery,
    GetTopupAddressesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetTopupAddressesQuery,
    GetTopupAddressesQueryVariables
  >(GetTopupAddressesDocument, options)
}
export type GetTopupAddressesQueryHookResult = ReturnType<
  typeof useGetTopupAddressesQuery
>
export type GetTopupAddressesLazyQueryHookResult = ReturnType<
  typeof useGetTopupAddressesLazyQuery
>
export type GetTopupAddressesQueryResult = ApolloReactCommon.QueryResult<
  GetTopupAddressesQuery,
  GetTopupAddressesQueryVariables
>
export const GetTopupAddressesByCustomIdDocument = gql`
  query GetTopupAddressesByCustomId(
    $page: Int!
    $limit: Int!
    $merchantId: Int
    $filter: TopupAddressFilterInput
  ) {
    topupAddresses(
      page: $page
      limit: $limit
      merchantId: $merchantId
      filter: $filter
    ) {
      items {
        id
        merchantId
        customId
        tokenId
        chain
        address
        isActive
        minAmount
        orderName
        deactivatedReason
        deactivatedAt
        merchant {
          id
          name
          mid
        }
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetTopupAddressesByCustomIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTopupAddressesByCustomIdQuery,
    GetTopupAddressesByCustomIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetTopupAddressesByCustomIdQuery,
    GetTopupAddressesByCustomIdQueryVariables
  >(GetTopupAddressesByCustomIdDocument, options)
}
export function useGetTopupAddressesByCustomIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTopupAddressesByCustomIdQuery,
    GetTopupAddressesByCustomIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetTopupAddressesByCustomIdQuery,
    GetTopupAddressesByCustomIdQueryVariables
  >(GetTopupAddressesByCustomIdDocument, options)
}
export type GetTopupAddressesByCustomIdQueryHookResult = ReturnType<
  typeof useGetTopupAddressesByCustomIdQuery
>
export type GetTopupAddressesByCustomIdLazyQueryHookResult = ReturnType<
  typeof useGetTopupAddressesByCustomIdLazyQuery
>
export type GetTopupAddressesByCustomIdQueryResult =
  ApolloReactCommon.QueryResult<
    GetTopupAddressesByCustomIdQuery,
    GetTopupAddressesByCustomIdQueryVariables
  >
export const GetWebhookEventDocument = gql`
  query GetWebhookEvent($id: String!) {
    webhookEvent(id: $id) {
      id
      direction
      gatewayId
      merchantId
      eventType
      eventId
      url
      headers
      payload
      signature
      status
      httpStatus
      response
      attempts
      nextRetryAt
      lastAttemptAt
      paymentId
      transactionId
      receivedAt
      processedAt
    }
  }
`
export function useGetWebhookEventQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetWebhookEventQuery,
    GetWebhookEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetWebhookEventQuery,
    GetWebhookEventQueryVariables
  >(GetWebhookEventDocument, options)
}
export function useGetWebhookEventLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetWebhookEventQuery,
    GetWebhookEventQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetWebhookEventQuery,
    GetWebhookEventQueryVariables
  >(GetWebhookEventDocument, options)
}
export type GetWebhookEventQueryHookResult = ReturnType<
  typeof useGetWebhookEventQuery
>
export type GetWebhookEventLazyQueryHookResult = ReturnType<
  typeof useGetWebhookEventLazyQuery
>
export type GetWebhookEventQueryResult = ApolloReactCommon.QueryResult<
  GetWebhookEventQuery,
  GetWebhookEventQueryVariables
>
export const GetWebhookEventsDocument = gql`
  query GetWebhookEvents(
    $page: Int
    $limit: Int
    $filter: WebhookEventFilterInput
  ) {
    webhookEvents(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        direction
        gatewayId
        merchantId
        eventType
        eventId
        url
        status
        httpStatus
        attempts
        nextRetryAt
        lastAttemptAt
        paymentId
        transactionId
        receivedAt
        processedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetWebhookEventsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetWebhookEventsQuery,
    GetWebhookEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetWebhookEventsQuery,
    GetWebhookEventsQueryVariables
  >(GetWebhookEventsDocument, options)
}
export function useGetWebhookEventsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetWebhookEventsQuery,
    GetWebhookEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetWebhookEventsQuery,
    GetWebhookEventsQueryVariables
  >(GetWebhookEventsDocument, options)
}
export type GetWebhookEventsQueryHookResult = ReturnType<
  typeof useGetWebhookEventsQuery
>
export type GetWebhookEventsLazyQueryHookResult = ReturnType<
  typeof useGetWebhookEventsLazyQuery
>
export type GetWebhookEventsQueryResult = ApolloReactCommon.QueryResult<
  GetWebhookEventsQuery,
  GetWebhookEventsQueryVariables
>
export const GetAmlAlertsDocument = gql`
  query GetAmlAlerts($page: Int, $limit: Int, $filter: AmlAlertFilterInput) {
    amlAlerts(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        merchantId
        paymentId
        alertType
        severity
        status
        notes
        resolvedAt
        createdAt
        screeningResult {
          id
          walletAddress
          blockchain
          direction
          riskScore
          riskLevel
          detectedCategories
          status
          screenedAt
        }
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetAmlAlertsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAmlAlertsQuery,
    GetAmlAlertsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAmlAlertsQuery,
    GetAmlAlertsQueryVariables
  >(GetAmlAlertsDocument, options)
}
export function useGetAmlAlertsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAmlAlertsQuery,
    GetAmlAlertsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAmlAlertsQuery,
    GetAmlAlertsQueryVariables
  >(GetAmlAlertsDocument, options)
}
export type GetAmlAlertsQueryHookResult = ReturnType<
  typeof useGetAmlAlertsQuery
>
export type GetAmlAlertsLazyQueryHookResult = ReturnType<
  typeof useGetAmlAlertsLazyQuery
>
export type GetAmlAlertsQueryResult = ApolloReactCommon.QueryResult<
  GetAmlAlertsQuery,
  GetAmlAlertsQueryVariables
>
export const GetAmlAlertDocument = gql`
  query GetAmlAlert($id: String!) {
    amlAlert(id: $id) {
      id
      merchantId
      merchantName
      paymentId
      alertType
      severity
      status
      notes
      assigneeId
      resolvedAt
      resolvedById
      createdAt
      updatedAt
      screeningResult {
        id
        walletAddress
        blockchain
        direction
        riskScore
        riskLevel
        detectedCategories
        rawResponse
        status
        screenedAt
        providerId
        providerName
      }
    }
  }
`
export function useGetAmlAlertQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetAmlAlertQuery,
    GetAmlAlertQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetAmlAlertQuery, GetAmlAlertQueryVariables>(
    GetAmlAlertDocument,
    options
  )
}
export function useGetAmlAlertLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAmlAlertQuery,
    GetAmlAlertQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAmlAlertQuery,
    GetAmlAlertQueryVariables
  >(GetAmlAlertDocument, options)
}
export type GetAmlAlertQueryHookResult = ReturnType<typeof useGetAmlAlertQuery>
export type GetAmlAlertLazyQueryHookResult = ReturnType<
  typeof useGetAmlAlertLazyQuery
>
export type GetAmlAlertQueryResult = ApolloReactCommon.QueryResult<
  GetAmlAlertQuery,
  GetAmlAlertQueryVariables
>
export const GetRiskManagementProvidersDocument = gql`
  query GetRiskManagementProviders {
    riskManagementProviders {
      id
      code
      name
      status
      priority
      createdAt
      updatedAt
    }
  }
`
export function useGetRiskManagementProvidersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetRiskManagementProvidersQuery,
    GetRiskManagementProvidersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetRiskManagementProvidersQuery,
    GetRiskManagementProvidersQueryVariables
  >(GetRiskManagementProvidersDocument, options)
}
export function useGetRiskManagementProvidersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRiskManagementProvidersQuery,
    GetRiskManagementProvidersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetRiskManagementProvidersQuery,
    GetRiskManagementProvidersQueryVariables
  >(GetRiskManagementProvidersDocument, options)
}
export type GetRiskManagementProvidersQueryHookResult = ReturnType<
  typeof useGetRiskManagementProvidersQuery
>
export type GetRiskManagementProvidersLazyQueryHookResult = ReturnType<
  typeof useGetRiskManagementProvidersLazyQuery
>
export type GetRiskManagementProvidersQueryResult =
  ApolloReactCommon.QueryResult<
    GetRiskManagementProvidersQuery,
    GetRiskManagementProvidersQueryVariables
  >
export const GetAmlScreeningResultsDocument = gql`
  query GetAmlScreeningResults(
    $page: Int
    $limit: Int
    $filter: AmlScreeningResultFilterInput
  ) {
    amlScreeningResults(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        paymentId
        blockchain
        riskLevel
        riskScore
        status
        screenedAt
        createdAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetAmlScreeningResultsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAmlScreeningResultsQuery,
    GetAmlScreeningResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAmlScreeningResultsQuery,
    GetAmlScreeningResultsQueryVariables
  >(GetAmlScreeningResultsDocument, options)
}
export function useGetAmlScreeningResultsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAmlScreeningResultsQuery,
    GetAmlScreeningResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAmlScreeningResultsQuery,
    GetAmlScreeningResultsQueryVariables
  >(GetAmlScreeningResultsDocument, options)
}
export type GetAmlScreeningResultsQueryHookResult = ReturnType<
  typeof useGetAmlScreeningResultsQuery
>
export type GetAmlScreeningResultsLazyQueryHookResult = ReturnType<
  typeof useGetAmlScreeningResultsLazyQuery
>
export type GetAmlScreeningResultsQueryResult = ApolloReactCommon.QueryResult<
  GetAmlScreeningResultsQuery,
  GetAmlScreeningResultsQueryVariables
>
export const GetAmlScreeningResultDocument = gql`
  query GetAmlScreeningResult($id: String!) {
    amlScreeningResult(id: $id) {
      id
      paymentId
      transactionId
      walletAddress
      blockchain
      direction
      providerId
      providerName
      riskScore
      riskLevel
      detectedCategories
      rawResponse
      status
      screenedAt
      createdAt
      updatedAt
    }
  }
`
export function useGetAmlScreeningResultQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetAmlScreeningResultQuery,
    GetAmlScreeningResultQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAmlScreeningResultQuery,
    GetAmlScreeningResultQueryVariables
  >(GetAmlScreeningResultDocument, options)
}
export function useGetAmlScreeningResultLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAmlScreeningResultQuery,
    GetAmlScreeningResultQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAmlScreeningResultQuery,
    GetAmlScreeningResultQueryVariables
  >(GetAmlScreeningResultDocument, options)
}
export type GetAmlScreeningResultQueryHookResult = ReturnType<
  typeof useGetAmlScreeningResultQuery
>
export type GetAmlScreeningResultLazyQueryHookResult = ReturnType<
  typeof useGetAmlScreeningResultLazyQuery
>
export type GetAmlScreeningResultQueryResult = ApolloReactCommon.QueryResult<
  GetAmlScreeningResultQuery,
  GetAmlScreeningResultQueryVariables
>
export const GetAmlScreeningResultsByPaymentDocument = gql`
  query GetAmlScreeningResultsByPayment($paymentId: String!) {
    amlScreeningResultsByPayment(paymentId: $paymentId) {
      id
      transactionId
      riskLevel
      status
    }
  }
`
export function useGetAmlScreeningResultsByPaymentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetAmlScreeningResultsByPaymentQuery,
    GetAmlScreeningResultsByPaymentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAmlScreeningResultsByPaymentQuery,
    GetAmlScreeningResultsByPaymentQueryVariables
  >(GetAmlScreeningResultsByPaymentDocument, options)
}
export function useGetAmlScreeningResultsByPaymentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAmlScreeningResultsByPaymentQuery,
    GetAmlScreeningResultsByPaymentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAmlScreeningResultsByPaymentQuery,
    GetAmlScreeningResultsByPaymentQueryVariables
  >(GetAmlScreeningResultsByPaymentDocument, options)
}
export type GetAmlScreeningResultsByPaymentQueryHookResult = ReturnType<
  typeof useGetAmlScreeningResultsByPaymentQuery
>
export type GetAmlScreeningResultsByPaymentLazyQueryHookResult = ReturnType<
  typeof useGetAmlScreeningResultsByPaymentLazyQuery
>
export type GetAmlScreeningResultsByPaymentQueryResult =
  ApolloReactCommon.QueryResult<
    GetAmlScreeningResultsByPaymentQuery,
    GetAmlScreeningResultsByPaymentQueryVariables
  >
export const ApprovalTodoSummaryDocument = gql`
  query ApprovalTodoSummary {
    approvalTodoSummary {
      topupCount
      withdrawalCount
      onrampCount
      offrampCount
      payoutCount
      channelFeeCount
      reconciliationCount
      refundCount
      totalCount
    }
  }
`
export function useApprovalTodoSummaryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ApprovalTodoSummaryQuery,
    ApprovalTodoSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ApprovalTodoSummaryQuery,
    ApprovalTodoSummaryQueryVariables
  >(ApprovalTodoSummaryDocument, options)
}
export function useApprovalTodoSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ApprovalTodoSummaryQuery,
    ApprovalTodoSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ApprovalTodoSummaryQuery,
    ApprovalTodoSummaryQueryVariables
  >(ApprovalTodoSummaryDocument, options)
}
export type ApprovalTodoSummaryQueryHookResult = ReturnType<
  typeof useApprovalTodoSummaryQuery
>
export type ApprovalTodoSummaryLazyQueryHookResult = ReturnType<
  typeof useApprovalTodoSummaryLazyQuery
>
export type ApprovalTodoSummaryQueryResult = ApolloReactCommon.QueryResult<
  ApprovalTodoSummaryQuery,
  ApprovalTodoSummaryQueryVariables
>
export const ApprovalTodoListDocument = gql`
  query ApprovalTodoList(
    $page: Int
    $limit: Int
    $filter: ApprovalTodoFilterInput
  ) {
    approvalTodoList(page: $page, limit: $limit, filter: $filter) {
      items {
        category
        orderId
        merchantId
        merchantName
        amount
        currency
        createdAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useApprovalTodoListQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ApprovalTodoListQuery,
    ApprovalTodoListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ApprovalTodoListQuery,
    ApprovalTodoListQueryVariables
  >(ApprovalTodoListDocument, options)
}
export function useApprovalTodoListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ApprovalTodoListQuery,
    ApprovalTodoListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ApprovalTodoListQuery,
    ApprovalTodoListQueryVariables
  >(ApprovalTodoListDocument, options)
}
export type ApprovalTodoListQueryHookResult = ReturnType<
  typeof useApprovalTodoListQuery
>
export type ApprovalTodoListLazyQueryHookResult = ReturnType<
  typeof useApprovalTodoListLazyQuery
>
export type ApprovalTodoListQueryResult = ApolloReactCommon.QueryResult<
  ApprovalTodoListQuery,
  ApprovalTodoListQueryVariables
>
export const BeneficiariesDocument = gql`
  query beneficiaries($merchantId: Int) {
    beneficiaries(merchantId: $merchantId) {
      id
      type
      label
      network
      address
      details
      verifiedAt
      lastUsedAt
      createdAt
    }
  }
`
export function useBeneficiariesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BeneficiariesQuery,
    BeneficiariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BeneficiariesQuery,
    BeneficiariesQueryVariables
  >(BeneficiariesDocument, options)
}
export function useBeneficiariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BeneficiariesQuery,
    BeneficiariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BeneficiariesQuery,
    BeneficiariesQueryVariables
  >(BeneficiariesDocument, options)
}
export type BeneficiariesQueryHookResult = ReturnType<
  typeof useBeneficiariesQuery
>
export type BeneficiariesLazyQueryHookResult = ReturnType<
  typeof useBeneficiariesLazyQuery
>
export type BeneficiariesQueryResult = ApolloReactCommon.QueryResult<
  BeneficiariesQuery,
  BeneficiariesQueryVariables
>
export const RegisterBeneficiaryDocument = gql`
  mutation registerBeneficiary($input: RegisterBeneficiaryInput!) {
    registerBeneficiary(input: $input) {
      id
      type
      label
      network
      address
      details
      verifiedAt
      createdAt
    }
  }
`
export function useRegisterBeneficiaryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RegisterBeneficiaryMutation,
    RegisterBeneficiaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RegisterBeneficiaryMutation,
    RegisterBeneficiaryMutationVariables
  >(RegisterBeneficiaryDocument, options)
}
export type RegisterBeneficiaryMutationHookResult = ReturnType<
  typeof useRegisterBeneficiaryMutation
>
export type RegisterBeneficiaryMutationResult =
  ApolloReactCommon.MutationResult<RegisterBeneficiaryMutation>
export const CreateBankBeneficiaryDocument = gql`
  mutation createBankBeneficiary($input: CreateBankBeneficiaryInput!) {
    createBankBeneficiary(input: $input) {
      id
      type
      label
      network
      address
      details
      verifiedAt
      createdAt
    }
  }
`
export function useCreateBankBeneficiaryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateBankBeneficiaryMutation,
    CreateBankBeneficiaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateBankBeneficiaryMutation,
    CreateBankBeneficiaryMutationVariables
  >(CreateBankBeneficiaryDocument, options)
}
export type CreateBankBeneficiaryMutationHookResult = ReturnType<
  typeof useCreateBankBeneficiaryMutation
>
export type CreateBankBeneficiaryMutationResult =
  ApolloReactCommon.MutationResult<CreateBankBeneficiaryMutation>
export const DeleteBeneficiaryDocument = gql`
  mutation deleteBeneficiary($id: Int!) {
    deleteBeneficiary(id: $id)
  }
`
export function useDeleteBeneficiaryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteBeneficiaryMutation,
    DeleteBeneficiaryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteBeneficiaryMutation,
    DeleteBeneficiaryMutationVariables
  >(DeleteBeneficiaryDocument, options)
}
export type DeleteBeneficiaryMutationHookResult = ReturnType<
  typeof useDeleteBeneficiaryMutation
>
export type DeleteBeneficiaryMutationResult =
  ApolloReactCommon.MutationResult<DeleteBeneficiaryMutation>
export const FundFlowChannelsDocument = gql`
  query FundFlowChannels {
    fundFlowChannels {
      code
      name
      status
      lastSyncedAt
    }
  }
`
export function useFundFlowChannelsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FundFlowChannelsQuery,
    FundFlowChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FundFlowChannelsQuery,
    FundFlowChannelsQueryVariables
  >(FundFlowChannelsDocument, options)
}
export function useFundFlowChannelsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FundFlowChannelsQuery,
    FundFlowChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FundFlowChannelsQuery,
    FundFlowChannelsQueryVariables
  >(FundFlowChannelsDocument, options)
}
export type FundFlowChannelsQueryHookResult = ReturnType<
  typeof useFundFlowChannelsQuery
>
export type FundFlowChannelsLazyQueryHookResult = ReturnType<
  typeof useFundFlowChannelsLazyQuery
>
export type FundFlowChannelsQueryResult = ApolloReactCommon.QueryResult<
  FundFlowChannelsQuery,
  FundFlowChannelsQueryVariables
>
export const FundFlowChannelBalanceDocument = gql`
  query FundFlowChannelBalance($channelCode: String!) {
    fundFlowChannelBalance(channelCode: $channelCode) {
      channelCode
      balances {
        currency
        availableBalance
        totalBalance
        frozenBalance
      }
      feeStationBalances {
        currency
        availableBalance
        totalBalance
        frozenBalance
      }
    }
  }
`
export function useFundFlowChannelBalanceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FundFlowChannelBalanceQuery,
    FundFlowChannelBalanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FundFlowChannelBalanceQuery,
    FundFlowChannelBalanceQueryVariables
  >(FundFlowChannelBalanceDocument, options)
}
export function useFundFlowChannelBalanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FundFlowChannelBalanceQuery,
    FundFlowChannelBalanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FundFlowChannelBalanceQuery,
    FundFlowChannelBalanceQueryVariables
  >(FundFlowChannelBalanceDocument, options)
}
export type FundFlowChannelBalanceQueryHookResult = ReturnType<
  typeof useFundFlowChannelBalanceQuery
>
export type FundFlowChannelBalanceLazyQueryHookResult = ReturnType<
  typeof useFundFlowChannelBalanceLazyQuery
>
export type FundFlowChannelBalanceQueryResult = ApolloReactCommon.QueryResult<
  FundFlowChannelBalanceQuery,
  FundFlowChannelBalanceQueryVariables
>
export const ChannelFundFlowsDocument = gql`
  query ChannelFundFlows(
    $page: Int
    $limit: Int
    $filter: ChannelFundFlowFilterInput
  ) {
    channelFundFlows(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        channelCode
        direction
        externalId
        amount
        feeAmount
        currency
        status
        externalStatus
        source
        occurredAt
        syncedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useChannelFundFlowsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ChannelFundFlowsQuery,
    ChannelFundFlowsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ChannelFundFlowsQuery,
    ChannelFundFlowsQueryVariables
  >(ChannelFundFlowsDocument, options)
}
export function useChannelFundFlowsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChannelFundFlowsQuery,
    ChannelFundFlowsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ChannelFundFlowsQuery,
    ChannelFundFlowsQueryVariables
  >(ChannelFundFlowsDocument, options)
}
export type ChannelFundFlowsQueryHookResult = ReturnType<
  typeof useChannelFundFlowsQuery
>
export type ChannelFundFlowsLazyQueryHookResult = ReturnType<
  typeof useChannelFundFlowsLazyQuery
>
export type ChannelFundFlowsQueryResult = ApolloReactCommon.QueryResult<
  ChannelFundFlowsQuery,
  ChannelFundFlowsQueryVariables
>
export const ChannelFundFlowSyncRunsDocument = gql`
  query ChannelFundFlowSyncRuns($channelCode: String, $limit: Int) {
    channelFundFlowSyncRuns(channelCode: $channelCode, limit: $limit) {
      id
      channelCode
      status
      rangeMode
      rangeFrom
      rangeTo
      stepsDone
      fetched
      upserted
      error
      startedAt
      finishedAt
      createdAt
    }
  }
`
export function useChannelFundFlowSyncRunsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ChannelFundFlowSyncRunsQuery,
    ChannelFundFlowSyncRunsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ChannelFundFlowSyncRunsQuery,
    ChannelFundFlowSyncRunsQueryVariables
  >(ChannelFundFlowSyncRunsDocument, options)
}
export function useChannelFundFlowSyncRunsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChannelFundFlowSyncRunsQuery,
    ChannelFundFlowSyncRunsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ChannelFundFlowSyncRunsQuery,
    ChannelFundFlowSyncRunsQueryVariables
  >(ChannelFundFlowSyncRunsDocument, options)
}
export type ChannelFundFlowSyncRunsQueryHookResult = ReturnType<
  typeof useChannelFundFlowSyncRunsQuery
>
export type ChannelFundFlowSyncRunsLazyQueryHookResult = ReturnType<
  typeof useChannelFundFlowSyncRunsLazyQuery
>
export type ChannelFundFlowSyncRunsQueryResult = ApolloReactCommon.QueryResult<
  ChannelFundFlowSyncRunsQuery,
  ChannelFundFlowSyncRunsQueryVariables
>
export const ChannelsDocument = gql`
  query Channels($page: Int, $limit: Int, $filter: ChannelFilterInput) {
    channels(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        code
        name
        description
        status
        gatewayId
        gatewayStatus
        topupAccountSource
        capabilities {
          id
          capability
          enabled
          config
        }
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useChannelsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ChannelsQuery,
    ChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ChannelsQuery, ChannelsQueryVariables>(
    ChannelsDocument,
    options
  )
}
export function useChannelsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChannelsQuery,
    ChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ChannelsQuery, ChannelsQueryVariables>(
    ChannelsDocument,
    options
  )
}
export type ChannelsQueryHookResult = ReturnType<typeof useChannelsQuery>
export type ChannelsLazyQueryHookResult = ReturnType<
  typeof useChannelsLazyQuery
>
export type ChannelsQueryResult = ApolloReactCommon.QueryResult<
  ChannelsQuery,
  ChannelsQueryVariables
>
export const ChannelDocument = gql`
  query Channel($code: String!) {
    channel(code: $code) {
      id
      code
      name
      description
      status
      gatewayId
      gatewayStatus
      capabilities {
        id
        capability
        enabled
        config
      }
      createdAt
      updatedAt
    }
  }
`
export function useChannelQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ChannelQuery,
    ChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ChannelQuery, ChannelQueryVariables>(
    ChannelDocument,
    options
  )
}
export function useChannelLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChannelQuery,
    ChannelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ChannelQuery, ChannelQueryVariables>(
    ChannelDocument,
    options
  )
}
export type ChannelQueryHookResult = ReturnType<typeof useChannelQuery>
export type ChannelLazyQueryHookResult = ReturnType<typeof useChannelLazyQuery>
export type ChannelQueryResult = ApolloReactCommon.QueryResult<
  ChannelQuery,
  ChannelQueryVariables
>
export const ChannelTopupAccountsDocument = gql`
  query ChannelTopupAccounts($channelCode: String!) {
    channelTopupAccounts(channelCode: $channelCode) {
      externalId
      nickName
      currency
      accountName
      accountNumber
      bankName
      bankCode
      branchCode
      swiftCode
      location
    }
  }
`
export function useChannelTopupAccountsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ChannelTopupAccountsQuery,
    ChannelTopupAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ChannelTopupAccountsQuery,
    ChannelTopupAccountsQueryVariables
  >(ChannelTopupAccountsDocument, options)
}
export function useChannelTopupAccountsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChannelTopupAccountsQuery,
    ChannelTopupAccountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ChannelTopupAccountsQuery,
    ChannelTopupAccountsQueryVariables
  >(ChannelTopupAccountsDocument, options)
}
export type ChannelTopupAccountsQueryHookResult = ReturnType<
  typeof useChannelTopupAccountsQuery
>
export type ChannelTopupAccountsLazyQueryHookResult = ReturnType<
  typeof useChannelTopupAccountsLazyQuery
>
export type ChannelTopupAccountsQueryResult = ApolloReactCommon.QueryResult<
  ChannelTopupAccountsQuery,
  ChannelTopupAccountsQueryVariables
>
export const ChannelRoutesDocument = gql`
  query ChannelRoutes(
    $filter: ChannelRouteFilterInput
    $page: Int = 1
    $limit: Int = 20
  ) {
    channelRoutes(filter: $filter, page: $page, limit: $limit) {
      items {
        id
        businessType
        channel
        merchantId
        merchant {
          id
          name
          mid
        }
        createdAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useChannelRoutesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ChannelRoutesQuery,
    ChannelRoutesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ChannelRoutesQuery,
    ChannelRoutesQueryVariables
  >(ChannelRoutesDocument, options)
}
export function useChannelRoutesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ChannelRoutesQuery,
    ChannelRoutesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ChannelRoutesQuery,
    ChannelRoutesQueryVariables
  >(ChannelRoutesDocument, options)
}
export type ChannelRoutesQueryHookResult = ReturnType<
  typeof useChannelRoutesQuery
>
export type ChannelRoutesLazyQueryHookResult = ReturnType<
  typeof useChannelRoutesLazyQuery
>
export type ChannelRoutesQueryResult = ApolloReactCommon.QueryResult<
  ChannelRoutesQuery,
  ChannelRoutesQueryVariables
>
export const GetChannelTransfersDocument = gql`
  query GetChannelTransfers(
    $filter: ChannelTransferFilterInput
    $page: Int = 1
    $limit: Int = 20
  ) {
    channelTransfers(filter: $filter, page: $page, limit: $limit) {
      items {
        id
        transferId
        type
        sourceChannel
        targetChannel
        gatewayCode
        requestedAmount
        requestedCurrency
        sourceAmount
        sourceCurrency
        targetAmount
        targetCurrency
        feeAmount
        feeCurrency
        providerRef
        txHash
        destinationAddress
        status
        errorMessage
        createdBy
        completedBy
        memo
        requestedAt
        processedAt
        succeededAt
        completedAt
        failedAt
        createdAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetChannelTransfersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetChannelTransfersQuery,
    GetChannelTransfersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetChannelTransfersQuery,
    GetChannelTransfersQueryVariables
  >(GetChannelTransfersDocument, options)
}
export function useGetChannelTransfersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetChannelTransfersQuery,
    GetChannelTransfersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetChannelTransfersQuery,
    GetChannelTransfersQueryVariables
  >(GetChannelTransfersDocument, options)
}
export type GetChannelTransfersQueryHookResult = ReturnType<
  typeof useGetChannelTransfersQuery
>
export type GetChannelTransfersLazyQueryHookResult = ReturnType<
  typeof useGetChannelTransfersLazyQuery
>
export type GetChannelTransfersQueryResult = ApolloReactCommon.QueryResult<
  GetChannelTransfersQuery,
  GetChannelTransfersQueryVariables
>
export const GetChannelTransferDocument = gql`
  query GetChannelTransfer($id: String!) {
    channelTransfer(id: $id) {
      id
      transferId
      type
      sourceChannel
      targetChannel
      gatewayCode
      requestedAmount
      requestedCurrency
      sourceAmount
      sourceCurrency
      targetAmount
      targetCurrency
      feeAmount
      feeCurrency
      providerRef
      txHash
      destinationAddress
      destinationMemo
      status
      errorCode
      errorMessage
      createdBy
      completedBy
      memo
      metadata
      requestedAt
      processedAt
      succeededAt
      completedAt
      failedAt
      createdAt
      updatedAt
    }
  }
`
export function useGetChannelTransferQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetChannelTransferQuery,
    GetChannelTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetChannelTransferQuery,
    GetChannelTransferQueryVariables
  >(GetChannelTransferDocument, options)
}
export function useGetChannelTransferLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetChannelTransferQuery,
    GetChannelTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetChannelTransferQuery,
    GetChannelTransferQueryVariables
  >(GetChannelTransferDocument, options)
}
export type GetChannelTransferQueryHookResult = ReturnType<
  typeof useGetChannelTransferQuery
>
export type GetChannelTransferLazyQueryHookResult = ReturnType<
  typeof useGetChannelTransferLazyQuery
>
export type GetChannelTransferQueryResult = ApolloReactCommon.QueryResult<
  GetChannelTransferQuery,
  GetChannelTransferQueryVariables
>
export const GetChannelBalanceDocument = gql`
  query GetChannelBalance($channelCode: String!) {
    channelBalance(channelCode: $channelCode) {
      channelCode
      channelLabel
      balances {
        currency
        availableBalance
        frozenBalance
        totalBalance
      }
    }
  }
`
export function useGetChannelBalanceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetChannelBalanceQuery,
    GetChannelBalanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetChannelBalanceQuery,
    GetChannelBalanceQueryVariables
  >(GetChannelBalanceDocument, options)
}
export function useGetChannelBalanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetChannelBalanceQuery,
    GetChannelBalanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetChannelBalanceQuery,
    GetChannelBalanceQueryVariables
  >(GetChannelBalanceDocument, options)
}
export type GetChannelBalanceQueryHookResult = ReturnType<
  typeof useGetChannelBalanceQuery
>
export type GetChannelBalanceLazyQueryHookResult = ReturnType<
  typeof useGetChannelBalanceLazyQuery
>
export type GetChannelBalanceQueryResult = ApolloReactCommon.QueryResult<
  GetChannelBalanceQuery,
  GetChannelBalanceQueryVariables
>
export const ConvertAmountDocument = gql`
  query ConvertAmount(
    $amount: Float!
    $fromCurrencyId: Int!
    $toCurrencyId: Int!
    $useWithdrawalRate: Boolean
  ) {
    convertAmount(
      amount: $amount
      fromCurrencyId: $fromCurrencyId
      toCurrencyId: $toCurrencyId
      useWithdrawalRate: $useWithdrawalRate
    )
  }
`
export function useConvertAmountQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ConvertAmountQuery,
    ConvertAmountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ConvertAmountQuery,
    ConvertAmountQueryVariables
  >(ConvertAmountDocument, options)
}
export function useConvertAmountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ConvertAmountQuery,
    ConvertAmountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ConvertAmountQuery,
    ConvertAmountQueryVariables
  >(ConvertAmountDocument, options)
}
export type ConvertAmountQueryHookResult = ReturnType<
  typeof useConvertAmountQuery
>
export type ConvertAmountLazyQueryHookResult = ReturnType<
  typeof useConvertAmountLazyQuery
>
export type ConvertAmountQueryResult = ApolloReactCommon.QueryResult<
  ConvertAmountQuery,
  ConvertAmountQueryVariables
>
export const GetCryptoRefundFeesDocument = gql`
  query GetCryptoRefundFees(
    $page: Int!
    $limit: Int!
    $filter: CryptoRefundFeeFilterInput
  ) {
    cryptoRefundFees(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        payableCurrencyId
        currencyId
        feeType
        feeAmount
        minFee
        maxFee
        isActive
        description
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetCryptoRefundFeesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCryptoRefundFeesQuery,
    GetCryptoRefundFeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetCryptoRefundFeesQuery,
    GetCryptoRefundFeesQueryVariables
  >(GetCryptoRefundFeesDocument, options)
}
export function useGetCryptoRefundFeesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCryptoRefundFeesQuery,
    GetCryptoRefundFeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetCryptoRefundFeesQuery,
    GetCryptoRefundFeesQueryVariables
  >(GetCryptoRefundFeesDocument, options)
}
export type GetCryptoRefundFeesQueryHookResult = ReturnType<
  typeof useGetCryptoRefundFeesQuery
>
export type GetCryptoRefundFeesLazyQueryHookResult = ReturnType<
  typeof useGetCryptoRefundFeesLazyQuery
>
export type GetCryptoRefundFeesQueryResult = ApolloReactCommon.QueryResult<
  GetCryptoRefundFeesQuery,
  GetCryptoRefundFeesQueryVariables
>
export const GetCryptoRefundFeeDocument = gql`
  query GetCryptoRefundFee($id: Int!) {
    cryptoRefundFee(id: $id) {
      id
      payableCurrencyId
      currencyId
      feeType
      feeAmount
      minFee
      maxFee
      isActive
      description
      createdAt
      updatedAt
    }
  }
`
export function useGetCryptoRefundFeeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCryptoRefundFeeQuery,
    GetCryptoRefundFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetCryptoRefundFeeQuery,
    GetCryptoRefundFeeQueryVariables
  >(GetCryptoRefundFeeDocument, options)
}
export function useGetCryptoRefundFeeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCryptoRefundFeeQuery,
    GetCryptoRefundFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetCryptoRefundFeeQuery,
    GetCryptoRefundFeeQueryVariables
  >(GetCryptoRefundFeeDocument, options)
}
export type GetCryptoRefundFeeQueryHookResult = ReturnType<
  typeof useGetCryptoRefundFeeQuery
>
export type GetCryptoRefundFeeLazyQueryHookResult = ReturnType<
  typeof useGetCryptoRefundFeeLazyQuery
>
export type GetCryptoRefundFeeQueryResult = ApolloReactCommon.QueryResult<
  GetCryptoRefundFeeQuery,
  GetCryptoRefundFeeQueryVariables
>
export const GetCurrenciesDocument = gql`
  query GetCurrencies($filter: CurrencyFilterInput, $page: Int, $limit: Int) {
    currencies(filter: $filter, page: $page, limit: $limit) {
      items {
        id
        code
        name
        symbol
        decimals
        baseToken
        network
        tokenType
        minAmlScreeningAmount
        isActive
        isSettleable
        isWithdrawable
        isExchangeRateEnabled
        createdAt
        updatedAt
      }
      totalCount
      totalPages
      page
      hasNext
      hasPrev
    }
  }
`
export function useGetCurrenciesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetCurrenciesQuery,
    GetCurrenciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetCurrenciesQuery,
    GetCurrenciesQueryVariables
  >(GetCurrenciesDocument, options)
}
export function useGetCurrenciesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCurrenciesQuery,
    GetCurrenciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetCurrenciesQuery,
    GetCurrenciesQueryVariables
  >(GetCurrenciesDocument, options)
}
export type GetCurrenciesQueryHookResult = ReturnType<
  typeof useGetCurrenciesQuery
>
export type GetCurrenciesLazyQueryHookResult = ReturnType<
  typeof useGetCurrenciesLazyQuery
>
export type GetCurrenciesQueryResult = ApolloReactCommon.QueryResult<
  GetCurrenciesQuery,
  GetCurrenciesQueryVariables
>
export const GetCurrencyDocument = gql`
  query GetCurrency($id: Int!) {
    currency(id: $id) {
      id
      code
      name
      symbol
      decimals
      baseToken
      network
      tokenType
      minAmlScreeningAmount
      isActive
      isSettleable
      isWithdrawable
      isExchangeRateEnabled
      createdAt
      updatedAt
    }
  }
`
export function useGetCurrencyQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCurrencyQuery,
    GetCurrencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(
    GetCurrencyDocument,
    options
  )
}
export function useGetCurrencyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCurrencyQuery,
    GetCurrencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetCurrencyQuery,
    GetCurrencyQueryVariables
  >(GetCurrencyDocument, options)
}
export type GetCurrencyQueryHookResult = ReturnType<typeof useGetCurrencyQuery>
export type GetCurrencyLazyQueryHookResult = ReturnType<
  typeof useGetCurrencyLazyQuery
>
export type GetCurrencyQueryResult = ApolloReactCommon.QueryResult<
  GetCurrencyQuery,
  GetCurrencyQueryVariables
>
export const CreateCurrencyDocument = gql`
  mutation CreateCurrency($input: CreateCurrencyInput!) {
    createCurrency(input: $input) {
      id
      code
      name
      symbol
      decimals
      baseToken
      network
      tokenType
      minAmlScreeningAmount
      isActive
      isSettleable
      isWithdrawable
      isExchangeRateEnabled
      createdAt
      updatedAt
    }
  }
`
export function useCreateCurrencyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateCurrencyMutation,
    CreateCurrencyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateCurrencyMutation,
    CreateCurrencyMutationVariables
  >(CreateCurrencyDocument, options)
}
export type CreateCurrencyMutationHookResult = ReturnType<
  typeof useCreateCurrencyMutation
>
export type CreateCurrencyMutationResult =
  ApolloReactCommon.MutationResult<CreateCurrencyMutation>
export const UpdateCurrencyDocument = gql`
  mutation UpdateCurrency($input: UpdateCurrencyInput!) {
    updateCurrency(input: $input) {
      id
      code
      name
      symbol
      decimals
      baseToken
      network
      tokenType
      minAmlScreeningAmount
      isActive
      isSettleable
      isWithdrawable
      isExchangeRateEnabled
      createdAt
      updatedAt
    }
  }
`
export function useUpdateCurrencyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateCurrencyMutation,
    UpdateCurrencyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateCurrencyMutation,
    UpdateCurrencyMutationVariables
  >(UpdateCurrencyDocument, options)
}
export type UpdateCurrencyMutationHookResult = ReturnType<
  typeof useUpdateCurrencyMutation
>
export type UpdateCurrencyMutationResult =
  ApolloReactCommon.MutationResult<UpdateCurrencyMutation>
export const DeleteCurrencyDocument = gql`
  mutation DeleteCurrency($id: Int!) {
    deleteCurrency(id: $id)
  }
`
export function useDeleteCurrencyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteCurrencyMutation,
    DeleteCurrencyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteCurrencyMutation,
    DeleteCurrencyMutationVariables
  >(DeleteCurrencyDocument, options)
}
export type DeleteCurrencyMutationHookResult = ReturnType<
  typeof useDeleteCurrencyMutation
>
export type DeleteCurrencyMutationResult =
  ApolloReactCommon.MutationResult<DeleteCurrencyMutation>
export const DashboardSummaryDocument = gql`
  query DashboardSummary($input: GetDashboardSummaryInput!) {
    dashboardSummary(input: $input) {
      paymentStats {
        paymentCount
        paymentSuccessCount
        paymentFailedCount
        paymentPendingCount
        paymentTotalAmount
        paymentSuccessAmount
        paymentAvgAmount
        paymentSuccessRate
      }
      cancellationStats {
        cancellationCount
        cancellationSuccessCount
        cancellationTotalAmount
        cancellationFullCount
        cancellationPartialCount
        cancellationAutoCount
        cancellationRate
        autoRefundOverpayment
        autoRefundExpired
        autoRefundUnderpaid
        autoRefundTimeout
      }
      hourlyBreakdown {
        hour
        count
        successCount
        successAmount
      }
      cryptoBreakdown {
        crypto
        count
        amount
        avgAmount
      }
      networkBreakdown {
        network
        count
        amount
      }
      cryptoNetworkBreakdown {
        crypto
        network
        count
        amount
        avgAmount
      }
    }
  }
`
export function useDashboardSummaryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    DashboardSummaryQuery,
    DashboardSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    DashboardSummaryQuery,
    DashboardSummaryQueryVariables
  >(DashboardSummaryDocument, options)
}
export function useDashboardSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DashboardSummaryQuery,
    DashboardSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    DashboardSummaryQuery,
    DashboardSummaryQueryVariables
  >(DashboardSummaryDocument, options)
}
export type DashboardSummaryQueryHookResult = ReturnType<
  typeof useDashboardSummaryQuery
>
export type DashboardSummaryLazyQueryHookResult = ReturnType<
  typeof useDashboardSummaryLazyQuery
>
export type DashboardSummaryQueryResult = ApolloReactCommon.QueryResult<
  DashboardSummaryQuery,
  DashboardSummaryQueryVariables
>
export const DailyTransactionSummariesDocument = gql`
  query DailyTransactionSummaries($input: GetDailyTransactionSummaryInput!) {
    dailyTransactionSummaries(input: $input) {
      id
      merchantId
      aggregationDate
      currency
      paymentStats {
        paymentCount
        paymentSuccessCount
        paymentFailedCount
        paymentPendingCount
        paymentTotalAmount
        paymentSuccessAmount
        paymentAvgAmount
        paymentSuccessRate
      }
      cancellationStats {
        cancellationCount
        cancellationSuccessCount
        cancellationTotalAmount
        cancellationFullCount
        cancellationPartialCount
        cancellationAutoCount
        cancellationRate
        autoRefundOverpayment
        autoRefundExpired
        autoRefundUnderpaid
        autoRefundTimeout
      }
      aggregatedAt
      createdAt
      updatedAt
    }
  }
`
export function useDailyTransactionSummariesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    DailyTransactionSummariesQuery,
    DailyTransactionSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    DailyTransactionSummariesQuery,
    DailyTransactionSummariesQueryVariables
  >(DailyTransactionSummariesDocument, options)
}
export function useDailyTransactionSummariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DailyTransactionSummariesQuery,
    DailyTransactionSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    DailyTransactionSummariesQuery,
    DailyTransactionSummariesQueryVariables
  >(DailyTransactionSummariesDocument, options)
}
export type DailyTransactionSummariesQueryHookResult = ReturnType<
  typeof useDailyTransactionSummariesQuery
>
export type DailyTransactionSummariesLazyQueryHookResult = ReturnType<
  typeof useDailyTransactionSummariesLazyQuery
>
export type DailyTransactionSummariesQueryResult =
  ApolloReactCommon.QueryResult<
    DailyTransactionSummariesQuery,
    DailyTransactionSummariesQueryVariables
  >
export const ActiveCurrenciesDocument = gql`
  query ActiveCurrencies {
    activeCurrencies {
      id
      code
      name
      symbol
      decimals
      isActive
      tokenType
    }
  }
`
export function useActiveCurrenciesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ActiveCurrenciesQuery,
    ActiveCurrenciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ActiveCurrenciesQuery,
    ActiveCurrenciesQueryVariables
  >(ActiveCurrenciesDocument, options)
}
export function useActiveCurrenciesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ActiveCurrenciesQuery,
    ActiveCurrenciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ActiveCurrenciesQuery,
    ActiveCurrenciesQueryVariables
  >(ActiveCurrenciesDocument, options)
}
export type ActiveCurrenciesQueryHookResult = ReturnType<
  typeof useActiveCurrenciesQuery
>
export type ActiveCurrenciesLazyQueryHookResult = ReturnType<
  typeof useActiveCurrenciesLazyQuery
>
export type ActiveCurrenciesQueryResult = ApolloReactCommon.QueryResult<
  ActiveCurrenciesQuery,
  ActiveCurrenciesQueryVariables
>
export const HourlyTransactionSummariesDocument = gql`
  query HourlyTransactionSummaries(
    $page: Int = 1
    $limit: Int = 100
    $input: GetHourlyTransactionSummaryInput!
  ) {
    hourlyTransactionSummaries(page: $page, limit: $limit, input: $input) {
      items {
        id
        merchantId
        aggregationHour
        currency
        paymentCount
        paymentSuccessCount
        paymentFailedCount
        paymentPendingCount
        paymentSuccessAmount
        paymentAvgAmount
        cancellationCount
        cancellationAmount
        cancellationFullCount
        cancellationPartialCount
        autoRefundOverpayment
        autoRefundExpired
        autoRefundUnderpaid
        autoRefundTimeout
        cryptoBreakdown
        networkBreakdown
        cryptoNetworkBreakdown
        aggregatedAt
        isReconciled
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useHourlyTransactionSummariesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    HourlyTransactionSummariesQuery,
    HourlyTransactionSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    HourlyTransactionSummariesQuery,
    HourlyTransactionSummariesQueryVariables
  >(HourlyTransactionSummariesDocument, options)
}
export function useHourlyTransactionSummariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    HourlyTransactionSummariesQuery,
    HourlyTransactionSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    HourlyTransactionSummariesQuery,
    HourlyTransactionSummariesQueryVariables
  >(HourlyTransactionSummariesDocument, options)
}
export type HourlyTransactionSummariesQueryHookResult = ReturnType<
  typeof useHourlyTransactionSummariesQuery
>
export type HourlyTransactionSummariesLazyQueryHookResult = ReturnType<
  typeof useHourlyTransactionSummariesLazyQuery
>
export type HourlyTransactionSummariesQueryResult =
  ApolloReactCommon.QueryResult<
    HourlyTransactionSummariesQuery,
    HourlyTransactionSummariesQueryVariables
  >
export const DownloadDailySummaryExcelDocument = gql`
  mutation DownloadDailySummaryExcel($input: GetDailyTransactionSummaryInput!) {
    downloadDailySummaryExcel(input: $input) {
      downloadUrl
      recordCount
      message
    }
  }
`
export function useDownloadDailySummaryExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadDailySummaryExcelMutation,
    DownloadDailySummaryExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadDailySummaryExcelMutation,
    DownloadDailySummaryExcelMutationVariables
  >(DownloadDailySummaryExcelDocument, options)
}
export type DownloadDailySummaryExcelMutationHookResult = ReturnType<
  typeof useDownloadDailySummaryExcelMutation
>
export type DownloadDailySummaryExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadDailySummaryExcelMutation>
export const MerchantStatisticsDocument = gql`
  query MerchantStatistics($input: GetMerchantStatisticsInput!) {
    merchantStatistics(input: $input) {
      items {
        id
        merchantId
        merchantName
        aggregationDate
        currency
        paymentStats {
          paymentCount
          paymentSuccessCount
          paymentFailedCount
          paymentPendingCount
          paymentTotalAmount
          paymentSuccessAmount
          paymentAvgAmount
          paymentSuccessRate
        }
        cancellationStats {
          cancellationCount
          cancellationSuccessCount
          cancellationTotalAmount
          cancellationFullCount
          cancellationPartialCount
          cancellationAutoCount
          cancellationRate
          autoRefundOverpayment
          autoRefundExpired
          autoRefundUnderpaid
          autoRefundTimeout
        }
        aggregatedAt
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
    }
  }
`
export function useMerchantStatisticsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MerchantStatisticsQuery,
    MerchantStatisticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MerchantStatisticsQuery,
    MerchantStatisticsQueryVariables
  >(MerchantStatisticsDocument, options)
}
export function useMerchantStatisticsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MerchantStatisticsQuery,
    MerchantStatisticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MerchantStatisticsQuery,
    MerchantStatisticsQueryVariables
  >(MerchantStatisticsDocument, options)
}
export type MerchantStatisticsQueryHookResult = ReturnType<
  typeof useMerchantStatisticsQuery
>
export type MerchantStatisticsLazyQueryHookResult = ReturnType<
  typeof useMerchantStatisticsLazyQuery
>
export type MerchantStatisticsQueryResult = ApolloReactCommon.QueryResult<
  MerchantStatisticsQuery,
  MerchantStatisticsQueryVariables
>
export const DownloadMerchantStatisticsExcelDocument = gql`
  mutation DownloadMerchantStatisticsExcel(
    $input: GetMerchantStatisticsInput!
  ) {
    downloadMerchantStatisticsExcel(input: $input) {
      downloadUrl
      recordCount
      message
    }
  }
`
export function useDownloadMerchantStatisticsExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadMerchantStatisticsExcelMutation,
    DownloadMerchantStatisticsExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadMerchantStatisticsExcelMutation,
    DownloadMerchantStatisticsExcelMutationVariables
  >(DownloadMerchantStatisticsExcelDocument, options)
}
export type DownloadMerchantStatisticsExcelMutationHookResult = ReturnType<
  typeof useDownloadMerchantStatisticsExcelMutation
>
export type DownloadMerchantStatisticsExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadMerchantStatisticsExcelMutation>
export const MerchantPayoutStatisticsDocument = gql`
  query MerchantPayoutStatistics($input: GetMerchantPayoutStatisticsInput!) {
    merchantPayoutStatistics(input: $input) {
      items {
        id
        merchantId
        merchantName
        aggregationDate
        currency
        payoutStats {
          payoutCount
          payoutSuccessCount
          payoutFailedCount
          payoutSuccessAmount
          payoutAvgAmount
          payoutSuccessRate
          payoutFeeAmount
          payoutChannelFeeAmount
        }
        aggregatedAt
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useMerchantPayoutStatisticsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MerchantPayoutStatisticsQuery,
    MerchantPayoutStatisticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MerchantPayoutStatisticsQuery,
    MerchantPayoutStatisticsQueryVariables
  >(MerchantPayoutStatisticsDocument, options)
}
export function useMerchantPayoutStatisticsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MerchantPayoutStatisticsQuery,
    MerchantPayoutStatisticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MerchantPayoutStatisticsQuery,
    MerchantPayoutStatisticsQueryVariables
  >(MerchantPayoutStatisticsDocument, options)
}
export type MerchantPayoutStatisticsQueryHookResult = ReturnType<
  typeof useMerchantPayoutStatisticsQuery
>
export type MerchantPayoutStatisticsLazyQueryHookResult = ReturnType<
  typeof useMerchantPayoutStatisticsLazyQuery
>
export type MerchantPayoutStatisticsQueryResult = ApolloReactCommon.QueryResult<
  MerchantPayoutStatisticsQuery,
  MerchantPayoutStatisticsQueryVariables
>
export const DownloadMerchantPayoutStatisticsExcelDocument = gql`
  mutation DownloadMerchantPayoutStatisticsExcel(
    $input: GetMerchantPayoutStatisticsInput!
  ) {
    downloadMerchantPayoutStatisticsExcel(input: $input) {
      downloadUrl
      recordCount
      message
    }
  }
`
export function useDownloadMerchantPayoutStatisticsExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadMerchantPayoutStatisticsExcelMutation,
    DownloadMerchantPayoutStatisticsExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadMerchantPayoutStatisticsExcelMutation,
    DownloadMerchantPayoutStatisticsExcelMutationVariables
  >(DownloadMerchantPayoutStatisticsExcelDocument, options)
}
export type DownloadMerchantPayoutStatisticsExcelMutationHookResult =
  ReturnType<typeof useDownloadMerchantPayoutStatisticsExcelMutation>
export type DownloadMerchantPayoutStatisticsExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadMerchantPayoutStatisticsExcelMutation>
export const PayoutSummaryDocument = gql`
  query PayoutSummary($input: GetPayoutSummaryInput!) {
    payoutSummary(input: $input) {
      payoutStats {
        payoutCount
        payoutSuccessCount
        payoutFailedCount
        payoutSuccessAmount
        payoutAvgAmount
        payoutSuccessRate
        payoutFeeAmount
        payoutChannelFeeAmount
      }
      hourlyBreakdown {
        hour
        count
        successCount
        successAmount
      }
      tokenBreakdown {
        token
        count
        amount
        avgAmount
      }
      networkBreakdown {
        network
        count
        amount
      }
      tokenNetworkBreakdown {
        token
        network
        count
        amount
        avgAmount
      }
      channelBreakdown {
        channel
        count
        successCount
        amount
        feeAmount
        channelFeeAmount
      }
    }
  }
`
export function usePayoutSummaryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PayoutSummaryQuery,
    PayoutSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PayoutSummaryQuery,
    PayoutSummaryQueryVariables
  >(PayoutSummaryDocument, options)
}
export function usePayoutSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PayoutSummaryQuery,
    PayoutSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PayoutSummaryQuery,
    PayoutSummaryQueryVariables
  >(PayoutSummaryDocument, options)
}
export type PayoutSummaryQueryHookResult = ReturnType<
  typeof usePayoutSummaryQuery
>
export type PayoutSummaryLazyQueryHookResult = ReturnType<
  typeof usePayoutSummaryLazyQuery
>
export type PayoutSummaryQueryResult = ApolloReactCommon.QueryResult<
  PayoutSummaryQuery,
  PayoutSummaryQueryVariables
>
export const HourlyPayoutSummariesDocument = gql`
  query HourlyPayoutSummaries(
    $input: GetHourlyPayoutSummaryInput!
    $page: Int
    $limit: Int
  ) {
    hourlyPayoutSummaries(input: $input, page: $page, limit: $limit) {
      items {
        id
        merchantId
        aggregationHour
        currency
        payoutCount
        payoutSuccessCount
        payoutFailedCount
        payoutSuccessAmount
        payoutAvgAmount
        payoutFeeAmount
        payoutChannelFeeAmount
        tokenBreakdown
        networkBreakdown
        tokenNetworkBreakdown
        channelBreakdown
        aggregatedAt
        isReconciled
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useHourlyPayoutSummariesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    HourlyPayoutSummariesQuery,
    HourlyPayoutSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    HourlyPayoutSummariesQuery,
    HourlyPayoutSummariesQueryVariables
  >(HourlyPayoutSummariesDocument, options)
}
export function useHourlyPayoutSummariesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    HourlyPayoutSummariesQuery,
    HourlyPayoutSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    HourlyPayoutSummariesQuery,
    HourlyPayoutSummariesQueryVariables
  >(HourlyPayoutSummariesDocument, options)
}
export type HourlyPayoutSummariesQueryHookResult = ReturnType<
  typeof useHourlyPayoutSummariesQuery
>
export type HourlyPayoutSummariesLazyQueryHookResult = ReturnType<
  typeof useHourlyPayoutSummariesLazyQuery
>
export type HourlyPayoutSummariesQueryResult = ApolloReactCommon.QueryResult<
  HourlyPayoutSummariesQuery,
  HourlyPayoutSummariesQueryVariables
>
export const GetDispatchReconciliationItemsDocument = gql`
  query GetDispatchReconciliationItems(
    $page: Int!
    $limit: Int!
    $filter: DispatchReconciliationFilterInput
  ) {
    dispatchReconciliationItems(page: $page, limit: $limit, filter: $filter) {
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
      items {
        kind
        recordId
        paymentId
        merchantId
        merchantName
        amount
        currency
        status
        state
        reason
        since
        providerReference
      }
    }
  }
`
export function useGetDispatchReconciliationItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetDispatchReconciliationItemsQuery,
    GetDispatchReconciliationItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetDispatchReconciliationItemsQuery,
    GetDispatchReconciliationItemsQueryVariables
  >(GetDispatchReconciliationItemsDocument, options)
}
export function useGetDispatchReconciliationItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDispatchReconciliationItemsQuery,
    GetDispatchReconciliationItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetDispatchReconciliationItemsQuery,
    GetDispatchReconciliationItemsQueryVariables
  >(GetDispatchReconciliationItemsDocument, options)
}
export type GetDispatchReconciliationItemsQueryHookResult = ReturnType<
  typeof useGetDispatchReconciliationItemsQuery
>
export type GetDispatchReconciliationItemsLazyQueryHookResult = ReturnType<
  typeof useGetDispatchReconciliationItemsLazyQuery
>
export type GetDispatchReconciliationItemsQueryResult =
  ApolloReactCommon.QueryResult<
    GetDispatchReconciliationItemsQuery,
    GetDispatchReconciliationItemsQueryVariables
  >
export const GetExceptionalTransfersDocument = gql`
  query GetExceptionalTransfers(
    $page: Int!
    $limit: Int!
    $filter: ExceptionalTransferFilterInput
  ) {
    exceptionalTransfers(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        pgTransactionId
        blockchainTxHash
        eventType
        receivedTokenId
        receivedAmount
        fromAddress
        toAddress
        topupAddressId
        expectedTokenId
        merchantId
        status
        resolutionNote
        resolvedById
        resolvedAt
        detectedAt
        createdAt
        updatedAt
        merchantName
        merchantNo
        topupAddressChain
        resolvedByName
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetExceptionalTransfersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetExceptionalTransfersQuery,
    GetExceptionalTransfersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetExceptionalTransfersQuery,
    GetExceptionalTransfersQueryVariables
  >(GetExceptionalTransfersDocument, options)
}
export function useGetExceptionalTransfersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetExceptionalTransfersQuery,
    GetExceptionalTransfersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetExceptionalTransfersQuery,
    GetExceptionalTransfersQueryVariables
  >(GetExceptionalTransfersDocument, options)
}
export type GetExceptionalTransfersQueryHookResult = ReturnType<
  typeof useGetExceptionalTransfersQuery
>
export type GetExceptionalTransfersLazyQueryHookResult = ReturnType<
  typeof useGetExceptionalTransfersLazyQuery
>
export type GetExceptionalTransfersQueryResult = ApolloReactCommon.QueryResult<
  GetExceptionalTransfersQuery,
  GetExceptionalTransfersQueryVariables
>
export const GetExceptionalTransferDocument = gql`
  query GetExceptionalTransfer($id: Int!) {
    exceptionalTransfer(id: $id) {
      id
      pgTransactionId
      blockchainTxHash
      eventType
      receivedTokenId
      receivedAmount
      fromAddress
      toAddress
      topupAddressId
      expectedTokenId
      merchantId
      status
      resolutionNote
      resolvedById
      resolvedAt
      rawWebhookData
      detectedAt
      createdAt
      updatedAt
      merchantName
      merchantNo
      topupAddressChain
      resolvedByName
    }
  }
`
export function useGetExceptionalTransferQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetExceptionalTransferQuery,
    GetExceptionalTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetExceptionalTransferQuery,
    GetExceptionalTransferQueryVariables
  >(GetExceptionalTransferDocument, options)
}
export function useGetExceptionalTransferLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetExceptionalTransferQuery,
    GetExceptionalTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetExceptionalTransferQuery,
    GetExceptionalTransferQueryVariables
  >(GetExceptionalTransferDocument, options)
}
export type GetExceptionalTransferQueryHookResult = ReturnType<
  typeof useGetExceptionalTransferQuery
>
export type GetExceptionalTransferLazyQueryHookResult = ReturnType<
  typeof useGetExceptionalTransferLazyQuery
>
export type GetExceptionalTransferQueryResult = ApolloReactCommon.QueryResult<
  GetExceptionalTransferQuery,
  GetExceptionalTransferQueryVariables
>
export const UpdateExceptionalTransferStatusDocument = gql`
  mutation UpdateExceptionalTransferStatus(
    $input: UpdateExceptionalTransferStatusInput!
  ) {
    updateExceptionalTransferStatus(input: $input) {
      id
      status
      resolutionNote
      resolvedById
      resolvedAt
      resolvedByName
    }
  }
`
export function useUpdateExceptionalTransferStatusMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateExceptionalTransferStatusMutation,
    UpdateExceptionalTransferStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateExceptionalTransferStatusMutation,
    UpdateExceptionalTransferStatusMutationVariables
  >(UpdateExceptionalTransferStatusDocument, options)
}
export type UpdateExceptionalTransferStatusMutationHookResult = ReturnType<
  typeof useUpdateExceptionalTransferStatusMutation
>
export type UpdateExceptionalTransferStatusMutationResult =
  ApolloReactCommon.MutationResult<UpdateExceptionalTransferStatusMutation>
export const GetExchangeRatesDocument = gql`
  query GetExchangeRates(
    $filter: ExchangeRateFilterInput
    $page: Int
    $limit: Int
  ) {
    exchangeRates(filter: $filter, page: $page, limit: $limit) {
      items {
        id
        currencyPair
        rate
        depositRate
        paymentRate
        withdrawalRate
        depositMargin
        paymentMargin
        withdrawalMargin
        source
        isActive
        isCurrentlyValid
        validFrom
        validTo
        fromCurrency {
          id
          code
          name
          symbol
        }
        toCurrency {
          id
          code
          name
          symbol
        }
        createdAt
        updatedAt
      }
      totalCount
      totalPages
      page
      hasNext
      hasPrev
    }
  }
`
export function useGetExchangeRatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetExchangeRatesQuery,
    GetExchangeRatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetExchangeRatesQuery,
    GetExchangeRatesQueryVariables
  >(GetExchangeRatesDocument, options)
}
export function useGetExchangeRatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetExchangeRatesQuery,
    GetExchangeRatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetExchangeRatesQuery,
    GetExchangeRatesQueryVariables
  >(GetExchangeRatesDocument, options)
}
export type GetExchangeRatesQueryHookResult = ReturnType<
  typeof useGetExchangeRatesQuery
>
export type GetExchangeRatesLazyQueryHookResult = ReturnType<
  typeof useGetExchangeRatesLazyQuery
>
export type GetExchangeRatesQueryResult = ApolloReactCommon.QueryResult<
  GetExchangeRatesQuery,
  GetExchangeRatesQueryVariables
>
export const GetExchangeRateDocument = gql`
  query GetExchangeRate($id: Int!) {
    exchangeRate(id: $id) {
      id
      currencyPair
      rate
      depositRate
      paymentRate
      withdrawalRate
      depositMargin
      paymentMargin
      withdrawalMargin
      source
      isActive
      isCurrentlyValid
      validFrom
      validTo
      fromCurrency {
        id
        code
        name
        symbol
      }
      toCurrency {
        id
        code
        name
        symbol
      }
      createdAt
      updatedAt
    }
  }
`
export function useGetExchangeRateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetExchangeRateQuery,
    GetExchangeRateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetExchangeRateQuery,
    GetExchangeRateQueryVariables
  >(GetExchangeRateDocument, options)
}
export function useGetExchangeRateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetExchangeRateQuery,
    GetExchangeRateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetExchangeRateQuery,
    GetExchangeRateQueryVariables
  >(GetExchangeRateDocument, options)
}
export type GetExchangeRateQueryHookResult = ReturnType<
  typeof useGetExchangeRateQuery
>
export type GetExchangeRateLazyQueryHookResult = ReturnType<
  typeof useGetExchangeRateLazyQuery
>
export type GetExchangeRateQueryResult = ApolloReactCommon.QueryResult<
  GetExchangeRateQuery,
  GetExchangeRateQueryVariables
>
export const GetCurrenciesForExchangeDocument = gql`
  query GetCurrenciesForExchange {
    currencies {
      items {
        id
        code
        name
        symbol
        isActive
        tokenType
        isExchangeRateEnabled
      }
    }
  }
`
export function useGetCurrenciesForExchangeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetCurrenciesForExchangeQuery,
    GetCurrenciesForExchangeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetCurrenciesForExchangeQuery,
    GetCurrenciesForExchangeQueryVariables
  >(GetCurrenciesForExchangeDocument, options)
}
export function useGetCurrenciesForExchangeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCurrenciesForExchangeQuery,
    GetCurrenciesForExchangeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetCurrenciesForExchangeQuery,
    GetCurrenciesForExchangeQueryVariables
  >(GetCurrenciesForExchangeDocument, options)
}
export type GetCurrenciesForExchangeQueryHookResult = ReturnType<
  typeof useGetCurrenciesForExchangeQuery
>
export type GetCurrenciesForExchangeLazyQueryHookResult = ReturnType<
  typeof useGetCurrenciesForExchangeLazyQuery
>
export type GetCurrenciesForExchangeQueryResult = ApolloReactCommon.QueryResult<
  GetCurrenciesForExchangeQuery,
  GetCurrenciesForExchangeQueryVariables
>
export const CreateExchangeRateDocument = gql`
  mutation CreateExchangeRate($input: CreateExchangeRateInput!) {
    createExchangeRate(input: $input) {
      id
      currencyPair
      rate
      depositRate
      paymentRate
      withdrawalRate
      depositMargin
      paymentMargin
      withdrawalMargin
      source
      isActive
      validFrom
      validTo
      createdAt
      updatedAt
    }
  }
`
export function useCreateExchangeRateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateExchangeRateMutation,
    CreateExchangeRateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateExchangeRateMutation,
    CreateExchangeRateMutationVariables
  >(CreateExchangeRateDocument, options)
}
export type CreateExchangeRateMutationHookResult = ReturnType<
  typeof useCreateExchangeRateMutation
>
export type CreateExchangeRateMutationResult =
  ApolloReactCommon.MutationResult<CreateExchangeRateMutation>
export const UpdateExchangeRateDocument = gql`
  mutation UpdateExchangeRate($input: UpdateExchangeRateInput!) {
    updateExchangeRate(input: $input) {
      id
      currencyPair
      rate
      depositRate
      paymentRate
      withdrawalRate
      depositMargin
      paymentMargin
      withdrawalMargin
      source
      isActive
      validFrom
      validTo
      createdAt
      updatedAt
    }
  }
`
export function useUpdateExchangeRateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateExchangeRateMutation,
    UpdateExchangeRateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateExchangeRateMutation,
    UpdateExchangeRateMutationVariables
  >(UpdateExchangeRateDocument, options)
}
export type UpdateExchangeRateMutationHookResult = ReturnType<
  typeof useUpdateExchangeRateMutation
>
export type UpdateExchangeRateMutationResult =
  ApolloReactCommon.MutationResult<UpdateExchangeRateMutation>
export const DeleteExchangeRateDocument = gql`
  mutation DeleteExchangeRate($id: Int!) {
    deleteExchangeRate(id: $id)
  }
`
export function useDeleteExchangeRateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteExchangeRateMutation,
    DeleteExchangeRateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteExchangeRateMutation,
    DeleteExchangeRateMutationVariables
  >(DeleteExchangeRateDocument, options)
}
export type DeleteExchangeRateMutationHookResult = ReturnType<
  typeof useDeleteExchangeRateMutation
>
export type DeleteExchangeRateMutationResult =
  ApolloReactCommon.MutationResult<DeleteExchangeRateMutation>
export const ActivateExchangeRateDocument = gql`
  mutation ActivateExchangeRate($input: ActivateExchangeRateInput!) {
    activateExchangeRate(input: $input) {
      id
      isActive
    }
  }
`
export function useActivateExchangeRateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ActivateExchangeRateMutation,
    ActivateExchangeRateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ActivateExchangeRateMutation,
    ActivateExchangeRateMutationVariables
  >(ActivateExchangeRateDocument, options)
}
export type ActivateExchangeRateMutationHookResult = ReturnType<
  typeof useActivateExchangeRateMutation
>
export type ActivateExchangeRateMutationResult =
  ApolloReactCommon.MutationResult<ActivateExchangeRateMutation>
export const FeeSettingListDocument = gql`
  query feeSettingList(
    $page: Int!
    $limit: Int!
    $merchantId: Int
    $bizType: FeeBusinessType
  ) {
    feeSettingList(
      page: $page
      limit: $limit
      merchantId: $merchantId
      bizType: $bizType
    ) {
      items {
        id
        bizType
        merchantId
        currency
        feeRate
        fixedFee
        minFee
        maxFee
        metadata
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useFeeSettingListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FeeSettingListQuery,
    FeeSettingListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    FeeSettingListQuery,
    FeeSettingListQueryVariables
  >(FeeSettingListDocument, options)
}
export function useFeeSettingListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FeeSettingListQuery,
    FeeSettingListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FeeSettingListQuery,
    FeeSettingListQueryVariables
  >(FeeSettingListDocument, options)
}
export type FeeSettingListQueryHookResult = ReturnType<
  typeof useFeeSettingListQuery
>
export type FeeSettingListLazyQueryHookResult = ReturnType<
  typeof useFeeSettingListLazyQuery
>
export type FeeSettingListQueryResult = ApolloReactCommon.QueryResult<
  FeeSettingListQuery,
  FeeSettingListQueryVariables
>
export const FeeSettingDocument = gql`
  query feeSetting($input: FeeSettingInput!) {
    feeSetting(input: $input) {
      id
      bizType
      merchantId
      currency
      feeRate
      fixedFee
      minFee
      maxFee
      metadata
    }
  }
`
export function useFeeSettingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FeeSettingQuery,
    FeeSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<FeeSettingQuery, FeeSettingQueryVariables>(
    FeeSettingDocument,
    options
  )
}
export function useFeeSettingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FeeSettingQuery,
    FeeSettingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    FeeSettingQuery,
    FeeSettingQueryVariables
  >(FeeSettingDocument, options)
}
export type FeeSettingQueryHookResult = ReturnType<typeof useFeeSettingQuery>
export type FeeSettingLazyQueryHookResult = ReturnType<
  typeof useFeeSettingLazyQuery
>
export type FeeSettingQueryResult = ApolloReactCommon.QueryResult<
  FeeSettingQuery,
  FeeSettingQueryVariables
>
export const GetFileDocument = gql`
  query GetFile($fileId: Int!) {
    file(fileId: $fileId) {
      id
      fileName
      size
      mimeType
      uploadedAt
      signedUrl
      description
    }
  }
`
export function useGetFileQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetFileQuery,
    GetFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetFileQuery, GetFileQueryVariables>(
    GetFileDocument,
    options
  )
}
export function useGetFileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFileQuery,
    GetFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetFileQuery, GetFileQueryVariables>(
    GetFileDocument,
    options
  )
}
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>
export type GetFileQueryResult = ApolloReactCommon.QueryResult<
  GetFileQuery,
  GetFileQueryVariables
>
export const GetFilesDocument = gql`
  query GetFiles($fileIds: [Int!]!) {
    files(fileIds: $fileIds) {
      id
      fileName
      size
      mimeType
      uploadedAt
      signedUrl
      description
    }
  }
`
export function useGetFilesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetFilesQuery,
    GetFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetFilesQuery, GetFilesQueryVariables>(
    GetFilesDocument,
    options
  )
}
export function useGetFilesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFilesQuery,
    GetFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(
    GetFilesDocument,
    options
  )
}
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>
export type GetFilesLazyQueryHookResult = ReturnType<
  typeof useGetFilesLazyQuery
>
export type GetFilesQueryResult = ApolloReactCommon.QueryResult<
  GetFilesQuery,
  GetFilesQueryVariables
>
export const GetAccountingChannelsDocument = gql`
  query GetAccountingChannels {
    accountingChannels {
      code
      label
    }
  }
`
export function useGetAccountingChannelsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAccountingChannelsQuery,
    GetAccountingChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAccountingChannelsQuery,
    GetAccountingChannelsQueryVariables
  >(GetAccountingChannelsDocument, options)
}
export function useGetAccountingChannelsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAccountingChannelsQuery,
    GetAccountingChannelsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAccountingChannelsQuery,
    GetAccountingChannelsQueryVariables
  >(GetAccountingChannelsDocument, options)
}
export type GetAccountingChannelsQueryHookResult = ReturnType<
  typeof useGetAccountingChannelsQuery
>
export type GetAccountingChannelsLazyQueryHookResult = ReturnType<
  typeof useGetAccountingChannelsLazyQuery
>
export type GetAccountingChannelsQueryResult = ApolloReactCommon.QueryResult<
  GetAccountingChannelsQuery,
  GetAccountingChannelsQueryVariables
>
export const InternalAccountEntryListDocument = gql`
  query internalAccountEntryList(
    $page: Int!
    $limit: Int!
    $filter: InternalAccountEntryListInput
  ) {
    internalAccountEntryList(page: $page, limit: $limit, filter: $filter) {
      items {
        entryNo
        voucherNo
        bizOrderNo
        bizType
        bizStep
        accountNo
        accountType
        amount
        dcFlag
        currency
        createdAt
        remark
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useInternalAccountEntryListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    InternalAccountEntryListQuery,
    InternalAccountEntryListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InternalAccountEntryListQuery,
    InternalAccountEntryListQueryVariables
  >(InternalAccountEntryListDocument, options)
}
export function useInternalAccountEntryListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InternalAccountEntryListQuery,
    InternalAccountEntryListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InternalAccountEntryListQuery,
    InternalAccountEntryListQueryVariables
  >(InternalAccountEntryListDocument, options)
}
export type InternalAccountEntryListQueryHookResult = ReturnType<
  typeof useInternalAccountEntryListQuery
>
export type InternalAccountEntryListLazyQueryHookResult = ReturnType<
  typeof useInternalAccountEntryListLazyQuery
>
export type InternalAccountEntryListQueryResult = ApolloReactCommon.QueryResult<
  InternalAccountEntryListQuery,
  InternalAccountEntryListQueryVariables
>
export const GetManualRefundApprovalDocument = gql`
  query GetManualRefundApproval($id: String!) {
    manualRefundApproval(id: $id) {
      id
      paymentId
      refundAmount
      reason
      currency
      requestedAt
      requestedBy
      status
      reviewedAt
      reviewedBy
      reviewNote
      walletAddress
      autoRefundJobId
      createdAt
      updatedAt
      refundLinkId
      refundLink {
        id
        status
        source
        customerEmail
        emailSent
        emailSentAt
        expiresAt
        walletAddress
        submittedAt
        completedAt
      }
      payment {
        id
        paymentKey
        amount
        currency
        status
        merchantOrderId
        customerEmail
        merchant {
          id
          name
          mid
        }
      }
    }
  }
`
export function useGetManualRefundApprovalQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetManualRefundApprovalQuery,
    GetManualRefundApprovalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetManualRefundApprovalQuery,
    GetManualRefundApprovalQueryVariables
  >(GetManualRefundApprovalDocument, options)
}
export function useGetManualRefundApprovalLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetManualRefundApprovalQuery,
    GetManualRefundApprovalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetManualRefundApprovalQuery,
    GetManualRefundApprovalQueryVariables
  >(GetManualRefundApprovalDocument, options)
}
export type GetManualRefundApprovalQueryHookResult = ReturnType<
  typeof useGetManualRefundApprovalQuery
>
export type GetManualRefundApprovalLazyQueryHookResult = ReturnType<
  typeof useGetManualRefundApprovalLazyQuery
>
export type GetManualRefundApprovalQueryResult = ApolloReactCommon.QueryResult<
  GetManualRefundApprovalQuery,
  GetManualRefundApprovalQueryVariables
>
export const GetManualRefundApprovalsDocument = gql`
  query GetManualRefundApprovals(
    $page: Int!
    $limit: Int!
    $filter: ManualRefundApprovalFilterInput
  ) {
    manualRefundApprovals(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        paymentId
        refundAmount
        reason
        currency
        requestedAt
        requestedBy
        status
        reviewedAt
        reviewedBy
        reviewNote
        walletAddress
        autoRefundJobId
        createdAt
        updatedAt
        refundLinkId
        refundLink {
          id
          status
          source
          customerEmail
          emailSent
          emailSentAt
          expiresAt
          walletAddress
          submittedAt
          completedAt
        }
        payment {
          id
          paymentKey
          amount
          currency
          status
          merchantOrderId
          customerEmail
          merchant {
            id
            name
            mid
          }
        }
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetManualRefundApprovalsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetManualRefundApprovalsQuery,
    GetManualRefundApprovalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetManualRefundApprovalsQuery,
    GetManualRefundApprovalsQueryVariables
  >(GetManualRefundApprovalsDocument, options)
}
export function useGetManualRefundApprovalsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetManualRefundApprovalsQuery,
    GetManualRefundApprovalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetManualRefundApprovalsQuery,
    GetManualRefundApprovalsQueryVariables
  >(GetManualRefundApprovalsDocument, options)
}
export type GetManualRefundApprovalsQueryHookResult = ReturnType<
  typeof useGetManualRefundApprovalsQuery
>
export type GetManualRefundApprovalsLazyQueryHookResult = ReturnType<
  typeof useGetManualRefundApprovalsLazyQuery
>
export type GetManualRefundApprovalsQueryResult = ApolloReactCommon.QueryResult<
  GetManualRefundApprovalsQuery,
  GetManualRefundApprovalsQueryVariables
>
export const ApproveManualRefundDocument = gql`
  mutation ApproveManualRefund($input: ApproveManualRefundInput!) {
    approveManualRefund(input: $input) {
      id
      status
      reviewedAt
      reviewedBy
      reviewNote
      walletAddress
    }
  }
`
export function useApproveManualRefundMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ApproveManualRefundMutation,
    ApproveManualRefundMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ApproveManualRefundMutation,
    ApproveManualRefundMutationVariables
  >(ApproveManualRefundDocument, options)
}
export type ApproveManualRefundMutationHookResult = ReturnType<
  typeof useApproveManualRefundMutation
>
export type ApproveManualRefundMutationResult =
  ApolloReactCommon.MutationResult<ApproveManualRefundMutation>
export const RejectManualRefundDocument = gql`
  mutation RejectManualRefund($input: RejectManualRefundInput!) {
    rejectManualRefund(input: $input) {
      id
      status
      reviewedAt
      reviewedBy
      reviewNote
    }
  }
`
export function useRejectManualRefundMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RejectManualRefundMutation,
    RejectManualRefundMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RejectManualRefundMutation,
    RejectManualRefundMutationVariables
  >(RejectManualRefundDocument, options)
}
export type RejectManualRefundMutationHookResult = ReturnType<
  typeof useRejectManualRefundMutation
>
export type RejectManualRefundMutationResult =
  ApolloReactCommon.MutationResult<RejectManualRefundMutation>
export const ResendRefundEmailDocument = gql`
  mutation ResendRefundEmail($approvalId: String!) {
    resendRefundEmail(approvalId: $approvalId) {
      id
      refundLinkId
      refundLink {
        id
        status
        source
        customerEmail
        emailSent
        emailSentAt
        expiresAt
      }
    }
  }
`
export function useResendRefundEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResendRefundEmailMutation,
    ResendRefundEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResendRefundEmailMutation,
    ResendRefundEmailMutationVariables
  >(ResendRefundEmailDocument, options)
}
export type ResendRefundEmailMutationHookResult = ReturnType<
  typeof useResendRefundEmailMutation
>
export type ResendRefundEmailMutationResult =
  ApolloReactCommon.MutationResult<ResendRefundEmailMutation>
export const GetUserMenusDocument = gql`
  query GetUserMenus {
    userMenus {
      id
      code
      name
      path
      icon
      component
      menuType
      sortOrder
      isVisible
      isPublic
      target
      description
      excludeRoles
      parentId
      permissions {
        canView
        canCreate
        canEdit
        canDelete
        canExport
      }
      children {
        id
        code
        name
        path
        icon
        component
        menuType
        sortOrder
        isVisible
        isPublic
        target
        description
        excludeRoles
        parentId
      }
    }
  }
`
export function useGetUserMenusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserMenusQuery,
    GetUserMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetUserMenusQuery,
    GetUserMenusQueryVariables
  >(GetUserMenusDocument, options)
}
export function useGetUserMenusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserMenusQuery,
    GetUserMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetUserMenusQuery,
    GetUserMenusQueryVariables
  >(GetUserMenusDocument, options)
}
export type GetUserMenusQueryHookResult = ReturnType<
  typeof useGetUserMenusQuery
>
export type GetUserMenusLazyQueryHookResult = ReturnType<
  typeof useGetUserMenusLazyQuery
>
export type GetUserMenusQueryResult = ApolloReactCommon.QueryResult<
  GetUserMenusQuery,
  GetUserMenusQueryVariables
>
export const GetAllMenusDocument = gql`
  query GetAllMenus($filter: MenuFilterInput) {
    allMenus(filter: $filter) {
      id
      code
      name
      description
      parentId
      path
      icon
      component
      sortOrder
      isVisible
      isPublic
      excludeRoles
      menuType
      target
      children {
        id
        code
        name
        description
        parentId
        path
        icon
        component
        sortOrder
        isVisible
        isPublic
        excludeRoles
        menuType
        target
        children {
          id
          code
          name
          path
          icon
          sortOrder
          isVisible
          parentId
        }
      }
    }
  }
`
export function useGetAllMenusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllMenusQuery,
    GetAllMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetAllMenusQuery, GetAllMenusQueryVariables>(
    GetAllMenusDocument,
    options
  )
}
export function useGetAllMenusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllMenusQuery,
    GetAllMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAllMenusQuery,
    GetAllMenusQueryVariables
  >(GetAllMenusDocument, options)
}
export type GetAllMenusQueryHookResult = ReturnType<typeof useGetAllMenusQuery>
export type GetAllMenusLazyQueryHookResult = ReturnType<
  typeof useGetAllMenusLazyQuery
>
export type GetAllMenusQueryResult = ApolloReactCommon.QueryResult<
  GetAllMenusQuery,
  GetAllMenusQueryVariables
>
export const GetMenuDetailDocument = gql`
  query GetMenuDetail($id: Int!) {
    menu(id: $id) {
      id
      code
      name
      description
      parentId
      path
      icon
      component
      sortOrder
      isVisible
      isPublic
      excludeRoles
      menuType
      target
    }
  }
`
export function useGetMenuDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetMenuDetailQuery,
    GetMenuDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMenuDetailQuery,
    GetMenuDetailQueryVariables
  >(GetMenuDetailDocument, options)
}
export function useGetMenuDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMenuDetailQuery,
    GetMenuDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMenuDetailQuery,
    GetMenuDetailQueryVariables
  >(GetMenuDetailDocument, options)
}
export type GetMenuDetailQueryHookResult = ReturnType<
  typeof useGetMenuDetailQuery
>
export type GetMenuDetailLazyQueryHookResult = ReturnType<
  typeof useGetMenuDetailLazyQuery
>
export type GetMenuDetailQueryResult = ApolloReactCommon.QueryResult<
  GetMenuDetailQuery,
  GetMenuDetailQueryVariables
>
export const GetUserMenusForManagementDocument = gql`
  query GetUserMenusForManagement {
    userMenus {
      id
      code
      name
      description
      parentId
      path
      icon
      component
      sortOrder
      isVisible
      isPublic
      excludeRoles
      menuType
      target
      permissions {
        canView
        canCreate
        canEdit
        canDelete
        canExport
      }
      children {
        id
        code
        name
        description
        parentId
        path
        icon
        component
        sortOrder
        isVisible
        isPublic
        excludeRoles
        menuType
        target
        permissions {
          canView
          canCreate
          canEdit
          canDelete
          canExport
        }
        children {
          id
          code
          name
          path
          icon
          sortOrder
          isVisible
          parentId
          permissions {
            canView
            canCreate
            canEdit
            canDelete
            canExport
          }
        }
      }
    }
  }
`
export function useGetUserMenusForManagementQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserMenusForManagementQuery,
    GetUserMenusForManagementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetUserMenusForManagementQuery,
    GetUserMenusForManagementQueryVariables
  >(GetUserMenusForManagementDocument, options)
}
export function useGetUserMenusForManagementLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserMenusForManagementQuery,
    GetUserMenusForManagementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetUserMenusForManagementQuery,
    GetUserMenusForManagementQueryVariables
  >(GetUserMenusForManagementDocument, options)
}
export type GetUserMenusForManagementQueryHookResult = ReturnType<
  typeof useGetUserMenusForManagementQuery
>
export type GetUserMenusForManagementLazyQueryHookResult = ReturnType<
  typeof useGetUserMenusForManagementLazyQuery
>
export type GetUserMenusForManagementQueryResult =
  ApolloReactCommon.QueryResult<
    GetUserMenusForManagementQuery,
    GetUserMenusForManagementQueryVariables
  >
export const GetMerchantDocument = gql`
  query GetMerchant($id: Float) {
    merchant(id: $id) {
      id
      mid
      name
      email
      status
      type
      riskLevel
      exceptionHandlingMode
      businessName
      businessNumber
      businessAddress
      businessPhoneCountryCode
      businessPhoneNumber
      businessCategory
      representativeName
      merchantBackground
      additionalInfo
      relevantCompany
      companyName
      countryCode
      employeeCount
      registeredDate
      taxNumber
      websiteUrl
      bankName
      bankBranch
      bankAddress
      settlementArea
      swiftCode
      signerName
      signerBirthDate
      signerIdType
      signerIdNumber
      signerIdDocument
      signerIdValidFrom
      signerIdValidTo
      signerResidentialAddress
      signerResidentialCountry
      createdAt
      updatedAt
      merchantDocuments {
        id
        description
        expiresAt
        fileUploadId
        isVerified
        verifiedAt
        createdAt
        updatedAt
        fileUpload {
          id
          fileName
          fileSize
          mimeType
          signedUrl
          description
        }
      }
      merchantAdminUser {
        id
        email
        name
        phoneCountryCode
        phoneNumber
        lastLoginAt
        createdAt
        updatedAt
      }
    }
  }
`
export function useGetMerchantQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMerchantQuery,
    GetMerchantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetMerchantQuery, GetMerchantQueryVariables>(
    GetMerchantDocument,
    options
  )
}
export function useGetMerchantLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantQuery,
    GetMerchantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantQuery,
    GetMerchantQueryVariables
  >(GetMerchantDocument, options)
}
export type GetMerchantQueryHookResult = ReturnType<typeof useGetMerchantQuery>
export type GetMerchantLazyQueryHookResult = ReturnType<
  typeof useGetMerchantLazyQuery
>
export type GetMerchantQueryResult = ApolloReactCommon.QueryResult<
  GetMerchantQuery,
  GetMerchantQueryVariables
>
export const MerchantAccountSummaryDocument = gql`
  query merchantAccountSummary($merchantId: Int!) {
    merchantAccountSummary(merchantId: $merchantId) {
      summary {
        currency
        balanceAmount
        pendingSettlementAmount
        frozenAmount
        frozenDetails {
          type
          amount
        }
      }
      details {
        currency
        balanceAmount
        pendingSettlementAmount
        frozenAmount
        frozenDetails {
          type
          amount
        }
      }
    }
  }
`
export function useMerchantAccountSummaryQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MerchantAccountSummaryQuery,
    MerchantAccountSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MerchantAccountSummaryQuery,
    MerchantAccountSummaryQueryVariables
  >(MerchantAccountSummaryDocument, options)
}
export function useMerchantAccountSummaryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MerchantAccountSummaryQuery,
    MerchantAccountSummaryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MerchantAccountSummaryQuery,
    MerchantAccountSummaryQueryVariables
  >(MerchantAccountSummaryDocument, options)
}
export type MerchantAccountSummaryQueryHookResult = ReturnType<
  typeof useMerchantAccountSummaryQuery
>
export type MerchantAccountSummaryLazyQueryHookResult = ReturnType<
  typeof useMerchantAccountSummaryLazyQuery
>
export type MerchantAccountSummaryQueryResult = ApolloReactCommon.QueryResult<
  MerchantAccountSummaryQuery,
  MerchantAccountSummaryQueryVariables
>
export const MerchantAccountEntryListDocument = gql`
  query merchantAccountEntryList(
    $page: Int!
    $limit: Int!
    $merchantId: Int!
    $filter: MerchantAccountEntryListInput
  ) {
    merchantAccountEntryList(
      page: $page
      limit: $limit
      merchantId: $merchantId
      filter: $filter
    ) {
      items {
        entryNo
        voucherNo
        bizOrderNo
        bizType
        bizStep
        accountNo
        accountType
        amount
        balance
        currency
        remark
        createdAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useMerchantAccountEntryListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MerchantAccountEntryListQuery,
    MerchantAccountEntryListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MerchantAccountEntryListQuery,
    MerchantAccountEntryListQueryVariables
  >(MerchantAccountEntryListDocument, options)
}
export function useMerchantAccountEntryListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MerchantAccountEntryListQuery,
    MerchantAccountEntryListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MerchantAccountEntryListQuery,
    MerchantAccountEntryListQueryVariables
  >(MerchantAccountEntryListDocument, options)
}
export type MerchantAccountEntryListQueryHookResult = ReturnType<
  typeof useMerchantAccountEntryListQuery
>
export type MerchantAccountEntryListLazyQueryHookResult = ReturnType<
  typeof useMerchantAccountEntryListLazyQuery
>
export type MerchantAccountEntryListQueryResult = ApolloReactCommon.QueryResult<
  MerchantAccountEntryListQuery,
  MerchantAccountEntryListQueryVariables
>
export const MerchantAccountAvailableBalanceDocument = gql`
  query merchantAccountAvailableBalance($merchantId: Int!, $currency: String!) {
    merchantAccountAvailableBalance(
      merchantId: $merchantId
      currency: $currency
    )
  }
`
export function useMerchantAccountAvailableBalanceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MerchantAccountAvailableBalanceQuery,
    MerchantAccountAvailableBalanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MerchantAccountAvailableBalanceQuery,
    MerchantAccountAvailableBalanceQueryVariables
  >(MerchantAccountAvailableBalanceDocument, options)
}
export function useMerchantAccountAvailableBalanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MerchantAccountAvailableBalanceQuery,
    MerchantAccountAvailableBalanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MerchantAccountAvailableBalanceQuery,
    MerchantAccountAvailableBalanceQueryVariables
  >(MerchantAccountAvailableBalanceDocument, options)
}
export type MerchantAccountAvailableBalanceQueryHookResult = ReturnType<
  typeof useMerchantAccountAvailableBalanceQuery
>
export type MerchantAccountAvailableBalanceLazyQueryHookResult = ReturnType<
  typeof useMerchantAccountAvailableBalanceLazyQuery
>
export type MerchantAccountAvailableBalanceQueryResult =
  ApolloReactCommon.QueryResult<
    MerchantAccountAvailableBalanceQuery,
    MerchantAccountAvailableBalanceQueryVariables
  >
export const DownloadMerchantAccountEntryExcelDocument = gql`
  mutation downloadMerchantAccountEntryExcel(
    $merchantId: Int
    $filter: MerchantAccountEntryListInput
  ) {
    downloadMerchantAccountEntryExcel(
      merchantId: $merchantId
      filter: $filter
    ) {
      downloadUrl
      jobId
      recordCount
      processType
      message
    }
  }
`
export function useDownloadMerchantAccountEntryExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadMerchantAccountEntryExcelMutation,
    DownloadMerchantAccountEntryExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadMerchantAccountEntryExcelMutation,
    DownloadMerchantAccountEntryExcelMutationVariables
  >(DownloadMerchantAccountEntryExcelDocument, options)
}
export type DownloadMerchantAccountEntryExcelMutationHookResult = ReturnType<
  typeof useDownloadMerchantAccountEntryExcelMutation
>
export type DownloadMerchantAccountEntryExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadMerchantAccountEntryExcelMutation>
export const GetMerchantCryptoRefundFeesDocument = gql`
  query GetMerchantCryptoRefundFees(
    $merchantId: Int!
    $page: Int!
    $limit: Int!
  ) {
    merchantCryptoRefundFees(
      merchantId: $merchantId
      page: $page
      limit: $limit
    ) {
      items {
        id
        merchantId
        payableCurrencyId
        currencyId
        feeType
        feeAmount
        minFee
        maxFee
        isActive
        description
        createdAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetMerchantCryptoRefundFeesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetMerchantCryptoRefundFeesQuery,
    GetMerchantCryptoRefundFeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantCryptoRefundFeesQuery,
    GetMerchantCryptoRefundFeesQueryVariables
  >(GetMerchantCryptoRefundFeesDocument, options)
}
export function useGetMerchantCryptoRefundFeesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantCryptoRefundFeesQuery,
    GetMerchantCryptoRefundFeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantCryptoRefundFeesQuery,
    GetMerchantCryptoRefundFeesQueryVariables
  >(GetMerchantCryptoRefundFeesDocument, options)
}
export type GetMerchantCryptoRefundFeesQueryHookResult = ReturnType<
  typeof useGetMerchantCryptoRefundFeesQuery
>
export type GetMerchantCryptoRefundFeesLazyQueryHookResult = ReturnType<
  typeof useGetMerchantCryptoRefundFeesLazyQuery
>
export type GetMerchantCryptoRefundFeesQueryResult =
  ApolloReactCommon.QueryResult<
    GetMerchantCryptoRefundFeesQuery,
    GetMerchantCryptoRefundFeesQueryVariables
  >
export const GetMerchantCryptoRefundFeeDocument = gql`
  query GetMerchantCryptoRefundFee($id: Int!) {
    merchantCryptoRefundFee(id: $id) {
      id
      merchantId
      payableCurrencyId
      currencyId
      feeType
      feeAmount
      minFee
      maxFee
      isActive
      description
      createdAt
    }
  }
`
export function useGetMerchantCryptoRefundFeeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetMerchantCryptoRefundFeeQuery,
    GetMerchantCryptoRefundFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantCryptoRefundFeeQuery,
    GetMerchantCryptoRefundFeeQueryVariables
  >(GetMerchantCryptoRefundFeeDocument, options)
}
export function useGetMerchantCryptoRefundFeeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantCryptoRefundFeeQuery,
    GetMerchantCryptoRefundFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantCryptoRefundFeeQuery,
    GetMerchantCryptoRefundFeeQueryVariables
  >(GetMerchantCryptoRefundFeeDocument, options)
}
export type GetMerchantCryptoRefundFeeQueryHookResult = ReturnType<
  typeof useGetMerchantCryptoRefundFeeQuery
>
export type GetMerchantCryptoRefundFeeLazyQueryHookResult = ReturnType<
  typeof useGetMerchantCryptoRefundFeeLazyQuery
>
export type GetMerchantCryptoRefundFeeQueryResult =
  ApolloReactCommon.QueryResult<
    GetMerchantCryptoRefundFeeQuery,
    GetMerchantCryptoRefundFeeQueryVariables
  >
export const GetMerchantExchangeMarginsDocument = gql`
  query GetMerchantExchangeMargins(
    $filter: MerchantExchangeMarginFilterInput
    $page: Int
    $limit: Int
  ) {
    merchantExchangeMargins(filter: $filter, page: $page, limit: $limit) {
      items {
        id
        merchantId
        fromCurrencyId
        toCurrencyId
        fromCurrency {
          id
          code
          name
          symbol
        }
        toCurrency {
          id
          code
          name
          symbol
        }
        paymentMarginRate
        depositMarginRate
        withdrawalMarginRate
        effectivePaymentMargin
        effectiveDepositMargin
        effectiveWithdrawalMargin
        isActive
        createdAt
        updatedAt
      }
      totalCount
      totalPages
      page
      hasNext
      hasPrev
    }
  }
`
export function useGetMerchantExchangeMarginsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMerchantExchangeMarginsQuery,
    GetMerchantExchangeMarginsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantExchangeMarginsQuery,
    GetMerchantExchangeMarginsQueryVariables
  >(GetMerchantExchangeMarginsDocument, options)
}
export function useGetMerchantExchangeMarginsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantExchangeMarginsQuery,
    GetMerchantExchangeMarginsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantExchangeMarginsQuery,
    GetMerchantExchangeMarginsQueryVariables
  >(GetMerchantExchangeMarginsDocument, options)
}
export type GetMerchantExchangeMarginsQueryHookResult = ReturnType<
  typeof useGetMerchantExchangeMarginsQuery
>
export type GetMerchantExchangeMarginsLazyQueryHookResult = ReturnType<
  typeof useGetMerchantExchangeMarginsLazyQuery
>
export type GetMerchantExchangeMarginsQueryResult =
  ApolloReactCommon.QueryResult<
    GetMerchantExchangeMarginsQuery,
    GetMerchantExchangeMarginsQueryVariables
  >
export const GetMerchantExchangeMarginDocument = gql`
  query GetMerchantExchangeMargin($id: Int!) {
    merchantExchangeMargin(id: $id) {
      id
      merchantId
      fromCurrencyId
      toCurrencyId
      fromCurrency {
        id
        code
        name
        symbol
      }
      toCurrency {
        id
        code
        name
        symbol
      }
      paymentMarginRate
      depositMarginRate
      withdrawalMarginRate
      effectivePaymentMargin
      effectiveDepositMargin
      effectiveWithdrawalMargin
      isActive
      createdAt
      updatedAt
    }
  }
`
export function useGetMerchantExchangeMarginQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetMerchantExchangeMarginQuery,
    GetMerchantExchangeMarginQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetMerchantExchangeMarginQuery,
    GetMerchantExchangeMarginQueryVariables
  >(GetMerchantExchangeMarginDocument, options)
}
export function useGetMerchantExchangeMarginLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMerchantExchangeMarginQuery,
    GetMerchantExchangeMarginQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetMerchantExchangeMarginQuery,
    GetMerchantExchangeMarginQueryVariables
  >(GetMerchantExchangeMarginDocument, options)
}
export type GetMerchantExchangeMarginQueryHookResult = ReturnType<
  typeof useGetMerchantExchangeMarginQuery
>
export type GetMerchantExchangeMarginLazyQueryHookResult = ReturnType<
  typeof useGetMerchantExchangeMarginLazyQuery
>
export type GetMerchantExchangeMarginQueryResult =
  ApolloReactCommon.QueryResult<
    GetMerchantExchangeMarginQuery,
    GetMerchantExchangeMarginQueryVariables
  >
export const CreateMerchantExchangeMarginDocument = gql`
  mutation CreateMerchantExchangeMargin(
    $input: CreateMerchantExchangeMarginInput!
  ) {
    createMerchantExchangeMargin(input: $input) {
      id
      merchantId
      fromCurrencyId
      toCurrencyId
      fromCurrency {
        id
        code
        name
      }
      toCurrency {
        id
        code
        name
      }
      paymentMarginRate
      depositMarginRate
      withdrawalMarginRate
      isActive
      createdAt
      updatedAt
    }
  }
`
export function useCreateMerchantExchangeMarginMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMerchantExchangeMarginMutation,
    CreateMerchantExchangeMarginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateMerchantExchangeMarginMutation,
    CreateMerchantExchangeMarginMutationVariables
  >(CreateMerchantExchangeMarginDocument, options)
}
export type CreateMerchantExchangeMarginMutationHookResult = ReturnType<
  typeof useCreateMerchantExchangeMarginMutation
>
export type CreateMerchantExchangeMarginMutationResult =
  ApolloReactCommon.MutationResult<CreateMerchantExchangeMarginMutation>
export const UpdateMerchantExchangeMarginDocument = gql`
  mutation UpdateMerchantExchangeMargin(
    $id: Int!
    $input: UpdateMerchantExchangeMarginInput!
  ) {
    updateMerchantExchangeMargin(id: $id, input: $input) {
      id
      merchantId
      fromCurrencyId
      toCurrencyId
      fromCurrency {
        id
        code
        name
      }
      toCurrency {
        id
        code
        name
      }
      paymentMarginRate
      depositMarginRate
      withdrawalMarginRate
      isActive
      createdAt
      updatedAt
    }
  }
`
export function useUpdateMerchantExchangeMarginMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMerchantExchangeMarginMutation,
    UpdateMerchantExchangeMarginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateMerchantExchangeMarginMutation,
    UpdateMerchantExchangeMarginMutationVariables
  >(UpdateMerchantExchangeMarginDocument, options)
}
export type UpdateMerchantExchangeMarginMutationHookResult = ReturnType<
  typeof useUpdateMerchantExchangeMarginMutation
>
export type UpdateMerchantExchangeMarginMutationResult =
  ApolloReactCommon.MutationResult<UpdateMerchantExchangeMarginMutation>
export const DeleteMerchantExchangeMarginDocument = gql`
  mutation DeleteMerchantExchangeMargin($id: Int!) {
    deleteMerchantExchangeMargin(id: $id)
  }
`
export function useDeleteMerchantExchangeMarginMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteMerchantExchangeMarginMutation,
    DeleteMerchantExchangeMarginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeleteMerchantExchangeMarginMutation,
    DeleteMerchantExchangeMarginMutationVariables
  >(DeleteMerchantExchangeMarginDocument, options)
}
export type DeleteMerchantExchangeMarginMutationHookResult = ReturnType<
  typeof useDeleteMerchantExchangeMarginMutation
>
export type DeleteMerchantExchangeMarginMutationResult =
  ApolloReactCommon.MutationResult<DeleteMerchantExchangeMarginMutation>
export const GetFilteredMerchantsDocument = gql`
  query GetFilteredMerchants(
    $page: Int
    $limit: Int
    $filter: MerchantFilterInput
  ) {
    merchants(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        name
        email
        mid
        status
        type
        businessNumber
        businessName
        representativeName
        businessPhoneCountryCode
        businessPhoneNumber
        createdAt
        riskLevel
      }
      totalCount
      page
      totalPages
      hasNext
      hasPrev
      limit
    }
  }
`
export function useGetFilteredMerchantsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetFilteredMerchantsQuery,
    GetFilteredMerchantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetFilteredMerchantsQuery,
    GetFilteredMerchantsQueryVariables
  >(GetFilteredMerchantsDocument, options)
}
export function useGetFilteredMerchantsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFilteredMerchantsQuery,
    GetFilteredMerchantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetFilteredMerchantsQuery,
    GetFilteredMerchantsQueryVariables
  >(GetFilteredMerchantsDocument, options)
}
export type GetFilteredMerchantsQueryHookResult = ReturnType<
  typeof useGetFilteredMerchantsQuery
>
export type GetFilteredMerchantsLazyQueryHookResult = ReturnType<
  typeof useGetFilteredMerchantsLazyQuery
>
export type GetFilteredMerchantsQueryResult = ApolloReactCommon.QueryResult<
  GetFilteredMerchantsQuery,
  GetFilteredMerchantsQueryVariables
>
export const IsAddressVerifiedDocument = gql`
  query isAddressVerified($input: AddressVerifiedInput!) {
    isAddressVerified(input: $input)
  }
`
export function useIsAddressVerifiedQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    IsAddressVerifiedQuery,
    IsAddressVerifiedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    IsAddressVerifiedQuery,
    IsAddressVerifiedQueryVariables
  >(IsAddressVerifiedDocument, options)
}
export function useIsAddressVerifiedLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    IsAddressVerifiedQuery,
    IsAddressVerifiedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    IsAddressVerifiedQuery,
    IsAddressVerifiedQueryVariables
  >(IsAddressVerifiedDocument, options)
}
export type IsAddressVerifiedQueryHookResult = ReturnType<
  typeof useIsAddressVerifiedQuery
>
export type IsAddressVerifiedLazyQueryHookResult = ReturnType<
  typeof useIsAddressVerifiedLazyQuery
>
export type IsAddressVerifiedQueryResult = ApolloReactCommon.QueryResult<
  IsAddressVerifiedQuery,
  IsAddressVerifiedQueryVariables
>
export const MicroTransferDocument = gql`
  query microTransfer($id: ID!) {
    microTransfer(id: $id) {
      id
      currency
      network
      address
      feeAmount
      status
      attempts
      expiresAt
      createdAt
    }
  }
`
export function useMicroTransferQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MicroTransferQuery,
    MicroTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MicroTransferQuery,
    MicroTransferQueryVariables
  >(MicroTransferDocument, options)
}
export function useMicroTransferLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MicroTransferQuery,
    MicroTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MicroTransferQuery,
    MicroTransferQueryVariables
  >(MicroTransferDocument, options)
}
export type MicroTransferQueryHookResult = ReturnType<
  typeof useMicroTransferQuery
>
export type MicroTransferLazyQueryHookResult = ReturnType<
  typeof useMicroTransferLazyQuery
>
export type MicroTransferQueryResult = ApolloReactCommon.QueryResult<
  MicroTransferQuery,
  MicroTransferQueryVariables
>
export const ActiveMicroTransferDocument = gql`
  query activeMicroTransfer($input: ActiveMicroTransferInput!) {
    activeMicroTransfer(input: $input) {
      id
      currency
      network
      address
      feeAmount
      status
      attempts
      expiresAt
      createdAt
    }
  }
`
export function useActiveMicroTransferQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ActiveMicroTransferQuery,
    ActiveMicroTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ActiveMicroTransferQuery,
    ActiveMicroTransferQueryVariables
  >(ActiveMicroTransferDocument, options)
}
export function useActiveMicroTransferLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ActiveMicroTransferQuery,
    ActiveMicroTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ActiveMicroTransferQuery,
    ActiveMicroTransferQueryVariables
  >(ActiveMicroTransferDocument, options)
}
export type ActiveMicroTransferQueryHookResult = ReturnType<
  typeof useActiveMicroTransferQuery
>
export type ActiveMicroTransferLazyQueryHookResult = ReturnType<
  typeof useActiveMicroTransferLazyQuery
>
export type ActiveMicroTransferQueryResult = ApolloReactCommon.QueryResult<
  ActiveMicroTransferQuery,
  ActiveMicroTransferQueryVariables
>
export const RequestMicroTransferDocument = gql`
  mutation requestMicroTransfer($input: RequestMicroTransferInput!) {
    requestMicroTransfer(input: $input) {
      id
      feeAmount
      status
      attempts
      expiresAt
    }
  }
`
export function useRequestMicroTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RequestMicroTransferMutation,
    RequestMicroTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RequestMicroTransferMutation,
    RequestMicroTransferMutationVariables
  >(RequestMicroTransferDocument, options)
}
export type RequestMicroTransferMutationHookResult = ReturnType<
  typeof useRequestMicroTransferMutation
>
export type RequestMicroTransferMutationResult =
  ApolloReactCommon.MutationResult<RequestMicroTransferMutation>
export const VerifyMicroTransferCodeDocument = gql`
  mutation verifyMicroTransferCode($input: VerifyMicroTransferCodeInput!) {
    verifyMicroTransferCode(input: $input) {
      success
      status
      remainingAttempts
    }
  }
`
export function useVerifyMicroTransferCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerifyMicroTransferCodeMutation,
    VerifyMicroTransferCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    VerifyMicroTransferCodeMutation,
    VerifyMicroTransferCodeMutationVariables
  >(VerifyMicroTransferCodeDocument, options)
}
export type VerifyMicroTransferCodeMutationHookResult = ReturnType<
  typeof useVerifyMicroTransferCodeMutation
>
export type VerifyMicroTransferCodeMutationResult =
  ApolloReactCommon.MutationResult<VerifyMicroTransferCodeMutation>
export const InProgressMicroTransfersDocument = gql`
  query inProgressMicroTransfers($merchantId: Int) {
    inProgressMicroTransfers(merchantId: $merchantId) {
      id
      currency
      network
      address
      status
      attempts
      expiresAt
      createdAt
    }
  }
`
export function useInProgressMicroTransfersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InProgressMicroTransfersQuery,
    InProgressMicroTransfersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    InProgressMicroTransfersQuery,
    InProgressMicroTransfersQueryVariables
  >(InProgressMicroTransfersDocument, options)
}
export function useInProgressMicroTransfersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InProgressMicroTransfersQuery,
    InProgressMicroTransfersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    InProgressMicroTransfersQuery,
    InProgressMicroTransfersQueryVariables
  >(InProgressMicroTransfersDocument, options)
}
export type InProgressMicroTransfersQueryHookResult = ReturnType<
  typeof useInProgressMicroTransfersQuery
>
export type InProgressMicroTransfersLazyQueryHookResult = ReturnType<
  typeof useInProgressMicroTransfersLazyQuery
>
export type InProgressMicroTransfersQueryResult = ApolloReactCommon.QueryResult<
  InProgressMicroTransfersQuery,
  InProgressMicroTransfersQueryVariables
>
export const RecheckMicroTransferDocument = gql`
  mutation recheckMicroTransfer($id: ID!) {
    recheckMicroTransfer(id: $id) {
      id
      currency
      network
      address
      status
      attempts
      expiresAt
      createdAt
    }
  }
`
export function useRecheckMicroTransferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RecheckMicroTransferMutation,
    RecheckMicroTransferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RecheckMicroTransferMutation,
    RecheckMicroTransferMutationVariables
  >(RecheckMicroTransferDocument, options)
}
export type RecheckMicroTransferMutationHookResult = ReturnType<
  typeof useRecheckMicroTransferMutation
>
export type RecheckMicroTransferMutationResult =
  ApolloReactCommon.MutationResult<RecheckMicroTransferMutation>
export const OfframpListDocument = gql`
  query offrampList(
    $page: Int!
    $limit: Int!
    $merchantId: Int
    $filter: OfframpListInput
  ) {
    offrampList(
      page: $page
      limit: $limit
      merchantId: $merchantId
      filter: $filter
    ) {
      items {
        id
        merchantId
        orderId
        channel
        channelOrderId
        originAmount
        originCurrency
        targetAmount
        targetCurrency
        channelFeeAmount
        feeAmount
        failedReason
        netAmount
        status
        createdAt
        createdBy {
          userId
          name
          email
        }
        merchant {
          id
          name
          mid
        }
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useOfframpListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    OfframpListQuery,
    OfframpListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<OfframpListQuery, OfframpListQueryVariables>(
    OfframpListDocument,
    options
  )
}
export function useOfframpListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OfframpListQuery,
    OfframpListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OfframpListQuery,
    OfframpListQueryVariables
  >(OfframpListDocument, options)
}
export type OfframpListQueryHookResult = ReturnType<typeof useOfframpListQuery>
export type OfframpListLazyQueryHookResult = ReturnType<
  typeof useOfframpListLazyQuery
>
export type OfframpListQueryResult = ApolloReactCommon.QueryResult<
  OfframpListQuery,
  OfframpListQueryVariables
>
export const OfframpDetailDocument = gql`
  query offrampDetail($orderId: String!) {
    offrampDetail(orderId: $orderId) {
      id
      merchantId
      orderId
      channel
      channelOrderId
      originAmount
      originCurrency
      targetAmount
      targetCurrency
      channelFeeAmount
      feeAmount
      failedReason
      netAmount
      status
      createdAt
      createdBy {
        userId
        name
        email
      }
      updatedAt
      completedAt
      metaData
      merchant {
        id
        name
        mid
      }
    }
  }
`
export function useOfframpDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    OfframpDetailQuery,
    OfframpDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    OfframpDetailQuery,
    OfframpDetailQueryVariables
  >(OfframpDetailDocument, options)
}
export function useOfframpDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OfframpDetailQuery,
    OfframpDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OfframpDetailQuery,
    OfframpDetailQueryVariables
  >(OfframpDetailDocument, options)
}
export type OfframpDetailQueryHookResult = ReturnType<
  typeof useOfframpDetailQuery
>
export type OfframpDetailLazyQueryHookResult = ReturnType<
  typeof useOfframpDetailLazyQuery
>
export type OfframpDetailQueryResult = ApolloReactCommon.QueryResult<
  OfframpDetailQuery,
  OfframpDetailQueryVariables
>
export const DownloadOfframpExcelDocument = gql`
  mutation DownloadOfframpExcel($filter: OfframpListInput) {
    downloadOfframpExcel(filter: $filter) {
      downloadUrl
      jobId
      message
      processType
      recordCount
    }
  }
`
export function useDownloadOfframpExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadOfframpExcelMutation,
    DownloadOfframpExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadOfframpExcelMutation,
    DownloadOfframpExcelMutationVariables
  >(DownloadOfframpExcelDocument, options)
}
export type DownloadOfframpExcelMutationHookResult = ReturnType<
  typeof useDownloadOfframpExcelMutation
>
export type DownloadOfframpExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadOfframpExcelMutation>
export const OnrampListDocument = gql`
  query onrampList(
    $page: Int!
    $limit: Int!
    $merchantId: Int
    $filter: OnrampListInput
  ) {
    onrampList(
      page: $page
      limit: $limit
      merchantId: $merchantId
      filter: $filter
    ) {
      items {
        id
        merchantId
        orderId
        channel
        channelOrderId
        originAmount
        originCurrency
        targetAmount
        targetCurrency
        channelFeeAmount
        feeAmount
        failedReason
        netAmount
        status
        createdAt
        createdBy {
          userId
          name
          email
        }
        fundingTransfer {
          status
        }
        merchant {
          id
          name
          mid
        }
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useOnrampListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    OnrampListQuery,
    OnrampListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<OnrampListQuery, OnrampListQueryVariables>(
    OnrampListDocument,
    options
  )
}
export function useOnrampListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OnrampListQuery,
    OnrampListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OnrampListQuery,
    OnrampListQueryVariables
  >(OnrampListDocument, options)
}
export type OnrampListQueryHookResult = ReturnType<typeof useOnrampListQuery>
export type OnrampListLazyQueryHookResult = ReturnType<
  typeof useOnrampListLazyQuery
>
export type OnrampListQueryResult = ApolloReactCommon.QueryResult<
  OnrampListQuery,
  OnrampListQueryVariables
>
export const OnrampDetailDocument = gql`
  query onrampDetail($orderId: String!) {
    onrampDetail(orderId: $orderId) {
      id
      merchantId
      orderId
      channel
      channelOrderId
      originAmount
      originCurrency
      targetAmount
      targetCurrency
      channelFeeAmount
      feeAmount
      failedReason
      netAmount
      status
      createdAt
      createdBy {
        userId
        name
        email
      }
      updatedAt
      completedAt
      metaData
      onrampChannel
      fundingSource
      fundingTransfer {
        id
        transferId
        sourceChannel
        targetChannel
        requestedAmount
        requestedCurrency
        targetAmount
        targetCurrency
        providerRef
        status
        errorMessage
        canSimulate
      }
      merchant {
        id
        name
        mid
      }
    }
  }
`
export function useOnrampDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    OnrampDetailQuery,
    OnrampDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    OnrampDetailQuery,
    OnrampDetailQueryVariables
  >(OnrampDetailDocument, options)
}
export function useOnrampDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OnrampDetailQuery,
    OnrampDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    OnrampDetailQuery,
    OnrampDetailQueryVariables
  >(OnrampDetailDocument, options)
}
export type OnrampDetailQueryHookResult = ReturnType<
  typeof useOnrampDetailQuery
>
export type OnrampDetailLazyQueryHookResult = ReturnType<
  typeof useOnrampDetailLazyQuery
>
export type OnrampDetailQueryResult = ApolloReactCommon.QueryResult<
  OnrampDetailQuery,
  OnrampDetailQueryVariables
>
export const DownloadOnrampExcelDocument = gql`
  mutation DownloadOnrampExcel($filter: OnrampListInput) {
    downloadOnrampExcel(filter: $filter) {
      downloadUrl
      jobId
      message
      processType
      recordCount
    }
  }
`
export function useDownloadOnrampExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadOnrampExcelMutation,
    DownloadOnrampExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadOnrampExcelMutation,
    DownloadOnrampExcelMutationVariables
  >(DownloadOnrampExcelDocument, options)
}
export type DownloadOnrampExcelMutationHookResult = ReturnType<
  typeof useDownloadOnrampExcelMutation
>
export type DownloadOnrampExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadOnrampExcelMutation>
export const GetPaymentAdjustmentsDocument = gql`
  query GetPaymentAdjustments(
    $page: Int
    $limit: Int
    $filter: PaymentAdjustmentFilterInput
  ) {
    paymentAdjustments(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        paymentId
        transactionId
        merchantId
        reason
        decision
        decisionSource
        decidedAt
        originalAmount
        originalCurrencyId
        originalCurrency
        originalPayableAmount
        originalPayableCurrencyId
        originalPayableCurrency
        actualReceivedAmount
        actualCurrencyId
        actualCurrency
        finalAmount
        finalCurrencyId
        finalCurrency
        fxRateSnapshotInit
        fxRateSnapshotFinal
        rejectReason
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetPaymentAdjustmentsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPaymentAdjustmentsQuery,
    GetPaymentAdjustmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPaymentAdjustmentsQuery,
    GetPaymentAdjustmentsQueryVariables
  >(GetPaymentAdjustmentsDocument, options)
}
export function useGetPaymentAdjustmentsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPaymentAdjustmentsQuery,
    GetPaymentAdjustmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPaymentAdjustmentsQuery,
    GetPaymentAdjustmentsQueryVariables
  >(GetPaymentAdjustmentsDocument, options)
}
export type GetPaymentAdjustmentsQueryHookResult = ReturnType<
  typeof useGetPaymentAdjustmentsQuery
>
export type GetPaymentAdjustmentsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentAdjustmentsLazyQuery
>
export type GetPaymentAdjustmentsQueryResult = ApolloReactCommon.QueryResult<
  GetPaymentAdjustmentsQuery,
  GetPaymentAdjustmentsQueryVariables
>
export const GetPaymentAdjustmentDocument = gql`
  query GetPaymentAdjustment($id: String!) {
    paymentAdjustment(id: $id) {
      id
      paymentId
      transactionId
      merchantId
      reason
      decision
      decisionSource
      decidedAt
      originalAmount
      originalCurrencyId
      originalCurrency
      actualReceivedAmount
      actualCurrencyId
      actualCurrency
      finalAmount
      finalCurrencyId
      finalCurrency
      fxRateSnapshotInit
      fxRateSnapshotFinal
      rejectReason
      createdAt
      updatedAt
    }
  }
`
export function useGetPaymentAdjustmentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPaymentAdjustmentQuery,
    GetPaymentAdjustmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPaymentAdjustmentQuery,
    GetPaymentAdjustmentQueryVariables
  >(GetPaymentAdjustmentDocument, options)
}
export function useGetPaymentAdjustmentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPaymentAdjustmentQuery,
    GetPaymentAdjustmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPaymentAdjustmentQuery,
    GetPaymentAdjustmentQueryVariables
  >(GetPaymentAdjustmentDocument, options)
}
export type GetPaymentAdjustmentQueryHookResult = ReturnType<
  typeof useGetPaymentAdjustmentQuery
>
export type GetPaymentAdjustmentLazyQueryHookResult = ReturnType<
  typeof useGetPaymentAdjustmentLazyQuery
>
export type GetPaymentAdjustmentQueryResult = ApolloReactCommon.QueryResult<
  GetPaymentAdjustmentQuery,
  GetPaymentAdjustmentQueryVariables
>
export const PaymentGatewaysDocument = gql`
  query PaymentGateways(
    $page: Int
    $limit: Int
    $filter: PaymentGatewayFilterInput
  ) {
    paymentGateways(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        code
        name
        status
        supportedMethods
        supportedCurrencies
        baseFeeRate
        supportsPartialRefund
        supportsWebhook
        supportsRecurring
        supportsInstantSettlement
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function usePaymentGatewaysQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PaymentGatewaysQuery,
    PaymentGatewaysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PaymentGatewaysQuery,
    PaymentGatewaysQueryVariables
  >(PaymentGatewaysDocument, options)
}
export function usePaymentGatewaysLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PaymentGatewaysQuery,
    PaymentGatewaysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PaymentGatewaysQuery,
    PaymentGatewaysQueryVariables
  >(PaymentGatewaysDocument, options)
}
export type PaymentGatewaysQueryHookResult = ReturnType<
  typeof usePaymentGatewaysQuery
>
export type PaymentGatewaysLazyQueryHookResult = ReturnType<
  typeof usePaymentGatewaysLazyQuery
>
export type PaymentGatewaysQueryResult = ApolloReactCommon.QueryResult<
  PaymentGatewaysQuery,
  PaymentGatewaysQueryVariables
>
export const ActivePaymentGatewaysDocument = gql`
  query ActivePaymentGateways {
    activePaymentGateways {
      id
      code
      name
      supportedMethods
      supportedCurrencies
      baseFeeRate
      status
    }
  }
`
export function useActivePaymentGatewaysQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ActivePaymentGatewaysQuery,
    ActivePaymentGatewaysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    ActivePaymentGatewaysQuery,
    ActivePaymentGatewaysQueryVariables
  >(ActivePaymentGatewaysDocument, options)
}
export function useActivePaymentGatewaysLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ActivePaymentGatewaysQuery,
    ActivePaymentGatewaysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    ActivePaymentGatewaysQuery,
    ActivePaymentGatewaysQueryVariables
  >(ActivePaymentGatewaysDocument, options)
}
export type ActivePaymentGatewaysQueryHookResult = ReturnType<
  typeof useActivePaymentGatewaysQuery
>
export type ActivePaymentGatewaysLazyQueryHookResult = ReturnType<
  typeof useActivePaymentGatewaysLazyQuery
>
export type ActivePaymentGatewaysQueryResult = ApolloReactCommon.QueryResult<
  ActivePaymentGatewaysQuery,
  ActivePaymentGatewaysQueryVariables
>
export const PaymentGatewayDocument = gql`
  query PaymentGateway($id: Int!) {
    paymentGateway(id: $id) {
      id
      code
      name
      status
      baseUrl
      apiVersion
      supportedMethods
      supportedCurrencies
      baseFeeRate
      minAmount
      maxAmount
      settlementCycle
      supportsPartialRefund
      supportsWebhook
      supportsRecurring
      supportsInstantSettlement
      createdAt
      updatedAt
    }
  }
`
export function usePaymentGatewayQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PaymentGatewayQuery,
    PaymentGatewayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PaymentGatewayQuery,
    PaymentGatewayQueryVariables
  >(PaymentGatewayDocument, options)
}
export function usePaymentGatewayLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PaymentGatewayQuery,
    PaymentGatewayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PaymentGatewayQuery,
    PaymentGatewayQueryVariables
  >(PaymentGatewayDocument, options)
}
export type PaymentGatewayQueryHookResult = ReturnType<
  typeof usePaymentGatewayQuery
>
export type PaymentGatewayLazyQueryHookResult = ReturnType<
  typeof usePaymentGatewayLazyQuery
>
export type PaymentGatewayQueryResult = ApolloReactCommon.QueryResult<
  PaymentGatewayQuery,
  PaymentGatewayQueryVariables
>
export const PaymentGatewayByCodeDocument = gql`
  query PaymentGatewayByCode($code: String!) {
    paymentGatewayByCode(code: $code) {
      id
      code
      name
      status
      supportedMethods
      supportedCurrencies
      baseFeeRate
      minAmount
      maxAmount
      settlementCycle
      supportsPartialRefund
      supportsWebhook
      supportsRecurring
      supportsInstantSettlement
    }
  }
`
export function usePaymentGatewayByCodeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PaymentGatewayByCodeQuery,
    PaymentGatewayByCodeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PaymentGatewayByCodeQuery,
    PaymentGatewayByCodeQueryVariables
  >(PaymentGatewayByCodeDocument, options)
}
export function usePaymentGatewayByCodeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PaymentGatewayByCodeQuery,
    PaymentGatewayByCodeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PaymentGatewayByCodeQuery,
    PaymentGatewayByCodeQueryVariables
  >(PaymentGatewayByCodeDocument, options)
}
export type PaymentGatewayByCodeQueryHookResult = ReturnType<
  typeof usePaymentGatewayByCodeQuery
>
export type PaymentGatewayByCodeLazyQueryHookResult = ReturnType<
  typeof usePaymentGatewayByCodeLazyQuery
>
export type PaymentGatewayByCodeQueryResult = ApolloReactCommon.QueryResult<
  PaymentGatewayByCodeQuery,
  PaymentGatewayByCodeQueryVariables
>
export const PaymentGatewaysByMethodDocument = gql`
  query PaymentGatewaysByMethod($paymentMethod: PaymentMethod!) {
    paymentGatewaysByMethod(paymentMethod: $paymentMethod) {
      id
      code
      name
      supportedMethods
      supportedCurrencies
      status
    }
  }
`
export function usePaymentGatewaysByMethodQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PaymentGatewaysByMethodQuery,
    PaymentGatewaysByMethodQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PaymentGatewaysByMethodQuery,
    PaymentGatewaysByMethodQueryVariables
  >(PaymentGatewaysByMethodDocument, options)
}
export function usePaymentGatewaysByMethodLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PaymentGatewaysByMethodQuery,
    PaymentGatewaysByMethodQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PaymentGatewaysByMethodQuery,
    PaymentGatewaysByMethodQueryVariables
  >(PaymentGatewaysByMethodDocument, options)
}
export type PaymentGatewaysByMethodQueryHookResult = ReturnType<
  typeof usePaymentGatewaysByMethodQuery
>
export type PaymentGatewaysByMethodLazyQueryHookResult = ReturnType<
  typeof usePaymentGatewaysByMethodLazyQuery
>
export type PaymentGatewaysByMethodQueryResult = ApolloReactCommon.QueryResult<
  PaymentGatewaysByMethodQuery,
  PaymentGatewaysByMethodQueryVariables
>
export const GetPaymentMethodConfigsDocument = gql`
  query GetPaymentMethodConfigs(
    $page: Int
    $limit: Int
    $filter: PaymentMethodConfigFilterInput
  ) {
    paymentMethodConfigs(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        paymentMethod
        displayName
        icon
        description
        priority
        defaultMinAmount
        defaultMaxAmount
        isEnabled
        metadata
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetPaymentMethodConfigsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPaymentMethodConfigsQuery,
    GetPaymentMethodConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPaymentMethodConfigsQuery,
    GetPaymentMethodConfigsQueryVariables
  >(GetPaymentMethodConfigsDocument, options)
}
export function useGetPaymentMethodConfigsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPaymentMethodConfigsQuery,
    GetPaymentMethodConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPaymentMethodConfigsQuery,
    GetPaymentMethodConfigsQueryVariables
  >(GetPaymentMethodConfigsDocument, options)
}
export type GetPaymentMethodConfigsQueryHookResult = ReturnType<
  typeof useGetPaymentMethodConfigsQuery
>
export type GetPaymentMethodConfigsLazyQueryHookResult = ReturnType<
  typeof useGetPaymentMethodConfigsLazyQuery
>
export type GetPaymentMethodConfigsQueryResult = ApolloReactCommon.QueryResult<
  GetPaymentMethodConfigsQuery,
  GetPaymentMethodConfigsQueryVariables
>
export const GetPaymentMethodConfigDocument = gql`
  query GetPaymentMethodConfig($id: Float!) {
    paymentMethodConfig(id: $id) {
      id
      paymentMethod
      displayName
      icon
      description
      priority
      defaultMinAmount
      defaultMaxAmount
      isEnabled
      metadata
      createdAt
      updatedAt
    }
  }
`
export function useGetPaymentMethodConfigQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPaymentMethodConfigQuery,
    GetPaymentMethodConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPaymentMethodConfigQuery,
    GetPaymentMethodConfigQueryVariables
  >(GetPaymentMethodConfigDocument, options)
}
export function useGetPaymentMethodConfigLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPaymentMethodConfigQuery,
    GetPaymentMethodConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPaymentMethodConfigQuery,
    GetPaymentMethodConfigQueryVariables
  >(GetPaymentMethodConfigDocument, options)
}
export type GetPaymentMethodConfigQueryHookResult = ReturnType<
  typeof useGetPaymentMethodConfigQuery
>
export type GetPaymentMethodConfigLazyQueryHookResult = ReturnType<
  typeof useGetPaymentMethodConfigLazyQuery
>
export type GetPaymentMethodConfigQueryResult = ApolloReactCommon.QueryResult<
  GetPaymentMethodConfigQuery,
  GetPaymentMethodConfigQueryVariables
>
export const CreatePaymentMethodConfigDocument = gql`
  mutation CreatePaymentMethodConfig($input: CreatePaymentMethodConfigInput!) {
    createPaymentMethodConfig(input: $input) {
      id
      paymentMethod
      displayName
      icon
      description
      priority
      defaultMinAmount
      defaultMaxAmount
      isEnabled
      metadata
    }
  }
`
export function useCreatePaymentMethodConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePaymentMethodConfigMutation,
    CreatePaymentMethodConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreatePaymentMethodConfigMutation,
    CreatePaymentMethodConfigMutationVariables
  >(CreatePaymentMethodConfigDocument, options)
}
export type CreatePaymentMethodConfigMutationHookResult = ReturnType<
  typeof useCreatePaymentMethodConfigMutation
>
export type CreatePaymentMethodConfigMutationResult =
  ApolloReactCommon.MutationResult<CreatePaymentMethodConfigMutation>
export const UpdatePaymentMethodConfigDocument = gql`
  mutation UpdatePaymentMethodConfig(
    $id: Float!
    $input: UpdatePaymentMethodConfigInput!
  ) {
    updatePaymentMethodConfig(id: $id, input: $input) {
      id
      paymentMethod
      displayName
      icon
      description
      priority
      defaultMinAmount
      defaultMaxAmount
      isEnabled
      metadata
    }
  }
`
export function useUpdatePaymentMethodConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdatePaymentMethodConfigMutation,
    UpdatePaymentMethodConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdatePaymentMethodConfigMutation,
    UpdatePaymentMethodConfigMutationVariables
  >(UpdatePaymentMethodConfigDocument, options)
}
export type UpdatePaymentMethodConfigMutationHookResult = ReturnType<
  typeof useUpdatePaymentMethodConfigMutation
>
export type UpdatePaymentMethodConfigMutationResult =
  ApolloReactCommon.MutationResult<UpdatePaymentMethodConfigMutation>
export const DeletePaymentMethodConfigDocument = gql`
  mutation DeletePaymentMethodConfig($id: Float!) {
    deletePaymentMethodConfig(id: $id) {
      id
    }
  }
`
export function useDeletePaymentMethodConfigMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeletePaymentMethodConfigMutation,
    DeletePaymentMethodConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DeletePaymentMethodConfigMutation,
    DeletePaymentMethodConfigMutationVariables
  >(DeletePaymentMethodConfigDocument, options)
}
export type DeletePaymentMethodConfigMutationHookResult = ReturnType<
  typeof useDeletePaymentMethodConfigMutation
>
export type DeletePaymentMethodConfigMutationResult =
  ApolloReactCommon.MutationResult<DeletePaymentMethodConfigMutation>
export const PaymentMethodRoutingsDocument = gql`
  query PaymentMethodRoutings(
    $page: Int
    $limit: Int
    $filter: PaymentMethodRoutingFilterInput
  ) {
    paymentMethodRoutings(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        paymentMethod
        gateway {
          id
          code
          name
          status
        }
        priority
        isActive
        isDefault
        successRate
        avgResponseTime
        availability
      }
      totalCount
      page
      limit
      hasNext
      hasPrev
    }
  }
`
export function usePaymentMethodRoutingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PaymentMethodRoutingsQuery,
    PaymentMethodRoutingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PaymentMethodRoutingsQuery,
    PaymentMethodRoutingsQueryVariables
  >(PaymentMethodRoutingsDocument, options)
}
export function usePaymentMethodRoutingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PaymentMethodRoutingsQuery,
    PaymentMethodRoutingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PaymentMethodRoutingsQuery,
    PaymentMethodRoutingsQueryVariables
  >(PaymentMethodRoutingsDocument, options)
}
export type PaymentMethodRoutingsQueryHookResult = ReturnType<
  typeof usePaymentMethodRoutingsQuery
>
export type PaymentMethodRoutingsLazyQueryHookResult = ReturnType<
  typeof usePaymentMethodRoutingsLazyQuery
>
export type PaymentMethodRoutingsQueryResult = ApolloReactCommon.QueryResult<
  PaymentMethodRoutingsQuery,
  PaymentMethodRoutingsQueryVariables
>
export const PaymentMethodRoutingDocument = gql`
  query PaymentMethodRouting($id: Int!) {
    paymentMethodRouting(id: $id) {
      id
      paymentMethod
      gateway {
        id
        code
        name
        status
        baseFeeRate
        minAmount
        maxAmount
        settlementCycle
      }
      priority
      isActive
      isDefault
      successRate
      avgResponseTime
      availability
      createdAt
      updatedAt
    }
  }
`
export function usePaymentMethodRoutingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    PaymentMethodRoutingQuery,
    PaymentMethodRoutingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    PaymentMethodRoutingQuery,
    PaymentMethodRoutingQueryVariables
  >(PaymentMethodRoutingDocument, options)
}
export function usePaymentMethodRoutingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PaymentMethodRoutingQuery,
    PaymentMethodRoutingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    PaymentMethodRoutingQuery,
    PaymentMethodRoutingQueryVariables
  >(PaymentMethodRoutingDocument, options)
}
export type PaymentMethodRoutingQueryHookResult = ReturnType<
  typeof usePaymentMethodRoutingQuery
>
export type PaymentMethodRoutingLazyQueryHookResult = ReturnType<
  typeof usePaymentMethodRoutingLazyQuery
>
export type PaymentMethodRoutingQueryResult = ApolloReactCommon.QueryResult<
  PaymentMethodRoutingQuery,
  PaymentMethodRoutingQueryVariables
>
export const RoutingsByPaymentMethodDocument = gql`
  query RoutingsByPaymentMethod($paymentMethod: PaymentMethod!) {
    routingsByPaymentMethod(paymentMethod: $paymentMethod) {
      id
      gateway {
        id
        code
        name
        status
      }
      priority
      isActive
      isDefault
      successRate
      avgResponseTime
      availability
    }
  }
`
export function useRoutingsByPaymentMethodQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RoutingsByPaymentMethodQuery,
    RoutingsByPaymentMethodQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RoutingsByPaymentMethodQuery,
    RoutingsByPaymentMethodQueryVariables
  >(RoutingsByPaymentMethodDocument, options)
}
export function useRoutingsByPaymentMethodLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RoutingsByPaymentMethodQuery,
    RoutingsByPaymentMethodQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RoutingsByPaymentMethodQuery,
    RoutingsByPaymentMethodQueryVariables
  >(RoutingsByPaymentMethodDocument, options)
}
export type RoutingsByPaymentMethodQueryHookResult = ReturnType<
  typeof useRoutingsByPaymentMethodQuery
>
export type RoutingsByPaymentMethodLazyQueryHookResult = ReturnType<
  typeof useRoutingsByPaymentMethodLazyQuery
>
export type RoutingsByPaymentMethodQueryResult = ApolloReactCommon.QueryResult<
  RoutingsByPaymentMethodQuery,
  RoutingsByPaymentMethodQueryVariables
>
export const CryptoPayoutListDocument = gql`
  query cryptoPayoutList(
    $page: Int!
    $limit: Int!
    $merchantId: Int
    $filter: CryptoPayoutListInput
  ) {
    cryptoPayoutList(
      page: $page
      limit: $limit
      merchantId: $merchantId
      filter: $filter
    ) {
      items {
        id
        merchantId
        batchNo
        orderId
        merchantOrderId
        channel
        channelOrderId
        currency
        address
        targetAmount
        feeAmount
        channelFeeAmount
        totalAmount
        status
        createdAt
        createdBy {
          userId
          name
          email
        }
        merchant {
          id
          name
          mid
        }
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useCryptoPayoutListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CryptoPayoutListQuery,
    CryptoPayoutListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CryptoPayoutListQuery,
    CryptoPayoutListQueryVariables
  >(CryptoPayoutListDocument, options)
}
export function useCryptoPayoutListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CryptoPayoutListQuery,
    CryptoPayoutListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CryptoPayoutListQuery,
    CryptoPayoutListQueryVariables
  >(CryptoPayoutListDocument, options)
}
export type CryptoPayoutListQueryHookResult = ReturnType<
  typeof useCryptoPayoutListQuery
>
export type CryptoPayoutListLazyQueryHookResult = ReturnType<
  typeof useCryptoPayoutListLazyQuery
>
export type CryptoPayoutListQueryResult = ApolloReactCommon.QueryResult<
  CryptoPayoutListQuery,
  CryptoPayoutListQueryVariables
>
export const CryptoPayoutDetailDocument = gql`
  query cryptoPayoutDetail($orderId: String!) {
    cryptoPayoutDetail(orderId: $orderId) {
      id
      merchantId
      orderId
      merchantOrderId
      channel
      channelOrderId
      currency
      network
      address
      targetAmount
      feeAmount
      totalAmount
      channelFeeAmount
      status
      failedReason
      chainTx
      createdAt
      createdBy {
        userId
        name
        email
      }
      updatedAt
      completedAt
      batchId
      metaData
      merchant {
        id
        name
        mid
      }
    }
  }
`
export function useCryptoPayoutDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CryptoPayoutDetailQuery,
    CryptoPayoutDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    CryptoPayoutDetailQuery,
    CryptoPayoutDetailQueryVariables
  >(CryptoPayoutDetailDocument, options)
}
export function useCryptoPayoutDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CryptoPayoutDetailQuery,
    CryptoPayoutDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    CryptoPayoutDetailQuery,
    CryptoPayoutDetailQueryVariables
  >(CryptoPayoutDetailDocument, options)
}
export type CryptoPayoutDetailQueryHookResult = ReturnType<
  typeof useCryptoPayoutDetailQuery
>
export type CryptoPayoutDetailLazyQueryHookResult = ReturnType<
  typeof useCryptoPayoutDetailLazyQuery
>
export type CryptoPayoutDetailQueryResult = ApolloReactCommon.QueryResult<
  CryptoPayoutDetailQuery,
  CryptoPayoutDetailQueryVariables
>
export const BatchCryptoPayoutDocument = gql`
  query BatchCryptoPayout($batchId: Int!) {
    batchCryptoPayout(batchId: $batchId) {
      id
      batchNo
      remark
      createdBy {
        userId
        name
        email
      }
    }
  }
`
export function useBatchCryptoPayoutQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    BatchCryptoPayoutQuery,
    BatchCryptoPayoutQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    BatchCryptoPayoutQuery,
    BatchCryptoPayoutQueryVariables
  >(BatchCryptoPayoutDocument, options)
}
export function useBatchCryptoPayoutLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BatchCryptoPayoutQuery,
    BatchCryptoPayoutQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    BatchCryptoPayoutQuery,
    BatchCryptoPayoutQueryVariables
  >(BatchCryptoPayoutDocument, options)
}
export type BatchCryptoPayoutQueryHookResult = ReturnType<
  typeof useBatchCryptoPayoutQuery
>
export type BatchCryptoPayoutLazyQueryHookResult = ReturnType<
  typeof useBatchCryptoPayoutLazyQuery
>
export type BatchCryptoPayoutQueryResult = ApolloReactCommon.QueryResult<
  BatchCryptoPayoutQuery,
  BatchCryptoPayoutQueryVariables
>
export const RecentCryptoPayoutAddressesDocument = gql`
  query recentCryptoPayoutAddresses($currency: String!, $merchantId: Int) {
    recentCryptoPayoutAddresses(currency: $currency, merchantId: $merchantId)
  }
`
export function useRecentCryptoPayoutAddressesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RecentCryptoPayoutAddressesQuery,
    RecentCryptoPayoutAddressesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RecentCryptoPayoutAddressesQuery,
    RecentCryptoPayoutAddressesQueryVariables
  >(RecentCryptoPayoutAddressesDocument, options)
}
export function useRecentCryptoPayoutAddressesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RecentCryptoPayoutAddressesQuery,
    RecentCryptoPayoutAddressesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RecentCryptoPayoutAddressesQuery,
    RecentCryptoPayoutAddressesQueryVariables
  >(RecentCryptoPayoutAddressesDocument, options)
}
export type RecentCryptoPayoutAddressesQueryHookResult = ReturnType<
  typeof useRecentCryptoPayoutAddressesQuery
>
export type RecentCryptoPayoutAddressesLazyQueryHookResult = ReturnType<
  typeof useRecentCryptoPayoutAddressesLazyQuery
>
export type RecentCryptoPayoutAddressesQueryResult =
  ApolloReactCommon.QueryResult<
    RecentCryptoPayoutAddressesQuery,
    RecentCryptoPayoutAddressesQueryVariables
  >
export const MerchantFrequentRecipientsDocument = gql`
  query MerchantFrequentRecipients(
    $page: Int!
    $limit: Int!
    $merchantId: Int!
    $network: String!
    $search: String
  ) {
    merchantFrequentRecipients(
      page: $page
      limit: $limit
      merchantId: $merchantId
      network: $network
      search: $search
    ) {
      items {
        id
        merchantId
        recipientName
        network
        address
        createdAt
        updatedAt
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useMerchantFrequentRecipientsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MerchantFrequentRecipientsQuery,
    MerchantFrequentRecipientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MerchantFrequentRecipientsQuery,
    MerchantFrequentRecipientsQueryVariables
  >(MerchantFrequentRecipientsDocument, options)
}
export function useMerchantFrequentRecipientsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MerchantFrequentRecipientsQuery,
    MerchantFrequentRecipientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MerchantFrequentRecipientsQuery,
    MerchantFrequentRecipientsQueryVariables
  >(MerchantFrequentRecipientsDocument, options)
}
export type MerchantFrequentRecipientsQueryHookResult = ReturnType<
  typeof useMerchantFrequentRecipientsQuery
>
export type MerchantFrequentRecipientsLazyQueryHookResult = ReturnType<
  typeof useMerchantFrequentRecipientsLazyQuery
>
export type MerchantFrequentRecipientsQueryResult =
  ApolloReactCommon.QueryResult<
    MerchantFrequentRecipientsQuery,
    MerchantFrequentRecipientsQueryVariables
  >
export const MerchantFrequentRecipientDocument = gql`
  query MerchantFrequentRecipient(
    $merchantId: Int!
    $network: String!
    $address: String!
  ) {
    merchantFrequentRecipient(
      merchantId: $merchantId
      network: $network
      address: $address
    ) {
      id
      merchantId
      recipientName
      network
      address
      createdAt
      updatedAt
    }
  }
`
export function useMerchantFrequentRecipientQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    MerchantFrequentRecipientQuery,
    MerchantFrequentRecipientQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    MerchantFrequentRecipientQuery,
    MerchantFrequentRecipientQueryVariables
  >(MerchantFrequentRecipientDocument, options)
}
export function useMerchantFrequentRecipientLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MerchantFrequentRecipientQuery,
    MerchantFrequentRecipientQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    MerchantFrequentRecipientQuery,
    MerchantFrequentRecipientQueryVariables
  >(MerchantFrequentRecipientDocument, options)
}
export type MerchantFrequentRecipientQueryHookResult = ReturnType<
  typeof useMerchantFrequentRecipientQuery
>
export type MerchantFrequentRecipientLazyQueryHookResult = ReturnType<
  typeof useMerchantFrequentRecipientLazyQuery
>
export type MerchantFrequentRecipientQueryResult =
  ApolloReactCommon.QueryResult<
    MerchantFrequentRecipientQuery,
    MerchantFrequentRecipientQueryVariables
  >
export const DownloadCryptoPayoutExcelDocument = gql`
  mutation DownloadCryptoPayoutExcel($filter: CryptoPayoutListInput) {
    downloadCryptoPayoutExcel(filter: $filter) {
      downloadUrl
      jobId
      message
      processType
      recordCount
    }
  }
`
export function useDownloadCryptoPayoutExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadCryptoPayoutExcelMutation,
    DownloadCryptoPayoutExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadCryptoPayoutExcelMutation,
    DownloadCryptoPayoutExcelMutationVariables
  >(DownloadCryptoPayoutExcelDocument, options)
}
export type DownloadCryptoPayoutExcelMutationHookResult = ReturnType<
  typeof useDownloadCryptoPayoutExcelMutation
>
export type DownloadCryptoPayoutExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadCryptoPayoutExcelMutation>
export const GetPgSettlementsDocument = gql`
  query GetPgSettlements(
    $page: Int!
    $limit: Int!
    $gatewayId: Int
    $status: PgSettlementStatus
    $settlementType: PgSettlementType
    $dateFrom: DateTime
    $dateTo: DateTime
  ) {
    pgSettlements(
      page: $page
      limit: $limit
      gatewayId: $gatewayId
      status: $status
      settlementType: $settlementType
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
      items {
        id
        batchId
        gatewayId
        dateFrom
        dateTo
        currency
        settlementType
        triggeredBy
        status
        requestedAt
        completedAt
        createdAt
        updatedAt
        itemCount
      }
    }
  }
`
export function useGetPgSettlementsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementsQuery,
    GetPgSettlementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementsQuery,
    GetPgSettlementsQueryVariables
  >(GetPgSettlementsDocument, options)
}
export function useGetPgSettlementsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementsQuery,
    GetPgSettlementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementsQuery,
    GetPgSettlementsQueryVariables
  >(GetPgSettlementsDocument, options)
}
export type GetPgSettlementsQueryHookResult = ReturnType<
  typeof useGetPgSettlementsQuery
>
export type GetPgSettlementsLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementsLazyQuery
>
export type GetPgSettlementsQueryResult = ApolloReactCommon.QueryResult<
  GetPgSettlementsQuery,
  GetPgSettlementsQueryVariables
>
export const GetPgSettlementDocument = gql`
  query GetPgSettlement($id: String!) {
    pgSettlement(id: $id) {
      id
      batchId
      gatewayId
      gateway {
        id
        code
        name
      }
      dateFrom
      dateTo
      currency
      status
      requestedAt
      submittedAt
      completedAt
      errorCode
      errorMessage
      createdAt
      updatedAt
      items {
        id
        pgSettlementId
        payableCurrencyCode
        orderCurrencyCode
        requestedAmount
        settledAmount
        transactionCount
        pgSettlementRef
        txHash
        status
        createdAt
        updatedAt
        transfers {
          id
          pgSettlementItemId
          requestId
          providerRef
          transferType
          sourceAmount
          sourceCurrency
          sourceNetwork
          sourceChannelCode
          destChannelCode
          destinationType
          destinationId
          destinationInfo
          txHash
          blockNumber
          status
          requestedAt
          submittedAt
          processedAt
          completedAt
          errorCode
          errorMessage
          retryCount
          notes
          targetAmount
          targetCurrency
          exchangeRate
          receivedAmount
          receivedCurrency
        }
        feeRecords {
          id
          feeType
          amount
          currency
          txHash
          blockNumber
          description
        }
      }
      timeline {
        events {
          id
          pgSettlementId
          pgSettlementTransferId
          eventType
          eventSource
          previousStatus
          newStatus
          title
          description
          metadata
          occurredAt
          createdAt
          createdBy
        }
        totalCount
      }
    }
  }
`
export function useGetPgSettlementQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementQuery,
    GetPgSettlementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementQuery,
    GetPgSettlementQueryVariables
  >(GetPgSettlementDocument, options)
}
export function useGetPgSettlementLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementQuery,
    GetPgSettlementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementQuery,
    GetPgSettlementQueryVariables
  >(GetPgSettlementDocument, options)
}
export type GetPgSettlementQueryHookResult = ReturnType<
  typeof useGetPgSettlementQuery
>
export type GetPgSettlementLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementLazyQuery
>
export type GetPgSettlementQueryResult = ApolloReactCommon.QueryResult<
  GetPgSettlementQuery,
  GetPgSettlementQueryVariables
>
export const GetPgSettlementByBatchIdDocument = gql`
  query GetPgSettlementByBatchId($batchId: String!) {
    pgSettlementByBatchId(batchId: $batchId) {
      id
      batchId
      gatewayId
      status
      dateFrom
      dateTo
      currency
      requestedAt
      completedAt
      createdAt
      updatedAt
    }
  }
`
export function useGetPgSettlementByBatchIdQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementByBatchIdQuery,
    GetPgSettlementByBatchIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementByBatchIdQuery,
    GetPgSettlementByBatchIdQueryVariables
  >(GetPgSettlementByBatchIdDocument, options)
}
export function useGetPgSettlementByBatchIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementByBatchIdQuery,
    GetPgSettlementByBatchIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementByBatchIdQuery,
    GetPgSettlementByBatchIdQueryVariables
  >(GetPgSettlementByBatchIdDocument, options)
}
export type GetPgSettlementByBatchIdQueryHookResult = ReturnType<
  typeof useGetPgSettlementByBatchIdQuery
>
export type GetPgSettlementByBatchIdLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementByBatchIdLazyQuery
>
export type GetPgSettlementByBatchIdQueryResult = ApolloReactCommon.QueryResult<
  GetPgSettlementByBatchIdQuery,
  GetPgSettlementByBatchIdQueryVariables
>
export const GetPgSettlementTransferDocument = gql`
  query GetPgSettlementTransfer($id: String!) {
    pgSettlementTransfer(id: $id) {
      id
      pgSettlementItemId
      requestId
      providerRef
      transferType
      sourceAmount
      sourceCurrency
      sourceNetwork
      sourceChannelCode
      destChannelCode
      destinationType
      destinationId
      destinationInfo
      txHash
      blockNumber
      status
      requestedAt
      submittedAt
      processedAt
      completedAt
      errorCode
      errorMessage
      retryCount
      notes
      targetAmount
      targetCurrency
      exchangeRate
      receivedAmount
      receivedCurrency
      providerRequest
      providerResponse
      createdAt
      updatedAt
    }
  }
`
export function useGetPgSettlementTransferQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementTransferQuery,
    GetPgSettlementTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementTransferQuery,
    GetPgSettlementTransferQueryVariables
  >(GetPgSettlementTransferDocument, options)
}
export function useGetPgSettlementTransferLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementTransferQuery,
    GetPgSettlementTransferQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementTransferQuery,
    GetPgSettlementTransferQueryVariables
  >(GetPgSettlementTransferDocument, options)
}
export type GetPgSettlementTransferQueryHookResult = ReturnType<
  typeof useGetPgSettlementTransferQuery
>
export type GetPgSettlementTransferLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementTransferLazyQuery
>
export type GetPgSettlementTransferQueryResult = ApolloReactCommon.QueryResult<
  GetPgSettlementTransferQuery,
  GetPgSettlementTransferQueryVariables
>
export const GetPgSettlementPreviewDocument = gql`
  query GetPgSettlementPreview($input: PgSettlementPreviewInput!) {
    pgSettlementPreview(input: $input) {
      items {
        gatewayId
        gatewayName
        gatewayCode
        payableCurrencyId
        payableCurrencyCode
        payableCurrencyName
        orderCurrencyId
        orderCurrencyCode
        originalPaymentAmount
        originalRefundAmount
        originalNetAmount
        payablePaymentAmount
        payableRefundAmount
        payableNetAmount
        paymentCount
        refundCount
        totalTransactionCount
      }
      dateFrom
      dateTo
      totalItems
    }
  }
`
export function useGetPgSettlementPreviewQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementPreviewQuery,
    GetPgSettlementPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementPreviewQuery,
    GetPgSettlementPreviewQueryVariables
  >(GetPgSettlementPreviewDocument, options)
}
export function useGetPgSettlementPreviewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementPreviewQuery,
    GetPgSettlementPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementPreviewQuery,
    GetPgSettlementPreviewQueryVariables
  >(GetPgSettlementPreviewDocument, options)
}
export type GetPgSettlementPreviewQueryHookResult = ReturnType<
  typeof useGetPgSettlementPreviewQuery
>
export type GetPgSettlementPreviewLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementPreviewLazyQuery
>
export type GetPgSettlementPreviewQueryResult = ApolloReactCommon.QueryResult<
  GetPgSettlementPreviewQuery,
  GetPgSettlementPreviewQueryVariables
>
export const GetPgSettlementWalletConfigsDocument = gql`
  query GetPgSettlementWalletConfigs(
    $gatewayCode: String
    $activeOnly: Boolean
  ) {
    pgSettlementWalletConfigs(
      gatewayCode: $gatewayCode
      activeOnly: $activeOnly
    ) {
      id
      gatewayId
      gatewayCode
      gatewayName
      currencyId
      currencyCode
      network
      walletAddress
      walletMemo
      isActive
      targetChannelCode
      createdAt
      updatedAt
      createdBy
    }
  }
`
export function useGetPgSettlementWalletConfigsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementWalletConfigsQuery,
    GetPgSettlementWalletConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementWalletConfigsQuery,
    GetPgSettlementWalletConfigsQueryVariables
  >(GetPgSettlementWalletConfigsDocument, options)
}
export function useGetPgSettlementWalletConfigsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementWalletConfigsQuery,
    GetPgSettlementWalletConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementWalletConfigsQuery,
    GetPgSettlementWalletConfigsQueryVariables
  >(GetPgSettlementWalletConfigsDocument, options)
}
export type GetPgSettlementWalletConfigsQueryHookResult = ReturnType<
  typeof useGetPgSettlementWalletConfigsQuery
>
export type GetPgSettlementWalletConfigsLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementWalletConfigsLazyQuery
>
export type GetPgSettlementWalletConfigsQueryResult =
  ApolloReactCommon.QueryResult<
    GetPgSettlementWalletConfigsQuery,
    GetPgSettlementWalletConfigsQueryVariables
  >
export const GetPgSettlementWalletConfigDocument = gql`
  query GetPgSettlementWalletConfig($id: String!) {
    pgSettlementWalletConfig(id: $id) {
      id
      gatewayId
      gatewayCode
      gatewayName
      currencyId
      currencyCode
      network
      walletAddress
      walletMemo
      isActive
      targetChannelCode
      createdAt
      updatedAt
      createdBy
    }
  }
`
export function useGetPgSettlementWalletConfigQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementWalletConfigQuery,
    GetPgSettlementWalletConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementWalletConfigQuery,
    GetPgSettlementWalletConfigQueryVariables
  >(GetPgSettlementWalletConfigDocument, options)
}
export function useGetPgSettlementWalletConfigLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementWalletConfigQuery,
    GetPgSettlementWalletConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementWalletConfigQuery,
    GetPgSettlementWalletConfigQueryVariables
  >(GetPgSettlementWalletConfigDocument, options)
}
export type GetPgSettlementWalletConfigQueryHookResult = ReturnType<
  typeof useGetPgSettlementWalletConfigQuery
>
export type GetPgSettlementWalletConfigLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementWalletConfigLazyQuery
>
export type GetPgSettlementWalletConfigQueryResult =
  ApolloReactCommon.QueryResult<
    GetPgSettlementWalletConfigQuery,
    GetPgSettlementWalletConfigQueryVariables
  >
export const GetAllActiveWalletConfigsDocument = gql`
  query GetAllActiveWalletConfigs {
    pgSettlementWalletConfigs {
      id
      gatewayId
      gatewayCode
      gatewayName
      currencyId
      currencyCode
      network
      walletAddress
      walletMemo
    }
  }
`
export function useGetAllActiveWalletConfigsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllActiveWalletConfigsQuery,
    GetAllActiveWalletConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetAllActiveWalletConfigsQuery,
    GetAllActiveWalletConfigsQueryVariables
  >(GetAllActiveWalletConfigsDocument, options)
}
export function useGetAllActiveWalletConfigsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllActiveWalletConfigsQuery,
    GetAllActiveWalletConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetAllActiveWalletConfigsQuery,
    GetAllActiveWalletConfigsQueryVariables
  >(GetAllActiveWalletConfigsDocument, options)
}
export type GetAllActiveWalletConfigsQueryHookResult = ReturnType<
  typeof useGetAllActiveWalletConfigsQuery
>
export type GetAllActiveWalletConfigsLazyQueryHookResult = ReturnType<
  typeof useGetAllActiveWalletConfigsLazyQuery
>
export type GetAllActiveWalletConfigsQueryResult =
  ApolloReactCommon.QueryResult<
    GetAllActiveWalletConfigsQuery,
    GetAllActiveWalletConfigsQueryVariables
  >
export const GetPgSettlementProcessedPeriodsDocument = gql`
  query GetPgSettlementProcessedPeriods(
    $gatewayCode: String!
    $settlementType: PgSettlementType!
  ) {
    pgSettlementProcessedPeriods(
      gatewayCode: $gatewayCode
      settlementType: $settlementType
    ) {
      dateFrom
      dateTo
      status
    }
  }
`
export function useGetPgSettlementProcessedPeriodsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementProcessedPeriodsQuery,
    GetPgSettlementProcessedPeriodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementProcessedPeriodsQuery,
    GetPgSettlementProcessedPeriodsQueryVariables
  >(GetPgSettlementProcessedPeriodsDocument, options)
}
export function useGetPgSettlementProcessedPeriodsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementProcessedPeriodsQuery,
    GetPgSettlementProcessedPeriodsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementProcessedPeriodsQuery,
    GetPgSettlementProcessedPeriodsQueryVariables
  >(GetPgSettlementProcessedPeriodsDocument, options)
}
export type GetPgSettlementProcessedPeriodsQueryHookResult = ReturnType<
  typeof useGetPgSettlementProcessedPeriodsQuery
>
export type GetPgSettlementProcessedPeriodsLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementProcessedPeriodsLazyQuery
>
export type GetPgSettlementProcessedPeriodsQueryResult =
  ApolloReactCommon.QueryResult<
    GetPgSettlementProcessedPeriodsQuery,
    GetPgSettlementProcessedPeriodsQueryVariables
  >
export const GetReconciliationMismatchItemsDocument = gql`
  query GetReconciliationMismatchItems(
    $page: Int!
    $limit: Int!
    $filter: ReconciliationMismatchItemFilterInput
  ) {
    reconciliationMismatchItems(page: $page, limit: $limit, filter: $filter) {
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
      items {
        ...ReconciliationMismatchItemFields
      }
    }
  }
  ${ReconciliationMismatchItemFieldsFragmentDoc}
`
export function useGetReconciliationMismatchItemsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetReconciliationMismatchItemsQuery,
    GetReconciliationMismatchItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetReconciliationMismatchItemsQuery,
    GetReconciliationMismatchItemsQueryVariables
  >(GetReconciliationMismatchItemsDocument, options)
}
export function useGetReconciliationMismatchItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetReconciliationMismatchItemsQuery,
    GetReconciliationMismatchItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetReconciliationMismatchItemsQuery,
    GetReconciliationMismatchItemsQueryVariables
  >(GetReconciliationMismatchItemsDocument, options)
}
export type GetReconciliationMismatchItemsQueryHookResult = ReturnType<
  typeof useGetReconciliationMismatchItemsQuery
>
export type GetReconciliationMismatchItemsLazyQueryHookResult = ReturnType<
  typeof useGetReconciliationMismatchItemsLazyQuery
>
export type GetReconciliationMismatchItemsQueryResult =
  ApolloReactCommon.QueryResult<
    GetReconciliationMismatchItemsQuery,
    GetReconciliationMismatchItemsQueryVariables
  >
export const GetReconciliationMismatchItemDocument = gql`
  query GetReconciliationMismatchItem($id: String!) {
    reconciliationMismatchItem(id: $id) {
      ...ReconciliationMismatchItemFields
    }
  }
  ${ReconciliationMismatchItemFieldsFragmentDoc}
`
export function useGetReconciliationMismatchItemQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetReconciliationMismatchItemQuery,
    GetReconciliationMismatchItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetReconciliationMismatchItemQuery,
    GetReconciliationMismatchItemQueryVariables
  >(GetReconciliationMismatchItemDocument, options)
}
export function useGetReconciliationMismatchItemLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetReconciliationMismatchItemQuery,
    GetReconciliationMismatchItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetReconciliationMismatchItemQuery,
    GetReconciliationMismatchItemQueryVariables
  >(GetReconciliationMismatchItemDocument, options)
}
export type GetReconciliationMismatchItemQueryHookResult = ReturnType<
  typeof useGetReconciliationMismatchItemQuery
>
export type GetReconciliationMismatchItemLazyQueryHookResult = ReturnType<
  typeof useGetReconciliationMismatchItemLazyQuery
>
export type GetReconciliationMismatchItemQueryResult =
  ApolloReactCommon.QueryResult<
    GetReconciliationMismatchItemQuery,
    GetReconciliationMismatchItemQueryVariables
  >
export const GetReconciliationRunsDocument = gql`
  query GetReconciliationRuns(
    $page: Int!
    $limit: Int!
    $filter: ReconciliationRunFilterInput
  ) {
    reconciliationRuns(page: $page, limit: $limit, filter: $filter) {
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
      items {
        id
        gatewayId
        dateFrom
        dateTo
        ourTotalCount
        ourMatchedCount
        ourUnmatchedCount
        pgTotalCount
        pgMatchedCount
        pgUnmatchedCount
        totalApiCalls
        status
        errorMessage
        createdAt
        gateway {
          id
          code
          name
        }
      }
    }
  }
`
export function useGetReconciliationRunsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetReconciliationRunsQuery,
    GetReconciliationRunsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetReconciliationRunsQuery,
    GetReconciliationRunsQueryVariables
  >(GetReconciliationRunsDocument, options)
}
export function useGetReconciliationRunsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetReconciliationRunsQuery,
    GetReconciliationRunsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetReconciliationRunsQuery,
    GetReconciliationRunsQueryVariables
  >(GetReconciliationRunsDocument, options)
}
export type GetReconciliationRunsQueryHookResult = ReturnType<
  typeof useGetReconciliationRunsQuery
>
export type GetReconciliationRunsLazyQueryHookResult = ReturnType<
  typeof useGetReconciliationRunsLazyQuery
>
export type GetReconciliationRunsQueryResult = ApolloReactCommon.QueryResult<
  GetReconciliationRunsQuery,
  GetReconciliationRunsQueryVariables
>
export const GetReconciliationRunDocument = gql`
  query GetReconciliationRun($id: String!) {
    reconciliationRun(id: $id) {
      id
      gatewayId
      dateFrom
      dateTo
      ourTotalCount
      ourMatchedCount
      ourUnmatchedCount
      ourUnmatchedKeys
      pgTotalCount
      pgMatchedCount
      pgUnmatchedCount
      pgUnmatchedCodes
      transactionMismatches
      totalApiCalls
      status
      errorMessage
      createdAt
      gateway {
        id
        code
        name
        baseUrl
      }
    }
  }
`
export function useGetReconciliationRunQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetReconciliationRunQuery,
    GetReconciliationRunQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetReconciliationRunQuery,
    GetReconciliationRunQueryVariables
  >(GetReconciliationRunDocument, options)
}
export function useGetReconciliationRunLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetReconciliationRunQuery,
    GetReconciliationRunQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetReconciliationRunQuery,
    GetReconciliationRunQueryVariables
  >(GetReconciliationRunDocument, options)
}
export type GetReconciliationRunQueryHookResult = ReturnType<
  typeof useGetReconciliationRunQuery
>
export type GetReconciliationRunLazyQueryHookResult = ReturnType<
  typeof useGetReconciliationRunLazyQuery
>
export type GetReconciliationRunQueryResult = ApolloReactCommon.QueryResult<
  GetReconciliationRunQuery,
  GetReconciliationRunQueryVariables
>
export const GetRefundApprovalRequestsDocument = gql`
  query GetRefundApprovalRequests(
    $page: Int!
    $limit: Int!
    $filter: RefundApprovalFilterInput
  ) {
    refundApprovalRequests(page: $page, limit: $limit, filter: $filter) {
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
      items {
        ...RefundApprovalRequestFields
      }
    }
  }
  ${RefundApprovalRequestFieldsFragmentDoc}
`
export function useGetRefundApprovalRequestsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetRefundApprovalRequestsQuery,
    GetRefundApprovalRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetRefundApprovalRequestsQuery,
    GetRefundApprovalRequestsQueryVariables
  >(GetRefundApprovalRequestsDocument, options)
}
export function useGetRefundApprovalRequestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRefundApprovalRequestsQuery,
    GetRefundApprovalRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetRefundApprovalRequestsQuery,
    GetRefundApprovalRequestsQueryVariables
  >(GetRefundApprovalRequestsDocument, options)
}
export type GetRefundApprovalRequestsQueryHookResult = ReturnType<
  typeof useGetRefundApprovalRequestsQuery
>
export type GetRefundApprovalRequestsLazyQueryHookResult = ReturnType<
  typeof useGetRefundApprovalRequestsLazyQuery
>
export type GetRefundApprovalRequestsQueryResult =
  ApolloReactCommon.QueryResult<
    GetRefundApprovalRequestsQuery,
    GetRefundApprovalRequestsQueryVariables
  >
export const GetRefundApprovalRequestDocument = gql`
  query GetRefundApprovalRequest($id: String!) {
    refundApprovalRequest(id: $id) {
      ...RefundApprovalRequestFields
    }
  }
  ${RefundApprovalRequestFieldsFragmentDoc}
`
export function useGetRefundApprovalRequestQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetRefundApprovalRequestQuery,
    GetRefundApprovalRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetRefundApprovalRequestQuery,
    GetRefundApprovalRequestQueryVariables
  >(GetRefundApprovalRequestDocument, options)
}
export function useGetRefundApprovalRequestLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRefundApprovalRequestQuery,
    GetRefundApprovalRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetRefundApprovalRequestQuery,
    GetRefundApprovalRequestQueryVariables
  >(GetRefundApprovalRequestDocument, options)
}
export type GetRefundApprovalRequestQueryHookResult = ReturnType<
  typeof useGetRefundApprovalRequestQuery
>
export type GetRefundApprovalRequestLazyQueryHookResult = ReturnType<
  typeof useGetRefundApprovalRequestLazyQuery
>
export type GetRefundApprovalRequestQueryResult = ApolloReactCommon.QueryResult<
  GetRefundApprovalRequestQuery,
  GetRefundApprovalRequestQueryVariables
>
export const RoleMenuPermissionsDocument = gql`
  query RoleMenuPermissions($role: UserRole!) {
    roleMenuPermissions(role: $role) {
      id
      menuId
      role
      canView
      canCreate
      canEdit
      canDelete
      canExport
      isDefault
    }
  }
`
export function useRoleMenuPermissionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    RoleMenuPermissionsQuery,
    RoleMenuPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    RoleMenuPermissionsQuery,
    RoleMenuPermissionsQueryVariables
  >(RoleMenuPermissionsDocument, options)
}
export function useRoleMenuPermissionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RoleMenuPermissionsQuery,
    RoleMenuPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    RoleMenuPermissionsQuery,
    RoleMenuPermissionsQueryVariables
  >(RoleMenuPermissionsDocument, options)
}
export type RoleMenuPermissionsQueryHookResult = ReturnType<
  typeof useRoleMenuPermissionsQuery
>
export type RoleMenuPermissionsLazyQueryHookResult = ReturnType<
  typeof useRoleMenuPermissionsLazyQuery
>
export type RoleMenuPermissionsQueryResult = ApolloReactCommon.QueryResult<
  RoleMenuPermissionsQuery,
  RoleMenuPermissionsQueryVariables
>
export const GetSettlementsDocument = gql`
  query GetSettlements(
    $page: Int = 1
    $limit: Int = 15
    $filter: SettlementFilterInput
  ) {
    settlements(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        merchantId
        merchant {
          id
          name
          businessName
          companyName
          mid
        }
        settlementDateFrom
        settlementDateTo
        grossAmount
        feeAmount
        netAmount
        refundAmount
        refundFeeAmount
        currency
        status
        completedAt
        createdAt
        updatedAt
        transactionCount
        paymentCount
        refundCount
      }
      totalCount
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useGetSettlementsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetSettlementsQuery,
    GetSettlementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetSettlementsQuery,
    GetSettlementsQueryVariables
  >(GetSettlementsDocument, options)
}
export function useGetSettlementsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSettlementsQuery,
    GetSettlementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetSettlementsQuery,
    GetSettlementsQueryVariables
  >(GetSettlementsDocument, options)
}
export type GetSettlementsQueryHookResult = ReturnType<
  typeof useGetSettlementsQuery
>
export type GetSettlementsLazyQueryHookResult = ReturnType<
  typeof useGetSettlementsLazyQuery
>
export type GetSettlementsQueryResult = ApolloReactCommon.QueryResult<
  GetSettlementsQuery,
  GetSettlementsQueryVariables
>
export const GetSettlementDocument = gql`
  query GetSettlement($id: Int!) {
    settlement(id: $id) {
      id
      merchantId
      merchant {
        id
        name
        businessName
        companyName
        mid
        businessAddress
        businessNumber
        businessCategory
      }
      settlementDateFrom
      settlementDateTo
      grossAmount
      feeAmount
      netAmount
      refundAmount
      refundFeeAmount
      refundFeeCount
      currency
      status
      completedAt
      createdAt
      updatedAt
      transactionCount
      paymentCount
      refundCount
    }
  }
`
export function useGetSettlementQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetSettlementQuery,
    GetSettlementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetSettlementQuery,
    GetSettlementQueryVariables
  >(GetSettlementDocument, options)
}
export function useGetSettlementLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSettlementQuery,
    GetSettlementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetSettlementQuery,
    GetSettlementQueryVariables
  >(GetSettlementDocument, options)
}
export type GetSettlementQueryHookResult = ReturnType<
  typeof useGetSettlementQuery
>
export type GetSettlementLazyQueryHookResult = ReturnType<
  typeof useGetSettlementLazyQuery
>
export type GetSettlementQueryResult = ApolloReactCommon.QueryResult<
  GetSettlementQuery,
  GetSettlementQueryVariables
>
export const DownloadSettlementExcelDocument = gql`
  mutation DownloadSettlementExcel($filter: SettlementFilterInput) {
    downloadSettlementExcel(filter: $filter) {
      downloadUrl
      jobId
      message
      recordCount
    }
  }
`
export function useDownloadSettlementExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadSettlementExcelMutation,
    DownloadSettlementExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadSettlementExcelMutation,
    DownloadSettlementExcelMutationVariables
  >(DownloadSettlementExcelDocument, options)
}
export type DownloadSettlementExcelMutationHookResult = ReturnType<
  typeof useDownloadSettlementExcelMutation
>
export type DownloadSettlementExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadSettlementExcelMutation>
export const DownloadTransactionExcelDocument = gql`
  mutation DownloadTransactionExcel($filter: TransactionExcelFilterInput!) {
    downloadTransactionExcel(filter: $filter) {
      downloadUrl
      jobId
      message
      recordCount
    }
  }
`
export function useDownloadTransactionExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadTransactionExcelMutation,
    DownloadTransactionExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadTransactionExcelMutation,
    DownloadTransactionExcelMutationVariables
  >(DownloadTransactionExcelDocument, options)
}
export type DownloadTransactionExcelMutationHookResult = ReturnType<
  typeof useDownloadTransactionExcelMutation
>
export type DownloadTransactionExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadTransactionExcelMutation>
export const GetPgSettlementTimelineDocument = gql`
  query GetPgSettlementTimeline($pgSettlementId: String!) {
    pgSettlementTimeline(pgSettlementId: $pgSettlementId) {
      events {
        id
        pgSettlementId
        pgSettlementTransferId
        eventType
        eventSource
        previousStatus
        newStatus
        title
        description
        metadata
        occurredAt
        createdAt
        createdBy
      }
      totalCount
    }
  }
`
export function useGetPgSettlementTimelineQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPgSettlementTimelineQuery,
    GetPgSettlementTimelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetPgSettlementTimelineQuery,
    GetPgSettlementTimelineQueryVariables
  >(GetPgSettlementTimelineDocument, options)
}
export function useGetPgSettlementTimelineLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPgSettlementTimelineQuery,
    GetPgSettlementTimelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetPgSettlementTimelineQuery,
    GetPgSettlementTimelineQueryVariables
  >(GetPgSettlementTimelineDocument, options)
}
export type GetPgSettlementTimelineQueryHookResult = ReturnType<
  typeof useGetPgSettlementTimelineQuery
>
export type GetPgSettlementTimelineLazyQueryHookResult = ReturnType<
  typeof useGetPgSettlementTimelineLazyQuery
>
export type GetPgSettlementTimelineQueryResult = ApolloReactCommon.QueryResult<
  GetPgSettlementTimelineQuery,
  GetPgSettlementTimelineQueryVariables
>
export const GetSidebarMenusDocument = gql`
  query GetSidebarMenus {
    userMenus {
      id
      code
      name
      path
      icon
      sortOrder
      isVisible
      parentId
      children {
        id
        code
        name
        path
        icon
        sortOrder
        isVisible
        parentId
      }
    }
  }
`
export function useGetSidebarMenusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetSidebarMenusQuery,
    GetSidebarMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetSidebarMenusQuery,
    GetSidebarMenusQueryVariables
  >(GetSidebarMenusDocument, options)
}
export function useGetSidebarMenusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetSidebarMenusQuery,
    GetSidebarMenusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetSidebarMenusQuery,
    GetSidebarMenusQueryVariables
  >(GetSidebarMenusDocument, options)
}
export type GetSidebarMenusQueryHookResult = ReturnType<
  typeof useGetSidebarMenusQuery
>
export type GetSidebarMenusLazyQueryHookResult = ReturnType<
  typeof useGetSidebarMenusLazyQuery
>
export type GetSidebarMenusQueryResult = ApolloReactCommon.QueryResult<
  GetSidebarMenusQuery,
  GetSidebarMenusQueryVariables
>
export const SystemSettingsDocument = gql`
  query SystemSettings($category: String) {
    systemSettings(category: $category) {
      id
      category
      key
      value
      valueType
      description
      updatedAt
    }
  }
`
export function useSystemSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SystemSettingsQuery,
    SystemSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SystemSettingsQuery,
    SystemSettingsQueryVariables
  >(SystemSettingsDocument, options)
}
export function useSystemSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SystemSettingsQuery,
    SystemSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SystemSettingsQuery,
    SystemSettingsQueryVariables
  >(SystemSettingsDocument, options)
}
export type SystemSettingsQueryHookResult = ReturnType<
  typeof useSystemSettingsQuery
>
export type SystemSettingsLazyQueryHookResult = ReturnType<
  typeof useSystemSettingsLazyQuery
>
export type SystemSettingsQueryResult = ApolloReactCommon.QueryResult<
  SystemSettingsQuery,
  SystemSettingsQueryVariables
>
export const TopupListDocument = gql`
  query topupList(
    $page: Int!
    $limit: Int!
    $merchantId: Int
    $filter: TopupListInput
  ) {
    topupList(
      page: $page
      limit: $limit
      merchantId: $merchantId
      filter: $filter
    ) {
      items {
        id
        merchantId
        orderId
        channel
        channelOrderId
        receivedAmount
        channelFeeAmount
        currency
        feeAmount
        netAmount
        status
        unmatchedDeposit
        createdAt
        createdBy {
          userId
          name
          email
        }
        merchant {
          id
          name
          mid
        }
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useTopupListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TopupListQuery,
    TopupListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<TopupListQuery, TopupListQueryVariables>(
    TopupListDocument,
    options
  )
}
export function useTopupListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TopupListQuery,
    TopupListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<TopupListQuery, TopupListQueryVariables>(
    TopupListDocument,
    options
  )
}
export type TopupListQueryHookResult = ReturnType<typeof useTopupListQuery>
export type TopupListLazyQueryHookResult = ReturnType<
  typeof useTopupListLazyQuery
>
export type TopupListQueryResult = ApolloReactCommon.QueryResult<
  TopupListQuery,
  TopupListQueryVariables
>
export const TopupDetailDocument = gql`
  query topupDetail($orderId: String!) {
    topupDetail(orderId: $orderId) {
      id
      merchantId
      orderId
      channel
      channelOrderId
      channelAccountNo
      receivedAmount
      channelFeeAmount
      currency
      feeAmount
      netAmount
      status
      createdAt
      createdBy {
        userId
        name
        email
      }
      updatedAt
      completedAt
      metaData
      merchant {
        id
        name
        mid
      }
    }
  }
`
export function useTopupDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TopupDetailQuery,
    TopupDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<TopupDetailQuery, TopupDetailQueryVariables>(
    TopupDetailDocument,
    options
  )
}
export function useTopupDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TopupDetailQuery,
    TopupDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TopupDetailQuery,
    TopupDetailQueryVariables
  >(TopupDetailDocument, options)
}
export type TopupDetailQueryHookResult = ReturnType<typeof useTopupDetailQuery>
export type TopupDetailLazyQueryHookResult = ReturnType<
  typeof useTopupDetailLazyQuery
>
export type TopupDetailQueryResult = ApolloReactCommon.QueryResult<
  TopupDetailQuery,
  TopupDetailQueryVariables
>
export const TopupRequestListDocument = gql`
  query TopupRequestList(
    $page: Int!
    $limit: Int!
    $filter: TopupRequestFilterInput
  ) {
    topupRequestList(page: $page, limit: $limit, filter: $filter) {
      items {
        id
        requestId
        merchantId
        channel
        amount
        currency
        tokenId
        paymentReference
        status
        topupId
        receivedAmount
        bankOrderNo
        evidenceMemo
        evidenceSubmittedAt
        expiresAt
        completedAt
        cancelledAt
        createdAt
        createdBy {
          userId
          name
          email
        }
      }
      totalCount
      page
      limit
      totalPages
      hasNext
      hasPrev
    }
  }
`
export function useTopupRequestListQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TopupRequestListQuery,
    TopupRequestListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TopupRequestListQuery,
    TopupRequestListQueryVariables
  >(TopupRequestListDocument, options)
}
export function useTopupRequestListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TopupRequestListQuery,
    TopupRequestListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TopupRequestListQuery,
    TopupRequestListQueryVariables
  >(TopupRequestListDocument, options)
}
export type TopupRequestListQueryHookResult = ReturnType<
  typeof useTopupRequestListQuery
>
export type TopupRequestListLazyQueryHookResult = ReturnType<
  typeof useTopupRequestListLazyQuery
>
export type TopupRequestListQueryResult = ApolloReactCommon.QueryResult<
  TopupRequestListQuery,
  TopupRequestListQueryVariables
>
export const TopupRequestDetailDocument = gql`
  query TopupRequestDetail($requestId: String!) {
    topupRequestDetail(requestId: $requestId) {
      id
      requestId
      merchantId
      amount
      currency
      tokenId
      paymentReference
      status
      topupId
      receivedAmount
      bankOrderNo
      evidenceMemo
      evidenceSubmittedAt
      expiresAt
      completedAt
      cancelledAt
      createdAt
      createdBy {
        userId
        name
        email
      }
      accountInfo {
        accountName
        accountNumber
        bankName
        bankCode
        branchCode
        swiftCode
        location
      }
      cryptoInfo {
        tokenId
        chain
        address
        qrDataUrl
      }
    }
  }
`
export function useTopupRequestDetailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TopupRequestDetailQuery,
    TopupRequestDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TopupRequestDetailQuery,
    TopupRequestDetailQueryVariables
  >(TopupRequestDetailDocument, options)
}
export function useTopupRequestDetailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TopupRequestDetailQuery,
    TopupRequestDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TopupRequestDetailQuery,
    TopupRequestDetailQueryVariables
  >(TopupRequestDetailDocument, options)
}
export type TopupRequestDetailQueryHookResult = ReturnType<
  typeof useTopupRequestDetailQuery
>
export type TopupRequestDetailLazyQueryHookResult = ReturnType<
  typeof useTopupRequestDetailLazyQuery
>
export type TopupRequestDetailQueryResult = ApolloReactCommon.QueryResult<
  TopupRequestDetailQuery,
  TopupRequestDetailQueryVariables
>
export const TopupSupportedCurrenciesDocument = gql`
  query TopupSupportedCurrencies($merchantId: Int) {
    topupSupportedCurrencies(merchantId: $merchantId)
    topupSupportedCryptoTokenIds
  }
`
export function useTopupSupportedCurrenciesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TopupSupportedCurrenciesQuery,
    TopupSupportedCurrenciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TopupSupportedCurrenciesQuery,
    TopupSupportedCurrenciesQueryVariables
  >(TopupSupportedCurrenciesDocument, options)
}
export function useTopupSupportedCurrenciesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TopupSupportedCurrenciesQuery,
    TopupSupportedCurrenciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TopupSupportedCurrenciesQuery,
    TopupSupportedCurrenciesQueryVariables
  >(TopupSupportedCurrenciesDocument, options)
}
export type TopupSupportedCurrenciesQueryHookResult = ReturnType<
  typeof useTopupSupportedCurrenciesQuery
>
export type TopupSupportedCurrenciesLazyQueryHookResult = ReturnType<
  typeof useTopupSupportedCurrenciesLazyQuery
>
export type TopupSupportedCurrenciesQueryResult = ApolloReactCommon.QueryResult<
  TopupSupportedCurrenciesQuery,
  TopupSupportedCurrenciesQueryVariables
>
export const SimulateTopupDepositDocument = gql`
  mutation SimulateTopupDeposit($requestId: String!) {
    simulateTopupDeposit(requestId: $requestId) {
      depositId
      success
    }
  }
`
export function useSimulateTopupDepositMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SimulateTopupDepositMutation,
    SimulateTopupDepositMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    SimulateTopupDepositMutation,
    SimulateTopupDepositMutationVariables
  >(SimulateTopupDepositDocument, options)
}
export type SimulateTopupDepositMutationHookResult = ReturnType<
  typeof useSimulateTopupDepositMutation
>
export type SimulateTopupDepositMutationResult =
  ApolloReactCommon.MutationResult<SimulateTopupDepositMutation>
export const GetMyInfoDocument = gql`
  query GetMyInfo {
    me {
      id
      email
      emailVerified
      name
      phoneNumber
      phoneCountryCode
      phoneVerified
      role
      status
      merchantId
      merchant {
        id
        name
        businessName
        businessNumber
        status
      }
      twoFactorEnabled
      twoFactorCodeRequired
      lastLoginAt
      createdAt
      updatedAt
    }
  }
`
export function useGetMyInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMyInfoQuery,
    GetMyInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<GetMyInfoQuery, GetMyInfoQueryVariables>(
    GetMyInfoDocument,
    options
  )
}
export function useGetMyInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMyInfoQuery,
    GetMyInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<GetMyInfoQuery, GetMyInfoQueryVariables>(
    GetMyInfoDocument,
    options
  )
}
export type GetMyInfoQueryHookResult = ReturnType<typeof useGetMyInfoQuery>
export type GetMyInfoLazyQueryHookResult = ReturnType<
  typeof useGetMyInfoLazyQuery
>
export type GetMyInfoQueryResult = ApolloReactCommon.QueryResult<
  GetMyInfoQuery,
  GetMyInfoQueryVariables
>
export const UpdateMyInfoDocument = gql`
  mutation UpdateMyInfo($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      name
      email
      phoneNumber
      phoneCountryCode
      updatedAt
    }
  }
`
export function useUpdateMyInfoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMyInfoMutation,
    UpdateMyInfoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateMyInfoMutation,
    UpdateMyInfoMutationVariables
  >(UpdateMyInfoDocument, options)
}
export type UpdateMyInfoMutationHookResult = ReturnType<
  typeof useUpdateMyInfoMutation
>
export type UpdateMyInfoMutationResult =
  ApolloReactCommon.MutationResult<UpdateMyInfoMutation>
export const ChangePasswordDocument = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input)
  }
`
export function useChangePasswordMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >(ChangePasswordDocument, options)
}
export type ChangePasswordMutationHookResult = ReturnType<
  typeof useChangePasswordMutation
>
export type ChangePasswordMutationResult =
  ApolloReactCommon.MutationResult<ChangePasswordMutation>
export const GetWithdrawalsDocument = gql`
  query GetWithdrawals(
    $filter: WithdrawalFilterInput
    $page: Int = 1
    $limit: Int = 20
  ) {
    withdrawals(filter: $filter, page: $page, limit: $limit) {
      items {
        id
        requestedAmount
        requestedCurrency
        feeAmount
        totalAmount
        status
        method
        createdAt
        createdBy {
          userId
          name
          email
        }
        processedAt
        completedAt
        failureReason
        transactionRef
        beneficiaryId
        recipientInfo
        merchant {
          id
          name
        }
        exchangeRate
        fromAmount
        fromCurrency
      }
      totalCount
      totalPages
      page
      limit
      hasNext
      hasPrev
    }
  }
`
export function useGetWithdrawalsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetWithdrawalsQuery,
    GetWithdrawalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetWithdrawalsQuery,
    GetWithdrawalsQueryVariables
  >(GetWithdrawalsDocument, options)
}
export function useGetWithdrawalsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetWithdrawalsQuery,
    GetWithdrawalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetWithdrawalsQuery,
    GetWithdrawalsQueryVariables
  >(GetWithdrawalsDocument, options)
}
export type GetWithdrawalsQueryHookResult = ReturnType<
  typeof useGetWithdrawalsQuery
>
export type GetWithdrawalsLazyQueryHookResult = ReturnType<
  typeof useGetWithdrawalsLazyQuery
>
export type GetWithdrawalsQueryResult = ApolloReactCommon.QueryResult<
  GetWithdrawalsQuery,
  GetWithdrawalsQueryVariables
>
export const GetWithdrawalDocument = gql`
  query GetWithdrawal($id: String!) {
    withdrawal(id: $id) {
      id
      requestedAmount
      requestedCurrency
      feeAmount
      totalAmount
      status
      method
      createdAt
      createdBy {
        userId
        name
        email
      }
      processedAt
      completedAt
      failureReason
      transactionRef
      beneficiaryId
      recipientInfo
      merchant {
        id
        name
      }
      exchangeRate
      fromAmount
      fromCurrency
      channel
      channelOrderId
      channelFeeAmount
      metaData
      attemptNo
      holdReason
      estimatedBridgingFee
      bridgingFeeAmount
      actualPayoutAmount
    }
  }
`
export function useGetWithdrawalQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetWithdrawalQuery,
    GetWithdrawalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetWithdrawalQuery,
    GetWithdrawalQueryVariables
  >(GetWithdrawalDocument, options)
}
export function useGetWithdrawalLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetWithdrawalQuery,
    GetWithdrawalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetWithdrawalQuery,
    GetWithdrawalQueryVariables
  >(GetWithdrawalDocument, options)
}
export type GetWithdrawalQueryHookResult = ReturnType<
  typeof useGetWithdrawalQuery
>
export type GetWithdrawalLazyQueryHookResult = ReturnType<
  typeof useGetWithdrawalLazyQuery
>
export type GetWithdrawalQueryResult = ApolloReactCommon.QueryResult<
  GetWithdrawalQuery,
  GetWithdrawalQueryVariables
>
export const EstimateWithdrawalBridgingFeeDocument = gql`
  query EstimateWithdrawalBridgingFee(
    $fromCurrency: String!
    $requestedCurrency: String!
    $amount: Float!
    $merchantId: Int
  ) {
    estimateWithdrawalBridgingFee(
      fromCurrency: $fromCurrency
      requestedCurrency: $requestedCurrency
      amount: $amount
      merchantId: $merchantId
    ) {
      feeAmount
      receivedAmount
      receivedCurrency
      minAmount
      maxAmount
      isEstimate
    }
  }
`
export function useEstimateWithdrawalBridgingFeeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    EstimateWithdrawalBridgingFeeQuery,
    EstimateWithdrawalBridgingFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    EstimateWithdrawalBridgingFeeQuery,
    EstimateWithdrawalBridgingFeeQueryVariables
  >(EstimateWithdrawalBridgingFeeDocument, options)
}
export function useEstimateWithdrawalBridgingFeeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EstimateWithdrawalBridgingFeeQuery,
    EstimateWithdrawalBridgingFeeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    EstimateWithdrawalBridgingFeeQuery,
    EstimateWithdrawalBridgingFeeQueryVariables
  >(EstimateWithdrawalBridgingFeeDocument, options)
}
export type EstimateWithdrawalBridgingFeeQueryHookResult = ReturnType<
  typeof useEstimateWithdrawalBridgingFeeQuery
>
export type EstimateWithdrawalBridgingFeeLazyQueryHookResult = ReturnType<
  typeof useEstimateWithdrawalBridgingFeeLazyQuery
>
export type EstimateWithdrawalBridgingFeeQueryResult =
  ApolloReactCommon.QueryResult<
    EstimateWithdrawalBridgingFeeQuery,
    EstimateWithdrawalBridgingFeeQueryVariables
  >
export const WithdrawalProcessPreviewDocument = gql`
  query WithdrawalProcessPreview($withdrawalId: String!) {
    withdrawalProcessPreview(withdrawalId: $withdrawalId) {
      channel
      currency
      requiredAmount
      channelAvailable
      sufficient
    }
  }
`
export function useWithdrawalProcessPreviewQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    WithdrawalProcessPreviewQuery,
    WithdrawalProcessPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    WithdrawalProcessPreviewQuery,
    WithdrawalProcessPreviewQueryVariables
  >(WithdrawalProcessPreviewDocument, options)
}
export function useWithdrawalProcessPreviewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    WithdrawalProcessPreviewQuery,
    WithdrawalProcessPreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    WithdrawalProcessPreviewQuery,
    WithdrawalProcessPreviewQueryVariables
  >(WithdrawalProcessPreviewDocument, options)
}
export type WithdrawalProcessPreviewQueryHookResult = ReturnType<
  typeof useWithdrawalProcessPreviewQuery
>
export type WithdrawalProcessPreviewLazyQueryHookResult = ReturnType<
  typeof useWithdrawalProcessPreviewLazyQuery
>
export type WithdrawalProcessPreviewQueryResult = ApolloReactCommon.QueryResult<
  WithdrawalProcessPreviewQuery,
  WithdrawalProcessPreviewQueryVariables
>
export const GetRecentWithdrawalsDocument = gql`
  query GetRecentWithdrawals($limit: Int! = 10) {
    getRecentWithdrawals(limit: $limit) {
      id
      requestedAmount
      requestedCurrency
      status
      method
      beneficiaryId
      createdAt
      merchant {
        id
        companyName
      }
    }
  }
`
export function useGetRecentWithdrawalsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetRecentWithdrawalsQuery,
    GetRecentWithdrawalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    GetRecentWithdrawalsQuery,
    GetRecentWithdrawalsQueryVariables
  >(GetRecentWithdrawalsDocument, options)
}
export function useGetRecentWithdrawalsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRecentWithdrawalsQuery,
    GetRecentWithdrawalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    GetRecentWithdrawalsQuery,
    GetRecentWithdrawalsQueryVariables
  >(GetRecentWithdrawalsDocument, options)
}
export type GetRecentWithdrawalsQueryHookResult = ReturnType<
  typeof useGetRecentWithdrawalsQuery
>
export type GetRecentWithdrawalsLazyQueryHookResult = ReturnType<
  typeof useGetRecentWithdrawalsLazyQuery
>
export type GetRecentWithdrawalsQueryResult = ApolloReactCommon.QueryResult<
  GetRecentWithdrawalsQuery,
  GetRecentWithdrawalsQueryVariables
>
export const CreateWithdrawalDocument = gql`
  mutation CreateWithdrawal($input: CreateWithdrawalInput!) {
    createWithdrawal(input: $input) {
      id
      requestedAmount
      requestedCurrency
      feeAmount
      totalAmount
      status
      method
      createdAt
      beneficiaryId
      recipientInfo
    }
  }
`
export function useCreateWithdrawalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateWithdrawalMutation,
    CreateWithdrawalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateWithdrawalMutation,
    CreateWithdrawalMutationVariables
  >(CreateWithdrawalDocument, options)
}
export type CreateWithdrawalMutationHookResult = ReturnType<
  typeof useCreateWithdrawalMutation
>
export type CreateWithdrawalMutationResult =
  ApolloReactCommon.MutationResult<CreateWithdrawalMutation>
export const UpdateWithdrawalDocument = gql`
  mutation UpdateWithdrawal($id: String!, $input: UpdateWithdrawalInput!) {
    updateWithdrawal(id: $id, input: $input) {
      id
      requestedAmount
      requestedCurrency
      status
      method
      beneficiaryId
      recipientInfo
      updatedAt
    }
  }
`
export function useUpdateWithdrawalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateWithdrawalMutation,
    UpdateWithdrawalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateWithdrawalMutation,
    UpdateWithdrawalMutationVariables
  >(UpdateWithdrawalDocument, options)
}
export type UpdateWithdrawalMutationHookResult = ReturnType<
  typeof useUpdateWithdrawalMutation
>
export type UpdateWithdrawalMutationResult =
  ApolloReactCommon.MutationResult<UpdateWithdrawalMutation>
export const CancelWithdrawalDocument = gql`
  mutation CancelWithdrawal($id: String!) {
    cancelWithdrawal(id: $id) {
      id
      status
      updatedAt
    }
  }
`
export function useCancelWithdrawalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelWithdrawalMutation,
    CancelWithdrawalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CancelWithdrawalMutation,
    CancelWithdrawalMutationVariables
  >(CancelWithdrawalDocument, options)
}
export type CancelWithdrawalMutationHookResult = ReturnType<
  typeof useCancelWithdrawalMutation
>
export type CancelWithdrawalMutationResult =
  ApolloReactCommon.MutationResult<CancelWithdrawalMutation>
export const ProcessWithdrawalDocument = gql`
  mutation ProcessWithdrawal($input: ProcessWithdrawalInput!) {
    processWithdrawal(input: $input) {
      id
      status
      processedAt
      updatedAt
    }
  }
`
export function useProcessWithdrawalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ProcessWithdrawalMutation,
    ProcessWithdrawalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ProcessWithdrawalMutation,
    ProcessWithdrawalMutationVariables
  >(ProcessWithdrawalDocument, options)
}
export type ProcessWithdrawalMutationHookResult = ReturnType<
  typeof useProcessWithdrawalMutation
>
export type ProcessWithdrawalMutationResult =
  ApolloReactCommon.MutationResult<ProcessWithdrawalMutation>
export const CompleteWithdrawalDocument = gql`
  mutation CompleteWithdrawal($input: CompleteWithdrawalInput!) {
    completeWithdrawal(input: $input) {
      id
      status
      completedAt
      transactionRef
      updatedAt
    }
  }
`
export function useCompleteWithdrawalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CompleteWithdrawalMutation,
    CompleteWithdrawalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CompleteWithdrawalMutation,
    CompleteWithdrawalMutationVariables
  >(CompleteWithdrawalDocument, options)
}
export type CompleteWithdrawalMutationHookResult = ReturnType<
  typeof useCompleteWithdrawalMutation
>
export type CompleteWithdrawalMutationResult =
  ApolloReactCommon.MutationResult<CompleteWithdrawalMutation>
export const FailWithdrawalDocument = gql`
  mutation FailWithdrawal($input: FailWithdrawalInput!) {
    failWithdrawal(input: $input) {
      id
      status
      failureReason
      updatedAt
    }
  }
`
export function useFailWithdrawalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    FailWithdrawalMutation,
    FailWithdrawalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    FailWithdrawalMutation,
    FailWithdrawalMutationVariables
  >(FailWithdrawalDocument, options)
}
export type FailWithdrawalMutationHookResult = ReturnType<
  typeof useFailWithdrawalMutation
>
export type FailWithdrawalMutationResult =
  ApolloReactCommon.MutationResult<FailWithdrawalMutation>
export const DownloadWithdrawalExcelDocument = gql`
  mutation DownloadWithdrawalExcel($filter: WithdrawalFilterInput) {
    downloadWithdrawalExcel(filter: $filter) {
      downloadUrl
      jobId
      message
      recordCount
    }
  }
`
export function useDownloadWithdrawalExcelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DownloadWithdrawalExcelMutation,
    DownloadWithdrawalExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    DownloadWithdrawalExcelMutation,
    DownloadWithdrawalExcelMutationVariables
  >(DownloadWithdrawalExcelDocument, options)
}
export type DownloadWithdrawalExcelMutationHookResult = ReturnType<
  typeof useDownloadWithdrawalExcelMutation
>
export type DownloadWithdrawalExcelMutationResult =
  ApolloReactCommon.MutationResult<DownloadWithdrawalExcelMutation>
export const RetryWithdrawalDocument = gql`
  mutation RetryWithdrawal($input: RetryWithdrawalInput!) {
    retryWithdrawal(input: $input) {
      id
      status
      attemptNo
      updatedAt
    }
  }
`
export function useRetryWithdrawalMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RetryWithdrawalMutation,
    RetryWithdrawalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    RetryWithdrawalMutation,
    RetryWithdrawalMutationVariables
  >(RetryWithdrawalDocument, options)
}
export type RetryWithdrawalMutationHookResult = ReturnType<
  typeof useRetryWithdrawalMutation
>
export type RetryWithdrawalMutationResult =
  ApolloReactCommon.MutationResult<RetryWithdrawalMutation>
export const StartTwoFactorEnrollmentDocument = gql`
  mutation StartTwoFactorEnrollment {
    startTwoFactorEnrollment {
      qrDataUrl
      manualKey
    }
  }
`
export function useStartTwoFactorEnrollmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartTwoFactorEnrollmentMutation,
    StartTwoFactorEnrollmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    StartTwoFactorEnrollmentMutation,
    StartTwoFactorEnrollmentMutationVariables
  >(StartTwoFactorEnrollmentDocument, options)
}
export type StartTwoFactorEnrollmentMutationHookResult = ReturnType<
  typeof useStartTwoFactorEnrollmentMutation
>
export type StartTwoFactorEnrollmentMutationResult =
  ApolloReactCommon.MutationResult<StartTwoFactorEnrollmentMutation>
export const ConfirmTwoFactorEnrollmentDocument = gql`
  mutation ConfirmTwoFactorEnrollment($input: ConfirmEnrollmentInput!) {
    confirmTwoFactorEnrollment(input: $input)
  }
`
export function useConfirmTwoFactorEnrollmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConfirmTwoFactorEnrollmentMutation,
    ConfirmTwoFactorEnrollmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ConfirmTwoFactorEnrollmentMutation,
    ConfirmTwoFactorEnrollmentMutationVariables
  >(ConfirmTwoFactorEnrollmentDocument, options)
}
export type ConfirmTwoFactorEnrollmentMutationHookResult = ReturnType<
  typeof useConfirmTwoFactorEnrollmentMutation
>
export type ConfirmTwoFactorEnrollmentMutationResult =
  ApolloReactCommon.MutationResult<ConfirmTwoFactorEnrollmentMutation>
export const VerifyLoginTwoFactorDocument = gql`
  mutation VerifyLoginTwoFactor($input: VerifyLoginTwoFactorInput!) {
    verifyLoginTwoFactor(input: $input) {
      accessToken
      refreshToken
    }
  }
`
export function useVerifyLoginTwoFactorMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerifyLoginTwoFactorMutation,
    VerifyLoginTwoFactorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    VerifyLoginTwoFactorMutation,
    VerifyLoginTwoFactorMutationVariables
  >(VerifyLoginTwoFactorDocument, options)
}
export type VerifyLoginTwoFactorMutationHookResult = ReturnType<
  typeof useVerifyLoginTwoFactorMutation
>
export type VerifyLoginTwoFactorMutationResult =
  ApolloReactCommon.MutationResult<VerifyLoginTwoFactorMutation>
export const ResetUserTwoFactorDocument = gql`
  mutation ResetUserTwoFactor($userId: Int!) {
    resetUserTwoFactor(userId: $userId)
  }
`
export function useResetUserTwoFactorMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResetUserTwoFactorMutation,
    ResetUserTwoFactorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    ResetUserTwoFactorMutation,
    ResetUserTwoFactorMutationVariables
  >(ResetUserTwoFactorDocument, options)
}
export type ResetUserTwoFactorMutationHookResult = ReturnType<
  typeof useResetUserTwoFactorMutation
>
export type ResetUserTwoFactorMutationResult =
  ApolloReactCommon.MutationResult<ResetUserTwoFactorMutation>
export const SecurityPolicyDocument = gql`
  query SecurityPolicy {
    securityPolicy {
      id
      requireTwoFactorForAdmin
      requireTwoFactorForMerchantAdmin
      requireTwoFactorForMerchantUser
      requireTwoFactorForDeveloper
    }
  }
`
export function useSecurityPolicyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SecurityPolicyQuery,
    SecurityPolicyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    SecurityPolicyQuery,
    SecurityPolicyQueryVariables
  >(SecurityPolicyDocument, options)
}
export function useSecurityPolicyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SecurityPolicyQuery,
    SecurityPolicyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    SecurityPolicyQuery,
    SecurityPolicyQueryVariables
  >(SecurityPolicyDocument, options)
}
export type SecurityPolicyQueryHookResult = ReturnType<
  typeof useSecurityPolicyQuery
>
export type SecurityPolicyLazyQueryHookResult = ReturnType<
  typeof useSecurityPolicyLazyQuery
>
export type SecurityPolicyQueryResult = ApolloReactCommon.QueryResult<
  SecurityPolicyQuery,
  SecurityPolicyQueryVariables
>
export const UpdateSecurityPolicyDocument = gql`
  mutation UpdateSecurityPolicy($input: UpdateSecurityPolicyInput!) {
    updateSecurityPolicy(input: $input) {
      id
      requireTwoFactorForAdmin
      requireTwoFactorForMerchantAdmin
      requireTwoFactorForMerchantUser
      requireTwoFactorForDeveloper
    }
  }
`
export function useUpdateSecurityPolicyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateSecurityPolicyMutation,
    UpdateSecurityPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    UpdateSecurityPolicyMutation,
    UpdateSecurityPolicyMutationVariables
  >(UpdateSecurityPolicyDocument, options)
}
export type UpdateSecurityPolicyMutationHookResult = ReturnType<
  typeof useUpdateSecurityPolicyMutation
>
export type UpdateSecurityPolicyMutationResult =
  ApolloReactCommon.MutationResult<UpdateSecurityPolicyMutation>
